/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 98);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(10);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var DOMProperty = __webpack_require__(19);
var ReactDOMComponentFlags = __webpack_require__(73);

var invariant = __webpack_require__(0);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var Flags = ReactDOMComponentFlags;

var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);

/**
 * Check if a given node should be cached.
 */
function shouldPrecacheNode(node, nodeID) {
  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
}

/**
 * Drill down (through composites and empty components) until we get a host or
 * host text component.
 *
 * This is pretty polymorphic but unavoidable with the current structure we have
 * for `_renderedChildren`.
 */
function getRenderedHostOrTextFromComponent(component) {
  var rendered;
  while (rendered = component._renderedComponent) {
    component = rendered;
  }
  return component;
}

/**
 * Populate `_hostNode` on the rendered host/text component with the given
 * DOM node. The passed `inst` can be a composite.
 */
function precacheNode(inst, node) {
  var hostInst = getRenderedHostOrTextFromComponent(inst);
  hostInst._hostNode = node;
  node[internalInstanceKey] = hostInst;
}

function uncacheNode(inst) {
  var node = inst._hostNode;
  if (node) {
    delete node[internalInstanceKey];
    inst._hostNode = null;
  }
}

/**
 * Populate `_hostNode` on each child of `inst`, assuming that the children
 * match up with the DOM (element) children of `node`.
 *
 * We cache entire levels at once to avoid an n^2 problem where we access the
 * children of a node sequentially and have to walk from the start to our target
 * node every time.
 *
 * Since we update `_renderedChildren` and the actual DOM at (slightly)
 * different times, we could race here and see a newer `_renderedChildren` than
 * the DOM nodes we see. To avoid this, ReactMultiChild calls
 * `prepareToManageChildren` before we change `_renderedChildren`, at which
 * time the container's child nodes are always cached (until it unmounts).
 */
function precacheChildNodes(inst, node) {
  if (inst._flags & Flags.hasCachedChildNodes) {
    return;
  }
  var children = inst._renderedChildren;
  var childNode = node.firstChild;
  outer: for (var name in children) {
    if (!children.hasOwnProperty(name)) {
      continue;
    }
    var childInst = children[name];
    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
    if (childID === 0) {
      // We're currently unmounting this child in ReactMultiChild; skip it.
      continue;
    }
    // We assume the child nodes are in the same order as the child instances.
    for (; childNode !== null; childNode = childNode.nextSibling) {
      if (shouldPrecacheNode(childNode, childID)) {
        precacheNode(childInst, childNode);
        continue outer;
      }
    }
    // We reached the end of the DOM children without finding an ID match.
     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
  }
  inst._flags |= Flags.hasCachedChildNodes;
}

/**
 * Given a DOM node, return the closest ReactDOMComponent or
 * ReactDOMTextComponent instance ancestor.
 */
function getClosestInstanceFromNode(node) {
  if (node[internalInstanceKey]) {
    return node[internalInstanceKey];
  }

  // Walk up the tree until we find an ancestor whose instance we have cached.
  var parents = [];
  while (!node[internalInstanceKey]) {
    parents.push(node);
    if (node.parentNode) {
      node = node.parentNode;
    } else {
      // Top of the tree. This node must not be part of a React tree (or is
      // unmounted, potentially).
      return null;
    }
  }

  var closest;
  var inst;
  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
    closest = inst;
    if (parents.length) {
      precacheChildNodes(inst, node);
    }
  }

  return closest;
}

/**
 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
 * instance, or null if the node was not rendered by this React.
 */
function getInstanceFromNode(node) {
  var inst = getClosestInstanceFromNode(node);
  if (inst != null && inst._hostNode === node) {
    return inst;
  } else {
    return null;
  }
}

/**
 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
 * DOM node.
 */
function getNodeFromInstance(inst) {
  // Without this first invariant, passing a non-DOM-component triggers the next
  // invariant for a missing parent, which is super confusing.
  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  if (inst._hostNode) {
    return inst._hostNode;
  }

  // Walk up the tree until we find an ancestor whose DOM node we have cached.
  var parents = [];
  while (!inst._hostNode) {
    parents.push(inst);
    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
    inst = inst._hostParent;
  }

  // Now parents contains each ancestor that does *not* have a cached native
  // node, and `inst` is the deepest ancestor that does.
  for (; parents.length; inst = parents.pop()) {
    precacheChildNodes(inst, inst._hostNode);
  }

  return inst._hostNode;
}

var ReactDOMComponentTree = {
  getClosestInstanceFromNode: getClosestInstanceFromNode,
  getInstanceFromNode: getInstanceFromNode,
  getNodeFromInstance: getNodeFromInstance,
  precacheChildNodes: precacheChildNodes,
  precacheNode: precacheNode,
  uncacheNode: uncacheNode
};

module.exports = ReactDOMComponentTree;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},registeredModules={};function dynamicRequire(module){if(registeredModules[module])return registeredModules[module];throw Error("Dynamic Module \""+module+"\" not found")}dynamicRequire.register=function(modules){registeredModules=_extends({},registeredModules,modules)},module.exports=dynamicRequire;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function(f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function(x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s': return String(args[i++]);
      case '%d': return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};


// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function(fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function() {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};


var debugs = {};
var debugEnviron;
exports.debuglog = function(set) {
  if (isUndefined(debugEnviron))
    debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function() {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function() {};
    }
  }
  return debugs[set];
};


/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;


// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold' : [1, 22],
  'italic' : [3, 23],
  'underline' : [4, 24],
  'inverse' : [7, 27],
  'white' : [37, 39],
  'grey' : [90, 39],
  'black' : [30, 39],
  'blue' : [34, 39],
  'cyan' : [36, 39],
  'green' : [32, 39],
  'magenta' : [35, 39],
  'red' : [31, 39],
  'yellow' : [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};


function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
           '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}


function stylizeNoColor(str, styleType) {
  return str;
}


function arrayToHash(array) {
  var hash = {};

  array.forEach(function(val, idx) {
    hash[val] = true;
  });

  return hash;
}


function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect &&
      value &&
      isFunction(value.inspect) &&
      // Filter out the util module, it's inspect function is special
      value.inspect !== exports.inspect &&
      // Also filter out any prototype objects using the circular check.
      !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value)
      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '', array = false, braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function(key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}


function formatPrimitive(ctx, value) {
  if (isUndefined(value))
    return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
                                             .replace(/'/g, "\\'")
                                             .replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value))
    return ctx.stylize('' + value, 'number');
  if (isBoolean(value))
    return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value))
    return ctx.stylize('null', 'null');
}


function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}


function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function(key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
          key, true));
    }
  });
  return output;
}


function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function(line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function(line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'")
                 .replace(/\\"/g, '"')
                 .replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}


function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function(prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] +
           (base === '' ? '' : base + '\n ') +
           ' ' +
           output.join(',\n  ') +
           ' ' +
           braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}


// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) &&
      (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(102);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}


function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}


var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
              'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()),
              pad(d.getMinutes()),
              pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}


// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function() {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};


/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(103);

exports._extend = function(origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54), __webpack_require__(34)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(17);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// Trust the developer to only use ReactInstrumentation with a __DEV__ check

var debugTool = null;

if (false) {
  var ReactDebugTool = require('./ReactDebugTool');
  debugTool = ReactDebugTool;
}

module.exports = { debugTool: debugTool };

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1),
    _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(77);
var PooledClass = __webpack_require__(16);
var ReactFeatureFlags = __webpack_require__(78);
var ReactReconciler = __webpack_require__(20);
var Transaction = __webpack_require__(28);

var invariant = __webpack_require__(0);

var dirtyComponents = [];
var updateBatchNumber = 0;
var asapCallbackQueue = CallbackQueue.getPooled();
var asapEnqueued = false;

var batchingStrategy = null;

function ensureInjected() {
  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
}

var NESTED_UPDATES = {
  initialize: function () {
    this.dirtyComponentsLength = dirtyComponents.length;
  },
  close: function () {
    if (this.dirtyComponentsLength !== dirtyComponents.length) {
      // Additional updates were enqueued by componentDidUpdate handlers or
      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
      // these new updates so that if A's componentDidUpdate calls setState on
      // B, B will update before the callback A's updater provided when calling
      // setState.
      dirtyComponents.splice(0, this.dirtyComponentsLength);
      flushBatchedUpdates();
    } else {
      dirtyComponents.length = 0;
    }
  }
};

var UPDATE_QUEUEING = {
  initialize: function () {
    this.callbackQueue.reset();
  },
  close: function () {
    this.callbackQueue.notifyAll();
  }
};

var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];

function ReactUpdatesFlushTransaction() {
  this.reinitializeTransaction();
  this.dirtyComponentsLength = null;
  this.callbackQueue = CallbackQueue.getPooled();
  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */true);
}

_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  destructor: function () {
    this.dirtyComponentsLength = null;
    CallbackQueue.release(this.callbackQueue);
    this.callbackQueue = null;
    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
    this.reconcileTransaction = null;
  },

  perform: function (method, scope, a) {
    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
    // with this transaction's wrappers around it.
    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
  }
});

PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);

function batchedUpdates(callback, a, b, c, d, e) {
  ensureInjected();
  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
}

/**
 * Array comparator for ReactComponents by mount ordering.
 *
 * @param {ReactComponent} c1 first component you're comparing
 * @param {ReactComponent} c2 second component you're comparing
 * @return {number} Return value usable by Array.prototype.sort().
 */
function mountOrderComparator(c1, c2) {
  return c1._mountOrder - c2._mountOrder;
}

function runBatchedUpdates(transaction) {
  var len = transaction.dirtyComponentsLength;
  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;

  // Since reconciling a component higher in the owner hierarchy usually (not
  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
  // them before their children by sorting the array.
  dirtyComponents.sort(mountOrderComparator);

  // Any updates enqueued while reconciling must be performed after this entire
  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
  // C, B could update twice in a single batch if C's render enqueues an update
  // to B (since B would have already updated, we should skip it, and the only
  // way we can know to do so is by checking the batch counter).
  updateBatchNumber++;

  for (var i = 0; i < len; i++) {
    // If a component is unmounted before pending changes apply, it will still
    // be here, but we assume that it has cleared its _pendingCallbacks and
    // that performUpdateIfNecessary is a noop.
    var component = dirtyComponents[i];

    // If performUpdateIfNecessary happens to enqueue any new updates, we
    // shouldn't execute the callbacks until the next render happens, so
    // stash the callbacks first
    var callbacks = component._pendingCallbacks;
    component._pendingCallbacks = null;

    var markerName;
    if (ReactFeatureFlags.logTopLevelRenders) {
      var namedComponent = component;
      // Duck type TopLevelWrapper. This is probably always true.
      if (component._currentElement.type.isReactTopLevelWrapper) {
        namedComponent = component._renderedComponent;
      }
      markerName = 'React update: ' + namedComponent.getName();
      console.time(markerName);
    }

    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);

    if (markerName) {
      console.timeEnd(markerName);
    }

    if (callbacks) {
      for (var j = 0; j < callbacks.length; j++) {
        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
      }
    }
  }
}

var flushBatchedUpdates = function () {
  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
  // array and perform any updates enqueued by mount-ready handlers (i.e.,
  // componentDidUpdate) but we need to check here too in order to catch
  // updates enqueued by setState callbacks and asap calls.
  while (dirtyComponents.length || asapEnqueued) {
    if (dirtyComponents.length) {
      var transaction = ReactUpdatesFlushTransaction.getPooled();
      transaction.perform(runBatchedUpdates, null, transaction);
      ReactUpdatesFlushTransaction.release(transaction);
    }

    if (asapEnqueued) {
      asapEnqueued = false;
      var queue = asapCallbackQueue;
      asapCallbackQueue = CallbackQueue.getPooled();
      queue.notifyAll();
      CallbackQueue.release(queue);
    }
  }
};

/**
 * Mark a component as needing a rerender, adding an optional callback to a
 * list of functions which will be executed once the rerender occurs.
 */
function enqueueUpdate(component) {
  ensureInjected();

  // Various parts of our code (such as ReactCompositeComponent's
  // _renderValidatedComponent) assume that calls to render aren't nested;
  // verify that that's the case. (This is called by each top-level update
  // function, like setState, forceUpdate, etc.; creation and
  // destruction of top-level components is guarded in ReactMount.)

  if (!batchingStrategy.isBatchingUpdates) {
    batchingStrategy.batchedUpdates(enqueueUpdate, component);
    return;
  }

  dirtyComponents.push(component);
  if (component._updateBatchNumber == null) {
    component._updateBatchNumber = updateBatchNumber + 1;
  }
}

/**
 * Enqueue a callback to be run at the end of the current batching cycle. Throws
 * if no updates are currently being performed.
 */
function asap(callback, context) {
  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
  asapCallbackQueue.enqueue(callback, context);
  asapEnqueued = true;
}

var ReactUpdatesInjection = {
  injectReconcileTransaction: function (ReconcileTransaction) {
    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
  },

  injectBatchingStrategy: function (_batchingStrategy) {
    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
    batchingStrategy = _batchingStrategy;
  }
};

var ReactUpdates = {
  /**
   * React references `ReactReconcileTransaction` using this property in order
   * to allow dependency injection.
   *
   * @internal
   */
  ReactReconcileTransaction: null,

  batchedUpdates: batchedUpdates,
  enqueueUpdate: enqueueUpdate,
  flushBatchedUpdates: flushBatchedUpdates,
  injection: ReactUpdatesInjection,
  asap: asap
};

module.exports = ReactUpdates;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}var instance,PartCache=function(){function PartCache(basePath){return _classCallCheck(this,PartCache),instance?instance:void(instance=this,this.basePath=basePath,this.modelCache={})}return _createClass(PartCache,[{key:'getBasePath',value:function getBasePath(){return this.basePath}},{key:'setCache',value:function setCache(key,value){var that=this;key in that.modelCache||(that.modelCache[key]=value)}},{key:'getCache',value:function getCache(key,defaultValue){var that=this;return key in that.modelCache?that.modelCache[key]:defaultValue}}]),PartCache}();PartCache.getInstance=function(){if(instance)return instance;throw new Error('object must be instanciated first')},module.exports=PartCache;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(16);

var emptyFunction = __webpack_require__(10);
var warning = __webpack_require__(2);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';

var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function (event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
  if (false) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (false) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

_assign(SyntheticEvent.prototype, {
  preventDefault: function () {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function () {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
      // eslint-disable-next-line valid-typeof
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function () {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function () {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (false) {
        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (false) {
      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function (Class, Interface) {
  var Super = this;

  var E = function () {};
  E.prototype = Super.prototype;
  var prototype = new E();

  _assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = _assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;

  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (false) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function (target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function (constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function (target, prop, value) {
            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {object} SyntheticEvent
  * @param {String} propName
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
  }
}

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),ElementView=__webpack_require__(57),PartCache=__webpack_require__(12),FOLDER='3DModels/',PartView=module.exports=function(model,parentHeight,parentLength,parentDepth){this.initPartView(model,parentHeight,parentLength,parentDepth)};utils.inherits(PartView,ElementView),PartView.prototype.initPartView=function(model,parentHeight,parentLength,parentDepth){this.init(model),this.initView(),this.cache=new PartCache,this.parentHeight=parentHeight,this.parentLength=parentLength,this.parentDepth=parentDepth,this._origin3DModel,this.loader=new THREE.OBJMTLLoader},PartView.preloadPart=function(cache,objFile,textureFile){var loader=new THREE.OBJMTLLoader;loader.addEventListener('load',function(event){var geometry=event.content;cache.setCache(objFile,geometry)}),loader.load(FOLDER+objFile,FOLDER+textureFile)},PartView.factory=function(partType,model,parentHeight,parentLength,parentDepth){if(0<=partType.indexOf('long')||'length'===model.alignment){var LengthPartView=__webpack_require__(58);return new LengthPartView(model,parentHeight,parentLength,parentDepth)}if(0<=partType.indexOf('height')||'height'===model.alignment){var HeightPartView=__webpack_require__(59);return new HeightPartView(model,parentHeight,parentLength,parentDepth)}if(0<=partType.indexOf('depth')||'depth'===model.alignment){var DepthPartView=__webpack_require__(60);return new DepthPartView(model,parentHeight,parentLength,parentDepth)}if(0<=partType.indexOf('top')||0<=partType.indexOf('bottom')||'top'===model.alignment||'bottom'===model.alignment){var UpperPartView=__webpack_require__(61);return new UpperPartView(model,parentHeight,parentLength,parentDepth)}return new PartView(model,parentHeight,parentLength,parentDepth)},PartView.prototype.loadModel3D=function(cachedGeometry){var that=this;return cachedGeometry?that.prepare3DModel(cachedGeometry.clone()):that.model.file?(that.loader.addEventListener('load',function(event){var geometry=event.content;that.prepare3DModel(geometry)}),that.loader.load(that.cache.getBasePath()+FOLDER+that.model.file,this.cache.getBasePath()+FOLDER+that.model.textureFile)):that.emit('3DModelLoaded'),that},PartView.prototype.prepare3DModel=function(geometry){var that=this,scaleParameter=that._getScaleParameter(geometry),modelsRotation=that.model.rotation,modelsPosition=that.model.position;that._origin3DModel=geometry.clone(),geometry.scale.set(scaleParameter[0],scaleParameter[1],scaleParameter[2]),geometry.rotation.set(modelsRotation[0],modelsRotation[1],modelsRotation[2]),geometry.position.x=modelsPosition[0],geometry.position.y=modelsPosition[1],geometry.position.z=modelsPosition[2],that.setModel3D(geometry),that._applyMaterial(geometry)},PartView.prototype._applyMaterial=function(geometry){function addNormalMaps(){geometry.children[childrenIndex].children[0].material&&null===geometry.children[childrenIndex].children[0].material.normalMap?'normalMaps'in that.model&&Array.isArray(that.model.normalMaps)&&0<that.model.normalMaps.length?that.model.normalMaps.forEach(function(normalMap,index){THREE.ImageUtils.loadTexture(that.cache.getBasePath()+FOLDER+normalMap,null,function(texture){'PANEL'===that.model.category&&(texture.repeat.set(1,1),texture.wrapS=THREE.RepeatWrapping,texture.wrapT=THREE.RepeatWrapping),geometry.children[childrenIndex].children[index].material.normalMap=texture,geometry.children[childrenIndex].children[index].material.needsUpdate=!0,'PANEL'===that.model.category?geometry.children[childrenIndex].children[index].material.normalScale.set(.1,.1):geometry.children[childrenIndex].children[index].material.normalScale.set(1.2,1.2),that.emit('3DModelLoaded')})}):(geometry.children[childrenIndex].children.forEach(function(child,index){geometry.children[childrenIndex].children[index].material.normalMap=null,geometry.children[childrenIndex].children[index].material.needsUpdate=!0}),that.emit('3DModelLoaded')):that.emit('3DModelLoaded')}function setColor(materialColor){geometry.children[childrenIndex].children.forEach(function(mesh){mesh.material.color.setStyle(materialColor)})}var that=this,childrenIndex=function(){var result=0;return geometry.children.forEach(function(child,index){0<child.children.length&&child.children[0]instanceof THREE.Mesh&&(result=index)}),result}();if(Detector.webgl)addNormalMaps();else{var material=geometry.children[childrenIndex].children[0].material;geometry.children[childrenIndex].children.forEach(function(child,index){geometry.children[childrenIndex].children[index].material=new THREE.MeshLambertMaterial(material),that.emit('3DModelLoaded')})}'PANEL'===that.model.category?(geometry.children[childrenIndex].children[0].renderDepth=-20,geometry.children[childrenIndex].children[0].material.ambient=new THREE.Color('#111111'),geometry.children[childrenIndex].children[0].material.emissive=new THREE.Color('#555555'),geometry.children[childrenIndex].children[0].material.specular=new THREE.Color('#555555')):'EDGE_PROTECTION'===that.model.category?geometry.children[childrenIndex].children[0].renderDepth=5:'PROFILE'===that.model.category?geometry.children[childrenIndex].children[0].renderDepth=0:'CORNER'===that.model.category?geometry.children[childrenIndex].children[0].renderDepth=20:geometry.children[childrenIndex].children[0].renderDepth=10,that.model.chromeMaterial?setColor('#8a8984'):that.model.aluMaterial?setColor('#a1a09a'):that.model.woodMaterial&&setColor('#29251d')},PartView.prototype.scaleHeight=function(globalScale,change,keepCapBodyRatio,onCap,keepBodyHeight){var that=this,geometry=that.getModel3D(),scaleAxis=that.model.scaleAxis,size=that.getDimensionsOfOrigin3DModel();if(that.axisMustBeScaled(scaleAxis[0])&&(geometry.scale.x=that.scaleLengthParameter(size.x)),that.axisMustBeScaled(scaleAxis[1])&&(geometry.scale.y=that.scaleHeightParameter(size.y)),keepCapBodyRatio||!onCap&&!keepBodyHeight){var yPosition=geometry.position.y;0<yPosition?geometry.position.y+=.5*change:0>yPosition&&(geometry.position.y-=.5*change)}else onCap&&keepBodyHeight&&(that.model.doNotMoveOnHeightScale||that.model.moveByChange?that.model.moveByChange&&(geometry.position.y+=change):geometry.position.y*=globalScale);that.model.position[1]=geometry.position.y,that.axisMustBeScaled(scaleAxis[2])&&(geometry.scale.z=that.scaleDepthParameter(size.z)),that.setModel3D(geometry)},PartView.prototype.scaleLength=function(globalScale,change){var that=this,geometry=that.getModel3D(),scaleAxis=that.model.scaleAxis,size=that.getDimensionsOfOrigin3DModel();that.axisMustBeScaled(scaleAxis[0])&&(geometry.scale.x=that.scaleLengthParameter(size.x)),that.axisMustBeScaled(scaleAxis[1])&&(geometry.scale.y=that.scaleHeightParameter(size.y)),that.axisMustBeScaled(scaleAxis[2])&&(geometry.scale.z=that.scaleDepthParameter(size.z));var xPosition=geometry.position.x;0<xPosition?geometry.position.x+=.5*change:0>xPosition&&(geometry.position.x-=.5*change),that.model.position[0]=geometry.position.x,that.setModel3D(geometry)},PartView.prototype.scaleDepth=function(globalScale,change){var that=this,geometry=that.getModel3D(),scaleAxis=that.model.scaleAxis,size=that.getDimensionsOfOrigin3DModel();that.axisMustBeScaled(scaleAxis[0])&&(geometry.scale.x=that.scaleLengthParameter(size.x)),that.axisMustBeScaled(scaleAxis[1])&&(geometry.scale.y=that.scaleHeightParameter(size.y)),that.axisMustBeScaled(scaleAxis[2])&&(geometry.scale.z=that.scaleDepthParameter(size.z));var zPosition=geometry.position.z;0<zPosition?geometry.position.z+=.5*change:0>zPosition&&(geometry.position.z-=.5*change),that.model.position[2]=geometry.position.z,that.setModel3D(geometry)},PartView.prototype.updateLength=function(newLength){this.parentLength=newLength},PartView.prototype.updateDepth=function(newDepth){this.parentDepth=newDepth},PartView.prototype.getDimensionsOfOrigin3DModel=function(){var that=this,bb=new THREE.BoundingBoxHelper(that._origin3DModel);return bb.update(),bb.box.size()},PartView.prototype.axisMustBeScaled=function(axis){return 0!==axis},PartView.prototype._getScaleParameter=function(object3D){var size,that=this,scaleParameter=[1,1,1],scaleAxis=that.model.scaleAxis,boundingBox=new THREE.BoundingBoxHelper(object3D);return boundingBox.update(),size=boundingBox.box.size(),that.axisMustBeScaled(scaleAxis[0])&&(scaleParameter[0]=that.scaleLengthParameter(size.x)),that.axisMustBeScaled(scaleAxis[1])&&(scaleParameter[1]=that.scaleHeightParameter(size.y)),that.axisMustBeScaled(scaleAxis[2])&&(scaleParameter[2]=that.scaleDepthParameter(size.z)),scaleParameter},PartView.prototype.updateHeight=function(newParentHeight){this.parentHeight=newParentHeight},PartView.prototype.scaleHeightParameter=function(size){return this.parentHeight/size},PartView.prototype.scaleLengthParameter=function(size){return this.parentLength/size},PartView.prototype.scaleDepthParameter=function(size){return this.parentDepth/size},PartView.prototype.getOriginal3DModel=function(){return this._origin3DModel},PartView.prototype.getParentLength=function(){return this.parentLength},PartView.prototype.getParentDepth=function(){return this.parentDepth},PartView.prototype.getParentHeight=function(){return this.parentHeight};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var ReactBaseClasses = __webpack_require__(65);
var ReactChildren = __webpack_require__(136);
var ReactDOMFactories = __webpack_require__(141);
var ReactElement = __webpack_require__(18);
var ReactPropTypes = __webpack_require__(142);
var ReactVersion = __webpack_require__(149);

var createReactClass = __webpack_require__(150);
var onlyChild = __webpack_require__(152);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var ReactCurrentOwner = __webpack_require__(13);

var warning = __webpack_require__(2);
var canDefineProperty = __webpack_require__(67);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(68);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

function checkMask(value, bitmask) {
  return (value & bitmask) === bitmask;
}

var DOMPropertyInjection = {
  /**
   * Mapping from normalized, camelcased property names to a configuration that
   * specifies how the associated DOM property should be accessed or rendered.
   */
  MUST_USE_PROPERTY: 0x1,
  HAS_BOOLEAN_VALUE: 0x4,
  HAS_NUMERIC_VALUE: 0x8,
  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,

  /**
   * Inject some specialized knowledge about the DOM. This takes a config object
   * with the following properties:
   *
   * isCustomAttribute: function that given an attribute name will return true
   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
   * attributes where it's impossible to enumerate all of the possible
   * attribute names,
   *
   * Properties: object mapping DOM property name to one of the
   * DOMPropertyInjection constants or null. If your attribute isn't in here,
   * it won't get written to the DOM.
   *
   * DOMAttributeNames: object mapping React attribute name to the DOM
   * attribute name. Attribute names not specified use the **lowercase**
   * normalized name.
   *
   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
   * attribute namespace URL. (Attribute names not specified use no namespace.)
   *
   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
   * Property names not specified use the normalized name.
   *
   * DOMMutationMethods: Properties that require special mutation methods. If
   * `value` is undefined, the mutation method should unset the property.
   *
   * @param {object} domPropertyConfig the config as described above.
   */
  injectDOMPropertyConfig: function (domPropertyConfig) {
    var Injection = DOMPropertyInjection;
    var Properties = domPropertyConfig.Properties || {};
    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};

    if (domPropertyConfig.isCustomAttribute) {
      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
    }

    for (var propName in Properties) {
      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;

      var lowerCased = propName.toLowerCase();
      var propConfig = Properties[propName];

      var propertyInfo = {
        attributeName: lowerCased,
        attributeNamespace: null,
        propertyName: propName,
        mutationMethod: null,

        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
      };
      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;

      if (false) {
        DOMProperty.getPossibleStandardName[lowerCased] = propName;
      }

      if (DOMAttributeNames.hasOwnProperty(propName)) {
        var attributeName = DOMAttributeNames[propName];
        propertyInfo.attributeName = attributeName;
        if (false) {
          DOMProperty.getPossibleStandardName[attributeName] = propName;
        }
      }

      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
      }

      if (DOMPropertyNames.hasOwnProperty(propName)) {
        propertyInfo.propertyName = DOMPropertyNames[propName];
      }

      if (DOMMutationMethods.hasOwnProperty(propName)) {
        propertyInfo.mutationMethod = DOMMutationMethods[propName];
      }

      DOMProperty.properties[propName] = propertyInfo;
    }
  }
};

/* eslint-disable max-len */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
/* eslint-enable max-len */

/**
 * DOMProperty exports lookup objects that can be used like functions:
 *
 *   > DOMProperty.isValid['id']
 *   true
 *   > DOMProperty.isValid['foobar']
 *   undefined
 *
 * Although this may be confusing, it performs better in general.
 *
 * @see http://jsperf.com/key-exists
 * @see http://jsperf.com/key-missing
 */
var DOMProperty = {
  ID_ATTRIBUTE_NAME: 'data-reactid',
  ROOT_ATTRIBUTE_NAME: 'data-reactroot',

  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',

  /**
   * Map from property "standard name" to an object with info about how to set
   * the property in the DOM. Each object contains:
   *
   * attributeName:
   *   Used when rendering markup or with `*Attribute()`.
   * attributeNamespace
   * propertyName:
   *   Used on DOM node instances. (This includes properties that mutate due to
   *   external factors.)
   * mutationMethod:
   *   If non-null, used instead of the property or `setAttribute()` after
   *   initial render.
   * mustUseProperty:
   *   Whether the property must be accessed and mutated as an object property.
   * hasBooleanValue:
   *   Whether the property should be removed when set to a falsey value.
   * hasNumericValue:
   *   Whether the property must be numeric or parse as a numeric and should be
   *   removed when set to a falsey value.
   * hasPositiveNumericValue:
   *   Whether the property must be positive numeric or parse as a positive
   *   numeric and should be removed when set to a falsey value.
   * hasOverloadedBooleanValue:
   *   Whether the property can be used as a flag as well as with a value.
   *   Removed when strictly equal to false; present without a value when
   *   strictly equal to true; present with a value otherwise.
   */
  properties: {},

  /**
   * Mapping from lowercase property names to the properly cased version, used
   * to warn in the case of missing properties. Available only in __DEV__.
   *
   * autofocus is predefined, because adding it to the property whitelist
   * causes unintended side effects.
   *
   * @type {Object}
   */
  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,

  /**
   * All of the isCustomAttribute() functions that have been injected.
   */
  _isCustomAttributeFunctions: [],

  /**
   * Checks whether a property name is a custom attribute.
   * @method
   */
  isCustomAttribute: function (attributeName) {
    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
      if (isCustomAttributeFn(attributeName)) {
        return true;
      }
    }
    return false;
  },

  injection: DOMPropertyInjection
};

module.exports = DOMProperty;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactRef = __webpack_require__(173);
var ReactInstrumentation = __webpack_require__(9);

var warning = __webpack_require__(2);

/**
 * Helper to call ReactRef.attachRefs with this composite component, split out
 * to avoid allocations in the transaction mount-ready queue.
 */
function attachRefs() {
  ReactRef.attachRefs(this, this._currentElement);
}

var ReactReconciler = {
  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} the containing host component instance
   * @param {?object} info about the host container
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
  {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
      }
    }
    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
      }
    }
    return markup;
  },

  /**
   * Returns a value that can be passed to
   * ReactComponentEnvironment.replaceNodeWithMarkup.
   */
  getHostNode: function (internalInstance) {
    return internalInstance.getHostNode();
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (internalInstance, safely) {
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
      }
    }
    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
    internalInstance.unmountComponent(safely);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Update a component using a new element.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @internal
   */
  receiveComponent: function (internalInstance, nextElement, transaction, context) {
    var prevElement = internalInstance._currentElement;

    if (nextElement === prevElement && context === internalInstance._context) {
      // Since elements are immutable after the owner is rendered,
      // we can do a cheap identity compare here to determine if this is a
      // superfluous reconcile. It's possible for state to be mutable but such
      // change should trigger an update of the owner which would recreate
      // the element. We explicitly check for the existence of an owner since
      // it's possible for an element created outside a composite to be
      // deeply mutated and reused.

      // TODO: Bailing out early is just a perf optimization right?
      // TODO: Removing the return statement should affect correctness?
      return;
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
      }
    }

    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);

    if (refsChanged) {
      ReactRef.detachRefs(internalInstance, prevElement);
    }

    internalInstance.receiveComponent(nextElement, transaction, context);

    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
    }

    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  },

  /**
   * Flush any dirty changes in a component.
   *
   * @param {ReactComponent} internalInstance
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
      // The component's enqueued batch number should always be the current
      // batch or the following one.
       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
      return;
    }
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
      }
    }
    internalInstance.performUpdateIfNecessary(transaction);
    if (false) {
      if (internalInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
      }
    }
  }
};

module.exports = ReactReconciler;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = __webpack_require__(44);
var setInnerHTML = __webpack_require__(30);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(45);
var setTextContent = __webpack_require__(82);

var ELEMENT_NODE_TYPE = 1;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

/**
 * In IE (8-11) and Edge, appending nodes with no children is dramatically
 * faster than appending a full subtree, so we essentially queue up the
 * .appendChild calls here and apply them so each node is added to its parent
 * before any children are added.
 *
 * In other browsers, doing so is slower or neutral compared to the other order
 * (in Firefox, twice as slow) so we only do this inversion in IE.
 *
 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
 */
var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);

function insertTreeChildren(tree) {
  if (!enableLazy) {
    return;
  }
  var node = tree.node;
  var children = tree.children;
  if (children.length) {
    for (var i = 0; i < children.length; i++) {
      insertTreeBefore(node, children[i], null);
    }
  } else if (tree.html != null) {
    setInnerHTML(node, tree.html);
  } else if (tree.text != null) {
    setTextContent(node, tree.text);
  }
}

var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
  // DocumentFragments aren't actually part of the DOM after insertion so
  // appending children won't update the DOM. We need to ensure the fragment
  // is properly populated first, breaking out of our lazy approach for just
  // this level. Also, some <object> plugins (like Flash Player) will read
  // <param> nodes immediately upon insertion into the DOM, so <object>
  // must also be populated prior to insertion into the DOM.
  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
    insertTreeChildren(tree);
    parentNode.insertBefore(tree.node, referenceNode);
  } else {
    parentNode.insertBefore(tree.node, referenceNode);
    insertTreeChildren(tree);
  }
});

function replaceChildWithTree(oldNode, newTree) {
  oldNode.parentNode.replaceChild(newTree.node, oldNode);
  insertTreeChildren(newTree);
}

function queueChild(parentTree, childTree) {
  if (enableLazy) {
    parentTree.children.push(childTree);
  } else {
    parentTree.node.appendChild(childTree.node);
  }
}

function queueHTML(tree, html) {
  if (enableLazy) {
    tree.html = html;
  } else {
    setInnerHTML(tree.node, html);
  }
}

function queueText(tree, text) {
  if (enableLazy) {
    tree.text = text;
  } else {
    setTextContent(tree.node, text);
  }
}

function toString() {
  return this.node.nodeName;
}

function DOMLazyTree(node) {
  return {
    node: node,
    children: [],
    html: null,
    text: null,
    toString: toString
  };
}

DOMLazyTree.insertTreeBefore = insertTreeBefore;
DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
DOMLazyTree.queueChild = queueChild;
DOMLazyTree.queueHTML = queueHTML;
DOMLazyTree.queueText = queueText;

module.exports = DOMLazyTree;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(24);
var EventPluginUtils = __webpack_require__(38);

var accumulateInto = __webpack_require__(74);
var forEachAccumulated = __webpack_require__(75);
var warning = __webpack_require__(2);

var getListener = EventPluginHub.getListener;

/**
 * Some event types have a notion of different registration names for different
 * "phases" of propagation. This finds listeners by a given phase.
 */
function listenerAtPhase(inst, event, propagationPhase) {
  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
  return getListener(inst, registrationName);
}

/**
 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
 * here, allows us to not have to bind or create functions for each event.
 * Mutating the event's members allows us to not have to create a wrapping
 * "dispatch" object that pairs the event with the listener.
 */
function accumulateDirectionalDispatches(inst, phase, event) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
  }
  var listener = listenerAtPhase(inst, event, phase);
  if (listener) {
    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
  }
}

/**
 * Collect dispatches (must be entirely collected before dispatching - see unit
 * tests). Lazily allocate the array to conserve memory.  We must loop through
 * each event and perform the traversal for each one. We cannot perform a
 * single traversal for the entire collection of events because each event may
 * have a different target.
 */
function accumulateTwoPhaseDispatchesSingle(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
 */
function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
  if (event && event.dispatchConfig.phasedRegistrationNames) {
    var targetInst = event._targetInst;
    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
  }
}

/**
 * Accumulates without regard to direction, does not look for phased
 * registration names. Same as `accumulateDirectDispatchesSingle` but without
 * requiring that the `dispatchMarker` be the same as the dispatched ID.
 */
function accumulateDispatches(inst, ignoredDirection, event) {
  if (event && event.dispatchConfig.registrationName) {
    var registrationName = event.dispatchConfig.registrationName;
    var listener = getListener(inst, registrationName);
    if (listener) {
      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
    }
  }
}

/**
 * Accumulates dispatches on an `SyntheticEvent`, but only for the
 * `dispatchMarker`.
 * @param {SyntheticEvent} event
 */
function accumulateDirectDispatchesSingle(event) {
  if (event && event.dispatchConfig.registrationName) {
    accumulateDispatches(event._targetInst, null, event);
  }
}

function accumulateTwoPhaseDispatches(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
}

function accumulateTwoPhaseDispatchesSkipTarget(events) {
  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
}

function accumulateEnterLeaveDispatches(leave, enter, from, to) {
  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
}

function accumulateDirectDispatches(events) {
  forEachAccumulated(events, accumulateDirectDispatchesSingle);
}

/**
 * A small set of propagation patterns, each of which will accept a small amount
 * of information, and generate a set of "dispatch ready event objects" - which
 * are sets of events that have already been annotated with a set of dispatched
 * listener functions/ids. The API is designed this way to discourage these
 * propagation strategies from actually executing the dispatches, since we
 * always want to collect the entire set of dispatches before executing event a
 * single one.
 *
 * @constructor EventPropagators
 */
var EventPropagators = {
  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
  accumulateDirectDispatches: accumulateDirectDispatches,
  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
};

module.exports = EventPropagators;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var EventPluginRegistry = __webpack_require__(37);
var EventPluginUtils = __webpack_require__(38);
var ReactErrorUtils = __webpack_require__(39);

var accumulateInto = __webpack_require__(74);
var forEachAccumulated = __webpack_require__(75);
var invariant = __webpack_require__(0);

/**
 * Internal store for event listeners
 */
var listenerBank = {};

/**
 * Internal queue of events that have accumulated their dispatches and are
 * waiting to have their dispatches executed.
 */
var eventQueue = null;

/**
 * Dispatches an event and releases it back into the pool, unless persistent.
 *
 * @param {?object} event Synthetic event to be dispatched.
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @private
 */
var executeDispatchesAndRelease = function (event, simulated) {
  if (event) {
    EventPluginUtils.executeDispatchesInOrder(event, simulated);

    if (!event.isPersistent()) {
      event.constructor.release(event);
    }
  }
};
var executeDispatchesAndReleaseSimulated = function (e) {
  return executeDispatchesAndRelease(e, true);
};
var executeDispatchesAndReleaseTopLevel = function (e) {
  return executeDispatchesAndRelease(e, false);
};

var getDictionaryKey = function (inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
};

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

function shouldPreventMouseEvent(name, type, props) {
  switch (name) {
    case 'onClick':
    case 'onClickCapture':
    case 'onDoubleClick':
    case 'onDoubleClickCapture':
    case 'onMouseDown':
    case 'onMouseDownCapture':
    case 'onMouseMove':
    case 'onMouseMoveCapture':
    case 'onMouseUp':
    case 'onMouseUpCapture':
      return !!(props.disabled && isInteractive(type));
    default:
      return false;
  }
}

/**
 * This is a unified interface for event plugins to be installed and configured.
 *
 * Event plugins can implement the following properties:
 *
 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
 *     Required. When a top-level event is fired, this method is expected to
 *     extract synthetic events that will in turn be queued and dispatched.
 *
 *   `eventTypes` {object}
 *     Optional, plugins that fire events must publish a mapping of registration
 *     names that are used to register listeners. Values of this mapping must
 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
 *
 *   `executeDispatch` {function(object, function, string)}
 *     Optional, allows plugins to override how an event gets dispatched. By
 *     default, the listener is simply invoked.
 *
 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
 *
 * @public
 */
var EventPluginHub = {
  /**
   * Methods for injecting dependencies.
   */
  injection: {
    /**
     * @param {array} InjectedEventPluginOrder
     * @public
     */
    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,

    /**
     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
     */
    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
  },

  /**
   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {function} listener The callback to store.
   */
  putListener: function (inst, registrationName, listener) {
    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;

    var key = getDictionaryKey(inst);
    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
    bankForRegistrationName[key] = listener;

    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.didPutListener) {
      PluginModule.didPutListener(inst, registrationName, listener);
    }
  },

  /**
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @return {?function} The stored callback.
   */
  getListener: function (inst, registrationName) {
    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
    // live here; needs to be moved to a better place soon
    var bankForRegistrationName = listenerBank[registrationName];
    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
      return null;
    }
    var key = getDictionaryKey(inst);
    return bankForRegistrationName && bankForRegistrationName[key];
  },

  /**
   * Deletes a listener from the registration bank.
   *
   * @param {object} inst The instance, which is the source of events.
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   */
  deleteListener: function (inst, registrationName) {
    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
    if (PluginModule && PluginModule.willDeleteListener) {
      PluginModule.willDeleteListener(inst, registrationName);
    }

    var bankForRegistrationName = listenerBank[registrationName];
    // TODO: This should never be null -- when is it?
    if (bankForRegistrationName) {
      var key = getDictionaryKey(inst);
      delete bankForRegistrationName[key];
    }
  },

  /**
   * Deletes all listeners for the DOM element with the supplied ID.
   *
   * @param {object} inst The instance, which is the source of events.
   */
  deleteAllListeners: function (inst) {
    var key = getDictionaryKey(inst);
    for (var registrationName in listenerBank) {
      if (!listenerBank.hasOwnProperty(registrationName)) {
        continue;
      }

      if (!listenerBank[registrationName][key]) {
        continue;
      }

      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
      if (PluginModule && PluginModule.willDeleteListener) {
        PluginModule.willDeleteListener(inst, registrationName);
      }

      delete listenerBank[registrationName][key];
    }
  },

  /**
   * Allows registered plugins an opportunity to extract events from top-level
   * native browser events.
   *
   * @return {*} An accumulation of synthetic events.
   * @internal
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events;
    var plugins = EventPluginRegistry.plugins;
    for (var i = 0; i < plugins.length; i++) {
      // Not every plugin in the ordering may be loaded at runtime.
      var possiblePlugin = plugins[i];
      if (possiblePlugin) {
        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
        if (extractedEvents) {
          events = accumulateInto(events, extractedEvents);
        }
      }
    }
    return events;
  },

  /**
   * Enqueues a synthetic event that should be dispatched when
   * `processEventQueue` is invoked.
   *
   * @param {*} events An accumulation of synthetic events.
   * @internal
   */
  enqueueEvents: function (events) {
    if (events) {
      eventQueue = accumulateInto(eventQueue, events);
    }
  },

  /**
   * Dispatches all synthetic events on the event queue.
   *
   * @internal
   */
  processEventQueue: function (simulated) {
    // Set `eventQueue` to null before processing it so that we can tell if more
    // events get enqueued while processing.
    var processingEventQueue = eventQueue;
    eventQueue = null;
    if (simulated) {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
    } else {
      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
    }
    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
    // This would be a good time to rethrow if any of the event handlers threw.
    ReactErrorUtils.rethrowCaughtError();
  },

  /**
   * These are needed for tests only. Do not use!
   */
  __purge: function () {
    listenerBank = {};
  },

  __getListenerBank: function () {
    return listenerBank;
  }
};

module.exports = EventPluginHub;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(14);

var getEventTarget = __webpack_require__(40);

/**
 * @interface UIEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var UIEventInterface = {
  view: function (event) {
    if (event.view) {
      return event.view;
    }

    var target = getEventTarget(event);
    if (target.window === target) {
      // target is a window object
      return target;
    }

    var doc = target.ownerDocument;
    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
    if (doc) {
      return doc.defaultView || doc.parentWindow;
    } else {
      return window;
    }
  },
  detail: function (event) {
    return event.detail || 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);

module.exports = SyntheticUIEvent;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `ReactInstanceMap` maintains a mapping from a public facing stateful
 * instance (key) and the internal representation (value). This allows public
 * methods to accept the user facing instance as an argument and map them back
 * to internal methods.
 */

// TODO: Replace this with ES6: var ReactInstanceMap = new Map();

var ReactInstanceMap = {
  /**
   * This API should be called `delete` but we'd have to make sure to always
   * transform these to strings for IE support. When this transform is fully
   * supported we can rename it.
   */
  remove: function (key) {
    key._reactInternalInstance = undefined;
  },

  get: function (key) {
    return key._reactInternalInstance;
  },

  has: function (key) {
    return key._reactInternalInstance !== undefined;
  },

  set: function (key, value) {
    key._reactInternalInstance = value;
  }
};

module.exports = ReactInstanceMap;

/***/ }),
/* 27 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

var OBSERVED_ERROR = {};

/**
 * `Transaction` creates a black box that is able to wrap any method such that
 * certain invariants are maintained before and after the method is invoked
 * (Even if an exception is thrown while invoking the wrapped method). Whoever
 * instantiates a transaction can provide enforcers of the invariants at
 * creation time. The `Transaction` class itself will supply one additional
 * automatic invariant for you - the invariant that any transaction instance
 * should not be run while it is already being run. You would typically create a
 * single instance of a `Transaction` for reuse multiple times, that potentially
 * is used to wrap several different methods. Wrappers are extremely simple -
 * they only require implementing two methods.
 *
 * <pre>
 *                       wrappers (injected at creation time)
 *                                      +        +
 *                                      |        |
 *                    +-----------------|--------|--------------+
 *                    |                 v        |              |
 *                    |      +---------------+   |              |
 *                    |   +--|    wrapper1   |---|----+         |
 *                    |   |  +---------------+   v    |         |
 *                    |   |          +-------------+  |         |
 *                    |   |     +----|   wrapper2  |--------+   |
 *                    |   |     |    +-------------+  |     |   |
 *                    |   |     |                     |     |   |
 *                    |   v     v                     v     v   | wrapper
 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | |   | |   |   |         |   |   | |   | |
 *                    | +---+ +---+   +---------+   +---+ +---+ |
 *                    |  initialize                    close    |
 *                    +-----------------------------------------+
 * </pre>
 *
 * Use cases:
 * - Preserving the input selection ranges before/after reconciliation.
 *   Restoring selection even in the event of an unexpected error.
 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
 *   while guaranteeing that afterwards, the event system is reactivated.
 * - Flushing a queue of collected DOM mutations to the main UI thread after a
 *   reconciliation takes place in a worker thread.
 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
 *   content.
 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
 * - (Future use case): Layout calculations before and after DOM updates.
 *
 * Transactional plugin API:
 * - A module that has an `initialize` method that returns any precomputation.
 * - and a `close` method that accepts the precomputation. `close` is invoked
 *   when the wrapped process is completed, or has failed.
 *
 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
 * that implement `initialize` and `close`.
 * @return {Transaction} Single transaction for reuse in thread.
 *
 * @class Transaction
 */
var TransactionImpl = {
  /**
   * Sets up this instance so that it is prepared for collecting metrics. Does
   * so such that this setup method may be used on an instance that is already
   * initialized, in a way that does not consume additional memory upon reuse.
   * That can be useful if you decide to make your subclass of this mixin a
   * "PooledClass".
   */
  reinitializeTransaction: function () {
    this.transactionWrappers = this.getTransactionWrappers();
    if (this.wrapperInitData) {
      this.wrapperInitData.length = 0;
    } else {
      this.wrapperInitData = [];
    }
    this._isInTransaction = false;
  },

  _isInTransaction: false,

  /**
   * @abstract
   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
   */
  getTransactionWrappers: null,

  isInTransaction: function () {
    return !!this._isInTransaction;
  },

  /* eslint-disable space-before-function-paren */

  /**
   * Executes the function within a safety window. Use this for the top level
   * methods that result in large amounts of computation/mutations that would
   * need to be safety checked. The optional arguments helps prevent the need
   * to bind in many cases.
   *
   * @param {function} method Member of scope to call.
   * @param {Object} scope Scope to invoke from.
   * @param {Object?=} a Argument to pass to the method.
   * @param {Object?=} b Argument to pass to the method.
   * @param {Object?=} c Argument to pass to the method.
   * @param {Object?=} d Argument to pass to the method.
   * @param {Object?=} e Argument to pass to the method.
   * @param {Object?=} f Argument to pass to the method.
   *
   * @return {*} Return value from `method`.
   */
  perform: function (method, scope, a, b, c, d, e, f) {
    /* eslint-enable space-before-function-paren */
    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
    var errorThrown;
    var ret;
    try {
      this._isInTransaction = true;
      // Catching errors makes debugging more difficult, so we start with
      // errorThrown set to true before setting it to false after calling
      // close -- if it's still set to true in the finally block, it means
      // one of these calls threw.
      errorThrown = true;
      this.initializeAll(0);
      ret = method.call(scope, a, b, c, d, e, f);
      errorThrown = false;
    } finally {
      try {
        if (errorThrown) {
          // If `method` throws, prefer to show that stack trace over any thrown
          // by invoking `closeAll`.
          try {
            this.closeAll(0);
          } catch (err) {}
        } else {
          // Since `method` didn't throw, we don't want to silence the exception
          // here.
          this.closeAll(0);
        }
      } finally {
        this._isInTransaction = false;
      }
    }
    return ret;
  },

  initializeAll: function (startIndex) {
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      try {
        // Catching errors makes debugging more difficult, so we start with the
        // OBSERVED_ERROR state before overwriting it with the real return value
        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
        // block, it means wrapper.initialize threw.
        this.wrapperInitData[i] = OBSERVED_ERROR;
        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
      } finally {
        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
          // The initializer for wrapper i threw an error; initialize the
          // remaining wrappers but silence any exceptions from them to ensure
          // that the first error is the one to bubble up.
          try {
            this.initializeAll(i + 1);
          } catch (err) {}
        }
      }
    }
  },

  /**
   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
   * them the respective return values of `this.transactionWrappers.init[i]`
   * (`close`rs that correspond to initializers that failed will not be
   * invoked).
   */
  closeAll: function (startIndex) {
    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
    var transactionWrappers = this.transactionWrappers;
    for (var i = startIndex; i < transactionWrappers.length; i++) {
      var wrapper = transactionWrappers[i];
      var initData = this.wrapperInitData[i];
      var errorThrown;
      try {
        // Catching errors makes debugging more difficult, so we start with
        // errorThrown set to true before setting it to false after calling
        // close -- if it's still set to true in the finally block, it means
        // wrapper.close threw.
        errorThrown = true;
        if (initData !== OBSERVED_ERROR && wrapper.close) {
          wrapper.close.call(this, initData);
        }
        errorThrown = false;
      } finally {
        if (errorThrown) {
          // The closer for wrapper i threw an error; close the remaining
          // wrappers but silence any exceptions from them to ensure that the
          // first error is the one to bubble up.
          try {
            this.closeAll(i + 1);
          } catch (e) {}
        }
      }
    }
    this.wrapperInitData.length = 0;
  }
};

module.exports = TransactionImpl;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(25);
var ViewportMetrics = __webpack_require__(81);

var getEventModifierState = __webpack_require__(42);

/**
 * @interface MouseEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var MouseEventInterface = {
  screenX: null,
  screenY: null,
  clientX: null,
  clientY: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  getModifierState: getEventModifierState,
  button: function (event) {
    // Webkit, Firefox, IE9+
    // which:  1 2 3
    // button: 0 1 2 (standard)
    var button = event.button;
    if ('which' in event) {
      return button;
    }
    // IE<9
    // which:  undefined
    // button: 0 0 0
    // button: 1 4 2 (onmouseup)
    return button === 2 ? 2 : button === 4 ? 1 : 0;
  },
  buttons: null,
  relatedTarget: function (event) {
    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
  },
  // "Proprietary" Interface.
  pageX: function (event) {
    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
  },
  pageY: function (event) {
    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);

module.exports = SyntheticMouseEvent;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);
var DOMNamespaces = __webpack_require__(44);

var WHITESPACE_TEST = /^[ \r\n\t\f]/;
var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;

var createMicrosoftUnsafeLocalFunction = __webpack_require__(45);

// SVG temp container for IE lacking innerHTML
var reusableSVGContainer;

/**
 * Set the innerHTML property of a node, ensuring that whitespace is preserved
 * even in IE8.
 *
 * @param {DOMElement} node
 * @param {string} html
 * @internal
 */
var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
  // IE does not have innerHTML for SVG nodes, so instead we inject the
  // new markup in a temp node and then move the child nodes across into
  // the target node
  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
    var svgNode = reusableSVGContainer.firstChild;
    while (svgNode.firstChild) {
      node.appendChild(svgNode.firstChild);
    }
  } else {
    node.innerHTML = html;
  }
});

if (ExecutionEnvironment.canUseDOM) {
  // IE8: When updating a just created node with innerHTML only leading
  // whitespace is removed. When updating an existing node with innerHTML
  // whitespace in root TextNodes is also collapsed.
  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html

  // Feature detection; only IE8 is known to behave improperly like this.
  var testElement = document.createElement('div');
  testElement.innerHTML = ' ';
  if (testElement.innerHTML === '') {
    setInnerHTML = function (node, html) {
      // Magic theory: IE8 supposedly differentiates between added and updated
      // nodes when processing innerHTML, innerHTML on updated nodes suffers
      // from worse whitespace behavior. Re-adding a node like this triggers
      // the initial and more favorable whitespace behavior.
      // TODO: What to do on a detached node?
      if (node.parentNode) {
        node.parentNode.replaceChild(node, node);
      }

      // We also implement a workaround for non-visible tags disappearing into
      // thin air on IE8, this only happens if there is no visible text
      // in-front of the non-visible tags. Piggyback on the whitespace fix
      // and simply check if any non-visible tags appear in the source.
      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
        // Recover leading whitespace by temporarily prepending any character.
        // \uFEFF has the potential advantage of being zero-width/invisible.
        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
        // in hopes that this is preserved even if "\uFEFF" is transformed to
        // the actual Unicode character (by Babel, for example).
        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
        node.innerHTML = String.fromCharCode(0xfeff) + html;

        // deleteData leaves an empty `TextNode` which offsets the index of all
        // children. Definitely want to avoid this.
        var textNode = node.firstChild;
        if (textNode.data.length === 1) {
          node.removeChild(textNode);
        } else {
          textNode.deleteData(0, 1);
        }
      } else {
        node.innerHTML = html;
      }
    };
  }
  testElement = null;
}

module.exports = setInnerHTML;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Based on the escape-html library, which is used under the MIT License below:
 *
 * Copyright (c) 2012-2013 TJ Holowaychuk
 * Copyright (c) 2015 Andreas Lubbe
 * Copyright (c) 2015 Tiancheng "Timothy" Gu
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * 'Software'), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 */



// code copied and modified from escape-html
/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}
// end code copied and modified from escape-html

/**
 * Escapes text to prevent scripting attacks.
 *
 * @param {*} text Text value to escape.
 * @return {string} An escaped string.
 */
function escapeTextContentForBrowser(text) {
  if (typeof text === 'boolean' || typeof text === 'number') {
    // this shortcircuit helps perf for types that we know will never have
    // special characters, especially given that this function is used often
    // for numeric dom ids.
    return '' + text;
  }
  return escapeHtml(text);
}

module.exports = escapeTextContentForBrowser;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var EventPluginRegistry = __webpack_require__(37);
var ReactEventEmitterMixin = __webpack_require__(194);
var ViewportMetrics = __webpack_require__(81);

var getVendorPrefixedEventName = __webpack_require__(195);
var isEventSupported = __webpack_require__(41);

/**
 * Summary of `ReactBrowserEventEmitter` event handling:
 *
 *  - Top-level delegation is used to trap most native browser events. This
 *    may only occur in the main thread and is the responsibility of
 *    ReactEventListener, which is injected and can therefore support pluggable
 *    event sources. This is the only work that occurs in the main thread.
 *
 *  - We normalize and de-duplicate events to account for browser quirks. This
 *    may be done in the worker thread.
 *
 *  - Forward these native events (with the associated top-level type used to
 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
 *    to extract any synthetic events.
 *
 *  - The `EventPluginHub` will then process each event by annotating them with
 *    "dispatches", a sequence of listeners and IDs that care about that event.
 *
 *  - The `EventPluginHub` then dispatches the events.
 *
 * Overview of React and the event system:
 *
 * +------------+    .
 * |    DOM     |    .
 * +------------+    .
 *       |           .
 *       v           .
 * +------------+    .
 * | ReactEvent |    .
 * |  Listener  |    .
 * +------------+    .                         +-----------+
 *       |           .               +--------+|SimpleEvent|
 *       |           .               |         |Plugin     |
 * +-----|------+    .               v         +-----------+
 * |     |      |    .    +--------------+                    +------------+
 * |     +-----------.--->|EventPluginHub|                    |    Event   |
 * |            |    .    |              |     +-----------+  | Propagators|
 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
 * |            |    .    |              |     +-----------+  |  utilities |
 * |     +-----------.--->|              |                    +------------+
 * |     |      |    .    +--------------+
 * +-----|------+    .                ^        +-----------+
 *       |           .                |        |Enter/Leave|
 *       +           .                +-------+|Plugin     |
 * +-------------+   .                         +-----------+
 * | application |   .
 * |-------------|   .
 * |             |   .
 * |             |   .
 * +-------------+   .
 *                   .
 *    React Core     .  General Purpose Event Plugin System
 */

var hasEventPageXY;
var alreadyListeningTo = {};
var isMonitoringScrollValue = false;
var reactTopListenersCounter = 0;

// For events like 'submit' which don't consistently bubble (which we trap at a
// lower node than `document`), binding at `document` would cause duplicate
// events so we don't include them here
var topEventMapping = {
  topAbort: 'abort',
  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
  topBlur: 'blur',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topChange: 'change',
  topClick: 'click',
  topCompositionEnd: 'compositionend',
  topCompositionStart: 'compositionstart',
  topCompositionUpdate: 'compositionupdate',
  topContextMenu: 'contextmenu',
  topCopy: 'copy',
  topCut: 'cut',
  topDoubleClick: 'dblclick',
  topDrag: 'drag',
  topDragEnd: 'dragend',
  topDragEnter: 'dragenter',
  topDragExit: 'dragexit',
  topDragLeave: 'dragleave',
  topDragOver: 'dragover',
  topDragStart: 'dragstart',
  topDrop: 'drop',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topFocus: 'focus',
  topInput: 'input',
  topKeyDown: 'keydown',
  topKeyPress: 'keypress',
  topKeyUp: 'keyup',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topMouseDown: 'mousedown',
  topMouseMove: 'mousemove',
  topMouseOut: 'mouseout',
  topMouseOver: 'mouseover',
  topMouseUp: 'mouseup',
  topPaste: 'paste',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topScroll: 'scroll',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topSelectionChange: 'selectionchange',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTextInput: 'textInput',
  topTimeUpdate: 'timeupdate',
  topTouchCancel: 'touchcancel',
  topTouchEnd: 'touchend',
  topTouchMove: 'touchmove',
  topTouchStart: 'touchstart',
  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting',
  topWheel: 'wheel'
};

/**
 * To ensure no conflicts with other potential React instances on the page
 */
var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);

function getListeningForDocument(mountAt) {
  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
  // directly.
  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
    mountAt[topListenersIDKey] = reactTopListenersCounter++;
    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
  }
  return alreadyListeningTo[mountAt[topListenersIDKey]];
}

/**
 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
 * example:
 *
 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
 *
 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
 *
 * @internal
 */
var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
  /**
   * Injectable event backend
   */
  ReactEventListener: null,

  injection: {
    /**
     * @param {object} ReactEventListener
     */
    injectReactEventListener: function (ReactEventListener) {
      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
    }
  },

  /**
   * Sets whether or not any created callbacks should be enabled.
   *
   * @param {boolean} enabled True if callbacks should be enabled.
   */
  setEnabled: function (enabled) {
    if (ReactBrowserEventEmitter.ReactEventListener) {
      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
    }
  },

  /**
   * @return {boolean} True if callbacks are enabled.
   */
  isEnabled: function () {
    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
  },

  /**
   * We listen for bubbled touch events on the document object.
   *
   * Firefox v8.01 (and possibly others) exhibited strange behavior when
   * mounting `onmousemove` events at some node that was not the document
   * element. The symptoms were that if your mouse is not moving over something
   * contained within that mount point (for example on the background) the
   * top-level listeners for `onmousemove` won't be called. However, if you
   * register the `mousemove` on the document object, then it will of course
   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
   * top-level listeners to the document object only, at least for these
   * movement types of events and possibly all events.
   *
   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
   *
   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
   * they bubble to document.
   *
   * @param {string} registrationName Name of listener (e.g. `onClick`).
   * @param {object} contentDocumentHandle Document which owns the container
   */
  listenTo: function (registrationName, contentDocumentHandle) {
    var mountAt = contentDocumentHandle;
    var isListening = getListeningForDocument(mountAt);
    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];

    for (var i = 0; i < dependencies.length; i++) {
      var dependency = dependencies[i];
      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
        if (dependency === 'topWheel') {
          if (isEventSupported('wheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
          } else if (isEventSupported('mousewheel')) {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
          } else {
            // Firefox needs to capture a different mouse scroll event.
            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
          }
        } else if (dependency === 'topScroll') {
          if (isEventSupported('scroll', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
          } else {
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
          }
        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
          if (isEventSupported('focus', true)) {
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
          } else if (isEventSupported('focusin')) {
            // IE has `focusin` and `focusout` events which bubble.
            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
          }

          // to make sure blur and focus event listeners are only attached once
          isListening.topBlur = true;
          isListening.topFocus = true;
        } else if (topEventMapping.hasOwnProperty(dependency)) {
          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
        }

        isListening[dependency] = true;
      }
    }
  },

  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
  },

  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
  },

  /**
   * Protect against document.createEvent() returning null
   * Some popup blocker extensions appear to do this:
   * https://github.com/facebook/react/issues/6887
   */
  supportsEventPageXY: function () {
    if (!document.createEvent) {
      return false;
    }
    var ev = document.createEvent('MouseEvent');
    return ev != null && 'pageX' in ev;
  },

  /**
   * Listens to window scroll and resize events. We cache scroll values so that
   * application code can access them without triggering reflows.
   *
   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
   * pageX/pageY isn't supported (legacy browsers).
   *
   * NOTE: Scroll events do not bubble.
   *
   * @see http://www.quirksmode.org/dom/events/scroll.html
   */
  ensureScrollValueMonitoring: function () {
    if (hasEventPageXY === undefined) {
      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
    }
    if (!hasEventPageXY && !isMonitoringScrollValue) {
      var refresh = ViewportMetrics.refreshScrollValues;
      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
      isMonitoringScrollValue = true;
    }
  }
});

module.exports = ReactBrowserEventEmitter;

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports={Controller:__webpack_require__(100),BuilderApi:__webpack_require__(62)};

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var caseWorldController,data,basePath,CaseWorldController=__webpack_require__(33).Controller,BuilderApi=__webpack_require__(33).BuilderApi,requestUpdates=__webpack_require__(163);function bootstrap(initialData){data=initialData;basePath='/wp-content/themes/megacase/img/static/tr/js/caseconfigurator/',caseWorldController=new CaseWorldController({data:data,viewHeight:465,viewWidth:684,basePath:basePath}),preloadPossibleParts(data,basePath),loadCasefactory()}function loadCasefactory(){var $3DContainer=$('[data-3d-container]'),$hideOverlay=$3DContainer.find('[data-hide-overlay]');window.Float32Array||($3DContainer.addClass('fallback'),$3DContainer.addClass('nowebgl')),$hideOverlay.show(),caseWorldController.load($3DContainer),caseWorldController.getCaseWorldView().once('WorldCreated',function(){caseWorldController.emit('init'),$hideOverlay.hide()})}function preloadPossibleParts(data,path){setTimeout(function(){data.possibleParts.forEach(function(part){if(part.file){var FILE_PATH=path+'3DModels/',loader=new THREE.OBJMTLLoader;loader.load(FILE_PATH+part.file,FILE_PATH+part.textureFile)}})},1e4)}function activateOption(option){caseWorldController.activateOption(),requestUpdates(BuilderApi.createUpdateOptionObject(data.case.id,option,'Ja'),onNewData)}function deactivateOption(option){caseWorldController.deactivateOption(data.case.id,option),requestUpdates(BuilderApi.createUpdateOptionObject(data.case.id,option,'Nein'),onNewData)}function removeRollsOrFeeds(part){caseWorldController.removeRollsOrFeeds(part.category,data.case.id),requestUpdates(BuilderApi.createUpdatePartObject(null,part.category,data.case.id),onNewData)}function addRollsOrFeeds(part){caseWorldController.addRollsOrFeeds(data.case.id,part.id,part.category,part.file,part.textureFile,part.normalMaps),requestUpdates(BuilderApi.createUpdatePartObject(part.id,part.category,data.case.id),onNewData)}function updateKeyboard(keyboardId,keyboardAndModel){caseWorldController.updateKeyboard(),requestUpdates(BuilderApi.createUpdateKeyboardObject(keyboardId,keyboardAndModel,data.case.id),onNewData)}function scaleCaseHeightTo(newHeight){caseWorldController.scaleCaseHeightTo(newHeight,data.case.id),requestUpdates(BuilderApi.createUpdateDimesionObject(newHeight,'height',data.case.id),onNewData)}function scaleCaseLengthTo(newLength){caseWorldController.scaleCaseLengthTo(newLength,data.case.id),requestUpdates(BuilderApi.createUpdateDimesionObject(newLength,'length',data.case.id),onNewData)}function scaleCaseDimensionToAndRequestUpdates(dimension,value,caseId){'height_unit'==dimension?scaleCaseDimensionTo('height',45*value,caseId):scaleCaseDimensionTo(dimension,value,caseId),requestUpdates(BuilderApi.createUpdateDimesionObject(value,dimension,data.case.id),onNewData)}function scaleCaseDepthTo(newDepth){caseWorldController.scaleCaseDepthTo(newDepth,data.case.id),requestUpdates(BuilderApi.createUpdateDimesionObject(newDepth,'depth',data.case.id),onNewData)}function scaleCaseDimensionTo(dimension,value){'depth'==dimension?caseWorldController.scaleCaseDepthTo(value,data.case.id):'height'==dimension?caseWorldController.scaleCaseHeightTo(value,data.case.id):caseWorldController.scaleCaseLengthTo(value,data.case.id)}function changeElementInCaseWorld(partId,category,file,textureFile,normalMaps,on,needUpdate,invisiblePart){function callback(newData){invisiblePart&&partId&&category&&caseWorldController.caseWorldView.setInvisiblePart(category,partId),needUpdate||caseWorldController.endAction(),onNewData(newData)}caseWorldController.changeElement(partId,category,file,textureFile,normalMaps,on),caseWorldController.prepareForUpdate(),requestUpdates(BuilderApi.createUpdatePartObject(partId,category,data.case.id),callback)}function onNewData(newData){newData.success===void 0&&(data=newData),caseWorldController.performUpdate(data),caseWorldController.emit('caseUpdated',data)}function getCaseWorldController(){return caseWorldController}function getData(){return data}function getBasePath(){return basePath}module.exports={bootstrap:bootstrap,getCaseWorldController:getCaseWorldController,getData:getData,getBasePath:getBasePath,action:{changeElementInCaseWorld:changeElementInCaseWorld,scaleCaseDimensionTo:scaleCaseDimensionTo,scaleCaseDepthTo:scaleCaseDepthTo,scaleCaseLengthTo:scaleCaseLengthTo,scaleCaseHeightTo:scaleCaseHeightTo,updateKeyboard:updateKeyboard,addRollsOrFeeds:addRollsOrFeeds,removeRollsOrFeeds:removeRollsOrFeeds,deactivateOption:deactivateOption,activateOption:activateOption,scaleCaseDimensionToAndRequestUpdates:scaleCaseDimensionToAndRequestUpdates}};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

/**
 * Injectable ordering of event plugins.
 */
var eventPluginOrder = null;

/**
 * Injectable mapping from names to event plugin modules.
 */
var namesToPlugins = {};

/**
 * Recomputes the plugin list using the injected plugins and plugin ordering.
 *
 * @private
 */
function recomputePluginOrdering() {
  if (!eventPluginOrder) {
    // Wait until an `eventPluginOrder` is injected.
    return;
  }
  for (var pluginName in namesToPlugins) {
    var pluginModule = namesToPlugins[pluginName];
    var pluginIndex = eventPluginOrder.indexOf(pluginName);
    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
    if (EventPluginRegistry.plugins[pluginIndex]) {
      continue;
    }
    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
    var publishedEvents = pluginModule.eventTypes;
    for (var eventName in publishedEvents) {
      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
    }
  }
}

/**
 * Publishes an event so that it can be dispatched by the supplied plugin.
 *
 * @param {object} dispatchConfig Dispatch configuration for the event.
 * @param {object} PluginModule Plugin publishing the event.
 * @return {boolean} True if the event was successfully published.
 * @private
 */
function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;

  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
  if (phasedRegistrationNames) {
    for (var phaseName in phasedRegistrationNames) {
      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
        var phasedRegistrationName = phasedRegistrationNames[phaseName];
        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
      }
    }
    return true;
  } else if (dispatchConfig.registrationName) {
    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
    return true;
  }
  return false;
}

/**
 * Publishes a registration name that is used to identify dispatched events and
 * can be used with `EventPluginHub.putListener` to register listeners.
 *
 * @param {string} registrationName Registration name to add.
 * @param {object} PluginModule Plugin publishing the event.
 * @private
 */
function publishRegistrationName(registrationName, pluginModule, eventName) {
  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;

  if (false) {
    var lowerCasedName = registrationName.toLowerCase();
    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;

    if (registrationName === 'onDoubleClick') {
      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
    }
  }
}

/**
 * Registers plugins so that they can extract and dispatch events.
 *
 * @see {EventPluginHub}
 */
var EventPluginRegistry = {
  /**
   * Ordered list of injected plugins.
   */
  plugins: [],

  /**
   * Mapping from event name to dispatch config
   */
  eventNameDispatchConfigs: {},

  /**
   * Mapping from registration name to plugin module
   */
  registrationNameModules: {},

  /**
   * Mapping from registration name to event name
   */
  registrationNameDependencies: {},

  /**
   * Mapping from lowercase registration names to the properly cased version,
   * used to warn in the case of missing event handlers. Available
   * only in __DEV__.
   * @type {Object}
   */
  possibleRegistrationNames:  false ? {} : null,
  // Trust the developer to only use possibleRegistrationNames in __DEV__

  /**
   * Injects an ordering of plugins (by plugin name). This allows the ordering
   * to be decoupled from injection of the actual plugins so that ordering is
   * always deterministic regardless of packaging, on-the-fly injection, etc.
   *
   * @param {array} InjectedEventPluginOrder
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginOrder}
   */
  injectEventPluginOrder: function (injectedEventPluginOrder) {
    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
    // Clone the ordering so it cannot be dynamically mutated.
    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
    recomputePluginOrdering();
  },

  /**
   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
   * in the ordering injected by `injectEventPluginOrder`.
   *
   * Plugins can be injected as part of page initialization or on-the-fly.
   *
   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
   * @internal
   * @see {EventPluginHub.injection.injectEventPluginsByName}
   */
  injectEventPluginsByName: function (injectedNamesToPlugins) {
    var isOrderingDirty = false;
    for (var pluginName in injectedNamesToPlugins) {
      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
        continue;
      }
      var pluginModule = injectedNamesToPlugins[pluginName];
      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
        namesToPlugins[pluginName] = pluginModule;
        isOrderingDirty = true;
      }
    }
    if (isOrderingDirty) {
      recomputePluginOrdering();
    }
  },

  /**
   * Looks up the plugin for the supplied event.
   *
   * @param {object} event A synthetic event.
   * @return {?object} The plugin that created the supplied event.
   * @internal
   */
  getPluginModuleForEvent: function (event) {
    var dispatchConfig = event.dispatchConfig;
    if (dispatchConfig.registrationName) {
      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
    }
    if (dispatchConfig.phasedRegistrationNames !== undefined) {
      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
      // that it is not undefined.
      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;

      for (var phase in phasedRegistrationNames) {
        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
          continue;
        }
        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
        if (pluginModule) {
          return pluginModule;
        }
      }
    }
    return null;
  },

  /**
   * Exposed for unit testing.
   * @private
   */
  _resetEventPlugins: function () {
    eventPluginOrder = null;
    for (var pluginName in namesToPlugins) {
      if (namesToPlugins.hasOwnProperty(pluginName)) {
        delete namesToPlugins[pluginName];
      }
    }
    EventPluginRegistry.plugins.length = 0;

    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
    for (var eventName in eventNameDispatchConfigs) {
      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
        delete eventNameDispatchConfigs[eventName];
      }
    }

    var registrationNameModules = EventPluginRegistry.registrationNameModules;
    for (var registrationName in registrationNameModules) {
      if (registrationNameModules.hasOwnProperty(registrationName)) {
        delete registrationNameModules[registrationName];
      }
    }

    if (false) {
      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
      for (var lowerCasedName in possibleRegistrationNames) {
        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
          delete possibleRegistrationNames[lowerCasedName];
        }
      }
    }
  }
};

module.exports = EventPluginRegistry;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var ReactErrorUtils = __webpack_require__(39);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

/**
 * Injected dependencies:
 */

/**
 * - `ComponentTree`: [required] Module that can convert between React instances
 *   and actual node references.
 */
var ComponentTree;
var TreeTraversal;
var injection = {
  injectComponentTree: function (Injected) {
    ComponentTree = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
    }
  },
  injectTreeTraversal: function (Injected) {
    TreeTraversal = Injected;
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
    }
  }
};

function isEndish(topLevelType) {
  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
}

function isMoveish(topLevelType) {
  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
}
function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

var validateEventDispatches;
if (false) {
  validateEventDispatches = function (event) {
    var dispatchListeners = event._dispatchListeners;
    var dispatchInstances = event._dispatchInstances;

    var listenersIsArr = Array.isArray(dispatchListeners);
    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;

    var instancesIsArr = Array.isArray(dispatchInstances);
    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;

    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
  };
}

/**
 * Dispatch the event to the listener.
 * @param {SyntheticEvent} event SyntheticEvent to handle
 * @param {boolean} simulated If the event is simulated (changes exn behavior)
 * @param {function} listener Application-level callback
 * @param {*} inst Internal component instance
 */
function executeDispatch(event, simulated, listener, inst) {
  var type = event.type || 'unknown-event';
  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
  if (simulated) {
    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
  } else {
    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
  }
  event.currentTarget = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches.
 */
function executeDispatchesInOrder(event, simulated) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
    }
  } else if (dispatchListeners) {
    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
  }
  event._dispatchListeners = null;
  event._dispatchInstances = null;
}

/**
 * Standard/simple iteration through an event's collected dispatches, but stops
 * at the first dispatch execution returning true, and returns that id.
 *
 * @return {?string} id of the first dispatch execution who's listener returns
 * true, or null if no listener returned true.
 */
function executeDispatchesInOrderStopAtTrueImpl(event) {
  var dispatchListeners = event._dispatchListeners;
  var dispatchInstances = event._dispatchInstances;
  if (false) {
    validateEventDispatches(event);
  }
  if (Array.isArray(dispatchListeners)) {
    for (var i = 0; i < dispatchListeners.length; i++) {
      if (event.isPropagationStopped()) {
        break;
      }
      // Listeners and Instances are two parallel arrays that are always in sync.
      if (dispatchListeners[i](event, dispatchInstances[i])) {
        return dispatchInstances[i];
      }
    }
  } else if (dispatchListeners) {
    if (dispatchListeners(event, dispatchInstances)) {
      return dispatchInstances;
    }
  }
  return null;
}

/**
 * @see executeDispatchesInOrderStopAtTrueImpl
 */
function executeDispatchesInOrderStopAtTrue(event) {
  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
  event._dispatchInstances = null;
  event._dispatchListeners = null;
  return ret;
}

/**
 * Execution of a "direct" dispatch - there must be at most one dispatch
 * accumulated on the event or it is considered an error. It doesn't really make
 * sense for an event with multiple dispatches (bubbled) to keep track of the
 * return values at each dispatch execution, but it does tend to make sense when
 * dealing with "direct" dispatches.
 *
 * @return {*} The return value of executing the single dispatch.
 */
function executeDirectDispatch(event) {
  if (false) {
    validateEventDispatches(event);
  }
  var dispatchListener = event._dispatchListeners;
  var dispatchInstance = event._dispatchInstances;
  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
  var res = dispatchListener ? dispatchListener(event) : null;
  event.currentTarget = null;
  event._dispatchListeners = null;
  event._dispatchInstances = null;
  return res;
}

/**
 * @param {SyntheticEvent} event
 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
 */
function hasDispatches(event) {
  return !!event._dispatchListeners;
}

/**
 * General utilities that are useful in creating custom Event Plugins.
 */
var EventPluginUtils = {
  isEndish: isEndish,
  isMoveish: isMoveish,
  isStartish: isStartish,

  executeDirectDispatch: executeDirectDispatch,
  executeDispatchesInOrder: executeDispatchesInOrder,
  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
  hasDispatches: hasDispatches,

  getInstanceFromNode: function (node) {
    return ComponentTree.getInstanceFromNode(node);
  },
  getNodeFromInstance: function (node) {
    return ComponentTree.getNodeFromInstance(node);
  },
  isAncestor: function (a, b) {
    return TreeTraversal.isAncestor(a, b);
  },
  getLowestCommonAncestor: function (a, b) {
    return TreeTraversal.getLowestCommonAncestor(a, b);
  },
  getParentInstance: function (inst) {
    return TreeTraversal.getParentInstance(inst);
  },
  traverseTwoPhase: function (target, fn, arg) {
    return TreeTraversal.traverseTwoPhase(target, fn, arg);
  },
  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
  },

  injection: injection
};

module.exports = EventPluginUtils;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var caughtError = null;

/**
 * Call a function while guarding against errors that happens within it.
 *
 * @param {String} name of the guard to use for logging or debugging
 * @param {Function} func The function to invoke
 * @param {*} a First argument
 * @param {*} b Second argument
 */
function invokeGuardedCallback(name, func, a) {
  try {
    func(a);
  } catch (x) {
    if (caughtError === null) {
      caughtError = x;
    }
  }
}

var ReactErrorUtils = {
  invokeGuardedCallback: invokeGuardedCallback,

  /**
   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
   * handler are sure to be rethrown by rethrowCaughtError.
   */
  invokeGuardedCallbackWithCatch: invokeGuardedCallback,

  /**
   * During execution of guarded functions we will capture the first error which
   * we will rethrow to be handled by the top level error handler.
   */
  rethrowCaughtError: function () {
    if (caughtError) {
      var error = caughtError;
      caughtError = null;
      throw error;
    }
  }
};

if (false) {
  /**
   * To help development we can get better devtools integration by simulating a
   * real browser event.
   */
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
    var fakeNode = document.createElement('react');
    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
      var boundFunc = function () {
        func(a);
      };
      var evtType = 'react-' + name;
      fakeNode.addEventListener(evtType, boundFunc, false);
      var evt = document.createEvent('Event');
      evt.initEvent(evtType, false, false);
      fakeNode.dispatchEvent(evt);
      fakeNode.removeEventListener(evtType, boundFunc, false);
    };
  }
}

module.exports = ReactErrorUtils;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Gets the target node from a native browser event by accounting for
 * inconsistencies in browser DOM APIs.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {DOMEventTarget} Target node.
 */

function getEventTarget(nativeEvent) {
  var target = nativeEvent.target || nativeEvent.srcElement || window;

  // Normalize SVG <use> element events #4963
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
  // @see http://www.quirksmode.org/js/events_properties.html
  return target.nodeType === 3 ? target.parentNode : target;
}

module.exports = getEventTarget;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

var useHasFeature;
if (ExecutionEnvironment.canUseDOM) {
  useHasFeature = document.implementation && document.implementation.hasFeature &&
  // always returns true in newer browsers as per the standard.
  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
  document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

module.exports = isEventSupported;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Translation from modifier key to the associated property in the event.
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
 */

var modifierKeyToProp = {
  Alt: 'altKey',
  Control: 'ctrlKey',
  Meta: 'metaKey',
  Shift: 'shiftKey'
};

// IE8 does not implement getModifierState so we simply map it to the only
// modifier keys exposed by the event itself, does not support Lock-keys.
// Currently, all major browsers except Chrome seems to support Lock-keys.
function modifierStateGetter(keyArg) {
  var syntheticEvent = this;
  var nativeEvent = syntheticEvent.nativeEvent;
  if (nativeEvent.getModifierState) {
    return nativeEvent.getModifierState(keyArg);
  }
  var keyProp = modifierKeyToProp[keyArg];
  return keyProp ? !!nativeEvent[keyProp] : false;
}

function getEventModifierState(nativeEvent) {
  return modifierStateGetter;
}

module.exports = getEventModifierState;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMLazyTree = __webpack_require__(21);
var Danger = __webpack_require__(179);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(9);

var createMicrosoftUnsafeLocalFunction = __webpack_require__(45);
var setInnerHTML = __webpack_require__(30);
var setTextContent = __webpack_require__(82);

function getNodeAfter(parentNode, node) {
  // Special case for text components, which return [open, close] comments
  // from getHostNode.
  if (Array.isArray(node)) {
    node = node[1];
  }
  return node ? node.nextSibling : parentNode.firstChild;
}

/**
 * Inserts `childNode` as a child of `parentNode` at the `index`.
 *
 * @param {DOMElement} parentNode Parent node in which to insert.
 * @param {DOMElement} childNode Child node to insert.
 * @param {number} index Index at which to insert the child.
 * @internal
 */
var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
  // We rely exclusively on `insertBefore(node, null)` instead of also using
  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
  // we are careful to use `null`.)
  parentNode.insertBefore(childNode, referenceNode);
});

function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
}

function moveChild(parentNode, childNode, referenceNode) {
  if (Array.isArray(childNode)) {
    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
  } else {
    insertChildAt(parentNode, childNode, referenceNode);
  }
}

function removeChild(parentNode, childNode) {
  if (Array.isArray(childNode)) {
    var closingComment = childNode[1];
    childNode = childNode[0];
    removeDelimitedText(parentNode, childNode, closingComment);
    parentNode.removeChild(closingComment);
  }
  parentNode.removeChild(childNode);
}

function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
  var node = openingComment;
  while (true) {
    var nextNode = node.nextSibling;
    insertChildAt(parentNode, node, referenceNode);
    if (node === closingComment) {
      break;
    }
    node = nextNode;
  }
}

function removeDelimitedText(parentNode, startNode, closingComment) {
  while (true) {
    var node = startNode.nextSibling;
    if (node === closingComment) {
      // The closing comment is removed by ReactMultiChild.
      break;
    } else {
      parentNode.removeChild(node);
    }
  }
}

function replaceDelimitedText(openingComment, closingComment, stringText) {
  var parentNode = openingComment.parentNode;
  var nodeAfterComment = openingComment.nextSibling;
  if (nodeAfterComment === closingComment) {
    // There are no text nodes between the opening and closing comments; insert
    // a new one if stringText isn't empty.
    if (stringText) {
      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
    }
  } else {
    if (stringText) {
      // Set the text content of the first node after the opening comment, and
      // remove all following nodes up until the closing comment.
      setTextContent(nodeAfterComment, stringText);
      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
    } else {
      removeDelimitedText(parentNode, openingComment, closingComment);
    }
  }

  if (false) {
    ReactInstrumentation.debugTool.onHostOperation({
      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
      type: 'replace text',
      payload: stringText
    });
  }
}

var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
if (false) {
  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
    if (prevInstance._debugID !== 0) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: prevInstance._debugID,
        type: 'replace with',
        payload: markup.toString()
      });
    } else {
      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
      if (nextInstance._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: nextInstance._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  };
}

/**
 * Operations for updating with DOM children.
 */
var DOMChildrenOperations = {
  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,

  replaceDelimitedText: replaceDelimitedText,

  /**
   * Updates a component's children by processing a series of updates. The
   * update configurations are each expected to have a `parentNode` property.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  processUpdates: function (parentNode, updates) {
    if (false) {
      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
    }

    for (var k = 0; k < updates.length; k++) {
      var update = updates[k];
      switch (update.type) {
        case 'INSERT_MARKUP':
          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'insert child',
              payload: {
                toIndex: update.toIndex,
                content: update.content.toString()
              }
            });
          }
          break;
        case 'MOVE_EXISTING':
          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'move child',
              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
            });
          }
          break;
        case 'SET_MARKUP':
          setInnerHTML(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace children',
              payload: update.content.toString()
            });
          }
          break;
        case 'TEXT_CONTENT':
          setTextContent(parentNode, update.content);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'replace text',
              payload: update.content.toString()
            });
          }
          break;
        case 'REMOVE_NODE':
          removeChild(parentNode, update.fromNode);
          if (false) {
            ReactInstrumentation.debugTool.onHostOperation({
              instanceID: parentNodeDebugID,
              type: 'remove child',
              payload: { fromIndex: update.fromIndex }
            });
          }
          break;
      }
    }
  }
};

module.exports = DOMChildrenOperations;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMNamespaces = {
  html: 'http://www.w3.org/1999/xhtml',
  mathml: 'http://www.w3.org/1998/Math/MathML',
  svg: 'http://www.w3.org/2000/svg'
};

module.exports = DOMNamespaces;

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals MSApp */



/**
 * Create a function which has 'unsafe' privileges (required by windows8 apps)
 */

var createMicrosoftUnsafeLocalFunction = function (func) {
  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
    return function (arg0, arg1, arg2, arg3) {
      MSApp.execUnsafeLocalFunction(function () {
        return func(arg0, arg1, arg2, arg3);
      });
    };
  } else {
    return func;
  }
};

module.exports = createMicrosoftUnsafeLocalFunction;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var ReactPropTypesSecret = __webpack_require__(197);
var propTypesFactory = __webpack_require__(69);

var React = __webpack_require__(17);
var PropTypes = propTypesFactory(React.isValidElement);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

var hasReadOnlyValue = {
  button: true,
  checkbox: true,
  image: true,
  hidden: true,
  radio: true,
  reset: true,
  submit: true
};

function _assertSingleLink(inputProps) {
  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
}
function _assertValueLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
}

function _assertCheckedLink(inputProps) {
  _assertSingleLink(inputProps);
  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
}

var propTypes = {
  value: function (props, propName, componentName) {
    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  checked: function (props, propName, componentName) {
    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
      return null;
    }
    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
  },
  onChange: PropTypes.func
};

var loggedTypeFailures = {};
function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Provide a linked `value` attribute for controlled forms. You should not use
 * this outside of the ReactDOM controlled form components.
 */
var LinkedValueUtils = {
  checkPropTypes: function (tagName, props, owner) {
    for (var propName in propTypes) {
      if (propTypes.hasOwnProperty(propName)) {
        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
      }
      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
        // Only monitor this failure once because there tends to be a lot of the
        // same error.
        loggedTypeFailures[error.message] = true;

        var addendum = getDeclarationErrorAddendum(owner);
         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
      }
    }
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current value of the input either from value prop or link.
   */
  getValue: function (inputProps) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.value;
    }
    return inputProps.value;
  },

  /**
   * @param {object} inputProps Props for form component
   * @return {*} current checked status of the input either from checked prop
   *             or link.
   */
  getChecked: function (inputProps) {
    if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.value;
    }
    return inputProps.checked;
  },

  /**
   * @param {object} inputProps Props for form component
   * @param {SyntheticEvent} event change event to handle
   */
  executeOnChange: function (inputProps, event) {
    if (inputProps.valueLink) {
      _assertValueLink(inputProps);
      return inputProps.valueLink.requestChange(event.target.value);
    } else if (inputProps.checkedLink) {
      _assertCheckedLink(inputProps);
      return inputProps.checkedLink.requestChange(event.target.checked);
    } else if (inputProps.onChange) {
      return inputProps.onChange.call(undefined, event);
    }
  }
};

module.exports = LinkedValueUtils;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

var injected = false;

var ReactComponentEnvironment = {
  /**
   * Optionally injectable hook for swapping out mount images in the middle of
   * the tree.
   */
  replaceNodeWithMarkup: null,

  /**
   * Optionally injectable hook for processing a queue of child updates. Will
   * later move into MultiChildComponents.
   */
  processChildrenUpdates: null,

  injection: {
    injectEnvironment: function (environment) {
      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
      injected = true;
    }
  }
};

module.exports = ReactComponentEnvironment;

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given a `prevElement` and `nextElement`, determines if the existing
 * instance should be updated as opposed to being destroyed or replaced by a new
 * instance. Both arguments are elements. This ensures that this logic can
 * operate on stateless trees without any backing instance.
 *
 * @param {?object} prevElement
 * @param {?object} nextElement
 * @return {boolean} True if the existing instance should be updated.
 * @protected
 */

function shouldUpdateReactComponent(prevElement, nextElement) {
  var prevEmpty = prevElement === null || prevElement === false;
  var nextEmpty = nextElement === null || nextElement === false;
  if (prevEmpty || nextEmpty) {
    return prevEmpty === nextEmpty;
  }

  var prevType = typeof prevElement;
  var nextType = typeof nextElement;
  if (prevType === 'string' || prevType === 'number') {
    return nextType === 'string' || nextType === 'number';
  } else {
    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
  }
}

module.exports = shouldUpdateReactComponent;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var ReactCurrentOwner = __webpack_require__(13);
var ReactInstanceMap = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(9);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

function enqueueUpdate(internalInstance) {
  ReactUpdates.enqueueUpdate(internalInstance);
}

function formatUnexpectedArgument(arg) {
  var type = typeof arg;
  if (type !== 'object') {
    return type;
  }
  var displayName = arg.constructor && arg.constructor.name || type;
  var keys = Object.keys(arg);
  if (keys.length > 0 && keys.length < 20) {
    return displayName + ' (keys: ' + keys.join(', ') + ')';
  }
  return displayName;
}

function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
  var internalInstance = ReactInstanceMap.get(publicInstance);
  if (!internalInstance) {
    if (false) {
      var ctor = publicInstance.constructor;
      // Only warn when we have a callerName. Otherwise we should be silent.
      // We're probably calling from enqueueCallback. We don't want to warn
      // there because we already warned for the corresponding lifecycle method.
      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
    }
    return null;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
  }

  return internalInstance;
}

/**
 * ReactUpdateQueue allows for state updates to be scheduled into a later
 * reconciliation step.
 */
var ReactUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    if (false) {
      var owner = ReactCurrentOwner.current;
      if (owner !== null) {
        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
        owner._warnedAboutRefsInRender = true;
      }
    }
    var internalInstance = ReactInstanceMap.get(publicInstance);
    if (internalInstance) {
      // During componentWillMount and render this will still be null but after
      // that will always render to something. At least for now. So we can use
      // this hack.
      return !!internalInstance._renderedComponent;
    } else {
      return false;
    }
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @param {string} callerName Name of the calling function in the public API.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback, callerName) {
    ReactUpdateQueue.validateCallback(callback, callerName);
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);

    // Previously we would throw an error if we didn't have an internal
    // instance. Since we want to make it a no-op instead, we mirror the same
    // behavior we have in other enqueue* methods.
    // We also need to ignore callbacks in componentWillMount. See
    // enqueueUpdates.
    if (!internalInstance) {
      return null;
    }

    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    // TODO: The callback here is ignored when setState is called from
    // componentWillMount. Either fix it or disallow doing so completely in
    // favor of getInitialState. Alternatively, we can disallow
    // componentWillMount during server-side rendering.
    enqueueUpdate(internalInstance);
  },

  enqueueCallbackInternal: function (internalInstance, callback) {
    if (internalInstance._pendingCallbacks) {
      internalInstance._pendingCallbacks.push(callback);
    } else {
      internalInstance._pendingCallbacks = [callback];
    }
    enqueueUpdate(internalInstance);
  },

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingForceUpdate = true;

    enqueueUpdate(internalInstance);
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState, callback) {
    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');

    if (!internalInstance) {
      return;
    }

    internalInstance._pendingStateQueue = [completeState];
    internalInstance._pendingReplaceState = true;

    // Future-proof 15.5
    if (callback !== undefined && callback !== null) {
      ReactUpdateQueue.validateCallback(callback, 'replaceState');
      if (internalInstance._pendingCallbacks) {
        internalInstance._pendingCallbacks.push(callback);
      } else {
        internalInstance._pendingCallbacks = [callback];
      }
    }

    enqueueUpdate(internalInstance);
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    if (false) {
      ReactInstrumentation.debugTool.onSetState();
      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
    }

    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');

    if (!internalInstance) {
      return;
    }

    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
    queue.push(partialState);

    enqueueUpdate(internalInstance);
  },

  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
    internalInstance._pendingElement = nextElement;
    // TODO: introduce _pendingContext instead of setting it directly.
    internalInstance._context = nextContext;
    enqueueUpdate(internalInstance);
  },

  validateCallback: function (callback, callerName) {
    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
  }
};

module.exports = ReactUpdateQueue;

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var emptyFunction = __webpack_require__(10);
var warning = __webpack_require__(2);

var validateDOMNesting = emptyFunction;

if (false) {
  // This validation code was written based on the HTML5 parsing spec:
  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  //
  // Note: this does not catch all invalid nesting, nor does it try to (as it's
  // not clear what practical benefit doing so provides); instead, we warn only
  // for cases where the parser will give a parse tree differing from what React
  // intended. For example, <b><div></div></b> is invalid but we don't warn
  // because it still parses correctly; we do warn for other cases like nested
  // <p> tags where the beginning of the second element implicitly closes the
  // first, causing a confusing mess.

  // https://html.spec.whatwg.org/multipage/syntax.html#special
  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',

  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
  // TODO: Distinguish by namespace here -- for <title>, including it here
  // errs on the side of fewer warnings
  'foreignObject', 'desc', 'title'];

  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
  var buttonScopeTags = inScopeTags.concat(['button']);

  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];

  var emptyAncestorInfo = {
    current: null,

    formTag: null,
    aTagInScope: null,
    buttonTagInScope: null,
    nobrTagInScope: null,
    pTagInButtonScope: null,

    listItemTagAutoclosing: null,
    dlItemTagAutoclosing: null
  };

  var updatedAncestorInfo = function (oldInfo, tag, instance) {
    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
    var info = { tag: tag, instance: instance };

    if (inScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.aTagInScope = null;
      ancestorInfo.buttonTagInScope = null;
      ancestorInfo.nobrTagInScope = null;
    }
    if (buttonScopeTags.indexOf(tag) !== -1) {
      ancestorInfo.pTagInButtonScope = null;
    }

    // See rules for 'li', 'dd', 'dt' start tags in
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
      ancestorInfo.listItemTagAutoclosing = null;
      ancestorInfo.dlItemTagAutoclosing = null;
    }

    ancestorInfo.current = info;

    if (tag === 'form') {
      ancestorInfo.formTag = info;
    }
    if (tag === 'a') {
      ancestorInfo.aTagInScope = info;
    }
    if (tag === 'button') {
      ancestorInfo.buttonTagInScope = info;
    }
    if (tag === 'nobr') {
      ancestorInfo.nobrTagInScope = info;
    }
    if (tag === 'p') {
      ancestorInfo.pTagInButtonScope = info;
    }
    if (tag === 'li') {
      ancestorInfo.listItemTagAutoclosing = info;
    }
    if (tag === 'dd' || tag === 'dt') {
      ancestorInfo.dlItemTagAutoclosing = info;
    }

    return ancestorInfo;
  };

  /**
   * Returns whether
   */
  var isTagValidWithParent = function (tag, parentTag) {
    // First, let's check if we're in an unusual parsing mode...
    switch (parentTag) {
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
      case 'select':
        return tag === 'option' || tag === 'optgroup' || tag === '#text';
      case 'optgroup':
        return tag === 'option' || tag === '#text';
      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
      // but
      case 'option':
        return tag === '#text';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
      // No special behavior since these rules fall back to "in body" mode for
      // all except special table nodes which cause bad parsing behavior anyway.

      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
      case 'tr':
        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
      case 'tbody':
      case 'thead':
      case 'tfoot':
        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
      case 'colgroup':
        return tag === 'col' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
      case 'table':
        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
      case 'head':
        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
      case 'html':
        return tag === 'head' || tag === 'body';
      case '#document':
        return tag === 'html';
    }

    // Probably in the "in body" parsing mode, so we outlaw only tag combos
    // where the parsing rules cause implicit opens or closes to be added.
    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
    switch (tag) {
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';

      case 'rp':
      case 'rt':
        return impliedEndTags.indexOf(parentTag) === -1;

      case 'body':
      case 'caption':
      case 'col':
      case 'colgroup':
      case 'frame':
      case 'head':
      case 'html':
      case 'tbody':
      case 'td':
      case 'tfoot':
      case 'th':
      case 'thead':
      case 'tr':
        // These tags are only valid with a few parents that have special child
        // parsing rules -- if we're down here, then none of those matched and
        // so we allow it only if we don't know what the parent is, as all other
        // cases are invalid.
        return parentTag == null;
    }

    return true;
  };

  /**
   * Returns whether
   */
  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
    switch (tag) {
      case 'address':
      case 'article':
      case 'aside':
      case 'blockquote':
      case 'center':
      case 'details':
      case 'dialog':
      case 'dir':
      case 'div':
      case 'dl':
      case 'fieldset':
      case 'figcaption':
      case 'figure':
      case 'footer':
      case 'header':
      case 'hgroup':
      case 'main':
      case 'menu':
      case 'nav':
      case 'ol':
      case 'p':
      case 'section':
      case 'summary':
      case 'ul':
      case 'pre':
      case 'listing':
      case 'table':
      case 'hr':
      case 'xmp':
      case 'h1':
      case 'h2':
      case 'h3':
      case 'h4':
      case 'h5':
      case 'h6':
        return ancestorInfo.pTagInButtonScope;

      case 'form':
        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;

      case 'li':
        return ancestorInfo.listItemTagAutoclosing;

      case 'dd':
      case 'dt':
        return ancestorInfo.dlItemTagAutoclosing;

      case 'button':
        return ancestorInfo.buttonTagInScope;

      case 'a':
        // Spec says something about storing a list of markers, but it sounds
        // equivalent to this check.
        return ancestorInfo.aTagInScope;

      case 'nobr':
        return ancestorInfo.nobrTagInScope;
    }

    return null;
  };

  /**
   * Given a ReactCompositeComponent instance, return a list of its recursive
   * owners, starting at the root and ending with the instance itself.
   */
  var findOwnerStack = function (instance) {
    if (!instance) {
      return [];
    }

    var stack = [];
    do {
      stack.push(instance);
    } while (instance = instance._currentElement._owner);
    stack.reverse();
    return stack;
  };

  var didWarn = {};

  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;

    if (childText != null) {
      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
      childTag = '#text';
    }

    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
    var problematic = invalidParent || invalidAncestor;

    if (problematic) {
      var ancestorTag = problematic.tag;
      var ancestorInstance = problematic.instance;

      var childOwner = childInstance && childInstance._currentElement._owner;
      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;

      var childOwners = findOwnerStack(childOwner);
      var ancestorOwners = findOwnerStack(ancestorOwner);

      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
      var i;

      var deepestCommon = -1;
      for (i = 0; i < minStackLen; i++) {
        if (childOwners[i] === ancestorOwners[i]) {
          deepestCommon = i;
        } else {
          break;
        }
      }

      var UNKNOWN = '(unknown)';
      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
        return inst.getName() || UNKNOWN;
      });
      var ownerInfo = [].concat(
      // If the parent and child instances have a common owner ancestor, start
      // with that -- otherwise we just start with the parent's owners.
      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
      // If we're warning about an invalid (non-parent) ancestry, add '...'
      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');

      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
      if (didWarn[warnKey]) {
        return;
      }
      didWarn[warnKey] = true;

      var tagDisplayName = childTag;
      var whitespaceInfo = '';
      if (childTag === '#text') {
        if (/\S/.test(childText)) {
          tagDisplayName = 'Text nodes';
        } else {
          tagDisplayName = 'Whitespace text nodes';
          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
        }
      } else {
        tagDisplayName = '<' + childTag + '>';
      }

      if (invalidParent) {
        var info = '';
        if (ancestorTag === 'table' && childTag === 'tr') {
          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
        }
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
      } else {
        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
      }
    }
  };

  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;

  // For testing
  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
    ancestorInfo = ancestorInfo || emptyAncestorInfo;
    var parentInfo = ancestorInfo.current;
    var parentTag = parentInfo && parentInfo.tag;
    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
  };
}

module.exports = validateDOMNesting;

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * `charCode` represents the actual "character code" and is safe to use with
 * `String.fromCharCode`. As such, only keys that correspond to printable
 * characters produce a valid `charCode`, the only exception to this is Enter.
 * The Tab-key is considered non-printable and does not have a `charCode`,
 * presumably because it does not produce a tab-character in browsers.
 *
 * @param {object} nativeEvent Native browser event.
 * @return {number} Normalized `charCode` property.
 */

function getEventCharCode(nativeEvent) {
  var charCode;
  var keyCode = nativeEvent.keyCode;

  if ('charCode' in nativeEvent) {
    charCode = nativeEvent.charCode;

    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
    if (charCode === 0 && keyCode === 13) {
      charCode = 13;
    }
  } else {
    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
    charCode = keyCode;
  }

  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
  // Must not discard the (non-)printable Enter-key.
  if (charCode >= 32 || charCode === 13) {
    return charCode;
  }

  return 0;
}

module.exports = getEventCharCode;

/***/ }),
/* 54 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),EventEmitter=__webpack_require__(27).EventEmitter,View=module.exports=function(){this.initView()};utils.inherits(View,EventEmitter),View.prototype.initView=function(){this.setMaxListeners(0)};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),ElementView=__webpack_require__(57),PartView=__webpack_require__(15),PartCache=__webpack_require__(12),CompositionElementView=module.exports=function(model,numberOfParts){this.init(model),this.initCompositionElementView(numberOfParts),this.initView(),this.cache=new PartCache};utils.inherits(CompositionElementView,ElementView),CompositionElementView.prototype.initCompositionElementView=function(numberOfParts){this.partViews=[],this.numberOfParts=numberOfParts},CompositionElementView.prototype.loadModel3D=function(){function addPartViews(viewsToLoad,key,index){if(viewsToLoad.length>key){var partType=viewsToLoad[key].key,model=that.model[partType];Array.isArray(model)?viewsToLoad[key].count>index?(model=model[index],addPartView(model,partType,key,!0,index)):(key++,addPartViews(viewsToLoad,key,0)):addPartView(model,partType,key,!1,index)}}function addPartView(model,partType,key,increaseIndex,index){var partView=PartView.factory(partType,model,parentHeight,parentLength,parentDepth);that.addPartView(partView),partView.once('3DModelLoaded',function(){partView.getModel3D()instanceof THREE.Object3D&&geometry.add(partView.getModel3D()),that.setModel3D(geometry),numberOfPartsLoaded++,that.cache.setCache(model.file,partView.getOriginal3DModel()),numberOfPartsLoaded===that.getNumberOfParts()&&that.emit('3DCompositionModelLoaded'),increaseIndex?(index++,addPartViews(viewsToLoad,key,index)):(key++,addPartViews(viewsToLoad,key,0))}),partView.loadModel3D(that.cache.getCache(model.file))}var that=this,geometry=new THREE.Object3D,keys=Object.keys(that.model),numberOfPartsLoaded=0,modelsPosition=that.model.position,parentHeight=that.model._height,parentLength=that.model._length,parentDepth=that.model._depth,modelsRotation=that.model.rotation;geometry.position.set(modelsPosition[0],modelsPosition[1],modelsPosition[2]),geometry.rotation.set(modelsRotation[0],modelsRotation[1],modelsRotation[2]);var viewsToLoad=[];return keys.forEach(function(part){var data={};null!==that.model[part]&&'PART'===that.model[part].partType?(data.key=part,viewsToLoad.push(data)):Array.isArray(that.model[part])&&0<that.model[part].length&&'PART'===that.model[part][0].partType&&(data.key=part,data.count=that.model[part].length,viewsToLoad.push(data))}),addPartViews(viewsToLoad,0,0),this},CompositionElementView.prototype.addPartView=function(partView){return partView.setScalePanelOffset(this.scalePanelOffset),this.partViews.push(partView),this},CompositionElementView.prototype.getNumberOfParts=function(){return this.numberOfParts},CompositionElementView.prototype.updateHeight=function(newHeight){var that=this;that.model.isDoubleDoorRackCap?(that.getModel()._depth=newHeight,that.partViews.forEach(function(view){view.updateDepth(newHeight)})):(that.getModel()._height=newHeight,that.partViews.forEach(function(view){view.updateHeight(newHeight)}))},CompositionElementView.prototype.scaleHeight=function(globalScale,change,keepCapBodyRatio,onCap,keepBodyHeight){var that=this;that.model.isDoubleDoorRackCap?that.partViews.forEach(function(view){view.scaleDepth(globalScale,change)}):(onCap&&!keepBodyHeight&&(that.model3D.position.y+=.5*change),that.partViews.forEach(function(view){view.scaleHeight(globalScale,change,keepCapBodyRatio,onCap,keepBodyHeight)}))},CompositionElementView.prototype.updateLength=function(newLength){var that=this;that.getModel()._length=newLength,that.partViews.forEach(function(view){view.updateLength(newLength)})},CompositionElementView.prototype.scaleLength=function(globalScale,change){var that=this;if(that.model.isDoubleDoorRackCap){var xPosition=that.getModel3D().position.x;0>xPosition?that.getModel3D().position.x-=.5*change:0<xPosition&&(that.getModel3D().position.x+=.5*change)}else that.partViews.forEach(function(view){view.scaleLength(globalScale,change)})},CompositionElementView.prototype.updateDepth=function(newDepth){var that=this;that.getModel()._depth=newDepth,that.partViews.forEach(function(view){view.updateDepth(newDepth)})},CompositionElementView.prototype.scaleDepth=function(globalScale,change){var that=this;if(that.model.isDoubleDoorRackCap){var zPosition=that.getModel3D().position.z;0>zPosition?that.getModel3D().position.z-=.5*change:0<zPosition&&(that.getModel3D().position.z+=.5*change)}else that.partViews.forEach(function(view){view.scaleDepth(globalScale,change)})},CompositionElementView.prototype.getPartViews=function(){return this.partViews},CompositionElementView.prototype.replacePartView=function(index,newPartView){var that=this,partView=that.partViews[index];that.model3D.remove(partView.getModel3D()),delete that.partViews[index],that.partViews[index]=newPartView,that.model3D.add(newPartView.getModel3D())};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),View=__webpack_require__(55),PartCache=__webpack_require__(12),ElementView=module.exports=function(model){this.init(model),this.initView(),this.cache=new PartCache};utils.inherits(ElementView,View),ElementView.prototype.init=function(model){this.model3D=[],this.model=model,this.scalePanelOffset=30},ElementView.prototype.setScalePanelOffset=function(offset){return this.scalePanelOffset=offset,this},ElementView.prototype.getModel3D=function(){return this.model3D},ElementView.prototype.setModel3D=function(model3D){return this.model3D=model3D,this},ElementView.prototype.getModel=function(){return this.model},ElementView.prototype.setModel=function(model){return this.model=model,this},ElementView.prototype.loadModel3D=function(){throw'method needs to be overwritten'};

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),PartView=__webpack_require__(15),PartCache=__webpack_require__(12),LengthPartView=module.exports=function(model,parentHeight,parentLength,parentDepth){this.initLengthView(model,parentHeight,parentLength,parentDepth),this.cache=new PartCache};utils.inherits(LengthPartView,PartView),LengthPartView.prototype.initLengthView=function(model,parentHeight,parentLength,parentDepth){this.initPartView(model,parentHeight,parentLength,parentDepth)},LengthPartView.prototype.scaleHeightParameter=function(size){var scale=this.parentHeight/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentHeight-this.scalePanelOffset)/size),scale},LengthPartView.prototype.scaleLengthParameter=function(size){var scale=this.parentLength/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentLength-this.scalePanelOffset)/size),scale},LengthPartView.prototype.scaleDepthParameter=function(size){var scale=this.parentLength/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentLength-this.scalePanelOffset)/size),scale};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),PartView=__webpack_require__(15),PartCache=__webpack_require__(12),HeightPartView=module.exports=function(model,parentHeight,parentLength,parentDepth){this.initHeightView(model,parentHeight,parentLength,parentDepth),this.cache=new PartCache};utils.inherits(HeightPartView,PartView),HeightPartView.prototype.initHeightView=function(model,parentHeight,parentLength,parentDepth){this.initPartView(model,parentHeight,parentLength,parentDepth)},HeightPartView.prototype.scaleHeightParameter=function(size){var scale=this.parentHeight/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentHeight-this.scalePanelOffset)/size),scale},HeightPartView.prototype.scaleLengthParameter=function(){return 1},HeightPartView.prototype.scaleDepthParameter=function(size){var scale=this.parentHeight/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentHeight-this.scalePanelOffset)/size),scale};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),PartView=__webpack_require__(15),PartCache=__webpack_require__(12),DepthPartView=module.exports=function(model,parentHeight,parentLength,parentDepth){this.initDepthView(model,parentHeight,parentLength,parentDepth),this.cache=new PartCache};utils.inherits(DepthPartView,PartView),DepthPartView.prototype.initDepthView=function(model,parentHeight,parentLength,parentDepth){this.initPartView(model,parentHeight,parentLength,parentDepth)},DepthPartView.prototype.scaleHeightParameter=function(size){var scale=this.parentHeight/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentHeight-this.scalePanelOffset)/size),scale},DepthPartView.prototype.scaleLengthParameter=function(size){var scale=this.parentLength/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentLength-this.scalePanelOffset)/size),scale},DepthPartView.prototype.scaleDepthParameter=function(size){var scale=this.parentDepth/size;return('PANEL'===this.model.category||'EDGE_PROTECTION'===this.model.category)&&(scale=(this.parentDepth-this.scalePanelOffset)/size),scale};

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),PartView=__webpack_require__(15),PartCache=__webpack_require__(12),UpperPartView=module.exports=function(model,parentHeight,parentLength,parentDepth){this.cache=new PartCache,this.initUpperView(model,parentHeight,parentLength,parentDepth)};utils.inherits(UpperPartView,PartView),UpperPartView.prototype.initUpperView=function(model,parentHeight,parentLength,parentDepth){this.initPartView(model,parentHeight,parentLength,parentDepth)},UpperPartView.prototype.scaleHeightParameter=function(size){var scale=this.parentLength/size;return'PANEL'===this.model.category&&(scale=(this.parentLength-this.scalePanelOffset)/size),scale},UpperPartView.prototype.scaleLengthParameter=function(size){var scale=this.parentLength/size;return'PANEL'===this.model.category&&(scale=(this.parentLength-this.scalePanelOffset)/size),scale},UpperPartView.prototype.scaleDepthParameter=function(size){var scale=this.parentDepth/size;return'PANEL'===this.model.category&&(scale=(this.parentDepth-this.scalePanelOffset)/size),scale};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),BuilderApi=module.exports={createUpdatePartObject:function createUpdatePartObject(newPartId,category,configuredCaseId){return''===newPartId&&(newPartId=null),{CaseId:configuredCaseId,PartData:[{NewPartId:newPartId,ItemType:'SELECTION_PART_'+this.parseCategory(category)}],OptionData:[]}},createUpdateOptionObject:function createUpdateOptionObject(configuredCaseId,option,value){return{CaseId:configuredCaseId,OptionData:[{ItemType:'SELECTION_OPTION_'+option,Value:value}],PartData:[]}},createUpdateDimesionObject:function createUpdateDimesionObject(value,dimension,configuredCaseId,useHeightUnits){var object={CaseId:parseInt(configuredCaseId),PartData:[],OptionData:[]};return'length'===dimension||'width'===dimension?object.WidthMillimeters=value:'depth'===dimension?object.LengthMillimeters=value:'height'===dimension?useHeightUnits?(value/=45,object.HeightHeightUnits=value):object.HeightMillimeters=value:'height_unit'==dimension&&(object.HeightHeightUnits=value),object},createUpdateKeyboardObject:function createUpdateKeyboardObject(keyboardId,keyboard,configuredCaseId){keyboardId=keyboardId||-1,keyboard=keyboard||'None',-1!==keyboardId&&(keyboard=null);var object={CaseId:parseInt(configuredCaseId),PartData:[],OptionData:[],KeyboardId:keyboardId,KeyboardBrandAndModel:keyboard};return object},createUpdateKeysObject:function createUpdateKeysObject(amountOfKeys,configuredCaseId){return{CaseId:configuredCaseId,PartData:[],OptionData:[],SizeKeyCount:amountOfKeys}},isCaseIdSet:function isCaseIdSet(object){return'CaseId'in object&&object.CaseId},parseCategory:function parseCategory(category){if('STAND'===category)return'WHEEL';return'ROLL_BOARD'===category?'WHEEL':'TROLLEY'===category?'WHEEL':'ACCESSORY_PULLOUT_HANDLE'===category?'WHEEL':category}};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),RangeSliderv3=dynamicRequire('RangeSliderv3.jsx').default,resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),DimensionChooser=function(_React$Component){function DimensionChooser(props){_classCallCheck(this,DimensionChooser);var _this=_possibleConstructorReturn(this,(DimensionChooser.__proto__||Object.getPrototypeOf(DimensionChooser)).call(this,props));return _this.onChange=_this.onChange.bind(_this),_this.onBlur=_this.onBlur.bind(_this),_this.onClick=_this.onClick.bind(_this),_this.onKeydown=_this.onKeydown.bind(_this),_this.isUserEditing=!1,_this.input=null,_this.state={value:props.start,visibleValue:_this.format(props.start)},_this.dirty=!1,_this}return _inherits(DimensionChooser,_React$Component),_createClass(DimensionChooser,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newState={value:nextProps.start};this.dirty||(newState.visibleValue=this.format(nextProps.start,nextProps.isCmMode),newState.error=!1),this.setState(newState)}},{key:'render',value:function render(){var _Mathround=Math.round,_this2=this;return React.createElement('div',{className:'lr-casefactory-choices-sliders-dimensions-slider slider '+(this.state.error?'lr-casefactory-choices-sliders-dimensions-slider-error error':'')},React.createElement('label',null,React.createElement(Mssg,{__key:this.props.label})),React.createElement('div',{className:'lr-casefactory-choices-sliders-dimensions-dimension-input dimension-input'},React.createElement('input',{type:'text',name:'width',ref:function ref(_ref){return _this2.input=_ref},className:'lr-casefactory-choices-input input '+(this.props.isCmMode?' cm':' mm'),value:this.state.visibleValue,onChange:this.onChange,onKeyDown:this.onKeydown,onClick:this.onClick,onBlur:this.onBlur}),React.createElement('span',{className:'lr-casefactory-choices-sliders-dimensions-dimension-unit dimension-unit'},' ',this.getCmOrMm())),React.createElement('div',{className:'lr-casefactory-choices-sliders-dimensions-validation validation'},React.createElement(Mssg,{__key:'nc_casefactory.dimensions.validation2',__parameters:{min:this.forceFormat(this.props.range.min),max:this.forceFormat(this.props.range.max),unit:this.getCmOrMm()}})),React.createElement('div',{className:'lr-casefactory-choices-sliders-dimensions-slider-line slider-line'},React.createElement(RangeSliderv3,{range:[this.props.range.min,this.props.range.max],onRelease:function onRelease(values){_this2.dirty=!1,_this2.context.emitter.emit('dimensionChange',_this2.props.dimension,_Mathround(values[0]))},points:this.getSnapPoints(),onChange:function onChange(value){_this2.dirty=!1,_this2.context.emitter.emit('dimensionDrag',_this2.props.dimension,_Mathround(value))},value:this.props.start})))}},{key:'getMmValue',value:function getMmValue(value){return this.props.isCmMode?10*value:value}},{key:'getCmOrMm',value:function getCmOrMm(){return this.props.isCmMode?resolveLanguage('nc_casefactory.centimeter'):'mm'}},{key:'format',value:function format(number,isCmMode){return this.isUserEditing?number:this.forceFormat(number,isCmMode)}},{key:'forceFormat',value:function forceFormat(number){var isCmMode=1<arguments.length&&void 0!==arguments[1]?arguments[1]:this.props.isCmMode;if(isNaN(number))return number;var parsedNumber;return parsedNumber=isCmMode?number/10:number,this.clampToRange(number)==number?parsedNumber.toLocaleString():number}},{key:'getSnapPoints',value:function getSnapPoints(){var i,snapPoints=[];if(!this.props.isCmMode){for(i=this.props.range.min;i<=this.props.range.max;i++)snapPoints.push(i);return snapPoints}for(i=this.props.range.min;i<=this.props.range.max;i+=10)snapPoints.push(i);return snapPoints}},{key:'onClick',value:function onClick(){this.input.select()}},{key:'onChange',value:function onChange(e){this.dirty=!0,this.isUserEditing=!0,this.setState({visibleValue:e.target.value})}},{key:'onBlur',value:function onBlur(e){this.isUserEditing=!1;var value=this.getValue(e.target.value);isNaN(value)||value!=this.clampToRange(value)?this.setState({error:!0,visibleValue:e.target.value}):(this.context.emitter.emit('dimensionChange',this.props.dimension,value),this.dirty=!1,this.setState({error:!1,value:value,visibleValue:this.format(value)}))}},{key:'getValue',value:function getValue(value){if(this.isUserEditing)return value;var parsedValue=this.getMmValue(parseFloat(value));return isNaN(parsedValue)?value:parsedValue}},{key:'onKeydown',value:function onKeydown(e){13==e.which&&this.onBlur(e)}},{key:'clampToRange',value:function clampToRange(number){return Math.max(this.props.range.min,Math.min(this.props.range.max,number))}}]),DimensionChooser}(React.Component);DimensionChooser.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=DimensionChooser;

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function resolveParameter(textValue,parameters){var returnText=textValue;if(parameters!=void 0){for(var currentKey in parameters)returnText=returnText.replace('{'+currentKey+'}',parameters[currentKey])}return returnText}module.exports=resolveParameter;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(22),
    _assign = __webpack_require__(3);

var ReactNoopUpdateQueue = __webpack_require__(66);

var canDefineProperty = __webpack_require__(67);
var emptyObject = __webpack_require__(35);
var invariant = __webpack_require__(0);
var lowPriorityWarning = __webpack_require__(135);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(2);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(143);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}var React=__webpack_require__(8),resolveParameter=__webpack_require__(64);function Mssg(props){var __direct=props.__direct,__className=props.__className,__tagName=props.__tagName,__key=props.__key,__parameters=props.__parameters,remainingProps=_objectWithoutProperties(props,['__direct','__className','__tagName','__key','__parameters']),formattedText=resolveParameter(mc_i18n[__key.replace('nc_casefactory.','')],__parameters);return remainingProps.className=__className||'',remainingProps.dangerouslySetInnerHTML={__html:__direct||formattedText},React.createElement(__tagName||'span',remainingProps)}Mssg.contextTypes={},exports.default=Mssg;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var initialTime=+new Date,requestAnimationFrame=window.requestAnimationFrame.bind(window)||function(fun){return setTimeout(function(){fun.call(this,+new Date-initialTime)},13)},cancelAnimationFrame=window.cancelAnimationFrame.bind(window)||clearInterval;module.exports={cancelAnimationFrame:cancelAnimationFrame,requestAnimationFrame:requestAnimationFrame};

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}var compose=function(){for(var _len=arguments.length,classes=Array(_len),_key=0;_key<_len;_key++)classes[_key]=arguments[_key];var composed=[];return classes.constructor!==Array&&(classes=Array(classes)),classes.filter(function(cls){return null!=cls}).forEach(function(cls){switch(cls.constructor){case String:case Number:composed.push(cls);break;case Array:composed.push(compose.apply(void 0,_toConsumableArray(cls)));break;case Object:Object.keys(cls).forEach(function(item){cls[item]&&composed.push(item)});}}),composed.join(' ').trim()};module.exports=compose;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentFlags = {
  hasCachedChildNodes: 1 << 0
};

module.exports = ReactDOMComponentFlags;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

/**
 * Accumulates items that must not be null or undefined into the first one. This
 * is used to conserve memory by avoiding array allocations, and thus sacrifices
 * API cleanness. Since `current` can be null before being passed in and not
 * null after this function, make sure to assign it back to `current`:
 *
 * `a = accumulateInto(a, b);`
 *
 * This API should be sparingly used. Try `accumulate` for something cleaner.
 *
 * @return {*|array<*>} An accumulation of items.
 */

function accumulateInto(current, next) {
  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;

  if (current == null) {
    return next;
  }

  // Both are not empty. Warning: Never call x.concat(y) when you are not
  // certain that x is an Array (x could be a string with concat method).
  if (Array.isArray(current)) {
    if (Array.isArray(next)) {
      current.push.apply(current, next);
      return current;
    }
    current.push(next);
    return current;
  }

  if (Array.isArray(next)) {
    // A bit too dangerous to mutate `next`.
    return [current].concat(next);
  }

  return [current, next];
}

module.exports = accumulateInto;

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @param {array} arr an "accumulation" of items which is either an Array or
 * a single item. Useful when paired with the `accumulate` module. This is a
 * simple utility that allows us to reason about a collection of items, but
 * handling the case when there is exactly one item (and we do not need to
 * allocate an array).
 */

function forEachAccumulated(arr, cb, scope) {
  if (Array.isArray(arr)) {
    arr.forEach(cb, scope);
  } else if (arr) {
    cb.call(scope, arr);
  }
}

module.exports = forEachAccumulated;

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

var contentKey = null;

/**
 * Gets the key used to access text content on a DOM node.
 *
 * @return {?string} Key used to access text content.
 * @internal
 */
function getTextContentAccessor() {
  if (!contentKey && ExecutionEnvironment.canUseDOM) {
    // Prefer textContent to innerText because many browsers support both but
    // SVG <text> elements don't support innerText even when <div> does.
    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
  }
  return contentKey;
}

module.exports = getTextContentAccessor;

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PooledClass = __webpack_require__(16);

var invariant = __webpack_require__(0);

/**
 * A specialized pseudo-event module to help keep track of components waiting to
 * be notified when their DOM representations are available for use.
 *
 * This implements `PooledClass`, so you should never need to instantiate this.
 * Instead, use `CallbackQueue.getPooled()`.
 *
 * @class ReactMountReady
 * @implements PooledClass
 * @internal
 */

var CallbackQueue = function () {
  function CallbackQueue(arg) {
    _classCallCheck(this, CallbackQueue);

    this._callbacks = null;
    this._contexts = null;
    this._arg = arg;
  }

  /**
   * Enqueues a callback to be invoked when `notifyAll` is invoked.
   *
   * @param {function} callback Invoked when `notifyAll` is invoked.
   * @param {?object} context Context to call `callback` with.
   * @internal
   */


  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
    this._callbacks = this._callbacks || [];
    this._callbacks.push(callback);
    this._contexts = this._contexts || [];
    this._contexts.push(context);
  };

  /**
   * Invokes all enqueued callbacks and clears the queue. This is invoked after
   * the DOM representation of a component has been created or updated.
   *
   * @internal
   */


  CallbackQueue.prototype.notifyAll = function notifyAll() {
    var callbacks = this._callbacks;
    var contexts = this._contexts;
    var arg = this._arg;
    if (callbacks && contexts) {
      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
      this._callbacks = null;
      this._contexts = null;
      for (var i = 0; i < callbacks.length; i++) {
        callbacks[i].call(contexts[i], arg);
      }
      callbacks.length = 0;
      contexts.length = 0;
    }
  };

  CallbackQueue.prototype.checkpoint = function checkpoint() {
    return this._callbacks ? this._callbacks.length : 0;
  };

  CallbackQueue.prototype.rollback = function rollback(len) {
    if (this._callbacks && this._contexts) {
      this._callbacks.length = len;
      this._contexts.length = len;
    }
  };

  /**
   * Resets the internal queue.
   *
   * @internal
   */


  CallbackQueue.prototype.reset = function reset() {
    this._callbacks = null;
    this._contexts = null;
  };

  /**
   * `PooledClass` looks for this.
   */


  CallbackQueue.prototype.destructor = function destructor() {
    this.reset();
  };

  return CallbackQueue;
}();

module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactFeatureFlags = {
  // When true, call console.time() before and .timeEnd() after each top-level
  // render (both initial renders and updates). Useful when looking at prod-mode
  // timeline profiles in Chrome, for example.
  logTopLevelRenders: false
};

module.exports = ReactFeatureFlags;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

function isCheckable(elem) {
  var type = elem.type;
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
}

function getTracker(inst) {
  return inst._wrapperState.valueTracker;
}

function attachTracker(inst, tracker) {
  inst._wrapperState.valueTracker = tracker;
}

function detachTracker(inst) {
  inst._wrapperState.valueTracker = null;
}

function getValueFromNode(node) {
  var value;
  if (node) {
    value = isCheckable(node) ? '' + node.checked : node.value;
  }
  return value;
}

var inputValueTracking = {
  // exposed for testing
  _getTrackerFromNode: function (node) {
    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
  },


  track: function (inst) {
    if (getTracker(inst)) {
      return;
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var valueField = isCheckable(node) ? 'checked' : 'value';
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);

    var currentValue = '' + node[valueField];

    // if someone has already defined a value or Safari, then bail
    // and don't track value will cause over reporting of changes,
    // but it's better then a hard failure
    // (needed for certain tests that spyOn input values and Safari)
    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
      return;
    }

    Object.defineProperty(node, valueField, {
      enumerable: descriptor.enumerable,
      configurable: true,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (value) {
        currentValue = '' + value;
        descriptor.set.call(this, value);
      }
    });

    attachTracker(inst, {
      getValue: function () {
        return currentValue;
      },
      setValue: function (value) {
        currentValue = '' + value;
      },
      stopTracking: function () {
        detachTracker(inst);
        delete node[valueField];
      }
    });
  },

  updateValueIfChanged: function (inst) {
    if (!inst) {
      return false;
    }
    var tracker = getTracker(inst);

    if (!tracker) {
      inputValueTracking.track(inst);
      return true;
    }

    var lastValue = tracker.getValue();
    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));

    if (nextValue !== lastValue) {
      tracker.setValue(nextValue);
      return true;
    }

    return false;
  },
  stopTracking: function (inst) {
    var tracker = getTracker(inst);
    if (tracker) {
      tracker.stopTracking();
    }
  }
};

module.exports = inputValueTracking;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
 */

var supportedInputTypes = {
  color: true,
  date: true,
  datetime: true,
  'datetime-local': true,
  email: true,
  month: true,
  number: true,
  password: true,
  range: true,
  search: true,
  tel: true,
  text: true,
  time: true,
  url: true,
  week: true
};

function isTextInputElement(elem) {
  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();

  if (nodeName === 'input') {
    return !!supportedInputTypes[elem.type];
  }

  if (nodeName === 'textarea') {
    return true;
  }

  return false;
}

module.exports = isTextInputElement;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ViewportMetrics = {
  currentScrollLeft: 0,

  currentScrollTop: 0,

  refreshScrollValues: function (scrollPosition) {
    ViewportMetrics.currentScrollLeft = scrollPosition.x;
    ViewportMetrics.currentScrollTop = scrollPosition.y;
  }
};

module.exports = ViewportMetrics;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);
var escapeTextContentForBrowser = __webpack_require__(31);
var setInnerHTML = __webpack_require__(30);

/**
 * Set the textContent property of a node, ensuring that whitespace is preserved
 * even in IE8. innerText is a poor substitute for textContent and, among many
 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
 * as it should.
 *
 * @param {DOMElement} node
 * @param {string} text
 * @internal
 */
var setTextContent = function (node, text) {
  if (text) {
    var firstChild = node.firstChild;

    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
      firstChild.nodeValue = text;
      return;
    }
  }
  node.textContent = text;
};

if (ExecutionEnvironment.canUseDOM) {
  if (!('textContent' in document.documentElement)) {
    setTextContent = function (node, text) {
      if (node.nodeType === 3) {
        node.nodeValue = text;
        return;
      }
      setInnerHTML(node, escapeTextContentForBrowser(text));
    };
  }
}

module.exports = setTextContent;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * @param {DOMElement} node input/textarea to focus
 */

function focusNode(node) {
  // IE8 can throw "Can't move focus to the control because it is invisible,
  // not enabled, or of a type that does not accept the focus." for all kinds of
  // reasons that are too expensive and fragile to test.
  try {
    node.focus();
  } catch (e) {}
}

module.exports = focusNode;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * CSS properties which accept numbers but are not in units of "px".
 */

var isUnitlessNumber = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  columns: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridRowEnd: true,
  gridRowSpan: true,
  gridRowStart: true,
  gridColumn: true,
  gridColumnEnd: true,
  gridColumnSpan: true,
  gridColumnStart: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true
};

/**
 * @param {string} prefix vendor-specific prefix, eg: Webkit
 * @param {string} key style name, eg: transitionDuration
 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
 * WebkitTransitionDuration
 */
function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
}

/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */
var prefixes = ['Webkit', 'ms', 'Moz', 'O'];

// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
// infinite loop, because it iterates over the newly added props too.
Object.keys(isUnitlessNumber).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
  });
});

/**
 * Most style properties can be unset by doing .style[prop] = '' but IE8
 * doesn't like doing that with shorthand properties so for the properties that
 * IE8 breaks on, which are listed here, we instead unset each of the
 * individual properties. See http://bugs.jquery.com/ticket/12385.
 * The 4-value 'clock' properties like margin, padding, border-width seem to
 * behave without any problems. Curiously, list-style works too without any
 * special prodding.
 */
var shorthandPropertyExpansions = {
  background: {
    backgroundAttachment: true,
    backgroundColor: true,
    backgroundImage: true,
    backgroundPositionX: true,
    backgroundPositionY: true,
    backgroundRepeat: true
  },
  backgroundPosition: {
    backgroundPositionX: true,
    backgroundPositionY: true
  },
  border: {
    borderWidth: true,
    borderStyle: true,
    borderColor: true
  },
  borderBottom: {
    borderBottomWidth: true,
    borderBottomStyle: true,
    borderBottomColor: true
  },
  borderLeft: {
    borderLeftWidth: true,
    borderLeftStyle: true,
    borderLeftColor: true
  },
  borderRight: {
    borderRightWidth: true,
    borderRightStyle: true,
    borderRightColor: true
  },
  borderTop: {
    borderTopWidth: true,
    borderTopStyle: true,
    borderTopColor: true
  },
  font: {
    fontStyle: true,
    fontVariant: true,
    fontWeight: true,
    fontSize: true,
    lineHeight: true,
    fontFamily: true
  },
  outline: {
    outlineWidth: true,
    outlineStyle: true,
    outlineColor: true
  }
};

var CSSProperty = {
  isUnitlessNumber: isUnitlessNumber,
  shorthandPropertyExpansions: shorthandPropertyExpansions
};

module.exports = CSSProperty;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(19);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstrumentation = __webpack_require__(9);

var quoteAttributeValueForBrowser = __webpack_require__(193);
var warning = __webpack_require__(2);

var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
var illegalAttributeNameCache = {};
var validatedAttributeNameCache = {};

function isAttributeNameSafe(attributeName) {
  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
    return true;
  }
  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
    return false;
  }
  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
    validatedAttributeNameCache[attributeName] = true;
    return true;
  }
  illegalAttributeNameCache[attributeName] = true;
   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
  return false;
}

function shouldIgnoreValue(propertyInfo, value) {
  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
}

/**
 * Operations for dealing with DOM properties.
 */
var DOMPropertyOperations = {
  /**
   * Creates markup for the ID property.
   *
   * @param {string} id Unescaped ID.
   * @return {string} Markup string.
   */
  createMarkupForID: function (id) {
    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
  },

  setAttributeForID: function (node, id) {
    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
  },

  createMarkupForRoot: function () {
    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
  },

  setAttributeForRoot: function (node) {
    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
  },

  /**
   * Creates markup for a property.
   *
   * @param {string} name
   * @param {*} value
   * @return {?string} Markup string, or null if the property was invalid.
   */
  createMarkupForProperty: function (name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      if (shouldIgnoreValue(propertyInfo, value)) {
        return '';
      }
      var attributeName = propertyInfo.attributeName;
      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
        return attributeName + '=""';
      }
      return attributeName + '=' + quoteAttributeValueForBrowser(value);
    } else if (DOMProperty.isCustomAttribute(name)) {
      if (value == null) {
        return '';
      }
      return name + '=' + quoteAttributeValueForBrowser(value);
    }
    return null;
  },

  /**
   * Creates markup for a custom property.
   *
   * @param {string} name
   * @param {*} value
   * @return {string} Markup string, or empty string if the property was invalid.
   */
  createMarkupForCustomAttribute: function (name, value) {
    if (!isAttributeNameSafe(name) || value == null) {
      return '';
    }
    return name + '=' + quoteAttributeValueForBrowser(value);
  },

  /**
   * Sets the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   * @param {*} value
   */
  setValueForProperty: function (node, name, value) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, value);
      } else if (shouldIgnoreValue(propertyInfo, value)) {
        this.deleteValueForProperty(node, name);
        return;
      } else if (propertyInfo.mustUseProperty) {
        // Contrary to `setAttribute`, object properties are properly
        // `toString`ed by IE8/9.
        node[propertyInfo.propertyName] = value;
      } else {
        var attributeName = propertyInfo.attributeName;
        var namespace = propertyInfo.attributeNamespace;
        // `setAttribute` with objects becomes only `[object]` in IE8/9,
        // ('' + value) makes it output the correct toString()-value.
        if (namespace) {
          node.setAttributeNS(namespace, attributeName, '' + value);
        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
          node.setAttribute(attributeName, '');
        } else {
          node.setAttribute(attributeName, '' + value);
        }
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      DOMPropertyOperations.setValueForAttribute(node, name, value);
      return;
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  setValueForAttribute: function (node, name, value) {
    if (!isAttributeNameSafe(name)) {
      return;
    }
    if (value == null) {
      node.removeAttribute(name);
    } else {
      node.setAttribute(name, '' + value);
    }

    if (false) {
      var payload = {};
      payload[name] = value;
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'update attribute',
        payload: payload
      });
    }
  },

  /**
   * Deletes an attributes from a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForAttribute: function (node, name) {
    node.removeAttribute(name);
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  },

  /**
   * Deletes the value for a property on a node.
   *
   * @param {DOMElement} node
   * @param {string} name
   */
  deleteValueForProperty: function (node, name) {
    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
    if (propertyInfo) {
      var mutationMethod = propertyInfo.mutationMethod;
      if (mutationMethod) {
        mutationMethod(node, undefined);
      } else if (propertyInfo.mustUseProperty) {
        var propName = propertyInfo.propertyName;
        if (propertyInfo.hasBooleanValue) {
          node[propName] = false;
        } else {
          node[propName] = '';
        }
      } else {
        node.removeAttribute(propertyInfo.attributeName);
      }
    } else if (DOMProperty.isCustomAttribute(name)) {
      node.removeAttribute(name);
    }

    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
        type: 'remove attribute',
        payload: name
      });
    }
  }
};

module.exports = DOMPropertyOperations;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(46);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(11);

var warning = __webpack_require__(2);

var didWarnValueLink = false;
var didWarnValueDefaultValue = false;

function updateOptionsIfPendingUpdateAndMounted() {
  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
    this._wrapperState.pendingUpdate = false;

    var props = this._currentElement.props;
    var value = LinkedValueUtils.getValue(props);

    if (value != null) {
      updateOptions(this, Boolean(props.multiple), value);
    }
  }
}

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

var valuePropNames = ['value', 'defaultValue'];

/**
 * Validation function for `value` and `defaultValue`.
 * @private
 */
function checkSelectPropTypes(inst, props) {
  var owner = inst._currentElement._owner;
  LinkedValueUtils.checkPropTypes('select', props, owner);

  if (props.valueLink !== undefined && !didWarnValueLink) {
     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
    didWarnValueLink = true;
  }

  for (var i = 0; i < valuePropNames.length; i++) {
    var propName = valuePropNames[i];
    if (props[propName] == null) {
      continue;
    }
    var isArray = Array.isArray(props[propName]);
    if (props.multiple && !isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    } else if (!props.multiple && isArray) {
       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
    }
  }
}

/**
 * @param {ReactDOMComponent} inst
 * @param {boolean} multiple
 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
 * @private
 */
function updateOptions(inst, multiple, propValue) {
  var selectedValue, i;
  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;

  if (multiple) {
    selectedValue = {};
    for (i = 0; i < propValue.length; i++) {
      selectedValue['' + propValue[i]] = true;
    }
    for (i = 0; i < options.length; i++) {
      var selected = selectedValue.hasOwnProperty(options[i].value);
      if (options[i].selected !== selected) {
        options[i].selected = selected;
      }
    }
  } else {
    // Do not set `select.value` as exact behavior isn't consistent across all
    // browsers for all cases.
    selectedValue = '' + propValue;
    for (i = 0; i < options.length; i++) {
      if (options[i].value === selectedValue) {
        options[i].selected = true;
        return;
      }
    }
    if (options.length) {
      options[0].selected = true;
    }
  }
}

/**
 * Implements a <select> host component that allows optionally setting the
 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
 * stringable. If `multiple` is true, the prop must be an array of stringables.
 *
 * If `value` is not supplied (or null/undefined), user actions that change the
 * selected option will trigger updates to the rendered options.
 *
 * If it is supplied (and not null/undefined), the rendered options will not
 * update in response to user actions. Instead, the `value` prop must change in
 * order for the rendered options to update.
 *
 * If `defaultValue` is provided, any options with the supplied values will be
 * selected.
 */
var ReactDOMSelect = {
  getHostProps: function (inst, props) {
    return _assign({}, props, {
      onChange: inst._wrapperState.onChange,
      value: undefined
    });
  },

  mountWrapper: function (inst, props) {
    if (false) {
      checkSelectPropTypes(inst, props);
    }

    var value = LinkedValueUtils.getValue(props);
    inst._wrapperState = {
      pendingUpdate: false,
      initialValue: value != null ? value : props.defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      wasMultiple: Boolean(props.multiple)
    };

    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
      didWarnValueDefaultValue = true;
    }
  },

  getSelectValueContext: function (inst) {
    // ReactDOMOption looks at this initial value so the initial generated
    // markup has correct `selected` attributes
    return inst._wrapperState.initialValue;
  },

  postUpdateWrapper: function (inst) {
    var props = inst._currentElement.props;

    // After the initial mount, we control selected-ness manually so don't pass
    // this value down
    inst._wrapperState.initialValue = undefined;

    var wasMultiple = inst._wrapperState.wasMultiple;
    inst._wrapperState.wasMultiple = Boolean(props.multiple);

    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      inst._wrapperState.pendingUpdate = false;
      updateOptions(inst, Boolean(props.multiple), value);
    } else if (wasMultiple !== Boolean(props.multiple)) {
      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
      if (props.defaultValue != null) {
        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
      } else {
        // Revert the select back to its default unselected state.
        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
      }
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  if (this._rootNodeID) {
    this._wrapperState.pendingUpdate = true;
  }
  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
  return returnValue;
}

module.exports = ReactDOMSelect;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1),
    _assign = __webpack_require__(3);

var ReactCompositeComponent = __webpack_require__(202);
var ReactEmptyComponent = __webpack_require__(89);
var ReactHostComponent = __webpack_require__(90);

var getNextDebugID = __webpack_require__(203);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

// To avoid a cyclic dependency, we create the final class in this module
var ReactCompositeComponentWrapper = function (element) {
  this.construct(element);
};

function getDeclarationErrorAddendum(owner) {
  if (owner) {
    var name = owner.getName();
    if (name) {
      return ' Check the render method of `' + name + '`.';
    }
  }
  return '';
}

/**
 * Check if the type reference is a known internal type. I.e. not a user
 * provided composite type.
 *
 * @param {function} type
 * @return {boolean} Returns true if this is a valid internal type.
 */
function isInternalComponentType(type) {
  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
}

/**
 * Given a ReactNode, create an instance that will actually be mounted.
 *
 * @param {ReactNode} node
 * @param {boolean} shouldHaveDebugID
 * @return {object} A new instance of the element's constructor.
 * @protected
 */
function instantiateReactComponent(node, shouldHaveDebugID) {
  var instance;

  if (node === null || node === false) {
    instance = ReactEmptyComponent.create(instantiateReactComponent);
  } else if (typeof node === 'object') {
    var element = node;
    var type = element.type;
    if (typeof type !== 'function' && typeof type !== 'string') {
      var info = '';
      if (false) {
        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
        }
      }
      info += getDeclarationErrorAddendum(element._owner);
       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
    }

    // Special case string values
    if (typeof element.type === 'string') {
      instance = ReactHostComponent.createInternalComponent(element);
    } else if (isInternalComponentType(element.type)) {
      // This is temporarily available for custom components that are not string
      // representations. I.e. ART. Once those are updated to use the string
      // representation, we can drop this code path.
      instance = new element.type(element);

      // We renamed this. Allow the old name for compat. :(
      if (!instance.getHostNode) {
        instance.getHostNode = instance.getNativeNode;
      }
    } else {
      instance = new ReactCompositeComponentWrapper(element);
    }
  } else if (typeof node === 'string' || typeof node === 'number') {
    instance = ReactHostComponent.createInstanceForText(node);
  } else {
     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
  }

  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
  }

  // These two fields are used by the DOM and ART diffing algorithms
  // respectively. Instead of using expandos on components, we should be
  // storing the state needed by the diffing algorithms elsewhere.
  instance._mountIndex = 0;
  instance._mountImage = null;

  if (false) {
    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
  }

  // Internal instances should fully constructed at this point, so they should
  // not get any new fields added to them at this point.
  if (false) {
    if (Object.preventExtensions) {
      Object.preventExtensions(instance);
    }
  }

  return instance;
}

_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
  _instantiateReactComponent: instantiateReactComponent
});

module.exports = instantiateReactComponent;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var React = __webpack_require__(17);

var invariant = __webpack_require__(0);

var ReactNodeTypes = {
  HOST: 0,
  COMPOSITE: 1,
  EMPTY: 2,

  getType: function (node) {
    if (node === null || node === false) {
      return ReactNodeTypes.EMPTY;
    } else if (React.isValidElement(node)) {
      if (typeof node.type === 'function') {
        return ReactNodeTypes.COMPOSITE;
      } else {
        return ReactNodeTypes.HOST;
      }
    }
     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
  }
};

module.exports = ReactNodeTypes;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyComponentFactory;

var ReactEmptyComponentInjection = {
  injectEmptyComponentFactory: function (factory) {
    emptyComponentFactory = factory;
  }
};

var ReactEmptyComponent = {
  create: function (instantiate) {
    return emptyComponentFactory(instantiate);
  }
};

ReactEmptyComponent.injection = ReactEmptyComponentInjection;

module.exports = ReactEmptyComponent;

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

var genericComponentClass = null;
var textComponentClass = null;

var ReactHostComponentInjection = {
  // This accepts a class that receives the tag string. This is a catch all
  // that can render any kind of tag.
  injectGenericComponentClass: function (componentClass) {
    genericComponentClass = componentClass;
  },
  // This accepts a text component class that takes the text string to be
  // rendered as props.
  injectTextComponentClass: function (componentClass) {
    textComponentClass = componentClass;
  }
};

/**
 * Get a host internal component class for a specific tag.
 *
 * @param {ReactElement} element The element to create.
 * @return {function} The internal class constructor function.
 */
function createInternalComponent(element) {
  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
  return new genericComponentClass(element);
}

/**
 * @param {ReactText} text
 * @return {ReactComponent}
 */
function createInstanceForText(text) {
  return new textComponentClass(text);
}

/**
 * @param {ReactComponent} component
 * @return {boolean}
 */
function isTextComponent(component) {
  return component instanceof textComponentClass;
}

var ReactHostComponent = {
  createInternalComponent: createInternalComponent,
  createInstanceForText: createInstanceForText,
  isTextComponent: isTextComponent,
  injection: ReactHostComponentInjection
};

module.exports = ReactHostComponent;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var ReactCurrentOwner = __webpack_require__(13);
var REACT_ELEMENT_TYPE = __webpack_require__(204);

var getIteratorFn = __webpack_require__(205);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(50);
var warning = __webpack_require__(2);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(13);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

function isNative(fn) {
  // Based on isNative() from Lodash
  var funcToString = Function.prototype.toString;
  var hasOwnProperty = Object.prototype.hasOwnProperty;
  var reIsNative = RegExp('^' + funcToString
  // Take an example native function source for comparison
  .call(hasOwnProperty
  // Strip regex characters so we can use it for regex
  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
  // Remove hasOwnProperty from the template to make it generic
  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
  try {
    var source = funcToString.call(fn);
    return reIsNative.test(source);
  } catch (err) {
    return false;
  }
}

var canUseCollections =
// Array.from
typeof Array.from === 'function' &&
// Map
typeof Map === 'function' && isNative(Map) &&
// Map.prototype.keys
Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
// Set
typeof Set === 'function' && isNative(Set) &&
// Set.prototype.keys
Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);

var setItem;
var getItem;
var removeItem;
var getItemIDs;
var addRoot;
var removeRoot;
var getRootIDs;

if (canUseCollections) {
  var itemMap = new Map();
  var rootIDSet = new Set();

  setItem = function (id, item) {
    itemMap.set(id, item);
  };
  getItem = function (id) {
    return itemMap.get(id);
  };
  removeItem = function (id) {
    itemMap['delete'](id);
  };
  getItemIDs = function () {
    return Array.from(itemMap.keys());
  };

  addRoot = function (id) {
    rootIDSet.add(id);
  };
  removeRoot = function (id) {
    rootIDSet['delete'](id);
  };
  getRootIDs = function () {
    return Array.from(rootIDSet.keys());
  };
} else {
  var itemByKey = {};
  var rootByKey = {};

  // Use non-numeric keys to prevent V8 performance issues:
  // https://github.com/facebook/react/pull/7232
  var getKeyFromID = function (id) {
    return '.' + id;
  };
  var getIDFromKey = function (key) {
    return parseInt(key.substr(1), 10);
  };

  setItem = function (id, item) {
    var key = getKeyFromID(id);
    itemByKey[key] = item;
  };
  getItem = function (id) {
    var key = getKeyFromID(id);
    return itemByKey[key];
  };
  removeItem = function (id) {
    var key = getKeyFromID(id);
    delete itemByKey[key];
  };
  getItemIDs = function () {
    return Object.keys(itemByKey).map(getIDFromKey);
  };

  addRoot = function (id) {
    var key = getKeyFromID(id);
    rootByKey[key] = true;
  };
  removeRoot = function (id) {
    var key = getKeyFromID(id);
    delete rootByKey[key];
  };
  getRootIDs = function () {
    return Object.keys(rootByKey).map(getIDFromKey);
  };
}

var unmountedIDs = [];

function purgeDeep(id) {
  var item = getItem(id);
  if (item) {
    var childIDs = item.childIDs;

    removeItem(id);
    childIDs.forEach(purgeDeep);
  }
}

function describeComponentFrame(name, source, ownerName) {
  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
}

function getDisplayName(element) {
  if (element == null) {
    return '#empty';
  } else if (typeof element === 'string' || typeof element === 'number') {
    return '#text';
  } else if (typeof element.type === 'string') {
    return element.type;
  } else {
    return element.type.displayName || element.type.name || 'Unknown';
  }
}

function describeID(id) {
  var name = ReactComponentTreeHook.getDisplayName(id);
  var element = ReactComponentTreeHook.getElement(id);
  var ownerID = ReactComponentTreeHook.getOwnerID(id);
  var ownerName;
  if (ownerID) {
    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
  }
   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
  return describeComponentFrame(name, element && element._source, ownerName);
}

var ReactComponentTreeHook = {
  onSetChildren: function (id, nextChildIDs) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.childIDs = nextChildIDs;

    for (var i = 0; i < nextChildIDs.length; i++) {
      var nextChildID = nextChildIDs[i];
      var nextChild = getItem(nextChildID);
      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
      if (nextChild.parentID == null) {
        nextChild.parentID = id;
        // TODO: This shouldn't be necessary but mounting a new root during in
        // componentWillMount currently causes not-yet-mounted components to
        // be purged from our tree data so their parent id is missing.
      }
      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
    }
  },
  onBeforeMountComponent: function (id, element, parentID) {
    var item = {
      element: element,
      parentID: parentID,
      text: null,
      childIDs: [],
      isMounted: false,
      updateCount: 0
    };
    setItem(id, item);
  },
  onBeforeUpdateComponent: function (id, element) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.element = element;
  },
  onMountComponent: function (id) {
    var item = getItem(id);
    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
    item.isMounted = true;
    var isRoot = item.parentID === 0;
    if (isRoot) {
      addRoot(id);
    }
  },
  onUpdateComponent: function (id) {
    var item = getItem(id);
    if (!item || !item.isMounted) {
      // We may end up here as a result of setState() in componentWillUnmount().
      // In this case, ignore the element.
      return;
    }
    item.updateCount++;
  },
  onUnmountComponent: function (id) {
    var item = getItem(id);
    if (item) {
      // We need to check if it exists.
      // `item` might not exist if it is inside an error boundary, and a sibling
      // error boundary child threw while mounting. Then this instance never
      // got a chance to mount, but it still gets an unmounting event during
      // the error boundary cleanup.
      item.isMounted = false;
      var isRoot = item.parentID === 0;
      if (isRoot) {
        removeRoot(id);
      }
    }
    unmountedIDs.push(id);
  },
  purgeUnmountedComponents: function () {
    if (ReactComponentTreeHook._preventPurging) {
      // Should only be used for testing.
      return;
    }

    for (var i = 0; i < unmountedIDs.length; i++) {
      var id = unmountedIDs[i];
      purgeDeep(id);
    }
    unmountedIDs.length = 0;
  },
  isMounted: function (id) {
    var item = getItem(id);
    return item ? item.isMounted : false;
  },
  getCurrentStackAddendum: function (topElement) {
    var info = '';
    if (topElement) {
      var name = getDisplayName(topElement);
      var owner = topElement._owner;
      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
    }

    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    info += ReactComponentTreeHook.getStackAddendumByID(id);
    return info;
  },
  getStackAddendumByID: function (id) {
    var info = '';
    while (id) {
      info += describeID(id);
      id = ReactComponentTreeHook.getParentID(id);
    }
    return info;
  },
  getChildIDs: function (id) {
    var item = getItem(id);
    return item ? item.childIDs : [];
  },
  getDisplayName: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element) {
      return null;
    }
    return getDisplayName(element);
  },
  getElement: function (id) {
    var item = getItem(id);
    return item ? item.element : null;
  },
  getOwnerID: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (!element || !element._owner) {
      return null;
    }
    return element._owner._debugID;
  },
  getParentID: function (id) {
    var item = getItem(id);
    return item ? item.parentID : null;
  },
  getSource: function (id) {
    var item = getItem(id);
    var element = item ? item.element : null;
    var source = element != null ? element._source : null;
    return source;
  },
  getText: function (id) {
    var element = ReactComponentTreeHook.getElement(id);
    if (typeof element === 'string') {
      return element;
    } else if (typeof element === 'number') {
      return '' + element;
    } else {
      return null;
    }
  },
  getUpdateCount: function (id) {
    var item = getItem(id);
    return item ? item.updateCount : 0;
  },


  getRootIDs: getRootIDs,
  getRegisteredIDs: getItemIDs,

  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
    if (typeof console.reactStack !== 'function') {
      return;
    }

    var stack = [];
    var currentOwner = ReactCurrentOwner.current;
    var id = currentOwner && currentOwner._debugID;

    try {
      if (isCreatingElement) {
        stack.push({
          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
          fileName: currentSource ? currentSource.fileName : null,
          lineNumber: currentSource ? currentSource.lineNumber : null
        });
      }

      while (id) {
        var element = ReactComponentTreeHook.getElement(id);
        var parentID = ReactComponentTreeHook.getParentID(id);
        var ownerID = ReactComponentTreeHook.getOwnerID(id);
        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
        var source = element && element._source;
        stack.push({
          name: ownerName,
          fileName: source ? source.fileName : null,
          lineNumber: source ? source.lineNumber : null
        });
        id = parentID;
      }
    } catch (err) {
      // Internal state is messed up.
      // Stop building the stack (it's just a nice to have).
    }

    console.reactStack(stack);
  },
  popNonStandardWarningStack: function () {
    if (typeof console.reactStackEnd !== 'function') {
      return;
    }
    console.reactStackEnd();
  }
};

module.exports = ReactComponentTreeHook;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var emptyFunction = __webpack_require__(10);

/**
 * Upstream version of event listener. Does not take into account specific
 * nature of platform.
 */
var EventListener = {
  /**
   * Listen to DOM events during the bubble phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  },

  /**
   * Listen to DOM events during the capture phase.
   *
   * @param {DOMEventTarget} target DOM element to register listener on.
   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
   * @param {function} callback Callback function.
   * @return {object} Object with a `remove` method.
   */
  capture: function capture(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, true);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, true);
        }
      };
    } else {
      if (false) {
        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
      }
      return {
        remove: emptyFunction
      };
    }
  },

  registerDefault: function registerDefault() {}
};

module.exports = EventListener;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMSelection = __webpack_require__(217);

var containsNode = __webpack_require__(219);
var focusNode = __webpack_require__(83);
var getActiveElement = __webpack_require__(95);

function isInDocument(node) {
  return containsNode(document.documentElement, node);
}

/**
 * @ReactInputSelection: React input selection module. Based on Selection.js,
 * but modified to be suitable for react and has a couple of bug fixes (doesn't
 * assume buttons have range selections allowed).
 * Input selection module for React.
 */
var ReactInputSelection = {
  hasSelectionCapabilities: function (elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
  },

  getSelectionInformation: function () {
    var focusedElem = getActiveElement();
    return {
      focusedElem: focusedElem,
      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
    };
  },

  /**
   * @restoreSelection: If any selection information was potentially lost,
   * restore it. This is useful when performing operations that could remove dom
   * nodes and place them back in, resulting in focus being lost.
   */
  restoreSelection: function (priorSelectionInformation) {
    var curFocusedElem = getActiveElement();
    var priorFocusedElem = priorSelectionInformation.focusedElem;
    var priorSelectionRange = priorSelectionInformation.selectionRange;
    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
      }
      focusNode(priorFocusedElem);
    }
  },

  /**
   * @getSelection: Gets the selection bounds of a focused textarea, input or
   * contentEditable node.
   * -@input: Look up selection bounds of this input
   * -@return {start: selectionStart, end: selectionEnd}
   */
  getSelection: function (input) {
    var selection;

    if ('selectionStart' in input) {
      // Modern browser with input or textarea.
      selection = {
        start: input.selectionStart,
        end: input.selectionEnd
      };
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      // IE8 input.
      var range = document.selection.createRange();
      // There can only be one selection per document in IE, so it must
      // be in our element.
      if (range.parentElement() === input) {
        selection = {
          start: -range.moveStart('character', -input.value.length),
          end: -range.moveEnd('character', -input.value.length)
        };
      }
    } else {
      // Content editable or old IE textarea.
      selection = ReactDOMSelection.getOffsets(input);
    }

    return selection || { start: 0, end: 0 };
  },

  /**
   * @setSelection: Sets the selection bounds of a textarea or input and focuses
   * the input.
   * -@input     Set selection bounds of this input or textarea
   * -@offsets   Object of same form that is returned from get*
   */
  setSelection: function (input, offsets) {
    var start = offsets.start;
    var end = offsets.end;
    if (end === undefined) {
      end = start;
    }

    if ('selectionStart' in input) {
      input.selectionStart = start;
      input.selectionEnd = Math.min(end, input.value.length);
    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    } else {
      ReactDOMSelection.setOffsets(input, offsets);
    }
  }
};

module.exports = ReactInputSelection;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var DOMLazyTree = __webpack_require__(21);
var DOMProperty = __webpack_require__(19);
var React = __webpack_require__(17);
var ReactBrowserEventEmitter = __webpack_require__(32);
var ReactCurrentOwner = __webpack_require__(13);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMContainerInfo = __webpack_require__(234);
var ReactDOMFeatureFlags = __webpack_require__(235);
var ReactFeatureFlags = __webpack_require__(78);
var ReactInstanceMap = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(9);
var ReactMarkupChecksum = __webpack_require__(236);
var ReactReconciler = __webpack_require__(20);
var ReactUpdateQueue = __webpack_require__(51);
var ReactUpdates = __webpack_require__(11);

var emptyObject = __webpack_require__(35);
var instantiateReactComponent = __webpack_require__(87);
var invariant = __webpack_require__(0);
var setInnerHTML = __webpack_require__(30);
var shouldUpdateReactComponent = __webpack_require__(49);
var warning = __webpack_require__(2);

var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;

var ELEMENT_NODE_TYPE = 1;
var DOC_NODE_TYPE = 9;
var DOCUMENT_FRAGMENT_NODE_TYPE = 11;

var instancesByReactRootID = {};

/**
 * Finds the index of the first character
 * that's not common between the two given strings.
 *
 * @return {number} the index of the character where the strings diverge
 */
function firstDifferenceIndex(string1, string2) {
  var minLen = Math.min(string1.length, string2.length);
  for (var i = 0; i < minLen; i++) {
    if (string1.charAt(i) !== string2.charAt(i)) {
      return i;
    }
  }
  return string1.length === string2.length ? -1 : minLen;
}

/**
 * @param {DOMElement|DOMDocument} container DOM element that may contain
 * a React component
 * @return {?*} DOM element that may have the reactRoot ID, or null.
 */
function getReactRootElementInContainer(container) {
  if (!container) {
    return null;
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    return container.documentElement;
  } else {
    return container.firstChild;
  }
}

function internalGetID(node) {
  // If node is something like a window, document, or text node, none of
  // which support attributes or a .getAttribute method, gracefully return
  // the empty string, as if the attribute were missing.
  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
}

/**
 * Mounts this component and inserts it into the DOM.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {ReactReconcileTransaction} transaction
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
  var markerName;
  if (ReactFeatureFlags.logTopLevelRenders) {
    var wrappedElement = wrapperInstance._currentElement.props.child;
    var type = wrappedElement.type;
    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
    console.time(markerName);
  }

  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
  );

  if (markerName) {
    console.timeEnd(markerName);
  }

  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
}

/**
 * Batched mount.
 *
 * @param {ReactComponent} componentInstance The instance to mount.
 * @param {DOMElement} container DOM element to mount into.
 * @param {boolean} shouldReuseMarkup If true, do not insert markup
 */
function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
  /* useCreateElement */
  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
  ReactUpdates.ReactReconcileTransaction.release(transaction);
}

/**
 * Unmounts a component and removes it from the DOM.
 *
 * @param {ReactComponent} instance React component instance.
 * @param {DOMElement} container DOM element to unmount from.
 * @final
 * @internal
 * @see {ReactMount.unmountComponentAtNode}
 */
function unmountComponentFromNode(instance, container, safely) {
  if (false) {
    ReactInstrumentation.debugTool.onBeginFlush();
  }
  ReactReconciler.unmountComponent(instance, safely);
  if (false) {
    ReactInstrumentation.debugTool.onEndFlush();
  }

  if (container.nodeType === DOC_NODE_TYPE) {
    container = container.documentElement;
  }

  // http://jsperf.com/emptying-a-node
  while (container.lastChild) {
    container.removeChild(container.lastChild);
  }
}

/**
 * True if the supplied DOM node has a direct React-rendered child that is
 * not a React root element. Useful for warning in `render`,
 * `unmountComponentAtNode`, etc.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM element contains a direct child that was
 * rendered by React but is not a root element.
 * @internal
 */
function hasNonRootReactChild(container) {
  var rootEl = getReactRootElementInContainer(container);
  if (rootEl) {
    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
    return !!(inst && inst._hostParent);
  }
}

/**
 * True if the supplied DOM node is a React DOM element and
 * it has been rendered by another copy of React.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM has been rendered by another copy of React
 * @internal
 */
function nodeIsRenderedByOtherInstance(container) {
  var rootEl = getReactRootElementInContainer(container);
  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
}

/**
 * True if the supplied DOM node is a valid node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid DOM node.
 * @internal
 */
function isValidContainer(node) {
  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
}

/**
 * True if the supplied DOM node is a valid React node element.
 *
 * @param {?DOMElement} node The candidate DOM node.
 * @return {boolean} True if the DOM is a valid React DOM node.
 * @internal
 */
function isReactNode(node) {
  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
}

function getHostRootInstanceInContainer(container) {
  var rootEl = getReactRootElementInContainer(container);
  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
}

function getTopLevelWrapperInContainer(container) {
  var root = getHostRootInstanceInContainer(container);
  return root ? root._hostContainerInfo._topLevelWrapper : null;
}

/**
 * Temporary (?) hack so that we can store all top-level pending updates on
 * composites instead of having to worry about different types of components
 * here.
 */
var topLevelRootCounter = 1;
var TopLevelWrapper = function () {
  this.rootID = topLevelRootCounter++;
};
TopLevelWrapper.prototype.isReactComponent = {};
if (false) {
  TopLevelWrapper.displayName = 'TopLevelWrapper';
}
TopLevelWrapper.prototype.render = function () {
  return this.props.child;
};
TopLevelWrapper.isReactTopLevelWrapper = true;

/**
 * Mounting is the process of initializing a React component by creating its
 * representative DOM elements and inserting them into a supplied `container`.
 * Any prior content inside `container` is destroyed in the process.
 *
 *   ReactMount.render(
 *     component,
 *     document.getElementById('container')
 *   );
 *
 *   <div id="container">                   <-- Supplied `container`.
 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
 *       // ...                                 component.
 *     </div>
 *   </div>
 *
 * Inside of `container`, the first element rendered is the "reactRoot".
 */
var ReactMount = {
  TopLevelWrapper: TopLevelWrapper,

  /**
   * Used by devtools. The keys are not important.
   */
  _instancesByReactRootID: instancesByReactRootID,

  /**
   * This is a hook provided to support rendering React components while
   * ensuring that the apparent scroll position of its `container` does not
   * change.
   *
   * @param {DOMElement} container The `container` being rendered into.
   * @param {function} renderCallback This must be called once to do the render.
   */
  scrollMonitor: function (container, renderCallback) {
    renderCallback();
  },

  /**
   * Take a component that's already mounted into the DOM and replace its props
   * @param {ReactComponent} prevComponent component instance already in the DOM
   * @param {ReactElement} nextElement component instance to render
   * @param {DOMElement} container container to render into
   * @param {?function} callback function triggered on completion
   */
  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
    ReactMount.scrollMonitor(container, function () {
      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
      if (callback) {
        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
      }
    });

    return prevComponent;
  },

  /**
   * Render a new component into the DOM. Hooked by hooks!
   *
   * @param {ReactElement} nextElement element to render
   * @param {DOMElement} container container to render into
   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
   * @return {ReactComponent} nextComponent
   */
  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case.
     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;

    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
    var componentInstance = instantiateReactComponent(nextElement, false);

    // The initial render is synchronous but any updates that happen during
    // rendering, in componentWillMount or componentDidMount, will be batched
    // according to the current batching strategy.

    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);

    var wrapperID = componentInstance._instance.rootID;
    instancesByReactRootID[wrapperID] = componentInstance;

    return componentInstance;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
  },

  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;

     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;

    var nextWrappedElement = React.createElement(TopLevelWrapper, {
      child: nextElement
    });

    var nextContext;
    if (parentComponent) {
      var parentInst = ReactInstanceMap.get(parentComponent);
      nextContext = parentInst._processChildContext(parentInst._context);
    } else {
      nextContext = emptyObject;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);

    if (prevComponent) {
      var prevWrappedElement = prevComponent._currentElement;
      var prevElement = prevWrappedElement.props.child;
      if (shouldUpdateReactComponent(prevElement, nextElement)) {
        var publicInst = prevComponent._renderedComponent.getPublicInstance();
        var updatedCallback = callback && function () {
          callback.call(publicInst);
        };
        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
        return publicInst;
      } else {
        ReactMount.unmountComponentAtNode(container);
      }
    }

    var reactRootElement = getReactRootElementInContainer(container);
    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
    var containerHasNonRootReactChild = hasNonRootReactChild(container);

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;

      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
        var rootElementSibling = reactRootElement;
        while (rootElementSibling) {
          if (internalGetID(rootElementSibling)) {
            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
            break;
          }
          rootElementSibling = rootElementSibling.nextSibling;
        }
      }
    }

    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
    if (callback) {
      callback.call(component);
    }
    return component;
  },

  /**
   * Renders a React component into the DOM in the supplied `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
   *
   * If the React component was previously rendered into `container`, this will
   * perform an update on it and only mutate the DOM as necessary to reflect the
   * latest React component.
   *
   * @param {ReactElement} nextElement Component element to render.
   * @param {DOMElement} container DOM element to render into.
   * @param {?function} callback function triggered on completion
   * @return {ReactComponent} Component instance rendered in `container`.
   */
  render: function (nextElement, container, callback) {
    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
  },

  /**
   * Unmounts and destroys the React component rendered in the `container`.
   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
   *
   * @param {DOMElement} container DOM element containing a React component.
   * @return {boolean} True if a component was found in and unmounted from
   *                   `container`
   */
  unmountComponentAtNode: function (container) {
    // Various parts of our code (such as ReactCompositeComponent's
    // _renderValidatedComponent) assume that calls to render aren't nested;
    // verify that that's the case. (Strictly speaking, unmounting won't cause a
    // render but we still don't expect to be in a render call here.)
     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;

    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
    }

    var prevComponent = getTopLevelWrapperInContainer(container);
    if (!prevComponent) {
      // Check if the node being unmounted was rendered by React, but isn't a
      // root node.
      var containerHasNonRootReactChild = hasNonRootReactChild(container);

      // Check if the container itself is a React root node.
      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
      }

      return false;
    }
    delete instancesByReactRootID[prevComponent._instance.rootID];
    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
    return true;
  },

  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;

    if (shouldReuseMarkup) {
      var rootElement = getReactRootElementInContainer(container);
      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
        ReactDOMComponentTree.precacheNode(instance, rootElement);
        return;
      } else {
        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);

        var rootMarkup = rootElement.outerHTML;
        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);

        var normalizedMarkup = markup;
        if (false) {
          // because rootMarkup is retrieved from the DOM, various normalizations
          // will have occurred which will not be present in `markup`. Here,
          // insert markup into a <div> or <iframe> depending on the container
          // type to perform the same normalizations before comparing.
          var normalizer;
          if (container.nodeType === ELEMENT_NODE_TYPE) {
            normalizer = document.createElement('div');
            normalizer.innerHTML = markup;
            normalizedMarkup = normalizer.innerHTML;
          } else {
            normalizer = document.createElement('iframe');
            document.body.appendChild(normalizer);
            normalizer.contentDocument.write(markup);
            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
            document.body.removeChild(normalizer);
          }
        }

        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);

        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;

        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
        }
      }
    }

    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;

    if (transaction.useCreateElement) {
      while (container.lastChild) {
        container.removeChild(container.lastChild);
      }
      DOMLazyTree.insertTreeBefore(container, markup, null);
    } else {
      setInnerHTML(container, markup);
      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
    }

    if (false) {
      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
      if (hostNode._debugID !== 0) {
        ReactInstrumentation.debugTool.onHostOperation({
          instanceID: hostNode._debugID,
          type: 'mount',
          payload: markup.toString()
        });
      }
    }
  }
};

module.exports = ReactMount;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactNodeTypes = __webpack_require__(88);

function getHostComponentFromComposite(inst) {
  var type;

  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
    inst = inst._renderedComponent;
  }

  if (type === ReactNodeTypes.HOST) {
    return inst._renderedComponent;
  } else if (type === ReactNodeTypes.EMPTY) {
    return null;
  }
}

module.exports = getHostComponentFromComposite;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(99);


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
$=jQuery,window.ThomannConfigurator=__webpack_require__(33),__webpack_require__(105),__webpack_require__(106),__webpack_require__(110),__webpack_require__(111),__webpack_require__(112),__webpack_require__(113),__webpack_require__(114),__webpack_require__(115),__webpack_require__(116),window.ThomannCasefactory_ui=__webpack_require__(117);var resolve_parameter=__webpack_require__(64);window.ThomannCasefactory_ui.dynamicRequire.register({react:__webpack_require__(8),"Mssg.jsx":__webpack_require__(70).default,"AccordionTab.jsx":__webpack_require__(153),"RangeSliderv2.jsx":__webpack_require__(154),"RangeSliderv3.jsx":__webpack_require__(156),"Select.jsx":__webpack_require__(157),"SVGIcon.jsx":__webpack_require__(159).default,resolveLanguage:function resolveLanguage(key,parameter){return resolve_parameter(mc_i18n[key.replace("nc_casefactory.","")],parameter)}}),window.ThomannCasefactory={mc_caseconfigurator:__webpack_require__(160),mc_canvasControl:__webpack_require__(242),mc_casefactory:__webpack_require__(36)},$(document).ready(function(){$(document).on("click","div.lr-casefactory-choices-sliders-dimensions h3",function(){$(this).next().slideToggle(500),$(this).parent().toggleClass("open"),$("div.lr-casefactory-choices-color-picker.open h3").next().slideToggle(500),$("div.lr-casefactory-choices-color-picker").removeClass("open"),megacase_close_casefactory_tabs()}),$(document).on("click","div.lr-casefactory-choices-color-picker h3",function(){$(this).next().slideToggle(500),$(this).parent().toggleClass("open"),$("div.lr-casefactory-choices-sliders-dimensions.open h3").next().slideToggle(500),$("div.lr-casefactory-choices-sliders-dimensions").removeClass("open"),megacase_close_casefactory_tabs()}),$(document).on("click","div.lr-components-accordion-tab h3",function(){$("div.lr-casefactory-choices-sliders-dimensions.open h3").next().slideToggle(500),$("div.lr-casefactory-choices-sliders-dimensions").removeClass("open"),$("div.lr-casefactory-choices-color-picker.open h3").next().slideToggle(500),$("div.lr-casefactory-choices-color-picker").removeClass("open")})});function megacase_close_casefactory_tabs(){var choices=$(".lr-casefactory-choices");choices.find("h3.open + div").slideToggle(500),choices.find("h3.open").removeClass("open")}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var CaseWorldView=__webpack_require__(101),utils=__webpack_require__(7),CompositeElementView=__webpack_require__(56),PartView=__webpack_require__(15),PartCache=__webpack_require__(12),BuilderApi=__webpack_require__(62),EventEmitter=__webpack_require__(27).EventEmitter,memory=0,CaseWorldController=module.exports=function(config){var data=config.data,basePath=config.basePath;this.caseJson=data.visualizerData,this.cache=new PartCache(basePath),this.caseWorldView=new CaseWorldView(this.caseJson),this.zoomOngoing=!1,this.setMaxListeners(0)};utils.inherits(CaseWorldController,EventEmitter),CaseWorldController.prototype.load=function($inElement){var that=this;that._createViews(),this.caseWorldView.createWorld($inElement),this.caseWorldView.once('WorldCreated',function(){that.caseWorldView.render(),$inElement.find('canvas').css({height:'',width:''}),Detector.webgl||(that.caseWorldView.interactionHandler.updateCameraCenter(),that.moveCameraTo('front'))}),that.caseWorldView.once('renderingInitialized',function(){that.caseWorldView.interactionHandler.once('fullCameraRotationDone',function(){that.endAction()})})},CaseWorldController.prototype.scaleCaseHeightTo=function(newHeight){var that=this,caseWorldModel=that.caseWorldView.getModel(),oldHeight=caseWorldModel._height;that.startAction();var change=newHeight-oldHeight,globalScale=that.caseWorldView.updateHeight(newHeight);globalScale?that.caseWorldView.scaleHeight(globalScale,change):that.caseWorldView.scaleHeight(newHeight/oldHeight,change),that.caseWorldView.interactionHandler&&that.caseWorldView.interactionHandler.positionCamera()},CaseWorldController.prototype.scaleCaseLengthTo=function(newLength){var that=this,oldLength=that.caseWorldView.getModel()._length;that.startAction(),that.caseWorldView.updateLength(newLength),that.caseWorldView.scaleLength(newLength/oldLength,newLength-oldLength),that.caseWorldView.interactionHandler&&that.caseWorldView.interactionHandler.positionCamera()},CaseWorldController.prototype.scaleCaseDepthTo=function(newDepth){var that=this,oldDepth=that.caseWorldView.getModel()._depth;that.startAction(),that.caseWorldView.updateDepth(newDepth),that.caseWorldView.scaleDepth(newDepth/oldDepth,newDepth-oldDepth),that.caseWorldView.interactionHandler&&that.caseWorldView.interactionHandler.positionCamera()},CaseWorldController.prototype._createViews=function(){var that=this;Object.keys(that.caseJson).forEach(function(attribute){var type='',attributeData=that.caseJson[attribute];$.isPlainObject(attributeData)&&'partType'in attributeData?type=attributeData.partType:Array.isArray(attributeData)&&0<attributeData.length&&'partType'in attributeData[0]&&(type=attributeData[0].partType),'PART'==type?Array.isArray(attributeData)?attributeData.forEach(function(part){that.caseWorldView.addElementView(new PartView(part,that.caseJson._height,that.caseJson._length,that.caseJson._depth))}):that.caseWorldView.addElementView(new PartView(attributeData,that.caseJson._height,that.caseJson._length,that.caseJson._depth)):'COMPOSITION_PART'==type&&that.caseWorldView.addElementView(new CompositeElementView(attributeData,attributeData.numberOfParts,that.caseWorldView.getLoadedModelsCache()),attribute)})},CaseWorldController.prototype.addRollsOrFeeds=function(configuredCaseId,partId,category){var that=this;that.caseWorldView.activateRolls(category)},CaseWorldController.prototype.removeRollsOrFeeds=function(){var that=this;that.caseWorldView.activateRolls(!1)},CaseWorldController.prototype.activateOption=function(){},CaseWorldController.prototype.deactivateOption=function(){},CaseWorldController.prototype.changeElement=function(configuredCaseId,partId,category,file,textureFile,normalMaps,on){var that=this;that.caseWorldView.changeElement(partId,category,file,textureFile,normalMaps,on)},CaseWorldController.prototype.getCaseWorldView=function(){return this.caseWorldView},CaseWorldController.prototype.moveCameraTo=function(position){var that=this,camera=that.caseWorldView.getCamera(),newPosition=new THREE.Vector3,model=that.caseWorldView.getModel(),interactionHandler=that.caseWorldView.interactionHandler,yPosition=interactionHandler.cameraControl.center.y,scalar=6;if(that.startAction(),'front'===position)newPosition.set(0,yPosition,scalar*(model._depth/2));else if('right'===position)newPosition.set(scalar*(model._length/2),yPosition,0);else if('back'===position)newPosition.set(0,yPosition,-scalar*(model._depth/2));else if('left'===position)newPosition.set(-scalar*(model._length/2),yPosition,0);else if('top'===position){var height=scalar*parseInt(model._height);newPosition.set(0,height,-.001)}else{var cameraCoordinates=position.split('x');newPosition=new THREE.Vector3(parseInt(cameraCoordinates[0]),parseInt(cameraCoordinates[1]),parseInt(cameraCoordinates[2]))}interactionHandler.moveCameraTo(camera.position,newPosition),interactionHandler.once('cameraAnimationDone',function(){interactionHandler.once('cameraAnimationDone',function(){that.endAction(),that.emit('cameraAnimationDone')}),interactionHandler.positionCamera()})},CaseWorldController.prototype.zoom=function(mode){var that=this;if(!that.zoomOngoing){var interactionHandler=that.caseWorldView.interactionHandler,scalar=1,zoomFactor=.9;that.startAction(),that.zoomOngoing=!0,'zoom_in'===mode?scalar=zoomFactor:'zoom_out'==mode&&(scalar=1/zoomFactor);var cameraPosition=that.caseWorldView.getCamera().position,newPosition=cameraPosition.clone().multiplyScalar(scalar);interactionHandler.once('cameraAnimationDone',function(){that.endAction(),setTimeout(function(){that.zoomOngoing=!1},100)}),interactionHandler.moveCameraTo(cameraPosition,newPosition,!1,200)}},CaseWorldController.prototype.prepareForUpdate=function(){var that=this;this.startAction(),this.caseWorldView.once('WorldCreated',function(){that.caseWorldView.updateStage(),that.caseWorldView.clearOldElementViews()})},CaseWorldController.prototype.updateKeyboard=function(){var that=this;that.once('caseUpdated',function(){that.caseWorldView.interactionHandler.positionCamera(400)})},CaseWorldController.prototype.isStartAnimationActive=function(){return!this.caseWorldView.startAnimationDone},CaseWorldController.prototype.startAction=function(){this.getCaseWorldView().emit('beginRendering')},CaseWorldController.prototype.endAction=function(){this.getCaseWorldView().emit('cancelRendering')},CaseWorldController.prototype.performUpdate=function(data){var that=this;this.caseJson=data.visualizerData,this.caseWorldView.setModel(this.caseJson),this.caseWorldView.bufferElementViews(),this._createViews(),this.caseWorldView.initCaseElements(!0),this.caseWorldView.once('WorldCreated',function(){that.caseWorldView.clearOldElementViews(),that.endAction()})};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),View=__webpack_require__(55),CaseWorldUserInteraction=__webpack_require__(104),CompositionElementView=__webpack_require__(56),PartView=__webpack_require__(15),HeightPartView=__webpack_require__(59),DepthPartView=__webpack_require__(60),LengthPartView=__webpack_require__(58),UpperPartView=__webpack_require__(61),PartCache=__webpack_require__(12),STAGE_HEIGHT_OFFSET=22,CaseWorldView=module.exports=function(model){this.scene,this.camera,this.renderer,this.elementViews={part:[]},this.oldElementViews=[],this.domElement,this.model=model,this.stage,this.rolls=this.model._hasRolls,this.FIELD_OF_VIEW=40,this.ASPECT_RATIO=1.471,this.interactionHandler,this.initView(),this.frontLight,this.backLight,this.topLight,this.startAnimationDone=!1,this.cache=new PartCache};utils.inherits(CaseWorldView,View),CaseWorldView.prototype.createWorld=function($inElement){var that=this;this.initRenderer(),this.initSceneWithCamera(),Detector.webgl&&this.initLight(),this.initCaseElements(),this.domElement=this.renderer.domElement,$inElement.append(this.renderer.domElement),$(this.domElement).css({height:'367px',width:'540px'}),this.initStage(),this.once('WorldCreated',function(){that.interactionHandler=new CaseWorldUserInteraction(this),that.interactionHandler.assignInteractions(),Detector.webgl?(that.interactionHandler.once('fullCameraRotationDone',function(){that.startAnimationDone=!0}),that.interactionHandler.cameraFullRotation()):that.startAnimationDone=!0}),this.clock=new THREE.Clock},CaseWorldView.prototype.render=function(){function render(){TWEEN.update(),Detector.webgl&&that.interactionHandler.updateCamera(that.clock.getDelta()),cancelAnimationFrame(renderId),renderId=requestAnimationFrame(render),that.renderer.render(that.scene,that.camera)}var that=this,renderId=null;window.onblur=function(){that.emit('cancelRendering')},that.on('cancelRendering',function(){render(),setTimeout(function(){null!==renderId&&!0===that.startAnimationDone&&(cancelAnimationFrame(renderId),renderId=null)},50)}),that.on('beginRendering',function(){null===renderId&&render()}),render(),that.emit('renderingInitialized')},CaseWorldView.prototype.initSceneWithCamera=function(){this.scene=new THREE.Scene,this.camera=new THREE.PerspectiveCamera(this.FIELD_OF_VIEW,this.ASPECT_RATIO,.1,1e4),Detector.webgl?this.camera.position.set(700,500,1e3):this.camera.position.set(0,0,1800),this.camera.lookAt(new THREE.Vector3(0,0,0)),this.scene.add(this.camera)},CaseWorldView.prototype.initStage=function(){var that=this,shadow=THREE.ImageUtils.loadTexture(this.cache.getBasePath()+'images/shadow.png'),material=new THREE.MeshPhongMaterial({map:shadow,color:'#ffffff',shading:THREE.NoShading,shininess:90,reflectivity:1,emissive:'#ffffff'});material.opacity=.6;var plane=new THREE.PlaneGeometry(2*that.model._length,2*that.model._depth);that.stage=new THREE.Mesh(plane,material),that.stage.rotation.x=-.5*Math.PI,that._positionStage(),that.scene.add(that.stage)},CaseWorldView.prototype._positionStage=function(){var that=this,rollsOffset=0;'WHEEL'===that.rolls?rollsOffset=130:'STAND'===that.rolls?rollsOffset=0:'TROLLEY'===that.rolls||'ACCESSORY_PULLOUT_HANDLE'===that.rolls?rollsOffset=20:'CORNER_WHEEL'===that.rolls&&(rollsOffset=20),that.stage.position.set(0,-that.model._body._height/2-STAGE_HEIGHT_OFFSET-rollsOffset,0)},CaseWorldView.prototype._setStageDimensions=function(){var that=this;that.scene.remove(that.stage),that.stage=new THREE.Mesh(new THREE.PlaneGeometry(2*that.model._length,2*that.model._depth),that.stage.material),that.stage.rotation.x=-.5*Math.PI,that.scene.add(that.stage)},CaseWorldView.prototype.updateStage=function(){var that=this;that._setStageDimensions(),that._positionStage()},CaseWorldView.prototype.initCaseElements=function(lateAdding){function modelLoadedHandler(elementView,loadedParts,loadedBody,loadedCap){var model3D=elementView.getModel3D();model3D&&(lateAdding?that.once('WorldCreated',function(){that.scene.add(model3D)}):that.scene.add(model3D)),loadedParts&&loadedBody&&(!capView||loadedCap)&&(that.clearOldElementViews(),that.emit('WorldCreated'))}var that=this,partView=that.elementViews.part,bodyView=that.elementViews._body,capView=that.elementViews._cap,capView2=that.elementViews._capTwo,loadedParts=0===partView.length,loadedBody=!1,loadedCap=!1,scalePanelOffset=that.model._scalePanelOffset;partView.forEach(function(view,index2){view.setScalePanelOffset(scalePanelOffset),view.once('3DModelLoaded',function(){index2===partView.length-1&&(loadedParts=!0),that.cache.setCache(view.getModel().file,view.getOriginal3DModel()),modelLoadedHandler(view,loadedParts,loadedBody,loadedCap)}),view.loadModel3D(that.cache.getCache(view.getModel().file))}),bodyView.once('3DCompositionModelLoaded',function(){loadedBody=!0,modelLoadedHandler(bodyView,loadedParts,loadedBody,loadedCap)}),bodyView.setScalePanelOffset(scalePanelOffset),bodyView.loadModel3D(),capView&&(capView.once('3DCompositionModelLoaded',function(){loadedCap=!0,modelLoadedHandler(capView,loadedParts,loadedBody,loadedCap)}),capView.setScalePanelOffset(scalePanelOffset),capView.loadModel3D()),capView2&&(capView2.setScalePanelOffset(scalePanelOffset),capView2.once('3DCompositionModelLoaded',function(){modelLoadedHandler(capView2,loadedParts,loadedBody,loadedCap)}),capView2.loadModel3D())},CaseWorldView.prototype.initRenderer=function(){this.renderer=Detector.webgl?new THREE.WebGLRenderer({antialias:!0,precision:'highp',preserveDrawingBuffer:!0,sortObjects:!1}):new THREE.CanvasRenderer({}),this.renderer.setSize(window.innerWidth,window.innerHeight),this.renderer.setClearColor(16777215)},CaseWorldView.prototype.initLight=function(){var _MathPI=Math.PI,that=this;that.scene.add(new THREE.AmbientLight('#ffffff'));var spotLight=new THREE.PointLight('#ffffff');spotLight.angle=_MathPI/2,spotLight.intensity=2;var scalar=1;spotLight.position.set(-3e3,0,3e3).multiplyScalar(scalar),spotLight.lookAt(that.scene.position),this.frontLight=spotLight,that.scene.add(this.frontLight);var pointLight=new THREE.PointLight('#ffffff');pointLight.angle=_MathPI/2,pointLight.intensity=2,pointLight.position.set(3e3,0,-3e3).multiplyScalar(scalar),pointLight.lookAt(that.scene.position),this.backLight=pointLight,that.scene.add(this.backLight);var pointLight=new THREE.PointLight('#ffffff');pointLight.position.set(0,3e3,0),pointLight.intensity=1,pointLight.lookAt(that.scene.position),this.topLight=pointLight,that.scene.add(this.topLight)},CaseWorldView.prototype.addElementView=function(elementView,type){var that=this;type?that.elementViews[type]=elementView:that.elementViews.part.push(elementView)},CaseWorldView.prototype.addPartView=function(partView,type){var that=this;partView.loadModel3D(),type?that.elementViews[type].addPartView(partView):that.elementViews.part.push(partView)},CaseWorldView.prototype.bufferElementViews=function(){this.oldElementViews.push(this.elementViews),this.elementViews={part:[]}},CaseWorldView.prototype.clearOldElementViews=function(){var that=this;that.oldElementViews.forEach(function(oldElementView){Object.keys(oldElementView).forEach(function(part){var view=oldElementView[part];if(Array.isArray(view))view.forEach(function(oldView){var model3D=oldView.getModel3D();model3D.scale.set(1.1,1.1,1.1),that.scene.remove(model3D)});else{var model3D2=view.getModel3D();model3D2.scale.set(1.1,1.1,1.1),that.scene.remove(model3D2)}})}),that.oldElementViews=[]},CaseWorldView.prototype.scaleHeight=function(globalScale,change){var that=this,keepBodyHeight=that.model._keepBodyHeight,keepCapBodyRation=that.model._keepCapBodyRatio;that.iterateElementViews(function(view,partType){'_cap'===partType?view.scaleHeight(globalScale,change,keepCapBodyRation,!0,keepBodyHeight):view.scaleHeight(globalScale,change,keepCapBodyRation,null,keepBodyHeight)}),that.updateStage()},CaseWorldView.prototype.updateHeight=function(newHeight){var that=this;if(that.model._height=newHeight,that.model._keepCapBodyRatio){var ratio=that._getCapBodyRatio(),newCapHeight=newHeight/(ratio+1),newBodyHeight=newHeight*(1-1/(ratio+1));that.elementViews._body.updateHeight(newBodyHeight),that.elementViews._cap.updateHeight(newCapHeight)}else{if(that.model._keepCapHeight){var capHeight=that.elementViews._cap.getModel()._height,newBodyHeight=newHeight-capHeight,oldBodyHeight=that.elementViews._body.getModel()._height;return that.elementViews._body.updateHeight(newBodyHeight),that.elementViews.part.forEach(function(partView){partView.updateHeight(newBodyHeight)}),newBodyHeight/oldBodyHeight}if(that.model._keepBodyHeight){var bodyHeight=that.elementViews._body.getModel()._height,newCapHeight=newHeight-bodyHeight,oldCapHeight=that.elementViews._cap.getModel()._height;return that.elementViews._cap.updateHeight(newCapHeight),newCapHeight/oldCapHeight}if(that.model._isDoubleDoorRack)return that.elementViews._body.updateHeight(newHeight),that.elementViews.part.forEach(function(partView){partView.updateHeight(newHeight)}),that.elementViews._cap&&that.elementViews._cap.updateHeight(newHeight),that.elementViews._capTwo&&that.elementViews._capTwo.updateHeight(newHeight),null}return null},CaseWorldView.prototype.updateLength=function(newLength){var that=this;that.model._length=newLength,that.iterateElementViews(function(view){view.updateLength(newLength)})},CaseWorldView.prototype.scaleLength=function(globalScale,change){var that=this;that.iterateElementViews(function(view){view.scaleLength(globalScale,change)}),that.updateStage()},CaseWorldView.prototype.updateDepth=function(newDepth){var that=this;that.model._depth=newDepth,that.iterateElementViews(function(view){view.updateDepth(newDepth)})},CaseWorldView.prototype.scaleDepth=function(globalScale,change){var that=this;that.iterateElementViews(function(view){view.scaleDepth(globalScale,change)}),that.updateStage()},CaseWorldView.prototype._getCapBodyRatio=function(){var that=this,bodyHeight=that.elementViews._body.getModel()._height,capHeight=that.elementViews._cap.getModel()._height;return bodyHeight/capHeight},CaseWorldView.prototype.getModel=function(){return this.model},CaseWorldView.prototype.setModel=function(model){return this.rolls=model._hasRolls,this.model=model,this},CaseWorldView.prototype.getCamera=function(){return this.camera},CaseWorldView.prototype.getDomElement=function(){return this.domElement},CaseWorldView.prototype.getScene=function(){return this.scene},CaseWorldView.prototype.iterateElementViews=function(callback){var that=this;Object.keys(that.elementViews).forEach(function(partType){'part'===partType?that.elementViews[partType].forEach(function(view,index){callback(view,partType,index)}):callback(that.elementViews[partType],partType)})},CaseWorldView.prototype.activateRolls=function(flag){var that=this;that.rolls=flag},CaseWorldView.prototype.changeElement=function(partId,category,file,textureFile,normalMaps,on){function checkAndUpdateElement(view,viewContainer,index){var newPartView,model=view.getModel();model.category===category&&(model.file=file,model.textureFile=textureFile,model.id=partId,model.normalMaps=normalMaps,newPartView=view instanceof HeightPartView?new HeightPartView(model,view.getParentHeight(),view.getParentLength(),view.getParentDepth()):view instanceof LengthPartView?new LengthPartView(model,view.getParentHeight(),view.getParentLength(),view.getParentDepth()):view instanceof DepthPartView?new DepthPartView(model,view.getParentHeight(),view.getParentLength(),view.getParentDepth()):view instanceof UpperPartView?new UpperPartView(model,view.getParentHeight(),view.getParentLength(),view.getParentDepth()):new PartView(model,view.getParentHeight(),view.getParentLength(),view.getParentDepth()),newPartView.setScalePanelOffset(that.model._scalePanelOffset),newPartView.once('3DModelLoaded',function(){that.cache.setCache(file,newPartView.getOriginal3DModel()),viewContainer.replacePartView(index,newPartView)}),newPartView.loadModel3D(that.cache.getCache(file)))}var that=this;return on?void that.elementViews[on].getPartViews().forEach(function(view,index){checkAndUpdateElement(view,that.elementViews._cap,index)}):void that.iterateElementViews(function(view,partType,index){if(view instanceof CompositionElementView){var partViews=view.getPartViews();partViews.forEach(function(partView,index2){checkAndUpdateElement(partView,view,index2)})}else checkAndUpdateElement(view,that,index)})},CaseWorldView.prototype.replacePartView=function(index,newPartView){var that=this,partView=that.elementViews.part[index];that.scene.remove(partView.getModel3D()),delete that.elementViews.part[index],that.elementViews.part[index]=newPartView,that.scene.add(newPartView.getModel3D())},CaseWorldView.prototype.getLoadedModelsCache=function(){return this.cache},CaseWorldView.prototype.getPartIdByCategory=function(category,on){var model,id,that=this;return on?that.elementViews[on].getPartViews().forEach(function(view){model=view.getModel(),model.category===category&&(id=model.id)}):that.iterateElementViews(function(view,partType){'part'===partType?(model=view.getModel(),model.category===category&&(id=model.id)):view.getPartViews().forEach(function(partView){model=partView.getModel(),model.category===category&&(id=model.id)})}),id||(id=that.getModel()._invisibleParts[category]),id},CaseWorldView.prototype.setInvisiblePart=function(category,partId){return this.getModel()._invisibleParts[category]=partId,this};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}

/***/ }),
/* 103 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor
    var TempCtor = function () {}
    TempCtor.prototype = superCtor.prototype
    ctor.prototype = new TempCtor()
    ctor.prototype.constructor = ctor
  }
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var utils=__webpack_require__(7),EventEmitter=__webpack_require__(27).EventEmitter,CaseWorldUserInteraction=module.exports=function(caseWorldView){this.caseWorldView=caseWorldView;var minCameraDistance=1e3;('HEAVY'===caseWorldView.model.variation||'PROFESSIONAL'===caseWorldView.model.variation)&&(minCameraDistance=1500),this.cameraControl=new THREE.OrbitControls(this.caseWorldView.getCamera(),this.caseWorldView.getDomElement(),null,minCameraDistance),this.setMaxListeners(0)};utils.inherits(CaseWorldUserInteraction,EventEmitter),CaseWorldUserInteraction.prototype.assignInteractions=function(){var that=this;that.changeCameraByMouse()},CaseWorldUserInteraction.prototype.changeCameraByMouse=function(){var that=this;that.cameraControl.autoRotate=!1},CaseWorldUserInteraction.prototype.updateCamera=function(delta){this.cameraControl.update(delta)},CaseWorldUserInteraction.prototype.updateCameraCenter=function(){var that=this,boundingBox=that._getSceneBoundingBox(),model=that.caseWorldView.getModel(),camera=that.caseWorldView.getCamera(),lookAtY=model._height/2+boundingBox.min.y-50;that.cameraControl.center.y=lookAtY,Detector.webgl||that.isCameraOnTopPosition()||(camera.position.y=lookAtY)},CaseWorldUserInteraction.prototype.positionCamera=function(delay,justPosition){function cameraShouldBeUpdated(viewHeight,viewLength,cameraStretch,heightStretch){var model=that.caseWorldView.getModel(),height=model._height,depth=model._depth,cameraOnTopPosition=that.isCameraOnTopPosition();return 1>cameraStretch&&1>heightStretch?viewHeight>height&&viewLength>depth&&!cameraOnTopPosition:!cameraOnTopPosition}var _Mathabs=Math.abs,_Mathtan=Math.tan,that=this;delay=delay||500,that.updateCameraCenter();var distanceToEdge=100,maxDistance=200,camera=that.caseWorldView.getCamera(),cameraCenter=that.cameraControl.center,angle=that.caseWorldView.FIELD_OF_VIEW/2;angle=2*angle*Math.PI/360;var cameraPosition=camera.position.clone(),distanceToLookAt=Math.sqrt(cameraPosition.distanceToSquared(that.cameraControl.center)),planeMinusX=-_Mathtan(angle)*distanceToLookAt,planePlusX=_Mathtan(angle)*distanceToLookAt,boundingBox=that._getSceneBoundingBox(),differentLeft=planePlusX-_Mathabs(boundingBox.min.x/2),differntRight=planePlusX-_Mathabs(boundingBox.max.x/2),newPlaneSize=0;newPlaneSize=differentLeft<differntRight?distanceToEdge+_Mathabs(planePlusX-differentLeft):distanceToEdge+_Mathabs(planePlusX-differntRight);var viewLength=2*newPlaneSize,viewHeight=that._calculateHeight(viewLength),newDistance=newPlaneSize/_Mathtan(angle),cameraStretch=newDistance/distanceToLookAt,newPosition=cameraPosition.clone().multiplyScalar(cameraStretch),highestY=cameraCenter.y+viewHeight/2,highestPoint=new THREE.Vector3(cameraCenter.x,highestY,cameraCenter.z),vectorToHighestPoint=highestPoint.clone().sub(newPosition.clone()),vectorToCenter=cameraCenter.clone().sub(newPosition.clone()),heightAngle=vectorToHighestPoint.angleTo(vectorToCenter),differenceTop=highestY-boundingBox.max.y,newHeight=distanceToEdge+boundingBox.max.y,newHeightDistance=newHeight/_Mathtan(heightAngle),heightStretch=1;return differenceTop<distanceToEdge&&(heightStretch=newHeightDistance/newDistance,newPosition=cameraPosition.clone().multiplyScalar(cameraStretch*heightStretch)),!0===justPosition?newPosition:void((differentLeft<distanceToEdge||differntRight<distanceToEdge||differentLeft>maxDistance||differntRight>maxDistance||differenceTop<distanceToEdge)&&cameraShouldBeUpdated(viewHeight,viewLength,cameraStretch,heightStretch)&&that.moveCameraTo(cameraPosition,newPosition,!1,delay))},CaseWorldUserInteraction.prototype.moveCameraTo=function(cameraPosition,position,returnTween,delay){var that=this,camera=that.caseWorldView.getCamera(),center=that.cameraControl.center;if(delay=delay||500,!Detector.webgl)return that.isCameraOnTopPosition(position)||(position.y=center.y),camera.position=position,camera.lookAt(center),void that.emit('cameraAnimationDone');var tween=new TWEEN.Tween({x:cameraPosition.x,y:cameraPosition.y,z:cameraPosition.z}).to({x:position.x,y:position.y,z:position.z},delay);return tween.easing(TWEEN.Easing.Quadratic.InOut),tween.onUpdate(function(){camera.position.set(this.x,this.y,this.z)}).onComplete(function(){that.emit('cameraAnimationDone')}),that.isCameraOnTopPosition(position)&&setTimeout(function(){that.emit('cameraAnimationDone')},delay),returnTween?tween:void tween.start()},CaseWorldUserInteraction.prototype._calculateHeight=function(viewLength){var that=this,aspectRation=that.caseWorldView.ASPECT_RATIO;return viewLength/aspectRation},CaseWorldUserInteraction.prototype._getSceneBoundingBox=function(){var that=this,scene=that.caseWorldView.getScene(),boundingBox=new THREE.BoundingBoxHelper(scene);return boundingBox.update(),boundingBox.box},CaseWorldUserInteraction.prototype.isCameraOnTopPosition=function(position){var _Mathabs2=Math.abs,that=this,camera=that.caseWorldView.getCamera(),x=camera.position.x,z=camera.position.z,tolerance=.01;return position&&(x=position.x,z=position.z),_Mathabs2(x)<tolerance&&_Mathabs2(z)<tolerance},CaseWorldUserInteraction.prototype.cameraFullRotation=function(startPoint,steps1){function getXCoordinate(angle,radius){return radius*Math.sin(angle)}function getZCoordinate(angle,radius){return radius*Math.cos(angle)}var _MathPI=Math.PI,that=this,camera=that.caseWorldView.getCamera(),cameraPosition=that.positionCamera(0,!0),initalAngle=cameraPosition.angleTo(new THREE.Vector3(0,0,1)),yPosition=cameraPosition.y,radius=cameraPosition.length(),rotationEnd=360+initalAngle*(180/_MathPI),radianStep=2*_MathPI/360,steps=initalAngle/radianStep,path=new THREE.Path([new THREE.Vector2(0,steps)]),startPoint=startPoint||50;path.bezierCurveTo(startPoint,0,0,rotationEnd,startPoint,rotationEnd);for(var steps1=steps1||200,points=path.getTransformedPoints(steps1),newPosition=new THREE.Vector3(getXCoordinate(initalAngle,radius),yPosition,getZCoordinate(initalAngle,radius)),initialTween=that.moveCameraTo(cameraPosition,newPosition,!0,1),rememberedPosition=newPosition.clone(),rememberedTween=initialTween,newTween=initialTween,index=1;steps<=rotationEnd&&index<points.length;){newPosition=new THREE.Vector3(getXCoordinate(steps*radianStep,radius),yPosition,getZCoordinate(steps*radianStep,radius)),newTween=that.moveCameraTo(rememberedPosition,newPosition,!0,2),rememberedTween.chain(newTween),rememberedTween=newTween,rememberedPosition=newPosition.clone();var fullRotationDistance=rotationEnd-steps,newStep=points[index].y;fullRotationDistance<1&&0<fullRotationDistance?steps+=fullRotationDistance:steps<newStep&&(steps=newStep),index++}rememberedTween.onComplete(function(){that.emit('fullCameraRotationDone')}),initialTween.start()},CaseWorldUserInteraction.prototype.tmpCameraFullRotation=function(speed){function getXCoordinate(angle,radius){return radius*Math.sin(angle)}function getZCoordinate(angle,radius){return radius*Math.cos(angle)}var _MathPI2=Math.PI,that=this,camera=that.caseWorldView.getCamera(),cameraPosition=camera.position,initalAngle=cameraPosition.angleTo(new THREE.Vector3(0,0,1)),yPosition=cameraPosition.y,radius=cameraPosition.length(),rotationEnd=720+initalAngle*(180/_MathPI2),radianStep=2*_MathPI2/360,steps=initalAngle/radianStep,newPosition=new THREE.Vector3(getXCoordinate(initalAngle,radius),yPosition,getZCoordinate(initalAngle,radius)),initialTween=that.moveCameraTo(cameraPosition,newPosition,!0,1),rememberedPosition=newPosition.clone(),rememberedTween=initialTween,newTween=initialTween,index=200;for(speed=speed||2;steps<=rotationEnd;){newPosition=new THREE.Vector3(getXCoordinate(steps*radianStep,radius),yPosition,getZCoordinate(steps*radianStep,radius)),newTween=that.moveCameraTo(rememberedPosition,newPosition,!0,2),rememberedTween.chain(newTween),rememberedTween=newTween,rememberedPosition=newPosition.clone();var fullRotationDistance=rotationEnd-steps;fullRotationDistance<6&&0<fullRotationDistance?steps+=fullRotationDistance:(steps+=speed,index++)}rememberedTween.onComplete(function(){that.emit('fullCameraRotationDone')}),initialTween.start()};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
window.TWEEN=function(){var a=[];return{REVISION:"10",getAll:function getAll(){return a},removeAll:function removeAll(){a=[]},add:function add(c){a.push(c)},remove:function remove(c){c=a.indexOf(c),-1!==c&&a.splice(c,1)},update:function update(c){if(0===a.length)return!1;for(var b=0,d=a.length,c=void 0===c?void 0!==window.performance&&void 0!==window.performance.now?window.performance.now():Date.now():c;b<d;)a[b].update(c)?b++:(a.splice(b,1),d--);return!0}}}(),TWEEN.Tween=function(a){var j,c={},b={},d={},e=1E3,g=0,i=0,k=null,u=TWEEN.Easing.Linear.None,v=TWEEN.Interpolation.Linear,p=[],q=null,r=!1,s=null,t=null;for(j in a)c[j]=parseFloat(a[j],10);this.to=function(a,c){return void 0!==c&&(e=c),b=a,this},this.start=function(e){for(var f in TWEEN.add(this),r=!1,k=void 0===e?void 0!==window.performance&&void 0!==window.performance.now?window.performance.now():Date.now():e,k+=i,b){if(b[f]instanceof Array){if(0===b[f].length)continue;b[f]=[a[f]].concat(b[f])}c[f]=a[f],!1==c[f]instanceof Array&&(c[f]*=1),d[f]=c[f]||0}return this},this.stop=function(){return TWEEN.remove(this),this},this.delay=function(a){return i=a,this},this.repeat=function(a){return g=a,this},this.easing=function(a){return u=a,this},this.interpolation=function(a){return v=a,this},this.chain=function(){return p=arguments,this},this.onStart=function(a){return q=a,this},this.onUpdate=function(a){return s=a,this},this.onComplete=function(a){return t=a,this},this.update=function(n){if(n<k)return!0;!1==r&&(null!==q&&q.call(a),r=!0);var h,f=(n-k)/e,f=1<f?1:f,m=u(f);for(h in b){var j=c[h]||0,l=b[h];l instanceof Array?a[h]=v(l,m):("string"==typeof l&&(l=j+parseFloat(l,10)),a[h]=j+(l-j)*m)}if(null!==s&&s.call(a,m),1==f)if(0<g){for(h in isFinite(g)&&g--,d)"string"==typeof b[h]&&(d[h]+=parseFloat(b[h],10)),c[h]=d[h];k=n+i}else{for(null!==t&&t.call(a),f=0,m=p.length;f<m;f++)p[f].start(n);return!1}return!0}},TWEEN.Easing={Linear:{None:function None(a){return a}},Quadratic:{In:function In(a){return a*a},Out:function Out(a){return a*(2-a)},InOut:function InOut(a){return 1>(a*=2)?.5*a*a:-.5*(--a*(a-2)-1)}},Cubic:{In:function In(a){return a*a*a},Out:function Out(a){return--a*a*a+1},InOut:function InOut(a){return 1>(a*=2)?.5*a*a*a:.5*((a-=2)*a*a+2)}},Quartic:{In:function In(a){return a*a*a*a},Out:function Out(a){return 1- --a*a*a*a},InOut:function InOut(a){return 1>(a*=2)?.5*a*a*a*a:-.5*((a-=2)*a*a*a-2)}},Quintic:{In:function In(a){return a*a*a*a*a},Out:function Out(a){return--a*a*a*a*a+1},InOut:function InOut(a){return 1>(a*=2)?.5*a*a*a*a*a:.5*((a-=2)*a*a*a*a+2)}},Sinusoidal:{In:function In(a){return 1-Math.cos(a*Math.PI/2)},Out:function Out(a){return Math.sin(a*Math.PI/2)},InOut:function InOut(a){return .5*(1-Math.cos(Math.PI*a))}},Exponential:{In:function In(a){return 0===a?0:Math.pow(1024,a-1)},Out:function Out(a){return 1===a?1:1-Math.pow(2,-10*a)},InOut:function InOut(a){var _Mathpow=Math.pow;return 0===a?0:1===a?1:1>(a*=2)?.5*_Mathpow(1024,a-1):.5*(-_Mathpow(2,-10*(a-1))+2)}},Circular:{In:function In(a){return 1-Math.sqrt(1-a*a)},Out:function Out(a){return Math.sqrt(1- --a*a)},InOut:function InOut(a){var _Mathsqrt=Math.sqrt;return 1>(a*=2)?-.5*(_Mathsqrt(1-a*a)-1):.5*(_Mathsqrt(1-(a-=2)*a)+1)}},Elastic:{In:function In(a){var c,_MathPI=Math.PI,b=.1;return 0===a?0:1===a?1:(!b||1>b?(b=1,c=.1):c=.4*Math.asin(1/b)/(2*_MathPI),-(b*Math.pow(2,10*(a-=1))*Math.sin(2*(a-c)*_MathPI/.4)))},Out:function Out(a){var c,_MathPI2=Math.PI,b=.1;return 0===a?0:1===a?1:(!b||1>b?(b=1,c=.1):c=.4*Math.asin(1/b)/(2*_MathPI2),b*Math.pow(2,-10*a)*Math.sin(2*(a-c)*_MathPI2/.4)+1)},InOut:function InOut(a){var c,_Mathpow2=Math.pow,_Mathsin=Math.sin,_MathPI3=Math.PI,b=.1;return 0===a?0:1===a?1:(!b||1>b?(b=1,c=.1):c=.4*Math.asin(1/b)/(2*_MathPI3),1>(a*=2)?-.5*b*_Mathpow2(2,10*(a-=1))*_Mathsin(2*(a-c)*_MathPI3/.4):.5*b*_Mathpow2(2,-10*(a-=1))*_Mathsin(2*(a-c)*_MathPI3/.4)+1)}},Back:{In:function In(a){return a*a*(2.70158*a-1.70158)},Out:function Out(a){return--a*a*(2.70158*a+1.70158)+1},InOut:function InOut(a){return 1>(a*=2)?.5*a*a*(3.5949095*a-2.5949095):.5*((a-=2)*a*(3.5949095*a+2.5949095)+2)}},Bounce:{In:function In(a){return 1-TWEEN.Easing.Bounce.Out(1-a)},Out:function Out(a){return a<1/2.75?7.5625*a*a:a<2/2.75?7.5625*(a-=1.5/2.75)*a+.75:a<2.5/2.75?7.5625*(a-=2.25/2.75)*a+.9375:7.5625*(a-=2.625/2.75)*a+.984375},InOut:function InOut(a){return .5>a?.5*TWEEN.Easing.Bounce.In(2*a):.5*TWEEN.Easing.Bounce.Out(2*a-1)+.5}}},TWEEN.Interpolation={Linear:function Linear(a,c){var b=a.length-1,d=b*c,e=Math.floor(d),g=TWEEN.Interpolation.Utils.Linear;return 0>c?g(a[0],a[1],d):1<c?g(a[b],a[b-1],b-d):g(a[e],a[e+1>b?b:e+1],d-e)},Bezier:function Bezier(a,c){var i,b=0,d=a.length-1,e=Math.pow,g=TWEEN.Interpolation.Utils.Bernstein;for(i=0;i<=d;i++)b+=e(1-c,d-i)*e(c,i)*a[i]*g(d,i);return b},CatmullRom:function CatmullRom(a,c){var _Mathfloor=Math.floor,b=a.length-1,d=b*c,e=_Mathfloor(d),g=TWEEN.Interpolation.Utils.CatmullRom;return a[0]===a[b]?(0>c&&(e=_Mathfloor(d=b*(1+c))),g(a[(e-1+b)%b],a[e],a[(e+1)%b],a[(e+2)%b],d-e)):0>c?a[0]-(g(a[0],a[0],a[1],a[1],-d)-a[0]):1<c?a[b]-(g(a[b],a[b],a[b-1],a[b-1],d-b)-a[b]):g(a[e?e-1:0],a[e],a[b<e+1?b:e+1],a[b<e+2?b:e+2],d-e)},Utils:{Linear:function Linear(a,c,b){return(c-a)*b+a},Bernstein:function Bernstein(a,c){var b=TWEEN.Interpolation.Utils.Factorial;return b(a)/b(c)/b(a-c)},Factorial:function(){var a=[1];return function(c){var d,b=1;if(a[c])return a[c];for(d=c;1<d;d--)b*=d;return a[c]=b}}(),CatmullRom:function CatmullRom(a,c,b,d,e){var a=.5*(b-a),d=.5*(d-c),g=e*e;return(2*c-2*b+a+d)*e*g+(-3*c+3*b-2*a-d)*g+a*e+c}}};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["Hammer"] = __webpack_require__(107);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(54)))

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj};(function(window,document,exportName){'use strict';function setTimeoutContext(fn,timeout,context){return setTimeout(bindFn(fn,context),timeout)}function invokeArrayArg(arg,fn,context){return!!Array.isArray(arg)&&(each(arg,context[fn],context),!0)}function each(obj,iterator,context){if(obj)if(obj.forEach)obj.forEach(iterator,context);else if(void 0!==obj.length)for(i=0;i<obj.length;)iterator.call(context,obj[i],i,obj),i++;else for(var i in obj)obj.hasOwnProperty(i)&&iterator.call(context,obj[i],i,obj)}function extend(dest,src,merge){for(var keys=Object.keys(src),i=0;i<keys.length;)(!merge||merge&&void 0===dest[keys[i]])&&(dest[keys[i]]=src[keys[i]]),i++;return dest}function merge(dest,src){return extend(dest,src,!0)}function inherit(child,base,properties){var childP,baseP=base.prototype;childP=child.prototype=Object.create(baseP),childP.constructor=child,childP._super=baseP,properties&&extend(childP,properties)}function bindFn(fn,context){return function(){return fn.apply(context,arguments)}}function boolOrFn(val,args){return('undefined'==typeof val?'undefined':_typeof(val))==TYPE_FUNCTION?val.apply(args?args[0]||void 0:void 0,args):val}function ifUndefined(val1,val2){return val1===void 0?val2:val1}function addEventListeners(target,types,handler){each(splitStr(types),function(type){target.addEventListener(type,handler,!1)})}function removeEventListeners(target,types,handler){each(splitStr(types),function(type){target.removeEventListener(type,handler,!1)})}function hasParent(node,parent){for(;node;){if(node==parent)return!0;node=node.parentNode}return!1}function inStr(str,find){return-1<str.indexOf(find)}function splitStr(str){return str.trim().split(/\s+/g)}function inArray(src,find,findByKey){if(src.indexOf&&!findByKey)return src.indexOf(find);for(var i=0;i<src.length;){if(findByKey&&src[i][findByKey]==find||!findByKey&&src[i]===find)return i;i++}return-1}function toArray(obj){return Array.prototype.slice.call(obj,0)}function uniqueArray(src,key,sort){for(var val,results=[],values=[],i=0;i<src.length;)val=key?src[i][key]:src[i],0>inArray(values,val)&&results.push(src[i]),values[i]=val,i++;return sort&&(key?results=results.sort(function(a,b){return a[key]>b[key]}):results=results.sort()),results}function prefixed(obj,property){for(var prefix,prop,camelProp=property[0].toUpperCase()+property.slice(1),i=0;i<VENDOR_PREFIXES.length;){if(prefix=VENDOR_PREFIXES[i],prop=prefix?prefix+camelProp:property,prop in obj)return prop;i++}return void 0}function uniqueId(){return _uniqueId++}function getWindowForElement(element){var doc=element.ownerDocument;return doc.defaultView||doc.parentWindow}function Input(manager,callback){var self=this;this.manager=manager,this.callback=callback,this.element=manager.element,this.target=manager.options.inputTarget,this.domHandler=function(ev){boolOrFn(manager.options.enable,[manager])&&self.handler(ev)},this.init()}function createInputInstance(manager){var Type,inputClass=manager.options.inputClass;return Type=inputClass?inputClass:SUPPORT_POINTER_EVENTS?PointerEventInput:SUPPORT_ONLY_TOUCH?TouchInput:SUPPORT_TOUCH?TouchMouseInput:MouseInput,new Type(manager,inputHandler)}function inputHandler(manager,eventType,input){var pointersLen=input.pointers.length,changedPointersLen=input.changedPointers.length,isFirst=eventType&INPUT_START&&0==pointersLen-changedPointersLen;input.isFirst=!!isFirst,input.isFinal=!!(eventType&(INPUT_END|INPUT_CANCEL)&&0==pointersLen-changedPointersLen),isFirst&&(manager.session={}),input.eventType=eventType,computeInputData(manager,input),manager.emit('hammer.input',input),manager.recognize(input),manager.session.prevInput=input}function computeInputData(manager,input){var session=manager.session,pointers=input.pointers,pointersLength=pointers.length;session.firstInput||(session.firstInput=simpleCloneInputData(input)),1<pointersLength&&!session.firstMultiple?session.firstMultiple=simpleCloneInputData(input):1===pointersLength&&(session.firstMultiple=!1);var firstInput=session.firstInput,firstMultiple=session.firstMultiple,offsetCenter=firstMultiple?firstMultiple.center:firstInput.center,center=input.center=getCenter(pointers);input.timeStamp=now(),input.deltaTime=input.timeStamp-firstInput.timeStamp,input.angle=getAngle(offsetCenter,center),input.distance=getDistance(offsetCenter,center),computeDeltaXY(session,input),input.offsetDirection=getDirection(input.deltaX,input.deltaY),input.scale=firstMultiple?getScale(firstMultiple.pointers,pointers):1,input.rotation=firstMultiple?getRotation(firstMultiple.pointers,pointers):0,computeIntervalInputData(session,input);var target=manager.element;hasParent(input.srcEvent.target,target)&&(target=input.srcEvent.target),input.target=target}function computeDeltaXY(session,input){var center=input.center,offset=session.offsetDelta||{},prevDelta=session.prevDelta||{},prevInput=session.prevInput||{};(input.eventType===INPUT_START||prevInput.eventType===INPUT_END)&&(prevDelta=session.prevDelta={x:prevInput.deltaX||0,y:prevInput.deltaY||0},offset=session.offsetDelta={x:center.x,y:center.y}),input.deltaX=prevDelta.x+(center.x-offset.x),input.deltaY=prevDelta.y+(center.y-offset.y)}function computeIntervalInputData(session,input){var velocity,velocityX,velocityY,direction,last=session.lastInterval||input,deltaTime=input.timeStamp-last.timeStamp;if(input.eventType!=INPUT_CANCEL&&(deltaTime>COMPUTE_INTERVAL||last.velocity===void 0)){var deltaX=last.deltaX-input.deltaX,deltaY=last.deltaY-input.deltaY,v=getVelocity(deltaTime,deltaX,deltaY);velocityX=v.x,velocityY=v.y,velocity=abs(v.x)>abs(v.y)?v.x:v.y,direction=getDirection(deltaX,deltaY),session.lastInterval=input}else velocity=last.velocity,velocityX=last.velocityX,velocityY=last.velocityY,direction=last.direction;input.velocity=velocity,input.velocityX=velocityX,input.velocityY=velocityY,input.direction=direction}function simpleCloneInputData(input){for(var pointers=[],i=0;i<input.pointers.length;)pointers[i]={clientX:round(input.pointers[i].clientX),clientY:round(input.pointers[i].clientY)},i++;return{timeStamp:now(),pointers:pointers,center:getCenter(pointers),deltaX:input.deltaX,deltaY:input.deltaY}}function getCenter(pointers){var pointersLength=pointers.length;if(1===pointersLength)return{x:round(pointers[0].clientX),y:round(pointers[0].clientY)};for(var x=0,y=0,i=0;i<pointersLength;)x+=pointers[i].clientX,y+=pointers[i].clientY,i++;return{x:round(x/pointersLength),y:round(y/pointersLength)}}function getVelocity(deltaTime,x,y){return{x:x/deltaTime||0,y:y/deltaTime||0}}function getDirection(x,y){return x===y?DIRECTION_NONE:abs(x)>=abs(y)?0<x?DIRECTION_LEFT:DIRECTION_RIGHT:0<y?DIRECTION_UP:DIRECTION_DOWN}function getDistance(p1,p2,props){props||(props=PROPS_XY);var x=p2[props[0]]-p1[props[0]],y=p2[props[1]]-p1[props[1]];return Math.sqrt(x*x+y*y)}function getAngle(p1,p2,props){props||(props=PROPS_XY);var x=p2[props[0]]-p1[props[0]],y=p2[props[1]]-p1[props[1]];return 180*Math.atan2(y,x)/Math.PI}function getRotation(start,end){return getAngle(end[1],end[0],PROPS_CLIENT_XY)-getAngle(start[1],start[0],PROPS_CLIENT_XY)}function getScale(start,end){return getDistance(end[0],end[1],PROPS_CLIENT_XY)/getDistance(start[0],start[1],PROPS_CLIENT_XY)}function MouseInput(){this.evEl=MOUSE_ELEMENT_EVENTS,this.evWin=MOUSE_WINDOW_EVENTS,this.allow=!0,this.pressed=!1,Input.apply(this,arguments)}function PointerEventInput(){this.evEl=POINTER_ELEMENT_EVENTS,this.evWin=POINTER_WINDOW_EVENTS,Input.apply(this,arguments),this.store=this.manager.session.pointerEvents=[]}function SingleTouchInput(){this.evTarget=SINGLE_TOUCH_TARGET_EVENTS,this.evWin=SINGLE_TOUCH_WINDOW_EVENTS,this.started=!1,Input.apply(this,arguments)}function normalizeSingleTouches(ev,type){var all=toArray(ev.touches),changed=toArray(ev.changedTouches);return type&(INPUT_END|INPUT_CANCEL)&&(all=uniqueArray(all.concat(changed),'identifier',!0)),[all,changed]}function TouchInput(){this.evTarget=TOUCH_TARGET_EVENTS,this.targetIds={},Input.apply(this,arguments)}function getTouches(ev,type){var allTouches=toArray(ev.touches),targetIds=this.targetIds;if(type&(INPUT_START|INPUT_MOVE)&&1===allTouches.length)return targetIds[allTouches[0].identifier]=!0,[allTouches,allTouches];var i,targetTouches,changedTouches=toArray(ev.changedTouches),changedTargetTouches=[],target=this.target;if(targetTouches=allTouches.filter(function(touch){return hasParent(touch.target,target)}),type===INPUT_START)for(i=0;i<targetTouches.length;)targetIds[targetTouches[i].identifier]=!0,i++;for(i=0;i<changedTouches.length;)targetIds[changedTouches[i].identifier]&&changedTargetTouches.push(changedTouches[i]),type&(INPUT_END|INPUT_CANCEL)&&delete targetIds[changedTouches[i].identifier],i++;return changedTargetTouches.length?[uniqueArray(targetTouches.concat(changedTargetTouches),'identifier',!0),changedTargetTouches]:void 0}function TouchMouseInput(){Input.apply(this,arguments);var handler=bindFn(this.handler,this);this.touch=new TouchInput(this.manager,handler),this.mouse=new MouseInput(this.manager,handler)}function TouchAction(manager,value){this.manager=manager,this.set(value)}function cleanTouchActions(actions){if(inStr(actions,TOUCH_ACTION_NONE))return TOUCH_ACTION_NONE;var hasPanX=inStr(actions,TOUCH_ACTION_PAN_X),hasPanY=inStr(actions,TOUCH_ACTION_PAN_Y);return hasPanX&&hasPanY?TOUCH_ACTION_PAN_X+' '+TOUCH_ACTION_PAN_Y:hasPanX||hasPanY?hasPanX?TOUCH_ACTION_PAN_X:TOUCH_ACTION_PAN_Y:inStr(actions,TOUCH_ACTION_MANIPULATION)?TOUCH_ACTION_MANIPULATION:TOUCH_ACTION_AUTO}function Recognizer(options){this.id=uniqueId(),this.manager=null,this.options=merge(options||{},this.defaults),this.options.enable=ifUndefined(this.options.enable,!0),this.state=STATE_POSSIBLE,this.simultaneous={},this.requireFail=[]}function stateStr(state){if(state&STATE_CANCELLED)return'cancel';return state&STATE_ENDED?'end':state&STATE_CHANGED?'move':state&STATE_BEGAN?'start':''}function directionStr(direction){if(direction==DIRECTION_DOWN)return'down';return direction==DIRECTION_UP?'up':direction==DIRECTION_LEFT?'left':direction==DIRECTION_RIGHT?'right':''}function getRecognizerByNameIfManager(otherRecognizer,recognizer){var manager=recognizer.manager;return manager?manager.get(otherRecognizer):otherRecognizer}function AttrRecognizer(){Recognizer.apply(this,arguments)}function PanRecognizer(){AttrRecognizer.apply(this,arguments),this.pX=null,this.pY=null}function PinchRecognizer(){AttrRecognizer.apply(this,arguments)}function PressRecognizer(){Recognizer.apply(this,arguments),this._timer=null,this._input=null}function RotateRecognizer(){AttrRecognizer.apply(this,arguments)}function SwipeRecognizer(){AttrRecognizer.apply(this,arguments)}function TapRecognizer(){Recognizer.apply(this,arguments),this.pTime=!1,this.pCenter=!1,this._timer=null,this._input=null,this.count=0}function Hammer(element,options){return options=options||{},options.recognizers=ifUndefined(options.recognizers,Hammer.defaults.preset),new Manager(element,options)}function Manager(element,options){options=options||{},this.options=merge(options,Hammer.defaults),this.options.inputTarget=this.options.inputTarget||element,this.handlers={},this.session={},this.recognizers=[],this.element=element,this.input=createInputInstance(this),this.touchAction=new TouchAction(this,this.options.touchAction),toggleCssProps(this,!0),each(options.recognizers,function(item){var recognizer=this.add(new item[0](item[1]));item[2]&&recognizer.recognizeWith(item[2]),item[3]&&recognizer.requireFailure(item[3])},this)}function toggleCssProps(manager,add){var element=manager.element;each(manager.options.cssProps,function(value,name){element.style[prefixed(element.style,name)]=add?value:''})}function triggerDomEvent(event,data){var gestureEvent=document.createEvent('Event');gestureEvent.initEvent(event,!0,!0),gestureEvent.gesture=data,data.target.dispatchEvent(gestureEvent)}var _Mathabs=Math.abs,VENDOR_PREFIXES=['','webkit','moz','MS','ms','o'],TEST_ELEMENT=document.createElement('div'),TYPE_FUNCTION='function',round=Math.round,abs=_Mathabs,now=Date.now,_uniqueId=1,MOBILE_REGEX=/mobile|tablet|ip(ad|hone|od)|android/i,SUPPORT_TOUCH='ontouchstart'in window,SUPPORT_POINTER_EVENTS=void 0!==prefixed(window,'PointerEvent'),SUPPORT_ONLY_TOUCH=SUPPORT_TOUCH&&MOBILE_REGEX.test(navigator.userAgent),INPUT_TYPE_TOUCH='touch',INPUT_TYPE_MOUSE='mouse',COMPUTE_INTERVAL=25,INPUT_START=1,INPUT_MOVE=2,INPUT_END=4,INPUT_CANCEL=8,DIRECTION_NONE=1,DIRECTION_LEFT=2,DIRECTION_RIGHT=4,DIRECTION_UP=8,DIRECTION_DOWN=16,DIRECTION_HORIZONTAL=DIRECTION_LEFT|DIRECTION_RIGHT,DIRECTION_VERTICAL=DIRECTION_UP|DIRECTION_DOWN,DIRECTION_ALL=DIRECTION_HORIZONTAL|DIRECTION_VERTICAL,PROPS_XY=['x','y'],PROPS_CLIENT_XY=['clientX','clientY'];Input.prototype={handler:function handler(){},init:function init(){this.evEl&&addEventListeners(this.element,this.evEl,this.domHandler),this.evTarget&&addEventListeners(this.target,this.evTarget,this.domHandler),this.evWin&&addEventListeners(getWindowForElement(this.element),this.evWin,this.domHandler)},destroy:function destroy(){this.evEl&&removeEventListeners(this.element,this.evEl,this.domHandler),this.evTarget&&removeEventListeners(this.target,this.evTarget,this.domHandler),this.evWin&&removeEventListeners(getWindowForElement(this.element),this.evWin,this.domHandler)}};var MOUSE_INPUT_MAP={mousedown:INPUT_START,mousemove:INPUT_MOVE,mouseup:INPUT_END},MOUSE_ELEMENT_EVENTS='mousedown',MOUSE_WINDOW_EVENTS='mousemove mouseup';inherit(MouseInput,Input,{handler:function(ev){var eventType=MOUSE_INPUT_MAP[ev.type];eventType&INPUT_START&&0===ev.button&&(this.pressed=!0),eventType&INPUT_MOVE&&1!==ev.which&&(eventType=INPUT_END);this.pressed&&this.allow&&(eventType&INPUT_END&&(this.pressed=!1),this.callback(this.manager,eventType,{pointers:[ev],changedPointers:[ev],pointerType:INPUT_TYPE_MOUSE,srcEvent:ev}))}});var POINTER_INPUT_MAP={pointerdown:INPUT_START,pointermove:INPUT_MOVE,pointerup:INPUT_END,pointercancel:INPUT_CANCEL,pointerout:INPUT_CANCEL},IE10_POINTER_TYPE_ENUM={2:INPUT_TYPE_TOUCH,3:'pen',4:INPUT_TYPE_MOUSE,5:'kinect'},POINTER_ELEMENT_EVENTS='pointerdown',POINTER_WINDOW_EVENTS='pointermove pointerup pointercancel';window.MSPointerEvent&&(POINTER_ELEMENT_EVENTS='MSPointerDown',POINTER_WINDOW_EVENTS='MSPointerMove MSPointerUp MSPointerCancel'),inherit(PointerEventInput,Input,{handler:function(ev){var store=this.store,removePointer=!1,eventTypeNormalized=ev.type.toLowerCase().replace('ms',''),eventType=POINTER_INPUT_MAP[eventTypeNormalized],pointerType=IE10_POINTER_TYPE_ENUM[ev.pointerType]||ev.pointerType,storeIndex=inArray(store,ev.pointerId,'pointerId');eventType&INPUT_START&&(0===ev.button||pointerType==INPUT_TYPE_TOUCH)?0>storeIndex&&(store.push(ev),storeIndex=store.length-1):eventType&(INPUT_END|INPUT_CANCEL)&&(removePointer=!0);0>storeIndex||(store[storeIndex]=ev,this.callback(this.manager,eventType,{pointers:store,changedPointers:[ev],pointerType:pointerType,srcEvent:ev}),removePointer&&store.splice(storeIndex,1))}});var SINGLE_TOUCH_INPUT_MAP={touchstart:INPUT_START,touchmove:INPUT_MOVE,touchend:INPUT_END,touchcancel:INPUT_CANCEL},SINGLE_TOUCH_TARGET_EVENTS='touchstart',SINGLE_TOUCH_WINDOW_EVENTS='touchstart touchmove touchend touchcancel';inherit(SingleTouchInput,Input,{handler:function(ev){var type=SINGLE_TOUCH_INPUT_MAP[ev.type];if(type===INPUT_START&&(this.started=!0),!!this.started){var touches=normalizeSingleTouches.call(this,ev,type);type&(INPUT_END|INPUT_CANCEL)&&0==touches[0].length-touches[1].length&&(this.started=!1),this.callback(this.manager,type,{pointers:touches[0],changedPointers:touches[1],pointerType:INPUT_TYPE_TOUCH,srcEvent:ev})}}});var TOUCH_INPUT_MAP={touchstart:INPUT_START,touchmove:INPUT_MOVE,touchend:INPUT_END,touchcancel:INPUT_CANCEL},TOUCH_TARGET_EVENTS='touchstart touchmove touchend touchcancel';inherit(TouchInput,Input,{handler:function(ev){var type=TOUCH_INPUT_MAP[ev.type],touches=getTouches.call(this,ev,type);touches&&this.callback(this.manager,type,{pointers:touches[0],changedPointers:touches[1],pointerType:INPUT_TYPE_TOUCH,srcEvent:ev})}}),inherit(TouchMouseInput,Input,{handler:function(manager,inputEvent,inputData){var isTouch=inputData.pointerType==INPUT_TYPE_TOUCH,isMouse=inputData.pointerType==INPUT_TYPE_MOUSE;if(isTouch)this.mouse.allow=!1;else if(isMouse&&!this.mouse.allow)return;inputEvent&(INPUT_END|INPUT_CANCEL)&&(this.mouse.allow=!0),this.callback(manager,inputEvent,inputData)},destroy:function(){this.touch.destroy(),this.mouse.destroy()}});var PREFIXED_TOUCH_ACTION=prefixed(TEST_ELEMENT.style,'touchAction'),NATIVE_TOUCH_ACTION=PREFIXED_TOUCH_ACTION!==void 0,TOUCH_ACTION_COMPUTE='compute',TOUCH_ACTION_AUTO='auto',TOUCH_ACTION_MANIPULATION='manipulation',TOUCH_ACTION_NONE='none',TOUCH_ACTION_PAN_X='pan-x',TOUCH_ACTION_PAN_Y='pan-y';TouchAction.prototype={set:function set(value){value==TOUCH_ACTION_COMPUTE&&(value=this.compute()),NATIVE_TOUCH_ACTION&&(this.manager.element.style[PREFIXED_TOUCH_ACTION]=value),this.actions=value.toLowerCase().trim()},update:function update(){this.set(this.manager.options.touchAction)},compute:function compute(){var actions=[];return each(this.manager.recognizers,function(recognizer){boolOrFn(recognizer.options.enable,[recognizer])&&(actions=actions.concat(recognizer.getTouchAction()))}),cleanTouchActions(actions.join(' '))},preventDefaults:function preventDefaults(input){if(!NATIVE_TOUCH_ACTION){var srcEvent=input.srcEvent,direction=input.offsetDirection;if(this.manager.session.prevented)return void srcEvent.preventDefault();var actions=this.actions,hasNone=inStr(actions,TOUCH_ACTION_NONE),hasPanY=inStr(actions,TOUCH_ACTION_PAN_Y),hasPanX=inStr(actions,TOUCH_ACTION_PAN_X);if(hasNone||hasPanY&&direction&DIRECTION_HORIZONTAL||hasPanX&&direction&DIRECTION_VERTICAL)return this.preventSrc(srcEvent)}},preventSrc:function preventSrc(srcEvent){this.manager.session.prevented=!0,srcEvent.preventDefault()}};var STATE_POSSIBLE=1,STATE_BEGAN=2,STATE_CHANGED=4,STATE_ENDED=8,STATE_RECOGNIZED=STATE_ENDED,STATE_CANCELLED=16,STATE_FAILED=32;Recognizer.prototype={defaults:{},set:function set(options){return extend(this.options,options),this.manager&&this.manager.touchAction.update(),this},recognizeWith:function recognizeWith(otherRecognizer){if(invokeArrayArg(otherRecognizer,'recognizeWith',this))return this;var simultaneous=this.simultaneous;return otherRecognizer=getRecognizerByNameIfManager(otherRecognizer,this),simultaneous[otherRecognizer.id]||(simultaneous[otherRecognizer.id]=otherRecognizer,otherRecognizer.recognizeWith(this)),this},dropRecognizeWith:function dropRecognizeWith(otherRecognizer){return invokeArrayArg(otherRecognizer,'dropRecognizeWith',this)?this:(otherRecognizer=getRecognizerByNameIfManager(otherRecognizer,this),delete this.simultaneous[otherRecognizer.id],this)},requireFailure:function requireFailure(otherRecognizer){if(invokeArrayArg(otherRecognizer,'requireFailure',this))return this;var requireFail=this.requireFail;return otherRecognizer=getRecognizerByNameIfManager(otherRecognizer,this),-1===inArray(requireFail,otherRecognizer)&&(requireFail.push(otherRecognizer),otherRecognizer.requireFailure(this)),this},dropRequireFailure:function dropRequireFailure(otherRecognizer){if(invokeArrayArg(otherRecognizer,'dropRequireFailure',this))return this;otherRecognizer=getRecognizerByNameIfManager(otherRecognizer,this);var index=inArray(this.requireFail,otherRecognizer);return-1<index&&this.requireFail.splice(index,1),this},hasRequireFailures:function hasRequireFailures(){return 0<this.requireFail.length},canRecognizeWith:function canRecognizeWith(otherRecognizer){return!!this.simultaneous[otherRecognizer.id]},emit:function(input){function emit(withState){self.manager.emit(self.options.event+(withState?stateStr(state):''),input)}var self=this,state=this.state;state<STATE_ENDED&&emit(!0),emit(),state>=STATE_ENDED&&emit(!0)},tryEmit:function tryEmit(input){return this.canEmit()?this.emit(input):void(this.state=STATE_FAILED)},canEmit:function canEmit(){for(var i=0;i<this.requireFail.length;){if(!(this.requireFail[i].state&(STATE_FAILED|STATE_POSSIBLE)))return!1;i++}return!0},recognize:function recognize(inputData){var inputDataClone=extend({},inputData);return boolOrFn(this.options.enable,[this,inputDataClone])?void(this.state&(STATE_RECOGNIZED|STATE_CANCELLED|STATE_FAILED)&&(this.state=STATE_POSSIBLE),this.state=this.process(inputDataClone),this.state&(STATE_BEGAN|STATE_CHANGED|STATE_ENDED|STATE_CANCELLED)&&this.tryEmit(inputDataClone)):(this.reset(),void(this.state=STATE_FAILED))},process:function process(){},getTouchAction:function getTouchAction(){},reset:function reset(){}},inherit(AttrRecognizer,Recognizer,{defaults:{pointers:1},attrTest:function attrTest(input){var optionPointers=this.options.pointers;return 0===optionPointers||input.pointers.length===optionPointers},process:function process(input){var state=this.state,eventType=input.eventType,isRecognized=state&(STATE_BEGAN|STATE_CHANGED),isValid=this.attrTest(input);if(isRecognized&&(eventType&INPUT_CANCEL||!isValid))return state|STATE_CANCELLED;return isRecognized||isValid?eventType&INPUT_END?state|STATE_ENDED:state&STATE_BEGAN?state|STATE_CHANGED:STATE_BEGAN:STATE_FAILED}}),inherit(PanRecognizer,AttrRecognizer,{defaults:{event:'pan',threshold:10,pointers:1,direction:DIRECTION_ALL},getTouchAction:function getTouchAction(){var direction=this.options.direction,actions=[];return direction&DIRECTION_HORIZONTAL&&actions.push(TOUCH_ACTION_PAN_Y),direction&DIRECTION_VERTICAL&&actions.push(TOUCH_ACTION_PAN_X),actions},directionTest:function directionTest(input){var options=this.options,hasMoved=!0,distance=input.distance,direction=input.direction,x=input.deltaX,y=input.deltaY;return direction&options.direction||(options.direction&DIRECTION_HORIZONTAL?(direction=0===x?DIRECTION_NONE:0>x?DIRECTION_LEFT:DIRECTION_RIGHT,hasMoved=x!=this.pX,distance=_Mathabs(input.deltaX)):(direction=0===y?DIRECTION_NONE:0>y?DIRECTION_UP:DIRECTION_DOWN,hasMoved=y!=this.pY,distance=_Mathabs(input.deltaY))),input.direction=direction,hasMoved&&distance>options.threshold&&direction&options.direction},attrTest:function attrTest(input){return AttrRecognizer.prototype.attrTest.call(this,input)&&(this.state&STATE_BEGAN||!(this.state&STATE_BEGAN)&&this.directionTest(input))},emit:function emit(input){this.pX=input.deltaX,this.pY=input.deltaY;var direction=directionStr(input.direction);direction&&this.manager.emit(this.options.event+direction,input),this._super.emit.call(this,input)}}),inherit(PinchRecognizer,AttrRecognizer,{defaults:{event:'pinch',threshold:0,pointers:2},getTouchAction:function getTouchAction(){return[TOUCH_ACTION_NONE]},attrTest:function attrTest(input){return this._super.attrTest.call(this,input)&&(_Mathabs(input.scale-1)>this.options.threshold||this.state&STATE_BEGAN)},emit:function emit(input){if(this._super.emit.call(this,input),1!==input.scale){var inOut=1>input.scale?'in':'out';this.manager.emit(this.options.event+inOut,input)}}}),inherit(PressRecognizer,Recognizer,{defaults:{event:'press',pointers:1,time:500,threshold:5},getTouchAction:function getTouchAction(){return[TOUCH_ACTION_AUTO]},process:function process(input){var options=this.options,validPointers=input.pointers.length===options.pointers,validMovement=input.distance<options.threshold,validTime=input.deltaTime>options.time;if(this._input=input,!validMovement||!validPointers||input.eventType&(INPUT_END|INPUT_CANCEL)&&!validTime)this.reset();else if(input.eventType&INPUT_START)this.reset(),this._timer=setTimeoutContext(function(){this.state=STATE_RECOGNIZED,this.tryEmit()},options.time,this);else if(input.eventType&INPUT_END)return STATE_RECOGNIZED;return STATE_FAILED},reset:function reset(){clearTimeout(this._timer)},emit:function emit(input){this.state!==STATE_RECOGNIZED||(input&&input.eventType&INPUT_END?this.manager.emit(this.options.event+'up',input):(this._input.timeStamp=now(),this.manager.emit(this.options.event,this._input)))}}),inherit(RotateRecognizer,AttrRecognizer,{defaults:{event:'rotate',threshold:0,pointers:2},getTouchAction:function getTouchAction(){return[TOUCH_ACTION_NONE]},attrTest:function attrTest(input){return this._super.attrTest.call(this,input)&&(_Mathabs(input.rotation)>this.options.threshold||this.state&STATE_BEGAN)}}),inherit(SwipeRecognizer,AttrRecognizer,{defaults:{event:'swipe',threshold:10,velocity:.65,direction:DIRECTION_HORIZONTAL|DIRECTION_VERTICAL,pointers:1},getTouchAction:function getTouchAction(){return PanRecognizer.prototype.getTouchAction.call(this)},attrTest:function attrTest(input){var velocity,direction=this.options.direction;return direction&(DIRECTION_HORIZONTAL|DIRECTION_VERTICAL)?velocity=input.velocity:direction&DIRECTION_HORIZONTAL?velocity=input.velocityX:direction&DIRECTION_VERTICAL&&(velocity=input.velocityY),this._super.attrTest.call(this,input)&&direction&input.direction&&input.distance>this.options.threshold&&abs(velocity)>this.options.velocity&&input.eventType&INPUT_END},emit:function emit(input){var direction=directionStr(input.direction);direction&&this.manager.emit(this.options.event+direction,input),this.manager.emit(this.options.event,input)}}),inherit(TapRecognizer,Recognizer,{defaults:{event:'tap',pointers:1,taps:1,interval:300,time:250,threshold:2,posThreshold:10},getTouchAction:function getTouchAction(){return[TOUCH_ACTION_MANIPULATION]},process:function process(input){var options=this.options,validPointers=input.pointers.length===options.pointers,validMovement=input.distance<options.threshold,validTouchTime=input.deltaTime<options.time;if(this.reset(),input.eventType&INPUT_START&&0===this.count)return this.failTimeout();if(validMovement&&validTouchTime&&validPointers){if(input.eventType!=INPUT_END)return this.failTimeout();var validInterval=!this.pTime||input.timeStamp-this.pTime<options.interval,validMultiTap=!this.pCenter||getDistance(this.pCenter,input.center)<options.posThreshold;this.pTime=input.timeStamp,this.pCenter=input.center,validMultiTap&&validInterval?this.count+=1:this.count=1,this._input=input;var tapCount=this.count%options.taps;if(0==tapCount)return this.hasRequireFailures()?(this._timer=setTimeoutContext(function(){this.state=STATE_RECOGNIZED,this.tryEmit()},options.interval,this),STATE_BEGAN):STATE_RECOGNIZED}return STATE_FAILED},failTimeout:function failTimeout(){return this._timer=setTimeoutContext(function(){this.state=STATE_FAILED},this.options.interval,this),STATE_FAILED},reset:function reset(){clearTimeout(this._timer)},emit:function emit(){this.state==STATE_RECOGNIZED&&(this._input.tapCount=this.count,this.manager.emit(this.options.event,this._input))}}),Hammer.VERSION='2.0.4',Hammer.defaults={domEvents:!1,touchAction:TOUCH_ACTION_COMPUTE,enable:!0,inputTarget:null,inputClass:null,preset:[[RotateRecognizer,{enable:!1}],[PinchRecognizer,{enable:!1},['rotate']],[SwipeRecognizer,{direction:DIRECTION_HORIZONTAL}],[PanRecognizer,{direction:DIRECTION_HORIZONTAL},['swipe']],[TapRecognizer],[TapRecognizer,{event:'doubletap',taps:2},['tap']],[PressRecognizer]],cssProps:{userSelect:'none',touchSelect:'none',touchCallout:'none',contentZooming:'none',userDrag:'none',tapHighlightColor:'rgba(0,0,0,0)'}};var FORCED_STOP=2;Manager.prototype={set:function set(options){return extend(this.options,options),options.touchAction&&this.touchAction.update(),options.inputTarget&&(this.input.destroy(),this.input.target=options.inputTarget,this.input.init()),this},stop:function stop(force){this.session.stopped=force?FORCED_STOP:1},recognize:function recognize(inputData){var session=this.session;if(!session.stopped){this.touchAction.preventDefaults(inputData);var recognizer,recognizers=this.recognizers,curRecognizer=session.curRecognizer;(!curRecognizer||curRecognizer&&curRecognizer.state&STATE_RECOGNIZED)&&(curRecognizer=session.curRecognizer=null);for(var i=0;i<recognizers.length;)recognizer=recognizers[i],session.stopped!==FORCED_STOP&&(!curRecognizer||recognizer==curRecognizer||recognizer.canRecognizeWith(curRecognizer))?recognizer.recognize(inputData):recognizer.reset(),!curRecognizer&&recognizer.state&(STATE_BEGAN|STATE_CHANGED|STATE_ENDED)&&(curRecognizer=session.curRecognizer=recognizer),i++}},get:function get(recognizer){if(recognizer instanceof Recognizer)return recognizer;for(var recognizers=this.recognizers,i=0;i<recognizers.length;i++)if(recognizers[i].options.event==recognizer)return recognizers[i];return null},add:function add(recognizer){if(invokeArrayArg(recognizer,'add',this))return this;var existing=this.get(recognizer.options.event);return existing&&this.remove(existing),this.recognizers.push(recognizer),recognizer.manager=this,this.touchAction.update(),recognizer},remove:function remove(recognizer){if(invokeArrayArg(recognizer,'remove',this))return this;var recognizers=this.recognizers;return recognizer=this.get(recognizer),recognizers.splice(inArray(recognizers,recognizer),1),this.touchAction.update(),this},on:function on(events,handler){var handlers=this.handlers;return each(splitStr(events),function(event){handlers[event]=handlers[event]||[],handlers[event].push(handler)}),this},off:function off(events,handler){var handlers=this.handlers;return each(splitStr(events),function(event){handler?handlers[event].splice(inArray(handlers[event],handler),1):delete handlers[event]}),this},emit:function emit(event,data){this.options.domEvents&&triggerDomEvent(event,data);var handlers=this.handlers[event]&&this.handlers[event].slice();if(handlers&&handlers.length){data.type=event,data.preventDefault=function(){data.srcEvent.preventDefault()};for(var i=0;i<handlers.length;)handlers[i](data),i++}},destroy:function destroy(){this.element&&toggleCssProps(this,!1),this.handlers={},this.session={},this.input.destroy(),this.element=null}},extend(Hammer,{INPUT_START:INPUT_START,INPUT_MOVE:INPUT_MOVE,INPUT_END:INPUT_END,INPUT_CANCEL:INPUT_CANCEL,STATE_POSSIBLE:STATE_POSSIBLE,STATE_BEGAN:STATE_BEGAN,STATE_CHANGED:STATE_CHANGED,STATE_ENDED:STATE_ENDED,STATE_RECOGNIZED:STATE_RECOGNIZED,STATE_CANCELLED:STATE_CANCELLED,STATE_FAILED:STATE_FAILED,DIRECTION_NONE:DIRECTION_NONE,DIRECTION_LEFT:DIRECTION_LEFT,DIRECTION_RIGHT:DIRECTION_RIGHT,DIRECTION_UP:DIRECTION_UP,DIRECTION_DOWN:DIRECTION_DOWN,DIRECTION_HORIZONTAL:DIRECTION_HORIZONTAL,DIRECTION_VERTICAL:DIRECTION_VERTICAL,DIRECTION_ALL:DIRECTION_ALL,Manager:Manager,Input:Input,TouchAction:TouchAction,TouchInput:TouchInput,MouseInput:MouseInput,PointerEventInput:PointerEventInput,TouchMouseInput:TouchMouseInput,SingleTouchInput:SingleTouchInput,Recognizer:Recognizer,AttrRecognizer:AttrRecognizer,Tap:TapRecognizer,Pan:PanRecognizer,Swipe:SwipeRecognizer,Pinch:PinchRecognizer,Rotate:RotateRecognizer,Press:PressRecognizer,on:addEventListeners,off:removeEventListeners,each:each,merge:merge,extend:extend,inherit:inherit,bindFn:bindFn,prefixed:prefixed}),( false?'undefined':_typeof(__webpack_require__(108)))==TYPE_FUNCTION&&__webpack_require__(109)?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return Hammer}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):'undefined'!=typeof module&&module.exports?module.exports=Hammer:window[exportName]=Hammer})(window,document,'Hammer');

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 109 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
window.Detector={canvas:!!window.CanvasRenderingContext2D,webgl:function(){try{var canvas=document.createElement('canvas');return!!window.WebGLRenderingContext&&(canvas.getContext('webgl')||canvas.getContext('experimental-webgl'))}catch(e){return!1}}(),workers:!!window.Worker,fileapi:window.File&&window.FileReader&&window.FileList&&window.Blob,getWebGLErrorMessage:function getWebGLErrorMessage(){var element=document.createElement('div');return element.id='webgl-error-message',element.style.fontFamily='monospace',element.style.fontSize='13px',element.style.fontWeight='normal',element.style.textAlign='center',element.style.background='#fff',element.style.color='#000',element.style.padding='1.5em',element.style.width='400px',element.style.margin='5em auto 0',this.webgl||(element.innerHTML=window.WebGLRenderingContext?'Your graphics card does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br />\nFind out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.':'Your browser does not seem to support <a href="http://khronos.org/webgl/wiki/Getting_a_WebGL_Implementation" style="color:#000">WebGL</a>.<br/>\nFind out how to get it <a href="http://get.webgl.org/" style="color:#000">here</a>.'),element},addGetWebGLMessage:function addGetWebGLMessage(parameters){var parent,id,element;parameters=parameters||{},parent=parameters.parent===void 0?document.body:parameters.parent,id=parameters.id===void 0?'oldie':parameters.id,element=Detector.getWebGLErrorMessage(),element.id=id,parent.appendChild(element)}};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var THREEx=THREEx||{};(function(){var _aspectResize=function(srcUrl,dstW,dstH,callback){var cpuScaleAspect=function(maxW,maxH,curW,curH){var ratio=curH/curW;return curW>=maxW&&1>=ratio?(curW=maxW,curH=maxW*ratio):curH>=maxH&&(curH=maxH,curW=maxH/ratio),{width:curW,height:curH}},onLoad=function(){var canvas=document.createElement('canvas');canvas.width=dstW,canvas.height=dstH;var ctx=canvas.getContext('2d');ctx.fillStyle='black',ctx.fillRect(0,0,canvas.width,canvas.height);var scaled=cpuScaleAspect(canvas.width,canvas.height,image.width,image.height),offsetX=(canvas.width-scaled.width)/2,offsetY=(canvas.height-scaled.height)/2;ctx.drawImage(image,offsetX,offsetY,scaled.width,scaled.height);var newDataUrl=canvas.toDataURL('image/png');callback&&callback(newDataUrl)}.bind(this),image=new Image;image.onload=onLoad,image.src=srcUrl};THREEx.Screenshot={toDataURL:function toDataURL(renderer,mimetype){mimetype=mimetype||'image/png';var dataUrl=renderer.domElement.toDataURL(mimetype);return dataUrl},bindKey:function bindKey(renderer,opts){opts=opts||{};var charCode=opts.charCode||112,width=opts.width,height=opts.height,callback=opts.callback||function(url){window.open(url,'name-'+Math.random())},onKeyPress=function(event){if(event.which===charCode){var dataUrl=this.toDataURL(renderer);void 0===width&&void 0===height?callback(dataUrl):_aspectResize(dataUrl,width,height,callback)}}.bind(this);return document.addEventListener('keypress',onKeyPress,!1),{unbind:function unbind(){document.removeEventListener('keypress',onKeyPress,!1)}}}}})();

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
window.THREE={REVISION:'60'},self.console=self.console||{info:function info(){},log:function log(){},debug:function debug(){},warn:function warn(){},error:function error(){}},String.prototype.trim=String.prototype.trim||function(){return this.replace(/^\s+|\s+$/g,'')},THREE.extend=function(obj,source){if(Object.keys)for(var keys=Object.keys(source),i=0,il=keys.length,prop;i<il;i++)prop=keys[i],Object.defineProperty(obj,prop,Object.getOwnPropertyDescriptor(source,prop));else{var safeHasOwnProperty={}.hasOwnProperty;for(var prop in source)safeHasOwnProperty.call(source,prop)&&(obj[prop]=source[prop])}return obj},function(){for(var lastTime=0,vendors=['ms','moz','webkit','o'],x=0;x<vendors.length&&!self.requestAnimationFrame;++x)self.requestAnimationFrame=self[vendors[x]+'RequestAnimationFrame'],self.cancelAnimationFrame=self[vendors[x]+'CancelAnimationFrame']||self[vendors[x]+'CancelRequestAnimationFrame'];self.requestAnimationFrame===void 0&&self.setTimeout!==void 0&&(self.requestAnimationFrame=function(callback){var currTime=Date.now(),timeToCall=Math.max(0,16-(currTime-lastTime)),id=self.setTimeout(function(){callback(currTime+timeToCall)},timeToCall);return lastTime=currTime+timeToCall,id}),self.cancelAnimationFrame===void 0&&self.clearTimeout!==void 0&&(self.cancelAnimationFrame=function(id){self.clearTimeout(id)})}(),THREE.CullFaceNone=0,THREE.CullFaceBack=1,THREE.CullFaceFront=2,THREE.CullFaceFrontBack=3,THREE.FrontFaceDirectionCW=0,THREE.FrontFaceDirectionCCW=1,THREE.BasicShadowMap=0,THREE.PCFShadowMap=1,THREE.PCFSoftShadowMap=2,THREE.FrontSide=0,THREE.BackSide=1,THREE.DoubleSide=2,THREE.NoShading=0,THREE.FlatShading=1,THREE.SmoothShading=2,THREE.NoColors=0,THREE.FaceColors=1,THREE.VertexColors=2,THREE.NoBlending=0,THREE.NormalBlending=1,THREE.AdditiveBlending=2,THREE.SubtractiveBlending=3,THREE.MultiplyBlending=4,THREE.CustomBlending=5,THREE.AddEquation=100,THREE.SubtractEquation=101,THREE.ReverseSubtractEquation=102,THREE.ZeroFactor=200,THREE.OneFactor=201,THREE.SrcColorFactor=202,THREE.OneMinusSrcColorFactor=203,THREE.SrcAlphaFactor=204,THREE.OneMinusSrcAlphaFactor=205,THREE.DstAlphaFactor=206,THREE.OneMinusDstAlphaFactor=207,THREE.DstColorFactor=208,THREE.OneMinusDstColorFactor=209,THREE.SrcAlphaSaturateFactor=210,THREE.MultiplyOperation=0,THREE.MixOperation=1,THREE.AddOperation=2,THREE.UVMapping=function(){},THREE.CubeReflectionMapping=function(){},THREE.CubeRefractionMapping=function(){},THREE.SphericalReflectionMapping=function(){},THREE.SphericalRefractionMapping=function(){},THREE.RepeatWrapping=1e3,THREE.ClampToEdgeWrapping=1001,THREE.MirroredRepeatWrapping=1002,THREE.NearestFilter=1003,THREE.NearestMipMapNearestFilter=1004,THREE.NearestMipMapLinearFilter=1005,THREE.LinearFilter=1006,THREE.LinearMipMapNearestFilter=1007,THREE.LinearMipMapLinearFilter=1008,THREE.UnsignedByteType=1009,THREE.ByteType=1010,THREE.ShortType=1011,THREE.UnsignedShortType=1012,THREE.IntType=1013,THREE.UnsignedIntType=1014,THREE.FloatType=1015,THREE.UnsignedShort4444Type=1016,THREE.UnsignedShort5551Type=1017,THREE.UnsignedShort565Type=1018,THREE.AlphaFormat=1019,THREE.RGBFormat=1020,THREE.RGBAFormat=1021,THREE.LuminanceFormat=1022,THREE.LuminanceAlphaFormat=1023,THREE.RGB_S3TC_DXT1_Format=2001,THREE.RGBA_S3TC_DXT1_Format=2002,THREE.RGBA_S3TC_DXT3_Format=2003,THREE.RGBA_S3TC_DXT5_Format=2004,THREE.Color=function(value){return void 0!==value&&this.set(value),this},THREE.Color.prototype={constructor:THREE.Color,r:1,g:1,b:1,set:function set(value){return value instanceof THREE.Color?this.copy(value):'number'==typeof value?this.setHex(value):'string'==typeof value&&this.setStyle(value),this},setHex:function setHex(hex){return hex=Math.floor(hex),this.r=(255&hex>>16)/255,this.g=(255&hex>>8)/255,this.b=(255&hex)/255,this},setRGB:function setRGB(r,g,b){return this.r=r,this.g=g,this.b=b,this},setHSL:function setHSL(h,s,l){if(0===s)this.r=this.g=this.b=l;else{var hue2rgb=function(p,q,t){return 0>t&&(t+=1),1<t&&(t-=1),t<1/6?p+6*(q-p)*t:t<1/2?q:t<2/3?p+6*(q-p)*(2/3-t):p},p=.5>=l?l*(1+s):l+s-l*s,q=2*l-p;this.r=hue2rgb(q,p,h+1/3),this.g=hue2rgb(q,p,h),this.b=hue2rgb(q,p,h-1/3)}return this},setStyle:function setStyle(style){var _Mathmin=Math.min;if(/^rgb\((\d+),(\d+),(\d+)\)$/i.test(style)){var color=/^rgb\((\d+),(\d+),(\d+)\)$/i.exec(style);return this.r=_Mathmin(255,parseInt(color[1],10))/255,this.g=_Mathmin(255,parseInt(color[2],10))/255,this.b=_Mathmin(255,parseInt(color[3],10))/255,this}if(/^rgb\((\d+)\%,(\d+)\%,(\d+)\%\)$/i.test(style)){var color=/^rgb\((\d+)\%,(\d+)\%,(\d+)\%\)$/i.exec(style);return this.r=_Mathmin(100,parseInt(color[1],10))/100,this.g=_Mathmin(100,parseInt(color[2],10))/100,this.b=_Mathmin(100,parseInt(color[3],10))/100,this}if(/^\#([0-9a-f]{6})$/i.test(style)){var color=/^\#([0-9a-f]{6})$/i.exec(style);return this.setHex(parseInt(color[1],16)),this}if(/^\#([0-9a-f])([0-9a-f])([0-9a-f])$/i.test(style)){var color=/^\#([0-9a-f])([0-9a-f])([0-9a-f])$/i.exec(style);return this.setHex(parseInt(color[1]+color[1]+color[2]+color[2]+color[3]+color[3],16)),this}return /^(\w+)$/i.test(style)?(this.setHex(THREE.ColorKeywords[style]),this):void 0},copy:function copy(color){return this.r=color.r,this.g=color.g,this.b=color.b,this},copyGammaToLinear:function copyGammaToLinear(color){return this.r=color.r*color.r,this.g=color.g*color.g,this.b=color.b*color.b,this},copyLinearToGamma:function copyLinearToGamma(color){var _Mathsqrt=Math.sqrt;return this.r=_Mathsqrt(color.r),this.g=_Mathsqrt(color.g),this.b=_Mathsqrt(color.b),this},convertGammaToLinear:function convertGammaToLinear(){var r=this.r,g=this.g,b=this.b;return this.r=r*r,this.g=g*g,this.b=b*b,this},convertLinearToGamma:function convertLinearToGamma(){var _Mathsqrt2=Math.sqrt;return this.r=_Mathsqrt2(this.r),this.g=_Mathsqrt2(this.g),this.b=_Mathsqrt2(this.b),this},getHex:function getHex(){return 255*this.r<<16^255*this.g<<8^255*this.b<<0},getHexString:function getHexString(){return('000000'+this.getHex().toString(16)).slice(-6)},getHSL:function(){var hsl={h:0,s:0,l:0};return function(){var r=this.r,g=this.g,b=this.b,max=Math.max(r,g,b),min=Math.min(r,g,b),lightness=(min+max)/2,hue,saturation;if(min===max)hue=0,saturation=0;else{var delta=max-min;saturation=.5>=lightness?delta/(max+min):delta/(2-max-min),max===r?hue=(g-b)/delta+(g<b?6:0):max===g?hue=(b-r)/delta+2:max===b?hue=(r-g)/delta+4:void 0,hue/=6}return hsl.h=hue,hsl.s=saturation,hsl.l=lightness,hsl}}(),getStyle:function getStyle(){return'rgb('+(0|255*this.r)+','+(0|255*this.g)+','+(0|255*this.b)+')'},offsetHSL:function offsetHSL(h,s,l){var hsl=this.getHSL();return hsl.h+=h,hsl.s+=s,hsl.l+=l,this.setHSL(hsl.h,hsl.s,hsl.l),this},add:function add(color){return this.r+=color.r,this.g+=color.g,this.b+=color.b,this},addColors:function addColors(color1,color2){return this.r=color1.r+color2.r,this.g=color1.g+color2.g,this.b=color1.b+color2.b,this},addScalar:function addScalar(s){return this.r+=s,this.g+=s,this.b+=s,this},multiply:function multiply(color){return this.r*=color.r,this.g*=color.g,this.b*=color.b,this},multiplyScalar:function multiplyScalar(s){return this.r*=s,this.g*=s,this.b*=s,this},lerp:function lerp(color,alpha){return this.r+=(color.r-this.r)*alpha,this.g+=(color.g-this.g)*alpha,this.b+=(color.b-this.b)*alpha,this},equals:function equals(c){return c.r===this.r&&c.g===this.g&&c.b===this.b},fromArray:function fromArray(array){return this.r=array[0],this.g=array[1],this.b=array[2],this},toArray:function toArray(){return[this.r,this.g,this.b]},clone:function clone(){return new THREE.Color().setRGB(this.r,this.g,this.b)}},THREE.ColorKeywords={aliceblue:15792383,antiquewhite:16444375,aqua:65535,aquamarine:8388564,azure:15794175,beige:16119260,bisque:16770244,black:0,blanchedalmond:16772045,blue:255,blueviolet:9055202,brown:10824234,burlywood:14596231,cadetblue:6266528,chartreuse:8388352,chocolate:13789470,coral:16744272,cornflowerblue:6591981,cornsilk:16775388,crimson:14423100,cyan:65535,darkblue:139,darkcyan:35723,darkgoldenrod:12092939,darkgray:11119017,darkgreen:25600,darkgrey:11119017,darkkhaki:12433259,darkmagenta:9109643,darkolivegreen:5597999,darkorange:16747520,darkorchid:10040012,darkred:9109504,darksalmon:15308410,darkseagreen:9419919,darkslateblue:4734347,darkslategray:3100495,darkslategrey:3100495,darkturquoise:52945,darkviolet:9699539,deeppink:16716947,deepskyblue:49151,dimgray:6908265,dimgrey:6908265,dodgerblue:2003199,firebrick:11674146,floralwhite:16775920,forestgreen:2263842,fuchsia:16711935,gainsboro:14474460,ghostwhite:16316671,gold:16766720,goldenrod:14329120,gray:8421504,green:32768,greenyellow:11403055,grey:8421504,honeydew:15794160,hotpink:16738740,indianred:13458524,indigo:4915330,ivory:16777200,khaki:15787660,lavender:15132410,lavenderblush:16773365,lawngreen:8190976,lemonchiffon:16775885,lightblue:11393254,lightcoral:15761536,lightcyan:14745599,lightgoldenrodyellow:16448210,lightgray:13882323,lightgreen:9498256,lightgrey:13882323,lightpink:16758465,lightsalmon:16752762,lightseagreen:2142890,lightskyblue:8900346,lightslategray:7833753,lightslategrey:7833753,lightsteelblue:11584734,lightyellow:16777184,lime:65280,limegreen:3329330,linen:16445670,magenta:16711935,maroon:8388608,mediumaquamarine:6737322,mediumblue:205,mediumorchid:12211667,mediumpurple:9662683,mediumseagreen:3978097,mediumslateblue:8087790,mediumspringgreen:64154,mediumturquoise:4772300,mediumvioletred:13047173,midnightblue:1644912,mintcream:16121850,mistyrose:16770273,moccasin:16770229,navajowhite:16768685,navy:128,oldlace:16643558,olive:8421376,olivedrab:7048739,orange:16753920,orangered:16729344,orchid:14315734,palegoldenrod:15657130,palegreen:10025880,paleturquoise:11529966,palevioletred:14381203,papayawhip:16773077,peachpuff:16767673,peru:13468991,pink:16761035,plum:14524637,powderblue:11591910,purple:8388736,red:16711680,rosybrown:12357519,royalblue:4286945,saddlebrown:9127187,salmon:16416882,sandybrown:16032864,seagreen:3050327,seashell:16774638,sienna:10506797,silver:12632256,skyblue:8900331,slateblue:6970061,slategray:7372944,slategrey:7372944,snow:16775930,springgreen:65407,steelblue:4620980,tan:13808780,teal:32896,thistle:14204888,tomato:16737095,turquoise:4251856,violet:15631086,wheat:16113331,white:16777215,whitesmoke:16119285,yellow:16776960,yellowgreen:10145074},THREE.Quaternion=function(x,y,z,w){this._x=x||0,this._y=y||0,this._z=z||0,this._w=w===void 0?1:w},THREE.Quaternion.prototype={constructor:THREE.Quaternion,_x:0,_y:0,_z:0,_w:0,_euler:void 0,_updateEuler:function _updateEuler(){this._euler!==void 0&&this._euler.setFromQuaternion(this,void 0,!1)},get x(){return this._x},set x(value){this._x=value,this._updateEuler()},get y(){return this._y},set y(value){this._y=value,this._updateEuler()},get z(){return this._z},set z(value){this._z=value,this._updateEuler()},get w(){return this._w},set w(value){this._w=value,this._updateEuler()},set:function set(x,y,z,w){return this._x=x,this._y=y,this._z=z,this._w=w,this._updateEuler(),this},copy:function copy(quaternion){return this._x=quaternion._x,this._y=quaternion._y,this._z=quaternion._z,this._w=quaternion._w,this._updateEuler(),this},setFromEuler:function setFromEuler(euler,update){var _Mathsin=Math.sin,_Mathcos=Math.cos;if(!1==euler instanceof THREE.Euler)throw new Error('ERROR: Quaternion\'s .setFromEuler() now expects a Euler rotation rather than a Vector3 and order.  Please update your code.');var c1=_Mathcos(euler._x/2),c2=_Mathcos(euler._y/2),c3=_Mathcos(euler._z/2),s1=_Mathsin(euler._x/2),s2=_Mathsin(euler._y/2),s3=_Mathsin(euler._z/2);return'XYZ'===euler.order?(this._x=s1*c2*c3+c1*s2*s3,this._y=c1*s2*c3-s1*c2*s3,this._z=c1*c2*s3+s1*s2*c3,this._w=c1*c2*c3-s1*s2*s3):'YXZ'===euler.order?(this._x=s1*c2*c3+c1*s2*s3,this._y=c1*s2*c3-s1*c2*s3,this._z=c1*c2*s3-s1*s2*c3,this._w=c1*c2*c3+s1*s2*s3):'ZXY'===euler.order?(this._x=s1*c2*c3-c1*s2*s3,this._y=c1*s2*c3+s1*c2*s3,this._z=c1*c2*s3+s1*s2*c3,this._w=c1*c2*c3-s1*s2*s3):'ZYX'===euler.order?(this._x=s1*c2*c3-c1*s2*s3,this._y=c1*s2*c3+s1*c2*s3,this._z=c1*c2*s3-s1*s2*c3,this._w=c1*c2*c3+s1*s2*s3):'YZX'===euler.order?(this._x=s1*c2*c3+c1*s2*s3,this._y=c1*s2*c3+s1*c2*s3,this._z=c1*c2*s3-s1*s2*c3,this._w=c1*c2*c3-s1*s2*s3):'XZY'===euler.order&&(this._x=s1*c2*c3-c1*s2*s3,this._y=c1*s2*c3-s1*c2*s3,this._z=c1*c2*s3+s1*s2*c3,this._w=c1*c2*c3+s1*s2*s3),!1!==update&&this._updateEuler(),this},setFromAxisAngle:function setFromAxisAngle(axis,angle){var halfAngle=angle/2,s=Math.sin(halfAngle);return this._x=axis.x*s,this._y=axis.y*s,this._z=axis.z*s,this._w=Math.cos(halfAngle),this._updateEuler(),this},setFromRotationMatrix:function setFromRotationMatrix(m){var _Mathsqrt3=Math.sqrt,te=m.elements,m11=te[0],m12=te[4],m13=te[8],m21=te[1],m22=te[5],m23=te[9],m31=te[2],m32=te[6],m33=te[10],trace=m11+m22+m33,s;return 0<trace?(s=.5/_Mathsqrt3(trace+1),this._w=.25/s,this._x=(m32-m23)*s,this._y=(m13-m31)*s,this._z=(m21-m12)*s):m11>m22&&m11>m33?(s=2*_Mathsqrt3(1+m11-m22-m33),this._w=(m32-m23)/s,this._x=.25*s,this._y=(m12+m21)/s,this._z=(m13+m31)/s):m22>m33?(s=2*_Mathsqrt3(1+m22-m11-m33),this._w=(m13-m31)/s,this._x=(m12+m21)/s,this._y=.25*s,this._z=(m23+m32)/s):(s=2*_Mathsqrt3(1+m33-m11-m22),this._w=(m21-m12)/s,this._x=(m13+m31)/s,this._y=(m23+m32)/s,this._z=.25*s),this._updateEuler(),this},inverse:function inverse(){return this.conjugate().normalize(),this},conjugate:function conjugate(){return this._x*=-1,this._y*=-1,this._z*=-1,this._updateEuler(),this},lengthSq:function lengthSq(){return this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w},length:function length(){return Math.sqrt(this._x*this._x+this._y*this._y+this._z*this._z+this._w*this._w)},normalize:function normalize(){var l=this.length();return 0===l?(this._x=0,this._y=0,this._z=0,this._w=1):(l=1/l,this._x*=l,this._y*=l,this._z*=l,this._w*=l),this},multiply:function multiply(q,p){return void 0===p?this.multiplyQuaternions(this,q):(console.warn('DEPRECATED: Quaternion\'s .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.'),this.multiplyQuaternions(q,p))},multiplyQuaternions:function multiplyQuaternions(a,b){var qax=a._x,qay=a._y,qaz=a._z,qaw=a._w,qbx=b._x,qby=b._y,qbz=b._z,qbw=b._w;return this._x=qax*qbw+qaw*qbx+qay*qbz-qaz*qby,this._y=qay*qbw+qaw*qby+qaz*qbx-qax*qbz,this._z=qaz*qbw+qaw*qbz+qax*qby-qay*qbx,this._w=qaw*qbw-qax*qbx-qay*qby-qaz*qbz,this._updateEuler(),this},multiplyVector3:function multiplyVector3(vector){return console.warn('DEPRECATED: Quaternion\'s .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.'),vector.applyQuaternion(this)},slerp:function slerp(qb,t){var _Mathsin2=Math.sin,x=this._x,y=this._y,z=this._z,w=this._w,cosHalfTheta=w*qb._w+x*qb._x+y*qb._y+z*qb._z;if(0>cosHalfTheta?(this._w=-qb._w,this._x=-qb._x,this._y=-qb._y,this._z=-qb._z,cosHalfTheta=-cosHalfTheta):this.copy(qb),1<=cosHalfTheta)return this._w=w,this._x=x,this._y=y,this._z=z,this;var halfTheta=Math.acos(cosHalfTheta),sinHalfTheta=Math.sqrt(1-cosHalfTheta*cosHalfTheta);if(.001>Math.abs(sinHalfTheta))return this._w=.5*(w+this._w),this._x=.5*(x+this._x),this._y=.5*(y+this._y),this._z=.5*(z+this._z),this;var ratioA=_Mathsin2((1-t)*halfTheta)/sinHalfTheta,ratioB=_Mathsin2(t*halfTheta)/sinHalfTheta;return this._w=w*ratioA+this._w*ratioB,this._x=x*ratioA+this._x*ratioB,this._y=y*ratioA+this._y*ratioB,this._z=z*ratioA+this._z*ratioB,this._updateEuler(),this},equals:function equals(quaternion){return quaternion._x===this._x&&quaternion._y===this._y&&quaternion._z===this._z&&quaternion._w===this._w},fromArray:function fromArray(array){return this._x=array[0],this._y=array[1],this._z=array[2],this._w=array[3],this._updateEuler(),this},toArray:function toArray(){return[this._x,this._y,this._z,this._w]},clone:function clone(){return new THREE.Quaternion(this._x,this._y,this._z,this._w)}},THREE.Quaternion.slerp=function(qa,qb,qm,t){return qm.copy(qa).slerp(qb,t)},THREE.Vector2=function(x,y){this.x=x||0,this.y=y||0},THREE.Vector2.prototype={constructor:THREE.Vector2,set:function set(x,y){return this.x=x,this.y=y,this},setX:function setX(x){return this.x=x,this},setY:function setY(y){return this.y=y,this},setComponent:function setComponent(index,value){switch(index){case 0:this.x=value;break;case 1:this.y=value;break;default:throw new Error('index is out of range: '+index);}},getComponent:function getComponent(index){switch(index){case 0:return this.x;case 1:return this.y;default:throw new Error('index is out of range: '+index);}},copy:function copy(v){return this.x=v.x,this.y=v.y,this},add:function add(v,w){return void 0===w?(this.x+=v.x,this.y+=v.y,this):(console.warn('DEPRECATED: Vector2\'s .add() now only accepts one argument. Use .addVectors( a, b ) instead.'),this.addVectors(v,w))},addVectors:function addVectors(a,b){return this.x=a.x+b.x,this.y=a.y+b.y,this},addScalar:function addScalar(s){return this.x+=s,this.y+=s,this},sub:function sub(v,w){return void 0===w?(this.x-=v.x,this.y-=v.y,this):(console.warn('DEPRECATED: Vector2\'s .sub() now only accepts one argument. Use .subVectors( a, b ) instead.'),this.subVectors(v,w))},subVectors:function subVectors(a,b){return this.x=a.x-b.x,this.y=a.y-b.y,this},multiplyScalar:function multiplyScalar(s){return this.x*=s,this.y*=s,this},divideScalar:function divideScalar(scalar){if(0!==scalar){var invScalar=1/scalar;this.x*=invScalar,this.y*=invScalar}else this.x=0,this.y=0;return this},min:function min(v){return this.x>v.x&&(this.x=v.x),this.y>v.y&&(this.y=v.y),this},max:function max(v){return this.x<v.x&&(this.x=v.x),this.y<v.y&&(this.y=v.y),this},clamp:function clamp(min,max){return this.x<min.x?this.x=min.x:this.x>max.x&&(this.x=max.x),this.y<min.y?this.y=min.y:this.y>max.y&&(this.y=max.y),this},negate:function negate(){return this.multiplyScalar(-1)},dot:function dot(v){return this.x*v.x+this.y*v.y},lengthSq:function lengthSq(){return this.x*this.x+this.y*this.y},length:function length(){return Math.sqrt(this.x*this.x+this.y*this.y)},normalize:function normalize(){return this.divideScalar(this.length())},distanceTo:function distanceTo(v){return Math.sqrt(this.distanceToSquared(v))},distanceToSquared:function distanceToSquared(v){var dx=this.x-v.x,dy=this.y-v.y;return dx*dx+dy*dy},setLength:function setLength(l){var oldLength=this.length();return 0!==oldLength&&l!==oldLength&&this.multiplyScalar(l/oldLength),this},lerp:function lerp(v,alpha){return this.x+=(v.x-this.x)*alpha,this.y+=(v.y-this.y)*alpha,this},equals:function equals(v){return v.x===this.x&&v.y===this.y},fromArray:function fromArray(array){return this.x=array[0],this.y=array[1],this},toArray:function toArray(){return[this.x,this.y]},clone:function clone(){return new THREE.Vector2(this.x,this.y)}},THREE.Vector3=function(x,y,z){this.x=x||0,this.y=y||0,this.z=z||0},THREE.Vector3.prototype={constructor:THREE.Vector3,set:function set(x,y,z){return this.x=x,this.y=y,this.z=z,this},setX:function setX(x){return this.x=x,this},setY:function setY(y){return this.y=y,this},setZ:function setZ(z){return this.z=z,this},setComponent:function setComponent(index,value){switch(index){case 0:this.x=value;break;case 1:this.y=value;break;case 2:this.z=value;break;default:throw new Error('index is out of range: '+index);}},getComponent:function getComponent(index){switch(index){case 0:return this.x;case 1:return this.y;case 2:return this.z;default:throw new Error('index is out of range: '+index);}},copy:function copy(v){return this.x=v.x,this.y=v.y,this.z=v.z,this},add:function add(v,w){return void 0===w?(this.x+=v.x,this.y+=v.y,this.z+=v.z,this):(console.warn('DEPRECATED: Vector3\'s .add() now only accepts one argument. Use .addVectors( a, b ) instead.'),this.addVectors(v,w))},addScalar:function addScalar(s){return this.x+=s,this.y+=s,this.z+=s,this},addVectors:function addVectors(a,b){return this.x=a.x+b.x,this.y=a.y+b.y,this.z=a.z+b.z,this},sub:function sub(v,w){return void 0===w?(this.x-=v.x,this.y-=v.y,this.z-=v.z,this):(console.warn('DEPRECATED: Vector3\'s .sub() now only accepts one argument. Use .subVectors( a, b ) instead.'),this.subVectors(v,w))},subVectors:function subVectors(a,b){return this.x=a.x-b.x,this.y=a.y-b.y,this.z=a.z-b.z,this},multiply:function multiply(v,w){return void 0===w?(this.x*=v.x,this.y*=v.y,this.z*=v.z,this):(console.warn('DEPRECATED: Vector3\'s .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.'),this.multiplyVectors(v,w))},multiplyScalar:function multiplyScalar(scalar){return this.x*=scalar,this.y*=scalar,this.z*=scalar,this},multiplyVectors:function multiplyVectors(a,b){return this.x=a.x*b.x,this.y=a.y*b.y,this.z=a.z*b.z,this},applyMatrix3:function applyMatrix3(m){var x=this.x,y=this.y,z=this.z,e=m.elements;return this.x=e[0]*x+e[3]*y+e[6]*z,this.y=e[1]*x+e[4]*y+e[7]*z,this.z=e[2]*x+e[5]*y+e[8]*z,this},applyMatrix4:function applyMatrix4(m){var x=this.x,y=this.y,z=this.z,e=m.elements;return this.x=e[0]*x+e[4]*y+e[8]*z+e[12],this.y=e[1]*x+e[5]*y+e[9]*z+e[13],this.z=e[2]*x+e[6]*y+e[10]*z+e[14],this},applyProjection:function applyProjection(m){var x=this.x,y=this.y,z=this.z,e=m.elements,d=1/(e[3]*x+e[7]*y+e[11]*z+e[15]);return this.x=(e[0]*x+e[4]*y+e[8]*z+e[12])*d,this.y=(e[1]*x+e[5]*y+e[9]*z+e[13])*d,this.z=(e[2]*x+e[6]*y+e[10]*z+e[14])*d,this},applyQuaternion:function applyQuaternion(q){var x=this.x,y=this.y,z=this.z,qx=q.x,qy=q.y,qz=q.z,qw=q.w,ix=qw*x+qy*z-qz*y,iy=qw*y+qz*x-qx*z,iz=qw*z+qx*y-qy*x,iw=-qx*x-qy*y-qz*z;return this.x=ix*qw+iw*-qx+iy*-qz-iz*-qy,this.y=iy*qw+iw*-qy+iz*-qx-ix*-qz,this.z=iz*qw+iw*-qz+ix*-qy-iy*-qx,this},transformDirection:function transformDirection(m){var x=this.x,y=this.y,z=this.z,e=m.elements;return this.x=e[0]*x+e[4]*y+e[8]*z,this.y=e[1]*x+e[5]*y+e[9]*z,this.z=e[2]*x+e[6]*y+e[10]*z,this.normalize(),this},divide:function divide(v){return this.x/=v.x,this.y/=v.y,this.z/=v.z,this},divideScalar:function divideScalar(scalar){if(0!==scalar){var invScalar=1/scalar;this.x*=invScalar,this.y*=invScalar,this.z*=invScalar}else this.x=0,this.y=0,this.z=0;return this},min:function min(v){return this.x>v.x&&(this.x=v.x),this.y>v.y&&(this.y=v.y),this.z>v.z&&(this.z=v.z),this},max:function max(v){return this.x<v.x&&(this.x=v.x),this.y<v.y&&(this.y=v.y),this.z<v.z&&(this.z=v.z),this},clamp:function clamp(min,max){return this.x<min.x?this.x=min.x:this.x>max.x&&(this.x=max.x),this.y<min.y?this.y=min.y:this.y>max.y&&(this.y=max.y),this.z<min.z?this.z=min.z:this.z>max.z&&(this.z=max.z),this},negate:function negate(){return this.multiplyScalar(-1)},dot:function dot(v){return this.x*v.x+this.y*v.y+this.z*v.z},lengthSq:function lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z},length:function length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z)},lengthManhattan:function lengthManhattan(){var _Mathabs=Math.abs;return _Mathabs(this.x)+_Mathabs(this.y)+_Mathabs(this.z)},normalize:function normalize(){return this.divideScalar(this.length())},setLength:function setLength(l){var oldLength=this.length();return 0!==oldLength&&l!==oldLength&&this.multiplyScalar(l/oldLength),this},lerp:function lerp(v,alpha){return this.x+=(v.x-this.x)*alpha,this.y+=(v.y-this.y)*alpha,this.z+=(v.z-this.z)*alpha,this},cross:function cross(v,w){if(void 0!==w)return console.warn('DEPRECATED: Vector3\'s .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.'),this.crossVectors(v,w);var x=this.x,y=this.y,z=this.z;return this.x=y*v.z-z*v.y,this.y=z*v.x-x*v.z,this.z=x*v.y-y*v.x,this},crossVectors:function crossVectors(a,b){var ax=a.x,ay=a.y,az=a.z,bx=b.x,by=b.y,bz=b.z;return this.x=ay*bz-az*by,this.y=az*bx-ax*bz,this.z=ax*by-ay*bx,this},angleTo:function angleTo(v){var theta=this.dot(v)/(this.length()*v.length());return Math.acos(THREE.Math.clamp(theta,-1,1))},distanceTo:function distanceTo(v){return Math.sqrt(this.distanceToSquared(v))},distanceToSquared:function distanceToSquared(v){var dx=this.x-v.x,dy=this.y-v.y,dz=this.z-v.z;return dx*dx+dy*dy+dz*dz},setEulerFromRotationMatrix:function setEulerFromRotationMatrix(){console.error('REMOVED: Vector3\'s setEulerFromRotationMatrix has been removed in favor of Euler.setFromRotationMatrix(), please update your code.')},setEulerFromQuaternion:function setEulerFromQuaternion(){console.error('REMOVED: Vector3\'s setEulerFromQuaternion: has been removed in favor of Euler.setFromQuaternion(), please update your code.')},getPositionFromMatrix:function getPositionFromMatrix(m){return this.x=m.elements[12],this.y=m.elements[13],this.z=m.elements[14],this},getScaleFromMatrix:function getScaleFromMatrix(m){var sx=this.set(m.elements[0],m.elements[1],m.elements[2]).length(),sy=this.set(m.elements[4],m.elements[5],m.elements[6]).length(),sz=this.set(m.elements[8],m.elements[9],m.elements[10]).length();return this.x=sx,this.y=sy,this.z=sz,this},getColumnFromMatrix:function getColumnFromMatrix(index,matrix){var offset=4*index,me=matrix.elements;return this.x=me[offset],this.y=me[offset+1],this.z=me[offset+2],this},equals:function equals(v){return v.x===this.x&&v.y===this.y&&v.z===this.z},fromArray:function fromArray(array){return this.x=array[0],this.y=array[1],this.z=array[2],this},toArray:function toArray(){return[this.x,this.y,this.z]},clone:function clone(){return new THREE.Vector3(this.x,this.y,this.z)}},THREE.extend(THREE.Vector3.prototype,{applyEuler:function(){var quaternion=new THREE.Quaternion;return function(euler){return!1==euler instanceof THREE.Euler&&console.error('ERROR: Vector3\'s .applyEuler() now expects a Euler rotation rather than a Vector3 and order.  Please update your code.'),this.applyQuaternion(quaternion.setFromEuler(euler)),this}}(),applyAxisAngle:function(){var quaternion=new THREE.Quaternion;return function(axis,angle){return this.applyQuaternion(quaternion.setFromAxisAngle(axis,angle)),this}}(),projectOnVector:function(){var v1=new THREE.Vector3;return function(vector){v1.copy(vector).normalize();var d=this.dot(v1);return this.copy(v1).multiplyScalar(d)}}(),projectOnPlane:function(){var v1=new THREE.Vector3;return function(planeNormal){return v1.copy(this).projectOnVector(planeNormal),this.sub(v1)}}(),reflect:function(){var v1=new THREE.Vector3;return function(vector){return v1.copy(this).projectOnVector(vector).multiplyScalar(2),this.subVectors(v1,this)}}()}),THREE.Vector4=function(x,y,z,w){this.x=x||0,this.y=y||0,this.z=z||0,this.w=w===void 0?1:w},THREE.Vector4.prototype={constructor:THREE.Vector4,set:function set(x,y,z,w){return this.x=x,this.y=y,this.z=z,this.w=w,this},setX:function setX(x){return this.x=x,this},setY:function setY(y){return this.y=y,this},setZ:function setZ(z){return this.z=z,this},setW:function setW(w){return this.w=w,this},setComponent:function setComponent(index,value){switch(index){case 0:this.x=value;break;case 1:this.y=value;break;case 2:this.z=value;break;case 3:this.w=value;break;default:throw new Error('index is out of range: '+index);}},getComponent:function getComponent(index){switch(index){case 0:return this.x;case 1:return this.y;case 2:return this.z;case 3:return this.w;default:throw new Error('index is out of range: '+index);}},copy:function copy(v){return this.x=v.x,this.y=v.y,this.z=v.z,this.w=void 0===v.w?1:v.w,this},add:function add(v,w){return void 0===w?(this.x+=v.x,this.y+=v.y,this.z+=v.z,this.w+=v.w,this):(console.warn('DEPRECATED: Vector4\'s .add() now only accepts one argument. Use .addVectors( a, b ) instead.'),this.addVectors(v,w))},addScalar:function addScalar(s){return this.x+=s,this.y+=s,this.z+=s,this.w+=s,this},addVectors:function addVectors(a,b){return this.x=a.x+b.x,this.y=a.y+b.y,this.z=a.z+b.z,this.w=a.w+b.w,this},sub:function sub(v,w){return void 0===w?(this.x-=v.x,this.y-=v.y,this.z-=v.z,this.w-=v.w,this):(console.warn('DEPRECATED: Vector4\'s .sub() now only accepts one argument. Use .subVectors( a, b ) instead.'),this.subVectors(v,w))},subVectors:function subVectors(a,b){return this.x=a.x-b.x,this.y=a.y-b.y,this.z=a.z-b.z,this.w=a.w-b.w,this},multiplyScalar:function multiplyScalar(scalar){return this.x*=scalar,this.y*=scalar,this.z*=scalar,this.w*=scalar,this},applyMatrix4:function applyMatrix4(m){var x=this.x,y=this.y,z=this.z,w=this.w,e=m.elements;return this.x=e[0]*x+e[4]*y+e[8]*z+e[12]*w,this.y=e[1]*x+e[5]*y+e[9]*z+e[13]*w,this.z=e[2]*x+e[6]*y+e[10]*z+e[14]*w,this.w=e[3]*x+e[7]*y+e[11]*z+e[15]*w,this},divideScalar:function divideScalar(scalar){if(0!==scalar){var invScalar=1/scalar;this.x*=invScalar,this.y*=invScalar,this.z*=invScalar,this.w*=invScalar}else this.x=0,this.y=0,this.z=0,this.w=1;return this},setAxisAngleFromQuaternion:function setAxisAngleFromQuaternion(q){this.w=2*Math.acos(q.w);var s=Math.sqrt(1-q.w*q.w);return 1e-4>s?(this.x=1,this.y=0,this.z=0):(this.x=q.x/s,this.y=q.y/s,this.z=q.z/s),this},setAxisAngleFromRotationMatrix:function setAxisAngleFromRotationMatrix(m){var _Mathabs2=Math.abs,_Mathsqrt4=Math.sqrt,epsilon=.01,epsilon2=.1,te=m.elements,m11=te[0],m12=te[4],m13=te[8],m21=te[1],m22=te[5],m23=te[9],m31=te[2],m32=te[6],m33=te[10],angle,x,y,z;if(_Mathabs2(m12-m21)<epsilon&&_Mathabs2(m13-m31)<epsilon&&_Mathabs2(m23-m32)<epsilon){if(_Mathabs2(m12+m21)<epsilon2&&_Mathabs2(m13+m31)<epsilon2&&_Mathabs2(m23+m32)<epsilon2&&_Mathabs2(m11+m22+m33-3)<epsilon2)return this.set(1,0,0,0),this;angle=Math.PI;var xx=(m11+1)/2,yy=(m22+1)/2,zz=(m33+1)/2,xy=(m12+m21)/4,xz=(m13+m31)/4,yz=(m23+m32)/4;return xx>yy&&xx>zz?xx<epsilon?(x=0,y=.707106781,z=.707106781):(x=_Mathsqrt4(xx),y=xy/x,z=xz/x):yy>zz?yy<epsilon?(x=.707106781,y=0,z=.707106781):(y=_Mathsqrt4(yy),x=xy/y,z=yz/y):zz<epsilon?(x=.707106781,y=.707106781,z=0):(z=_Mathsqrt4(zz),x=xz/z,y=yz/z),this.set(x,y,z,angle),this}var s=_Mathsqrt4((m32-m23)*(m32-m23)+(m13-m31)*(m13-m31)+(m21-m12)*(m21-m12));return .001>_Mathabs2(s)&&(s=1),this.x=(m32-m23)/s,this.y=(m13-m31)/s,this.z=(m21-m12)/s,this.w=Math.acos((m11+m22+m33-1)/2),this},min:function min(v){return this.x>v.x&&(this.x=v.x),this.y>v.y&&(this.y=v.y),this.z>v.z&&(this.z=v.z),this.w>v.w&&(this.w=v.w),this},max:function max(v){return this.x<v.x&&(this.x=v.x),this.y<v.y&&(this.y=v.y),this.z<v.z&&(this.z=v.z),this.w<v.w&&(this.w=v.w),this},clamp:function clamp(min,max){return this.x<min.x?this.x=min.x:this.x>max.x&&(this.x=max.x),this.y<min.y?this.y=min.y:this.y>max.y&&(this.y=max.y),this.z<min.z?this.z=min.z:this.z>max.z&&(this.z=max.z),this.w<min.w?this.w=min.w:this.w>max.w&&(this.w=max.w),this},negate:function negate(){return this.multiplyScalar(-1)},dot:function dot(v){return this.x*v.x+this.y*v.y+this.z*v.z+this.w*v.w},lengthSq:function lengthSq(){return this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w},length:function length(){return Math.sqrt(this.x*this.x+this.y*this.y+this.z*this.z+this.w*this.w)},lengthManhattan:function lengthManhattan(){var _Mathabs3=Math.abs;return _Mathabs3(this.x)+_Mathabs3(this.y)+_Mathabs3(this.z)+_Mathabs3(this.w)},normalize:function normalize(){return this.divideScalar(this.length())},setLength:function setLength(l){var oldLength=this.length();return 0!==oldLength&&l!==oldLength&&this.multiplyScalar(l/oldLength),this},lerp:function lerp(v,alpha){return this.x+=(v.x-this.x)*alpha,this.y+=(v.y-this.y)*alpha,this.z+=(v.z-this.z)*alpha,this.w+=(v.w-this.w)*alpha,this},equals:function equals(v){return v.x===this.x&&v.y===this.y&&v.z===this.z&&v.w===this.w},fromArray:function fromArray(array){return this.x=array[0],this.y=array[1],this.z=array[2],this.w=array[3],this},toArray:function toArray(){return[this.x,this.y,this.z,this.w]},clone:function clone(){return new THREE.Vector4(this.x,this.y,this.z,this.w)}},THREE.Euler=function(x,y,z,order){this._x=x||0,this._y=y||0,this._z=z||0,this._order=order||THREE.Euler.DefaultOrder},THREE.Euler.RotationOrders=['XYZ','YZX','ZXY','XZY','YXZ','ZYX'],THREE.Euler.DefaultOrder='XYZ',THREE.Euler.prototype={constructor:THREE.Euler,_x:0,_y:0,_z:0,_order:THREE.Euler.DefaultOrder,_quaternion:void 0,_updateQuaternion:function _updateQuaternion(){this._quaternion!==void 0&&this._quaternion.setFromEuler(this,!1)},get x(){return this._x},set x(value){this._x=value,this._updateQuaternion()},get y(){return this._y},set y(value){this._y=value,this._updateQuaternion()},get z(){return this._z},set z(value){this._z=value,this._updateQuaternion()},get order(){return this._order},set order(value){this._order=value,this._updateQuaternion()},set:function set(x,y,z,order){return this._x=x,this._y=y,this._z=z,this._order=order||this._order,this._updateQuaternion(),this},copy:function copy(euler){return this._x=euler._x,this._y=euler._y,this._z=euler._z,this._order=euler._order,this._updateQuaternion(),this},setFromRotationMatrix:function setFromRotationMatrix(m,order){function clamp(x){return Math.min(Math.max(x,-1),1)}var _Mathatan=Math.atan2,_Mathasin=Math.asin,_Mathabs4=Math.abs,te=m.elements,m11=te[0],m12=te[4],m13=te[8],m21=te[1],m22=te[5],m23=te[9],m31=te[2],m32=te[6],m33=te[10];return order=order||this._order,'XYZ'===order?(this._y=_Mathasin(clamp(m13)),.99999>_Mathabs4(m13)?(this._x=_Mathatan(-m23,m33),this._z=_Mathatan(-m12,m11)):(this._x=_Mathatan(m32,m22),this._z=0)):'YXZ'===order?(this._x=_Mathasin(-clamp(m23)),.99999>_Mathabs4(m23)?(this._y=_Mathatan(m13,m33),this._z=_Mathatan(m21,m22)):(this._y=_Mathatan(-m31,m11),this._z=0)):'ZXY'===order?(this._x=_Mathasin(clamp(m32)),.99999>_Mathabs4(m32)?(this._y=_Mathatan(-m31,m33),this._z=_Mathatan(-m12,m22)):(this._y=0,this._z=_Mathatan(m21,m11))):'ZYX'===order?(this._y=_Mathasin(-clamp(m31)),.99999>_Mathabs4(m31)?(this._x=_Mathatan(m32,m33),this._z=_Mathatan(m21,m11)):(this._x=0,this._z=_Mathatan(-m12,m22))):'YZX'===order?(this._z=_Mathasin(clamp(m21)),.99999>_Mathabs4(m21)?(this._x=_Mathatan(-m23,m22),this._y=_Mathatan(-m31,m11)):(this._x=0,this._y=_Mathatan(m13,m33))):'XZY'===order?(this._z=_Mathasin(-clamp(m12)),.99999>_Mathabs4(m12)?(this._x=_Mathatan(m32,m22),this._y=_Mathatan(m13,m11)):(this._x=_Mathatan(-m23,m33),this._y=0)):console.warn('WARNING: Euler.setFromRotationMatrix() given unsupported order: '+order),this._order=order,this._updateQuaternion(),this},setFromQuaternion:function setFromQuaternion(q,order,update){function clamp(x){return Math.min(Math.max(x,-1),1)}var _Mathatan2=Math.atan2,_Mathasin2=Math.asin,sqx=q.x*q.x,sqy=q.y*q.y,sqz=q.z*q.z,sqw=q.w*q.w;return order=order||this._order,'XYZ'===order?(this._x=_Mathatan2(2*(q.x*q.w-q.y*q.z),sqw-sqx-sqy+sqz),this._y=_Mathasin2(clamp(2*(q.x*q.z+q.y*q.w))),this._z=_Mathatan2(2*(q.z*q.w-q.x*q.y),sqw+sqx-sqy-sqz)):'YXZ'===order?(this._x=_Mathasin2(clamp(2*(q.x*q.w-q.y*q.z))),this._y=_Mathatan2(2*(q.x*q.z+q.y*q.w),sqw-sqx-sqy+sqz),this._z=_Mathatan2(2*(q.x*q.y+q.z*q.w),sqw-sqx+sqy-sqz)):'ZXY'===order?(this._x=_Mathasin2(clamp(2*(q.x*q.w+q.y*q.z))),this._y=_Mathatan2(2*(q.y*q.w-q.z*q.x),sqw-sqx-sqy+sqz),this._z=_Mathatan2(2*(q.z*q.w-q.x*q.y),sqw-sqx+sqy-sqz)):'ZYX'===order?(this._x=_Mathatan2(2*(q.x*q.w+q.z*q.y),sqw-sqx-sqy+sqz),this._y=_Mathasin2(clamp(2*(q.y*q.w-q.x*q.z))),this._z=_Mathatan2(2*(q.x*q.y+q.z*q.w),sqw+sqx-sqy-sqz)):'YZX'===order?(this._x=_Mathatan2(2*(q.x*q.w-q.z*q.y),sqw-sqx+sqy-sqz),this._y=_Mathatan2(2*(q.y*q.w-q.x*q.z),sqw+sqx-sqy-sqz),this._z=_Mathasin2(clamp(2*(q.x*q.y+q.z*q.w)))):'XZY'===order?(this._x=_Mathatan2(2*(q.x*q.w+q.y*q.z),sqw-sqx+sqy-sqz),this._y=_Mathatan2(2*(q.x*q.z+q.y*q.w),sqw+sqx-sqy-sqz),this._z=_Mathasin2(clamp(2*(q.z*q.w-q.x*q.y)))):console.warn('WARNING: Euler.setFromQuaternion() given unsupported order: '+order),this._order=order,!1!==update&&this._updateQuaternion(),this},reorder:function(){var q=new THREE.Quaternion;return function(newOrder){q.setFromEuler(this),this.setFromQuaternion(q,newOrder)}}(),fromArray:function fromArray(array){return this._x=array[0],this._y=array[1],this._z=array[2],void 0!==array[3]&&(this._order=array[3]),this._updateQuaternion(),this},toArray:function toArray(){return[this._x,this._y,this._z,this._order]},equals:function equals(euler){return euler._x===this._x&&euler._y===this._y&&euler._z===this._z&&euler._order===this._order},clone:function clone(){return new THREE.Euler(this._x,this._y,this._z,this._order)}},THREE.Line3=function(start,end){this.start=start===void 0?new THREE.Vector3:start,this.end=end===void 0?new THREE.Vector3:end},THREE.Line3.prototype={constructor:THREE.Line3,set:function set(start,end){return this.start.copy(start),this.end.copy(end),this},copy:function copy(line){return this.start.copy(line.start),this.end.copy(line.end),this},center:function center(optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.addVectors(this.start,this.end).multiplyScalar(.5)},delta:function delta(optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.subVectors(this.end,this.start)},distanceSq:function distanceSq(){return this.start.distanceToSquared(this.end)},distance:function distance(){return this.start.distanceTo(this.end)},at:function at(t,optionalTarget){var result=optionalTarget||new THREE.Vector3;return this.delta(result).multiplyScalar(t).add(this.start)},closestPointToPointParameter:function(){var startP=new THREE.Vector3,startEnd=new THREE.Vector3;return function(point,clampToLine){startP.subVectors(point,this.start),startEnd.subVectors(this.end,this.start);var startEnd2=startEnd.dot(startEnd),startEnd_startP=startEnd.dot(startP),t=startEnd_startP/startEnd2;return clampToLine&&(t=THREE.Math.clamp(t,0,1)),t}}(),closestPointToPoint:function closestPointToPoint(point,clampToLine,optionalTarget){var t=this.closestPointToPointParameter(point,clampToLine),result=optionalTarget||new THREE.Vector3;return this.delta(result).multiplyScalar(t).add(this.start)},applyMatrix4:function applyMatrix4(matrix){return this.start.applyMatrix4(matrix),this.end.applyMatrix4(matrix),this},equals:function equals(line){return line.start.equals(this.start)&&line.end.equals(this.end)},clone:function clone(){return new THREE.Line3().copy(this)}},THREE.Box2=function(min,max){this.min=min===void 0?new THREE.Vector2(Infinity,Infinity):min,this.max=max===void 0?new THREE.Vector2(-Infinity,-Infinity):max},THREE.Box2.prototype={constructor:THREE.Box2,set:function set(min,max){return this.min.copy(min),this.max.copy(max),this},setFromPoints:function setFromPoints(points){if(0<points.length){var point=points[0];this.min.copy(point),this.max.copy(point);for(var i=1,il=points.length;i<il;i++)point=points[i],point.x<this.min.x?this.min.x=point.x:point.x>this.max.x&&(this.max.x=point.x),point.y<this.min.y?this.min.y=point.y:point.y>this.max.y&&(this.max.y=point.y)}else this.makeEmpty();return this},setFromCenterAndSize:function(){var v1=new THREE.Vector2;return function(center,size){var halfSize=v1.copy(size).multiplyScalar(.5);return this.min.copy(center).sub(halfSize),this.max.copy(center).add(halfSize),this}}(),copy:function copy(box){return this.min.copy(box.min),this.max.copy(box.max),this},makeEmpty:function makeEmpty(){return this.min.x=this.min.y=Infinity,this.max.x=this.max.y=-Infinity,this},empty:function empty(){return this.max.x<this.min.x||this.max.y<this.min.y},center:function center(optionalTarget){var result=optionalTarget||new THREE.Vector2;return result.addVectors(this.min,this.max).multiplyScalar(.5)},size:function size(optionalTarget){var result=optionalTarget||new THREE.Vector2;return result.subVectors(this.max,this.min)},expandByPoint:function expandByPoint(point){return this.min.min(point),this.max.max(point),this},expandByVector:function expandByVector(vector){return this.min.sub(vector),this.max.add(vector),this},expandByScalar:function expandByScalar(scalar){return this.min.addScalar(-scalar),this.max.addScalar(scalar),this},containsPoint:function containsPoint(point){return!(point.x<this.min.x||point.x>this.max.x||point.y<this.min.y||point.y>this.max.y)},containsBox:function containsBox(box){return!!(this.min.x<=box.min.x&&box.max.x<=this.max.x&&this.min.y<=box.min.y&&box.max.y<=this.max.y)},getParameter:function getParameter(point){return new THREE.Vector2((point.x-this.min.x)/(this.max.x-this.min.x),(point.y-this.min.y)/(this.max.y-this.min.y))},isIntersectionBox:function isIntersectionBox(box){return!(box.max.x<this.min.x||box.min.x>this.max.x||box.max.y<this.min.y||box.min.y>this.max.y)},clampPoint:function clampPoint(point,optionalTarget){var result=optionalTarget||new THREE.Vector2;return result.copy(point).clamp(this.min,this.max)},distanceToPoint:function(){var v1=new THREE.Vector2;return function(point){var clampedPoint=v1.copy(point).clamp(this.min,this.max);return clampedPoint.sub(point).length()}}(),intersect:function intersect(box){return this.min.max(box.min),this.max.min(box.max),this},union:function union(box){return this.min.min(box.min),this.max.max(box.max),this},translate:function translate(offset){return this.min.add(offset),this.max.add(offset),this},equals:function equals(box){return box.min.equals(this.min)&&box.max.equals(this.max)},clone:function clone(){return new THREE.Box2().copy(this)}},THREE.Box3=function(min,max){this.min=min===void 0?new THREE.Vector3(Infinity,Infinity,Infinity):min,this.max=max===void 0?new THREE.Vector3(-Infinity,-Infinity,-Infinity):max},THREE.Box3.prototype={constructor:THREE.Box3,set:function set(min,max){return this.min.copy(min),this.max.copy(max),this},addPoint:function addPoint(point){point.x<this.min.x?this.min.x=point.x:point.x>this.max.x&&(this.max.x=point.x),point.y<this.min.y?this.min.y=point.y:point.y>this.max.y&&(this.max.y=point.y),point.z<this.min.z?this.min.z=point.z:point.z>this.max.z&&(this.max.z=point.z)},setFromPoints:function setFromPoints(points){if(0<points.length){var point=points[0];this.min.copy(point),this.max.copy(point);for(var i=1,il=points.length;i<il;i++)this.addPoint(points[i])}else this.makeEmpty();return this},setFromCenterAndSize:function(){var v1=new THREE.Vector3;return function(center,size){var halfSize=v1.copy(size).multiplyScalar(.5);return this.min.copy(center).sub(halfSize),this.max.copy(center).add(halfSize),this}}(),setFromObject:function(){var v1=new THREE.Vector3;return function(object){var scope=this;return object.updateMatrixWorld(!0),this.makeEmpty(),object.traverse(function(node){if(void 0!==node.geometry&&void 0!==node.geometry.vertices)for(var vertices=node.geometry.vertices,i=0,il=vertices.length;i<il;i++)v1.copy(vertices[i]),v1.applyMatrix4(node.matrixWorld),scope.expandByPoint(v1)}),this}}(),copy:function copy(box){return this.min.copy(box.min),this.max.copy(box.max),this},makeEmpty:function makeEmpty(){return this.min.x=this.min.y=this.min.z=Infinity,this.max.x=this.max.y=this.max.z=-Infinity,this},empty:function empty(){return this.max.x<this.min.x||this.max.y<this.min.y||this.max.z<this.min.z},center:function center(optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.addVectors(this.min,this.max).multiplyScalar(.5)},size:function size(optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.subVectors(this.max,this.min)},expandByPoint:function expandByPoint(point){return this.min.min(point),this.max.max(point),this},expandByVector:function expandByVector(vector){return this.min.sub(vector),this.max.add(vector),this},expandByScalar:function expandByScalar(scalar){return this.min.addScalar(-scalar),this.max.addScalar(scalar),this},containsPoint:function containsPoint(point){return!(point.x<this.min.x||point.x>this.max.x||point.y<this.min.y||point.y>this.max.y||point.z<this.min.z||point.z>this.max.z)},containsBox:function containsBox(box){return!!(this.min.x<=box.min.x&&box.max.x<=this.max.x&&this.min.y<=box.min.y&&box.max.y<=this.max.y&&this.min.z<=box.min.z&&box.max.z<=this.max.z)},getParameter:function getParameter(point){return new THREE.Vector3((point.x-this.min.x)/(this.max.x-this.min.x),(point.y-this.min.y)/(this.max.y-this.min.y),(point.z-this.min.z)/(this.max.z-this.min.z))},isIntersectionBox:function isIntersectionBox(box){return!(box.max.x<this.min.x||box.min.x>this.max.x||box.max.y<this.min.y||box.min.y>this.max.y||box.max.z<this.min.z||box.min.z>this.max.z)},clampPoint:function clampPoint(point,optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.copy(point).clamp(this.min,this.max)},distanceToPoint:function(){var v1=new THREE.Vector3;return function(point){var clampedPoint=v1.copy(point).clamp(this.min,this.max);return clampedPoint.sub(point).length()}}(),getBoundingSphere:function(){var v1=new THREE.Vector3;return function(optionalTarget){var result=optionalTarget||new THREE.Sphere;return result.center=this.center(),result.radius=.5*this.size(v1).length(),result}}(),intersect:function intersect(box){return this.min.max(box.min),this.max.min(box.max),this},union:function union(box){return this.min.min(box.min),this.max.max(box.max),this},applyMatrix4:function(){var points=[new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3,new THREE.Vector3];return function(matrix){return points[0].set(this.min.x,this.min.y,this.min.z).applyMatrix4(matrix),points[1].set(this.min.x,this.min.y,this.max.z).applyMatrix4(matrix),points[2].set(this.min.x,this.max.y,this.min.z).applyMatrix4(matrix),points[3].set(this.min.x,this.max.y,this.max.z).applyMatrix4(matrix),points[4].set(this.max.x,this.min.y,this.min.z).applyMatrix4(matrix),points[5].set(this.max.x,this.min.y,this.max.z).applyMatrix4(matrix),points[6].set(this.max.x,this.max.y,this.min.z).applyMatrix4(matrix),points[7].set(this.max.x,this.max.y,this.max.z).applyMatrix4(matrix),this.makeEmpty(),this.setFromPoints(points),this}}(),translate:function translate(offset){return this.min.add(offset),this.max.add(offset),this},equals:function equals(box){return box.min.equals(this.min)&&box.max.equals(this.max)},clone:function clone(){return new THREE.Box3().copy(this)}},THREE.Matrix3=function(n11,n12,n13,n21,n22,n23,n31,n32,n33){this.elements=new Float32Array(9),this.set(n11===void 0?1:n11,n12||0,n13||0,n21||0,n22===void 0?1:n22,n23||0,n31||0,n32||0,n33===void 0?1:n33)},THREE.Matrix3.prototype={constructor:THREE.Matrix3,set:function set(n11,n12,n13,n21,n22,n23,n31,n32,n33){var te=this.elements;return te[0]=n11,te[3]=n12,te[6]=n13,te[1]=n21,te[4]=n22,te[7]=n23,te[2]=n31,te[5]=n32,te[8]=n33,this},identity:function identity(){return this.set(1,0,0,0,1,0,0,0,1),this},copy:function copy(m){var me=m.elements;return this.set(me[0],me[3],me[6],me[1],me[4],me[7],me[2],me[5],me[8]),this},multiplyVector3:function multiplyVector3(vector){return console.warn('DEPRECATED: Matrix3\'s .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.'),vector.applyMatrix3(this)},multiplyVector3Array:function(){var v1=new THREE.Vector3;return function(a){for(var i=0,il=a.length;i<il;i+=3)v1.x=a[i],v1.y=a[i+1],v1.z=a[i+2],v1.applyMatrix3(this),a[i]=v1.x,a[i+1]=v1.y,a[i+2]=v1.z;return a}}(),multiplyScalar:function multiplyScalar(s){var te=this.elements;return te[0]*=s,te[3]*=s,te[6]*=s,te[1]*=s,te[4]*=s,te[7]*=s,te[2]*=s,te[5]*=s,te[8]*=s,this},determinant:function determinant(){var te=this.elements,a=te[0],b=te[1],c=te[2],d=te[3],e=te[4],f=te[5],g=te[6],h=te[7],i=te[8];return a*e*i-a*f*h-b*d*i+b*f*g+c*d*h-c*e*g},getInverse:function getInverse(matrix,throwOnInvertible){var me=matrix.elements,te=this.elements;te[0]=me[10]*me[5]-me[6]*me[9],te[1]=-me[10]*me[1]+me[2]*me[9],te[2]=me[6]*me[1]-me[2]*me[5],te[3]=-me[10]*me[4]+me[6]*me[8],te[4]=me[10]*me[0]-me[2]*me[8],te[5]=-me[6]*me[0]+me[2]*me[4],te[6]=me[9]*me[4]-me[5]*me[8],te[7]=-me[9]*me[0]+me[1]*me[8],te[8]=me[5]*me[0]-me[1]*me[4];var det=me[0]*te[0]+me[1]*te[3]+me[2]*te[6];if(0==det){if(throwOnInvertible||!1)throw new Error('Matrix3.getInverse(): can\'t invert matrix, determinant is 0');else;return this.identity(),this}return this.multiplyScalar(1/det),this},transpose:function transpose(){var m=this.elements,tmp;return tmp=m[1],m[1]=m[3],m[3]=tmp,tmp=m[2],m[2]=m[6],m[6]=tmp,tmp=m[5],m[5]=m[7],m[7]=tmp,this},getNormalMatrix:function getNormalMatrix(m){return this.getInverse(m).transpose(),this},transposeIntoArray:function transposeIntoArray(r){var m=this.elements;return r[0]=m[0],r[1]=m[3],r[2]=m[6],r[3]=m[1],r[4]=m[4],r[5]=m[7],r[6]=m[2],r[7]=m[5],r[8]=m[8],this},clone:function clone(){var te=this.elements;return new THREE.Matrix3(te[0],te[3],te[6],te[1],te[4],te[7],te[2],te[5],te[8])}},THREE.Matrix4=function(n11,n12,n13,n14,n21,n22,n23,n24,n31,n32,n33,n34,n41,n42,n43,n44){this.elements=new Float32Array(16);var te=this.elements;te[0]=n11===void 0?1:n11,te[4]=n12||0,te[8]=n13||0,te[12]=n14||0,te[1]=n21||0,te[5]=n22===void 0?1:n22,te[9]=n23||0,te[13]=n24||0,te[2]=n31||0,te[6]=n32||0,te[10]=n33===void 0?1:n33,te[14]=n34||0,te[3]=n41||0,te[7]=n42||0,te[11]=n43||0,te[15]=n44===void 0?1:n44},THREE.Matrix4.prototype={constructor:THREE.Matrix4,set:function set(n11,n12,n13,n14,n21,n22,n23,n24,n31,n32,n33,n34,n41,n42,n43,n44){var te=this.elements;return te[0]=n11,te[4]=n12,te[8]=n13,te[12]=n14,te[1]=n21,te[5]=n22,te[9]=n23,te[13]=n24,te[2]=n31,te[6]=n32,te[10]=n33,te[14]=n34,te[3]=n41,te[7]=n42,te[11]=n43,te[15]=n44,this},identity:function identity(){return this.set(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1),this},copy:function copy(m){return this.elements.set(m.elements),this},extractPosition:function extractPosition(m){return console.warn('DEPRECATED: Matrix4\'s .extractPosition() has been renamed to .copyPosition().'),this.copyPosition(m)},copyPosition:function copyPosition(m){var te=this.elements,me=m.elements;return te[12]=me[12],te[13]=me[13],te[14]=me[14],this},extractRotation:function(){var v1=new THREE.Vector3;return function(m){var te=this.elements,me=m.elements,scaleX=1/v1.set(me[0],me[1],me[2]).length(),scaleY=1/v1.set(me[4],me[5],me[6]).length(),scaleZ=1/v1.set(me[8],me[9],me[10]).length();return te[0]=me[0]*scaleX,te[1]=me[1]*scaleX,te[2]=me[2]*scaleX,te[4]=me[4]*scaleY,te[5]=me[5]*scaleY,te[6]=me[6]*scaleY,te[8]=me[8]*scaleZ,te[9]=me[9]*scaleZ,te[10]=me[10]*scaleZ,this}}(),makeRotationFromEuler:function makeRotationFromEuler(euler){var _Mathsin3=Math.sin,_Mathcos2=Math.cos;!1==euler instanceof THREE.Euler&&console.error('ERROR: Matrix\'s .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.  Please update your code.');var te=this.elements,x=euler.x,y=euler.y,z=euler.z,a=_Mathcos2(x),b=_Mathsin3(x),c=_Mathcos2(y),d=_Mathsin3(y),e=_Mathcos2(z),f=_Mathsin3(z);if('XYZ'===euler.order){var ae=a*e,af=a*f,be=b*e,bf=b*f;te[0]=c*e,te[4]=-c*f,te[8]=d,te[1]=af+be*d,te[5]=ae-bf*d,te[9]=-b*c,te[2]=bf-ae*d,te[6]=be+af*d,te[10]=a*c}else if('YXZ'===euler.order){var ce=c*e,cf=c*f,de=d*e,df=d*f;te[0]=ce+df*b,te[4]=de*b-cf,te[8]=a*d,te[1]=a*f,te[5]=a*e,te[9]=-b,te[2]=cf*b-de,te[6]=df+ce*b,te[10]=a*c}else if('ZXY'===euler.order){var ce=c*e,cf=c*f,de=d*e,df=d*f;te[0]=ce-df*b,te[4]=-a*f,te[8]=de+cf*b,te[1]=cf+de*b,te[5]=a*e,te[9]=df-ce*b,te[2]=-a*d,te[6]=b,te[10]=a*c}else if('ZYX'===euler.order){var ae=a*e,af=a*f,be=b*e,bf=b*f;te[0]=c*e,te[4]=be*d-af,te[8]=ae*d+bf,te[1]=c*f,te[5]=bf*d+ae,te[9]=af*d-be,te[2]=-d,te[6]=b*c,te[10]=a*c}else if('YZX'===euler.order){var ac=a*c,ad=a*d,bc=b*c,bd=b*d;te[0]=c*e,te[4]=bd-ac*f,te[8]=bc*f+ad,te[1]=f,te[5]=a*e,te[9]=-b*e,te[2]=-d*e,te[6]=ad*f+bc,te[10]=ac-bd*f}else if('XZY'===euler.order){var ac=a*c,ad=a*d,bc=b*c,bd=b*d;te[0]=c*e,te[4]=-f,te[8]=d*e,te[1]=ac*f+bd,te[5]=a*e,te[9]=ad*f-bc,te[2]=bc*f-ad,te[6]=b*e,te[10]=bd*f+ac}return te[3]=0,te[7]=0,te[11]=0,te[12]=0,te[13]=0,te[14]=0,te[15]=1,this},setRotationFromQuaternion:function setRotationFromQuaternion(q){return console.warn('DEPRECATED: Matrix4\'s .setRotationFromQuaternion() has been deprecated in favor of makeRotationFromQuaternion.  Please update your code.'),this.makeRotationFromQuaternion(q)},makeRotationFromQuaternion:function makeRotationFromQuaternion(q){var te=this.elements,x=q.x,y=q.y,z=q.z,w=q.w,x2=x+x,y2=y+y,z2=z+z,xx=x*x2,xy=x*y2,xz=x*z2,yy=y*y2,yz=y*z2,zz=z*z2,wx=w*x2,wy=w*y2,wz=w*z2;return te[0]=1-(yy+zz),te[4]=xy-wz,te[8]=xz+wy,te[1]=xy+wz,te[5]=1-(xx+zz),te[9]=yz-wx,te[2]=xz-wy,te[6]=yz+wx,te[10]=1-(xx+yy),te[3]=0,te[7]=0,te[11]=0,te[12]=0,te[13]=0,te[14]=0,te[15]=1,this},lookAt:function(){var x=new THREE.Vector3,y=new THREE.Vector3,z=new THREE.Vector3;return function(eye,target,up){var te=this.elements;return z.subVectors(eye,target).normalize(),0===z.length()&&(z.z=1),x.crossVectors(up,z).normalize(),0===x.length()&&(z.x+=1e-4,x.crossVectors(up,z).normalize()),y.crossVectors(z,x),te[0]=x.x,te[4]=y.x,te[8]=z.x,te[1]=x.y,te[5]=y.y,te[9]=z.y,te[2]=x.z,te[6]=y.z,te[10]=z.z,this}}(),multiply:function multiply(m,n){return void 0===n?this.multiplyMatrices(this,m):(console.warn('DEPRECATED: Matrix4\'s .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.'),this.multiplyMatrices(m,n))},multiplyMatrices:function multiplyMatrices(a,b){var ae=a.elements,be=b.elements,te=this.elements,a11=ae[0],a12=ae[4],a13=ae[8],a14=ae[12],a21=ae[1],a22=ae[5],a23=ae[9],a24=ae[13],a31=ae[2],a32=ae[6],a33=ae[10],a34=ae[14],a41=ae[3],a42=ae[7],a43=ae[11],a44=ae[15],b11=be[0],b12=be[4],b13=be[8],b14=be[12],b21=be[1],b22=be[5],b23=be[9],b24=be[13],b31=be[2],b32=be[6],b33=be[10],b34=be[14],b41=be[3],b42=be[7],b43=be[11],b44=be[15];return te[0]=a11*b11+a12*b21+a13*b31+a14*b41,te[4]=a11*b12+a12*b22+a13*b32+a14*b42,te[8]=a11*b13+a12*b23+a13*b33+a14*b43,te[12]=a11*b14+a12*b24+a13*b34+a14*b44,te[1]=a21*b11+a22*b21+a23*b31+a24*b41,te[5]=a21*b12+a22*b22+a23*b32+a24*b42,te[9]=a21*b13+a22*b23+a23*b33+a24*b43,te[13]=a21*b14+a22*b24+a23*b34+a24*b44,te[2]=a31*b11+a32*b21+a33*b31+a34*b41,te[6]=a31*b12+a32*b22+a33*b32+a34*b42,te[10]=a31*b13+a32*b23+a33*b33+a34*b43,te[14]=a31*b14+a32*b24+a33*b34+a34*b44,te[3]=a41*b11+a42*b21+a43*b31+a44*b41,te[7]=a41*b12+a42*b22+a43*b32+a44*b42,te[11]=a41*b13+a42*b23+a43*b33+a44*b43,te[15]=a41*b14+a42*b24+a43*b34+a44*b44,this},multiplyToArray:function multiplyToArray(a,b,r){var te=this.elements;return this.multiplyMatrices(a,b),r[0]=te[0],r[1]=te[1],r[2]=te[2],r[3]=te[3],r[4]=te[4],r[5]=te[5],r[6]=te[6],r[7]=te[7],r[8]=te[8],r[9]=te[9],r[10]=te[10],r[11]=te[11],r[12]=te[12],r[13]=te[13],r[14]=te[14],r[15]=te[15],this},multiplyScalar:function multiplyScalar(s){var te=this.elements;return te[0]*=s,te[4]*=s,te[8]*=s,te[12]*=s,te[1]*=s,te[5]*=s,te[9]*=s,te[13]*=s,te[2]*=s,te[6]*=s,te[10]*=s,te[14]*=s,te[3]*=s,te[7]*=s,te[11]*=s,te[15]*=s,this},multiplyVector3:function multiplyVector3(vector){return console.warn('DEPRECATED: Matrix4\'s .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) or vector.applyProjection( matrix ) instead.'),vector.applyProjection(this)},multiplyVector4:function multiplyVector4(vector){return console.warn('DEPRECATED: Matrix4\'s .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.'),vector.applyMatrix4(this)},multiplyVector3Array:function(){var v1=new THREE.Vector3;return function(a){for(var i=0,il=a.length;i<il;i+=3)v1.x=a[i],v1.y=a[i+1],v1.z=a[i+2],v1.applyProjection(this),a[i]=v1.x,a[i+1]=v1.y,a[i+2]=v1.z;return a}}(),rotateAxis:function rotateAxis(v){console.warn('DEPRECATED: Matrix4\'s .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.'),v.transformDirection(this)},crossVector:function crossVector(vector){return console.warn('DEPRECATED: Matrix4\'s .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.'),vector.applyMatrix4(this)},determinant:function determinant(){var te=this.elements,n11=te[0],n12=te[4],n13=te[8],n14=te[12],n21=te[1],n22=te[5],n23=te[9],n24=te[13],n31=te[2],n32=te[6],n33=te[10],n34=te[14],n41=te[3],n42=te[7],n43=te[11],n44=te[15];return n41*(+n14*n23*n32-n13*n24*n32-n14*n22*n33+n12*n24*n33+n13*n22*n34-n12*n23*n34)+n42*(+n11*n23*n34-n11*n24*n33+n14*n21*n33-n13*n21*n34+n13*n24*n31-n14*n23*n31)+n43*(+n11*n24*n32-n11*n22*n34-n14*n21*n32+n12*n21*n34+n14*n22*n31-n12*n24*n31)+n44*(-n13*n22*n31-n11*n23*n32+n11*n22*n33+n13*n21*n32-n12*n21*n33+n12*n23*n31)},transpose:function transpose(){var te=this.elements,tmp;return tmp=te[1],te[1]=te[4],te[4]=tmp,tmp=te[2],te[2]=te[8],te[8]=tmp,tmp=te[6],te[6]=te[9],te[9]=tmp,tmp=te[3],te[3]=te[12],te[12]=tmp,tmp=te[7],te[7]=te[13],te[13]=tmp,tmp=te[11],te[11]=te[14],te[14]=tmp,this},flattenToArray:function flattenToArray(flat){var te=this.elements;return flat[0]=te[0],flat[1]=te[1],flat[2]=te[2],flat[3]=te[3],flat[4]=te[4],flat[5]=te[5],flat[6]=te[6],flat[7]=te[7],flat[8]=te[8],flat[9]=te[9],flat[10]=te[10],flat[11]=te[11],flat[12]=te[12],flat[13]=te[13],flat[14]=te[14],flat[15]=te[15],flat},flattenToArrayOffset:function flattenToArrayOffset(flat,offset){var te=this.elements;return flat[offset]=te[0],flat[offset+1]=te[1],flat[offset+2]=te[2],flat[offset+3]=te[3],flat[offset+4]=te[4],flat[offset+5]=te[5],flat[offset+6]=te[6],flat[offset+7]=te[7],flat[offset+8]=te[8],flat[offset+9]=te[9],flat[offset+10]=te[10],flat[offset+11]=te[11],flat[offset+12]=te[12],flat[offset+13]=te[13],flat[offset+14]=te[14],flat[offset+15]=te[15],flat},getPosition:function(){var v1=new THREE.Vector3;return function(){console.warn('DEPRECATED: Matrix4\'s .getPosition() has been removed. Use Vector3.getPositionFromMatrix( matrix ) instead.');var te=this.elements;return v1.set(te[12],te[13],te[14])}}(),setPosition:function setPosition(v){var te=this.elements;return te[12]=v.x,te[13]=v.y,te[14]=v.z,this},getInverse:function getInverse(m,throwOnInvertible){var te=this.elements,me=m.elements,n11=me[0],n12=me[4],n13=me[8],n14=me[12],n21=me[1],n22=me[5],n23=me[9],n24=me[13],n31=me[2],n32=me[6],n33=me[10],n34=me[14],n41=me[3],n42=me[7],n43=me[11],n44=me[15];te[0]=n23*n34*n42-n24*n33*n42+n24*n32*n43-n22*n34*n43-n23*n32*n44+n22*n33*n44,te[4]=n14*n33*n42-n13*n34*n42-n14*n32*n43+n12*n34*n43+n13*n32*n44-n12*n33*n44,te[8]=n13*n24*n42-n14*n23*n42+n14*n22*n43-n12*n24*n43-n13*n22*n44+n12*n23*n44,te[12]=n14*n23*n32-n13*n24*n32-n14*n22*n33+n12*n24*n33+n13*n22*n34-n12*n23*n34,te[1]=n24*n33*n41-n23*n34*n41-n24*n31*n43+n21*n34*n43+n23*n31*n44-n21*n33*n44,te[5]=n13*n34*n41-n14*n33*n41+n14*n31*n43-n11*n34*n43-n13*n31*n44+n11*n33*n44,te[9]=n14*n23*n41-n13*n24*n41-n14*n21*n43+n11*n24*n43+n13*n21*n44-n11*n23*n44,te[13]=n13*n24*n31-n14*n23*n31+n14*n21*n33-n11*n24*n33-n13*n21*n34+n11*n23*n34,te[2]=n22*n34*n41-n24*n32*n41+n24*n31*n42-n21*n34*n42-n22*n31*n44+n21*n32*n44,te[6]=n14*n32*n41-n12*n34*n41-n14*n31*n42+n11*n34*n42+n12*n31*n44-n11*n32*n44,te[10]=n12*n24*n41-n14*n22*n41+n14*n21*n42-n11*n24*n42-n12*n21*n44+n11*n22*n44,te[14]=n14*n22*n31-n12*n24*n31-n14*n21*n32+n11*n24*n32+n12*n21*n34-n11*n22*n34,te[3]=n23*n32*n41-n22*n33*n41-n23*n31*n42+n21*n33*n42+n22*n31*n43-n21*n32*n43,te[7]=n12*n33*n41-n13*n32*n41+n13*n31*n42-n11*n33*n42-n12*n31*n43+n11*n32*n43,te[11]=n13*n22*n41-n12*n23*n41-n13*n21*n42+n11*n23*n42+n12*n21*n43-n11*n22*n43,te[15]=n12*n23*n31-n13*n22*n31+n13*n21*n32-n11*n23*n32-n12*n21*n33+n11*n22*n33;var det=n11*te[0]+n21*te[4]+n31*te[8]+n41*te[12];if(0==det){var msg='Matrix4.getInverse(): can\'t invert matrix, determinant is 0';if(throwOnInvertible||!1)throw new Error(msg);else console.warn(msg);return this.identity(),this}return this.multiplyScalar(1/det),this},translate:function translate(){console.warn('DEPRECATED: Matrix4\'s .translate() has been removed.')},rotateX:function rotateX(){console.warn('DEPRECATED: Matrix4\'s .rotateX() has been removed.')},rotateY:function rotateY(){console.warn('DEPRECATED: Matrix4\'s .rotateY() has been removed.')},rotateZ:function rotateZ(){console.warn('DEPRECATED: Matrix4\'s .rotateZ() has been removed.')},rotateByAxis:function rotateByAxis(){console.warn('DEPRECATED: Matrix4\'s .rotateByAxis() has been removed.')},scale:function scale(v){var te=this.elements,x=v.x,y=v.y,z=v.z;return te[0]*=x,te[4]*=y,te[8]*=z,te[1]*=x,te[5]*=y,te[9]*=z,te[2]*=x,te[6]*=y,te[10]*=z,te[3]*=x,te[7]*=y,te[11]*=z,this},getMaxScaleOnAxis:function getMaxScaleOnAxis(){var _Mathmax=Math.max,te=this.elements,scaleXSq=te[0]*te[0]+te[1]*te[1]+te[2]*te[2],scaleYSq=te[4]*te[4]+te[5]*te[5]+te[6]*te[6],scaleZSq=te[8]*te[8]+te[9]*te[9]+te[10]*te[10];return Math.sqrt(_Mathmax(scaleXSq,_Mathmax(scaleYSq,scaleZSq)))},makeTranslation:function makeTranslation(x,y,z){return this.set(1,0,0,x,0,1,0,y,0,0,1,z,0,0,0,1),this},makeRotationX:function makeRotationX(theta){var c=Math.cos(theta),s=Math.sin(theta);return this.set(1,0,0,0,0,c,-s,0,0,s,c,0,0,0,0,1),this},makeRotationY:function makeRotationY(theta){var c=Math.cos(theta),s=Math.sin(theta);return this.set(c,0,s,0,0,1,0,0,-s,0,c,0,0,0,0,1),this},makeRotationZ:function makeRotationZ(theta){var c=Math.cos(theta),s=Math.sin(theta);return this.set(c,-s,0,0,s,c,0,0,0,0,1,0,0,0,0,1),this},makeRotationAxis:function makeRotationAxis(axis,angle){var c=Math.cos(angle),s=Math.sin(angle),t=1-c,x=axis.x,y=axis.y,z=axis.z,tx=t*x,ty=t*y;return this.set(tx*x+c,tx*y-s*z,tx*z+s*y,0,tx*y+s*z,ty*y+c,ty*z-s*x,0,tx*z-s*y,ty*z+s*x,t*z*z+c,0,0,0,0,1),this},makeScale:function makeScale(x,y,z){return this.set(x,0,0,0,0,y,0,0,0,0,z,0,0,0,0,1),this},compose:function compose(position,quaternion,scale){return this.makeRotationFromQuaternion(quaternion),this.scale(scale),this.setPosition(position),this},decompose:function(){var vector=new THREE.Vector3,matrix=new THREE.Matrix4;return function(position,quaternion,scale){var te=this.elements,sx=vector.set(te[0],te[1],te[2]).length(),sy=vector.set(te[4],te[5],te[6]).length(),sz=vector.set(te[8],te[9],te[10]).length();position.x=te[12],position.y=te[13],position.z=te[14],matrix.elements.set(this.elements);var invSX=1/sx,invSY=1/sy,invSZ=1/sz;return matrix.elements[0]*=invSX,matrix.elements[1]*=invSX,matrix.elements[2]*=invSX,matrix.elements[4]*=invSY,matrix.elements[5]*=invSY,matrix.elements[6]*=invSY,matrix.elements[8]*=invSZ,matrix.elements[9]*=invSZ,matrix.elements[10]*=invSZ,quaternion.setFromRotationMatrix(matrix),scale.x=sx,scale.y=sy,scale.z=sz,this}}(),makeFrustum:function makeFrustum(left,right,bottom,top,near,far){var te=this.elements;return te[0]=2*near/(right-left),te[4]=0,te[8]=(right+left)/(right-left),te[12]=0,te[1]=0,te[5]=2*near/(top-bottom),te[9]=(top+bottom)/(top-bottom),te[13]=0,te[2]=0,te[6]=0,te[10]=-(far+near)/(far-near),te[14]=-2*far*near/(far-near),te[3]=0,te[7]=0,te[11]=-1,te[15]=0,this},makePerspective:function makePerspective(fov,aspect,near,far){var ymax=near*Math.tan(THREE.Math.degToRad(.5*fov)),ymin=-ymax;return this.makeFrustum(ymin*aspect,ymax*aspect,ymin,ymax,near,far)},makeOrthographic:function makeOrthographic(left,right,top,bottom,near,far){var te=this.elements,w=right-left,h=top-bottom,p=far-near;return te[0]=2/w,te[4]=0,te[8]=0,te[12]=-((right+left)/w),te[1]=0,te[5]=2/h,te[9]=0,te[13]=-((top+bottom)/h),te[2]=0,te[6]=0,te[10]=-2/p,te[14]=-((far+near)/p),te[3]=0,te[7]=0,te[11]=0,te[15]=1,this},fromArray:function fromArray(array){return this.elements.set(array),this},toArray:function toArray(){var te=this.elements;return[te[0],te[1],te[2],te[3],te[4],te[5],te[6],te[7],te[8],te[9],te[10],te[11],te[12],te[13],te[14],te[15]]},clone:function clone(){var te=this.elements;return new THREE.Matrix4(te[0],te[4],te[8],te[12],te[1],te[5],te[9],te[13],te[2],te[6],te[10],te[14],te[3],te[7],te[11],te[15])}},THREE.Ray=function(origin,direction){this.origin=origin===void 0?new THREE.Vector3:origin,this.direction=direction===void 0?new THREE.Vector3:direction},THREE.Ray.prototype={constructor:THREE.Ray,set:function set(origin,direction){return this.origin.copy(origin),this.direction.copy(direction),this},copy:function copy(ray){return this.origin.copy(ray.origin),this.direction.copy(ray.direction),this},at:function at(t,optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.copy(this.direction).multiplyScalar(t).add(this.origin)},recast:function(){var v1=new THREE.Vector3;return function(t){return this.origin.copy(this.at(t,v1)),this}}(),closestPointToPoint:function closestPointToPoint(point,optionalTarget){var result=optionalTarget||new THREE.Vector3;result.subVectors(point,this.origin);var directionDistance=result.dot(this.direction);return 0>directionDistance?result.copy(this.origin):result.copy(this.direction).multiplyScalar(directionDistance).add(this.origin)},distanceToPoint:function(){var v1=new THREE.Vector3;return function(point){var directionDistance=v1.subVectors(point,this.origin).dot(this.direction);return 0>directionDistance?this.origin.distanceTo(point):(v1.copy(this.direction).multiplyScalar(directionDistance).add(this.origin),v1.distanceTo(point))}}(),distanceSqToSegment:function distanceSqToSegment(v0,v1,optionalPointOnRay,optionalPointOnSegment){var _Mathmin2=Math.min,_Mathmax2=Math.max,segCenter=v0.clone().add(v1).multiplyScalar(.5),segDir=v1.clone().sub(v0).normalize(),segExtent=.5*v0.distanceTo(v1),diff=this.origin.clone().sub(segCenter),a01=-this.direction.dot(segDir),b0=diff.dot(this.direction),b1=-diff.dot(segDir),c=diff.lengthSq(),det=Math.abs(1-a01*a01),s0,s1,sqrDist,extDet;if(!(0<=det))s1=0<a01?-segExtent:segExtent,s0=_Mathmax2(0,-(a01*s1+b0)),sqrDist=-s0*s0+s1*(s1+2*b1)+c;else if(s0=a01*b1-b0,s1=a01*b0-b1,extDet=segExtent*det,!(0<=s0))s1<=-extDet?(s0=_Mathmax2(0,-(-a01*segExtent+b0)),s1=0<s0?-segExtent:_Mathmin2(_Mathmax2(-segExtent,-b1),segExtent),sqrDist=-s0*s0+s1*(s1+2*b1)+c):s1<=extDet?(s0=0,s1=_Mathmin2(_Mathmax2(-segExtent,-b1),segExtent),sqrDist=s1*(s1+2*b1)+c):(s0=_Mathmax2(0,-(a01*segExtent+b0)),s1=0<s0?segExtent:_Mathmin2(_Mathmax2(-segExtent,-b1),segExtent),sqrDist=-s0*s0+s1*(s1+2*b1)+c);else if(!(s1>=-extDet))s1=-segExtent,s0=_Mathmax2(0,-(a01*s1+b0)),sqrDist=-s0*s0+s1*(s1+2*b1)+c;else if(s1<=extDet){var invDet=1/det;s0*=invDet,s1*=invDet,sqrDist=s0*(s0+a01*s1+2*b0)+s1*(a01*s0+s1+2*b1)+c}else s1=segExtent,s0=_Mathmax2(0,-(a01*s1+b0)),sqrDist=-s0*s0+s1*(s1+2*b1)+c;return optionalPointOnRay&&optionalPointOnRay.copy(this.direction.clone().multiplyScalar(s0).add(this.origin)),optionalPointOnSegment&&optionalPointOnSegment.copy(segDir.clone().multiplyScalar(s1).add(segCenter)),sqrDist},isIntersectionSphere:function isIntersectionSphere(sphere){return this.distanceToPoint(sphere.center)<=sphere.radius},isIntersectionPlane:function isIntersectionPlane(plane){var distToPoint=plane.distanceToPoint(this.origin);if(0===distToPoint)return!0;var denominator=plane.normal.dot(this.direction);return!!(0>denominator*distToPoint)},distanceToPlane:function distanceToPlane(plane){var denominator=plane.normal.dot(this.direction);if(0==denominator)return 0==plane.distanceToPoint(this.origin)?0:null;var t=-(this.origin.dot(plane.normal)+plane.constant)/denominator;return 0<=t?t:null},intersectPlane:function intersectPlane(plane,optionalTarget){var t=this.distanceToPlane(plane);return null===t?null:this.at(t,optionalTarget)},isIntersectionBox:function(){var v=new THREE.Vector3;return function(box){return null!==this.intersectBox(box,v)}}(),intersectBox:function intersectBox(box,optionalTarget){var invdirx=1/this.direction.x,invdiry=1/this.direction.y,invdirz=1/this.direction.z,origin=this.origin,tmin,tmax,tymin,tymax,tzmin,tzmax;return(0<=invdirx?(tmin=(box.min.x-origin.x)*invdirx,tmax=(box.max.x-origin.x)*invdirx):(tmin=(box.max.x-origin.x)*invdirx,tmax=(box.min.x-origin.x)*invdirx),0<=invdiry?(tymin=(box.min.y-origin.y)*invdiry,tymax=(box.max.y-origin.y)*invdiry):(tymin=(box.max.y-origin.y)*invdiry,tymax=(box.min.y-origin.y)*invdiry),tmin>tymax||tymin>tmax)?null:((tymin>tmin||tmin!=tmin)&&(tmin=tymin),(tymax<tmax||tmax!=tmax)&&(tmax=tymax),0<=invdirz?(tzmin=(box.min.z-origin.z)*invdirz,tzmax=(box.max.z-origin.z)*invdirz):(tzmin=(box.max.z-origin.z)*invdirz,tzmax=(box.min.z-origin.z)*invdirz),tmin>tzmax||tzmin>tmax)?null:((tzmin>tmin||tmin!=tmin)&&(tmin=tzmin),(tzmax<tmax||tmax!=tmax)&&(tmax=tzmax),0>tmax?null:this.at(0<=tmin?tmin:tmax,optionalTarget))},intersectTriangle:function(){var diff=new THREE.Vector3,edge1=new THREE.Vector3,edge2=new THREE.Vector3,normal=new THREE.Vector3;return function(a,b,c,backfaceCulling,optionalTarget){edge1.subVectors(b,a),edge2.subVectors(c,a),normal.crossVectors(edge1,edge2);var DdN=this.direction.dot(normal),sign;if(0<DdN){if(backfaceCulling)return null;sign=1}else if(0>DdN)sign=-1,DdN=-DdN;else return null;diff.subVectors(this.origin,a);var DdQxE2=sign*this.direction.dot(edge2.crossVectors(diff,edge2));if(0>DdQxE2)return null;var DdE1xQ=sign*this.direction.dot(edge1.cross(diff));if(0>DdE1xQ)return null;if(DdQxE2+DdE1xQ>DdN)return null;var QdN=-sign*diff.dot(normal);return 0>QdN?null:this.at(QdN/DdN,optionalTarget)}}(),applyMatrix4:function applyMatrix4(matrix4){return this.direction.add(this.origin).applyMatrix4(matrix4),this.origin.applyMatrix4(matrix4),this.direction.sub(this.origin),this.direction.normalize(),this},equals:function equals(ray){return ray.origin.equals(this.origin)&&ray.direction.equals(this.direction)},clone:function clone(){return new THREE.Ray().copy(this)}},THREE.Sphere=function(center,radius){this.center=center===void 0?new THREE.Vector3:center,this.radius=radius===void 0?0:radius},THREE.Sphere.prototype={constructor:THREE.Sphere,set:function set(center,radius){return this.center.copy(center),this.radius=radius,this},setFromPoints:function(){var box=new THREE.Box3;return function(points,optionalCenter){var center=this.center;void 0===optionalCenter?box.setFromPoints(points).center(center):center.copy(optionalCenter);for(var maxRadiusSq=0,i=0,il=points.length;i<il;i++)maxRadiusSq=Math.max(maxRadiusSq,center.distanceToSquared(points[i]));return this.radius=Math.sqrt(maxRadiusSq),this}}(),copy:function copy(sphere){return this.center.copy(sphere.center),this.radius=sphere.radius,this},empty:function empty(){return 0>=this.radius},containsPoint:function containsPoint(point){return point.distanceToSquared(this.center)<=this.radius*this.radius},distanceToPoint:function distanceToPoint(point){return point.distanceTo(this.center)-this.radius},intersectsSphere:function intersectsSphere(sphere){var radiusSum=this.radius+sphere.radius;return sphere.center.distanceToSquared(this.center)<=radiusSum*radiusSum},clampPoint:function clampPoint(point,optionalTarget){var deltaLengthSq=this.center.distanceToSquared(point),result=optionalTarget||new THREE.Vector3;return result.copy(point),deltaLengthSq>this.radius*this.radius&&(result.sub(this.center).normalize(),result.multiplyScalar(this.radius).add(this.center)),result},getBoundingBox:function getBoundingBox(optionalTarget){var box=optionalTarget||new THREE.Box3;return box.set(this.center,this.center),box.expandByScalar(this.radius),box},applyMatrix4:function applyMatrix4(matrix){return this.center.applyMatrix4(matrix),this.radius*=matrix.getMaxScaleOnAxis(),this},translate:function translate(offset){return this.center.add(offset),this},equals:function equals(sphere){return sphere.center.equals(this.center)&&sphere.radius===this.radius},clone:function clone(){return new THREE.Sphere().copy(this)}},THREE.Frustum=function(p0,p1,p2,p3,p4,p5){this.planes=[p0===void 0?new THREE.Plane:p0,p1===void 0?new THREE.Plane:p1,p2===void 0?new THREE.Plane:p2,p3===void 0?new THREE.Plane:p3,p4===void 0?new THREE.Plane:p4,p5===void 0?new THREE.Plane:p5]},THREE.Frustum.prototype={constructor:THREE.Frustum,set:function set(p0,p1,p2,p3,p4,p5){var planes=this.planes;return planes[0].copy(p0),planes[1].copy(p1),planes[2].copy(p2),planes[3].copy(p3),planes[4].copy(p4),planes[5].copy(p5),this},copy:function copy(frustum){for(var planes=this.planes,i=0;6>i;i++)planes[i].copy(frustum.planes[i]);return this},setFromMatrix:function setFromMatrix(m){var planes=this.planes,me=m.elements,me0=me[0],me1=me[1],me2=me[2],me3=me[3],me4=me[4],me5=me[5],me6=me[6],me7=me[7],me8=me[8],me9=me[9],me10=me[10],me11=me[11],me12=me[12],me13=me[13],me14=me[14],me15=me[15];return planes[0].setComponents(me3-me0,me7-me4,me11-me8,me15-me12).normalize(),planes[1].setComponents(me3+me0,me7+me4,me11+me8,me15+me12).normalize(),planes[2].setComponents(me3+me1,me7+me5,me11+me9,me15+me13).normalize(),planes[3].setComponents(me3-me1,me7-me5,me11-me9,me15-me13).normalize(),planes[4].setComponents(me3-me2,me7-me6,me11-me10,me15-me14).normalize(),planes[5].setComponents(me3+me2,me7+me6,me11+me10,me15+me14).normalize(),this},intersectsObject:function(){var sphere=new THREE.Sphere;return function(object){var geometry=object.geometry;return null===geometry.boundingSphere&&geometry.computeBoundingSphere(),sphere.copy(geometry.boundingSphere),sphere.applyMatrix4(object.matrixWorld),this.intersectsSphere(sphere)}}(),intersectsSphere:function intersectsSphere(sphere){for(var planes=this.planes,center=sphere.center,negRadius=-sphere.radius,i=0,distance;6>i;i++)if(distance=planes[i].distanceToPoint(center),distance<negRadius)return!1;return!0},intersectsBox:function(){var p1=new THREE.Vector3,p2=new THREE.Vector3;return function(box){for(var planes=this.planes,i=0,plane;6>i;i++){plane=planes[i],p1.x=0<plane.normal.x?box.min.x:box.max.x,p2.x=0<plane.normal.x?box.max.x:box.min.x,p1.y=0<plane.normal.y?box.min.y:box.max.y,p2.y=0<plane.normal.y?box.max.y:box.min.y,p1.z=0<plane.normal.z?box.min.z:box.max.z,p2.z=0<plane.normal.z?box.max.z:box.min.z;var d1=plane.distanceToPoint(p1),d2=plane.distanceToPoint(p2);if(0>d1&&0>d2)return!1}return!0}}(),containsPoint:function containsPoint(point){for(var planes=this.planes,i=0;6>i;i++)if(0>planes[i].distanceToPoint(point))return!1;return!0},clone:function clone(){return new THREE.Frustum().copy(this)}},THREE.Plane=function(normal,constant){this.normal=normal===void 0?new THREE.Vector3(1,0,0):normal,this.constant=constant===void 0?0:constant},THREE.Plane.prototype={constructor:THREE.Plane,set:function set(normal,constant){return this.normal.copy(normal),this.constant=constant,this},setComponents:function setComponents(x,y,z,w){return this.normal.set(x,y,z),this.constant=w,this},setFromNormalAndCoplanarPoint:function setFromNormalAndCoplanarPoint(normal,point){return this.normal.copy(normal),this.constant=-point.dot(this.normal),this},setFromCoplanarPoints:function(){var v1=new THREE.Vector3,v2=new THREE.Vector3;return function(a,b,c){var normal=v1.subVectors(c,b).cross(v2.subVectors(a,b)).normalize();return this.setFromNormalAndCoplanarPoint(normal,a),this}}(),copy:function copy(plane){return this.normal.copy(plane.normal),this.constant=plane.constant,this},normalize:function normalize(){var inverseNormalLength=1/this.normal.length();return this.normal.multiplyScalar(inverseNormalLength),this.constant*=inverseNormalLength,this},negate:function negate(){return this.constant*=-1,this.normal.negate(),this},distanceToPoint:function distanceToPoint(point){return this.normal.dot(point)+this.constant},distanceToSphere:function distanceToSphere(sphere){return this.distanceToPoint(sphere.center)-sphere.radius},projectPoint:function projectPoint(point,optionalTarget){return this.orthoPoint(point,optionalTarget).sub(point).negate()},orthoPoint:function orthoPoint(point,optionalTarget){var perpendicularMagnitude=this.distanceToPoint(point),result=optionalTarget||new THREE.Vector3;return result.copy(this.normal).multiplyScalar(perpendicularMagnitude)},isIntersectionLine:function isIntersectionLine(line){var startSign=this.distanceToPoint(line.start),endSign=this.distanceToPoint(line.end);return 0>startSign&&0<endSign||0>endSign&&0<startSign},intersectLine:function(){var v1=new THREE.Vector3;return function(line,optionalTarget){var result=optionalTarget||new THREE.Vector3,direction=line.delta(v1),denominator=this.normal.dot(direction);if(0==denominator)return 0==this.distanceToPoint(line.start)?result.copy(line.start):void 0;var t=-(line.start.dot(this.normal)+this.constant)/denominator;return 0>t||1<t?void 0:result.copy(direction).multiplyScalar(t).add(line.start)}}(),coplanarPoint:function coplanarPoint(optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.copy(this.normal).multiplyScalar(-this.constant)},applyMatrix4:function(){var v1=new THREE.Vector3,v2=new THREE.Vector3;return function(matrix,optionalNormalMatrix){optionalNormalMatrix=optionalNormalMatrix||new THREE.Matrix3().getNormalMatrix(matrix);var newNormal=v1.copy(this.normal).applyMatrix3(optionalNormalMatrix),newCoplanarPoint=this.coplanarPoint(v2);return newCoplanarPoint.applyMatrix4(matrix),this.setFromNormalAndCoplanarPoint(newNormal,newCoplanarPoint),this}}(),translate:function translate(offset){return this.constant-=offset.dot(this.normal),this},equals:function equals(plane){return plane.normal.equals(this.normal)&&plane.constant==this.constant},clone:function clone(){return new THREE.Plane().copy(this)}},THREE.Math={PI2:2*Math.PI,generateUUID:function(){var chars=['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z','a','b','c','d','e','f','g','h','i','j','k','l','m','n','o','p','q','r','s','t','u','v','w','x','y','z'],uuid=Array(36),rnd=0,r;return function(){for(var i=0;36>i;i++)8==i||13==i||18==i||23==i?uuid[i]='-':14==i?uuid[i]='4':(2>=rnd&&(rnd=0|33554432+16777216*Math.random()),r=15&rnd,rnd>>=4,uuid[i]=chars[19==i?8|3&r:r]);return uuid.join('')}}(),clamp:function clamp(x,a,b){return x<a?a:x>b?b:x},clampBottom:function clampBottom(x,a){return x<a?a:x},mapLinear:function mapLinear(x,a1,a2,b1,b2){return b1+(x-a1)*(b2-b1)/(a2-a1)},smoothstep:function smoothstep(x,min,max){return x<=min?0:x>=max?1:(x=(x-min)/(max-min),x*x*(3-2*x))},smootherstep:function smootherstep(x,min,max){return x<=min?0:x>=max?1:(x=(x-min)/(max-min),x*x*x*(x*(6*x-15)+10))},random16:function random16(){return(65280*Math.random()+255*Math.random())/65535},randInt:function randInt(low,high){return low+Math.floor(Math.random()*(high-low+1))},randFloat:function randFloat(low,high){return low+Math.random()*(high-low)},randFloatSpread:function randFloatSpread(range){return range*(.5-Math.random())},sign:function sign(x){return 0>x?-1:0<x?1:0},degToRad:function(){var degreeToRadiansFactor=Math.PI/180;return function(degrees){return degrees*degreeToRadiansFactor}}(),radToDeg:function(){var radianToDegreesFactor=180/Math.PI;return function(radians){return radians*radianToDegreesFactor}}()},THREE.Spline=function(points){function interpolate(p0,p1,p2,p3,t,t2,t3){var v0=.5*(p2-p0),v1=.5*(p3-p1);return(2*(p1-p2)+v0+v1)*t3+(-3*(p1-p2)-2*v0-v1)*t2+v0*t+p1}var _Mathfloor=Math.floor;this.points=points;var c=[],v3={x:0,y:0,z:0},point,intPoint,weight,w2,w3,pa,pb,pc,pd;this.initFromArray=function(a){this.points=[];for(var i=0;i<a.length;i++)this.points[i]={x:a[i][0],y:a[i][1],z:a[i][2]}},this.getPoint=function(k){return point=(this.points.length-1)*k,intPoint=_Mathfloor(point),weight=point-intPoint,c[0]=0===intPoint?intPoint:intPoint-1,c[1]=intPoint,c[2]=intPoint>this.points.length-2?this.points.length-1:intPoint+1,c[3]=intPoint>this.points.length-3?this.points.length-1:intPoint+2,pa=this.points[c[0]],pb=this.points[c[1]],pc=this.points[c[2]],pd=this.points[c[3]],w2=weight*weight,w3=weight*w2,v3.x=interpolate(pa.x,pb.x,pc.x,pd.x,weight,w2,w3),v3.y=interpolate(pa.y,pb.y,pc.y,pd.y,weight,w2,w3),v3.z=interpolate(pa.z,pb.z,pc.z,pd.z,weight,w2,w3),v3},this.getControlPointsArray=function(){var l=this.points.length,coords=[],i,p;for(i=0;i<l;i++)p=this.points[i],coords[i]=[p.x,p.y,p.z];return coords},this.getLength=function(nSubDivisions){var point=0,intPoint=0,oldIntPoint=0,oldPosition=new THREE.Vector3,tmpVec=new THREE.Vector3,chunkLengths=[],totalLength=0,i,index,nSamples,position;for(chunkLengths[0]=0,nSubDivisions||(nSubDivisions=100),nSamples=this.points.length*nSubDivisions,oldPosition.copy(this.points[0]),i=1;i<nSamples;i++)index=i/nSamples,position=this.getPoint(index),tmpVec.copy(position),totalLength+=tmpVec.distanceTo(oldPosition),oldPosition.copy(position),point=(this.points.length-1)*index,intPoint=_Mathfloor(point),intPoint!=oldIntPoint&&(chunkLengths[intPoint]=totalLength,oldIntPoint=intPoint);return chunkLengths[chunkLengths.length]=totalLength,{chunks:chunkLengths,total:totalLength}},this.reparametrizeByArcLength=function(samplingCoef){var newpoints=[],tmpVec=new THREE.Vector3,sl=this.getLength(),i,j,index,indexCurrent,indexNext,realDistance,sampling,position;for(newpoints.push(tmpVec.copy(this.points[0]).clone()),i=1;i<this.points.length;i++){for(realDistance=sl.chunks[i]-sl.chunks[i-1],sampling=Math.ceil(samplingCoef*realDistance/sl.total),indexCurrent=(i-1)/(this.points.length-1),indexNext=i/(this.points.length-1),j=1;j<sampling-1;j++)index=indexCurrent+j*(1/sampling)*(indexNext-indexCurrent),position=this.getPoint(index),newpoints.push(tmpVec.copy(position).clone());newpoints.push(tmpVec.copy(this.points[i]).clone())}this.points=newpoints}},THREE.Triangle=function(a,b,c){this.a=a===void 0?new THREE.Vector3:a,this.b=b===void 0?new THREE.Vector3:b,this.c=c===void 0?new THREE.Vector3:c},THREE.Triangle.normal=function(){var v0=new THREE.Vector3;return function(a,b,c,optionalTarget){var result=optionalTarget||new THREE.Vector3;result.subVectors(c,b),v0.subVectors(a,b),result.cross(v0);var resultLengthSq=result.lengthSq();return 0<resultLengthSq?result.multiplyScalar(1/Math.sqrt(resultLengthSq)):result.set(0,0,0)}}(),THREE.Triangle.barycoordFromPoint=function(){var v0=new THREE.Vector3,v1=new THREE.Vector3,v2=new THREE.Vector3;return function(point,a,b,c,optionalTarget){v0.subVectors(c,a),v1.subVectors(b,a),v2.subVectors(point,a);var dot00=v0.dot(v0),dot01=v0.dot(v1),dot02=v0.dot(v2),dot11=v1.dot(v1),dot12=v1.dot(v2),denom=dot00*dot11-dot01*dot01,result=optionalTarget||new THREE.Vector3;if(0==denom)return result.set(-2,-1,-1);var invDenom=1/denom,u=(dot11*dot02-dot01*dot12)*invDenom,v=(dot00*dot12-dot01*dot02)*invDenom;return result.set(1-u-v,v,u)}}(),THREE.Triangle.containsPoint=function(){var v1=new THREE.Vector3;return function(point,a,b,c){var result=THREE.Triangle.barycoordFromPoint(point,a,b,c,v1);return 0<=result.x&&0<=result.y&&1>=result.x+result.y}}(),THREE.Triangle.prototype={constructor:THREE.Triangle,set:function set(a,b,c){return this.a.copy(a),this.b.copy(b),this.c.copy(c),this},setFromPointsAndIndices:function setFromPointsAndIndices(points,i0,i1,i2){return this.a.copy(points[i0]),this.b.copy(points[i1]),this.c.copy(points[i2]),this},copy:function copy(triangle){return this.a.copy(triangle.a),this.b.copy(triangle.b),this.c.copy(triangle.c),this},area:function(){var v0=new THREE.Vector3,v1=new THREE.Vector3;return function(){return v0.subVectors(this.c,this.b),v1.subVectors(this.a,this.b),.5*v0.cross(v1).length()}}(),midpoint:function midpoint(optionalTarget){var result=optionalTarget||new THREE.Vector3;return result.addVectors(this.a,this.b).add(this.c).multiplyScalar(1/3)},normal:function normal(optionalTarget){return THREE.Triangle.normal(this.a,this.b,this.c,optionalTarget)},plane:function plane(optionalTarget){var result=optionalTarget||new THREE.Plane;return result.setFromCoplanarPoints(this.a,this.b,this.c)},barycoordFromPoint:function barycoordFromPoint(point,optionalTarget){return THREE.Triangle.barycoordFromPoint(point,this.a,this.b,this.c,optionalTarget)},containsPoint:function containsPoint(point){return THREE.Triangle.containsPoint(point,this.a,this.b,this.c)},equals:function equals(triangle){return triangle.a.equals(this.a)&&triangle.b.equals(this.b)&&triangle.c.equals(this.c)},clone:function clone(){return new THREE.Triangle().copy(this)}},THREE.Vertex=function(v){return console.warn('THREE.Vertex has been DEPRECATED. Use THREE.Vector3 instead.'),v},THREE.UV=function(u,v){return console.warn('THREE.UV has been DEPRECATED. Use THREE.Vector2 instead.'),new THREE.Vector2(u,v)},THREE.Clock=function(autoStart){this.autoStart=!(autoStart!==void 0)||autoStart,this.startTime=0,this.oldTime=0,this.elapsedTime=0,this.running=!1},THREE.Clock.prototype={constructor:THREE.Clock,start:function start(){this.startTime=self.performance!==void 0&&self.performance.now!==void 0?self.performance.now():Date.now(),this.oldTime=this.startTime,this.running=!0},stop:function stop(){this.getElapsedTime(),this.running=!1},getElapsedTime:function getElapsedTime(){return this.getDelta(),this.elapsedTime},getDelta:function getDelta(){var diff=0;if(this.autoStart&&!this.running&&this.start(),this.running){var newTime=void 0!==self.performance&&void 0!==self.performance.now?self.performance.now():Date.now();diff=.001*(newTime-this.oldTime),this.oldTime=newTime,this.elapsedTime+=diff}return diff}},THREE.EventDispatcher=function(){},THREE.EventDispatcher.prototype={constructor:THREE.EventDispatcher,apply:function apply(object){object.addEventListener=THREE.EventDispatcher.prototype.addEventListener,object.hasEventListener=THREE.EventDispatcher.prototype.hasEventListener,object.removeEventListener=THREE.EventDispatcher.prototype.removeEventListener,object.dispatchEvent=THREE.EventDispatcher.prototype.dispatchEvent},addEventListener:function addEventListener(type,listener){this._listeners===void 0&&(this._listeners={});var listeners=this._listeners;listeners[type]===void 0&&(listeners[type]=[]),-1===listeners[type].indexOf(listener)&&listeners[type].push(listener)},hasEventListener:function hasEventListener(type,listener){if(this._listeners===void 0)return!1;var listeners=this._listeners;return!(void 0===listeners[type]||-1===listeners[type].indexOf(listener))},removeEventListener:function removeEventListener(type,listener){if(void 0!==this._listeners){var listeners=this._listeners,index=listeners[type].indexOf(listener);-1!==index&&listeners[type].splice(index,1)}},dispatchEvent:function dispatchEvent(event){if(void 0!==this._listeners){var listeners=this._listeners,listenerArray=listeners[event.type];if(void 0!==listenerArray){event.target=this;for(var i=0,l=listenerArray.length;i<l;i++)listenerArray[i].call(this,event)}}}},function(THREE){THREE.Raycaster=function(origin,direction,near,far){this.ray=new THREE.Ray(origin,direction),this.near=near||0,this.far=far||Infinity};var sphere=new THREE.Sphere,localRay=new THREE.Ray,facePlane=new THREE.Plane,intersectPoint=new THREE.Vector3,matrixPosition=new THREE.Vector3,inverseMatrix=new THREE.Matrix4,descSort=function(a,b){return a.distance-b.distance},vA=new THREE.Vector3,vB=new THREE.Vector3,vC=new THREE.Vector3,intersectObject=function(object,raycaster,intersects){if(object instanceof THREE.Particle){matrixPosition.getPositionFromMatrix(object.matrixWorld);var distance=raycaster.ray.distanceToPoint(matrixPosition);if(distance>object.scale.x)return intersects;intersects.push({distance:distance,point:object.position,face:null,object:object})}else if(object instanceof THREE.LOD){matrixPosition.getPositionFromMatrix(object.matrixWorld);var distance=raycaster.ray.origin.distanceTo(matrixPosition);intersectObject(object.getObjectForDistance(distance),raycaster,intersects)}else if(object instanceof THREE.Mesh){var geometry=object.geometry;if(null===geometry.boundingSphere&&geometry.computeBoundingSphere(),sphere.copy(geometry.boundingSphere),sphere.applyMatrix4(object.matrixWorld),!1===raycaster.ray.isIntersectionSphere(sphere))return intersects;if(inverseMatrix.getInverse(object.matrixWorld),localRay.copy(raycaster.ray).applyMatrix4(inverseMatrix),null!==geometry.boundingBox&&!1===localRay.isIntersectionBox(geometry.boundingBox))return intersects;var vertices=geometry.vertices;if(geometry instanceof THREE.BufferGeometry){var material=object.material;if(void 0===material)return intersects;if(!1===geometry.dynamic)return intersects;var precision=raycaster.precision,a,b,c;if(void 0!==geometry.attributes.index)for(var offsets=geometry.offsets,indices=geometry.attributes.index.array,positions=geometry.attributes.position.array,offLength=geometry.offsets.length,fl=geometry.attributes.index.array.length/3,oi=0;oi<offLength;++oi)for(var start=offsets[oi].start,count=offsets[oi].count,index=offsets[oi].index,i=start;i<start+count;i+=3){a=index+indices[i],b=index+indices[i+1],c=index+indices[i+2],vA.set(positions[3*a],positions[3*a+1],positions[3*a+2]),vB.set(positions[3*b],positions[3*b+1],positions[3*b+2]),vC.set(positions[3*c],positions[3*c+1],positions[3*c+2]);var intersectionPoint=localRay.intersectTriangle(vA,vB,vC,material.side!==THREE.DoubleSide);if(null!==intersectionPoint){intersectionPoint.applyMatrix4(object.matrixWorld);var distance=raycaster.ray.origin.distanceTo(intersectionPoint);distance<precision||distance<raycaster.near||distance>raycaster.far||intersects.push({distance:distance,point:intersectionPoint,face:null,faceIndex:null,object:object})}}else for(var offsets=geometry.offsets,positions=geometry.attributes.position.array,offLength=geometry.offsets.length,fl=geometry.attributes.position.array.length,i=0;i<fl;i+=3){a=i,b=i+1,c=i+2,vA.set(positions[3*a],positions[3*a+1],positions[3*a+2]),vB.set(positions[3*b],positions[3*b+1],positions[3*b+2]),vC.set(positions[3*c],positions[3*c+1],positions[3*c+2]);var intersectionPoint=localRay.intersectTriangle(vA,vB,vC,material.side!==THREE.DoubleSide);if(null!==intersectionPoint){intersectionPoint.applyMatrix4(object.matrixWorld);var distance=raycaster.ray.origin.distanceTo(intersectionPoint);distance<precision||distance<raycaster.near||distance>raycaster.far||intersects.push({distance:distance,point:intersectionPoint,face:null,faceIndex:null,object:object})}}}else if(geometry instanceof THREE.Geometry)for(var isFaceMaterial=object.material instanceof THREE.MeshFaceMaterial,objectMaterials=!0==isFaceMaterial?object.material.materials:null,precision=raycaster.precision,f=0,fl=geometry.faces.length,a,b,c;f<fl;f++){var face=geometry.faces[f],material=!0==isFaceMaterial?objectMaterials[face.materialIndex]:object.material;if(void 0!==material){a=vertices[face.a],b=vertices[face.b],c=vertices[face.c];var intersectionPoint=localRay.intersectTriangle(a,b,c,material.side!==THREE.DoubleSide);if(null!==intersectionPoint){intersectionPoint.applyMatrix4(object.matrixWorld);var distance=raycaster.ray.origin.distanceTo(intersectionPoint);distance<precision||distance<raycaster.near||distance>raycaster.far||intersects.push({distance:distance,point:intersectionPoint,face:face,faceIndex:f,object:object})}}}}else if(object instanceof THREE.Line){var precision=raycaster.linePrecision,precisionSq=precision*precision,geometry=object.geometry;if(null===geometry.boundingSphere&&geometry.computeBoundingSphere(),sphere.copy(geometry.boundingSphere),sphere.applyMatrix4(object.matrixWorld),!1===raycaster.ray.isIntersectionSphere(sphere))return intersects;inverseMatrix.getInverse(object.matrixWorld),localRay.copy(raycaster.ray).applyMatrix4(inverseMatrix);for(var vertices=geometry.vertices,nbVertices=vertices.length,interSegment=new THREE.Vector3,interRay=new THREE.Vector3,step=object.type===THREE.LineStrip?1:2,i=0,distSq;i<nbVertices-1;i+=step)if(distSq=localRay.distanceSqToSegment(vertices[i],vertices[i+1],interRay,interSegment),!(distSq>precisionSq)){var distance=localRay.origin.distanceTo(interRay);distance<raycaster.near||distance>raycaster.far||intersects.push({distance:distance,point:interSegment.clone().applyMatrix4(object.matrixWorld),face:null,faceIndex:null,object:object})}}},intersectDescendants=function(object,raycaster,intersects){for(var descendants=object.getDescendants(),i=0,l=descendants.length;i<l;i++)intersectObject(descendants[i],raycaster,intersects)};THREE.Raycaster.prototype.precision=1e-4,THREE.Raycaster.prototype.linePrecision=1,THREE.Raycaster.prototype.set=function(origin,direction){this.ray.set(origin,direction)},THREE.Raycaster.prototype.intersectObject=function(object,recursive){var intersects=[];return!0===recursive&&intersectDescendants(object,this,intersects),intersectObject(object,this,intersects),intersects.sort(descSort),intersects},THREE.Raycaster.prototype.intersectObjects=function(objects,recursive){for(var intersects=[],i=0,l=objects.length;i<l;i++)intersectObject(objects[i],this,intersects),!0===recursive&&intersectDescendants(objects[i],this,intersects);return intersects.sort(descSort),intersects}}(THREE),THREE.Object3D=function(){this.id=THREE.Object3DIdCount++,this.uuid=THREE.Math.generateUUID(),this.name='',this.parent=void 0,this.children=[],this.up=new THREE.Vector3(0,1,0),this.position=new THREE.Vector3,this.rotation=new THREE.Euler,this.quaternion=new THREE.Quaternion,this.scale=new THREE.Vector3(1,1,1),this.rotation._quaternion=this.quaternion,this.quaternion._euler=this.rotation,this.renderDepth=null,this.rotationAutoUpdate=!0,this.matrix=new THREE.Matrix4,this.matrixWorld=new THREE.Matrix4,this.matrixAutoUpdate=!0,this.matrixWorldNeedsUpdate=!0,this.visible=!0,this.castShadow=!1,this.receiveShadow=!1,this.frustumCulled=!0,this.userData={}},THREE.Object3D.prototype={constructor:THREE.Object3D,get eulerOrder(){return console.warn('DEPRECATED: Object3D\'s .eulerOrder has been moved to Object3D\'s .rotation.order.'),this.rotation.order},set eulerOrder(value){console.warn('DEPRECATED: Object3D\'s .eulerOrder has been moved to Object3D\'s .rotation.order.'),this.rotation.order=value},get useQuaternion(){console.warn('DEPRECATED: Object3D\'s .useQuaternion has been removed. The library now uses quaternions by default.')},set useQuaternion(value){console.warn('DEPRECATED: Object3D\'s .useQuaternion has been removed. The library now uses quaternions by default.')},applyMatrix:function(){var m1=new THREE.Matrix4;return function(matrix){this.matrix.multiplyMatrices(matrix,this.matrix),this.position.getPositionFromMatrix(this.matrix),this.scale.getScaleFromMatrix(this.matrix),m1.extractRotation(this.matrix),this.quaternion.setFromRotationMatrix(m1)}}(),setRotationFromAxisAngle:function setRotationFromAxisAngle(axis,angle){this.quaternion.setFromAxisAngle(axis,angle)},setRotationFromEuler:function setRotationFromEuler(euler){this.quaternion.setFromEuler(euler,!0)},setRotationFromMatrix:function setRotationFromMatrix(m){this.quaternion.setFromRotationMatrix(m)},setRotationFromQuaternion:function setRotationFromQuaternion(q){this.quaternion.copy(q)},rotateOnAxis:function(){var q1=new THREE.Quaternion;return function(axis,angle){return q1.setFromAxisAngle(axis,angle),this.quaternion.multiply(q1),this}}(),rotateX:function(){var v1=new THREE.Vector3(1,0,0);return function(angle){return this.rotateOnAxis(v1,angle)}}(),rotateY:function(){var v1=new THREE.Vector3(0,1,0);return function(angle){return this.rotateOnAxis(v1,angle)}}(),rotateZ:function(){var v1=new THREE.Vector3(0,0,1);return function(angle){return this.rotateOnAxis(v1,angle)}}(),translateOnAxis:function(){var v1=new THREE.Vector3;return function(axis,distance){return v1.copy(axis),v1.applyQuaternion(this.quaternion),this.position.add(v1.multiplyScalar(distance)),this}}(),translate:function translate(distance,axis){return console.warn('DEPRECATED: Object3D\'s .translate() has been removed. Use .translateOnAxis( axis, distance ) instead. Note args have been changed.'),this.translateOnAxis(axis,distance)},translateX:function(){var v1=new THREE.Vector3(1,0,0);return function(distance){return this.translateOnAxis(v1,distance)}}(),translateY:function(){var v1=new THREE.Vector3(0,1,0);return function(distance){return this.translateOnAxis(v1,distance)}}(),translateZ:function(){var v1=new THREE.Vector3(0,0,1);return function(distance){return this.translateOnAxis(v1,distance)}}(),localToWorld:function localToWorld(vector){return vector.applyMatrix4(this.matrixWorld)},worldToLocal:function(){var m1=new THREE.Matrix4;return function(vector){return vector.applyMatrix4(m1.getInverse(this.matrixWorld))}}(),lookAt:function(){var m1=new THREE.Matrix4;return function(vector){m1.lookAt(vector,this.position,this.up),this.quaternion.setFromRotationMatrix(m1)}}(),add:function add(object){if(object===this)return void console.warn('THREE.Object3D.add: An object can\'t be added as a child of itself.');if(object instanceof THREE.Object3D){void 0!==object.parent&&object.parent.remove(object),object.parent=this,object.dispatchEvent({type:'added'}),this.children.push(object);for(var scene=this;void 0!==scene.parent;)scene=scene.parent;void 0!==scene&&scene instanceof THREE.Scene&&scene.__addObject(object)}},remove:function remove(object){var index=this.children.indexOf(object);if(-1!==index){object.parent=void 0,object.dispatchEvent({type:'removed'}),this.children.splice(index,1);for(var scene=this;scene.parent!==void 0;)scene=scene.parent;scene!==void 0&&scene instanceof THREE.Scene&&scene.__removeObject(object)}},traverse:function traverse(callback){callback(this);for(var i=0,l=this.children.length;i<l;i++)this.children[i].traverse(callback)},getObjectById:function getObjectById(id,recursive){for(var i=0,l=this.children.length,child;i<l;i++){if(child=this.children[i],child.id===id)return child;if(!0===recursive&&(child=child.getObjectById(id,recursive),void 0!==child))return child}},getObjectByName:function getObjectByName(name,recursive){for(var i=0,l=this.children.length,child;i<l;i++){if(child=this.children[i],child.name===name)return child;if(!0===recursive&&(child=child.getObjectByName(name,recursive),void 0!==child))return child}},getChildByName:function getChildByName(name,recursive){return console.warn('DEPRECATED: Object3D\'s .getChildByName() has been renamed to .getObjectByName().'),this.getObjectByName(name,recursive)},getDescendants:function getDescendants(array){array===void 0&&(array=[]),Array.prototype.push.apply(array,this.children);for(var i=0,l=this.children.length;i<l;i++)this.children[i].getDescendants(array);return array},updateMatrix:function updateMatrix(){this.matrix.compose(this.position,this.quaternion,this.scale),this.matrixWorldNeedsUpdate=!0},updateMatrixWorld:function updateMatrixWorld(force){!0===this.matrixAutoUpdate&&this.updateMatrix(),(!0===this.matrixWorldNeedsUpdate||!0===force)&&(this.parent===void 0?this.matrixWorld.copy(this.matrix):this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix),this.matrixWorldNeedsUpdate=!1,force=!0);for(var i=0,l=this.children.length;i<l;i++)this.children[i].updateMatrixWorld(force)},clone:function clone(object,recursive){if(void 0===object&&(object=new THREE.Object3D),void 0===recursive&&(recursive=!0),object.name=this.name,object.up.copy(this.up),object.position.copy(this.position),object.quaternion.copy(this.quaternion),object.scale.copy(this.scale),object.renderDepth=this.renderDepth,object.rotationAutoUpdate=this.rotationAutoUpdate,object.matrix.copy(this.matrix),object.matrixWorld.copy(this.matrixWorld),object.matrixAutoUpdate=this.matrixAutoUpdate,object.matrixWorldNeedsUpdate=this.matrixWorldNeedsUpdate,object.visible=this.visible,object.castShadow=this.castShadow,object.receiveShadow=this.receiveShadow,object.frustumCulled=this.frustumCulled,object.userData=JSON.parse(JSON.stringify(this.userData)),!0===recursive)for(var i=0,child;i<this.children.length;i++)child=this.children[i],object.add(child.clone());return object}},THREE.EventDispatcher.prototype.apply(THREE.Object3D.prototype),THREE.Object3DIdCount=0,THREE.Projector=function(){function getNextObjectInPool(){if(_objectCount===_objectPoolLength){var object=new THREE.RenderableObject;return _objectPool.push(object),_objectPoolLength++,_objectCount++,object}return _objectPool[_objectCount++]}function getNextVertexInPool(){if(_vertexCount===_vertexPoolLength){var vertex=new THREE.RenderableVertex;return _vertexPool.push(vertex),_vertexPoolLength++,_vertexCount++,vertex}return _vertexPool[_vertexCount++]}function getNextFace3InPool(){if(_face3Count===_face3PoolLength){var face=new THREE.RenderableFace3;return _face3Pool.push(face),_face3PoolLength++,_face3Count++,face}return _face3Pool[_face3Count++]}function getNextLineInPool(){if(_lineCount===_linePoolLength){var line=new THREE.RenderableLine;return _linePool.push(line),_linePoolLength++,_lineCount++,line}return _linePool[_lineCount++]}function getNextParticleInPool(){if(_particleCount===_particlePoolLength){var particle=new THREE.RenderableParticle;return _particlePool.push(particle),_particlePoolLength++,_particleCount++,particle}return _particlePool[_particleCount++]}function painterSort(a,b){return a.z===b.z?a.id===b.id?0:a.id-b.id:b.z-a.z}function clipLine(s1,s2){var alpha1=0,alpha2=1,bc1near=s1.z+s1.w,bc2near=s2.z+s2.w,bc1far=-s1.z+s1.w,bc2far=-s2.z+s2.w;return!!(0<=bc1near&&0<=bc2near&&0<=bc1far&&0<=bc2far)||!(0>bc1near&&0>bc2near||0>bc1far&&0>bc2far)&&(0>bc1near?alpha1=_Mathmax3(alpha1,bc1near/(bc1near-bc2near)):0>bc2near&&(alpha2=_Mathmin3(alpha2,bc1near/(bc1near-bc2near))),0>bc1far?alpha1=_Mathmax3(alpha1,bc1far/(bc1far-bc2far)):0>bc2far&&(alpha2=_Mathmin3(alpha2,bc1far/(bc1far-bc2far))),!(alpha2<alpha1)&&(s1.lerp(s2,alpha1),s2.lerp(s1,1-alpha2),!0))}var _Mathabs5=Math.abs,_Mathmin3=Math.min,_Mathmax3=Math.max,_objectPool=[],_objectPoolLength=0,_vertexPool=[],_vertexPoolLength=0,_face3Pool=[],_face3PoolLength=0,_linePool=[],_linePoolLength=0,_particlePool=[],_particlePoolLength=0,_renderData={objects:[],sprites:[],lights:[],elements:[]},_vector3=new THREE.Vector3,_vector4=new THREE.Vector4,_clipBox=new THREE.Box3(new THREE.Vector3(-1,-1,-1),new THREE.Vector3(1,1,1)),_boundingBox=new THREE.Box3,_points3=[,,,],_points4=[,,,,],_viewMatrix=new THREE.Matrix4,_viewProjectionMatrix=new THREE.Matrix4,_modelViewProjectionMatrix=new THREE.Matrix4,_normalMatrix=new THREE.Matrix3,_normalViewMatrix=new THREE.Matrix3,_centroid=new THREE.Vector3,_frustum=new THREE.Frustum,_clippedVertex1PositionScreen=new THREE.Vector4,_clippedVertex2PositionScreen=new THREE.Vector4,_object,_objectCount,_vertex,_vertexCount,_face,_face3Count,_line,_lineCount,_particle,_particleCount,_modelMatrix;this.projectVector=function(vector,camera){return camera.matrixWorldInverse.getInverse(camera.matrixWorld),_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix,camera.matrixWorldInverse),vector.applyProjection(_viewProjectionMatrix)},this.unprojectVector=function(vector,camera){return camera.projectionMatrixInverse.getInverse(camera.projectionMatrix),_viewProjectionMatrix.multiplyMatrices(camera.matrixWorld,camera.projectionMatrixInverse),vector.applyProjection(_viewProjectionMatrix)},this.pickingRay=function(vector,camera){vector.z=-1;var end=new THREE.Vector3(vector.x,vector.y,1);return this.unprojectVector(vector,camera),this.unprojectVector(end,camera),end.sub(vector).normalize(),new THREE.Raycaster(vector,end)};var getObject=function(object){return _object=getNextObjectInPool(),_object.id=object.id,_object.object=object,null===object.renderDepth?(_vector3.getPositionFromMatrix(object.matrixWorld),_vector3.applyProjection(_viewProjectionMatrix),_object.z=_vector3.z):_object.z=object.renderDepth,_object},projectObject=function(object){if(!1!==object.visible){object instanceof THREE.Light?_renderData.lights.push(object):object instanceof THREE.Mesh||object instanceof THREE.Line?(!1===object.frustumCulled||!0===_frustum.intersectsObject(object))&&_renderData.objects.push(getObject(object)):(object instanceof THREE.Sprite||object instanceof THREE.Particle)&&_renderData.sprites.push(getObject(object));for(var i=0,l=object.children.length;i<l;i++)projectObject(object.children[i])}},projectGraph=function(root,sortObjects){_objectCount=0,_renderData.objects.length=0,_renderData.sprites.length=0,_renderData.lights.length=0,projectObject(root),!0===sortObjects&&_renderData.objects.sort(painterSort)};this.projectScene=function(scene,camera,sortObjects,sortElements){var visible=!1,o,ol,v,vl,f,fl,n,nl,c,cl,u,ul,object,geometry,vertices,faces,face,faceVertexNormals,faceVertexUvs,uvs,v1,v2,v3,isFaceMaterial,objectMaterials;for(_face3Count=0,_lineCount=0,_particleCount=0,_renderData.elements.length=0,!0===scene.autoUpdate&&scene.updateMatrixWorld(),void 0===camera.parent&&camera.updateMatrixWorld(),_viewMatrix.copy(camera.matrixWorldInverse.getInverse(camera.matrixWorld)),_viewProjectionMatrix.multiplyMatrices(camera.projectionMatrix,_viewMatrix),_normalViewMatrix.getNormalMatrix(_viewMatrix),_frustum.setFromMatrix(_viewProjectionMatrix),projectGraph(scene,sortObjects),(o=0,ol=_renderData.objects.length);o<ol;o++)if(object=_renderData.objects[o].object,_modelMatrix=object.matrixWorld,_vertexCount=0,object instanceof THREE.Mesh){for(geometry=object.geometry,vertices=geometry.vertices,faces=geometry.faces,faceVertexUvs=geometry.faceVertexUvs,_normalMatrix.getNormalMatrix(_modelMatrix),isFaceMaterial=object.material instanceof THREE.MeshFaceMaterial,objectMaterials=!0===isFaceMaterial?object.material:null,(v=0,vl=vertices.length);v<vl;v++){_vertex=getNextVertexInPool(),_vertex.positionWorld.copy(vertices[v]).applyMatrix4(_modelMatrix),_vertex.positionScreen.copy(_vertex.positionWorld).applyMatrix4(_viewProjectionMatrix);var invW=1/_vertex.positionScreen.w;_vertex.positionScreen.x*=invW,_vertex.positionScreen.y*=invW,_vertex.positionScreen.z*=invW,_vertex.visible=!(-1>_vertex.positionScreen.x||1<_vertex.positionScreen.x||-1>_vertex.positionScreen.y||1<_vertex.positionScreen.y||-1>_vertex.positionScreen.z||1<_vertex.positionScreen.z)}for(f=0,fl=faces.length;f<fl;f++){face=faces[f];var material=!0===isFaceMaterial?objectMaterials.materials[face.materialIndex]:object.material;if(void 0!==material){var side=material.side;if(v1=_vertexPool[face.a],v2=_vertexPool[face.b],v3=_vertexPool[face.c],_points3[0]=v1.positionScreen,_points3[1]=v2.positionScreen,_points3[2]=v3.positionScreen,!(!0===v1.visible||!0===v2.visible||!0===v3.visible||_clipBox.isIntersectionBox(_boundingBox.setFromPoints(_points3))))continue;else if(visible=0>(v3.positionScreen.x-v1.positionScreen.x)*(v2.positionScreen.y-v1.positionScreen.y)-(v3.positionScreen.y-v1.positionScreen.y)*(v2.positionScreen.x-v1.positionScreen.x),side===THREE.DoubleSide||visible==(side===THREE.FrontSide))_face=getNextFace3InPool(),_face.id=object.id,_face.v1.copy(v1),_face.v2.copy(v2),_face.v3.copy(v3);else continue;for(_face.normalModel.copy(face.normal),!1==visible&&(side===THREE.BackSide||side===THREE.DoubleSide)&&_face.normalModel.negate(),_face.normalModel.applyMatrix3(_normalMatrix).normalize(),_face.normalModelView.copy(_face.normalModel).applyMatrix3(_normalViewMatrix),_face.centroidModel.copy(face.centroid).applyMatrix4(_modelMatrix),faceVertexNormals=face.vertexNormals,(n=0,nl=_Mathmin3(faceVertexNormals.length,3));n<nl;n++){var normalModel=_face.vertexNormalsModel[n];normalModel.copy(faceVertexNormals[n]),!1==visible&&(side===THREE.BackSide||side===THREE.DoubleSide)&&normalModel.negate(),normalModel.applyMatrix3(_normalMatrix).normalize();var normalModelView=_face.vertexNormalsModelView[n];normalModelView.copy(normalModel).applyMatrix3(_normalViewMatrix)}for(_face.vertexNormalsLength=faceVertexNormals.length,c=0,cl=_Mathmin3(faceVertexUvs.length,3);c<cl;c++)if(uvs=faceVertexUvs[c][f],void 0!==uvs)for(u=0,ul=uvs.length;u<ul;u++)_face.uvs[c][u]=uvs[u];_face.color=face.color,_face.material=material,_centroid.copy(_face.centroidModel).applyProjection(_viewProjectionMatrix),_face.z=_centroid.z,_renderData.elements.push(_face)}}}else if(object instanceof THREE.Line){_modelViewProjectionMatrix.multiplyMatrices(_viewProjectionMatrix,_modelMatrix),vertices=object.geometry.vertices,v1=getNextVertexInPool(),v1.positionScreen.copy(vertices[0]).applyMatrix4(_modelViewProjectionMatrix);var step=object.type===THREE.LinePieces?2:1;for(v=1,vl=vertices.length;v<vl;v++)v1=getNextVertexInPool(),v1.positionScreen.copy(vertices[v]).applyMatrix4(_modelViewProjectionMatrix),0<(v+1)%step||(v2=_vertexPool[_vertexCount-2],_clippedVertex1PositionScreen.copy(v1.positionScreen),_clippedVertex2PositionScreen.copy(v2.positionScreen),!0===clipLine(_clippedVertex1PositionScreen,_clippedVertex2PositionScreen)&&(_clippedVertex1PositionScreen.multiplyScalar(1/_clippedVertex1PositionScreen.w),_clippedVertex2PositionScreen.multiplyScalar(1/_clippedVertex2PositionScreen.w),_line=getNextLineInPool(),_line.id=object.id,_line.v1.positionScreen.copy(_clippedVertex1PositionScreen),_line.v2.positionScreen.copy(_clippedVertex2PositionScreen),_line.z=_Mathmax3(_clippedVertex1PositionScreen.z,_clippedVertex2PositionScreen.z),_line.material=object.material,object.material.vertexColors===THREE.VertexColors&&(_line.vertexColors[0].copy(object.geometry.colors[v]),_line.vertexColors[1].copy(object.geometry.colors[v-1])),_renderData.elements.push(_line)))}for(o=0,ol=_renderData.sprites.length;o<ol;o++)if(object=_renderData.sprites[o].object,_modelMatrix=object.matrixWorld,object instanceof THREE.Particle){_vector4.set(_modelMatrix.elements[12],_modelMatrix.elements[13],_modelMatrix.elements[14],1),_vector4.applyMatrix4(_viewProjectionMatrix);var invW=1/_vector4.w;_vector4.z*=invW,0<_vector4.z&&1>_vector4.z&&(_particle=getNextParticleInPool(),_particle.id=object.id,_particle.x=_vector4.x*invW,_particle.y=_vector4.y*invW,_particle.z=_vector4.z,_particle.object=object,_particle.rotation=object.rotation.z,_particle.scale.x=object.scale.x*_Mathabs5(_particle.x-(_vector4.x+camera.projectionMatrix.elements[0])/(_vector4.w+camera.projectionMatrix.elements[12])),_particle.scale.y=object.scale.y*_Mathabs5(_particle.y-(_vector4.y+camera.projectionMatrix.elements[5])/(_vector4.w+camera.projectionMatrix.elements[13])),_particle.material=object.material,_renderData.elements.push(_particle))}return!0===sortElements&&_renderData.elements.sort(painterSort),_renderData}},THREE.Face3=function(a,b,c,normal,color,materialIndex){this.a=a,this.b=b,this.c=c,this.normal=normal instanceof THREE.Vector3?normal:new THREE.Vector3,this.vertexNormals=normal instanceof Array?normal:[],this.color=color instanceof THREE.Color?color:new THREE.Color,this.vertexColors=color instanceof Array?color:[],this.vertexTangents=[],this.materialIndex=materialIndex===void 0?0:materialIndex,this.centroid=new THREE.Vector3},THREE.Face3.prototype={constructor:THREE.Face3,clone:function clone(){var face=new THREE.Face3(this.a,this.b,this.c);face.normal.copy(this.normal),face.color.copy(this.color),face.centroid.copy(this.centroid),face.materialIndex=this.materialIndex;var i,il;for(i=0,il=this.vertexNormals.length;i<il;i++)face.vertexNormals[i]=this.vertexNormals[i].clone();for(i=0,il=this.vertexColors.length;i<il;i++)face.vertexColors[i]=this.vertexColors[i].clone();for(i=0,il=this.vertexTangents.length;i<il;i++)face.vertexTangents[i]=this.vertexTangents[i].clone();return face}},THREE.Face4=function(a,b,c,d,normal,color,materialIndex){return new THREE.Face3(a,b,c,normal,color,materialIndex)},THREE.Geometry=function(){this.id=THREE.GeometryIdCount++,this.uuid=THREE.Math.generateUUID(),this.name='',this.vertices=[],this.colors=[],this.normals=[],this.faces=[],this.faceVertexUvs=[[]],this.morphTargets=[],this.morphColors=[],this.morphNormals=[],this.skinWeights=[],this.skinIndices=[],this.lineDistances=[],this.boundingBox=null,this.boundingSphere=null,this.hasTangents=!1,this.dynamic=!0,this.verticesNeedUpdate=!1,this.elementsNeedUpdate=!1,this.uvsNeedUpdate=!1,this.normalsNeedUpdate=!1,this.tangentsNeedUpdate=!1,this.colorsNeedUpdate=!1,this.lineDistancesNeedUpdate=!1,this.buffersNeedUpdate=!1},THREE.Geometry.prototype={constructor:THREE.Geometry,applyMatrix:function applyMatrix(matrix){for(var normalMatrix=new THREE.Matrix3().getNormalMatrix(matrix),i=0,il=this.vertices.length,vertex;i<il;i++)vertex=this.vertices[i],vertex.applyMatrix4(matrix);for(var i=0,il=this.faces.length,face;i<il;i++){face=this.faces[i],face.normal.applyMatrix3(normalMatrix).normalize();for(var j=0,jl=face.vertexNormals.length;j<jl;j++)face.vertexNormals[j].applyMatrix3(normalMatrix).normalize();face.centroid.applyMatrix4(matrix)}this.boundingBox instanceof THREE.Box3&&this.computeBoundingBox(),this.boundingSphere instanceof THREE.Sphere&&this.computeBoundingSphere()},computeCentroids:function computeCentroids(){var f,fl,face;for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],face.centroid.set(0,0,0),face.centroid.add(this.vertices[face.a]),face.centroid.add(this.vertices[face.b]),face.centroid.add(this.vertices[face.c]),face.centroid.divideScalar(3)},computeFaceNormals:function computeFaceNormals(){for(var cb=new THREE.Vector3,ab=new THREE.Vector3,f=0,fl=this.faces.length;f<fl;f++){var face=this.faces[f],vA=this.vertices[face.a],vB=this.vertices[face.b],vC=this.vertices[face.c];cb.subVectors(vC,vB),ab.subVectors(vA,vB),cb.cross(ab),cb.normalize(),face.normal.copy(cb)}},computeVertexNormals:function computeVertexNormals(areaWeighted){var v,vl,f,fl,face,vertices;if(this.__tmpVertices===void 0){for(this.__tmpVertices=Array(this.vertices.length),vertices=this.__tmpVertices,(v=0,vl=this.vertices.length);v<vl;v++)vertices[v]=new THREE.Vector3;for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],face.vertexNormals=[new THREE.Vector3,new THREE.Vector3,new THREE.Vector3]}else for(vertices=this.__tmpVertices,v=0,vl=this.vertices.length;v<vl;v++)vertices[v].set(0,0,0);if(areaWeighted){var cb=new THREE.Vector3,ab=new THREE.Vector3,db=new THREE.Vector3,dc=new THREE.Vector3,bc=new THREE.Vector3,vA,vB,vC;for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],vA=this.vertices[face.a],vB=this.vertices[face.b],vC=this.vertices[face.c],cb.subVectors(vC,vB),ab.subVectors(vA,vB),cb.cross(ab),vertices[face.a].add(cb),vertices[face.b].add(cb),vertices[face.c].add(cb)}else for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],vertices[face.a].add(face.normal),vertices[face.b].add(face.normal),vertices[face.c].add(face.normal);for(v=0,vl=this.vertices.length;v<vl;v++)vertices[v].normalize();for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],face.vertexNormals[0].copy(vertices[face.a]),face.vertexNormals[1].copy(vertices[face.b]),face.vertexNormals[2].copy(vertices[face.c])},computeMorphNormals:function computeMorphNormals(){var i,il,f,fl,face;for(f=0,fl=this.faces.length;f<fl;f++)for(face=this.faces[f],face.__originalFaceNormal?face.__originalFaceNormal.copy(face.normal):face.__originalFaceNormal=face.normal.clone(),face.__originalVertexNormals||(face.__originalVertexNormals=[]),(i=0,il=face.vertexNormals.length);i<il;i++)face.__originalVertexNormals[i]?face.__originalVertexNormals[i].copy(face.vertexNormals[i]):face.__originalVertexNormals[i]=face.vertexNormals[i].clone();var tmpGeo=new THREE.Geometry;for(tmpGeo.faces=this.faces,i=0,il=this.morphTargets.length;i<il;i++){if(!this.morphNormals[i]){this.morphNormals[i]={},this.morphNormals[i].faceNormals=[],this.morphNormals[i].vertexNormals=[];var dstNormalsFace=this.morphNormals[i].faceNormals,dstNormalsVertex=this.morphNormals[i].vertexNormals,faceNormal,vertexNormals;for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],faceNormal=new THREE.Vector3,vertexNormals={a:new THREE.Vector3,b:new THREE.Vector3,c:new THREE.Vector3},dstNormalsFace.push(faceNormal),dstNormalsVertex.push(vertexNormals)}var morphNormals=this.morphNormals[i];tmpGeo.vertices=this.morphTargets[i].vertices,tmpGeo.computeFaceNormals(),tmpGeo.computeVertexNormals();var faceNormal,vertexNormals;for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],faceNormal=morphNormals.faceNormals[f],vertexNormals=morphNormals.vertexNormals[f],faceNormal.copy(face.normal),vertexNormals.a.copy(face.vertexNormals[0]),vertexNormals.b.copy(face.vertexNormals[1]),vertexNormals.c.copy(face.vertexNormals[2])}for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],face.normal=face.__originalFaceNormal,face.vertexNormals=face.__originalVertexNormals},computeTangents:function computeTangents(){function handleTriangle(context,a,b,c,ua,ub,uc){vA=context.vertices[a],vB=context.vertices[b],vC=context.vertices[c],uvA=uv[ua],uvB=uv[ub],uvC=uv[uc],x1=vB.x-vA.x,x2=vC.x-vA.x,y1=vB.y-vA.y,y2=vC.y-vA.y,z1=vB.z-vA.z,z2=vC.z-vA.z,s1=uvB.x-uvA.x,s2=uvC.x-uvA.x,t1=uvB.y-uvA.y,t2=uvC.y-uvA.y,r=1/(s1*t2-s2*t1),sdir.set((t2*x1-t1*x2)*r,(t2*y1-t1*y2)*r,(t2*z1-t1*z2)*r),tdir.set((s1*x2-s2*x1)*r,(s1*y2-s2*y1)*r,(s1*z2-s2*z1)*r),tan1[a].add(sdir),tan1[b].add(sdir),tan1[c].add(sdir),tan2[a].add(tdir),tan2[b].add(tdir),tan2[c].add(tdir)}var tan1=[],tan2=[],sdir=new THREE.Vector3,tdir=new THREE.Vector3,tmp=new THREE.Vector3,tmp2=new THREE.Vector3,n=new THREE.Vector3,f,fl,v,vl,i,vertexIndex,face,uv,vA,vB,vC,uvA,uvB,uvC,x1,x2,y1,y2,z1,z2,s1,s2,t1,t2,r,t,test,w;for(v=0,vl=this.vertices.length;v<vl;v++)tan1[v]=new THREE.Vector3,tan2[v]=new THREE.Vector3;for(f=0,fl=this.faces.length;f<fl;f++)face=this.faces[f],uv=this.faceVertexUvs[0][f],handleTriangle(this,face.a,face.b,face.c,0,1,2);var faceIndex=['a','b','c','d'];for(f=0,fl=this.faces.length;f<fl;f++)for(face=this.faces[f],i=0;i<Math.min(face.vertexNormals.length,3);i++)n.copy(face.vertexNormals[i]),vertexIndex=face[faceIndex[i]],t=tan1[vertexIndex],tmp.copy(t),tmp.sub(n.multiplyScalar(n.dot(t))).normalize(),tmp2.crossVectors(face.vertexNormals[i],t),test=tmp2.dot(tan2[vertexIndex]),w=0>test?-1:1,face.vertexTangents[i]=new THREE.Vector4(tmp.x,tmp.y,tmp.z,w);this.hasTangents=!0},computeLineDistances:function computeLineDistances(){for(var d=0,vertices=this.vertices,i=0,il=vertices.length;i<il;i++)0<i&&(d+=vertices[i].distanceTo(vertices[i-1])),this.lineDistances[i]=d},computeBoundingBox:function computeBoundingBox(){null===this.boundingBox&&(this.boundingBox=new THREE.Box3),this.boundingBox.setFromPoints(this.vertices)},computeBoundingSphere:function computeBoundingSphere(){null===this.boundingSphere&&(this.boundingSphere=new THREE.Sphere),this.boundingSphere.setFromPoints(this.vertices)},mergeVertices:function mergeVertices(){var _Mathround=Math.round,verticesMap={},unique=[],changes=[],precision=10000,v,key,i,il,face,indices,j,jl;for(this.__tmpVertices=void 0,i=0,il=this.vertices.length;i<il;i++)v=this.vertices[i],key=_Mathround(v.x*precision)+'_'+_Mathround(v.y*precision)+'_'+_Mathround(v.z*precision),void 0===verticesMap[key]?(verticesMap[key]=i,unique.push(this.vertices[i]),changes[i]=unique.length-1):changes[i]=changes[verticesMap[key]];var faceIndicesToRemove=[];for(i=0,il=this.faces.length;i<il;i++){face=this.faces[i],face.a=changes[face.a],face.b=changes[face.b],face.c=changes[face.c],indices=[face.a,face.b,face.c];for(var dupIndex=-1,n=0;3>n;n++)if(indices[n]==indices[(n+1)%3]){dupIndex=n,faceIndicesToRemove.push(i);break}}for(i=faceIndicesToRemove.length-1;0<=i;i--)for(this.faces.splice(i,1),j=0,jl=this.faceVertexUvs.length;j<jl;j++)this.faceVertexUvs[j].splice(i,1);var diff=this.vertices.length-unique.length;return this.vertices=unique,diff},clone:function clone(){for(var geometry=new THREE.Geometry,vertices=this.vertices,i=0,il=vertices.length;i<il;i++)geometry.vertices.push(vertices[i].clone());for(var faces=this.faces,i=0,il=faces.length;i<il;i++)geometry.faces.push(faces[i].clone());for(var uvs=this.faceVertexUvs[0],i=0,il=uvs.length;i<il;i++){for(var uv=uvs[i],uvCopy=[],j=0,jl=uv.length;j<jl;j++)uvCopy.push(new THREE.Vector2(uv[j].x,uv[j].y));geometry.faceVertexUvs[0].push(uvCopy)}return geometry},dispose:function dispose(){this.dispatchEvent({type:'dispose'})}},THREE.EventDispatcher.prototype.apply(THREE.Geometry.prototype),THREE.GeometryIdCount=0,THREE.BufferGeometry=function(){this.id=THREE.GeometryIdCount++,this.uuid=THREE.Math.generateUUID(),this.name='',this.attributes={},this.dynamic=!0,this.offsets=[],this.boundingBox=null,this.boundingSphere=null,this.hasTangents=!1,this.morphTargets=[]},THREE.BufferGeometry.prototype={constructor:THREE.BufferGeometry,applyMatrix:function applyMatrix(matrix){var positionArray,normalArray;if(this.attributes.position&&(positionArray=this.attributes.position.array),this.attributes.normal&&(normalArray=this.attributes.normal.array),void 0!==positionArray&&(matrix.multiplyVector3Array(positionArray),this.verticesNeedUpdate=!0),void 0!==normalArray){var normalMatrix=new THREE.Matrix3().getNormalMatrix(matrix);normalMatrix.multiplyVector3Array(normalArray),this.normalizeNormals(),this.normalsNeedUpdate=!0}},computeBoundingBox:function computeBoundingBox(){null===this.boundingBox&&(this.boundingBox=new THREE.Box3);var positions=this.attributes.position.array;if(positions){var bb=this.boundingBox,x,y,z;3<=positions.length&&(bb.min.x=bb.max.x=positions[0],bb.min.y=bb.max.y=positions[1],bb.min.z=bb.max.z=positions[2]);for(var i=3,il=positions.length;i<il;i+=3)x=positions[i],y=positions[i+1],z=positions[i+2],x<bb.min.x?bb.min.x=x:x>bb.max.x&&(bb.max.x=x),y<bb.min.y?bb.min.y=y:y>bb.max.y&&(bb.max.y=y),z<bb.min.z?bb.min.z=z:z>bb.max.z&&(bb.max.z=z)}(positions===void 0||0===positions.length)&&(this.boundingBox.min.set(0,0,0),this.boundingBox.max.set(0,0,0))},computeBoundingSphere:function(){var box=new THREE.Box3,vector=new THREE.Vector3;return function(){null===this.boundingSphere&&(this.boundingSphere=new THREE.Sphere);var positions=this.attributes.position.array;if(positions){for(var center=this.boundingSphere.center,i=0,il=positions.length;i<il;i+=3)vector.set(positions[i],positions[i+1],positions[i+2]),box.addPoint(vector);box.center(center);for(var maxRadiusSq=0,i=0,il=positions.length;i<il;i+=3)vector.set(positions[i],positions[i+1],positions[i+2]),maxRadiusSq=Math.max(maxRadiusSq,center.distanceToSquared(vector));this.boundingSphere.radius=Math.sqrt(maxRadiusSq)}}}(),computeVertexNormals:function computeVertexNormals(){if(this.attributes.position){var nVertexElements=this.attributes.position.array.length,i,il,j,jl;if(this.attributes.normal===void 0)this.attributes.normal={itemSize:3,array:new Float32Array(nVertexElements)};else for(i=0,il=this.attributes.normal.array.length;i<il;i++)this.attributes.normal.array[i]=0;var positions=this.attributes.position.array,normals=this.attributes.normal.array,pA=new THREE.Vector3,pB=new THREE.Vector3,pC=new THREE.Vector3,cb=new THREE.Vector3,ab=new THREE.Vector3,vA,vB,vC,x,y,z;if(this.attributes.index){var indices=this.attributes.index.array,offsets=this.offsets;for(j=0,jl=offsets.length;j<jl;++j){var start=offsets[j].start,count=offsets[j].count,index=offsets[j].index;for(i=start,il=start+count;i<il;i+=3)vA=index+indices[i],vB=index+indices[i+1],vC=index+indices[i+2],x=positions[3*vA],y=positions[3*vA+1],z=positions[3*vA+2],pA.set(x,y,z),x=positions[3*vB],y=positions[3*vB+1],z=positions[3*vB+2],pB.set(x,y,z),x=positions[3*vC],y=positions[3*vC+1],z=positions[3*vC+2],pC.set(x,y,z),cb.subVectors(pC,pB),ab.subVectors(pA,pB),cb.cross(ab),normals[3*vA]+=cb.x,normals[3*vA+1]+=cb.y,normals[3*vA+2]+=cb.z,normals[3*vB]+=cb.x,normals[3*vB+1]+=cb.y,normals[3*vB+2]+=cb.z,normals[3*vC]+=cb.x,normals[3*vC+1]+=cb.y,normals[3*vC+2]+=cb.z}}else for(i=0,il=positions.length;i<il;i+=9)x=positions[i],y=positions[i+1],z=positions[i+2],pA.set(x,y,z),x=positions[i+3],y=positions[i+4],z=positions[i+5],pB.set(x,y,z),x=positions[i+6],y=positions[i+7],z=positions[i+8],pC.set(x,y,z),cb.subVectors(pC,pB),ab.subVectors(pA,pB),cb.cross(ab),normals[i]=cb.x,normals[i+1]=cb.y,normals[i+2]=cb.z,normals[i+3]=cb.x,normals[i+4]=cb.y,normals[i+5]=cb.z,normals[i+6]=cb.x,normals[i+7]=cb.y,normals[i+8]=cb.z;this.normalizeNormals(),this.normalsNeedUpdate=!0}},normalizeNormals:function normalizeNormals(){for(var normals=this.attributes.normal.array,i=0,il=normals.length,x,y,z,n;i<il;i+=3)x=normals[i],y=normals[i+1],z=normals[i+2],n=1/Math.sqrt(x*x+y*y+z*z),normals[i]*=n,normals[i+1]*=n,normals[i+2]*=n},computeTangents:function computeTangents(){function handleTriangle(a,b,c){xA=positions[3*a],yA=positions[3*a+1],zA=positions[3*a+2],xB=positions[3*b],yB=positions[3*b+1],zB=positions[3*b+2],xC=positions[3*c],yC=positions[3*c+1],zC=positions[3*c+2],uA=uvs[2*a],vA=uvs[2*a+1],uB=uvs[2*b],vB=uvs[2*b+1],uC=uvs[2*c],vC=uvs[2*c+1],x1=xB-xA,x2=xC-xA,y1=yB-yA,y2=yC-yA,z1=zB-zA,z2=zC-zA,s1=uB-uA,s2=uC-uA,t1=vB-vA,t2=vC-vA,r=1/(s1*t2-s2*t1),sdir.set((t2*x1-t1*x2)*r,(t2*y1-t1*y2)*r,(t2*z1-t1*z2)*r),tdir.set((s1*x2-s2*x1)*r,(s1*y2-s2*y1)*r,(s1*z2-s2*z1)*r),tan1[a].add(sdir),tan1[b].add(sdir),tan1[c].add(sdir),tan2[a].add(tdir),tan2[b].add(tdir),tan2[c].add(tdir)}function handleVertex(v){n.x=normals[3*v],n.y=normals[3*v+1],n.z=normals[3*v+2],n2.copy(n),t=tan1[v],tmp.copy(t),tmp.sub(n.multiplyScalar(n.dot(t))).normalize(),tmp2.crossVectors(n2,t),test=tmp2.dot(tan2[v]),w=0>test?-1:1,tangents[4*v]=tmp.x,tangents[4*v+1]=tmp.y,tangents[4*v+2]=tmp.z,tangents[4*v+3]=w}if(void 0===this.attributes.index||void 0===this.attributes.position||void 0===this.attributes.normal||void 0===this.attributes.uv)return void console.warn('Missing required attributes (index, position, normal or uv) in BufferGeometry.computeTangents()');var indices=this.attributes.index.array,positions=this.attributes.position.array,normals=this.attributes.normal.array,uvs=this.attributes.uv.array,nVertices=positions.length/3;if(this.attributes.tangent===void 0){this.attributes.tangent={itemSize:4,array:new Float32Array(4*nVertices)}}for(var tangents=this.attributes.tangent.array,tan1=[],tan2=[],k=0;k<nVertices;k++)tan1[k]=new THREE.Vector3,tan2[k]=new THREE.Vector3;var sdir=new THREE.Vector3,tdir=new THREE.Vector3,offsets=this.offsets,xA,yA,zA,xB,yB,zB,xC,yC,zC,uA,vA,uB,vB,uC,vC,x1,x2,y1,y2,z1,z2,s1,s2,t1,t2,r,i,il,j,jl,iA,iB,iC;for(j=0,jl=offsets.length;j<jl;++j){var start=offsets[j].start,count=offsets[j].count,index=offsets[j].index;for(i=start,il=start+count;i<il;i+=3)iA=index+indices[i],iB=index+indices[i+1],iC=index+indices[i+2],handleTriangle(iA,iB,iC)}var tmp=new THREE.Vector3,tmp2=new THREE.Vector3,n=new THREE.Vector3,n2=new THREE.Vector3,w,t,test;for(j=0,jl=offsets.length;j<jl;++j){var start=offsets[j].start,count=offsets[j].count,index=offsets[j].index;for(i=start,il=start+count;i<il;i+=3)iA=index+indices[i],iB=index+indices[i+1],iC=index+indices[i+2],handleVertex(iA),handleVertex(iB),handleVertex(iC)}this.hasTangents=!0,this.tangentsNeedUpdate=!0},dispose:function dispose(){this.dispatchEvent({type:'dispose'})}},THREE.EventDispatcher.prototype.apply(THREE.BufferGeometry.prototype),THREE.Camera=function(){THREE.Object3D.call(this),this.matrixWorldInverse=new THREE.Matrix4,this.projectionMatrix=new THREE.Matrix4,this.projectionMatrixInverse=new THREE.Matrix4},THREE.Camera.prototype=Object.create(THREE.Object3D.prototype),THREE.Camera.prototype.lookAt=function(){var m1=new THREE.Matrix4;return function(vector){m1.lookAt(this.position,vector,this.up),this.quaternion.setFromRotationMatrix(m1)}}(),THREE.Camera.prototype.clone=function(camera){return void 0===camera&&(camera=new THREE.Camera),THREE.Object3D.prototype.clone.call(this,camera),camera.matrixWorldInverse.copy(this.matrixWorldInverse),camera.projectionMatrix.copy(this.projectionMatrix),camera.projectionMatrixInverse.copy(this.projectionMatrixInverse),camera},THREE.OrthographicCamera=function(left,right,top,bottom,near,far){THREE.Camera.call(this),this.left=left,this.right=right,this.top=top,this.bottom=bottom,this.near=near===void 0?.1:near,this.far=far===void 0?2e3:far,this.updateProjectionMatrix()},THREE.OrthographicCamera.prototype=Object.create(THREE.Camera.prototype),THREE.OrthographicCamera.prototype.updateProjectionMatrix=function(){this.projectionMatrix.makeOrthographic(this.left,this.right,this.top,this.bottom,this.near,this.far)},THREE.OrthographicCamera.prototype.clone=function(){var camera=new THREE.OrthographicCamera;return THREE.Camera.prototype.clone.call(this,camera),camera.left=this.left,camera.right=this.right,camera.top=this.top,camera.bottom=this.bottom,camera.near=this.near,camera.far=this.far,camera},THREE.PerspectiveCamera=function(fov,aspect,near,far){THREE.Camera.call(this),this.fov=fov===void 0?50:fov,this.aspect=aspect===void 0?1:aspect,this.near=near===void 0?.1:near,this.far=far===void 0?2e3:far,this.updateProjectionMatrix()},THREE.PerspectiveCamera.prototype=Object.create(THREE.Camera.prototype),THREE.PerspectiveCamera.prototype.setLens=function(focalLength,frameHeight){frameHeight===void 0&&(frameHeight=24),this.fov=2*THREE.Math.radToDeg(Math.atan(frameHeight/(2*focalLength))),this.updateProjectionMatrix()},THREE.PerspectiveCamera.prototype.setViewOffset=function(fullWidth,fullHeight,x,y,width,height){this.fullWidth=fullWidth,this.fullHeight=fullHeight,this.x=x,this.y=y,this.width=width,this.height=height,this.updateProjectionMatrix()},THREE.PerspectiveCamera.prototype.updateProjectionMatrix=function(){var _Mathabs6=Math.abs;if(this.fullWidth){var aspect=this.fullWidth/this.fullHeight,top=Math.tan(THREE.Math.degToRad(.5*this.fov))*this.near,bottom=-top,left=aspect*bottom,width=_Mathabs6(aspect*top-left),height=_Mathabs6(top-bottom);this.projectionMatrix.makeFrustum(left+this.x*width/this.fullWidth,left+(this.x+this.width)*width/this.fullWidth,top-(this.y+this.height)*height/this.fullHeight,top-this.y*height/this.fullHeight,this.near,this.far)}else this.projectionMatrix.makePerspective(this.fov,this.aspect,this.near,this.far)},THREE.PerspectiveCamera.prototype.clone=function(){var camera=new THREE.PerspectiveCamera;return THREE.Camera.prototype.clone.call(this,camera),camera.fov=this.fov,camera.aspect=this.aspect,camera.near=this.near,camera.far=this.far,camera},THREE.Light=function(hex){THREE.Object3D.call(this),this.color=new THREE.Color(hex)},THREE.Light.prototype=Object.create(THREE.Object3D.prototype),THREE.Light.prototype.clone=function(light){return void 0===light&&(light=new THREE.Light),THREE.Object3D.prototype.clone.call(this,light),light.color.copy(this.color),light},THREE.AmbientLight=function(hex){THREE.Light.call(this,hex)},THREE.AmbientLight.prototype=Object.create(THREE.Light.prototype),THREE.AmbientLight.prototype.clone=function(){var light=new THREE.AmbientLight;return THREE.Light.prototype.clone.call(this,light),light},THREE.AreaLight=function(hex,intensity){THREE.Light.call(this,hex),this.normal=new THREE.Vector3(0,-1,0),this.right=new THREE.Vector3(1,0,0),this.intensity=intensity===void 0?1:intensity,this.width=1,this.height=1,this.constantAttenuation=1.5,this.linearAttenuation=.5,this.quadraticAttenuation=.1},THREE.AreaLight.prototype=Object.create(THREE.Light.prototype),THREE.DirectionalLight=function(hex,intensity){THREE.Light.call(this,hex),this.position.set(0,1,0),this.target=new THREE.Object3D,this.intensity=intensity===void 0?1:intensity,this.castShadow=!1,this.onlyShadow=!1,this.shadowCameraNear=50,this.shadowCameraFar=5e3,this.shadowCameraLeft=-500,this.shadowCameraRight=500,this.shadowCameraTop=500,this.shadowCameraBottom=-500,this.shadowCameraVisible=!1,this.shadowBias=0,this.shadowDarkness=.5,this.shadowMapWidth=512,this.shadowMapHeight=512,this.shadowCascade=!1,this.shadowCascadeOffset=new THREE.Vector3(0,0,-1e3),this.shadowCascadeCount=2,this.shadowCascadeBias=[0,0,0],this.shadowCascadeWidth=[512,512,512],this.shadowCascadeHeight=[512,512,512],this.shadowCascadeNearZ=[-1,.99,.998],this.shadowCascadeFarZ=[.99,.998,1],this.shadowCascadeArray=[],this.shadowMap=null,this.shadowMapSize=null,this.shadowCamera=null,this.shadowMatrix=null},THREE.DirectionalLight.prototype=Object.create(THREE.Light.prototype),THREE.DirectionalLight.prototype.clone=function(){var light=new THREE.DirectionalLight;return THREE.Light.prototype.clone.call(this,light),light.target=this.target.clone(),light.intensity=this.intensity,light.castShadow=this.castShadow,light.onlyShadow=this.onlyShadow,light},THREE.HemisphereLight=function(skyColorHex,groundColorHex,intensity){THREE.Light.call(this,skyColorHex),this.position.set(0,100,0),this.groundColor=new THREE.Color(groundColorHex),this.intensity=intensity===void 0?1:intensity},THREE.HemisphereLight.prototype=Object.create(THREE.Light.prototype),THREE.HemisphereLight.prototype.clone=function(){var light=new THREE.HemisphereLight;return THREE.Light.prototype.clone.call(this,light),light.groundColor.copy(this.groundColor),light.intensity=this.intensity,light},THREE.PointLight=function(hex,intensity,distance){THREE.Light.call(this,hex),this.intensity=intensity===void 0?1:intensity,this.distance=distance===void 0?0:distance},THREE.PointLight.prototype=Object.create(THREE.Light.prototype),THREE.PointLight.prototype.clone=function(){var light=new THREE.PointLight;return THREE.Light.prototype.clone.call(this,light),light.intensity=this.intensity,light.distance=this.distance,light},THREE.SpotLight=function(hex,intensity,distance,angle,exponent){THREE.Light.call(this,hex),this.position.set(0,1,0),this.target=new THREE.Object3D,this.intensity=intensity===void 0?1:intensity,this.distance=distance===void 0?0:distance,this.angle=angle===void 0?Math.PI/3:angle,this.exponent=exponent===void 0?10:exponent,this.castShadow=!1,this.onlyShadow=!1,this.shadowCameraNear=50,this.shadowCameraFar=5e3,this.shadowCameraFov=50,this.shadowCameraVisible=!1,this.shadowBias=0,this.shadowDarkness=.5,this.shadowMapWidth=512,this.shadowMapHeight=512,this.shadowMap=null,this.shadowMapSize=null,this.shadowCamera=null,this.shadowMatrix=null},THREE.SpotLight.prototype=Object.create(THREE.Light.prototype),THREE.SpotLight.prototype.clone=function(){var light=new THREE.SpotLight;return THREE.Light.prototype.clone.call(this,light),light.target=this.target.clone(),light.intensity=this.intensity,light.distance=this.distance,light.angle=this.angle,light.exponent=this.exponent,light.castShadow=this.castShadow,light.onlyShadow=this.onlyShadow,light},THREE.Loader=function(showStatus){this.showStatus=showStatus,this.statusDomElement=showStatus?THREE.Loader.prototype.addStatusElement():null,this.onLoadStart=function(){},this.onLoadProgress=function(){},this.onLoadComplete=function(){}},THREE.Loader.prototype={constructor:THREE.Loader,crossOrigin:'anonymous',addStatusElement:function addStatusElement(){var e=document.createElement('div');return e.style.position='absolute',e.style.right='0px',e.style.top='0px',e.style.fontSize='0.8em',e.style.textAlign='left',e.style.background='rgba(0,0,0,0.25)',e.style.color='#fff',e.style.width='120px',e.style.padding='0.5em 0.5em 0.5em 0.5em',e.style.zIndex=1e3,e.innerHTML='Loading ...',e},updateProgress:function updateProgress(progress){var message='Loaded ';message+=progress.total?(100*progress.loaded/progress.total).toFixed(0)+'%':(progress.loaded/1e3).toFixed(2)+' KB',this.statusDomElement.innerHTML=message},extractUrlBase:function extractUrlBase(url){var parts=url.split('/');return parts.pop(),(1>parts.length?'.':parts.join('/'))+'/'},initMaterials:function initMaterials(materials,texturePath){for(var array=[],i=0;i<materials.length;++i)array[i]=THREE.Loader.prototype.createMaterial(materials[i],texturePath);return array},needsTangents:function needsTangents(materials){for(var i=0,il=materials.length,m;i<il;i++)if(m=materials[i],m instanceof THREE.ShaderMaterial)return!0;return!1},createMaterial:function createMaterial(m,texturePath){function is_pow2(n){var l=_Mathlog(n)/_MathLN;return Math.floor(l)==l}function nearest_pow2(n){var l=_Mathlog(n)/_MathLN;return Math.pow(2,Math.round(l))}function load_image(where,url){var image=new Image;image.onload=function(){if(!is_pow2(this.width)||!is_pow2(this.height)){var width=nearest_pow2(this.width),height=nearest_pow2(this.height);where.image.width=width,where.image.height=height,where.image.getContext('2d').drawImage(this,0,0,width,height)}else where.image=this;where.needsUpdate=!0},image.crossOrigin=_this.crossOrigin,image.src=url}function create_texture(where,name,sourceFile,repeat,offset,wrap,anisotropy){var isCompressed=/\.dds$/i.test(sourceFile),fullPath=texturePath+'/'+sourceFile;if(isCompressed){var texture=THREE.ImageUtils.loadCompressedTexture(fullPath);where[name]=texture}else{var texture=document.createElement('canvas');where[name]=new THREE.Texture(texture)}if(where[name].sourceFile=sourceFile,repeat&&(where[name].repeat.set(repeat[0],repeat[1]),1!==repeat[0]&&(where[name].wrapS=THREE.RepeatWrapping),1!==repeat[1]&&(where[name].wrapT=THREE.RepeatWrapping)),offset&&where[name].offset.set(offset[0],offset[1]),wrap){var wrapMap={repeat:THREE.RepeatWrapping,mirror:THREE.MirroredRepeatWrapping};void 0!==wrapMap[wrap[0]]&&(where[name].wrapS=wrapMap[wrap[0]]),void 0!==wrapMap[wrap[1]]&&(where[name].wrapT=wrapMap[wrap[1]])}anisotropy&&(where[name].anisotropy=anisotropy),isCompressed||load_image(where[name],fullPath)}function rgb2hex(rgb){return(255*rgb[0]<<16)+(255*rgb[1]<<8)+255*rgb[2]}var _MathLN=Math.LN2,_Mathlog=Math.log,_this=this,mtype='MeshLambertMaterial',mpars={color:15658734,opacity:1,map:null,lightMap:null,normalMap:null,bumpMap:null,wireframe:!1};if(m.shading){var shading=m.shading.toLowerCase();'phong'===shading?mtype='MeshPhongMaterial':'basic'===shading&&(mtype='MeshBasicMaterial')}if(void 0!==m.blending&&void 0!==THREE[m.blending]&&(mpars.blending=THREE[m.blending]),(void 0!==m.transparent||1>m.opacity)&&(mpars.transparent=m.transparent),void 0!==m.depthTest&&(mpars.depthTest=m.depthTest),void 0!==m.depthWrite&&(mpars.depthWrite=m.depthWrite),void 0!==m.visible&&(mpars.visible=m.visible),void 0!==m.flipSided&&(mpars.side=THREE.BackSide),void 0!==m.doubleSided&&(mpars.side=THREE.DoubleSide),void 0!==m.wireframe&&(mpars.wireframe=m.wireframe),void 0!==m.vertexColors&&('face'===m.vertexColors?mpars.vertexColors=THREE.FaceColors:m.vertexColors&&(mpars.vertexColors=THREE.VertexColors)),m.colorDiffuse?mpars.color=rgb2hex(m.colorDiffuse):m.DbgColor&&(mpars.color=m.DbgColor),m.colorSpecular&&(mpars.specular=rgb2hex(m.colorSpecular)),m.colorAmbient&&(mpars.ambient=rgb2hex(m.colorAmbient)),m.transparency&&(mpars.opacity=m.transparency),m.specularCoef&&(mpars.shininess=m.specularCoef),m.mapDiffuse&&texturePath&&create_texture(mpars,'map',m.mapDiffuse,m.mapDiffuseRepeat,m.mapDiffuseOffset,m.mapDiffuseWrap,m.mapDiffuseAnisotropy),m.mapLight&&texturePath&&create_texture(mpars,'lightMap',m.mapLight,m.mapLightRepeat,m.mapLightOffset,m.mapLightWrap,m.mapLightAnisotropy),m.mapBump&&texturePath&&create_texture(mpars,'bumpMap',m.mapBump,m.mapBumpRepeat,m.mapBumpOffset,m.mapBumpWrap,m.mapBumpAnisotropy),m.mapNormal&&texturePath&&create_texture(mpars,'normalMap',m.mapNormal,m.mapNormalRepeat,m.mapNormalOffset,m.mapNormalWrap,m.mapNormalAnisotropy),m.mapSpecular&&texturePath&&create_texture(mpars,'specularMap',m.mapSpecular,m.mapSpecularRepeat,m.mapSpecularOffset,m.mapSpecularWrap,m.mapSpecularAnisotropy),m.mapBumpScale&&(mpars.bumpScale=m.mapBumpScale),m.mapNormal){var shader=THREE.ShaderLib.normalmap,uniforms=THREE.UniformsUtils.clone(shader.uniforms);uniforms.tNormal.value=mpars.normalMap,m.mapNormalFactor&&uniforms.uNormalScale.value.set(m.mapNormalFactor,m.mapNormalFactor),mpars.map&&(uniforms.tDiffuse.value=mpars.map,uniforms.enableDiffuse.value=!0),mpars.specularMap&&(uniforms.tSpecular.value=mpars.specularMap,uniforms.enableSpecular.value=!0),mpars.lightMap&&(uniforms.tAO.value=mpars.lightMap,uniforms.enableAO.value=!0),uniforms.uDiffuseColor.value.setHex(mpars.color),uniforms.uSpecularColor.value.setHex(mpars.specular),uniforms.uAmbientColor.value.setHex(mpars.ambient),uniforms.uShininess.value=mpars.shininess,void 0!==mpars.opacity&&(uniforms.uOpacity.value=mpars.opacity);var parameters={fragmentShader:shader.fragmentShader,vertexShader:shader.vertexShader,uniforms:uniforms,lights:!0,fog:!0},material=new THREE.ShaderMaterial(parameters);mpars.transparent&&(material.transparent=!0)}else var material=new THREE[mtype](mpars);return void 0!==m.DbgName&&(material.name=m.DbgName),material}},THREE.XHRLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.XHRLoader.prototype={constructor:THREE.XHRLoader,load:function load(url,onLoad,onProgress,onError){var scope=this,request=new XMLHttpRequest;onLoad!==void 0&&request.addEventListener('load',function(event){onLoad(event.target.responseText),scope.manager.itemEnd(url)},!1),onProgress!==void 0&&request.addEventListener('progress',function(event){onProgress(event)},!1),onError!==void 0&&request.addEventListener('error',function(event){onError(event)},!1),this.crossOrigin!==void 0&&(request.crossOrigin=this.crossOrigin),request.open('GET',url,!0),request.send(null),scope.manager.itemStart(url)},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value}},THREE.ImageLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.ImageLoader.prototype={constructor:THREE.ImageLoader,load:function load(url,onLoad,onProgress,onError){var scope=this,image=document.createElement('img');onLoad!==void 0&&image.addEventListener('load',function(){scope.manager.itemEnd(url),onLoad(this)},!1),onProgress!==void 0&&image.addEventListener('progress',function(event){onProgress(event)},!1),onError!==void 0&&image.addEventListener('error',function(event){onError(event)},!1),this.crossOrigin!==void 0&&(image.crossOrigin=this.crossOrigin),image.src=url,scope.manager.itemStart(url)},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value}},THREE.JSONLoader=function(showStatus){THREE.Loader.call(this,showStatus),this.withCredentials=!1},THREE.JSONLoader.prototype=Object.create(THREE.Loader.prototype),THREE.JSONLoader.prototype.load=function(url,callback,texturePath){this;texturePath=texturePath&&'string'==typeof texturePath?texturePath:this.extractUrlBase(url),this.onLoadStart(),this.loadAjaxJSON(this,url,callback,texturePath)},THREE.JSONLoader.prototype.loadAjaxJSON=function(context,url,callback,texturePath,callbackProgress){var xhr=new XMLHttpRequest,length=0;xhr.onreadystatechange=function(){if(!(xhr.readyState===xhr.DONE))xhr.readyState===xhr.LOADING?callbackProgress&&(0===length&&(length=xhr.getResponseHeader('Content-Length')),callbackProgress({total:length,loaded:xhr.responseText.length})):xhr.readyState===xhr.HEADERS_RECEIVED&&void 0!==callbackProgress&&(length=xhr.getResponseHeader('Content-Length'));else if(200===xhr.status||0===xhr.status){if(xhr.responseText){var json=JSON.parse(xhr.responseText),result=context.parse(json,texturePath);callback(result.geometry,result.materials)}else console.warn('THREE.JSONLoader: ['+url+'] seems to be unreachable or file there is empty');context.onLoadComplete()}else console.error('THREE.JSONLoader: Couldn\'t load ['+url+'] ['+xhr.status+']')},xhr.open('GET',url,!0),xhr.withCredentials=this.withCredentials,xhr.send(null)},THREE.JSONLoader.prototype.parse=function(json,texturePath){var scope=this,geometry=new THREE.Geometry,scale=void 0===json.scale?1:1/json.scale;if(function(scale){function isBitSet(value,position){return value&1<<position}var faces=json.faces,vertices=json.vertices,normals=json.normals,colors=json.colors,nUvLayers=0,i,j,fi,offset,zLength,colorIndex,normalIndex,uvIndex,materialIndex,type,isQuad,hasMaterial,hasFaceVertexUv,hasFaceNormal,hasFaceVertexNormal,hasFaceColor,hasFaceVertexColor,vertex,face,faceA,faceB,hex,normal,uvLayer,uv,u,v;if(void 0!==json.uvs){for(i=0;i<json.uvs.length;i++)json.uvs[i].length&&nUvLayers++;for(i=0;i<nUvLayers;i++)geometry.faceVertexUvs[i]=[]}for(offset=0,zLength=vertices.length;offset<zLength;)vertex=new THREE.Vector3,vertex.x=vertices[offset++]*scale,vertex.y=vertices[offset++]*scale,vertex.z=vertices[offset++]*scale,geometry.vertices.push(vertex);for(offset=0,zLength=faces.length;offset<zLength;)if(type=faces[offset++],isQuad=isBitSet(type,0),hasMaterial=isBitSet(type,1),hasFaceVertexUv=isBitSet(type,3),hasFaceNormal=isBitSet(type,4),hasFaceVertexNormal=isBitSet(type,5),hasFaceColor=isBitSet(type,6),hasFaceVertexColor=isBitSet(type,7),isQuad){if(faceA=new THREE.Face3,faceA.a=faces[offset],faceA.b=faces[offset+1],faceA.c=faces[offset+3],faceB=new THREE.Face3,faceB.a=faces[offset+1],faceB.b=faces[offset+2],faceB.c=faces[offset+3],offset+=4,hasMaterial&&(materialIndex=faces[offset++],faceA.materialIndex=materialIndex,faceB.materialIndex=materialIndex),fi=geometry.faces.length,hasFaceVertexUv)for(i=0;i<nUvLayers;i++)for(uvLayer=json.uvs[i],geometry.faceVertexUvs[i][fi]=[],geometry.faceVertexUvs[i][fi+1]=[],j=0;4>j;j++)uvIndex=faces[offset++],u=uvLayer[2*uvIndex],v=uvLayer[2*uvIndex+1],uv=new THREE.Vector2(u,v),2!==j&&geometry.faceVertexUvs[i][fi].push(uv),0!==j&&geometry.faceVertexUvs[i][fi+1].push(uv);if(hasFaceNormal&&(normalIndex=3*faces[offset++],faceA.normal.set(normals[normalIndex++],normals[normalIndex++],normals[normalIndex]),faceB.normal.copy(faceA.normal)),hasFaceVertexNormal)for(i=0;4>i;i++)normalIndex=3*faces[offset++],normal=new THREE.Vector3(normals[normalIndex++],normals[normalIndex++],normals[normalIndex]),2!==i&&faceA.vertexNormals.push(normal),0!==i&&faceB.vertexNormals.push(normal);if(hasFaceColor&&(colorIndex=faces[offset++],hex=colors[colorIndex],faceA.color.setHex(hex),faceB.color.setHex(hex)),hasFaceVertexColor)for(i=0;4>i;i++)colorIndex=faces[offset++],hex=colors[colorIndex],2!==i&&faceA.vertexColors.push(new THREE.Color(hex)),0!==i&&faceB.vertexColors.push(new THREE.Color(hex));geometry.faces.push(faceA),geometry.faces.push(faceB)}else{if(face=new THREE.Face3,face.a=faces[offset++],face.b=faces[offset++],face.c=faces[offset++],hasMaterial&&(materialIndex=faces[offset++],face.materialIndex=materialIndex),fi=geometry.faces.length,hasFaceVertexUv)for(i=0;i<nUvLayers;i++)for(uvLayer=json.uvs[i],geometry.faceVertexUvs[i][fi]=[],j=0;3>j;j++)uvIndex=faces[offset++],u=uvLayer[2*uvIndex],v=uvLayer[2*uvIndex+1],uv=new THREE.Vector2(u,v),geometry.faceVertexUvs[i][fi].push(uv);if(hasFaceNormal&&(normalIndex=3*faces[offset++],face.normal.set(normals[normalIndex++],normals[normalIndex++],normals[normalIndex])),hasFaceVertexNormal)for(i=0;3>i;i++)normalIndex=3*faces[offset++],normal=new THREE.Vector3(normals[normalIndex++],normals[normalIndex++],normals[normalIndex]),face.vertexNormals.push(normal);if(hasFaceColor&&(colorIndex=faces[offset++],face.color.setHex(colors[colorIndex])),hasFaceVertexColor)for(i=0;3>i;i++)colorIndex=faces[offset++],face.vertexColors.push(new THREE.Color(colors[colorIndex]));geometry.faces.push(face)}}(scale),function(){var i,l,x,y,z,w,a,b,c,d;if(json.skinWeights)for(i=0,l=json.skinWeights.length;i<l;i+=2)x=json.skinWeights[i],y=json.skinWeights[i+1],z=0,w=0,geometry.skinWeights.push(new THREE.Vector4(x,y,z,w));if(json.skinIndices)for(i=0,l=json.skinIndices.length;i<l;i+=2)a=json.skinIndices[i],b=json.skinIndices[i+1],c=0,d=0,geometry.skinIndices.push(new THREE.Vector4(a,b,c,d));geometry.bones=json.bones,geometry.animation=json.animation}(),function(scale){if(void 0!==json.morphTargets){var i,l,v,vl,dstVertices,srcVertices;for(i=0,l=json.morphTargets.length;i<l;i++)for(geometry.morphTargets[i]={},geometry.morphTargets[i].name=json.morphTargets[i].name,geometry.morphTargets[i].vertices=[],dstVertices=geometry.morphTargets[i].vertices,srcVertices=json.morphTargets[i].vertices,(v=0,vl=srcVertices.length);v<vl;v+=3){var vertex=new THREE.Vector3;vertex.x=srcVertices[v]*scale,vertex.y=srcVertices[v+1]*scale,vertex.z=srcVertices[v+2]*scale,dstVertices.push(vertex)}}if(void 0!==json.morphColors){var i,l,c,cl,dstColors,srcColors,color;for(i=0,l=json.morphColors.length;i<l;i++)for(geometry.morphColors[i]={},geometry.morphColors[i].name=json.morphColors[i].name,geometry.morphColors[i].colors=[],dstColors=geometry.morphColors[i].colors,srcColors=json.morphColors[i].colors,(c=0,cl=srcColors.length);c<cl;c+=3)color=new THREE.Color(16755200),color.setRGB(srcColors[c],srcColors[c+1],srcColors[c+2]),dstColors.push(color)}}(scale),geometry.computeCentroids(),geometry.computeFaceNormals(),geometry.computeBoundingSphere(),void 0===json.materials)return{geometry:geometry};var materials=this.initMaterials(json.materials,texturePath);return this.needsTangents(materials)&&geometry.computeTangents(),{geometry:geometry,materials:materials}},THREE.LoadingManager=function(onLoad,onProgress,onError){var scope=this,loaded=0,total=0;this.onLoad=onLoad,this.onProgress=onProgress,this.onError=onError,this.itemStart=function(){total++},this.itemEnd=function(url){loaded++,scope.onProgress!==void 0&&scope.onProgress(url,loaded,total),loaded==total&&scope.onLoad!==void 0&&scope.onLoad()}},THREE.DefaultLoadingManager=new THREE.LoadingManager,THREE.BufferGeometryLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.BufferGeometryLoader.prototype={constructor:THREE.BufferGeometryLoader,load:function load(url,onLoad){var scope=this,loader=new THREE.XHRLoader;loader.setCrossOrigin(this.crossOrigin),loader.load(url,function(text){onLoad(scope.parse(JSON.parse(text)))})},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value},parse:function parse(json){var geometry=new THREE.BufferGeometry,attributes=json.attributes,offsets=json.offsets,boundingSphere=json.boundingSphere;for(var key in attributes){var attribute=attributes[key];geometry.attributes[key]={itemSize:attribute.itemSize,array:new self[attribute.type](attribute.array)}}return void 0!==offsets&&(geometry.offsets=JSON.parse(JSON.stringify(offsets))),void 0!==boundingSphere&&(geometry.boundingSphere=new THREE.Sphere(new THREE.Vector3().fromArray(void 0===boundingSphere.center?[0,0,0]:boundingSphere.center),boundingSphere.radius)),geometry}},THREE.GeometryLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.GeometryLoader.prototype={constructor:THREE.GeometryLoader,load:function load(url,onLoad){var scope=this,loader=new THREE.XHRLoader;loader.setCrossOrigin(this.crossOrigin),loader.load(url,function(text){onLoad(scope.parse(JSON.parse(text)))})},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value},parse:function parse(){}},THREE.MaterialLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.MaterialLoader.prototype={constructor:THREE.MaterialLoader,load:function load(url,onLoad){var scope=this,loader=new THREE.XHRLoader;loader.setCrossOrigin(this.crossOrigin),loader.load(url,function(text){onLoad(scope.parse(JSON.parse(text)))})},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value},parse:function parse(json){var material=new THREE[json.type];if(void 0!==json.color&&material.color.setHex(json.color),void 0!==json.ambient&&material.ambient.setHex(json.ambient),void 0!==json.emissive&&material.emissive.setHex(json.emissive),void 0!==json.specular&&material.specular.setHex(json.specular),void 0!==json.shininess&&(material.shininess=json.shininess),void 0!==json.vertexColors&&(material.vertexColors=json.vertexColors),void 0!==json.blending&&(material.blending=json.blending),void 0!==json.opacity&&(material.opacity=json.opacity),void 0!==json.transparent&&(material.transparent=json.transparent),void 0!==json.wireframe&&(material.wireframe=json.wireframe),void 0!==json.materials)for(var i=0,l=json.materials.length;i<l;i++)material.materials.push(this.parse(json.materials[i]));return material}},THREE.ObjectLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.ObjectLoader.prototype={constructor:THREE.ObjectLoader,load:function load(url,onLoad){var scope=this,loader=new THREE.XHRLoader(scope.manager);loader.setCrossOrigin(this.crossOrigin),loader.load(url,function(text){onLoad(scope.parse(JSON.parse(text)))})},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value},parse:function parse(json){var geometries=this.parseGeometries(json.geometries),materials=this.parseMaterials(json.materials),object=this.parseObject(json.object,geometries,materials);return object},parseGeometries:function parseGeometries(json){var geometries={};if(json!==void 0)for(var geometryLoader=new THREE.JSONLoader,bufferGeometryLoader=new THREE.BufferGeometryLoader,i=0,l=json.length;i<l;i++){var data=json[i],geometry;switch(data.type){case'PlaneGeometry':geometry=new THREE.PlaneGeometry(data.width,data.height,data.widthSegments,data.heightSegments);break;case'CubeGeometry':geometry=new THREE.CubeGeometry(data.width,data.height,data.depth,data.widthSegments,data.heightSegments,data.depthSegments);break;case'CylinderGeometry':geometry=new THREE.CylinderGeometry(data.radiusTop,data.radiusBottom,data.height,data.radiusSegments,data.heightSegments,data.openEnded);break;case'SphereGeometry':geometry=new THREE.SphereGeometry(data.radius,data.widthSegments,data.heightSegments,data.phiStart,data.phiLength,data.thetaStart,data.thetaLength);break;case'IcosahedronGeometry':geometry=new THREE.IcosahedronGeometry(data.radius,data.detail);break;case'TorusGeometry':geometry=new THREE.TorusGeometry(data.radius,data.tube,data.radialSegments,data.tubularSegments,data.arc);break;case'TorusKnotGeometry':geometry=new THREE.TorusKnotGeometry(data.radius,data.tube,data.radialSegments,data.tubularSegments,data.p,data.q,data.heightScale);break;case'BufferGeometry':geometry=bufferGeometryLoader.parse(data.data);break;case'Geometry':geometry=geometryLoader.parse(data.data).geometry;}geometry.uuid=data.uuid,void 0!==data.name&&(geometry.name=data.name),geometries[data.uuid]=geometry}return geometries},parseMaterials:function parseMaterials(json){var materials={};if(json!==void 0)for(var loader=new THREE.MaterialLoader,i=0,l=json.length;i<l;i++){var data=json[i],material=loader.parse(data);material.uuid=data.uuid,void 0!==data.name&&(material.name=data.name),materials[data.uuid]=material}return materials},parseObject:function(){var matrix=new THREE.Matrix4;return function(data,geometries,materials){var object;switch(data.type){case'Scene':object=new THREE.Scene;break;case'PerspectiveCamera':object=new THREE.PerspectiveCamera(data.fov,data.aspect,data.near,data.far);break;case'OrthographicCamera':object=new THREE.OrthographicCamera(data.left,data.right,data.top,data.bottom,data.near,data.far);break;case'AmbientLight':object=new THREE.AmbientLight(data.color);break;case'DirectionalLight':object=new THREE.DirectionalLight(data.color,data.intensity);break;case'PointLight':object=new THREE.PointLight(data.color,data.intensity,data.distance);break;case'SpotLight':object=new THREE.SpotLight(data.color,data.intensity,data.distance,data.angle,data.exponent);break;case'HemisphereLight':object=new THREE.HemisphereLight(data.color,data.groundColor,data.intensity);break;case'Mesh':var geometry=geometries[data.geometry],material=materials[data.material];void 0===geometry&&console.error('THREE.ObjectLoader: Undefined geometry '+data.geometry),void 0===material&&console.error('THREE.ObjectLoader: Undefined material '+data.material),object=new THREE.Mesh(geometry,material);break;default:object=new THREE.Object3D;}if(object.uuid=data.uuid,void 0!==data.name&&(object.name=data.name),void 0===data.matrix?(void 0!==data.position&&object.position.fromArray(data.position),void 0!==data.rotation&&object.rotation.fromArray(data.rotation),void 0!==data.scale&&object.scale.fromArray(data.scale)):(matrix.fromArray(data.matrix),matrix.decompose(object.position,object.quaternion,object.scale)),void 0!==data.visible&&(object.visible=data.visible),void 0!==data.userData&&(object.userData=data.userData),void 0!==data.children)for(var child in data.children)object.add(this.parseObject(data.children[child],geometries,materials));return object}}()},THREE.SceneLoader=function(){this.onLoadStart=function(){},this.onLoadProgress=function(){},this.onLoadComplete=function(){},this.callbackSync=function(){},this.callbackProgress=function(){},this.geometryHandlers={},this.hierarchyHandlers={},this.addGeometryHandler('ascii',THREE.JSONLoader)},THREE.SceneLoader.prototype={constructor:THREE.SceneLoader,load:function load(url,onLoad){var scope=this,loader=new THREE.XHRLoader(scope.manager);loader.setCrossOrigin(this.crossOrigin),loader.load(url,function(text){scope.parse(JSON.parse(text),onLoad,url)})},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value},addGeometryHandler:function addGeometryHandler(typeID,loaderClass){this.geometryHandlers[typeID]={loaderClass:loaderClass}},addHierarchyHandler:function addHierarchyHandler(typeID,loaderClass){this.hierarchyHandlers[typeID]={loaderClass:loaderClass}},parse:function parse(json,callbackFinished,url){function get_url(source_url,url_type){return'relativeToHTML'==url_type?source_url:urlBase+'/'+source_url}function handle_objects(){handle_children(result.scene,data.objects)}function handle_children(parent,children){var mat,dst,pos,rot,scl,quat;for(var objID in children){var object=result.objects[objID],objJSON=children[objID];if(void 0===object){if(objJSON.type&&objJSON.type in scope.hierarchyHandlers){if(void 0===objJSON.loading){var reservedTypes={type:1,url:1,material:1,position:1,rotation:1,scale:1,visible:1,children:1,userData:1,skin:1,morph:1,mirroredLoop:1,duration:1},loaderParameters={};for(var parType in objJSON)parType in reservedTypes||(loaderParameters[parType]=objJSON[parType]);material=result.materials[objJSON.material],objJSON.loading=!0;var loader=scope.hierarchyHandlers[objJSON.type].loaderObject;loader.options?loader.load(get_url(objJSON.url,data.urlBaseType),create_callback_hierachy(objID,parent,material,objJSON)):loader.load(get_url(objJSON.url,data.urlBaseType),create_callback_hierachy(objID,parent,material,objJSON),loaderParameters)}}else if(void 0===objJSON.geometry)'DirectionalLight'===objJSON.type||'PointLight'===objJSON.type||'AmbientLight'===objJSON.type?(hex=void 0===objJSON.color?16777215:objJSON.color,intensity=void 0===objJSON.intensity?1:objJSON.intensity,'DirectionalLight'===objJSON.type?(pos=objJSON.direction,light=new THREE.DirectionalLight(hex,intensity),light.position.fromArray(pos),objJSON.target&&(target_array.push({object:light,targetName:objJSON.target}),light.target=null)):'PointLight'===objJSON.type?(pos=objJSON.position,dst=objJSON.distance,light=new THREE.PointLight(hex,intensity,dst),light.position.fromArray(pos)):'AmbientLight'===objJSON.type&&(light=new THREE.AmbientLight(hex)),parent.add(light),light.name=objID,result.lights[objID]=light,result.objects[objID]=light):'PerspectiveCamera'===objJSON.type||'OrthographicCamera'===objJSON.type?(pos=objJSON.position,rot=objJSON.rotation,quat=objJSON.quaternion,'PerspectiveCamera'===objJSON.type?camera=new THREE.PerspectiveCamera(objJSON.fov,objJSON.aspect,objJSON.near,objJSON.far):'OrthographicCamera'===objJSON.type&&(camera=new THREE.OrthographicCamera(objJSON.left,objJSON.right,objJSON.top,objJSON.bottom,objJSON.near,objJSON.far)),camera.name=objID,camera.position.fromArray(pos),void 0===quat?void 0!==rot&&camera.rotation.fromArray(rot):camera.quaternion.fromArray(quat),parent.add(camera),result.cameras[objID]=camera,result.objects[objID]=camera):(pos=objJSON.position,rot=objJSON.rotation,scl=objJSON.scale,quat=objJSON.quaternion,object=new THREE.Object3D,object.name=objID,object.position.fromArray(pos),quat?object.quaternion.fromArray(quat):object.rotation.fromArray(rot),object.scale.fromArray(scl),object.visible=void 0!==objJSON.visible&&objJSON.visible,parent.add(object),result.objects[objID]=object,result.empties[objID]=object);else if(geometry=result.geometries[objJSON.geometry],geometry){var needsTangents=!1;if(material=result.materials[objJSON.material],needsTangents=material instanceof THREE.ShaderMaterial,pos=objJSON.position,rot=objJSON.rotation,scl=objJSON.scale,mat=objJSON.matrix,quat=objJSON.quaternion,objJSON.material||(material=new THREE.MeshFaceMaterial(result.face_materials[objJSON.geometry])),material instanceof THREE.MeshFaceMaterial&&0===material.materials.length&&(material=new THREE.MeshFaceMaterial(result.face_materials[objJSON.geometry])),material instanceof THREE.MeshFaceMaterial)for(var i=0;i<material.materials.length;i++)needsTangents=needsTangents||material.materials[i]instanceof THREE.ShaderMaterial;needsTangents&&geometry.computeTangents(),objJSON.skin?object=new THREE.SkinnedMesh(geometry,material):objJSON.morph?(object=new THREE.MorphAnimMesh(geometry,material),void 0!==objJSON.duration&&(object.duration=objJSON.duration),void 0!==objJSON.time&&(object.time=objJSON.time),void 0!==objJSON.mirroredLoop&&(object.mirroredLoop=objJSON.mirroredLoop),material.morphNormals&&geometry.computeMorphNormals()):object=new THREE.Mesh(geometry,material),object.name=objID,mat?(object.matrixAutoUpdate=!1,object.matrix.set(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15])):(object.position.fromArray(pos),quat?object.quaternion.fromArray(quat):object.rotation.fromArray(rot),object.scale.fromArray(scl)),object.visible=objJSON.visible,object.castShadow=objJSON.castShadow,object.receiveShadow=objJSON.receiveShadow,parent.add(object),result.objects[objID]=object}if(object){if(void 0!==objJSON.userData)for(var key in objJSON.userData){var value=objJSON.userData[key];object.userData[key]=value}if(void 0!==objJSON.groups)for(var i=0,groupID;i<objJSON.groups.length;i++)groupID=objJSON.groups[i],void 0===result.groups[groupID]&&(result.groups[groupID]=[]),result.groups[groupID].push(objID)}}void 0!==object&&void 0!==objJSON.children&&handle_children(object,objJSON.children)}}function handle_mesh(geo,mat,id){result.geometries[id]=geo,result.face_materials[id]=mat,handle_objects()}function handle_hierarchy(node,id,parent,material,obj){var p=obj.position,r=obj.rotation,q=obj.quaternion,s=obj.scale;node.position.fromArray(p),q?node.quaternion.fromArray(q):node.rotation.fromArray(r),node.scale.fromArray(s),material&&node.traverse(function(child){child.material=material});var visible=void 0===obj.visible||obj.visible;node.traverse(function(child){child.visible=visible}),parent.add(node),node.name=id,result.objects[id]=node,handle_objects()}function create_callback_geometry(id){return function(geo,mat){geo.name=id,handle_mesh(geo,mat,id),counter_models-=1,scope.onLoadComplete(),async_callback_gate()}}function create_callback_hierachy(id,parent,material,obj){return function(event){var result;result=event.content?event.content:event.dae?event.scene:event,handle_hierarchy(result,id,parent,material,obj),counter_models-=1,scope.onLoadComplete(),async_callback_gate()}}function create_callback_embed(id){return function(geo,mat){geo.name=id,result.geometries[id]=geo,result.face_materials[id]=mat}}function async_callback_gate(){var progress={totalModels:total_models,totalTextures:total_textures,loadedModels:total_models-counter_models,loadedTextures:total_textures-counter_textures};scope.callbackProgress(progress,result),scope.onLoadProgress(),0==counter_models&&0===counter_textures&&(finalize(),callbackFinished(result))}function finalize(){for(var i=0;i<target_array.length;i++){var ta=target_array[i],target=result.objects[ta.targetName];target?ta.object.target=target:(ta.object.target=new THREE.Object3D,result.scene.add(ta.object.target)),ta.object.target.userData.targetInverse=ta.object}}function traverse_json_hierarchy(objJSON,callback){if(callback(objJSON),void 0!==objJSON.children)for(var objChildID in objJSON.children)traverse_json_hierarchy(objJSON.children[objChildID],callback)}var scope=this,urlBase=THREE.Loader.prototype.extractUrlBase(url),target_array=[],data=json,geometry,material,camera,fog,texture,color,light,hex,intensity,counter_models,counter_textures,total_models,total_textures,result;for(var typeID in this.geometryHandlers){var loaderClass=this.geometryHandlers[typeID].loaderClass;this.geometryHandlers[typeID].loaderObject=new loaderClass}for(var typeID in this.hierarchyHandlers){var loaderClass=this.hierarchyHandlers[typeID].loaderClass;this.hierarchyHandlers[typeID].loaderObject=new loaderClass}if(counter_models=0,counter_textures=0,result={scene:new THREE.Scene,geometries:{},face_materials:{},materials:{},textures:{},objects:{},cameras:{},lights:{},fogs:{},empties:{},groups:{}},data.transform){var position=data.transform.position,rotation=data.transform.rotation,scale=data.transform.scale;position&&result.scene.position.fromArray(position),rotation&&result.scene.rotation.fromArray(rotation),scale&&result.scene.scale.fromArray(scale),(position||rotation||scale)&&(result.scene.updateMatrix(),result.scene.updateMatrixWorld())}var callbackTexture=function(count){counter_textures-=count,async_callback_gate(),scope.onLoadComplete()},generateTextureCallback=function(count){return function(){callbackTexture(count)}},fogID,fogJSON;for(fogID in data.fogs)fogJSON=data.fogs[fogID],'linear'===fogJSON.type?fog=new THREE.Fog(0,fogJSON.near,fogJSON.far):'exp2'===fogJSON.type&&(fog=new THREE.FogExp2(0,fogJSON.density)),color=fogJSON.color,fog.color.setRGB(color[0],color[1],color[2]),result.fogs[fogID]=fog;var geoID,geoJSON;for(geoID in data.geometries)geoJSON=data.geometries[geoID],geoJSON.type in this.geometryHandlers&&(counter_models+=1,scope.onLoadStart());for(var objID in data.objects)traverse_json_hierarchy(data.objects[objID],function(objJSON){objJSON.type&&objJSON.type in scope.hierarchyHandlers&&(counter_models+=1,scope.onLoadStart())});for(geoID in total_models=counter_models,data.geometries)if(geoJSON=data.geometries[geoID],'cube'===geoJSON.type)geometry=new THREE.CubeGeometry(geoJSON.width,geoJSON.height,geoJSON.depth,geoJSON.widthSegments,geoJSON.heightSegments,geoJSON.depthSegments),geometry.name=geoID,result.geometries[geoID]=geometry;else if('plane'===geoJSON.type)geometry=new THREE.PlaneGeometry(geoJSON.width,geoJSON.height,geoJSON.widthSegments,geoJSON.heightSegments),geometry.name=geoID,result.geometries[geoID]=geometry;else if('sphere'===geoJSON.type)geometry=new THREE.SphereGeometry(geoJSON.radius,geoJSON.widthSegments,geoJSON.heightSegments),geometry.name=geoID,result.geometries[geoID]=geometry;else if('cylinder'===geoJSON.type)geometry=new THREE.CylinderGeometry(geoJSON.topRad,geoJSON.botRad,geoJSON.height,geoJSON.radSegs,geoJSON.heightSegs),geometry.name=geoID,result.geometries[geoID]=geometry;else if('torus'===geoJSON.type)geometry=new THREE.TorusGeometry(geoJSON.radius,geoJSON.tube,geoJSON.segmentsR,geoJSON.segmentsT),geometry.name=geoID,result.geometries[geoID]=geometry;else if('icosahedron'===geoJSON.type)geometry=new THREE.IcosahedronGeometry(geoJSON.radius,geoJSON.subdivisions),geometry.name=geoID,result.geometries[geoID]=geometry;else if(geoJSON.type in this.geometryHandlers){var loaderParameters={};for(var parType in geoJSON)'type'!==parType&&'url'!==parType&&(loaderParameters[parType]=geoJSON[parType]);var loader=this.geometryHandlers[geoJSON.type].loaderObject;loader.load(get_url(geoJSON.url,data.urlBaseType),create_callback_geometry(geoID),loaderParameters)}else if('embedded'===geoJSON.type){var modelJson=data.embeds[geoJSON.id];if(modelJson.metadata=data.metadata,modelJson){var jsonLoader=this.geometryHandlers.ascii.loaderObject,model=jsonLoader.parse(modelJson,'');create_callback_embed(geoID)(model.geometry,model.materials)}}var textureID,textureJSON;for(textureID in data.textures)if(textureJSON=data.textures[textureID],textureJSON.url instanceof Array){counter_textures+=textureJSON.url.length;for(var n=0;n<textureJSON.url.length;n++)scope.onLoadStart()}else counter_textures+=1,scope.onLoadStart();for(textureID in total_textures=counter_textures,data.textures){if(textureJSON=data.textures[textureID],void 0!==textureJSON.mapping&&void 0!==THREE[textureJSON.mapping]&&(textureJSON.mapping=new THREE[textureJSON.mapping]),textureJSON.url instanceof Array){for(var count=textureJSON.url.length,url_array=[],i=0;i<count;i++)url_array[i]=get_url(textureJSON.url[i],data.urlBaseType);var isCompressed=/\.dds$/i.test(url_array[0]);texture=isCompressed?THREE.ImageUtils.loadCompressedTextureCube(url_array,textureJSON.mapping,generateTextureCallback(count)):THREE.ImageUtils.loadTextureCube(url_array,textureJSON.mapping,generateTextureCallback(count))}else{var isCompressed=/\.dds$/i.test(textureJSON.url),fullUrl=get_url(textureJSON.url,data.urlBaseType),textureCallback=generateTextureCallback(1);if(texture=isCompressed?THREE.ImageUtils.loadCompressedTexture(fullUrl,textureJSON.mapping,textureCallback):THREE.ImageUtils.loadTexture(fullUrl,textureJSON.mapping,textureCallback),void 0!==THREE[textureJSON.minFilter]&&(texture.minFilter=THREE[textureJSON.minFilter]),void 0!==THREE[textureJSON.magFilter]&&(texture.magFilter=THREE[textureJSON.magFilter]),textureJSON.anisotropy&&(texture.anisotropy=textureJSON.anisotropy),textureJSON.repeat&&(texture.repeat.set(textureJSON.repeat[0],textureJSON.repeat[1]),1!==textureJSON.repeat[0]&&(texture.wrapS=THREE.RepeatWrapping),1!==textureJSON.repeat[1]&&(texture.wrapT=THREE.RepeatWrapping)),textureJSON.offset&&texture.offset.set(textureJSON.offset[0],textureJSON.offset[1]),textureJSON.wrap){var wrapMap={repeat:THREE.RepeatWrapping,mirror:THREE.MirroredRepeatWrapping};void 0!==wrapMap[textureJSON.wrap[0]]&&(texture.wrapS=wrapMap[textureJSON.wrap[0]]),void 0!==wrapMap[textureJSON.wrap[1]]&&(texture.wrapT=wrapMap[textureJSON.wrap[1]])}}result.textures[textureID]=texture}var matID,matJSON,parID;for(matID in data.materials){for(parID in matJSON=data.materials[matID],matJSON.parameters)if('envMap'===parID||'map'===parID||'lightMap'===parID||'bumpMap'===parID)matJSON.parameters[parID]=result.textures[matJSON.parameters[parID]];else if('shading'===parID)matJSON.parameters[parID]='flat'===matJSON.parameters[parID]?THREE.FlatShading:THREE.SmoothShading;else if('side'===parID)matJSON.parameters[parID]='double'==matJSON.parameters[parID]?THREE.DoubleSide:'back'==matJSON.parameters[parID]?THREE.BackSide:THREE.FrontSide;else if('blending'===parID)matJSON.parameters[parID]=matJSON.parameters[parID]in THREE?THREE[matJSON.parameters[parID]]:THREE.NormalBlending;else if('combine'===parID)matJSON.parameters[parID]=matJSON.parameters[parID]in THREE?THREE[matJSON.parameters[parID]]:THREE.MultiplyOperation;else if('vertexColors'===parID)'face'==matJSON.parameters[parID]?matJSON.parameters[parID]=THREE.FaceColors:matJSON.parameters[parID]&&(matJSON.parameters[parID]=THREE.VertexColors);else if('wrapRGB'===parID){var v3=matJSON.parameters[parID];matJSON.parameters[parID]=new THREE.Vector3(v3[0],v3[1],v3[2])}if(void 0!==matJSON.parameters.opacity&&1>matJSON.parameters.opacity&&(matJSON.parameters.transparent=!0),matJSON.parameters.normalMap){var shader=THREE.ShaderLib.normalmap,uniforms=THREE.UniformsUtils.clone(shader.uniforms),diffuse=matJSON.parameters.color,specular=matJSON.parameters.specular,ambient=matJSON.parameters.ambient,shininess=matJSON.parameters.shininess;uniforms.tNormal.value=result.textures[matJSON.parameters.normalMap],matJSON.parameters.normalScale&&uniforms.uNormalScale.value.set(matJSON.parameters.normalScale[0],matJSON.parameters.normalScale[1]),matJSON.parameters.map&&(uniforms.tDiffuse.value=matJSON.parameters.map,uniforms.enableDiffuse.value=!0),matJSON.parameters.envMap&&(uniforms.tCube.value=matJSON.parameters.envMap,uniforms.enableReflection.value=!0,uniforms.uReflectivity.value=matJSON.parameters.reflectivity),matJSON.parameters.lightMap&&(uniforms.tAO.value=matJSON.parameters.lightMap,uniforms.enableAO.value=!0),matJSON.parameters.specularMap&&(uniforms.tSpecular.value=result.textures[matJSON.parameters.specularMap],uniforms.enableSpecular.value=!0),matJSON.parameters.displacementMap&&(uniforms.tDisplacement.value=result.textures[matJSON.parameters.displacementMap],uniforms.enableDisplacement.value=!0,uniforms.uDisplacementBias.value=matJSON.parameters.displacementBias,uniforms.uDisplacementScale.value=matJSON.parameters.displacementScale),uniforms.uDiffuseColor.value.setHex(diffuse),uniforms.uSpecularColor.value.setHex(specular),uniforms.uAmbientColor.value.setHex(ambient),uniforms.uShininess.value=shininess,matJSON.parameters.opacity&&(uniforms.uOpacity.value=matJSON.parameters.opacity);var parameters={fragmentShader:shader.fragmentShader,vertexShader:shader.vertexShader,uniforms:uniforms,lights:!0,fog:!0};material=new THREE.ShaderMaterial(parameters)}else material=new THREE[matJSON.type](matJSON.parameters);material.name=matID,result.materials[matID]=material}for(matID in data.materials)if(matJSON=data.materials[matID],matJSON.parameters.materials){for(var materialArray=[],i=0,label;i<matJSON.parameters.materials.length;i++)label=matJSON.parameters.materials[i],materialArray.push(result.materials[label]);result.materials[matID].materials=materialArray}handle_objects(),result.cameras&&data.defaults.camera&&(result.currentCamera=result.cameras[data.defaults.camera]),result.fogs&&data.defaults.fog&&(result.scene.fog=result.fogs[data.defaults.fog]),scope.callbackSync(result),async_callback_gate()}},THREE.TextureLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.TextureLoader.prototype={constructor:THREE.TextureLoader,load:function load(url,onLoad){var scope=this,loader=new THREE.ImageLoader(scope.manager);loader.setCrossOrigin(this.crossOrigin),loader.load(url,function(image){var texture=new THREE.Texture(image);texture.needsUpdate=!0,onLoad!==void 0&&onLoad(texture)})},setCrossOrigin:function setCrossOrigin(value){this.crossOrigin=value}},THREE.Material=function(){this.id=THREE.MaterialIdCount++,this.uuid=THREE.Math.generateUUID(),this.name='',this.side=THREE.FrontSide,this.opacity=1,this.transparent=!1,this.blending=THREE.NormalBlending,this.blendSrc=THREE.SrcAlphaFactor,this.blendDst=THREE.OneMinusSrcAlphaFactor,this.blendEquation=THREE.AddEquation,this.depthTest=!0,this.depthWrite=!0,this.polygonOffset=!1,this.polygonOffsetFactor=0,this.polygonOffsetUnits=0,this.alphaTest=0,this.overdraw=0,this.visible=!0,this.needsUpdate=!0},THREE.Material.prototype={constructor:THREE.Material,setValues:function setValues(values){if(void 0!==values)for(var key in values){var newValue=values[key];if(void 0===newValue){console.warn('THREE.Material: \''+key+'\' parameter is undefined.');continue}if(key in this){var currentValue=this[key];currentValue instanceof THREE.Color?currentValue.set(newValue):currentValue instanceof THREE.Vector3&&newValue instanceof THREE.Vector3?currentValue.copy(newValue):'overdraw'==key?this[key]=+newValue:this[key]=newValue}}},clone:function clone(material){return void 0===material&&(material=new THREE.Material),material.name=this.name,material.side=this.side,material.opacity=this.opacity,material.transparent=this.transparent,material.blending=this.blending,material.blendSrc=this.blendSrc,material.blendDst=this.blendDst,material.blendEquation=this.blendEquation,material.depthTest=this.depthTest,material.depthWrite=this.depthWrite,material.polygonOffset=this.polygonOffset,material.polygonOffsetFactor=this.polygonOffsetFactor,material.polygonOffsetUnits=this.polygonOffsetUnits,material.alphaTest=this.alphaTest,material.overdraw=this.overdraw,material.visible=this.visible,material},dispose:function dispose(){this.dispatchEvent({type:'dispose'})}},THREE.EventDispatcher.prototype.apply(THREE.Material.prototype),THREE.MaterialIdCount=0,THREE.LineBasicMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.linewidth=1,this.linecap='round',this.linejoin='round',this.vertexColors=!1,this.fog=!0,this.setValues(parameters)},THREE.LineBasicMaterial.prototype=Object.create(THREE.Material.prototype),THREE.LineBasicMaterial.prototype.clone=function(){var material=new THREE.LineBasicMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.linewidth=this.linewidth,material.linecap=this.linecap,material.linejoin=this.linejoin,material.vertexColors=this.vertexColors,material.fog=this.fog,material},THREE.LineDashedMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.linewidth=1,this.scale=1,this.dashSize=3,this.gapSize=1,this.vertexColors=!1,this.fog=!0,this.setValues(parameters)},THREE.LineDashedMaterial.prototype=Object.create(THREE.Material.prototype),THREE.LineDashedMaterial.prototype.clone=function(){var material=new THREE.LineDashedMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.linewidth=this.linewidth,material.scale=this.scale,material.dashSize=this.dashSize,material.gapSize=this.gapSize,material.vertexColors=this.vertexColors,material.fog=this.fog,material},THREE.MeshBasicMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.map=null,this.lightMap=null,this.specularMap=null,this.envMap=null,this.combine=THREE.MultiplyOperation,this.reflectivity=1,this.refractionRatio=.98,this.fog=!0,this.shading=THREE.SmoothShading,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap='round',this.wireframeLinejoin='round',this.vertexColors=THREE.NoColors,this.skinning=!1,this.morphTargets=!1,this.setValues(parameters)},THREE.MeshBasicMaterial.prototype=Object.create(THREE.Material.prototype),THREE.MeshBasicMaterial.prototype.clone=function(){var material=new THREE.MeshBasicMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.map=this.map,material.lightMap=this.lightMap,material.specularMap=this.specularMap,material.envMap=this.envMap,material.combine=this.combine,material.reflectivity=this.reflectivity,material.refractionRatio=this.refractionRatio,material.fog=this.fog,material.shading=this.shading,material.wireframe=this.wireframe,material.wireframeLinewidth=this.wireframeLinewidth,material.wireframeLinecap=this.wireframeLinecap,material.wireframeLinejoin=this.wireframeLinejoin,material.vertexColors=this.vertexColors,material.skinning=this.skinning,material.morphTargets=this.morphTargets,material},THREE.MeshLambertMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.ambient=new THREE.Color(16777215),this.emissive=new THREE.Color(0),this.wrapAround=!1,this.wrapRGB=new THREE.Vector3(1,1,1),this.map=null,this.lightMap=null,this.specularMap=null,this.envMap=null,this.combine=THREE.MultiplyOperation,this.reflectivity=1,this.refractionRatio=.98,this.fog=!0,this.shading=THREE.SmoothShading,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap='round',this.wireframeLinejoin='round',this.vertexColors=THREE.NoColors,this.skinning=!1,this.morphTargets=!1,this.morphNormals=!1,this.setValues(parameters)},THREE.MeshLambertMaterial.prototype=Object.create(THREE.Material.prototype),THREE.MeshLambertMaterial.prototype.clone=function(){var material=new THREE.MeshLambertMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.ambient.copy(this.ambient),material.emissive.copy(this.emissive),material.wrapAround=this.wrapAround,material.wrapRGB.copy(this.wrapRGB),material.map=this.map,material.lightMap=this.lightMap,material.specularMap=this.specularMap,material.envMap=this.envMap,material.combine=this.combine,material.reflectivity=this.reflectivity,material.refractionRatio=this.refractionRatio,material.fog=this.fog,material.shading=this.shading,material.wireframe=this.wireframe,material.wireframeLinewidth=this.wireframeLinewidth,material.wireframeLinecap=this.wireframeLinecap,material.wireframeLinejoin=this.wireframeLinejoin,material.vertexColors=this.vertexColors,material.skinning=this.skinning,material.morphTargets=this.morphTargets,material.morphNormals=this.morphNormals,material},THREE.MeshPhongMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.ambient=new THREE.Color(16777215),this.emissive=new THREE.Color(0),this.specular=new THREE.Color(1118481),this.shininess=30,this.metal=!1,this.perPixel=!0,this.wrapAround=!1,this.wrapRGB=new THREE.Vector3(1,1,1),this.map=null,this.lightMap=null,this.bumpMap=null,this.bumpScale=1,this.normalMap=null,this.normalScale=new THREE.Vector2(1,1),this.specularMap=null,this.envMap=null,this.combine=THREE.MultiplyOperation,this.reflectivity=1,this.refractionRatio=.98,this.fog=!0,this.shading=THREE.SmoothShading,this.wireframe=!1,this.wireframeLinewidth=1,this.wireframeLinecap='round',this.wireframeLinejoin='round',this.vertexColors=THREE.NoColors,this.skinning=!1,this.morphTargets=!1,this.morphNormals=!1,this.setValues(parameters)},THREE.MeshPhongMaterial.prototype=Object.create(THREE.Material.prototype),THREE.MeshPhongMaterial.prototype.clone=function(){var material=new THREE.MeshPhongMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.ambient.copy(this.ambient),material.emissive.copy(this.emissive),material.specular.copy(this.specular),material.shininess=this.shininess,material.metal=this.metal,material.perPixel=this.perPixel,material.wrapAround=this.wrapAround,material.wrapRGB.copy(this.wrapRGB),material.map=this.map,material.lightMap=this.lightMap,material.bumpMap=this.bumpMap,material.bumpScale=this.bumpScale,material.normalMap=this.normalMap,material.normalScale.copy(this.normalScale),material.specularMap=this.specularMap,material.envMap=this.envMap,material.combine=this.combine,material.reflectivity=this.reflectivity,material.refractionRatio=this.refractionRatio,material.fog=this.fog,material.shading=this.shading,material.wireframe=this.wireframe,material.wireframeLinewidth=this.wireframeLinewidth,material.wireframeLinecap=this.wireframeLinecap,material.wireframeLinejoin=this.wireframeLinejoin,material.vertexColors=this.vertexColors,material.skinning=this.skinning,material.morphTargets=this.morphTargets,material.morphNormals=this.morphNormals,material},THREE.MeshDepthMaterial=function(parameters){THREE.Material.call(this),this.wireframe=!1,this.wireframeLinewidth=1,this.setValues(parameters)},THREE.MeshDepthMaterial.prototype=Object.create(THREE.Material.prototype),THREE.MeshDepthMaterial.prototype.clone=function(){var material=new THREE.MeshDepthMaterial;return THREE.Material.prototype.clone.call(this,material),material.wireframe=this.wireframe,material.wireframeLinewidth=this.wireframeLinewidth,material},THREE.MeshNormalMaterial=function(parameters){THREE.Material.call(this,parameters),this.shading=THREE.FlatShading,this.wireframe=!1,this.wireframeLinewidth=1,this.morphTargets=!1,this.setValues(parameters)},THREE.MeshNormalMaterial.prototype=Object.create(THREE.Material.prototype),THREE.MeshNormalMaterial.prototype.clone=function(){var material=new THREE.MeshNormalMaterial;return THREE.Material.prototype.clone.call(this,material),material.shading=this.shading,material.wireframe=this.wireframe,material.wireframeLinewidth=this.wireframeLinewidth,material},THREE.MeshFaceMaterial=function(materials){this.materials=materials instanceof Array?materials:[]},THREE.MeshFaceMaterial.prototype.clone=function(){return new THREE.MeshFaceMaterial(this.materials.slice(0))},THREE.ParticleBasicMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.map=null,this.size=1,this.sizeAttenuation=!0,this.vertexColors=!1,this.fog=!0,this.setValues(parameters)},THREE.ParticleBasicMaterial.prototype=Object.create(THREE.Material.prototype),THREE.ParticleBasicMaterial.prototype.clone=function(){var material=new THREE.ParticleBasicMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.map=this.map,material.size=this.size,material.sizeAttenuation=this.sizeAttenuation,material.vertexColors=this.vertexColors,material.fog=this.fog,material},THREE.ParticleCanvasMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.program=function(){},this.setValues(parameters)},THREE.ParticleCanvasMaterial.prototype=Object.create(THREE.Material.prototype),THREE.ParticleCanvasMaterial.prototype.clone=function(){var material=new THREE.ParticleCanvasMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.program=this.program,material},THREE.ShaderMaterial=function(parameters){THREE.Material.call(this),this.fragmentShader='void main() {}',this.vertexShader='void main() {}',this.uniforms={},this.defines={},this.attributes=null,this.shading=THREE.SmoothShading,this.linewidth=1,this.wireframe=!1,this.wireframeLinewidth=1,this.fog=!1,this.lights=!1,this.vertexColors=THREE.NoColors,this.skinning=!1,this.morphTargets=!1,this.morphNormals=!1,this.defaultAttributeValues={color:[1,1,1],uv:[0,0],uv2:[0,0]},this.index0AttributeName='position',this.setValues(parameters)},THREE.ShaderMaterial.prototype=Object.create(THREE.Material.prototype),THREE.ShaderMaterial.prototype.clone=function(){var material=new THREE.ShaderMaterial;return THREE.Material.prototype.clone.call(this,material),material.fragmentShader=this.fragmentShader,material.vertexShader=this.vertexShader,material.uniforms=THREE.UniformsUtils.clone(this.uniforms),material.attributes=this.attributes,material.defines=this.defines,material.shading=this.shading,material.wireframe=this.wireframe,material.wireframeLinewidth=this.wireframeLinewidth,material.fog=this.fog,material.lights=this.lights,material.vertexColors=this.vertexColors,material.skinning=this.skinning,material.morphTargets=this.morphTargets,material.morphNormals=this.morphNormals,material},THREE.SpriteMaterial=function(parameters){THREE.Material.call(this),this.color=new THREE.Color(16777215),this.map=new THREE.Texture,this.useScreenCoordinates=!0,this.depthTest=!this.useScreenCoordinates,this.sizeAttenuation=!this.useScreenCoordinates,this.scaleByViewport=!this.sizeAttenuation,this.alignment=THREE.SpriteAlignment.center.clone(),this.fog=!1,this.uvOffset=new THREE.Vector2(0,0),this.uvScale=new THREE.Vector2(1,1),this.setValues(parameters),parameters=parameters||{},parameters.depthTest===void 0&&(this.depthTest=!this.useScreenCoordinates),parameters.sizeAttenuation===void 0&&(this.sizeAttenuation=!this.useScreenCoordinates),parameters.scaleByViewport===void 0&&(this.scaleByViewport=!this.sizeAttenuation)},THREE.SpriteMaterial.prototype=Object.create(THREE.Material.prototype),THREE.SpriteMaterial.prototype.clone=function(){var material=new THREE.SpriteMaterial;return THREE.Material.prototype.clone.call(this,material),material.color.copy(this.color),material.map=this.map,material.useScreenCoordinates=this.useScreenCoordinates,material.sizeAttenuation=this.sizeAttenuation,material.scaleByViewport=this.scaleByViewport,material.alignment.copy(this.alignment),material.uvOffset.copy(this.uvOffset),material.uvScale.copy(this.uvScale),material.fog=this.fog,material},THREE.SpriteAlignment={},THREE.SpriteAlignment.topLeft=new THREE.Vector2(1,-1),THREE.SpriteAlignment.topCenter=new THREE.Vector2(0,-1),THREE.SpriteAlignment.topRight=new THREE.Vector2(-1,-1),THREE.SpriteAlignment.centerLeft=new THREE.Vector2(1,0),THREE.SpriteAlignment.center=new THREE.Vector2(0,0),THREE.SpriteAlignment.centerRight=new THREE.Vector2(-1,0),THREE.SpriteAlignment.bottomLeft=new THREE.Vector2(1,1),THREE.SpriteAlignment.bottomCenter=new THREE.Vector2(0,1),THREE.SpriteAlignment.bottomRight=new THREE.Vector2(-1,1),THREE.Texture=function(image,mapping,wrapS,wrapT,magFilter,minFilter,format,type,anisotropy){this.id=THREE.TextureIdCount++,this.uuid=THREE.Math.generateUUID(),this.name='',this.image=image,this.mipmaps=[],this.mapping=mapping===void 0?new THREE.UVMapping:mapping,this.wrapS=wrapS===void 0?THREE.ClampToEdgeWrapping:wrapS,this.wrapT=wrapT===void 0?THREE.ClampToEdgeWrapping:wrapT,this.magFilter=magFilter===void 0?THREE.LinearFilter:magFilter,this.minFilter=minFilter===void 0?THREE.LinearMipMapLinearFilter:minFilter,this.anisotropy=anisotropy===void 0?1:anisotropy,this.format=format===void 0?THREE.RGBAFormat:format,this.type=type===void 0?THREE.UnsignedByteType:type,this.offset=new THREE.Vector2(0,0),this.repeat=new THREE.Vector2(1,1),this.generateMipmaps=!0,this.premultiplyAlpha=!1,this.flipY=!0,this.unpackAlignment=4,this.needsUpdate=!1,this.onUpdate=null},THREE.Texture.prototype={constructor:THREE.Texture,clone:function clone(texture){return void 0===texture&&(texture=new THREE.Texture),texture.image=this.image,texture.mipmaps=this.mipmaps.slice(0),texture.mapping=this.mapping,texture.wrapS=this.wrapS,texture.wrapT=this.wrapT,texture.magFilter=this.magFilter,texture.minFilter=this.minFilter,texture.anisotropy=this.anisotropy,texture.format=this.format,texture.type=this.type,texture.offset.copy(this.offset),texture.repeat.copy(this.repeat),texture.generateMipmaps=this.generateMipmaps,texture.premultiplyAlpha=this.premultiplyAlpha,texture.flipY=this.flipY,texture.unpackAlignment=this.unpackAlignment,texture},dispose:function dispose(){this.dispatchEvent({type:'dispose'})}},THREE.EventDispatcher.prototype.apply(THREE.Texture.prototype),THREE.TextureIdCount=0,THREE.CompressedTexture=function(mipmaps,width,height,format,type,mapping,wrapS,wrapT,magFilter,minFilter,anisotropy){THREE.Texture.call(this,null,mapping,wrapS,wrapT,magFilter,minFilter,format,type,anisotropy),this.image={width:width,height:height},this.mipmaps=mipmaps,this.generateMipmaps=!1},THREE.CompressedTexture.prototype=Object.create(THREE.Texture.prototype),THREE.CompressedTexture.prototype.clone=function(){var texture=new THREE.CompressedTexture;return THREE.Texture.prototype.clone.call(this,texture),texture},THREE.DataTexture=function(data,width,height,format,type,mapping,wrapS,wrapT,magFilter,minFilter,anisotropy){THREE.Texture.call(this,null,mapping,wrapS,wrapT,magFilter,minFilter,format,type,anisotropy),this.image={data:data,width:width,height:height}},THREE.DataTexture.prototype=Object.create(THREE.Texture.prototype),THREE.DataTexture.prototype.clone=function(){var texture=new THREE.DataTexture;return THREE.Texture.prototype.clone.call(this,texture),texture},THREE.Particle=function(material){THREE.Object3D.call(this),this.material=material},THREE.Particle.prototype=Object.create(THREE.Object3D.prototype),THREE.Particle.prototype.clone=function(object){return void 0===object&&(object=new THREE.Particle(this.material)),THREE.Object3D.prototype.clone.call(this,object),object},THREE.ParticleSystem=function(geometry,material){THREE.Object3D.call(this),this.geometry=geometry===void 0?new THREE.Geometry:geometry,this.material=material===void 0?new THREE.ParticleBasicMaterial({color:16777215*Math.random()}):material,this.sortParticles=!1,this.frustumCulled=!1},THREE.ParticleSystem.prototype=Object.create(THREE.Object3D.prototype),THREE.ParticleSystem.prototype.clone=function(object){return void 0===object&&(object=new THREE.ParticleSystem(this.geometry,this.material)),object.sortParticles=this.sortParticles,THREE.Object3D.prototype.clone.call(this,object),object},THREE.Line=function(geometry,material,type){THREE.Object3D.call(this),this.geometry=geometry===void 0?new THREE.Geometry:geometry,this.material=material===void 0?new THREE.LineBasicMaterial({color:16777215*Math.random()}):material,this.type=type===void 0?THREE.LineStrip:type},THREE.LineStrip=0,THREE.LinePieces=1,THREE.Line.prototype=Object.create(THREE.Object3D.prototype),THREE.Line.prototype.clone=function(object){return void 0===object&&(object=new THREE.Line(this.geometry,this.material,this.type)),THREE.Object3D.prototype.clone.call(this,object),object},THREE.Mesh=function(geometry,material){THREE.Object3D.call(this),this.geometry=geometry===void 0?new THREE.Geometry:geometry,this.material=material===void 0?new THREE.MeshBasicMaterial({color:16777215*Math.random()}):material,this.updateMorphTargets()},THREE.Mesh.prototype=Object.create(THREE.Object3D.prototype),THREE.Mesh.prototype.updateMorphTargets=function(){if(0<this.geometry.morphTargets.length){this.morphTargetBase=-1,this.morphTargetForcedOrder=[],this.morphTargetInfluences=[],this.morphTargetDictionary={};for(var m=0,ml=this.geometry.morphTargets.length;m<ml;m++)this.morphTargetInfluences.push(0),this.morphTargetDictionary[this.geometry.morphTargets[m].name]=m}},THREE.Mesh.prototype.getMorphTargetIndexByName=function(name){return void 0===this.morphTargetDictionary[name]?(console.log('THREE.Mesh.getMorphTargetIndexByName: morph target '+name+' does not exist. Returning 0.'),0):this.morphTargetDictionary[name]},THREE.Mesh.prototype.clone=function(object){return void 0===object&&(object=new THREE.Mesh(this.geometry,this.material)),THREE.Object3D.prototype.clone.call(this,object),object},THREE.Bone=function(belongsToSkin){THREE.Object3D.call(this),this.skin=belongsToSkin,this.skinMatrix=new THREE.Matrix4},THREE.Bone.prototype=Object.create(THREE.Object3D.prototype),THREE.Bone.prototype.update=function(parentSkinMatrix,forceUpdate){this.matrixAutoUpdate&&(forceUpdate|=this.updateMatrix()),(forceUpdate||this.matrixWorldNeedsUpdate)&&(parentSkinMatrix?this.skinMatrix.multiplyMatrices(parentSkinMatrix,this.matrix):this.skinMatrix.copy(this.matrix),this.matrixWorldNeedsUpdate=!1,forceUpdate=!0);var l=this.children.length,i;for(i=0;i<l;i++)this.children[i].update(this.skinMatrix,forceUpdate)},THREE.SkinnedMesh=function(geometry,material,useVertexTexture){THREE.Mesh.call(this,geometry,material),this.useVertexTexture=!(useVertexTexture!==void 0)||useVertexTexture,this.identityMatrix=new THREE.Matrix4,this.bones=[],this.boneMatrices=[];var b,bone,gbone,p,q,s;if(this.geometry&&this.geometry.bones!==void 0){for(b=0;b<this.geometry.bones.length;b++)gbone=this.geometry.bones[b],p=gbone.pos,q=gbone.rotq,s=gbone.scl,bone=this.addBone(),bone.name=gbone.name,bone.position.set(p[0],p[1],p[2]),bone.quaternion.set(q[0],q[1],q[2],q[3]),void 0===s?bone.scale.set(1,1,1):bone.scale.set(s[0],s[1],s[2]);for(b=0;b<this.bones.length;b++)gbone=this.geometry.bones[b],bone=this.bones[b],-1===gbone.parent?this.add(bone):this.bones[gbone.parent].add(bone);var nBones=this.bones.length;if(this.useVertexTexture){var size;size=256<nBones?64:64<nBones?32:16<nBones?16:8,this.boneTextureWidth=size,this.boneTextureHeight=size,this.boneMatrices=new Float32Array(4*(this.boneTextureWidth*this.boneTextureHeight)),this.boneTexture=new THREE.DataTexture(this.boneMatrices,this.boneTextureWidth,this.boneTextureHeight,THREE.RGBAFormat,THREE.FloatType),this.boneTexture.minFilter=THREE.NearestFilter,this.boneTexture.magFilter=THREE.NearestFilter,this.boneTexture.generateMipmaps=!1,this.boneTexture.flipY=!1}else this.boneMatrices=new Float32Array(16*nBones);this.pose()}},THREE.SkinnedMesh.prototype=Object.create(THREE.Mesh.prototype),THREE.SkinnedMesh.prototype.addBone=function(bone){return void 0===bone&&(bone=new THREE.Bone(this)),this.bones.push(bone),bone},THREE.SkinnedMesh.prototype.updateMatrixWorld=function(){var offsetMatrix=new THREE.Matrix4;return function(force){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||force)&&(this.parent?this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix):this.matrixWorld.copy(this.matrix),this.matrixWorldNeedsUpdate=!1,force=!0);for(var i=0,l=this.children.length,child;i<l;i++)child=this.children[i],child instanceof THREE.Bone?child.update(this.identityMatrix,!1):child.updateMatrixWorld(!0);if(this.boneInverses==void 0){this.boneInverses=[];for(var b=0,bl=this.bones.length,inverse;b<bl;b++)inverse=new THREE.Matrix4,inverse.getInverse(this.bones[b].skinMatrix),this.boneInverses.push(inverse)}for(var b=0,bl=this.bones.length;b<bl;b++)offsetMatrix.multiplyMatrices(this.bones[b].skinMatrix,this.boneInverses[b]),offsetMatrix.flattenToArrayOffset(this.boneMatrices,16*b);this.useVertexTexture&&(this.boneTexture.needsUpdate=!0)}}(),THREE.SkinnedMesh.prototype.pose=function(){this.updateMatrixWorld(!0),this.normalizeSkinWeights()},THREE.SkinnedMesh.prototype.normalizeSkinWeights=function(){if(this.geometry instanceof THREE.Geometry)for(var i=0;i<this.geometry.skinIndices.length;i++){var sw=this.geometry.skinWeights[i],scale=1/sw.lengthManhattan();scale==Infinity?sw.set(1):sw.multiplyScalar(scale)}else;},THREE.SkinnedMesh.prototype.clone=function(object){return void 0===object&&(object=new THREE.SkinnedMesh(this.geometry,this.material,this.useVertexTexture)),THREE.Mesh.prototype.clone.call(this,object),object},THREE.MorphAnimMesh=function(geometry,material){THREE.Mesh.call(this,geometry,material),this.duration=1e3,this.mirroredLoop=!1,this.time=0,this.lastKeyframe=0,this.currentKeyframe=0,this.direction=1,this.directionBackwards=!1,this.setFrameRange(0,this.geometry.morphTargets.length-1)},THREE.MorphAnimMesh.prototype=Object.create(THREE.Mesh.prototype),THREE.MorphAnimMesh.prototype.setFrameRange=function(start,end){this.startKeyframe=start,this.endKeyframe=end,this.length=this.endKeyframe-this.startKeyframe+1},THREE.MorphAnimMesh.prototype.setDirectionForward=function(){this.direction=1,this.directionBackwards=!1},THREE.MorphAnimMesh.prototype.setDirectionBackward=function(){this.direction=-1,this.directionBackwards=!0},THREE.MorphAnimMesh.prototype.parseAnimations=function(){var geometry=this.geometry;geometry.animations||(geometry.animations={});for(var animations=geometry.animations,pattern=/([a-z]+)(\d+)/,i=0,il=geometry.morphTargets.length,firstAnimation;i<il;i++){var morph=geometry.morphTargets[i],parts=morph.name.match(pattern);if(parts&&1<parts.length){var label=parts[1],num=parts[2];animations[label]||(animations[label]={start:Infinity,end:-Infinity});var animation=animations[label];i<animation.start&&(animation.start=i),i>animation.end&&(animation.end=i),firstAnimation||(firstAnimation=label)}}geometry.firstAnimation=firstAnimation},THREE.MorphAnimMesh.prototype.setAnimationLabel=function(label,start,end){this.geometry.animations||(this.geometry.animations={}),this.geometry.animations[label]={start:start,end:end}},THREE.MorphAnimMesh.prototype.playAnimation=function(label,fps){var animation=this.geometry.animations[label];animation?(this.setFrameRange(animation.start,animation.end),this.duration=1e3*((animation.end-animation.start)/fps),this.time=0):console.warn('animation['+label+'] undefined')},THREE.MorphAnimMesh.prototype.updateAnimation=function(delta){var frameTime=this.duration/this.length;this.time+=this.direction*delta,this.mirroredLoop?(this.time>this.duration||0>this.time)&&(this.direction*=-1,this.time>this.duration&&(this.time=this.duration,this.directionBackwards=!0),0>this.time&&(this.time=0,this.directionBackwards=!1)):(this.time%=this.duration,0>this.time&&(this.time+=this.duration));var keyframe=this.startKeyframe+THREE.Math.clamp(Math.floor(this.time/frameTime),0,this.length-1);keyframe!==this.currentKeyframe&&(this.morphTargetInfluences[this.lastKeyframe]=0,this.morphTargetInfluences[this.currentKeyframe]=1,this.morphTargetInfluences[keyframe]=0,this.lastKeyframe=this.currentKeyframe,this.currentKeyframe=keyframe);var mix=this.time%frameTime/frameTime;this.directionBackwards&&(mix=1-mix),this.morphTargetInfluences[this.currentKeyframe]=mix,this.morphTargetInfluences[this.lastKeyframe]=1-mix},THREE.MorphAnimMesh.prototype.clone=function(object){return void 0===object&&(object=new THREE.MorphAnimMesh(this.geometry,this.material)),object.duration=this.duration,object.mirroredLoop=this.mirroredLoop,object.time=this.time,object.lastKeyframe=this.lastKeyframe,object.currentKeyframe=this.currentKeyframe,object.direction=this.direction,object.directionBackwards=this.directionBackwards,THREE.Mesh.prototype.clone.call(this,object),object},THREE.Ribbon=function(geometry,material){THREE.Object3D.call(this),this.geometry=geometry,this.material=material},THREE.Ribbon.prototype=Object.create(THREE.Object3D.prototype),THREE.Ribbon.prototype.clone=function(object){return void 0===object&&(object=new THREE.Ribbon(this.geometry,this.material)),THREE.Object3D.prototype.clone.call(this,object),object},THREE.LOD=function(){THREE.Object3D.call(this),this.objects=[]},THREE.LOD.prototype=Object.create(THREE.Object3D.prototype),THREE.LOD.prototype.addLevel=function(object,distance){distance===void 0&&(distance=0),distance=Math.abs(distance);for(var l=0;l<this.objects.length&&!(distance<this.objects[l].distance);l++);this.objects.splice(l,0,{distance:distance,object:object}),this.add(object)},THREE.LOD.prototype.getObjectForDistance=function(distance){for(var i=1,l=this.objects.length;i<l&&!(distance<this.objects[i].distance);i++);return this.objects[i-1].object},THREE.LOD.prototype.update=function(){var v1=new THREE.Vector3,v2=new THREE.Vector3;return function(camera){if(1<this.objects.length){v1.getPositionFromMatrix(camera.matrixWorld),v2.getPositionFromMatrix(this.matrixWorld);var distance=v1.distanceTo(v2);this.objects[0].object.visible=!0;for(var i=1,l=this.objects.length;i<l&&distance>=this.objects[i].distance;i++)this.objects[i-1].object.visible=!1,this.objects[i].object.visible=!0;for(;i<l;i++)this.objects[i].object.visible=!1}}}(),THREE.LOD.prototype.clone=function(){},THREE.Sprite=function(material){THREE.Object3D.call(this),this.material=material===void 0?new THREE.SpriteMaterial:material,this.rotation3d=this.rotation,this.rotation=0},THREE.Sprite.prototype=Object.create(THREE.Object3D.prototype),THREE.Sprite.prototype.updateMatrix=function(){this.rotation3d.set(0,0,this.rotation,this.rotation3d.order),this.quaternion.setFromEuler(this.rotation3d),this.matrix.compose(this.position,this.quaternion,this.scale),this.matrixWorldNeedsUpdate=!0},THREE.Sprite.prototype.clone=function(object){return void 0===object&&(object=new THREE.Sprite(this.material)),THREE.Object3D.prototype.clone.call(this,object),object},THREE.Scene=function(){THREE.Object3D.call(this),this.fog=null,this.overrideMaterial=null,this.autoUpdate=!0,this.matrixAutoUpdate=!1,this.__objects=[],this.__lights=[],this.__objectsAdded=[],this.__objectsRemoved=[]},THREE.Scene.prototype=Object.create(THREE.Object3D.prototype),THREE.Scene.prototype.__addObject=function(object){if(object instanceof THREE.Light)-1===this.__lights.indexOf(object)&&this.__lights.push(object),object.target&&void 0===object.target.parent&&this.add(object.target);else if(!(object instanceof THREE.Camera||object instanceof THREE.Bone)&&-1===this.__objects.indexOf(object)){this.__objects.push(object),this.__objectsAdded.push(object);var i=this.__objectsRemoved.indexOf(object);-1!==i&&this.__objectsRemoved.splice(i,1)}for(var c=0;c<object.children.length;c++)this.__addObject(object.children[c])},THREE.Scene.prototype.__removeObject=function(object){if(object instanceof THREE.Light){var i=this.__lights.indexOf(object);-1!==i&&this.__lights.splice(i,1)}else if(!(object instanceof THREE.Camera)){var i=this.__objects.indexOf(object);if(-1!==i){this.__objects.splice(i,1),this.__objectsRemoved.push(object);var ai=this.__objectsAdded.indexOf(object);-1!==ai&&this.__objectsAdded.splice(ai,1)}}for(var c=0;c<object.children.length;c++)this.__removeObject(object.children[c])},THREE.Scene.prototype.clone=function(object){return void 0===object&&(object=new THREE.Scene),THREE.Object3D.prototype.clone.call(this,object),null!==this.fog&&(object.fog=this.fog.clone()),null!==this.overrideMaterial&&(object.overrideMaterial=this.overrideMaterial.clone()),object.autoUpdate=this.autoUpdate,object.matrixAutoUpdate=this.matrixAutoUpdate,object},THREE.Fog=function(hex,near,far){this.name='',this.color=new THREE.Color(hex),this.near=near===void 0?1:near,this.far=far===void 0?1e3:far},THREE.Fog.prototype.clone=function(){return new THREE.Fog(this.color.getHex(),this.near,this.far)},THREE.FogExp2=function(hex,density){this.name='',this.color=new THREE.Color(hex),this.density=density===void 0?25e-5:density},THREE.FogExp2.prototype.clone=function(){return new THREE.FogExp2(this.color.getHex(),this.density)},THREE.CanvasRenderer=function(parameters){function calculateLights(){_ambientLight.setRGB(0,0,0),_directionalLights.setRGB(0,0,0),_pointLights.setRGB(0,0,0);for(var l=0,ll=_lights.length;l<ll;l++){var light=_lights[l],lightColor=light.color;light instanceof THREE.AmbientLight?_ambientLight.add(lightColor):light instanceof THREE.DirectionalLight?_directionalLights.add(lightColor):light instanceof THREE.PointLight&&_pointLights.add(lightColor)}}function calculateLight(position,normal,color){for(var l=0,ll=_lights.length,light;l<ll;l++)if(light=_lights[l],_lightColor.copy(light.color),light instanceof THREE.DirectionalLight){var lightPosition=_vector3.getPositionFromMatrix(light.matrixWorld).normalize(),amount=normal.dot(lightPosition);if(0>=amount)continue;amount*=light.intensity,color.add(_lightColor.multiplyScalar(amount))}else if(light instanceof THREE.PointLight){var lightPosition=_vector3.getPositionFromMatrix(light.matrixWorld),amount=normal.dot(_vector3.subVectors(lightPosition,position).normalize());if(0>=amount)continue;if(amount*=0==light.distance?1:1-Math.min(position.distanceTo(lightPosition)/light.distance,1),0==amount)continue;amount*=light.intensity,color.add(_lightColor.multiplyScalar(amount))}}function renderParticle(v1,element,material){setOpacity(material.opacity),setBlending(material.blending);var width,height,scaleX,scaleY,bitmap,bitmapWidth,bitmapHeight;if(material instanceof THREE.ParticleBasicMaterial){if(null===material.map){if(scaleX=element.object.scale.x,scaleY=element.object.scale.y,scaleX*=element.scale.x*_canvasWidthHalf,scaleY*=element.scale.y*_canvasHeightHalf,_elemBox.min.set(v1.x-scaleX,v1.y-scaleY),_elemBox.max.set(v1.x+scaleX,v1.y+scaleY),!1===_clipBox.isIntersectionBox(_elemBox))return void _elemBox.makeEmpty();setFillStyle(material.color.getStyle()),_context.save(),_context.translate(v1.x,v1.y),_context.rotate(-element.rotation),_context.scale(scaleX,scaleY),_context.fillRect(-1,-1,2,2),_context.restore()}else{if(bitmap=material.map.image,bitmapWidth=bitmap.width>>1,bitmapHeight=bitmap.height>>1,scaleX=element.scale.x*_canvasWidthHalf,scaleY=element.scale.y*_canvasHeightHalf,width=scaleX*bitmapWidth,height=scaleY*bitmapHeight,_elemBox.min.set(v1.x-width,v1.y-height),_elemBox.max.set(v1.x+width,v1.y+height),!1===_clipBox.isIntersectionBox(_elemBox))return void _elemBox.makeEmpty();_context.save(),_context.translate(v1.x,v1.y),_context.rotate(-element.rotation),_context.scale(scaleX,-scaleY),_context.translate(-bitmapWidth,-bitmapHeight),_context.drawImage(bitmap,0,0),_context.restore()}}else if(material instanceof THREE.ParticleCanvasMaterial){if(width=element.scale.x*_canvasWidthHalf,height=element.scale.y*_canvasHeightHalf,_elemBox.min.set(v1.x-width,v1.y-height),_elemBox.max.set(v1.x+width,v1.y+height),!1===_clipBox.isIntersectionBox(_elemBox))return void _elemBox.makeEmpty();setStrokeStyle(material.color.getStyle()),setFillStyle(material.color.getStyle()),_context.save(),_context.translate(v1.x,v1.y),_context.rotate(-element.rotation),_context.scale(width,height),material.program(_context),_context.restore()}}function renderLine(v1,v2,element,material){if(setOpacity(material.opacity),setBlending(material.blending),_context.beginPath(),_context.moveTo(v1.positionScreen.x,v1.positionScreen.y),_context.lineTo(v2.positionScreen.x,v2.positionScreen.y),material instanceof THREE.LineBasicMaterial){if(setLineWidth(material.linewidth),setLineCap(material.linecap),setLineJoin(material.linejoin),material.vertexColors!==THREE.VertexColors)setStrokeStyle(material.color.getStyle());else{var colorStyle1=element.vertexColors[0].getStyle(),colorStyle2=element.vertexColors[1].getStyle();if(colorStyle1===colorStyle2)setStrokeStyle(colorStyle1);else{try{var grad=_context.createLinearGradient(v1.positionScreen.x,v1.positionScreen.y,v2.positionScreen.x,v2.positionScreen.y);grad.addColorStop(0,colorStyle1),grad.addColorStop(1,colorStyle2)}catch(exception){grad=colorStyle1}setStrokeStyle(grad)}}_context.stroke(),_elemBox.expandByScalar(2*material.linewidth)}else material instanceof THREE.LineDashedMaterial&&(setLineWidth(material.linewidth),setLineCap(material.linecap),setLineJoin(material.linejoin),setStrokeStyle(material.color.getStyle()),setDashAndGap(material.dashSize,material.gapSize),_context.stroke(),_elemBox.expandByScalar(2*material.linewidth),setDashAndGap(null,null))}function renderFace3(v1,v2,v3,uv1,uv2,uv3,element,material){if(_this.info.render.vertices+=3,_this.info.render.faces++,setOpacity(material.opacity),setBlending(material.blending),_v1x=v1.positionScreen.x,_v1y=v1.positionScreen.y,_v2x=v2.positionScreen.x,_v2y=v2.positionScreen.y,_v3x=v3.positionScreen.x,_v3y=v3.positionScreen.y,drawTriangle(_v1x,_v1y,_v2x,_v2y,_v3x,_v3y),(material instanceof THREE.MeshLambertMaterial||material instanceof THREE.MeshPhongMaterial)&&null===material.map)_diffuseColor.copy(material.color),_emissiveColor.copy(material.emissive),material.vertexColors===THREE.FaceColors&&_diffuseColor.multiply(element.color),!1===material.wireframe&&material.shading==THREE.SmoothShading&&3==element.vertexNormalsLength?(_color1.copy(_ambientLight),_color2.copy(_ambientLight),_color3.copy(_ambientLight),calculateLight(element.v1.positionWorld,element.vertexNormalsModel[0],_color1),calculateLight(element.v2.positionWorld,element.vertexNormalsModel[1],_color2),calculateLight(element.v3.positionWorld,element.vertexNormalsModel[2],_color3),_color1.multiply(_diffuseColor).add(_emissiveColor),_color2.multiply(_diffuseColor).add(_emissiveColor),_color3.multiply(_diffuseColor).add(_emissiveColor),_color4.addColors(_color2,_color3).multiplyScalar(.5),_image=getGradientTexture(_color1,_color2,_color3,_color4),clipImage(_v1x,_v1y,_v2x,_v2y,_v3x,_v3y,0,0,1,0,0,1,_image)):(_color.copy(_ambientLight),calculateLight(element.centroidModel,element.normalModel,_color),_color.multiply(_diffuseColor).add(_emissiveColor),!0===material.wireframe?strokePath(_color,material.wireframeLinewidth,material.wireframeLinecap,material.wireframeLinejoin):fillPath(_color));else if(material instanceof THREE.MeshBasicMaterial||material instanceof THREE.MeshLambertMaterial||material instanceof THREE.MeshPhongMaterial)null===material.map?null===material.envMap?(_color.copy(material.color),material.vertexColors===THREE.FaceColors&&_color.multiply(element.color),!0===material.wireframe?strokePath(_color,material.wireframeLinewidth,material.wireframeLinecap,material.wireframeLinejoin):fillPath(_color)):material.envMap.mapping instanceof THREE.SphericalReflectionMapping&&(_vector3.copy(element.vertexNormalsModelView[uv1]),_uv1x=.5*_vector3.x+.5,_uv1y=.5*_vector3.y+.5,_vector3.copy(element.vertexNormalsModelView[uv2]),_uv2x=.5*_vector3.x+.5,_uv2y=.5*_vector3.y+.5,_vector3.copy(element.vertexNormalsModelView[uv3]),_uv3x=.5*_vector3.x+.5,_uv3y=.5*_vector3.y+.5,patternPath(_v1x,_v1y,_v2x,_v2y,_v3x,_v3y,_uv1x,_uv1y,_uv2x,_uv2y,_uv3x,_uv3y,material.envMap)):material.map.mapping instanceof THREE.UVMapping&&(_uvs=element.uvs[0],patternPath(_v1x,_v1y,_v2x,_v2y,_v3x,_v3y,_uvs[uv1].x,_uvs[uv1].y,_uvs[uv2].x,_uvs[uv2].y,_uvs[uv3].x,_uvs[uv3].y,material.map));else if(material instanceof THREE.MeshDepthMaterial)_near=_camera.near,_far=_camera.far,_color1.r=_color1.g=_color1.b=1-smoothstep(v1.positionScreen.z*v1.positionScreen.w,_near,_far),_color2.r=_color2.g=_color2.b=1-smoothstep(v2.positionScreen.z*v2.positionScreen.w,_near,_far),_color3.r=_color3.g=_color3.b=1-smoothstep(v3.positionScreen.z*v3.positionScreen.w,_near,_far),_color4.addColors(_color2,_color3).multiplyScalar(.5),_image=getGradientTexture(_color1,_color2,_color3,_color4),clipImage(_v1x,_v1y,_v2x,_v2y,_v3x,_v3y,0,0,1,0,0,1,_image);else if(material instanceof THREE.MeshNormalMaterial){var normal;material.shading==THREE.FlatShading?(normal=element.normalModelView,_color.setRGB(normal.x,normal.y,normal.z).multiplyScalar(.5).addScalar(.5),!0===material.wireframe?strokePath(_color,material.wireframeLinewidth,material.wireframeLinecap,material.wireframeLinejoin):fillPath(_color)):material.shading==THREE.SmoothShading&&(normal=element.vertexNormalsModelView[uv1],_color1.setRGB(normal.x,normal.y,normal.z).multiplyScalar(.5).addScalar(.5),normal=element.vertexNormalsModelView[uv2],_color2.setRGB(normal.x,normal.y,normal.z).multiplyScalar(.5).addScalar(.5),normal=element.vertexNormalsModelView[uv3],_color3.setRGB(normal.x,normal.y,normal.z).multiplyScalar(.5).addScalar(.5),_color4.addColors(_color2,_color3).multiplyScalar(.5),_image=getGradientTexture(_color1,_color2,_color3,_color4),clipImage(_v1x,_v1y,_v2x,_v2y,_v3x,_v3y,0,0,1,0,0,1,_image))}}function drawTriangle(x0,y0,x1,y1,x2,y2){_context.beginPath(),_context.moveTo(x0,y0),_context.lineTo(x1,y1),_context.lineTo(x2,y2),_context.closePath()}function strokePath(color,linewidth,linecap,linejoin){setLineWidth(linewidth),setLineCap(linecap),setLineJoin(linejoin),setStrokeStyle(color.getStyle()),_context.stroke(),_elemBox.expandByScalar(2*linewidth)}function fillPath(color){setFillStyle(color.getStyle()),_context.fill()}function patternPath(x0,y0,x1,y1,x2,y2,u0,v0,u1,v1,u2,v2,texture){if(!(texture instanceof THREE.DataTexture||void 0===texture.image||0==texture.image.width)){if(!0===texture.needsUpdate){var repeatX=texture.wrapS==THREE.RepeatWrapping,repeatY=texture.wrapT==THREE.RepeatWrapping;_patterns[texture.id]=_context.createPattern(texture.image,!0==repeatX&&!0==repeatY?'repeat':!0==repeatX&&!1==repeatY?'repeat-x':!1==repeatX&&!0==repeatY?'repeat-y':'no-repeat'),texture.needsUpdate=!1}void 0===_patterns[texture.id]?setFillStyle('rgba(0,0,0,1)'):setFillStyle(_patterns[texture.id]);var offsetX=texture.offset.x/texture.repeat.x,offsetY=texture.offset.y/texture.repeat.y,width=texture.image.width*texture.repeat.x,height=texture.image.height*texture.repeat.y,a,b,c,d,e,f,det,idet;if(u0=(u0+offsetX)*width,v0=(1-v0+offsetY)*height,u1=(u1+offsetX)*width,v1=(1-v1+offsetY)*height,u2=(u2+offsetX)*width,v2=(1-v2+offsetY)*height,x1-=x0,y1-=y0,x2-=x0,y2-=y0,u1-=u0,v1-=v0,u2-=u0,v2-=v0,det=u1*v2-u2*v1,0===det){if(void 0===_imagedatas[texture.id]){var canvas=document.createElement('canvas');canvas.width=texture.image.width,canvas.height=texture.image.height;var context=canvas.getContext('2d');context.drawImage(texture.image,0,0),_imagedatas[texture.id]=context.getImageData(0,0,texture.image.width,texture.image.height).data}var data=_imagedatas[texture.id],index=4*(_Mathfloor2(u0)+_Mathfloor2(v0)*texture.image.width);return _color.setRGB(data[index]/255,data[index+1]/255,data[index+2]/255),void fillPath(_color)}idet=1/det,a=(v2*x1-v1*x2)*idet,b=(v2*y1-v1*y2)*idet,c=(u1*x2-u2*x1)*idet,d=(u1*y2-u2*y1)*idet,e=x0-a*u0-c*v0,f=y0-b*u0-d*v0,_context.save(),_context.transform(a,b,c,d,e,f),_context.fill(),_context.restore()}}function clipImage(x0,y0,x1,y1,x2,y2,u0,v0,u1,v1,u2,v2,image){var width=image.width-1,height=image.height-1,a,b,c,d,e,f,det,idet;u0*=width,v0*=height,u1*=width,v1*=height,u2*=width,v2*=height,x1-=x0,y1-=y0,x2-=x0,y2-=y0,u1-=u0,v1-=v0,u2-=u0,v2-=v0,det=u1*v2-u2*v1,idet=1/det,a=(v2*x1-v1*x2)*idet,b=(v2*y1-v1*y2)*idet,c=(u1*x2-u2*x1)*idet,d=(u1*y2-u2*y1)*idet,e=x0-a*u0-c*v0,f=y0-b*u0-d*v0,_context.save(),_context.transform(a,b,c,d,e,f),_context.clip(),_context.drawImage(image,0,0),_context.restore()}function getGradientTexture(color1,color2,color3,color4){return _pixelMapData[0]=0|255*color1.r,_pixelMapData[1]=0|255*color1.g,_pixelMapData[2]=0|255*color1.b,_pixelMapData[4]=0|255*color2.r,_pixelMapData[5]=0|255*color2.g,_pixelMapData[6]=0|255*color2.b,_pixelMapData[8]=0|255*color3.r,_pixelMapData[9]=0|255*color3.g,_pixelMapData[10]=0|255*color3.b,_pixelMapData[12]=0|255*color4.r,_pixelMapData[13]=0|255*color4.g,_pixelMapData[14]=0|255*color4.b,_pixelMapContext.putImageData(_pixelMapImage,0,0),_gradientMapContext.drawImage(_pixelMap,0,0),_gradientMap}function expand(v1,v2,pixels){var x=v2.x-v1.x,y=v2.y-v1.y,det=x*x+y*y,idet;0==det||(idet=pixels/Math.sqrt(det),x*=idet,y*=idet,v2.x+=x,v2.y+=y,v1.x-=x,v1.y-=y)}function setOpacity(value){_contextGlobalAlpha!==value&&(_context.globalAlpha=value,_contextGlobalAlpha=value)}function setBlending(value){_contextGlobalCompositeOperation!==value&&(value===THREE.NormalBlending?_context.globalCompositeOperation='source-over':value===THREE.AdditiveBlending?_context.globalCompositeOperation='lighter':value===THREE.SubtractiveBlending&&(_context.globalCompositeOperation='darker'),_contextGlobalCompositeOperation=value)}function setLineWidth(value){_contextLineWidth!==value&&(_context.lineWidth=value,_contextLineWidth=value)}function setLineCap(value){_contextLineCap!==value&&(_context.lineCap=value,_contextLineCap=value)}function setLineJoin(value){_contextLineJoin!==value&&(_context.lineJoin=value,_contextLineJoin=value)}function setStrokeStyle(value){_contextStrokeStyle!==value&&(_context.strokeStyle=value,_contextStrokeStyle=value)}function setFillStyle(value){_contextFillStyle!==value&&(_context.fillStyle=value,_contextFillStyle=value)}function setDashAndGap(dashSizeValue,gapSizeValue){(_contextDashSize!==dashSizeValue||_contextGapSize!==gapSizeValue)&&(_context.setLineDash([dashSizeValue,gapSizeValue]),_contextDashSize=dashSizeValue,_contextGapSize=gapSizeValue)}var _Mathfloor2=Math.floor;console.log('THREE.CanvasRenderer',THREE.REVISION);var smoothstep=THREE.Math.smoothstep;parameters=parameters||{};var _this=this,_projector=new THREE.Projector,_canvas=parameters.canvas===void 0?document.createElement('canvas'):parameters.canvas,_context=_canvas.getContext('2d'),_clearColor=new THREE.Color(0),_clearAlpha=0,_contextGlobalAlpha=1,_contextGlobalCompositeOperation=0,_contextStrokeStyle=null,_contextFillStyle=null,_contextLineWidth=null,_contextLineCap=null,_contextLineJoin=null,_contextDashSize=null,_contextGapSize=0,_v5=new THREE.RenderableVertex,_v6=new THREE.RenderableVertex,_color=new THREE.Color,_color1=new THREE.Color,_color2=new THREE.Color,_color3=new THREE.Color,_color4=new THREE.Color,_diffuseColor=new THREE.Color,_emissiveColor=new THREE.Color,_lightColor=new THREE.Color,_patterns={},_imagedatas={},_clipBox=new THREE.Box2,_clearBox=new THREE.Box2,_elemBox=new THREE.Box2,_ambientLight=new THREE.Color,_directionalLights=new THREE.Color,_pointLights=new THREE.Color,_vector3=new THREE.Vector3,_gradientMapQuality=16,_renderData,_elements,_lights,_canvasWidth,_canvasHeight,_canvasWidthHalf,_canvasHeightHalf,_camera,_v1,_v2,_v3,_v1x,_v1y,_v2x,_v2y,_v3x,_v3y,_near,_far,_image,_uvs,_uv1x,_uv1y,_uv2x,_uv2y,_uv3x,_uv3y,_pixelMap,_pixelMapContext,_pixelMapImage,_pixelMapData,_gradientMap,_gradientMapContext;_pixelMap=document.createElement('canvas'),_pixelMap.width=_pixelMap.height=2,_pixelMapContext=_pixelMap.getContext('2d'),_pixelMapContext.fillStyle='rgba(0,0,0,1)',_pixelMapContext.fillRect(0,0,2,2),_pixelMapImage=_pixelMapContext.getImageData(0,0,2,2),_pixelMapData=_pixelMapImage.data,_gradientMap=document.createElement('canvas'),_gradientMap.width=_gradientMap.height=_gradientMapQuality,_gradientMapContext=_gradientMap.getContext('2d'),_gradientMapContext.translate(-_gradientMapQuality/2,-_gradientMapQuality/2),_gradientMapContext.scale(_gradientMapQuality,_gradientMapQuality),_gradientMapQuality--,_context.setLineDash===void 0&&(_context.mozDash===void 0?_context.setLineDash=function(){}:_context.setLineDash=function(values){_context.mozDash=null===values[0]?null:values}),this.domElement=_canvas,this.devicePixelRatio=parameters.devicePixelRatio===void 0?window.devicePixelRatio===void 0?1:window.devicePixelRatio:parameters.devicePixelRatio,this.autoClear=!0,this.sortObjects=!0,this.sortElements=!0,this.info={render:{vertices:0,faces:0}},this.supportsVertexTextures=function(){},this.setFaceCulling=function(){},this.setSize=function(width,height,updateStyle){_canvasWidth=width*this.devicePixelRatio,_canvasHeight=height*this.devicePixelRatio,_canvasWidthHalf=_Mathfloor2(_canvasWidth/2),_canvasHeightHalf=_Mathfloor2(_canvasHeight/2),_canvas.width=_canvasWidth,_canvas.height=_canvasHeight,1!==this.devicePixelRatio&&!1!==updateStyle&&(_canvas.style.width=width+'px',_canvas.style.height=height+'px'),_clipBox.set(new THREE.Vector2(-_canvasWidthHalf,-_canvasHeightHalf),new THREE.Vector2(_canvasWidthHalf,_canvasHeightHalf)),_clearBox.set(new THREE.Vector2(-_canvasWidthHalf,-_canvasHeightHalf),new THREE.Vector2(_canvasWidthHalf,_canvasHeightHalf)),_contextGlobalAlpha=1,_contextGlobalCompositeOperation=0,_contextStrokeStyle=null,_contextFillStyle=null,_contextLineWidth=null,_contextLineCap=null,_contextLineJoin=null},this.setClearColor=function(color,alpha){_clearColor.set(color),_clearAlpha=alpha===void 0?1:alpha,_clearBox.set(new THREE.Vector2(-_canvasWidthHalf,-_canvasHeightHalf),new THREE.Vector2(_canvasWidthHalf,_canvasHeightHalf))},this.setClearColorHex=function(hex,alpha){console.warn('DEPRECATED: .setClearColorHex() is being removed. Use .setClearColor() instead.'),this.setClearColor(hex,alpha)},this.getMaxAnisotropy=function(){return 0},this.clear=function(){_context.setTransform(1,0,0,-1,_canvasWidthHalf,_canvasHeightHalf),!1===_clearBox.empty()&&(_clearBox.intersect(_clipBox),_clearBox.expandByScalar(2),1>_clearAlpha&&_context.clearRect(0|_clearBox.min.x,0|_clearBox.min.y,0|_clearBox.max.x-_clearBox.min.x,0|_clearBox.max.y-_clearBox.min.y),0<_clearAlpha&&(setBlending(THREE.NormalBlending),setOpacity(1),setFillStyle('rgba('+_Mathfloor2(255*_clearColor.r)+','+_Mathfloor2(255*_clearColor.g)+','+_Mathfloor2(255*_clearColor.b)+','+_clearAlpha+')'),_context.fillRect(0|_clearBox.min.x,0|_clearBox.min.y,0|_clearBox.max.x-_clearBox.min.x,0|_clearBox.max.y-_clearBox.min.y)),_clearBox.makeEmpty())},this.render=function(scene,camera){if(!1==camera instanceof THREE.Camera)return void console.error('THREE.CanvasRenderer.render: camera is not an instance of THREE.Camera.');!0===this.autoClear&&this.clear(),_context.setTransform(1,0,0,-1,_canvasWidthHalf,_canvasHeightHalf),_this.info.render.vertices=0,_this.info.render.faces=0,_renderData=_projector.projectScene(scene,camera,this.sortObjects,this.sortElements),_elements=_renderData.elements,_lights=_renderData.lights,_camera=camera,calculateLights();for(var e=0,el=_elements.length;e<el;e++){var element=_elements[e],material=element.material;if(void 0!==material&&!1!==material.visible){if(_elemBox.makeEmpty(),element instanceof THREE.RenderableParticle)_v1=element,_v1.x*=_canvasWidthHalf,_v1.y*=_canvasHeightHalf,renderParticle(_v1,element,material);else if(element instanceof THREE.RenderableLine)_v1=element.v1,_v2=element.v2,_v1.positionScreen.x*=_canvasWidthHalf,_v1.positionScreen.y*=_canvasHeightHalf,_v2.positionScreen.x*=_canvasWidthHalf,_v2.positionScreen.y*=_canvasHeightHalf,_elemBox.setFromPoints([_v1.positionScreen,_v2.positionScreen]),!0===_clipBox.isIntersectionBox(_elemBox)&&renderLine(_v1,_v2,element,material);else if(element instanceof THREE.RenderableFace3){if(_v1=element.v1,_v2=element.v2,_v3=element.v3,-1>_v1.positionScreen.z||1<_v1.positionScreen.z)continue;if(-1>_v2.positionScreen.z||1<_v2.positionScreen.z)continue;if(-1>_v3.positionScreen.z||1<_v3.positionScreen.z)continue;_v1.positionScreen.x*=_canvasWidthHalf,_v1.positionScreen.y*=_canvasHeightHalf,_v2.positionScreen.x*=_canvasWidthHalf,_v2.positionScreen.y*=_canvasHeightHalf,_v3.positionScreen.x*=_canvasWidthHalf,_v3.positionScreen.y*=_canvasHeightHalf,0<material.overdraw&&(expand(_v1.positionScreen,_v2.positionScreen,material.overdraw),expand(_v2.positionScreen,_v3.positionScreen,material.overdraw),expand(_v3.positionScreen,_v1.positionScreen,material.overdraw)),_elemBox.setFromPoints([_v1.positionScreen,_v2.positionScreen,_v3.positionScreen]),!0===_clipBox.isIntersectionBox(_elemBox)&&renderFace3(_v1,_v2,_v3,0,1,2,element,material)}_clearBox.union(_elemBox)}}_context.setTransform(1,0,0,1,0,0)}},THREE.ShaderChunk={fog_pars_fragment:'#ifdef USE_FOG\nuniform vec3 fogColor;\n#ifdef FOG_EXP2\nuniform float fogDensity;\n#else\nuniform float fogNear;\nuniform float fogFar;\n#endif\n#endif',fog_fragment:'#ifdef USE_FOG\nfloat depth = gl_FragCoord.z / gl_FragCoord.w;\n#ifdef FOG_EXP2\nconst float LOG2 = 1.442695;\nfloat fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );\nfogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );\n#else\nfloat fogFactor = smoothstep( fogNear, fogFar, depth );\n#endif\ngl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );\n#endif',envmap_pars_fragment:'#ifdef USE_ENVMAP\nuniform float reflectivity;\nuniform samplerCube envMap;\nuniform float flipEnvMap;\nuniform int combine;\n#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\nuniform bool useRefract;\nuniform float refractionRatio;\n#else\nvarying vec3 vReflect;\n#endif\n#endif',envmap_fragment:'#ifdef USE_ENVMAP\nvec3 reflectVec;\n#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP )\nvec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );\nif ( useRefract ) {\nreflectVec = refract( cameraToVertex, normal, refractionRatio );\n} else { \nreflectVec = reflect( cameraToVertex, normal );\n}\n#else\nreflectVec = vReflect;\n#endif\n#ifdef DOUBLE_SIDED\nfloat flipNormal = ( -1.0 + 2.0 * float( gl_FrontFacing ) );\nvec4 cubeColor = textureCube( envMap, flipNormal * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n#else\nvec4 cubeColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n#endif\n#ifdef GAMMA_INPUT\ncubeColor.xyz *= cubeColor.xyz;\n#endif\nif ( combine == 1 ) {\ngl_FragColor.xyz = mix( gl_FragColor.xyz, cubeColor.xyz, specularStrength * reflectivity );\n} else if ( combine == 2 ) {\ngl_FragColor.xyz += cubeColor.xyz * specularStrength * reflectivity;\n} else {\ngl_FragColor.xyz = mix( gl_FragColor.xyz, gl_FragColor.xyz * cubeColor.xyz, specularStrength * reflectivity );\n}\n#endif',envmap_pars_vertex:'#if defined( USE_ENVMAP ) && ! defined( USE_BUMPMAP ) && ! defined( USE_NORMALMAP )\nvarying vec3 vReflect;\nuniform float refractionRatio;\nuniform bool useRefract;\n#endif',worldpos_vertex:'#if defined( USE_ENVMAP ) || defined( PHONG ) || defined( LAMBERT ) || defined ( USE_SHADOWMAP )\n#ifdef USE_SKINNING\nvec4 worldPosition = modelMatrix * skinned;\n#endif\n#if defined( USE_MORPHTARGETS ) && ! defined( USE_SKINNING )\nvec4 worldPosition = modelMatrix * vec4( morphed, 1.0 );\n#endif\n#if ! defined( USE_MORPHTARGETS ) && ! defined( USE_SKINNING )\nvec4 worldPosition = modelMatrix * vec4( position, 1.0 );\n#endif\n#endif',envmap_vertex:'#if defined( USE_ENVMAP ) && ! defined( USE_BUMPMAP ) && ! defined( USE_NORMALMAP )\nvec3 worldNormal = mat3( modelMatrix[ 0 ].xyz, modelMatrix[ 1 ].xyz, modelMatrix[ 2 ].xyz ) * objectNormal;\nworldNormal = normalize( worldNormal );\nvec3 cameraToVertex = normalize( worldPosition.xyz - cameraPosition );\nif ( useRefract ) {\nvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n} else {\nvReflect = reflect( cameraToVertex, worldNormal );\n}\n#endif',map_particle_pars_fragment:'#ifdef USE_MAP\nuniform sampler2D map;\n#endif',map_particle_fragment:'#ifdef USE_MAP\ngl_FragColor = gl_FragColor * texture2D( map, vec2( gl_PointCoord.x, 1.0 - gl_PointCoord.y ) );\n#endif',map_pars_vertex:'#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP )\nvarying vec2 vUv;\nuniform vec4 offsetRepeat;\n#endif',map_pars_fragment:'#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP )\nvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\nuniform sampler2D map;\n#endif',map_vertex:'#if defined( USE_MAP ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( USE_SPECULARMAP )\nvUv = uv * offsetRepeat.zw + offsetRepeat.xy;\n#endif',map_fragment:'#ifdef USE_MAP\nvec4 texelColor = texture2D( map, vUv );\n#ifdef GAMMA_INPUT\ntexelColor.xyz *= texelColor.xyz;\n#endif\ngl_FragColor = gl_FragColor * texelColor;\n#endif',lightmap_pars_fragment:'#ifdef USE_LIGHTMAP\nvarying vec2 vUv2;\nuniform sampler2D lightMap;\n#endif',lightmap_pars_vertex:'#ifdef USE_LIGHTMAP\nvarying vec2 vUv2;\n#endif',lightmap_fragment:'#ifdef USE_LIGHTMAP\ngl_FragColor = gl_FragColor * texture2D( lightMap, vUv2 );\n#endif',lightmap_vertex:'#ifdef USE_LIGHTMAP\nvUv2 = uv2;\n#endif',bumpmap_pars_fragment:'#ifdef USE_BUMPMAP\nuniform sampler2D bumpMap;\nuniform float bumpScale;\nvec2 dHdxy_fwd() {\nvec2 dSTdx = dFdx( vUv );\nvec2 dSTdy = dFdy( vUv );\nfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\nfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\nfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\nreturn vec2( dBx, dBy );\n}\nvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\nvec3 vSigmaX = dFdx( surf_pos );\nvec3 vSigmaY = dFdy( surf_pos );\nvec3 vN = surf_norm;\nvec3 R1 = cross( vSigmaY, vN );\nvec3 R2 = cross( vN, vSigmaX );\nfloat fDet = dot( vSigmaX, R1 );\nvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\nreturn normalize( abs( fDet ) * surf_norm - vGrad );\n}\n#endif',normalmap_pars_fragment:'#ifdef USE_NORMALMAP\nuniform sampler2D normalMap;\nuniform vec2 normalScale;\nvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm ) {\nvec3 q0 = dFdx( eye_pos.xyz );\nvec3 q1 = dFdy( eye_pos.xyz );\nvec2 st0 = dFdx( vUv.st );\nvec2 st1 = dFdy( vUv.st );\nvec3 S = normalize(  q0 * st1.t - q1 * st0.t );\nvec3 T = normalize( -q0 * st1.s + q1 * st0.s );\nvec3 N = normalize( surf_norm );\nvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\nmapN.xy = normalScale * mapN.xy;\nmat3 tsn = mat3( S, T, N );\nreturn normalize( tsn * mapN );\n}\n#endif',specularmap_pars_fragment:'#ifdef USE_SPECULARMAP\nuniform sampler2D specularMap;\n#endif',specularmap_fragment:'float specularStrength;\n#ifdef USE_SPECULARMAP\nvec4 texelSpecular = texture2D( specularMap, vUv );\nspecularStrength = texelSpecular.r;\n#else\nspecularStrength = 1.0;\n#endif',lights_lambert_pars_vertex:'uniform vec3 ambient;\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 ambientLightColor;\n#if MAX_DIR_LIGHTS > 0\nuniform vec3 directionalLightColor[ MAX_DIR_LIGHTS ];\nuniform vec3 directionalLightDirection[ MAX_DIR_LIGHTS ];\n#endif\n#if MAX_HEMI_LIGHTS > 0\nuniform vec3 hemisphereLightSkyColor[ MAX_HEMI_LIGHTS ];\nuniform vec3 hemisphereLightGroundColor[ MAX_HEMI_LIGHTS ];\nuniform vec3 hemisphereLightDirection[ MAX_HEMI_LIGHTS ];\n#endif\n#if MAX_POINT_LIGHTS > 0\nuniform vec3 pointLightColor[ MAX_POINT_LIGHTS ];\nuniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];\nuniform float pointLightDistance[ MAX_POINT_LIGHTS ];\n#endif\n#if MAX_SPOT_LIGHTS > 0\nuniform vec3 spotLightColor[ MAX_SPOT_LIGHTS ];\nuniform vec3 spotLightPosition[ MAX_SPOT_LIGHTS ];\nuniform vec3 spotLightDirection[ MAX_SPOT_LIGHTS ];\nuniform float spotLightDistance[ MAX_SPOT_LIGHTS ];\nuniform float spotLightAngleCos[ MAX_SPOT_LIGHTS ];\nuniform float spotLightExponent[ MAX_SPOT_LIGHTS ];\n#endif\n#ifdef WRAP_AROUND\nuniform vec3 wrapRGB;\n#endif',lights_lambert_vertex:'vLightFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\nvLightBack = vec3( 0.0 );\n#endif\ntransformedNormal = normalize( transformedNormal );\n#if MAX_DIR_LIGHTS > 0\nfor( int i = 0; i < MAX_DIR_LIGHTS; i ++ ) {\nvec4 lDirection = viewMatrix * vec4( directionalLightDirection[ i ], 0.0 );\nvec3 dirVector = normalize( lDirection.xyz );\nfloat dotProduct = dot( transformedNormal, dirVector );\nvec3 directionalLightWeighting = vec3( max( dotProduct, 0.0 ) );\n#ifdef DOUBLE_SIDED\nvec3 directionalLightWeightingBack = vec3( max( -dotProduct, 0.0 ) );\n#ifdef WRAP_AROUND\nvec3 directionalLightWeightingHalfBack = vec3( max( -0.5 * dotProduct + 0.5, 0.0 ) );\n#endif\n#endif\n#ifdef WRAP_AROUND\nvec3 directionalLightWeightingHalf = vec3( max( 0.5 * dotProduct + 0.5, 0.0 ) );\ndirectionalLightWeighting = mix( directionalLightWeighting, directionalLightWeightingHalf, wrapRGB );\n#ifdef DOUBLE_SIDED\ndirectionalLightWeightingBack = mix( directionalLightWeightingBack, directionalLightWeightingHalfBack, wrapRGB );\n#endif\n#endif\nvLightFront += directionalLightColor[ i ] * directionalLightWeighting;\n#ifdef DOUBLE_SIDED\nvLightBack += directionalLightColor[ i ] * directionalLightWeightingBack;\n#endif\n}\n#endif\n#if MAX_POINT_LIGHTS > 0\nfor( int i = 0; i < MAX_POINT_LIGHTS; i ++ ) {\nvec4 lPosition = viewMatrix * vec4( pointLightPosition[ i ], 1.0 );\nvec3 lVector = lPosition.xyz - mvPosition.xyz;\nfloat lDistance = 1.0;\nif ( pointLightDistance[ i ] > 0.0 )\nlDistance = 1.0 - min( ( length( lVector ) / pointLightDistance[ i ] ), 1.0 );\nlVector = normalize( lVector );\nfloat dotProduct = dot( transformedNormal, lVector );\nvec3 pointLightWeighting = vec3( max( dotProduct, 0.0 ) );\n#ifdef DOUBLE_SIDED\nvec3 pointLightWeightingBack = vec3( max( -dotProduct, 0.0 ) );\n#ifdef WRAP_AROUND\nvec3 pointLightWeightingHalfBack = vec3( max( -0.5 * dotProduct + 0.5, 0.0 ) );\n#endif\n#endif\n#ifdef WRAP_AROUND\nvec3 pointLightWeightingHalf = vec3( max( 0.5 * dotProduct + 0.5, 0.0 ) );\npointLightWeighting = mix( pointLightWeighting, pointLightWeightingHalf, wrapRGB );\n#ifdef DOUBLE_SIDED\npointLightWeightingBack = mix( pointLightWeightingBack, pointLightWeightingHalfBack, wrapRGB );\n#endif\n#endif\nvLightFront += pointLightColor[ i ] * pointLightWeighting * lDistance;\n#ifdef DOUBLE_SIDED\nvLightBack += pointLightColor[ i ] * pointLightWeightingBack * lDistance;\n#endif\n}\n#endif\n#if MAX_SPOT_LIGHTS > 0\nfor( int i = 0; i < MAX_SPOT_LIGHTS; i ++ ) {\nvec4 lPosition = viewMatrix * vec4( spotLightPosition[ i ], 1.0 );\nvec3 lVector = lPosition.xyz - mvPosition.xyz;\nfloat spotEffect = dot( spotLightDirection[ i ], normalize( spotLightPosition[ i ] - worldPosition.xyz ) );\nif ( spotEffect > spotLightAngleCos[ i ] ) {\nspotEffect = max( pow( spotEffect, spotLightExponent[ i ] ), 0.0 );\nfloat lDistance = 1.0;\nif ( spotLightDistance[ i ] > 0.0 )\nlDistance = 1.0 - min( ( length( lVector ) / spotLightDistance[ i ] ), 1.0 );\nlVector = normalize( lVector );\nfloat dotProduct = dot( transformedNormal, lVector );\nvec3 spotLightWeighting = vec3( max( dotProduct, 0.0 ) );\n#ifdef DOUBLE_SIDED\nvec3 spotLightWeightingBack = vec3( max( -dotProduct, 0.0 ) );\n#ifdef WRAP_AROUND\nvec3 spotLightWeightingHalfBack = vec3( max( -0.5 * dotProduct + 0.5, 0.0 ) );\n#endif\n#endif\n#ifdef WRAP_AROUND\nvec3 spotLightWeightingHalf = vec3( max( 0.5 * dotProduct + 0.5, 0.0 ) );\nspotLightWeighting = mix( spotLightWeighting, spotLightWeightingHalf, wrapRGB );\n#ifdef DOUBLE_SIDED\nspotLightWeightingBack = mix( spotLightWeightingBack, spotLightWeightingHalfBack, wrapRGB );\n#endif\n#endif\nvLightFront += spotLightColor[ i ] * spotLightWeighting * lDistance * spotEffect;\n#ifdef DOUBLE_SIDED\nvLightBack += spotLightColor[ i ] * spotLightWeightingBack * lDistance * spotEffect;\n#endif\n}\n}\n#endif\n#if MAX_HEMI_LIGHTS > 0\nfor( int i = 0; i < MAX_HEMI_LIGHTS; i ++ ) {\nvec4 lDirection = viewMatrix * vec4( hemisphereLightDirection[ i ], 0.0 );\nvec3 lVector = normalize( lDirection.xyz );\nfloat dotProduct = dot( transformedNormal, lVector );\nfloat hemiDiffuseWeight = 0.5 * dotProduct + 0.5;\nfloat hemiDiffuseWeightBack = -0.5 * dotProduct + 0.5;\nvLightFront += mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeight );\n#ifdef DOUBLE_SIDED\nvLightBack += mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeightBack );\n#endif\n}\n#endif\nvLightFront = vLightFront * diffuse + ambient * ambientLightColor + emissive;\n#ifdef DOUBLE_SIDED\nvLightBack = vLightBack * diffuse + ambient * ambientLightColor + emissive;\n#endif',lights_phong_pars_vertex:'#ifndef PHONG_PER_PIXEL\n#if MAX_POINT_LIGHTS > 0\nuniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];\nuniform float pointLightDistance[ MAX_POINT_LIGHTS ];\nvarying vec4 vPointLight[ MAX_POINT_LIGHTS ];\n#endif\n#if MAX_SPOT_LIGHTS > 0\nuniform vec3 spotLightPosition[ MAX_SPOT_LIGHTS ];\nuniform float spotLightDistance[ MAX_SPOT_LIGHTS ];\nvarying vec4 vSpotLight[ MAX_SPOT_LIGHTS ];\n#endif\n#endif\n#if MAX_SPOT_LIGHTS > 0 || defined( USE_BUMPMAP )\nvarying vec3 vWorldPosition;\n#endif',lights_phong_vertex:'#ifndef PHONG_PER_PIXEL\n#if MAX_POINT_LIGHTS > 0\nfor( int i = 0; i < MAX_POINT_LIGHTS; i ++ ) {\nvec4 lPosition = viewMatrix * vec4( pointLightPosition[ i ], 1.0 );\nvec3 lVector = lPosition.xyz - mvPosition.xyz;\nfloat lDistance = 1.0;\nif ( pointLightDistance[ i ] > 0.0 )\nlDistance = 1.0 - min( ( length( lVector ) / pointLightDistance[ i ] ), 1.0 );\nvPointLight[ i ] = vec4( lVector, lDistance );\n}\n#endif\n#if MAX_SPOT_LIGHTS > 0\nfor( int i = 0; i < MAX_SPOT_LIGHTS; i ++ ) {\nvec4 lPosition = viewMatrix * vec4( spotLightPosition[ i ], 1.0 );\nvec3 lVector = lPosition.xyz - mvPosition.xyz;\nfloat lDistance = 1.0;\nif ( spotLightDistance[ i ] > 0.0 )\nlDistance = 1.0 - min( ( length( lVector ) / spotLightDistance[ i ] ), 1.0 );\nvSpotLight[ i ] = vec4( lVector, lDistance );\n}\n#endif\n#endif\n#if MAX_SPOT_LIGHTS > 0 || defined( USE_BUMPMAP )\nvWorldPosition = worldPosition.xyz;\n#endif',lights_phong_pars_fragment:'uniform vec3 ambientLightColor;\n#if MAX_DIR_LIGHTS > 0\nuniform vec3 directionalLightColor[ MAX_DIR_LIGHTS ];\nuniform vec3 directionalLightDirection[ MAX_DIR_LIGHTS ];\n#endif\n#if MAX_HEMI_LIGHTS > 0\nuniform vec3 hemisphereLightSkyColor[ MAX_HEMI_LIGHTS ];\nuniform vec3 hemisphereLightGroundColor[ MAX_HEMI_LIGHTS ];\nuniform vec3 hemisphereLightDirection[ MAX_HEMI_LIGHTS ];\n#endif\n#if MAX_POINT_LIGHTS > 0\nuniform vec3 pointLightColor[ MAX_POINT_LIGHTS ];\n#ifdef PHONG_PER_PIXEL\nuniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];\nuniform float pointLightDistance[ MAX_POINT_LIGHTS ];\n#else\nvarying vec4 vPointLight[ MAX_POINT_LIGHTS ];\n#endif\n#endif\n#if MAX_SPOT_LIGHTS > 0\nuniform vec3 spotLightColor[ MAX_SPOT_LIGHTS ];\nuniform vec3 spotLightPosition[ MAX_SPOT_LIGHTS ];\nuniform vec3 spotLightDirection[ MAX_SPOT_LIGHTS ];\nuniform float spotLightAngleCos[ MAX_SPOT_LIGHTS ];\nuniform float spotLightExponent[ MAX_SPOT_LIGHTS ];\n#ifdef PHONG_PER_PIXEL\nuniform float spotLightDistance[ MAX_SPOT_LIGHTS ];\n#else\nvarying vec4 vSpotLight[ MAX_SPOT_LIGHTS ];\n#endif\n#endif\n#if MAX_SPOT_LIGHTS > 0 || defined( USE_BUMPMAP )\nvarying vec3 vWorldPosition;\n#endif\n#ifdef WRAP_AROUND\nuniform vec3 wrapRGB;\n#endif\nvarying vec3 vViewPosition;\nvarying vec3 vNormal;',lights_phong_fragment:'vec3 normal = normalize( vNormal );\nvec3 viewPosition = normalize( vViewPosition );\n#ifdef DOUBLE_SIDED\nnormal = normal * ( -1.0 + 2.0 * float( gl_FrontFacing ) );\n#endif\n#ifdef USE_NORMALMAP\nnormal = perturbNormal2Arb( -vViewPosition, normal );\n#elif defined( USE_BUMPMAP )\nnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif\n#if MAX_POINT_LIGHTS > 0\nvec3 pointDiffuse  = vec3( 0.0 );\nvec3 pointSpecular = vec3( 0.0 );\nfor ( int i = 0; i < MAX_POINT_LIGHTS; i ++ ) {\n#ifdef PHONG_PER_PIXEL\nvec4 lPosition = viewMatrix * vec4( pointLightPosition[ i ], 1.0 );\nvec3 lVector = lPosition.xyz + vViewPosition.xyz;\nfloat lDistance = 1.0;\nif ( pointLightDistance[ i ] > 0.0 )\nlDistance = 1.0 - min( ( length( lVector ) / pointLightDistance[ i ] ), 1.0 );\nlVector = normalize( lVector );\n#else\nvec3 lVector = normalize( vPointLight[ i ].xyz );\nfloat lDistance = vPointLight[ i ].w;\n#endif\nfloat dotProduct = dot( normal, lVector );\n#ifdef WRAP_AROUND\nfloat pointDiffuseWeightFull = max( dotProduct, 0.0 );\nfloat pointDiffuseWeightHalf = max( 0.5 * dotProduct + 0.5, 0.0 );\nvec3 pointDiffuseWeight = mix( vec3 ( pointDiffuseWeightFull ), vec3( pointDiffuseWeightHalf ), wrapRGB );\n#else\nfloat pointDiffuseWeight = max( dotProduct, 0.0 );\n#endif\npointDiffuse  += diffuse * pointLightColor[ i ] * pointDiffuseWeight * lDistance;\nvec3 pointHalfVector = normalize( lVector + viewPosition );\nfloat pointDotNormalHalf = max( dot( normal, pointHalfVector ), 0.0 );\nfloat pointSpecularWeight = specularStrength * max( pow( pointDotNormalHalf, shininess ), 0.0 );\n#ifdef PHYSICALLY_BASED_SHADING\nfloat specularNormalization = ( shininess + 2.0001 ) / 8.0;\nvec3 schlick = specular + vec3( 1.0 - specular ) * pow( 1.0 - dot( lVector, pointHalfVector ), 5.0 );\npointSpecular += schlick * pointLightColor[ i ] * pointSpecularWeight * pointDiffuseWeight * lDistance * specularNormalization;\n#else\npointSpecular += specular * pointLightColor[ i ] * pointSpecularWeight * pointDiffuseWeight * lDistance;\n#endif\n}\n#endif\n#if MAX_SPOT_LIGHTS > 0\nvec3 spotDiffuse  = vec3( 0.0 );\nvec3 spotSpecular = vec3( 0.0 );\nfor ( int i = 0; i < MAX_SPOT_LIGHTS; i ++ ) {\n#ifdef PHONG_PER_PIXEL\nvec4 lPosition = viewMatrix * vec4( spotLightPosition[ i ], 1.0 );\nvec3 lVector = lPosition.xyz + vViewPosition.xyz;\nfloat lDistance = 1.0;\nif ( spotLightDistance[ i ] > 0.0 )\nlDistance = 1.0 - min( ( length( lVector ) / spotLightDistance[ i ] ), 1.0 );\nlVector = normalize( lVector );\n#else\nvec3 lVector = normalize( vSpotLight[ i ].xyz );\nfloat lDistance = vSpotLight[ i ].w;\n#endif\nfloat spotEffect = dot( spotLightDirection[ i ], normalize( spotLightPosition[ i ] - vWorldPosition ) );\nif ( spotEffect > spotLightAngleCos[ i ] ) {\nspotEffect = max( pow( spotEffect, spotLightExponent[ i ] ), 0.0 );\nfloat dotProduct = dot( normal, lVector );\n#ifdef WRAP_AROUND\nfloat spotDiffuseWeightFull = max( dotProduct, 0.0 );\nfloat spotDiffuseWeightHalf = max( 0.5 * dotProduct + 0.5, 0.0 );\nvec3 spotDiffuseWeight = mix( vec3 ( spotDiffuseWeightFull ), vec3( spotDiffuseWeightHalf ), wrapRGB );\n#else\nfloat spotDiffuseWeight = max( dotProduct, 0.0 );\n#endif\nspotDiffuse += diffuse * spotLightColor[ i ] * spotDiffuseWeight * lDistance * spotEffect;\nvec3 spotHalfVector = normalize( lVector + viewPosition );\nfloat spotDotNormalHalf = max( dot( normal, spotHalfVector ), 0.0 );\nfloat spotSpecularWeight = specularStrength * max( pow( spotDotNormalHalf, shininess ), 0.0 );\n#ifdef PHYSICALLY_BASED_SHADING\nfloat specularNormalization = ( shininess + 2.0001 ) / 8.0;\nvec3 schlick = specular + vec3( 1.0 - specular ) * pow( 1.0 - dot( lVector, spotHalfVector ), 5.0 );\nspotSpecular += schlick * spotLightColor[ i ] * spotSpecularWeight * spotDiffuseWeight * lDistance * specularNormalization * spotEffect;\n#else\nspotSpecular += specular * spotLightColor[ i ] * spotSpecularWeight * spotDiffuseWeight * lDistance * spotEffect;\n#endif\n}\n}\n#endif\n#if MAX_DIR_LIGHTS > 0\nvec3 dirDiffuse  = vec3( 0.0 );\nvec3 dirSpecular = vec3( 0.0 );\nfor( int i = 0; i < MAX_DIR_LIGHTS; i ++ ) {\nvec4 lDirection = viewMatrix * vec4( directionalLightDirection[ i ], 0.0 );\nvec3 dirVector = normalize( lDirection.xyz );\nfloat dotProduct = dot( normal, dirVector );\n#ifdef WRAP_AROUND\nfloat dirDiffuseWeightFull = max( dotProduct, 0.0 );\nfloat dirDiffuseWeightHalf = max( 0.5 * dotProduct + 0.5, 0.0 );\nvec3 dirDiffuseWeight = mix( vec3( dirDiffuseWeightFull ), vec3( dirDiffuseWeightHalf ), wrapRGB );\n#else\nfloat dirDiffuseWeight = max( dotProduct, 0.0 );\n#endif\ndirDiffuse  += diffuse * directionalLightColor[ i ] * dirDiffuseWeight;\nvec3 dirHalfVector = normalize( dirVector + viewPosition );\nfloat dirDotNormalHalf = max( dot( normal, dirHalfVector ), 0.0 );\nfloat dirSpecularWeight = specularStrength * max( pow( dirDotNormalHalf, shininess ), 0.0 );\n#ifdef PHYSICALLY_BASED_SHADING\nfloat specularNormalization = ( shininess + 2.0001 ) / 8.0;\nvec3 schlick = specular + vec3( 1.0 - specular ) * pow( 1.0 - dot( dirVector, dirHalfVector ), 5.0 );\ndirSpecular += schlick * directionalLightColor[ i ] * dirSpecularWeight * dirDiffuseWeight * specularNormalization;\n#else\ndirSpecular += specular * directionalLightColor[ i ] * dirSpecularWeight * dirDiffuseWeight;\n#endif\n}\n#endif\n#if MAX_HEMI_LIGHTS > 0\nvec3 hemiDiffuse  = vec3( 0.0 );\nvec3 hemiSpecular = vec3( 0.0 );\nfor( int i = 0; i < MAX_HEMI_LIGHTS; i ++ ) {\nvec4 lDirection = viewMatrix * vec4( hemisphereLightDirection[ i ], 0.0 );\nvec3 lVector = normalize( lDirection.xyz );\nfloat dotProduct = dot( normal, lVector );\nfloat hemiDiffuseWeight = 0.5 * dotProduct + 0.5;\nvec3 hemiColor = mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeight );\nhemiDiffuse += diffuse * hemiColor;\nvec3 hemiHalfVectorSky = normalize( lVector + viewPosition );\nfloat hemiDotNormalHalfSky = 0.5 * dot( normal, hemiHalfVectorSky ) + 0.5;\nfloat hemiSpecularWeightSky = specularStrength * max( pow( hemiDotNormalHalfSky, shininess ), 0.0 );\nvec3 lVectorGround = -lVector;\nvec3 hemiHalfVectorGround = normalize( lVectorGround + viewPosition );\nfloat hemiDotNormalHalfGround = 0.5 * dot( normal, hemiHalfVectorGround ) + 0.5;\nfloat hemiSpecularWeightGround = specularStrength * max( pow( hemiDotNormalHalfGround, shininess ), 0.0 );\n#ifdef PHYSICALLY_BASED_SHADING\nfloat dotProductGround = dot( normal, lVectorGround );\nfloat specularNormalization = ( shininess + 2.0001 ) / 8.0;\nvec3 schlickSky = specular + vec3( 1.0 - specular ) * pow( 1.0 - dot( lVector, hemiHalfVectorSky ), 5.0 );\nvec3 schlickGround = specular + vec3( 1.0 - specular ) * pow( 1.0 - dot( lVectorGround, hemiHalfVectorGround ), 5.0 );\nhemiSpecular += hemiColor * specularNormalization * ( schlickSky * hemiSpecularWeightSky * max( dotProduct, 0.0 ) + schlickGround * hemiSpecularWeightGround * max( dotProductGround, 0.0 ) );\n#else\nhemiSpecular += specular * hemiColor * ( hemiSpecularWeightSky + hemiSpecularWeightGround ) * hemiDiffuseWeight;\n#endif\n}\n#endif\nvec3 totalDiffuse = vec3( 0.0 );\nvec3 totalSpecular = vec3( 0.0 );\n#if MAX_DIR_LIGHTS > 0\ntotalDiffuse += dirDiffuse;\ntotalSpecular += dirSpecular;\n#endif\n#if MAX_HEMI_LIGHTS > 0\ntotalDiffuse += hemiDiffuse;\ntotalSpecular += hemiSpecular;\n#endif\n#if MAX_POINT_LIGHTS > 0\ntotalDiffuse += pointDiffuse;\ntotalSpecular += pointSpecular;\n#endif\n#if MAX_SPOT_LIGHTS > 0\ntotalDiffuse += spotDiffuse;\ntotalSpecular += spotSpecular;\n#endif\n#ifdef METAL\ngl_FragColor.xyz = gl_FragColor.xyz * ( emissive + totalDiffuse + ambientLightColor * ambient + totalSpecular );\n#else\ngl_FragColor.xyz = gl_FragColor.xyz * ( emissive + totalDiffuse + ambientLightColor * ambient ) + totalSpecular;\n#endif',color_pars_fragment:'#ifdef USE_COLOR\nvarying vec3 vColor;\n#endif',color_fragment:'#ifdef USE_COLOR\ngl_FragColor = gl_FragColor * vec4( vColor, opacity );\n#endif',color_pars_vertex:'#ifdef USE_COLOR\nvarying vec3 vColor;\n#endif',color_vertex:'#ifdef USE_COLOR\n#ifdef GAMMA_INPUT\nvColor = color * color;\n#else\nvColor = color;\n#endif\n#endif',skinning_pars_vertex:'#ifdef USE_SKINNING\n#ifdef BONE_TEXTURE\nuniform sampler2D boneTexture;\nmat4 getBoneMatrix( const in float i ) {\nfloat j = i * 4.0;\nfloat x = mod( j, N_BONE_PIXEL_X );\nfloat y = floor( j / N_BONE_PIXEL_X );\nconst float dx = 1.0 / N_BONE_PIXEL_X;\nconst float dy = 1.0 / N_BONE_PIXEL_Y;\ny = dy * ( y + 0.5 );\nvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\nvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\nvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\nvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\nmat4 bone = mat4( v1, v2, v3, v4 );\nreturn bone;\n}\n#else\nuniform mat4 boneGlobalMatrices[ MAX_BONES ];\nmat4 getBoneMatrix( const in float i ) {\nmat4 bone = boneGlobalMatrices[ int(i) ];\nreturn bone;\n}\n#endif\n#endif',skinbase_vertex:'#ifdef USE_SKINNING\nmat4 boneMatX = getBoneMatrix( skinIndex.x );\nmat4 boneMatY = getBoneMatrix( skinIndex.y );\n#endif',skinning_vertex:'#ifdef USE_SKINNING\n#ifdef USE_MORPHTARGETS\nvec4 skinVertex = vec4( morphed, 1.0 );\n#else\nvec4 skinVertex = vec4( position, 1.0 );\n#endif\nvec4 skinned  = boneMatX * skinVertex * skinWeight.x;\nskinned \t  += boneMatY * skinVertex * skinWeight.y;\n#endif',morphtarget_pars_vertex:'#ifdef USE_MORPHTARGETS\n#ifndef USE_MORPHNORMALS\nuniform float morphTargetInfluences[ 8 ];\n#else\nuniform float morphTargetInfluences[ 4 ];\n#endif\n#endif',morphtarget_vertex:'#ifdef USE_MORPHTARGETS\nvec3 morphed = vec3( 0.0 );\nmorphed += ( morphTarget0 - position ) * morphTargetInfluences[ 0 ];\nmorphed += ( morphTarget1 - position ) * morphTargetInfluences[ 1 ];\nmorphed += ( morphTarget2 - position ) * morphTargetInfluences[ 2 ];\nmorphed += ( morphTarget3 - position ) * morphTargetInfluences[ 3 ];\n#ifndef USE_MORPHNORMALS\nmorphed += ( morphTarget4 - position ) * morphTargetInfluences[ 4 ];\nmorphed += ( morphTarget5 - position ) * morphTargetInfluences[ 5 ];\nmorphed += ( morphTarget6 - position ) * morphTargetInfluences[ 6 ];\nmorphed += ( morphTarget7 - position ) * morphTargetInfluences[ 7 ];\n#endif\nmorphed += position;\n#endif',default_vertex:'vec4 mvPosition;\n#ifdef USE_SKINNING\nmvPosition = modelViewMatrix * skinned;\n#endif\n#if !defined( USE_SKINNING ) && defined( USE_MORPHTARGETS )\nmvPosition = modelViewMatrix * vec4( morphed, 1.0 );\n#endif\n#if !defined( USE_SKINNING ) && ! defined( USE_MORPHTARGETS )\nmvPosition = modelViewMatrix * vec4( position, 1.0 );\n#endif\ngl_Position = projectionMatrix * mvPosition;',morphnormal_vertex:'#ifdef USE_MORPHNORMALS\nvec3 morphedNormal = vec3( 0.0 );\nmorphedNormal +=  ( morphNormal0 - normal ) * morphTargetInfluences[ 0 ];\nmorphedNormal +=  ( morphNormal1 - normal ) * morphTargetInfluences[ 1 ];\nmorphedNormal +=  ( morphNormal2 - normal ) * morphTargetInfluences[ 2 ];\nmorphedNormal +=  ( morphNormal3 - normal ) * morphTargetInfluences[ 3 ];\nmorphedNormal += normal;\n#endif',skinnormal_vertex:'#ifdef USE_SKINNING\nmat4 skinMatrix = skinWeight.x * boneMatX;\nskinMatrix \t+= skinWeight.y * boneMatY;\n#ifdef USE_MORPHNORMALS\nvec4 skinnedNormal = skinMatrix * vec4( morphedNormal, 0.0 );\n#else\nvec4 skinnedNormal = skinMatrix * vec4( normal, 0.0 );\n#endif\n#endif',defaultnormal_vertex:'vec3 objectNormal;\n#ifdef USE_SKINNING\nobjectNormal = skinnedNormal.xyz;\n#endif\n#if !defined( USE_SKINNING ) && defined( USE_MORPHNORMALS )\nobjectNormal = morphedNormal;\n#endif\n#if !defined( USE_SKINNING ) && ! defined( USE_MORPHNORMALS )\nobjectNormal = normal;\n#endif\n#ifdef FLIP_SIDED\nobjectNormal = -objectNormal;\n#endif\nvec3 transformedNormal = normalMatrix * objectNormal;',shadowmap_pars_fragment:'#ifdef USE_SHADOWMAP\nuniform sampler2D shadowMap[ MAX_SHADOWS ];\nuniform vec2 shadowMapSize[ MAX_SHADOWS ];\nuniform float shadowDarkness[ MAX_SHADOWS ];\nuniform float shadowBias[ MAX_SHADOWS ];\nvarying vec4 vShadowCoord[ MAX_SHADOWS ];\nfloat unpackDepth( const in vec4 rgba_depth ) {\nconst vec4 bit_shift = vec4( 1.0 / ( 256.0 * 256.0 * 256.0 ), 1.0 / ( 256.0 * 256.0 ), 1.0 / 256.0, 1.0 );\nfloat depth = dot( rgba_depth, bit_shift );\nreturn depth;\n}\n#endif',shadowmap_fragment:'#ifdef USE_SHADOWMAP\n#ifdef SHADOWMAP_DEBUG\nvec3 frustumColors[3];\nfrustumColors[0] = vec3( 1.0, 0.5, 0.0 );\nfrustumColors[1] = vec3( 0.0, 1.0, 0.8 );\nfrustumColors[2] = vec3( 0.0, 0.5, 1.0 );\n#endif\n#ifdef SHADOWMAP_CASCADE\nint inFrustumCount = 0;\n#endif\nfloat fDepth;\nvec3 shadowColor = vec3( 1.0 );\nfor( int i = 0; i < MAX_SHADOWS; i ++ ) {\nvec3 shadowCoord = vShadowCoord[ i ].xyz / vShadowCoord[ i ].w;\nbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\nbool inFrustum = all( inFrustumVec );\n#ifdef SHADOWMAP_CASCADE\ninFrustumCount += int( inFrustum );\nbvec3 frustumTestVec = bvec3( inFrustum, inFrustumCount == 1, shadowCoord.z <= 1.0 );\n#else\nbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n#endif\nbool frustumTest = all( frustumTestVec );\nif ( frustumTest ) {\nshadowCoord.z += shadowBias[ i ];\n#if defined( SHADOWMAP_TYPE_PCF )\nfloat shadow = 0.0;\nconst float shadowDelta = 1.0 / 9.0;\nfloat xPixelOffset = 1.0 / shadowMapSize[ i ].x;\nfloat yPixelOffset = 1.0 / shadowMapSize[ i ].y;\nfloat dx0 = -1.25 * xPixelOffset;\nfloat dy0 = -1.25 * yPixelOffset;\nfloat dx1 = 1.25 * xPixelOffset;\nfloat dy1 = 1.25 * yPixelOffset;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy0 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy0 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy0 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, 0.0 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, 0.0 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy1 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy1 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nfDepth = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy1 ) ) );\nif ( fDepth < shadowCoord.z ) shadow += shadowDelta;\nshadowColor = shadowColor * vec3( ( 1.0 - shadowDarkness[ i ] * shadow ) );\n#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\nfloat shadow = 0.0;\nfloat xPixelOffset = 1.0 / shadowMapSize[ i ].x;\nfloat yPixelOffset = 1.0 / shadowMapSize[ i ].y;\nfloat dx0 = -1.0 * xPixelOffset;\nfloat dy0 = -1.0 * yPixelOffset;\nfloat dx1 = 1.0 * xPixelOffset;\nfloat dy1 = 1.0 * yPixelOffset;\nmat3 shadowKernel;\nmat3 depthKernel;\ndepthKernel[0][0] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy0 ) ) );\ndepthKernel[0][1] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, 0.0 ) ) );\ndepthKernel[0][2] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx0, dy1 ) ) );\ndepthKernel[1][0] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy0 ) ) );\ndepthKernel[1][1] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy ) );\ndepthKernel[1][2] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( 0.0, dy1 ) ) );\ndepthKernel[2][0] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy0 ) ) );\ndepthKernel[2][1] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, 0.0 ) ) );\ndepthKernel[2][2] = unpackDepth( texture2D( shadowMap[ i ], shadowCoord.xy + vec2( dx1, dy1 ) ) );\nvec3 shadowZ = vec3( shadowCoord.z );\nshadowKernel[0] = vec3(lessThan(depthKernel[0], shadowZ ));\nshadowKernel[0] *= vec3(0.25);\nshadowKernel[1] = vec3(lessThan(depthKernel[1], shadowZ ));\nshadowKernel[1] *= vec3(0.25);\nshadowKernel[2] = vec3(lessThan(depthKernel[2], shadowZ ));\nshadowKernel[2] *= vec3(0.25);\nvec2 fractionalCoord = 1.0 - fract( shadowCoord.xy * shadowMapSize[i].xy );\nshadowKernel[0] = mix( shadowKernel[1], shadowKernel[0], fractionalCoord.x );\nshadowKernel[1] = mix( shadowKernel[2], shadowKernel[1], fractionalCoord.x );\nvec4 shadowValues;\nshadowValues.x = mix( shadowKernel[0][1], shadowKernel[0][0], fractionalCoord.y );\nshadowValues.y = mix( shadowKernel[0][2], shadowKernel[0][1], fractionalCoord.y );\nshadowValues.z = mix( shadowKernel[1][1], shadowKernel[1][0], fractionalCoord.y );\nshadowValues.w = mix( shadowKernel[1][2], shadowKernel[1][1], fractionalCoord.y );\nshadow = dot( shadowValues, vec4( 1.0 ) );\nshadowColor = shadowColor * vec3( ( 1.0 - shadowDarkness[ i ] * shadow ) );\n#else\nvec4 rgbaDepth = texture2D( shadowMap[ i ], shadowCoord.xy );\nfloat fDepth = unpackDepth( rgbaDepth );\nif ( fDepth < shadowCoord.z )\nshadowColor = shadowColor * vec3( 1.0 - shadowDarkness[ i ] );\n#endif\n}\n#ifdef SHADOWMAP_DEBUG\n#ifdef SHADOWMAP_CASCADE\nif ( inFrustum && inFrustumCount == 1 ) gl_FragColor.xyz *= frustumColors[ i ];\n#else\nif ( inFrustum ) gl_FragColor.xyz *= frustumColors[ i ];\n#endif\n#endif\n}\n#ifdef GAMMA_OUTPUT\nshadowColor *= shadowColor;\n#endif\ngl_FragColor.xyz = gl_FragColor.xyz * shadowColor;\n#endif',shadowmap_pars_vertex:'#ifdef USE_SHADOWMAP\nvarying vec4 vShadowCoord[ MAX_SHADOWS ];\nuniform mat4 shadowMatrix[ MAX_SHADOWS ];\n#endif',shadowmap_vertex:'#ifdef USE_SHADOWMAP\nfor( int i = 0; i < MAX_SHADOWS; i ++ ) {\nvShadowCoord[ i ] = shadowMatrix[ i ] * worldPosition;\n}\n#endif',alphatest_fragment:'#ifdef ALPHATEST\nif ( gl_FragColor.a < ALPHATEST ) discard;\n#endif',linear_to_gamma_fragment:'#ifdef GAMMA_OUTPUT\ngl_FragColor.xyz = sqrt( gl_FragColor.xyz );\n#endif'},THREE.UniformsUtils={merge:function merge(uniforms){var merged={},u,p,tmp;for(u=0;u<uniforms.length;u++)for(p in tmp=this.clone(uniforms[u]),tmp)merged[p]=tmp[p];return merged},clone:function clone(uniforms_src){var uniforms_dst={},u,p,parameter_src;for(u in uniforms_src)for(p in uniforms_dst[u]={},uniforms_src[u])parameter_src=uniforms_src[u][p],uniforms_dst[u][p]=parameter_src instanceof THREE.Color||parameter_src instanceof THREE.Vector2||parameter_src instanceof THREE.Vector3||parameter_src instanceof THREE.Vector4||parameter_src instanceof THREE.Matrix4||parameter_src instanceof THREE.Texture?parameter_src.clone():parameter_src instanceof Array?parameter_src.slice():parameter_src;return uniforms_dst}},THREE.UniformsLib={common:{diffuse:{type:'c',value:new THREE.Color(15658734)},opacity:{type:'f',value:1},map:{type:'t',value:null},offsetRepeat:{type:'v4',value:new THREE.Vector4(0,0,1,1)},lightMap:{type:'t',value:null},specularMap:{type:'t',value:null},envMap:{type:'t',value:null},flipEnvMap:{type:'f',value:-1},useRefract:{type:'i',value:0},reflectivity:{type:'f',value:1},refractionRatio:{type:'f',value:.98},combine:{type:'i',value:0},morphTargetInfluences:{type:'f',value:0}},bump:{bumpMap:{type:'t',value:null},bumpScale:{type:'f',value:1}},normalmap:{normalMap:{type:'t',value:null},normalScale:{type:'v2',value:new THREE.Vector2(1,1)}},fog:{fogDensity:{type:'f',value:25e-5},fogNear:{type:'f',value:1},fogFar:{type:'f',value:2e3},fogColor:{type:'c',value:new THREE.Color(16777215)}},lights:{ambientLightColor:{type:'fv',value:[]},directionalLightDirection:{type:'fv',value:[]},directionalLightColor:{type:'fv',value:[]},hemisphereLightDirection:{type:'fv',value:[]},hemisphereLightSkyColor:{type:'fv',value:[]},hemisphereLightGroundColor:{type:'fv',value:[]},pointLightColor:{type:'fv',value:[]},pointLightPosition:{type:'fv',value:[]},pointLightDistance:{type:'fv1',value:[]},spotLightColor:{type:'fv',value:[]},spotLightPosition:{type:'fv',value:[]},spotLightDirection:{type:'fv',value:[]},spotLightDistance:{type:'fv1',value:[]},spotLightAngleCos:{type:'fv1',value:[]},spotLightExponent:{type:'fv1',value:[]}},particle:{psColor:{type:'c',value:new THREE.Color(15658734)},opacity:{type:'f',value:1},size:{type:'f',value:1},scale:{type:'f',value:1},map:{type:'t',value:null},fogDensity:{type:'f',value:25e-5},fogNear:{type:'f',value:1},fogFar:{type:'f',value:2e3},fogColor:{type:'c',value:new THREE.Color(16777215)}},shadowmap:{shadowMap:{type:'tv',value:[]},shadowMapSize:{type:'v2v',value:[]},shadowBias:{type:'fv1',value:[]},shadowDarkness:{type:'fv1',value:[]},shadowMatrix:{type:'m4v',value:[]}}},THREE.ShaderLib={basic:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.fog,THREE.UniformsLib.shadowmap]),vertexShader:[THREE.ShaderChunk.map_pars_vertex,THREE.ShaderChunk.lightmap_pars_vertex,THREE.ShaderChunk.envmap_pars_vertex,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,'void main() {',THREE.ShaderChunk.map_vertex,THREE.ShaderChunk.lightmap_vertex,THREE.ShaderChunk.color_vertex,THREE.ShaderChunk.skinbase_vertex,'#ifdef USE_ENVMAP',THREE.ShaderChunk.morphnormal_vertex,THREE.ShaderChunk.skinnormal_vertex,THREE.ShaderChunk.defaultnormal_vertex,'#endif',THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.default_vertex,THREE.ShaderChunk.worldpos_vertex,THREE.ShaderChunk.envmap_vertex,THREE.ShaderChunk.shadowmap_vertex,'}'].join('\n'),fragmentShader:['uniform vec3 diffuse;','uniform float opacity;',THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.map_pars_fragment,THREE.ShaderChunk.lightmap_pars_fragment,THREE.ShaderChunk.envmap_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,THREE.ShaderChunk.specularmap_pars_fragment,'void main() {','gl_FragColor = vec4( diffuse, opacity );',THREE.ShaderChunk.map_fragment,THREE.ShaderChunk.alphatest_fragment,THREE.ShaderChunk.specularmap_fragment,THREE.ShaderChunk.lightmap_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.envmap_fragment,THREE.ShaderChunk.shadowmap_fragment,THREE.ShaderChunk.linear_to_gamma_fragment,THREE.ShaderChunk.fog_fragment,'}'].join('\n')},lambert:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.fog,THREE.UniformsLib.lights,THREE.UniformsLib.shadowmap,{ambient:{type:'c',value:new THREE.Color(16777215)},emissive:{type:'c',value:new THREE.Color(0)},wrapRGB:{type:'v3',value:new THREE.Vector3(1,1,1)}}]),vertexShader:['#define LAMBERT','varying vec3 vLightFront;','#ifdef DOUBLE_SIDED','varying vec3 vLightBack;','#endif',THREE.ShaderChunk.map_pars_vertex,THREE.ShaderChunk.lightmap_pars_vertex,THREE.ShaderChunk.envmap_pars_vertex,THREE.ShaderChunk.lights_lambert_pars_vertex,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,'void main() {',THREE.ShaderChunk.map_vertex,THREE.ShaderChunk.lightmap_vertex,THREE.ShaderChunk.color_vertex,THREE.ShaderChunk.morphnormal_vertex,THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.skinnormal_vertex,THREE.ShaderChunk.defaultnormal_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.default_vertex,THREE.ShaderChunk.worldpos_vertex,THREE.ShaderChunk.envmap_vertex,THREE.ShaderChunk.lights_lambert_vertex,THREE.ShaderChunk.shadowmap_vertex,'}'].join('\n'),fragmentShader:['uniform float opacity;','varying vec3 vLightFront;','#ifdef DOUBLE_SIDED','varying vec3 vLightBack;','#endif',THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.map_pars_fragment,THREE.ShaderChunk.lightmap_pars_fragment,THREE.ShaderChunk.envmap_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,THREE.ShaderChunk.specularmap_pars_fragment,'void main() {','gl_FragColor = vec4( vec3 ( 1.0 ), opacity );',THREE.ShaderChunk.map_fragment,THREE.ShaderChunk.alphatest_fragment,THREE.ShaderChunk.specularmap_fragment,'#ifdef DOUBLE_SIDED','if ( gl_FrontFacing )','gl_FragColor.xyz *= vLightFront;','else','gl_FragColor.xyz *= vLightBack;','#else','gl_FragColor.xyz *= vLightFront;','#endif',THREE.ShaderChunk.lightmap_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.envmap_fragment,THREE.ShaderChunk.shadowmap_fragment,THREE.ShaderChunk.linear_to_gamma_fragment,THREE.ShaderChunk.fog_fragment,'}'].join('\n')},phong:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.bump,THREE.UniformsLib.normalmap,THREE.UniformsLib.fog,THREE.UniformsLib.lights,THREE.UniformsLib.shadowmap,{ambient:{type:'c',value:new THREE.Color(16777215)},emissive:{type:'c',value:new THREE.Color(0)},specular:{type:'c',value:new THREE.Color(1118481)},shininess:{type:'f',value:30},wrapRGB:{type:'v3',value:new THREE.Vector3(1,1,1)}}]),vertexShader:['#define PHONG','varying vec3 vViewPosition;','varying vec3 vNormal;',THREE.ShaderChunk.map_pars_vertex,THREE.ShaderChunk.lightmap_pars_vertex,THREE.ShaderChunk.envmap_pars_vertex,THREE.ShaderChunk.lights_phong_pars_vertex,THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,'void main() {',THREE.ShaderChunk.map_vertex,THREE.ShaderChunk.lightmap_vertex,THREE.ShaderChunk.color_vertex,THREE.ShaderChunk.morphnormal_vertex,THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.skinnormal_vertex,THREE.ShaderChunk.defaultnormal_vertex,'vNormal = normalize( transformedNormal );',THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.default_vertex,'vViewPosition = -mvPosition.xyz;',THREE.ShaderChunk.worldpos_vertex,THREE.ShaderChunk.envmap_vertex,THREE.ShaderChunk.lights_phong_vertex,THREE.ShaderChunk.shadowmap_vertex,'}'].join('\n'),fragmentShader:['uniform vec3 diffuse;','uniform float opacity;','uniform vec3 ambient;','uniform vec3 emissive;','uniform vec3 specular;','uniform float shininess;',THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.map_pars_fragment,THREE.ShaderChunk.lightmap_pars_fragment,THREE.ShaderChunk.envmap_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.lights_phong_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,THREE.ShaderChunk.bumpmap_pars_fragment,THREE.ShaderChunk.normalmap_pars_fragment,THREE.ShaderChunk.specularmap_pars_fragment,'void main() {','gl_FragColor = vec4( vec3 ( 1.0 ), opacity );',THREE.ShaderChunk.map_fragment,THREE.ShaderChunk.alphatest_fragment,THREE.ShaderChunk.specularmap_fragment,THREE.ShaderChunk.lights_phong_fragment,THREE.ShaderChunk.lightmap_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.envmap_fragment,THREE.ShaderChunk.shadowmap_fragment,THREE.ShaderChunk.linear_to_gamma_fragment,THREE.ShaderChunk.fog_fragment,'}'].join('\n')},particle_basic:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.particle,THREE.UniformsLib.shadowmap]),vertexShader:['uniform float size;','uniform float scale;',THREE.ShaderChunk.color_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,'void main() {',THREE.ShaderChunk.color_vertex,'vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );','#ifdef USE_SIZEATTENUATION','gl_PointSize = size * ( scale / length( mvPosition.xyz ) );','#else','gl_PointSize = size;','#endif','gl_Position = projectionMatrix * mvPosition;',THREE.ShaderChunk.worldpos_vertex,THREE.ShaderChunk.shadowmap_vertex,'}'].join('\n'),fragmentShader:['uniform vec3 psColor;','uniform float opacity;',THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.map_particle_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,THREE.ShaderChunk.shadowmap_pars_fragment,'void main() {','gl_FragColor = vec4( psColor, opacity );',THREE.ShaderChunk.map_particle_fragment,THREE.ShaderChunk.alphatest_fragment,THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.shadowmap_fragment,THREE.ShaderChunk.fog_fragment,'}'].join('\n')},dashed:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.common,THREE.UniformsLib.fog,{scale:{type:'f',value:1},dashSize:{type:'f',value:1},totalSize:{type:'f',value:2}}]),vertexShader:['uniform float scale;','attribute float lineDistance;','varying float vLineDistance;',THREE.ShaderChunk.color_pars_vertex,'void main() {',THREE.ShaderChunk.color_vertex,'vLineDistance = scale * lineDistance;','vec4 mvPosition = modelViewMatrix * vec4( position, 1.0 );','gl_Position = projectionMatrix * mvPosition;','}'].join('\n'),fragmentShader:['uniform vec3 diffuse;','uniform float opacity;','uniform float dashSize;','uniform float totalSize;','varying float vLineDistance;',THREE.ShaderChunk.color_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,'void main() {','if ( mod( vLineDistance, totalSize ) > dashSize ) {','discard;','}','gl_FragColor = vec4( diffuse, opacity );',THREE.ShaderChunk.color_fragment,THREE.ShaderChunk.fog_fragment,'}'].join('\n')},depth:{uniforms:{mNear:{type:'f',value:1},mFar:{type:'f',value:2e3},opacity:{type:'f',value:1}},vertexShader:'void main() {\ngl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}',fragmentShader:'uniform float mNear;\nuniform float mFar;\nuniform float opacity;\nvoid main() {\nfloat depth = gl_FragCoord.z / gl_FragCoord.w;\nfloat color = 1.0 - smoothstep( mNear, mFar, depth );\ngl_FragColor = vec4( vec3( color ), opacity );\n}'},normal:{uniforms:{opacity:{type:'f',value:1}},vertexShader:['varying vec3 vNormal;',THREE.ShaderChunk.morphtarget_pars_vertex,'void main() {','vNormal = normalize( normalMatrix * normal );',THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.default_vertex,'}'].join('\n'),fragmentShader:'uniform float opacity;\nvarying vec3 vNormal;\nvoid main() {\ngl_FragColor = vec4( 0.5 * normalize( vNormal ) + 0.5, opacity );\n}'},normalmap:{uniforms:THREE.UniformsUtils.merge([THREE.UniformsLib.fog,THREE.UniformsLib.lights,THREE.UniformsLib.shadowmap,{enableAO:{type:'i',value:0},enableDiffuse:{type:'i',value:0},enableSpecular:{type:'i',value:0},enableReflection:{type:'i',value:0},enableDisplacement:{type:'i',value:0},tDisplacement:{type:'t',value:null},tDiffuse:{type:'t',value:null},tCube:{type:'t',value:null},tNormal:{type:'t',value:null},tSpecular:{type:'t',value:null},tAO:{type:'t',value:null},uNormalScale:{type:'v2',value:new THREE.Vector2(1,1)},uDisplacementBias:{type:'f',value:0},uDisplacementScale:{type:'f',value:1},uDiffuseColor:{type:'c',value:new THREE.Color(16777215)},uSpecularColor:{type:'c',value:new THREE.Color(1118481)},uAmbientColor:{type:'c',value:new THREE.Color(16777215)},uShininess:{type:'f',value:30},uOpacity:{type:'f',value:1},useRefract:{type:'i',value:0},uRefractionRatio:{type:'f',value:.98},uReflectivity:{type:'f',value:.5},uOffset:{type:'v2',value:new THREE.Vector2(0,0)},uRepeat:{type:'v2',value:new THREE.Vector2(1,1)},wrapRGB:{type:'v3',value:new THREE.Vector3(1,1,1)}}]),fragmentShader:['uniform vec3 uAmbientColor;','uniform vec3 uDiffuseColor;','uniform vec3 uSpecularColor;','uniform float uShininess;','uniform float uOpacity;','uniform bool enableDiffuse;','uniform bool enableSpecular;','uniform bool enableAO;','uniform bool enableReflection;','uniform sampler2D tDiffuse;','uniform sampler2D tNormal;','uniform sampler2D tSpecular;','uniform sampler2D tAO;','uniform samplerCube tCube;','uniform vec2 uNormalScale;','uniform bool useRefract;','uniform float uRefractionRatio;','uniform float uReflectivity;','varying vec3 vTangent;','varying vec3 vBinormal;','varying vec3 vNormal;','varying vec2 vUv;','uniform vec3 ambientLightColor;','#if MAX_DIR_LIGHTS > 0','uniform vec3 directionalLightColor[ MAX_DIR_LIGHTS ];','uniform vec3 directionalLightDirection[ MAX_DIR_LIGHTS ];','#endif','#if MAX_HEMI_LIGHTS > 0','uniform vec3 hemisphereLightSkyColor[ MAX_HEMI_LIGHTS ];','uniform vec3 hemisphereLightGroundColor[ MAX_HEMI_LIGHTS ];','uniform vec3 hemisphereLightDirection[ MAX_HEMI_LIGHTS ];','#endif','#if MAX_POINT_LIGHTS > 0','uniform vec3 pointLightColor[ MAX_POINT_LIGHTS ];','uniform vec3 pointLightPosition[ MAX_POINT_LIGHTS ];','uniform float pointLightDistance[ MAX_POINT_LIGHTS ];','#endif','#if MAX_SPOT_LIGHTS > 0','uniform vec3 spotLightColor[ MAX_SPOT_LIGHTS ];','uniform vec3 spotLightPosition[ MAX_SPOT_LIGHTS ];','uniform vec3 spotLightDirection[ MAX_SPOT_LIGHTS ];','uniform float spotLightAngleCos[ MAX_SPOT_LIGHTS ];','uniform float spotLightExponent[ MAX_SPOT_LIGHTS ];','uniform float spotLightDistance[ MAX_SPOT_LIGHTS ];','#endif','#ifdef WRAP_AROUND','uniform vec3 wrapRGB;','#endif','varying vec3 vWorldPosition;','varying vec3 vViewPosition;',THREE.ShaderChunk.shadowmap_pars_fragment,THREE.ShaderChunk.fog_pars_fragment,'void main() {','gl_FragColor = vec4( vec3( 1.0 ), uOpacity );','vec3 specularTex = vec3( 1.0 );','vec3 normalTex = texture2D( tNormal, vUv ).xyz * 2.0 - 1.0;','normalTex.xy *= uNormalScale;','normalTex = normalize( normalTex );','if( enableDiffuse ) {','#ifdef GAMMA_INPUT','vec4 texelColor = texture2D( tDiffuse, vUv );','texelColor.xyz *= texelColor.xyz;','gl_FragColor = gl_FragColor * texelColor;','#else','gl_FragColor = gl_FragColor * texture2D( tDiffuse, vUv );','#endif','}','if( enableAO ) {','#ifdef GAMMA_INPUT','vec4 aoColor = texture2D( tAO, vUv );','aoColor.xyz *= aoColor.xyz;','gl_FragColor.xyz = gl_FragColor.xyz * aoColor.xyz;','#else','gl_FragColor.xyz = gl_FragColor.xyz * texture2D( tAO, vUv ).xyz;','#endif','}','if( enableSpecular )','specularTex = texture2D( tSpecular, vUv ).xyz;','mat3 tsb = mat3( normalize( vTangent ), normalize( vBinormal ), normalize( vNormal ) );','vec3 finalNormal = tsb * normalTex;','#ifdef FLIP_SIDED','finalNormal = -finalNormal;','#endif','vec3 normal = normalize( finalNormal );','vec3 viewPosition = normalize( vViewPosition );','#if MAX_POINT_LIGHTS > 0','vec3 pointDiffuse = vec3( 0.0 );','vec3 pointSpecular = vec3( 0.0 );','for ( int i = 0; i < MAX_POINT_LIGHTS; i ++ ) {','vec4 lPosition = viewMatrix * vec4( pointLightPosition[ i ], 1.0 );','vec3 pointVector = lPosition.xyz + vViewPosition.xyz;','float pointDistance = 1.0;','if ( pointLightDistance[ i ] > 0.0 )','pointDistance = 1.0 - min( ( length( pointVector ) / pointLightDistance[ i ] ), 1.0 );','pointVector = normalize( pointVector );','#ifdef WRAP_AROUND','float pointDiffuseWeightFull = max( dot( normal, pointVector ), 0.0 );','float pointDiffuseWeightHalf = max( 0.5 * dot( normal, pointVector ) + 0.5, 0.0 );','vec3 pointDiffuseWeight = mix( vec3 ( pointDiffuseWeightFull ), vec3( pointDiffuseWeightHalf ), wrapRGB );','#else','float pointDiffuseWeight = max( dot( normal, pointVector ), 0.0 );','#endif','pointDiffuse += pointDistance * pointLightColor[ i ] * uDiffuseColor * pointDiffuseWeight;','vec3 pointHalfVector = normalize( pointVector + viewPosition );','float pointDotNormalHalf = max( dot( normal, pointHalfVector ), 0.0 );','float pointSpecularWeight = specularTex.r * max( pow( pointDotNormalHalf, uShininess ), 0.0 );','#ifdef PHYSICALLY_BASED_SHADING','float specularNormalization = ( uShininess + 2.0001 ) / 8.0;','vec3 schlick = uSpecularColor + vec3( 1.0 - uSpecularColor ) * pow( 1.0 - dot( pointVector, pointHalfVector ), 5.0 );','pointSpecular += schlick * pointLightColor[ i ] * pointSpecularWeight * pointDiffuseWeight * pointDistance * specularNormalization;','#else','pointSpecular += pointDistance * pointLightColor[ i ] * uSpecularColor * pointSpecularWeight * pointDiffuseWeight;','#endif','}','#endif','#if MAX_SPOT_LIGHTS > 0','vec3 spotDiffuse = vec3( 0.0 );','vec3 spotSpecular = vec3( 0.0 );','for ( int i = 0; i < MAX_SPOT_LIGHTS; i ++ ) {','vec4 lPosition = viewMatrix * vec4( spotLightPosition[ i ], 1.0 );','vec3 spotVector = lPosition.xyz + vViewPosition.xyz;','float spotDistance = 1.0;','if ( spotLightDistance[ i ] > 0.0 )','spotDistance = 1.0 - min( ( length( spotVector ) / spotLightDistance[ i ] ), 1.0 );','spotVector = normalize( spotVector );','float spotEffect = dot( spotLightDirection[ i ], normalize( spotLightPosition[ i ] - vWorldPosition ) );','if ( spotEffect > spotLightAngleCos[ i ] ) {','spotEffect = max( pow( spotEffect, spotLightExponent[ i ] ), 0.0 );','#ifdef WRAP_AROUND','float spotDiffuseWeightFull = max( dot( normal, spotVector ), 0.0 );','float spotDiffuseWeightHalf = max( 0.5 * dot( normal, spotVector ) + 0.5, 0.0 );','vec3 spotDiffuseWeight = mix( vec3 ( spotDiffuseWeightFull ), vec3( spotDiffuseWeightHalf ), wrapRGB );','#else','float spotDiffuseWeight = max( dot( normal, spotVector ), 0.0 );','#endif','spotDiffuse += spotDistance * spotLightColor[ i ] * uDiffuseColor * spotDiffuseWeight * spotEffect;','vec3 spotHalfVector = normalize( spotVector + viewPosition );','float spotDotNormalHalf = max( dot( normal, spotHalfVector ), 0.0 );','float spotSpecularWeight = specularTex.r * max( pow( spotDotNormalHalf, uShininess ), 0.0 );','#ifdef PHYSICALLY_BASED_SHADING','float specularNormalization = ( uShininess + 2.0001 ) / 8.0;','vec3 schlick = uSpecularColor + vec3( 1.0 - uSpecularColor ) * pow( 1.0 - dot( spotVector, spotHalfVector ), 5.0 );','spotSpecular += schlick * spotLightColor[ i ] * spotSpecularWeight * spotDiffuseWeight * spotDistance * specularNormalization * spotEffect;','#else','spotSpecular += spotDistance * spotLightColor[ i ] * uSpecularColor * spotSpecularWeight * spotDiffuseWeight * spotEffect;','#endif','}','}','#endif','#if MAX_DIR_LIGHTS > 0','vec3 dirDiffuse = vec3( 0.0 );','vec3 dirSpecular = vec3( 0.0 );','for( int i = 0; i < MAX_DIR_LIGHTS; i++ ) {','vec4 lDirection = viewMatrix * vec4( directionalLightDirection[ i ], 0.0 );','vec3 dirVector = normalize( lDirection.xyz );','#ifdef WRAP_AROUND','float directionalLightWeightingFull = max( dot( normal, dirVector ), 0.0 );','float directionalLightWeightingHalf = max( 0.5 * dot( normal, dirVector ) + 0.5, 0.0 );','vec3 dirDiffuseWeight = mix( vec3( directionalLightWeightingFull ), vec3( directionalLightWeightingHalf ), wrapRGB );','#else','float dirDiffuseWeight = max( dot( normal, dirVector ), 0.0 );','#endif','dirDiffuse += directionalLightColor[ i ] * uDiffuseColor * dirDiffuseWeight;','vec3 dirHalfVector = normalize( dirVector + viewPosition );','float dirDotNormalHalf = max( dot( normal, dirHalfVector ), 0.0 );','float dirSpecularWeight = specularTex.r * max( pow( dirDotNormalHalf, uShininess ), 0.0 );','#ifdef PHYSICALLY_BASED_SHADING','float specularNormalization = ( uShininess + 2.0001 ) / 8.0;','vec3 schlick = uSpecularColor + vec3( 1.0 - uSpecularColor ) * pow( 1.0 - dot( dirVector, dirHalfVector ), 5.0 );','dirSpecular += schlick * directionalLightColor[ i ] * dirSpecularWeight * dirDiffuseWeight * specularNormalization;','#else','dirSpecular += directionalLightColor[ i ] * uSpecularColor * dirSpecularWeight * dirDiffuseWeight;','#endif','}','#endif','#if MAX_HEMI_LIGHTS > 0','vec3 hemiDiffuse  = vec3( 0.0 );','vec3 hemiSpecular = vec3( 0.0 );','for( int i = 0; i < MAX_HEMI_LIGHTS; i ++ ) {','vec4 lDirection = viewMatrix * vec4( hemisphereLightDirection[ i ], 0.0 );','vec3 lVector = normalize( lDirection.xyz );','float dotProduct = dot( normal, lVector );','float hemiDiffuseWeight = 0.5 * dotProduct + 0.5;','vec3 hemiColor = mix( hemisphereLightGroundColor[ i ], hemisphereLightSkyColor[ i ], hemiDiffuseWeight );','hemiDiffuse += uDiffuseColor * hemiColor;','vec3 hemiHalfVectorSky = normalize( lVector + viewPosition );','float hemiDotNormalHalfSky = 0.5 * dot( normal, hemiHalfVectorSky ) + 0.5;','float hemiSpecularWeightSky = specularTex.r * max( pow( hemiDotNormalHalfSky, uShininess ), 0.0 );','vec3 lVectorGround = -lVector;','vec3 hemiHalfVectorGround = normalize( lVectorGround + viewPosition );','float hemiDotNormalHalfGround = 0.5 * dot( normal, hemiHalfVectorGround ) + 0.5;','float hemiSpecularWeightGround = specularTex.r * max( pow( hemiDotNormalHalfGround, uShininess ), 0.0 );','#ifdef PHYSICALLY_BASED_SHADING','float dotProductGround = dot( normal, lVectorGround );','float specularNormalization = ( uShininess + 2.0001 ) / 8.0;','vec3 schlickSky = uSpecularColor + vec3( 1.0 - uSpecularColor ) * pow( 1.0 - dot( lVector, hemiHalfVectorSky ), 5.0 );','vec3 schlickGround = uSpecularColor + vec3( 1.0 - uSpecularColor ) * pow( 1.0 - dot( lVectorGround, hemiHalfVectorGround ), 5.0 );','hemiSpecular += hemiColor * specularNormalization * ( schlickSky * hemiSpecularWeightSky * max( dotProduct, 0.0 ) + schlickGround * hemiSpecularWeightGround * max( dotProductGround, 0.0 ) );','#else','hemiSpecular += uSpecularColor * hemiColor * ( hemiSpecularWeightSky + hemiSpecularWeightGround ) * hemiDiffuseWeight;','#endif','}','#endif','vec3 totalDiffuse = vec3( 0.0 );','vec3 totalSpecular = vec3( 0.0 );','#if MAX_DIR_LIGHTS > 0','totalDiffuse += dirDiffuse;','totalSpecular += dirSpecular;','#endif','#if MAX_HEMI_LIGHTS > 0','totalDiffuse += hemiDiffuse;','totalSpecular += hemiSpecular;','#endif','#if MAX_POINT_LIGHTS > 0','totalDiffuse += pointDiffuse;','totalSpecular += pointSpecular;','#endif','#if MAX_SPOT_LIGHTS > 0','totalDiffuse += spotDiffuse;','totalSpecular += spotSpecular;','#endif','#ifdef METAL','gl_FragColor.xyz = gl_FragColor.xyz * ( totalDiffuse + ambientLightColor * uAmbientColor + totalSpecular );','#else','gl_FragColor.xyz = gl_FragColor.xyz * ( totalDiffuse + ambientLightColor * uAmbientColor ) + totalSpecular;','#endif','if ( enableReflection ) {','vec3 vReflect;','vec3 cameraToVertex = normalize( vWorldPosition - cameraPosition );','if ( useRefract ) {','vReflect = refract( cameraToVertex, normal, uRefractionRatio );','} else {','vReflect = reflect( cameraToVertex, normal );','}','vec4 cubeColor = textureCube( tCube, vec3( -vReflect.x, vReflect.yz ) );','#ifdef GAMMA_INPUT','cubeColor.xyz *= cubeColor.xyz;','#endif','gl_FragColor.xyz = mix( gl_FragColor.xyz, cubeColor.xyz, specularTex.r * uReflectivity );','}',THREE.ShaderChunk.shadowmap_fragment,THREE.ShaderChunk.linear_to_gamma_fragment,THREE.ShaderChunk.fog_fragment,'}'].join('\n'),vertexShader:['attribute vec4 tangent;','uniform vec2 uOffset;','uniform vec2 uRepeat;','uniform bool enableDisplacement;','#ifdef VERTEX_TEXTURES','uniform sampler2D tDisplacement;','uniform float uDisplacementScale;','uniform float uDisplacementBias;','#endif','varying vec3 vTangent;','varying vec3 vBinormal;','varying vec3 vNormal;','varying vec2 vUv;','varying vec3 vWorldPosition;','varying vec3 vViewPosition;',THREE.ShaderChunk.skinning_pars_vertex,THREE.ShaderChunk.shadowmap_pars_vertex,'void main() {',THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.skinnormal_vertex,'#ifdef USE_SKINNING','vNormal = normalize( normalMatrix * skinnedNormal.xyz );','vec4 skinnedTangent = skinMatrix * vec4( tangent.xyz, 0.0 );','vTangent = normalize( normalMatrix * skinnedTangent.xyz );','#else','vNormal = normalize( normalMatrix * normal );','vTangent = normalize( normalMatrix * tangent.xyz );','#endif','vBinormal = normalize( cross( vNormal, vTangent ) * tangent.w );','vUv = uv * uRepeat + uOffset;','vec3 displacedPosition;','#ifdef VERTEX_TEXTURES','if ( enableDisplacement ) {','vec3 dv = texture2D( tDisplacement, uv ).xyz;','float df = uDisplacementScale * dv.x + uDisplacementBias;','displacedPosition = position + normalize( normal ) * df;','} else {','#ifdef USE_SKINNING','vec4 skinVertex = vec4( position, 1.0 );','vec4 skinned  = boneMatX * skinVertex * skinWeight.x;','skinned \t  += boneMatY * skinVertex * skinWeight.y;','displacedPosition  = skinned.xyz;','#else','displacedPosition = position;','#endif','}','#else','#ifdef USE_SKINNING','vec4 skinVertex = vec4( position, 1.0 );','vec4 skinned  = boneMatX * skinVertex * skinWeight.x;','skinned \t  += boneMatY * skinVertex * skinWeight.y;','displacedPosition  = skinned.xyz;','#else','displacedPosition = position;','#endif','#endif','vec4 mvPosition = modelViewMatrix * vec4( displacedPosition, 1.0 );','vec4 worldPosition = modelMatrix * vec4( displacedPosition, 1.0 );','gl_Position = projectionMatrix * mvPosition;','vWorldPosition = worldPosition.xyz;','vViewPosition = -mvPosition.xyz;','#ifdef USE_SHADOWMAP','for( int i = 0; i < MAX_SHADOWS; i ++ ) {','vShadowCoord[ i ] = shadowMatrix[ i ] * worldPosition;','}','#endif','}'].join('\n')},cube:{uniforms:{tCube:{type:'t',value:null},tFlip:{type:'f',value:-1}},vertexShader:'varying vec3 vWorldPosition;\nvoid main() {\nvec4 worldPosition = modelMatrix * vec4( position, 1.0 );\nvWorldPosition = worldPosition.xyz;\ngl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}',fragmentShader:'uniform samplerCube tCube;\nuniform float tFlip;\nvarying vec3 vWorldPosition;\nvoid main() {\ngl_FragColor = textureCube( tCube, vec3( tFlip * vWorldPosition.x, vWorldPosition.yz ) );\n}'},depthRGBA:{uniforms:{},vertexShader:[THREE.ShaderChunk.morphtarget_pars_vertex,THREE.ShaderChunk.skinning_pars_vertex,'void main() {',THREE.ShaderChunk.skinbase_vertex,THREE.ShaderChunk.morphtarget_vertex,THREE.ShaderChunk.skinning_vertex,THREE.ShaderChunk.default_vertex,'}'].join('\n'),fragmentShader:'vec4 pack_depth( const in float depth ) {\nconst vec4 bit_shift = vec4( 256.0 * 256.0 * 256.0, 256.0 * 256.0, 256.0, 1.0 );\nconst vec4 bit_mask  = vec4( 0.0, 1.0 / 256.0, 1.0 / 256.0, 1.0 / 256.0 );\nvec4 res = fract( depth * bit_shift );\nres -= res.xxyz * bit_mask;\nreturn res;\n}\nvoid main() {\ngl_FragData[ 0 ] = pack_depth( gl_FragCoord.z );\n}'}},THREE.WebGLRenderer=function(parameters){function createParticleBuffers(geometry){geometry.__webglVertexBuffer=_gl.createBuffer(),geometry.__webglColorBuffer=_gl.createBuffer(),_this.info.memory.geometries++}function createLineBuffers(geometry){geometry.__webglVertexBuffer=_gl.createBuffer(),geometry.__webglColorBuffer=_gl.createBuffer(),geometry.__webglLineDistanceBuffer=_gl.createBuffer(),_this.info.memory.geometries++}function createRibbonBuffers(geometry){geometry.__webglVertexBuffer=_gl.createBuffer(),geometry.__webglColorBuffer=_gl.createBuffer(),geometry.__webglNormalBuffer=_gl.createBuffer(),_this.info.memory.geometries++}function createMeshBuffers(geometryGroup){geometryGroup.__webglVertexBuffer=_gl.createBuffer(),geometryGroup.__webglNormalBuffer=_gl.createBuffer(),geometryGroup.__webglTangentBuffer=_gl.createBuffer(),geometryGroup.__webglColorBuffer=_gl.createBuffer(),geometryGroup.__webglUVBuffer=_gl.createBuffer(),geometryGroup.__webglUV2Buffer=_gl.createBuffer(),geometryGroup.__webglSkinIndicesBuffer=_gl.createBuffer(),geometryGroup.__webglSkinWeightsBuffer=_gl.createBuffer(),geometryGroup.__webglFaceBuffer=_gl.createBuffer(),geometryGroup.__webglLineBuffer=_gl.createBuffer();var m,ml;if(geometryGroup.numMorphTargets)for(geometryGroup.__webglMorphTargetsBuffers=[],m=0,ml=geometryGroup.numMorphTargets;m<ml;m++)geometryGroup.__webglMorphTargetsBuffers.push(_gl.createBuffer());if(geometryGroup.numMorphNormals)for(geometryGroup.__webglMorphNormalsBuffers=[],m=0,ml=geometryGroup.numMorphNormals;m<ml;m++)geometryGroup.__webglMorphNormalsBuffers.push(_gl.createBuffer());_this.info.memory.geometries++}function initCustomAttributes(geometry,object){var nvertices=geometry.vertices.length,material=object.material;if(material.attributes)for(var a in void 0===geometry.__webglCustomAttributesList&&(geometry.__webglCustomAttributesList=[]),material.attributes){var attribute=material.attributes[a];if(!attribute.__webglInitialized||attribute.createUniqueBuffers){attribute.__webglInitialized=!0;var size=1;'v2'===attribute.type?size=2:'v3'===attribute.type?size=3:'v4'===attribute.type?size=4:'c'===attribute.type&&(size=3),attribute.size=size,attribute.array=new Float32Array(nvertices*size),attribute.buffer=_gl.createBuffer(),attribute.buffer.belongsToAttribute=a,attribute.needsUpdate=!0}geometry.__webglCustomAttributesList.push(attribute)}}function initParticleBuffers(geometry,object){var nvertices=geometry.vertices.length;geometry.__vertexArray=new Float32Array(3*nvertices),geometry.__colorArray=new Float32Array(3*nvertices),geometry.__sortArray=[],geometry.__webglParticleCount=nvertices,initCustomAttributes(geometry,object)}function initLineBuffers(geometry,object){var nvertices=geometry.vertices.length;geometry.__vertexArray=new Float32Array(3*nvertices),geometry.__colorArray=new Float32Array(3*nvertices),geometry.__lineDistanceArray=new Float32Array(1*nvertices),geometry.__webglLineCount=nvertices,initCustomAttributes(geometry,object)}function initRibbonBuffers(geometry,object){var nvertices=geometry.vertices.length;geometry.__vertexArray=new Float32Array(3*nvertices),geometry.__colorArray=new Float32Array(3*nvertices),geometry.__normalArray=new Float32Array(3*nvertices),geometry.__webglVertexCount=nvertices,initCustomAttributes(geometry,object)}function initMeshBuffers(geometryGroup,object){var geometry=object.geometry,faces3=geometryGroup.faces3,nvertices=3*faces3.length,ntris=1*faces3.length,nlines=3*faces3.length,material=getBufferMaterial(object,geometryGroup),uvType=bufferGuessUVType(material),normalType=bufferGuessNormalType(material),vertexColorType=bufferGuessVertexColorType(material);geometryGroup.__vertexArray=new Float32Array(3*nvertices),normalType&&(geometryGroup.__normalArray=new Float32Array(3*nvertices)),geometry.hasTangents&&(geometryGroup.__tangentArray=new Float32Array(4*nvertices)),vertexColorType&&(geometryGroup.__colorArray=new Float32Array(3*nvertices)),uvType&&(0<geometry.faceVertexUvs.length&&(geometryGroup.__uvArray=new Float32Array(2*nvertices)),1<geometry.faceVertexUvs.length&&(geometryGroup.__uv2Array=new Float32Array(2*nvertices))),object.geometry.skinWeights.length&&object.geometry.skinIndices.length&&(geometryGroup.__skinIndexArray=new Float32Array(4*nvertices),geometryGroup.__skinWeightArray=new Float32Array(4*nvertices)),geometryGroup.__faceArray=new Uint16Array(3*ntris),geometryGroup.__lineArray=new Uint16Array(2*nlines);var m,ml;if(geometryGroup.numMorphTargets)for(geometryGroup.__morphTargetsArrays=[],m=0,ml=geometryGroup.numMorphTargets;m<ml;m++)geometryGroup.__morphTargetsArrays.push(new Float32Array(3*nvertices));if(geometryGroup.numMorphNormals)for(geometryGroup.__morphNormalsArrays=[],m=0,ml=geometryGroup.numMorphNormals;m<ml;m++)geometryGroup.__morphNormalsArrays.push(new Float32Array(3*nvertices));if(geometryGroup.__webglFaceCount=3*ntris,geometryGroup.__webglLineCount=2*nlines,material.attributes)for(var a in void 0===geometryGroup.__webglCustomAttributesList&&(geometryGroup.__webglCustomAttributesList=[]),material.attributes){var originalAttribute=material.attributes[a],attribute={};for(var property in originalAttribute)attribute[property]=originalAttribute[property];if(!attribute.__webglInitialized||attribute.createUniqueBuffers){attribute.__webglInitialized=!0;var size=1;'v2'===attribute.type?size=2:'v3'===attribute.type?size=3:'v4'===attribute.type?size=4:'c'===attribute.type&&(size=3),attribute.size=size,attribute.array=new Float32Array(nvertices*size),attribute.buffer=_gl.createBuffer(),attribute.buffer.belongsToAttribute=a,originalAttribute.needsUpdate=!0,attribute.__original=originalAttribute}geometryGroup.__webglCustomAttributesList.push(attribute)}geometryGroup.__inittedArrays=!0}function getBufferMaterial(object,geometryGroup){return object.material instanceof THREE.MeshFaceMaterial?object.material.materials[geometryGroup.materialIndex]:object.material}function materialNeedsSmoothNormals(material){return material&&material.shading!==void 0&&material.shading===THREE.SmoothShading}function bufferGuessNormalType(material){return!(material instanceof THREE.MeshBasicMaterial&&!material.envMap||material instanceof THREE.MeshDepthMaterial)&&(materialNeedsSmoothNormals(material)?THREE.SmoothShading:THREE.FlatShading)}function bufferGuessVertexColorType(material){return!!material.vertexColors&&material.vertexColors}function bufferGuessUVType(material){return!!(material.map||material.lightMap||material.bumpMap||material.normalMap||material.specularMap||material instanceof THREE.ShaderMaterial)}function initDirectBuffers(geometry){var a,attribute,type;for(a in geometry.attributes)type='index'===a?_gl.ELEMENT_ARRAY_BUFFER:_gl.ARRAY_BUFFER,attribute=geometry.attributes[a],void 0===attribute.numItems&&(attribute.numItems=attribute.array.length),attribute.buffer=_gl.createBuffer(),_gl.bindBuffer(type,attribute.buffer),_gl.bufferData(type,attribute.array,_gl.STATIC_DRAW)}function setParticleBuffers(geometry,hint,object){var vertices=geometry.vertices,vl=vertices.length,colors=geometry.colors,cl=colors.length,vertexArray=geometry.__vertexArray,colorArray=geometry.__colorArray,sortArray=geometry.__sortArray,dirtyVertices=geometry.verticesNeedUpdate,dirtyElements=geometry.elementsNeedUpdate,dirtyColors=geometry.colorsNeedUpdate,customAttributes=geometry.__webglCustomAttributesList,v,c,vertex,offset,index,color,i,il,ca,cal,value,customAttribute;if(object.sortParticles){for(_projScreenMatrixPS.copy(_projScreenMatrix),_projScreenMatrixPS.multiply(object.matrixWorld),v=0;v<vl;v++)vertex=vertices[v],_vector3.copy(vertex),_vector3.applyProjection(_projScreenMatrixPS),sortArray[v]=[_vector3.z,v];for(sortArray.sort(numericalSort),v=0;v<vl;v++)vertex=vertices[sortArray[v][1]],offset=3*v,vertexArray[offset]=vertex.x,vertexArray[offset+1]=vertex.y,vertexArray[offset+2]=vertex.z;for(c=0;c<cl;c++)offset=3*c,color=colors[sortArray[c][1]],colorArray[offset]=color.r,colorArray[offset+1]=color.g,colorArray[offset+2]=color.b;if(customAttributes)for(i=0,il=customAttributes.length;i<il;i++)if(customAttribute=customAttributes[i],void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo)if(offset=0,cal=customAttribute.value.length,1===customAttribute.size)for(ca=0;ca<cal;ca++)index=sortArray[ca][1],customAttribute.array[ca]=customAttribute.value[index];else if(2===customAttribute.size)for(ca=0;ca<cal;ca++)index=sortArray[ca][1],value=customAttribute.value[index],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,offset+=2;else if(3===customAttribute.size){if('c'===customAttribute.type)for(ca=0;ca<cal;ca++)index=sortArray[ca][1],value=customAttribute.value[index],customAttribute.array[offset]=value.r,customAttribute.array[offset+1]=value.g,customAttribute.array[offset+2]=value.b,offset+=3;else for(ca=0;ca<cal;ca++)index=sortArray[ca][1],value=customAttribute.value[index],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,offset+=3;}else if(4===customAttribute.size)for(ca=0;ca<cal;ca++)index=sortArray[ca][1],value=customAttribute.value[index],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,customAttribute.array[offset+3]=value.w,offset+=4}else{if(dirtyVertices)for(v=0;v<vl;v++)vertex=vertices[v],offset=3*v,vertexArray[offset]=vertex.x,vertexArray[offset+1]=vertex.y,vertexArray[offset+2]=vertex.z;if(dirtyColors)for(c=0;c<cl;c++)color=colors[c],offset=3*c,colorArray[offset]=color.r,colorArray[offset+1]=color.g,colorArray[offset+2]=color.b;if(customAttributes)for(i=0,il=customAttributes.length;i<il;i++)if(customAttribute=customAttributes[i],customAttribute.needsUpdate&&(void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo))if(cal=customAttribute.value.length,offset=0,1===customAttribute.size)for(ca=0;ca<cal;ca++)customAttribute.array[ca]=customAttribute.value[ca];else if(2===customAttribute.size)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,offset+=2;else if(3===customAttribute.size){if('c'===customAttribute.type)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.r,customAttribute.array[offset+1]=value.g,customAttribute.array[offset+2]=value.b,offset+=3;else for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,offset+=3;}else if(4===customAttribute.size)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,customAttribute.array[offset+3]=value.w,offset+=4}if((dirtyVertices||object.sortParticles)&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglVertexBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,vertexArray,hint)),(dirtyColors||object.sortParticles)&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglColorBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,colorArray,hint)),customAttributes)for(i=0,il=customAttributes.length;i<il;i++)customAttribute=customAttributes[i],(customAttribute.needsUpdate||object.sortParticles)&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,customAttribute.buffer),_gl.bufferData(_gl.ARRAY_BUFFER,customAttribute.array,hint))}function setLineBuffers(geometry,hint){var vertices=geometry.vertices,colors=geometry.colors,lineDistances=geometry.lineDistances,vl=vertices.length,cl=colors.length,dl=lineDistances.length,vertexArray=geometry.__vertexArray,colorArray=geometry.__colorArray,lineDistanceArray=geometry.__lineDistanceArray,dirtyVertices=geometry.verticesNeedUpdate,dirtyColors=geometry.colorsNeedUpdate,dirtyLineDistances=geometry.lineDistancesNeedUpdate,customAttributes=geometry.__webglCustomAttributesList,v,c,d,vertex,offset,color,i,il,ca,cal,value,customAttribute;if(dirtyVertices){for(v=0;v<vl;v++)vertex=vertices[v],offset=3*v,vertexArray[offset]=vertex.x,vertexArray[offset+1]=vertex.y,vertexArray[offset+2]=vertex.z;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglVertexBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,vertexArray,hint)}if(dirtyColors){for(c=0;c<cl;c++)color=colors[c],offset=3*c,colorArray[offset]=color.r,colorArray[offset+1]=color.g,colorArray[offset+2]=color.b;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglColorBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,colorArray,hint)}if(dirtyLineDistances){for(d=0;d<dl;d++)lineDistanceArray[d]=lineDistances[d];_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglLineDistanceBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,lineDistanceArray,hint)}if(customAttributes)for(i=0,il=customAttributes.length;i<il;i++)if(customAttribute=customAttributes[i],customAttribute.needsUpdate&&(void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo)){if(offset=0,cal=customAttribute.value.length,1===customAttribute.size)for(ca=0;ca<cal;ca++)customAttribute.array[ca]=customAttribute.value[ca];else if(2===customAttribute.size)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,offset+=2;else if(3===customAttribute.size){if('c'===customAttribute.type)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.r,customAttribute.array[offset+1]=value.g,customAttribute.array[offset+2]=value.b,offset+=3;else for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,offset+=3;}else if(4===customAttribute.size)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,customAttribute.array[offset+3]=value.w,offset+=4;_gl.bindBuffer(_gl.ARRAY_BUFFER,customAttribute.buffer),_gl.bufferData(_gl.ARRAY_BUFFER,customAttribute.array,hint)}}function setRibbonBuffers(geometry,hint){var vertices=geometry.vertices,colors=geometry.colors,normals=geometry.normals,vl=vertices.length,cl=colors.length,nl=normals.length,vertexArray=geometry.__vertexArray,colorArray=geometry.__colorArray,normalArray=geometry.__normalArray,dirtyVertices=geometry.verticesNeedUpdate,dirtyColors=geometry.colorsNeedUpdate,dirtyNormals=geometry.normalsNeedUpdate,customAttributes=geometry.__webglCustomAttributesList,v,c,n,vertex,offset,color,normal,i,il,ca,cal,customAttribute,value;if(dirtyVertices){for(v=0;v<vl;v++)vertex=vertices[v],offset=3*v,vertexArray[offset]=vertex.x,vertexArray[offset+1]=vertex.y,vertexArray[offset+2]=vertex.z;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglVertexBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,vertexArray,hint)}if(dirtyColors){for(c=0;c<cl;c++)color=colors[c],offset=3*c,colorArray[offset]=color.r,colorArray[offset+1]=color.g,colorArray[offset+2]=color.b;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglColorBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,colorArray,hint)}if(dirtyNormals){for(n=0;n<nl;n++)normal=normals[n],offset=3*n,normalArray[offset]=normal.x,normalArray[offset+1]=normal.y,normalArray[offset+2]=normal.z;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometry.__webglNormalBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,normalArray,hint)}if(customAttributes)for(i=0,il=customAttributes.length;i<il;i++)if(customAttribute=customAttributes[i],customAttribute.needsUpdate&&(void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo)){if(offset=0,cal=customAttribute.value.length,1===customAttribute.size)for(ca=0;ca<cal;ca++)customAttribute.array[ca]=customAttribute.value[ca];else if(2===customAttribute.size)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,offset+=2;else if(3===customAttribute.size){if('c'===customAttribute.type)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.r,customAttribute.array[offset+1]=value.g,customAttribute.array[offset+2]=value.b,offset+=3;else for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,offset+=3;}else if(4===customAttribute.size)for(ca=0;ca<cal;ca++)value=customAttribute.value[ca],customAttribute.array[offset]=value.x,customAttribute.array[offset+1]=value.y,customAttribute.array[offset+2]=value.z,customAttribute.array[offset+3]=value.w,offset+=4;_gl.bindBuffer(_gl.ARRAY_BUFFER,customAttribute.buffer),_gl.bufferData(_gl.ARRAY_BUFFER,customAttribute.array,hint)}}function setMeshBuffers(geometryGroup,object,hint,dispose,material){if(geometryGroup.__inittedArrays){var normalType=bufferGuessNormalType(material),vertexColorType=bufferGuessVertexColorType(material),uvType=bufferGuessUVType(material),needsSmoothNormals=normalType===THREE.SmoothShading,vertexIndex=0,offset=0,offset_uv=0,offset_uv2=0,offset_face=0,offset_normal=0,offset_tangent=0,offset_line=0,offset_color=0,offset_skin=0,offset_morphTarget=0,offset_custom=0,offset_customSrc=0,vertexArray=geometryGroup.__vertexArray,uvArray=geometryGroup.__uvArray,uv2Array=geometryGroup.__uv2Array,normalArray=geometryGroup.__normalArray,tangentArray=geometryGroup.__tangentArray,colorArray=geometryGroup.__colorArray,skinIndexArray=geometryGroup.__skinIndexArray,skinWeightArray=geometryGroup.__skinWeightArray,morphTargetsArrays=geometryGroup.__morphTargetsArrays,morphNormalsArrays=geometryGroup.__morphNormalsArrays,customAttributes=geometryGroup.__webglCustomAttributesList,faceArray=geometryGroup.__faceArray,lineArray=geometryGroup.__lineArray,geometry=object.geometry,dirtyVertices=geometry.verticesNeedUpdate,dirtyElements=geometry.elementsNeedUpdate,dirtyUvs=geometry.uvsNeedUpdate,dirtyNormals=geometry.normalsNeedUpdate,dirtyTangents=geometry.tangentsNeedUpdate,dirtyColors=geometry.colorsNeedUpdate,dirtyMorphTargets=geometry.morphTargetsNeedUpdate,vertices=geometry.vertices,chunk_faces3=geometryGroup.faces3,obj_faces=geometry.faces,obj_uvs=geometry.faceVertexUvs[0],obj_uvs2=geometry.faceVertexUvs[1],obj_colors=geometry.colors,obj_skinIndices=geometry.skinIndices,obj_skinWeights=geometry.skinWeights,morphTargets=geometry.morphTargets,morphNormals=geometry.morphNormals,f,fl,fi,face,vertexNormals,faceNormal,vertexColors,faceColor,vertexTangents,uv,uv2,v1,v2,v3,t1,t2,t3,n1,n2,n3,c1,c2,c3,sw1,sw2,sw3,si1,si2,si3,i,il,vn,uvi,uv2i,vk,vkl,vka,nka,chf,faceVertexNormals,value,customAttribute;if(dirtyVertices){for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],v1=vertices[face.a],v2=vertices[face.b],v3=vertices[face.c],vertexArray[offset]=v1.x,vertexArray[offset+1]=v1.y,vertexArray[offset+2]=v1.z,vertexArray[offset+3]=v2.x,vertexArray[offset+4]=v2.y,vertexArray[offset+5]=v2.z,vertexArray[offset+6]=v3.x,vertexArray[offset+7]=v3.y,vertexArray[offset+8]=v3.z,offset+=9;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglVertexBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,vertexArray,hint)}if(dirtyMorphTargets)for(vk=0,vkl=morphTargets.length;vk<vkl;vk++){for(offset_morphTarget=0,f=0,fl=chunk_faces3.length;f<fl;f++)chf=chunk_faces3[f],face=obj_faces[chf],v1=morphTargets[vk].vertices[face.a],v2=morphTargets[vk].vertices[face.b],v3=morphTargets[vk].vertices[face.c],vka=morphTargetsArrays[vk],vka[offset_morphTarget]=v1.x,vka[offset_morphTarget+1]=v1.y,vka[offset_morphTarget+2]=v1.z,vka[offset_morphTarget+3]=v2.x,vka[offset_morphTarget+4]=v2.y,vka[offset_morphTarget+5]=v2.z,vka[offset_morphTarget+6]=v3.x,vka[offset_morphTarget+7]=v3.y,vka[offset_morphTarget+8]=v3.z,material.morphNormals&&(needsSmoothNormals?(faceVertexNormals=morphNormals[vk].vertexNormals[chf],n1=faceVertexNormals.a,n2=faceVertexNormals.b,n3=faceVertexNormals.c):(n1=morphNormals[vk].faceNormals[chf],n2=n1,n3=n1),nka=morphNormalsArrays[vk],nka[offset_morphTarget]=n1.x,nka[offset_morphTarget+1]=n1.y,nka[offset_morphTarget+2]=n1.z,nka[offset_morphTarget+3]=n2.x,nka[offset_morphTarget+4]=n2.y,nka[offset_morphTarget+5]=n2.z,nka[offset_morphTarget+6]=n3.x,nka[offset_morphTarget+7]=n3.y,nka[offset_morphTarget+8]=n3.z),offset_morphTarget+=9;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglMorphTargetsBuffers[vk]),_gl.bufferData(_gl.ARRAY_BUFFER,morphTargetsArrays[vk],hint),material.morphNormals&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglMorphNormalsBuffers[vk]),_gl.bufferData(_gl.ARRAY_BUFFER,morphNormalsArrays[vk],hint))}if(obj_skinWeights.length){for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],sw1=obj_skinWeights[face.a],sw2=obj_skinWeights[face.b],sw3=obj_skinWeights[face.c],skinWeightArray[offset_skin]=sw1.x,skinWeightArray[offset_skin+1]=sw1.y,skinWeightArray[offset_skin+2]=sw1.z,skinWeightArray[offset_skin+3]=sw1.w,skinWeightArray[offset_skin+4]=sw2.x,skinWeightArray[offset_skin+5]=sw2.y,skinWeightArray[offset_skin+6]=sw2.z,skinWeightArray[offset_skin+7]=sw2.w,skinWeightArray[offset_skin+8]=sw3.x,skinWeightArray[offset_skin+9]=sw3.y,skinWeightArray[offset_skin+10]=sw3.z,skinWeightArray[offset_skin+11]=sw3.w,si1=obj_skinIndices[face.a],si2=obj_skinIndices[face.b],si3=obj_skinIndices[face.c],skinIndexArray[offset_skin]=si1.x,skinIndexArray[offset_skin+1]=si1.y,skinIndexArray[offset_skin+2]=si1.z,skinIndexArray[offset_skin+3]=si1.w,skinIndexArray[offset_skin+4]=si2.x,skinIndexArray[offset_skin+5]=si2.y,skinIndexArray[offset_skin+6]=si2.z,skinIndexArray[offset_skin+7]=si2.w,skinIndexArray[offset_skin+8]=si3.x,skinIndexArray[offset_skin+9]=si3.y,skinIndexArray[offset_skin+10]=si3.z,skinIndexArray[offset_skin+11]=si3.w,offset_skin+=12;0<offset_skin&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglSkinIndicesBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,skinIndexArray,hint),_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglSkinWeightsBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,skinWeightArray,hint))}if(dirtyColors&&vertexColorType){for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],vertexColors=face.vertexColors,faceColor=face.color,3===vertexColors.length&&vertexColorType===THREE.VertexColors?(c1=vertexColors[0],c2=vertexColors[1],c3=vertexColors[2]):(c1=faceColor,c2=faceColor,c3=faceColor),colorArray[offset_color]=c1.r,colorArray[offset_color+1]=c1.g,colorArray[offset_color+2]=c1.b,colorArray[offset_color+3]=c2.r,colorArray[offset_color+4]=c2.g,colorArray[offset_color+5]=c2.b,colorArray[offset_color+6]=c3.r,colorArray[offset_color+7]=c3.g,colorArray[offset_color+8]=c3.b,offset_color+=9;0<offset_color&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglColorBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,colorArray,hint))}if(dirtyTangents&&geometry.hasTangents){for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],vertexTangents=face.vertexTangents,t1=vertexTangents[0],t2=vertexTangents[1],t3=vertexTangents[2],tangentArray[offset_tangent]=t1.x,tangentArray[offset_tangent+1]=t1.y,tangentArray[offset_tangent+2]=t1.z,tangentArray[offset_tangent+3]=t1.w,tangentArray[offset_tangent+4]=t2.x,tangentArray[offset_tangent+5]=t2.y,tangentArray[offset_tangent+6]=t2.z,tangentArray[offset_tangent+7]=t2.w,tangentArray[offset_tangent+8]=t3.x,tangentArray[offset_tangent+9]=t3.y,tangentArray[offset_tangent+10]=t3.z,tangentArray[offset_tangent+11]=t3.w,offset_tangent+=12;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglTangentBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,tangentArray,hint)}if(dirtyNormals&&normalType){for(f=0,fl=chunk_faces3.length;f<fl;f++)if(face=obj_faces[chunk_faces3[f]],vertexNormals=face.vertexNormals,faceNormal=face.normal,3===vertexNormals.length&&needsSmoothNormals)for(i=0;3>i;i++)vn=vertexNormals[i],normalArray[offset_normal]=vn.x,normalArray[offset_normal+1]=vn.y,normalArray[offset_normal+2]=vn.z,offset_normal+=3;else for(i=0;3>i;i++)normalArray[offset_normal]=faceNormal.x,normalArray[offset_normal+1]=faceNormal.y,normalArray[offset_normal+2]=faceNormal.z,offset_normal+=3;_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglNormalBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,normalArray,hint)}if(dirtyUvs&&obj_uvs&&uvType){for(f=0,fl=chunk_faces3.length;f<fl;f++)if(fi=chunk_faces3[f],uv=obj_uvs[fi],void 0!==uv)for(i=0;3>i;i++)uvi=uv[i],uvArray[offset_uv]=uvi.x,uvArray[offset_uv+1]=uvi.y,offset_uv+=2;0<offset_uv&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglUVBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,uvArray,hint))}if(dirtyUvs&&obj_uvs2&&uvType){for(f=0,fl=chunk_faces3.length;f<fl;f++)if(fi=chunk_faces3[f],uv2=obj_uvs2[fi],void 0!==uv2)for(i=0;3>i;i++)uv2i=uv2[i],uv2Array[offset_uv2]=uv2i.x,uv2Array[offset_uv2+1]=uv2i.y,offset_uv2+=2;0<offset_uv2&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglUV2Buffer),_gl.bufferData(_gl.ARRAY_BUFFER,uv2Array,hint))}if(dirtyElements){for(f=0,fl=chunk_faces3.length;f<fl;f++)faceArray[offset_face]=vertexIndex,faceArray[offset_face+1]=vertexIndex+1,faceArray[offset_face+2]=vertexIndex+2,offset_face+=3,lineArray[offset_line]=vertexIndex,lineArray[offset_line+1]=vertexIndex+1,lineArray[offset_line+2]=vertexIndex,lineArray[offset_line+3]=vertexIndex+2,lineArray[offset_line+4]=vertexIndex+1,lineArray[offset_line+5]=vertexIndex+2,offset_line+=6,vertexIndex+=3;_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,geometryGroup.__webglFaceBuffer),_gl.bufferData(_gl.ELEMENT_ARRAY_BUFFER,faceArray,hint),_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,geometryGroup.__webglLineBuffer),_gl.bufferData(_gl.ELEMENT_ARRAY_BUFFER,lineArray,hint)}if(customAttributes)for(i=0,il=customAttributes.length;i<il;i++)if(customAttribute=customAttributes[i],customAttribute.__original.needsUpdate){if(offset_custom=0,offset_customSrc=0,1===customAttribute.size){if(void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],customAttribute.array[offset_custom]=customAttribute.value[face.a],customAttribute.array[offset_custom+1]=customAttribute.value[face.b],customAttribute.array[offset_custom+2]=customAttribute.value[face.c],offset_custom+=3;else if('faces'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)value=customAttribute.value[chunk_faces3[f]],customAttribute.array[offset_custom]=value,customAttribute.array[offset_custom+1]=value,customAttribute.array[offset_custom+2]=value,offset_custom+=3;}else if(2===customAttribute.size){if(void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],v1=customAttribute.value[face.a],v2=customAttribute.value[face.b],v3=customAttribute.value[face.c],customAttribute.array[offset_custom]=v1.x,customAttribute.array[offset_custom+1]=v1.y,customAttribute.array[offset_custom+2]=v2.x,customAttribute.array[offset_custom+3]=v2.y,customAttribute.array[offset_custom+4]=v3.x,customAttribute.array[offset_custom+5]=v3.y,offset_custom+=6;else if('faces'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)value=customAttribute.value[chunk_faces3[f]],v1=value,v2=value,v3=value,customAttribute.array[offset_custom]=v1.x,customAttribute.array[offset_custom+1]=v1.y,customAttribute.array[offset_custom+2]=v2.x,customAttribute.array[offset_custom+3]=v2.y,customAttribute.array[offset_custom+4]=v3.x,customAttribute.array[offset_custom+5]=v3.y,offset_custom+=6;}else if(3===customAttribute.size){var pp;if(pp='c'===customAttribute.type?['r','g','b']:['x','y','z'],void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],v1=customAttribute.value[face.a],v2=customAttribute.value[face.b],v3=customAttribute.value[face.c],customAttribute.array[offset_custom]=v1[pp[0]],customAttribute.array[offset_custom+1]=v1[pp[1]],customAttribute.array[offset_custom+2]=v1[pp[2]],customAttribute.array[offset_custom+3]=v2[pp[0]],customAttribute.array[offset_custom+4]=v2[pp[1]],customAttribute.array[offset_custom+5]=v2[pp[2]],customAttribute.array[offset_custom+6]=v3[pp[0]],customAttribute.array[offset_custom+7]=v3[pp[1]],customAttribute.array[offset_custom+8]=v3[pp[2]],offset_custom+=9;else if('faces'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)value=customAttribute.value[chunk_faces3[f]],v1=value,v2=value,v3=value,customAttribute.array[offset_custom]=v1[pp[0]],customAttribute.array[offset_custom+1]=v1[pp[1]],customAttribute.array[offset_custom+2]=v1[pp[2]],customAttribute.array[offset_custom+3]=v2[pp[0]],customAttribute.array[offset_custom+4]=v2[pp[1]],customAttribute.array[offset_custom+5]=v2[pp[2]],customAttribute.array[offset_custom+6]=v3[pp[0]],customAttribute.array[offset_custom+7]=v3[pp[1]],customAttribute.array[offset_custom+8]=v3[pp[2]],offset_custom+=9;else if('faceVertices'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)value=customAttribute.value[chunk_faces3[f]],v1=value[0],v2=value[1],v3=value[2],customAttribute.array[offset_custom]=v1[pp[0]],customAttribute.array[offset_custom+1]=v1[pp[1]],customAttribute.array[offset_custom+2]=v1[pp[2]],customAttribute.array[offset_custom+3]=v2[pp[0]],customAttribute.array[offset_custom+4]=v2[pp[1]],customAttribute.array[offset_custom+5]=v2[pp[2]],customAttribute.array[offset_custom+6]=v3[pp[0]],customAttribute.array[offset_custom+7]=v3[pp[1]],customAttribute.array[offset_custom+8]=v3[pp[2]],offset_custom+=9}else if(4===customAttribute.size)if(void 0===customAttribute.boundTo||'vertices'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)face=obj_faces[chunk_faces3[f]],v1=customAttribute.value[face.a],v2=customAttribute.value[face.b],v3=customAttribute.value[face.c],customAttribute.array[offset_custom]=v1.x,customAttribute.array[offset_custom+1]=v1.y,customAttribute.array[offset_custom+2]=v1.z,customAttribute.array[offset_custom+3]=v1.w,customAttribute.array[offset_custom+4]=v2.x,customAttribute.array[offset_custom+5]=v2.y,customAttribute.array[offset_custom+6]=v2.z,customAttribute.array[offset_custom+7]=v2.w,customAttribute.array[offset_custom+8]=v3.x,customAttribute.array[offset_custom+9]=v3.y,customAttribute.array[offset_custom+10]=v3.z,customAttribute.array[offset_custom+11]=v3.w,offset_custom+=12;else if('faces'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)value=customAttribute.value[chunk_faces3[f]],v1=value,v2=value,v3=value,customAttribute.array[offset_custom]=v1.x,customAttribute.array[offset_custom+1]=v1.y,customAttribute.array[offset_custom+2]=v1.z,customAttribute.array[offset_custom+3]=v1.w,customAttribute.array[offset_custom+4]=v2.x,customAttribute.array[offset_custom+5]=v2.y,customAttribute.array[offset_custom+6]=v2.z,customAttribute.array[offset_custom+7]=v2.w,customAttribute.array[offset_custom+8]=v3.x,customAttribute.array[offset_custom+9]=v3.y,customAttribute.array[offset_custom+10]=v3.z,customAttribute.array[offset_custom+11]=v3.w,offset_custom+=12;else if('faceVertices'===customAttribute.boundTo)for(f=0,fl=chunk_faces3.length;f<fl;f++)value=customAttribute.value[chunk_faces3[f]],v1=value[0],v2=value[1],v3=value[2],customAttribute.array[offset_custom]=v1.x,customAttribute.array[offset_custom+1]=v1.y,customAttribute.array[offset_custom+2]=v1.z,customAttribute.array[offset_custom+3]=v1.w,customAttribute.array[offset_custom+4]=v2.x,customAttribute.array[offset_custom+5]=v2.y,customAttribute.array[offset_custom+6]=v2.z,customAttribute.array[offset_custom+7]=v2.w,customAttribute.array[offset_custom+8]=v3.x,customAttribute.array[offset_custom+9]=v3.y,customAttribute.array[offset_custom+10]=v3.z,customAttribute.array[offset_custom+11]=v3.w,offset_custom+=12;_gl.bindBuffer(_gl.ARRAY_BUFFER,customAttribute.buffer),_gl.bufferData(_gl.ARRAY_BUFFER,customAttribute.array,hint)}dispose&&(delete geometryGroup.__inittedArrays,delete geometryGroup.__colorArray,delete geometryGroup.__normalArray,delete geometryGroup.__tangentArray,delete geometryGroup.__uvArray,delete geometryGroup.__uv2Array,delete geometryGroup.__faceArray,delete geometryGroup.__vertexArray,delete geometryGroup.__lineArray,delete geometryGroup.__skinIndexArray,delete geometryGroup.__skinWeightArray)}}function setDirectBuffers(geometry,hint,dispose){var attributes=geometry.attributes,attributeName,attributeItem;for(attributeName in attributes)attributeItem=attributes[attributeName],attributeItem.needsUpdate&&('index'===attributeName?(_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,attributeItem.buffer),_gl.bufferData(_gl.ELEMENT_ARRAY_BUFFER,attributeItem.array,hint)):(_gl.bindBuffer(_gl.ARRAY_BUFFER,attributeItem.buffer),_gl.bufferData(_gl.ARRAY_BUFFER,attributeItem.array,hint)),attributeItem.needsUpdate=!1),dispose&&!attributeItem.dynamic&&(attributeItem.array=null)}function enableAttribute(attribute){_enabledAttributes[attribute]||(_gl.enableVertexAttribArray(attribute),_enabledAttributes[attribute]=!0)}function disableAttributes(){for(var attribute in _enabledAttributes)_enabledAttributes[attribute]&&(_gl.disableVertexAttribArray(attribute),_enabledAttributes[attribute]=!1)}function setupMorphTargets(material,geometryGroup,object){var attributes=material.program.attributes;if(-1!==object.morphTargetBase&&0<=attributes.position?(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglMorphTargetsBuffers[object.morphTargetBase]),enableAttribute(attributes.position),_gl.vertexAttribPointer(attributes.position,3,_gl.FLOAT,!1,0,0)):0<=attributes.position&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglVertexBuffer),enableAttribute(attributes.position),_gl.vertexAttribPointer(attributes.position,3,_gl.FLOAT,!1,0,0)),object.morphTargetForcedOrder.length)for(var m=0,order=object.morphTargetForcedOrder,influences=object.morphTargetInfluences;m<material.numSupportedMorphTargets&&m<order.length;)0<=attributes['morphTarget'+m]&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglMorphTargetsBuffers[order[m]]),enableAttribute(attributes['morphTarget'+m]),_gl.vertexAttribPointer(attributes['morphTarget'+m],3,_gl.FLOAT,!1,0,0)),0<=attributes['morphNormal'+m]&&material.morphNormals&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglMorphNormalsBuffers[order[m]]),enableAttribute(attributes['morphNormal'+m]),_gl.vertexAttribPointer(attributes['morphNormal'+m],3,_gl.FLOAT,!1,0,0)),object.__webglMorphTargetInfluences[m]=influences[order[m]],m++;else{var activeInfluenceIndices=[],influences=object.morphTargetInfluences,il=influences.length,influence,i;for(i=0;i<il;i++)influence=influences[i],0<influence&&activeInfluenceIndices.push([influence,i]);activeInfluenceIndices.length>material.numSupportedMorphTargets?(activeInfluenceIndices.sort(numericalSort),activeInfluenceIndices.length=material.numSupportedMorphTargets):activeInfluenceIndices.length>material.numSupportedMorphNormals?activeInfluenceIndices.sort(numericalSort):0===activeInfluenceIndices.length&&activeInfluenceIndices.push([0,0]);for(var m=0,influenceIndex;m<material.numSupportedMorphTargets;)activeInfluenceIndices[m]?(influenceIndex=activeInfluenceIndices[m][1],0<=attributes['morphTarget'+m]&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglMorphTargetsBuffers[influenceIndex]),enableAttribute(attributes['morphTarget'+m]),_gl.vertexAttribPointer(attributes['morphTarget'+m],3,_gl.FLOAT,!1,0,0)),0<=attributes['morphNormal'+m]&&material.morphNormals&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglMorphNormalsBuffers[influenceIndex]),enableAttribute(attributes['morphNormal'+m]),_gl.vertexAttribPointer(attributes['morphNormal'+m],3,_gl.FLOAT,!1,0,0)),object.__webglMorphTargetInfluences[m]=influences[influenceIndex]):object.__webglMorphTargetInfluences[m]=0,m++}null!==material.program.uniforms.morphTargetInfluences&&_gl.uniform1fv(material.program.uniforms.morphTargetInfluences,object.__webglMorphTargetInfluences)}function painterSortStable(a,b){return a.z===b.z?a.id-b.id:b.z-a.z}function numericalSort(a,b){return b[0]-a[0]}function renderPlugins(plugins,scene,camera){if(plugins.length)for(var i=0,il=plugins.length;i<il;i++)_currentProgram=null,_currentCamera=null,_oldBlending=-1,_oldDepthTest=-1,_oldDepthWrite=-1,_oldDoubleSided=-1,_oldFlipSided=-1,_currentGeometryGroupHash=-1,_currentMaterialId=-1,_lightsNeedUpdate=!0,plugins[i].render(scene,camera,_currentWidth,_currentHeight),_currentProgram=null,_currentCamera=null,_oldBlending=-1,_oldDepthTest=-1,_oldDepthWrite=-1,_oldDoubleSided=-1,_oldFlipSided=-1,_currentGeometryGroupHash=-1,_currentMaterialId=-1,_lightsNeedUpdate=!0}function renderObjects(renderList,reverse,materialType,camera,lights,fog,useBlending,overrideMaterial){var webglObject,object,buffer,material,start,end,delta;reverse?(start=renderList.length-1,end=-1,delta=-1):(start=0,end=renderList.length,delta=1);for(var i=start;i!==end;i+=delta)if(webglObject=renderList[i],webglObject.render){if(object=webglObject.object,buffer=webglObject.buffer,overrideMaterial)material=overrideMaterial;else{if(material=webglObject[materialType],!material)continue;useBlending&&_this.setBlending(material.blending,material.blendEquation,material.blendSrc,material.blendDst),_this.setDepthTest(material.depthTest),_this.setDepthWrite(material.depthWrite),setPolygonOffset(material.polygonOffset,material.polygonOffsetFactor,material.polygonOffsetUnits)}_this.setMaterialFaces(material),buffer instanceof THREE.BufferGeometry?_this.renderBufferDirect(camera,lights,fog,material,buffer,object):_this.renderBuffer(camera,lights,fog,material,buffer,object)}}function renderObjectsImmediate(renderList,materialType,camera,lights,fog,useBlending,overrideMaterial){for(var i=0,il=renderList.length,webglObject,object,material;i<il;i++)if(webglObject=renderList[i],object=webglObject.object,object.visible){if(overrideMaterial)material=overrideMaterial;else{if(material=webglObject[materialType],!material)continue;useBlending&&_this.setBlending(material.blending,material.blendEquation,material.blendSrc,material.blendDst),_this.setDepthTest(material.depthTest),_this.setDepthWrite(material.depthWrite),setPolygonOffset(material.polygonOffset,material.polygonOffsetFactor,material.polygonOffsetUnits)}_this.renderImmediateObject(camera,lights,fog,material,object)}}function unrollImmediateBufferMaterial(globject){var object=globject.object,material=object.material;material.transparent?(globject.transparent=material,globject.opaque=null):(globject.opaque=material,globject.transparent=null)}function unrollBufferMaterial(globject){var object=globject.object,buffer=globject.buffer,material,materialIndex,meshMaterial;meshMaterial=object.material,meshMaterial instanceof THREE.MeshFaceMaterial?(materialIndex=buffer.materialIndex,material=meshMaterial.materials[materialIndex],material.transparent?(globject.transparent=material,globject.opaque=null):(globject.opaque=material,globject.transparent=null)):(material=meshMaterial,material&&(material.transparent?(globject.transparent=material,globject.opaque=null):(globject.opaque=material,globject.transparent=null)))}function sortFacesByMaterial(geometry,material){var hash_map={},numMorphTargets=geometry.morphTargets.length,numMorphNormals=geometry.morphNormals.length,usesFaceMaterial=material instanceof THREE.MeshFaceMaterial,f,fl,face,materialIndex,vertices,groupHash;for(geometry.geometryGroups={},f=0,fl=geometry.faces.length;f<fl;f++)face=geometry.faces[f],materialIndex=usesFaceMaterial?face.materialIndex:0,void 0===hash_map[materialIndex]&&(hash_map[materialIndex]={hash:materialIndex,counter:0}),groupHash=hash_map[materialIndex].hash+'_'+hash_map[materialIndex].counter,void 0===geometry.geometryGroups[groupHash]&&(geometry.geometryGroups[groupHash]={faces3:[],materialIndex:materialIndex,vertices:0,numMorphTargets:numMorphTargets,numMorphNormals:numMorphNormals}),vertices=3,65535<geometry.geometryGroups[groupHash].vertices+vertices&&(hash_map[materialIndex].counter+=1,groupHash=hash_map[materialIndex].hash+'_'+hash_map[materialIndex].counter,void 0===geometry.geometryGroups[groupHash]&&(geometry.geometryGroups[groupHash]={faces3:[],materialIndex:materialIndex,vertices:0,numMorphTargets:numMorphTargets,numMorphNormals:numMorphNormals})),geometry.geometryGroups[groupHash].faces3.push(f),geometry.geometryGroups[groupHash].vertices+=vertices;for(var g in geometry.geometryGroupsList=[],geometry.geometryGroups)geometry.geometryGroups[g].id=_geometryGroupCounter++,geometry.geometryGroupsList.push(geometry.geometryGroups[g])}function addObject(object,scene){var g,geometry,material,geometryGroup;if(void 0===object.__webglInit)if(object.__webglInit=!0,object._modelViewMatrix=new THREE.Matrix4,object._normalMatrix=new THREE.Matrix3,void 0!==object.geometry&&void 0===object.geometry.__webglInit&&(object.geometry.__webglInit=!0,object.geometry.addEventListener('dispose',onGeometryDispose)),geometry=object.geometry,void 0===geometry);else if(geometry instanceof THREE.BufferGeometry)initDirectBuffers(geometry);else if(object instanceof THREE.Mesh)for(g in material=object.material,void 0===geometry.geometryGroups&&sortFacesByMaterial(geometry,material),geometry.geometryGroups)geometryGroup=geometry.geometryGroups[g],geometryGroup.__webglVertexBuffer||(createMeshBuffers(geometryGroup),initMeshBuffers(geometryGroup,object),geometry.verticesNeedUpdate=!0,geometry.morphTargetsNeedUpdate=!0,geometry.elementsNeedUpdate=!0,geometry.uvsNeedUpdate=!0,geometry.normalsNeedUpdate=!0,geometry.tangentsNeedUpdate=!0,geometry.colorsNeedUpdate=!0);else object instanceof THREE.Ribbon?geometry.__webglVertexBuffer||(createRibbonBuffers(geometry),initRibbonBuffers(geometry,object),geometry.verticesNeedUpdate=!0,geometry.colorsNeedUpdate=!0,geometry.normalsNeedUpdate=!0):object instanceof THREE.Line?geometry.__webglVertexBuffer||(createLineBuffers(geometry),initLineBuffers(geometry,object),geometry.verticesNeedUpdate=!0,geometry.colorsNeedUpdate=!0,geometry.lineDistancesNeedUpdate=!0):object instanceof THREE.ParticleSystem&&(geometry.__webglVertexBuffer||(createParticleBuffers(geometry),initParticleBuffers(geometry,object),geometry.verticesNeedUpdate=!0,geometry.colorsNeedUpdate=!0));if(void 0===object.__webglActive){if(!(object instanceof THREE.Mesh))object instanceof THREE.Ribbon||object instanceof THREE.Line||object instanceof THREE.ParticleSystem?(geometry=object.geometry,addBuffer(scene.__webglObjects,geometry,object)):object instanceof THREE.ImmediateRenderObject||object.immediateRenderCallback?addBufferImmediate(scene.__webglObjectsImmediate,object):object instanceof THREE.Sprite?scene.__webglSprites.push(object):object instanceof THREE.LensFlare&&scene.__webglFlares.push(object);else if(geometry=object.geometry,geometry instanceof THREE.BufferGeometry)addBuffer(scene.__webglObjects,geometry,object);else if(geometry instanceof THREE.Geometry)for(g in geometry.geometryGroups)geometryGroup=geometry.geometryGroups[g],addBuffer(scene.__webglObjects,geometryGroup,object);object.__webglActive=!0}}function addBuffer(objlist,buffer,object){objlist.push({id:null,buffer:buffer,object:object,opaque:null,transparent:null,z:0})}function addBufferImmediate(objlist,object){objlist.push({id:null,object:object,opaque:null,transparent:null,z:0})}function updateObject(object){var geometry=object.geometry,geometryGroup,customAttributesDirty,material;if(geometry instanceof THREE.BufferGeometry)setDirectBuffers(geometry,_gl.DYNAMIC_DRAW,!geometry.dynamic);else if(object instanceof THREE.Mesh){for(var i=0,il=geometry.geometryGroupsList.length;i<il;i++)geometryGroup=geometry.geometryGroupsList[i],material=getBufferMaterial(object,geometryGroup),geometry.buffersNeedUpdate&&initMeshBuffers(geometryGroup,object),customAttributesDirty=material.attributes&&areCustomAttributesDirty(material),(geometry.verticesNeedUpdate||geometry.morphTargetsNeedUpdate||geometry.elementsNeedUpdate||geometry.uvsNeedUpdate||geometry.normalsNeedUpdate||geometry.colorsNeedUpdate||geometry.tangentsNeedUpdate||customAttributesDirty)&&setMeshBuffers(geometryGroup,object,_gl.DYNAMIC_DRAW,!geometry.dynamic,material);geometry.verticesNeedUpdate=!1,geometry.morphTargetsNeedUpdate=!1,geometry.elementsNeedUpdate=!1,geometry.uvsNeedUpdate=!1,geometry.normalsNeedUpdate=!1,geometry.colorsNeedUpdate=!1,geometry.tangentsNeedUpdate=!1,geometry.buffersNeedUpdate=!1,material.attributes&&clearCustomAttributes(material)}else object instanceof THREE.Ribbon?(material=getBufferMaterial(object,geometry),customAttributesDirty=material.attributes&&areCustomAttributesDirty(material),(geometry.verticesNeedUpdate||geometry.colorsNeedUpdate||geometry.normalsNeedUpdate||customAttributesDirty)&&setRibbonBuffers(geometry,_gl.DYNAMIC_DRAW),geometry.verticesNeedUpdate=!1,geometry.colorsNeedUpdate=!1,geometry.normalsNeedUpdate=!1,material.attributes&&clearCustomAttributes(material)):object instanceof THREE.Line?(material=getBufferMaterial(object,geometry),customAttributesDirty=material.attributes&&areCustomAttributesDirty(material),(geometry.verticesNeedUpdate||geometry.colorsNeedUpdate||geometry.lineDistancesNeedUpdate||customAttributesDirty)&&setLineBuffers(geometry,_gl.DYNAMIC_DRAW),geometry.verticesNeedUpdate=!1,geometry.colorsNeedUpdate=!1,geometry.lineDistancesNeedUpdate=!1,material.attributes&&clearCustomAttributes(material)):object instanceof THREE.ParticleSystem&&(material=getBufferMaterial(object,geometry),customAttributesDirty=material.attributes&&areCustomAttributesDirty(material),(geometry.verticesNeedUpdate||geometry.colorsNeedUpdate||object.sortParticles||customAttributesDirty)&&setParticleBuffers(geometry,_gl.DYNAMIC_DRAW,object),geometry.verticesNeedUpdate=!1,geometry.colorsNeedUpdate=!1,material.attributes&&clearCustomAttributes(material))}function areCustomAttributesDirty(material){for(var a in material.attributes)if(material.attributes[a].needsUpdate)return!0;return!1}function clearCustomAttributes(material){for(var a in material.attributes)material.attributes[a].needsUpdate=!1}function removeObject(object,scene){object instanceof THREE.Mesh||object instanceof THREE.ParticleSystem||object instanceof THREE.Ribbon||object instanceof THREE.Line?removeInstances(scene.__webglObjects,object):object instanceof THREE.Sprite?removeInstancesDirect(scene.__webglSprites,object):object instanceof THREE.LensFlare?removeInstancesDirect(scene.__webglFlares,object):(object instanceof THREE.ImmediateRenderObject||object.immediateRenderCallback)&&removeInstances(scene.__webglObjectsImmediate,object),delete object.__webglActive}function removeInstances(objlist,object){for(var o=objlist.length-1;0<=o;o--)objlist[o].object===object&&objlist.splice(o,1)}function removeInstancesDirect(objlist,object){for(var o=objlist.length-1;0<=o;o--)objlist[o]===object&&objlist.splice(o,1)}function setMaterialShaders(material,shaders){material.uniforms=THREE.UniformsUtils.clone(shaders.uniforms),material.vertexShader=shaders.vertexShader,material.fragmentShader=shaders.fragmentShader}function setProgram(camera,lights,fog,material,object){_usedTextureUnits=0,material.needsUpdate&&(material.program&&deallocateMaterial(material),_this.initMaterial(material,lights,fog,object),material.needsUpdate=!1),material.morphTargets&&!object.__webglMorphTargetInfluences&&(object.__webglMorphTargetInfluences=new Float32Array(_this.maxMorphTargets));var refreshMaterial=!1,program=material.program,p_uniforms=program.uniforms,m_uniforms=material.uniforms;if(program!==_currentProgram&&(_gl.useProgram(program),_currentProgram=program,refreshMaterial=!0),material.id!==_currentMaterialId&&(_currentMaterialId=material.id,refreshMaterial=!0),(refreshMaterial||camera!==_currentCamera)&&(_gl.uniformMatrix4fv(p_uniforms.projectionMatrix,!1,camera.projectionMatrix.elements),camera!==_currentCamera&&(_currentCamera=camera)),material.skinning)if(!(_supportsBoneTextures&&object.useVertexTexture))null!==p_uniforms.boneGlobalMatrices&&_gl.uniformMatrix4fv(p_uniforms.boneGlobalMatrices,!1,object.boneMatrices);else if(null!==p_uniforms.boneTexture){var textureUnit=getTextureUnit();_gl.uniform1i(p_uniforms.boneTexture,textureUnit),_this.setTexture(object.boneTexture,textureUnit)}return refreshMaterial&&(fog&&material.fog&&refreshUniformsFog(m_uniforms,fog),(material instanceof THREE.MeshPhongMaterial||material instanceof THREE.MeshLambertMaterial||material.lights)&&(_lightsNeedUpdate&&(setupLights(program,lights),_lightsNeedUpdate=!1),refreshUniformsLights(m_uniforms,_lights)),(material instanceof THREE.MeshBasicMaterial||material instanceof THREE.MeshLambertMaterial||material instanceof THREE.MeshPhongMaterial)&&refreshUniformsCommon(m_uniforms,material),material instanceof THREE.LineBasicMaterial?refreshUniformsLine(m_uniforms,material):material instanceof THREE.LineDashedMaterial?(refreshUniformsLine(m_uniforms,material),refreshUniformsDash(m_uniforms,material)):material instanceof THREE.ParticleBasicMaterial?refreshUniformsParticle(m_uniforms,material):material instanceof THREE.MeshPhongMaterial?refreshUniformsPhong(m_uniforms,material):material instanceof THREE.MeshLambertMaterial?refreshUniformsLambert(m_uniforms,material):material instanceof THREE.MeshDepthMaterial?(m_uniforms.mNear.value=camera.near,m_uniforms.mFar.value=camera.far,m_uniforms.opacity.value=material.opacity):material instanceof THREE.MeshNormalMaterial&&(m_uniforms.opacity.value=material.opacity),object.receiveShadow&&!material._shadowPass&&refreshUniformsShadow(m_uniforms,lights),loadUniformsGeneric(program,material.uniformsList),(material instanceof THREE.ShaderMaterial||material instanceof THREE.MeshPhongMaterial||material.envMap)&&null!==p_uniforms.cameraPosition&&(_vector3.getPositionFromMatrix(camera.matrixWorld),_gl.uniform3f(p_uniforms.cameraPosition,_vector3.x,_vector3.y,_vector3.z)),(material instanceof THREE.MeshPhongMaterial||material instanceof THREE.MeshLambertMaterial||material instanceof THREE.ShaderMaterial||material.skinning)&&null!==p_uniforms.viewMatrix&&_gl.uniformMatrix4fv(p_uniforms.viewMatrix,!1,camera.matrixWorldInverse.elements)),loadUniformsMatrices(p_uniforms,object),null!==p_uniforms.modelMatrix&&_gl.uniformMatrix4fv(p_uniforms.modelMatrix,!1,object.matrixWorld.elements),program}function refreshUniformsCommon(uniforms,material){uniforms.opacity.value=material.opacity,_this.gammaInput?uniforms.diffuse.value.copyGammaToLinear(material.color):uniforms.diffuse.value=material.color,uniforms.map.value=material.map,uniforms.lightMap.value=material.lightMap,uniforms.specularMap.value=material.specularMap,material.bumpMap&&(uniforms.bumpMap.value=material.bumpMap,uniforms.bumpScale.value=material.bumpScale),material.normalMap&&(uniforms.normalMap.value=material.normalMap,uniforms.normalScale.value.copy(material.normalScale));var uvScaleMap;if(material.map?uvScaleMap=material.map:material.specularMap?uvScaleMap=material.specularMap:material.normalMap?uvScaleMap=material.normalMap:material.bumpMap&&(uvScaleMap=material.bumpMap),void 0!==uvScaleMap){var offset=uvScaleMap.offset,repeat=uvScaleMap.repeat;uniforms.offsetRepeat.value.set(offset.x,offset.y,repeat.x,repeat.y)}uniforms.envMap.value=material.envMap,uniforms.flipEnvMap.value=material.envMap instanceof THREE.WebGLRenderTargetCube?1:-1,uniforms.reflectivity.value=_this.gammaInput?material.reflectivity:material.reflectivity,uniforms.refractionRatio.value=material.refractionRatio,uniforms.combine.value=material.combine,uniforms.useRefract.value=material.envMap&&material.envMap.mapping instanceof THREE.CubeRefractionMapping}function refreshUniformsLine(uniforms,material){uniforms.diffuse.value=material.color,uniforms.opacity.value=material.opacity}function refreshUniformsDash(uniforms,material){uniforms.dashSize.value=material.dashSize,uniforms.totalSize.value=material.dashSize+material.gapSize,uniforms.scale.value=material.scale}function refreshUniformsParticle(uniforms,material){uniforms.psColor.value=material.color,uniforms.opacity.value=material.opacity,uniforms.size.value=material.size,uniforms.scale.value=_canvas.height/2,uniforms.map.value=material.map}function refreshUniformsFog(uniforms,fog){uniforms.fogColor.value=fog.color,fog instanceof THREE.Fog?(uniforms.fogNear.value=fog.near,uniforms.fogFar.value=fog.far):fog instanceof THREE.FogExp2&&(uniforms.fogDensity.value=fog.density)}function refreshUniformsPhong(uniforms,material){uniforms.shininess.value=material.shininess,_this.gammaInput?(uniforms.ambient.value.copyGammaToLinear(material.ambient),uniforms.emissive.value.copyGammaToLinear(material.emissive),uniforms.specular.value.copyGammaToLinear(material.specular)):(uniforms.ambient.value=material.ambient,uniforms.emissive.value=material.emissive,uniforms.specular.value=material.specular),material.wrapAround&&uniforms.wrapRGB.value.copy(material.wrapRGB)}function refreshUniformsLambert(uniforms,material){_this.gammaInput?(uniforms.ambient.value.copyGammaToLinear(material.ambient),uniforms.emissive.value.copyGammaToLinear(material.emissive)):(uniforms.ambient.value=material.ambient,uniforms.emissive.value=material.emissive),material.wrapAround&&uniforms.wrapRGB.value.copy(material.wrapRGB)}function refreshUniformsLights(uniforms,lights){uniforms.ambientLightColor.value=lights.ambient,uniforms.directionalLightColor.value=lights.directional.colors,uniforms.directionalLightDirection.value=lights.directional.positions,uniforms.pointLightColor.value=lights.point.colors,uniforms.pointLightPosition.value=lights.point.positions,uniforms.pointLightDistance.value=lights.point.distances,uniforms.spotLightColor.value=lights.spot.colors,uniforms.spotLightPosition.value=lights.spot.positions,uniforms.spotLightDistance.value=lights.spot.distances,uniforms.spotLightDirection.value=lights.spot.directions,uniforms.spotLightAngleCos.value=lights.spot.anglesCos,uniforms.spotLightExponent.value=lights.spot.exponents,uniforms.hemisphereLightSkyColor.value=lights.hemi.skyColors,uniforms.hemisphereLightGroundColor.value=lights.hemi.groundColors,uniforms.hemisphereLightDirection.value=lights.hemi.positions}function refreshUniformsShadow(uniforms,lights){if(uniforms.shadowMatrix)for(var j=0,i=0,il=lights.length,light;i<il;i++)light=lights[i],light.castShadow&&(light instanceof THREE.SpotLight||light instanceof THREE.DirectionalLight&&!light.shadowCascade)&&(uniforms.shadowMap.value[j]=light.shadowMap,uniforms.shadowMapSize.value[j]=light.shadowMapSize,uniforms.shadowMatrix.value[j]=light.shadowMatrix,uniforms.shadowDarkness.value[j]=light.shadowDarkness,uniforms.shadowBias.value[j]=light.shadowBias,j++)}function loadUniformsMatrices(uniforms,object){_gl.uniformMatrix4fv(uniforms.modelViewMatrix,!1,object._modelViewMatrix.elements),uniforms.normalMatrix&&_gl.uniformMatrix3fv(uniforms.normalMatrix,!1,object._normalMatrix.elements)}function getTextureUnit(){var textureUnit=_usedTextureUnits;return textureUnit>=_maxTextures&&console.warn('WebGLRenderer: trying to use '+textureUnit+' texture units while this GPU supports only '+_maxTextures),_usedTextureUnits+=1,textureUnit}function loadUniformsGeneric(program,uniforms){var uniform,value,type,location,texture,textureUnit,i,il,j,jl,offset;for(j=0,jl=uniforms.length;j<jl;j++)if(location=program.uniforms[uniforms[j][1]],location)if(uniform=uniforms[j][0],type=uniform.type,value=uniform.value,'i'===type)_gl.uniform1i(location,value);else if('f'===type)_gl.uniform1f(location,value);else if('v2'===type)_gl.uniform2f(location,value.x,value.y);else if('v3'===type)_gl.uniform3f(location,value.x,value.y,value.z);else if('v4'===type)_gl.uniform4f(location,value.x,value.y,value.z,value.w);else if('c'===type)_gl.uniform3f(location,value.r,value.g,value.b);else if('iv1'===type)_gl.uniform1iv(location,value);else if('iv'===type)_gl.uniform3iv(location,value);else if('fv1'===type)_gl.uniform1fv(location,value);else if('fv'===type)_gl.uniform3fv(location,value);else if('v2v'===type){for(void 0===uniform._array&&(uniform._array=new Float32Array(2*value.length)),i=0,il=value.length;i<il;i++)offset=2*i,uniform._array[offset]=value[i].x,uniform._array[offset+1]=value[i].y;_gl.uniform2fv(location,uniform._array)}else if('v3v'===type){for(void 0===uniform._array&&(uniform._array=new Float32Array(3*value.length)),i=0,il=value.length;i<il;i++)offset=3*i,uniform._array[offset]=value[i].x,uniform._array[offset+1]=value[i].y,uniform._array[offset+2]=value[i].z;_gl.uniform3fv(location,uniform._array)}else if('v4v'===type){for(void 0===uniform._array&&(uniform._array=new Float32Array(4*value.length)),i=0,il=value.length;i<il;i++)offset=4*i,uniform._array[offset]=value[i].x,uniform._array[offset+1]=value[i].y,uniform._array[offset+2]=value[i].z,uniform._array[offset+3]=value[i].w;_gl.uniform4fv(location,uniform._array)}else if('m4'===type)void 0===uniform._array&&(uniform._array=new Float32Array(16)),value.flattenToArray(uniform._array),_gl.uniformMatrix4fv(location,!1,uniform._array);else if('m4v'===type){for(void 0===uniform._array&&(uniform._array=new Float32Array(16*value.length)),i=0,il=value.length;i<il;i++)value[i].flattenToArrayOffset(uniform._array,16*i);_gl.uniformMatrix4fv(location,!1,uniform._array)}else if('t'===type){if(texture=value,textureUnit=getTextureUnit(),_gl.uniform1i(location,textureUnit),!texture)continue;texture.image instanceof Array&&6===texture.image.length?setCubeTexture(texture,textureUnit):texture instanceof THREE.WebGLRenderTargetCube?setCubeTextureDynamic(texture,textureUnit):_this.setTexture(texture,textureUnit)}else if('tv'===type){for(void 0===uniform._array&&(uniform._array=[]),i=0,il=uniform.value.length;i<il;i++)uniform._array[i]=getTextureUnit();for(_gl.uniform1iv(location,uniform._array),i=0,il=uniform.value.length;i<il;i++)texture=uniform.value[i],textureUnit=uniform._array[i],texture&&_this.setTexture(texture,textureUnit)}else console.warn('THREE.WebGLRenderer: Unknown uniform type: '+type)}function setupMatrices(object,camera){object._modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse,object.matrixWorld),object._normalMatrix.getNormalMatrix(object._modelViewMatrix)}function setColorGamma(array,offset,color,intensitySq){array[offset]=color.r*color.r*intensitySq,array[offset+1]=color.g*color.g*intensitySq,array[offset+2]=color.b*color.b*intensitySq}function setColorLinear(array,offset,color,intensity){array[offset]=color.r*intensity,array[offset+1]=color.g*intensity,array[offset+2]=color.b*intensity}function setupLights(program,lights){var r=0,g=0,b=0,zlights=_lights,dirColors=zlights.directional.colors,dirPositions=zlights.directional.positions,pointColors=zlights.point.colors,pointPositions=zlights.point.positions,pointDistances=zlights.point.distances,spotColors=zlights.spot.colors,spotPositions=zlights.spot.positions,spotDistances=zlights.spot.distances,spotDirections=zlights.spot.directions,spotAnglesCos=zlights.spot.anglesCos,spotExponents=zlights.spot.exponents,hemiSkyColors=zlights.hemi.skyColors,hemiGroundColors=zlights.hemi.groundColors,hemiPositions=zlights.hemi.positions,dirLength=0,pointLength=0,spotLength=0,hemiLength=0,dirCount=0,pointCount=0,spotCount=0,hemiCount=0,dirOffset=0,pointOffset=0,spotOffset=0,hemiOffset=0,l,ll,light,color,skyColor,groundColor,intensity,intensitySq,distance;for(l=0,ll=lights.length;l<ll;l++)if(light=lights[l],!light.onlyShadow)if(color=light.color,intensity=light.intensity,distance=light.distance,light instanceof THREE.AmbientLight){if(!light.visible)continue;_this.gammaInput?(r+=color.r*color.r,g+=color.g*color.g,b+=color.b*color.b):(r+=color.r,g+=color.g,b+=color.b)}else if(light instanceof THREE.DirectionalLight){if(dirCount+=1,!light.visible)continue;if(_direction.getPositionFromMatrix(light.matrixWorld),_vector3.getPositionFromMatrix(light.target.matrixWorld),_direction.sub(_vector3),_direction.normalize(),0===_direction.x&&0===_direction.y&&0===_direction.z)continue;dirOffset=3*dirLength,dirPositions[dirOffset]=_direction.x,dirPositions[dirOffset+1]=_direction.y,dirPositions[dirOffset+2]=_direction.z,_this.gammaInput?setColorGamma(dirColors,dirOffset,color,intensity*intensity):setColorLinear(dirColors,dirOffset,color,intensity),dirLength+=1}else if(light instanceof THREE.PointLight){if(pointCount+=1,!light.visible)continue;pointOffset=3*pointLength,_this.gammaInput?setColorGamma(pointColors,pointOffset,color,intensity*intensity):setColorLinear(pointColors,pointOffset,color,intensity),_vector3.getPositionFromMatrix(light.matrixWorld),pointPositions[pointOffset]=_vector3.x,pointPositions[pointOffset+1]=_vector3.y,pointPositions[pointOffset+2]=_vector3.z,pointDistances[pointLength]=distance,pointLength+=1}else if(light instanceof THREE.SpotLight){if(spotCount+=1,!light.visible)continue;spotOffset=3*spotLength,_this.gammaInput?setColorGamma(spotColors,spotOffset,color,intensity*intensity):setColorLinear(spotColors,spotOffset,color,intensity),_vector3.getPositionFromMatrix(light.matrixWorld),spotPositions[spotOffset]=_vector3.x,spotPositions[spotOffset+1]=_vector3.y,spotPositions[spotOffset+2]=_vector3.z,spotDistances[spotLength]=distance,_direction.copy(_vector3),_vector3.getPositionFromMatrix(light.target.matrixWorld),_direction.sub(_vector3),_direction.normalize(),spotDirections[spotOffset]=_direction.x,spotDirections[spotOffset+1]=_direction.y,spotDirections[spotOffset+2]=_direction.z,spotAnglesCos[spotLength]=Math.cos(light.angle),spotExponents[spotLength]=light.exponent,spotLength+=1}else if(light instanceof THREE.HemisphereLight){if(hemiCount+=1,!light.visible)continue;if(_direction.getPositionFromMatrix(light.matrixWorld),_direction.normalize(),0===_direction.x&&0===_direction.y&&0===_direction.z)continue;hemiOffset=3*hemiLength,hemiPositions[hemiOffset]=_direction.x,hemiPositions[hemiOffset+1]=_direction.y,hemiPositions[hemiOffset+2]=_direction.z,skyColor=light.color,groundColor=light.groundColor,_this.gammaInput?(intensitySq=intensity*intensity,setColorGamma(hemiSkyColors,hemiOffset,skyColor,intensitySq),setColorGamma(hemiGroundColors,hemiOffset,groundColor,intensitySq)):(setColorLinear(hemiSkyColors,hemiOffset,skyColor,intensity),setColorLinear(hemiGroundColors,hemiOffset,groundColor,intensity)),hemiLength+=1}for(l=3*dirLength,ll=_Mathmax4(dirColors.length,3*dirCount);l<ll;l++)dirColors[l]=0;for(l=3*pointLength,ll=_Mathmax4(pointColors.length,3*pointCount);l<ll;l++)pointColors[l]=0;for(l=3*spotLength,ll=_Mathmax4(spotColors.length,3*spotCount);l<ll;l++)spotColors[l]=0;for(l=3*hemiLength,ll=_Mathmax4(hemiSkyColors.length,3*hemiCount);l<ll;l++)hemiSkyColors[l]=0;for(l=3*hemiLength,ll=_Mathmax4(hemiGroundColors.length,3*hemiCount);l<ll;l++)hemiGroundColors[l]=0;zlights.directional.length=dirLength,zlights.point.length=pointLength,zlights.spot.length=spotLength,zlights.hemi.length=hemiLength,zlights.ambient[0]=r,zlights.ambient[1]=g,zlights.ambient[2]=b}function setLineWidth(width){width!==_oldLineWidth&&(_gl.lineWidth(width),_oldLineWidth=width)}function setPolygonOffset(polygonoffset,factor,units){_oldPolygonOffset!==polygonoffset&&(polygonoffset?_gl.enable(_gl.POLYGON_OFFSET_FILL):_gl.disable(_gl.POLYGON_OFFSET_FILL),_oldPolygonOffset=polygonoffset),polygonoffset&&(_oldPolygonOffsetFactor!==factor||_oldPolygonOffsetUnits!==units)&&(_gl.polygonOffset(factor,units),_oldPolygonOffsetFactor=factor,_oldPolygonOffsetUnits=units)}function generateDefines(defines){var chunks=[],value,chunk;for(var d in defines)value=defines[d],!1===value||(chunk='#define '+d+' '+value,chunks.push(chunk));return chunks.join('\n')}function buildProgram(shaderID,fragmentShader,vertexShader,uniforms,attributes,defines,parameters,index0AttributeName){var chunks=[],p,pl,d,program,code;for(d in shaderID?chunks.push(shaderID):(chunks.push(fragmentShader),chunks.push(vertexShader)),defines)chunks.push(d),chunks.push(defines[d]);for(p in parameters)chunks.push(p),chunks.push(parameters[p]);for(code=chunks.join(),p=0,pl=_programs.length;p<pl;p++){var programInfo=_programs[p];if(programInfo.code===code)return programInfo.usedTimes++,programInfo.program}var shadowMapTypeDefine='SHADOWMAP_TYPE_BASIC';parameters.shadowMapType===THREE.PCFShadowMap?shadowMapTypeDefine='SHADOWMAP_TYPE_PCF':parameters.shadowMapType===THREE.PCFSoftShadowMap&&(shadowMapTypeDefine='SHADOWMAP_TYPE_PCF_SOFT');var customDefines=generateDefines(defines);program=_gl.createProgram();var prefix_vertex=['precision '+_precision+' float;','precision '+_precision+' int;',customDefines,_supportsVertexTextures?'#define VERTEX_TEXTURES':'',_this.gammaInput?'#define GAMMA_INPUT':'',_this.gammaOutput?'#define GAMMA_OUTPUT':'',_this.physicallyBasedShading?'#define PHYSICALLY_BASED_SHADING':'','#define MAX_DIR_LIGHTS '+parameters.maxDirLights,'#define MAX_POINT_LIGHTS '+parameters.maxPointLights,'#define MAX_SPOT_LIGHTS '+parameters.maxSpotLights,'#define MAX_HEMI_LIGHTS '+parameters.maxHemiLights,'#define MAX_SHADOWS '+parameters.maxShadows,'#define MAX_BONES '+parameters.maxBones,parameters.map?'#define USE_MAP':'',parameters.envMap?'#define USE_ENVMAP':'',parameters.lightMap?'#define USE_LIGHTMAP':'',parameters.bumpMap?'#define USE_BUMPMAP':'',parameters.normalMap?'#define USE_NORMALMAP':'',parameters.specularMap?'#define USE_SPECULARMAP':'',parameters.vertexColors?'#define USE_COLOR':'',parameters.skinning?'#define USE_SKINNING':'',parameters.useVertexTexture?'#define BONE_TEXTURE':'',parameters.boneTextureWidth?'#define N_BONE_PIXEL_X '+parameters.boneTextureWidth.toFixed(1):'',parameters.boneTextureHeight?'#define N_BONE_PIXEL_Y '+parameters.boneTextureHeight.toFixed(1):'',parameters.morphTargets?'#define USE_MORPHTARGETS':'',parameters.morphNormals?'#define USE_MORPHNORMALS':'',parameters.perPixel?'#define PHONG_PER_PIXEL':'',parameters.wrapAround?'#define WRAP_AROUND':'',parameters.doubleSided?'#define DOUBLE_SIDED':'',parameters.flipSided?'#define FLIP_SIDED':'',parameters.shadowMapEnabled?'#define USE_SHADOWMAP':'',parameters.shadowMapEnabled?'#define '+shadowMapTypeDefine:'',parameters.shadowMapDebug?'#define SHADOWMAP_DEBUG':'',parameters.shadowMapCascade?'#define SHADOWMAP_CASCADE':'',parameters.sizeAttenuation?'#define USE_SIZEATTENUATION':'','uniform mat4 modelMatrix;','uniform mat4 modelViewMatrix;','uniform mat4 projectionMatrix;','uniform mat4 viewMatrix;','uniform mat3 normalMatrix;','uniform vec3 cameraPosition;','attribute vec3 position;','attribute vec3 normal;','attribute vec2 uv;','attribute vec2 uv2;','#ifdef USE_COLOR','attribute vec3 color;','#endif','#ifdef USE_MORPHTARGETS','attribute vec3 morphTarget0;','attribute vec3 morphTarget1;','attribute vec3 morphTarget2;','attribute vec3 morphTarget3;','#ifdef USE_MORPHNORMALS','attribute vec3 morphNormal0;','attribute vec3 morphNormal1;','attribute vec3 morphNormal2;','attribute vec3 morphNormal3;','#else','attribute vec3 morphTarget4;','attribute vec3 morphTarget5;','attribute vec3 morphTarget6;','attribute vec3 morphTarget7;','#endif','#endif','#ifdef USE_SKINNING','attribute vec4 skinIndex;','attribute vec4 skinWeight;','#endif',''].join('\n'),prefix_fragment=['precision '+_precision+' float;','precision '+_precision+' int;',parameters.bumpMap||parameters.normalMap?'#extension GL_OES_standard_derivatives : enable':'',customDefines,'#define MAX_DIR_LIGHTS '+parameters.maxDirLights,'#define MAX_POINT_LIGHTS '+parameters.maxPointLights,'#define MAX_SPOT_LIGHTS '+parameters.maxSpotLights,'#define MAX_HEMI_LIGHTS '+parameters.maxHemiLights,'#define MAX_SHADOWS '+parameters.maxShadows,parameters.alphaTest?'#define ALPHATEST '+parameters.alphaTest:'',_this.gammaInput?'#define GAMMA_INPUT':'',_this.gammaOutput?'#define GAMMA_OUTPUT':'',_this.physicallyBasedShading?'#define PHYSICALLY_BASED_SHADING':'',parameters.useFog&&parameters.fog?'#define USE_FOG':'',parameters.useFog&&parameters.fogExp?'#define FOG_EXP2':'',parameters.map?'#define USE_MAP':'',parameters.envMap?'#define USE_ENVMAP':'',parameters.lightMap?'#define USE_LIGHTMAP':'',parameters.bumpMap?'#define USE_BUMPMAP':'',parameters.normalMap?'#define USE_NORMALMAP':'',parameters.specularMap?'#define USE_SPECULARMAP':'',parameters.vertexColors?'#define USE_COLOR':'',parameters.metal?'#define METAL':'',parameters.perPixel?'#define PHONG_PER_PIXEL':'',parameters.wrapAround?'#define WRAP_AROUND':'',parameters.doubleSided?'#define DOUBLE_SIDED':'',parameters.flipSided?'#define FLIP_SIDED':'',parameters.shadowMapEnabled?'#define USE_SHADOWMAP':'',parameters.shadowMapEnabled?'#define '+shadowMapTypeDefine:'',parameters.shadowMapDebug?'#define SHADOWMAP_DEBUG':'',parameters.shadowMapCascade?'#define SHADOWMAP_CASCADE':'','uniform mat4 viewMatrix;','uniform vec3 cameraPosition;',''].join('\n'),glVertexShader=getShader('vertex',prefix_vertex+vertexShader),glFragmentShader=getShader('fragment',prefix_fragment+fragmentShader);_gl.attachShader(program,glVertexShader),_gl.attachShader(program,glFragmentShader),index0AttributeName&&_gl.bindAttribLocation(program,0,index0AttributeName),_gl.linkProgram(program),_gl.getProgramParameter(program,_gl.LINK_STATUS)||(console.error('Could not initialise shader\nVALIDATE_STATUS: '+_gl.getProgramParameter(program,_gl.VALIDATE_STATUS)+', gl error ['+_gl.getError()+']'),console.error('Program Info Log: '+_gl.getProgramInfoLog(program))),_gl.deleteShader(glFragmentShader),_gl.deleteShader(glVertexShader),program.uniforms={},program.attributes={};var identifiers,u,a,i;for(u in identifiers=['viewMatrix','modelViewMatrix','projectionMatrix','normalMatrix','modelMatrix','cameraPosition','morphTargetInfluences'],parameters.useVertexTexture?identifiers.push('boneTexture'):identifiers.push('boneGlobalMatrices'),uniforms)identifiers.push(u);for(cacheUniformLocations(program,identifiers),identifiers=['position','normal','uv','uv2','tangent','color','skinIndex','skinWeight','lineDistance'],i=0;i<parameters.maxMorphTargets;i++)identifiers.push('morphTarget'+i);for(i=0;i<parameters.maxMorphNormals;i++)identifiers.push('morphNormal'+i);for(a in attributes)identifiers.push(a);return cacheAttributeLocations(program,identifiers),program.id=_programs_counter++,_programs.push({program:program,code:code,usedTimes:1}),_this.info.memory.programs=_programs.length,program}function cacheUniformLocations(program,identifiers){var i,l,id;for(i=0,l=identifiers.length;i<l;i++)id=identifiers[i],program.uniforms[id]=_gl.getUniformLocation(program,id)}function cacheAttributeLocations(program,identifiers){var i,l,id;for(i=0,l=identifiers.length;i<l;i++)id=identifiers[i],program.attributes[id]=_gl.getAttribLocation(program,id)}function addLineNumbers(string){for(var chunks=string.split('\n'),i=0,il=chunks.length;i<il;i++)chunks[i]=i+1+': '+chunks[i];return chunks.join('\n')}function getShader(type,string){var shader;return'fragment'===type?shader=_gl.createShader(_gl.FRAGMENT_SHADER):'vertex'==type&&(shader=_gl.createShader(_gl.VERTEX_SHADER)),_gl.shaderSource(shader,string),_gl.compileShader(shader),_gl.getShaderParameter(shader,_gl.COMPILE_STATUS)?shader:(console.error(_gl.getShaderInfoLog(shader)),console.error(addLineNumbers(string)),null)}function isPowerOfTwo(value){return 0==(value&value-1)}function setTextureParameters(textureType,texture,isImagePowerOfTwo){isImagePowerOfTwo?(_gl.texParameteri(textureType,_gl.TEXTURE_WRAP_S,paramThreeToGL(texture.wrapS)),_gl.texParameteri(textureType,_gl.TEXTURE_WRAP_T,paramThreeToGL(texture.wrapT)),_gl.texParameteri(textureType,_gl.TEXTURE_MAG_FILTER,paramThreeToGL(texture.magFilter)),_gl.texParameteri(textureType,_gl.TEXTURE_MIN_FILTER,paramThreeToGL(texture.minFilter))):(_gl.texParameteri(textureType,_gl.TEXTURE_WRAP_S,_gl.CLAMP_TO_EDGE),_gl.texParameteri(textureType,_gl.TEXTURE_WRAP_T,_gl.CLAMP_TO_EDGE),_gl.texParameteri(textureType,_gl.TEXTURE_MAG_FILTER,filterFallback(texture.magFilter)),_gl.texParameteri(textureType,_gl.TEXTURE_MIN_FILTER,filterFallback(texture.minFilter))),_glExtensionTextureFilterAnisotropic&&texture.type!==THREE.FloatType&&(1<texture.anisotropy||texture.__oldAnisotropy)&&(_gl.texParameterf(textureType,_glExtensionTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,_Mathmin4(texture.anisotropy,_maxAnisotropy)),texture.__oldAnisotropy=texture.anisotropy)}function clampToMaxSize(image,maxSize){if(image.width<=maxSize&&image.height<=maxSize)return image;var maxDimension=_Mathmax4(image.width,image.height),newWidth=_Mathfloor3(image.width*maxSize/maxDimension),newHeight=_Mathfloor3(image.height*maxSize/maxDimension),canvas=document.createElement('canvas');canvas.width=newWidth,canvas.height=newHeight;var ctx=canvas.getContext('2d');return ctx.drawImage(image,0,0,image.width,image.height,0,0,newWidth,newHeight),canvas}function setCubeTexture(texture,slot){if(6===texture.image.length)if(texture.needsUpdate){texture.image.__webglTextureCube||(texture.addEventListener('dispose',onTextureDispose),texture.image.__webglTextureCube=_gl.createTexture(),_this.info.memory.textures++),_gl.activeTexture(_gl.TEXTURE0+slot),_gl.bindTexture(_gl.TEXTURE_CUBE_MAP,texture.image.__webglTextureCube),_gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL,texture.flipY);for(var isCompressed=texture instanceof THREE.CompressedTexture,cubeImage=[],i=0;6>i;i++)cubeImage[i]=_this.autoScaleCubemaps&&!isCompressed?clampToMaxSize(texture.image[i],_maxCubemapSize):texture.image[i];var image=cubeImage[0],isImagePowerOfTwo=isPowerOfTwo(image.width)&&isPowerOfTwo(image.height),glFormat=paramThreeToGL(texture.format),glType=paramThreeToGL(texture.type);setTextureParameters(_gl.TEXTURE_CUBE_MAP,texture,isImagePowerOfTwo);for(var i=0;6>i;i++)if(isCompressed)for(var mipmaps=cubeImage[i].mipmaps,j=0,jl=mipmaps.length,mipmap;j<jl;j++)mipmap=mipmaps[j],_gl.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X+i,j,glFormat,mipmap.width,mipmap.height,0,mipmap.data);else _gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X+i,0,glFormat,glFormat,glType,cubeImage[i]);texture.generateMipmaps&&isImagePowerOfTwo&&_gl.generateMipmap(_gl.TEXTURE_CUBE_MAP),texture.needsUpdate=!1,texture.onUpdate&&texture.onUpdate()}else _gl.activeTexture(_gl.TEXTURE0+slot),_gl.bindTexture(_gl.TEXTURE_CUBE_MAP,texture.image.__webglTextureCube)}function setCubeTextureDynamic(texture,slot){_gl.activeTexture(_gl.TEXTURE0+slot),_gl.bindTexture(_gl.TEXTURE_CUBE_MAP,texture.__webglTexture)}function setupFrameBuffer(framebuffer,renderTarget,textureTarget){_gl.bindFramebuffer(_gl.FRAMEBUFFER,framebuffer),_gl.framebufferTexture2D(_gl.FRAMEBUFFER,_gl.COLOR_ATTACHMENT0,textureTarget,renderTarget.__webglTexture,0)}function setupRenderBuffer(renderbuffer,renderTarget){_gl.bindRenderbuffer(_gl.RENDERBUFFER,renderbuffer),renderTarget.depthBuffer&&!renderTarget.stencilBuffer?(_gl.renderbufferStorage(_gl.RENDERBUFFER,_gl.DEPTH_COMPONENT16,renderTarget.width,renderTarget.height),_gl.framebufferRenderbuffer(_gl.FRAMEBUFFER,_gl.DEPTH_ATTACHMENT,_gl.RENDERBUFFER,renderbuffer)):renderTarget.depthBuffer&&renderTarget.stencilBuffer?(_gl.renderbufferStorage(_gl.RENDERBUFFER,_gl.DEPTH_STENCIL,renderTarget.width,renderTarget.height),_gl.framebufferRenderbuffer(_gl.FRAMEBUFFER,_gl.DEPTH_STENCIL_ATTACHMENT,_gl.RENDERBUFFER,renderbuffer)):_gl.renderbufferStorage(_gl.RENDERBUFFER,_gl.RGBA4,renderTarget.width,renderTarget.height)}function updateRenderTargetMipmap(renderTarget){renderTarget instanceof THREE.WebGLRenderTargetCube?(_gl.bindTexture(_gl.TEXTURE_CUBE_MAP,renderTarget.__webglTexture),_gl.generateMipmap(_gl.TEXTURE_CUBE_MAP),_gl.bindTexture(_gl.TEXTURE_CUBE_MAP,null)):(_gl.bindTexture(_gl.TEXTURE_2D,renderTarget.__webglTexture),_gl.generateMipmap(_gl.TEXTURE_2D),_gl.bindTexture(_gl.TEXTURE_2D,null))}function filterFallback(f){return f===THREE.NearestFilter||f===THREE.NearestMipMapNearestFilter||f===THREE.NearestMipMapLinearFilter?_gl.NEAREST:_gl.LINEAR}function paramThreeToGL(p){if(p===THREE.RepeatWrapping)return _gl.REPEAT;if(p===THREE.ClampToEdgeWrapping)return _gl.CLAMP_TO_EDGE;if(p===THREE.MirroredRepeatWrapping)return _gl.MIRRORED_REPEAT;if(p===THREE.NearestFilter)return _gl.NEAREST;if(p===THREE.NearestMipMapNearestFilter)return _gl.NEAREST_MIPMAP_NEAREST;if(p===THREE.NearestMipMapLinearFilter)return _gl.NEAREST_MIPMAP_LINEAR;if(p===THREE.LinearFilter)return _gl.LINEAR;if(p===THREE.LinearMipMapNearestFilter)return _gl.LINEAR_MIPMAP_NEAREST;if(p===THREE.LinearMipMapLinearFilter)return _gl.LINEAR_MIPMAP_LINEAR;if(p===THREE.UnsignedByteType)return _gl.UNSIGNED_BYTE;if(p===THREE.UnsignedShort4444Type)return _gl.UNSIGNED_SHORT_4_4_4_4;if(p===THREE.UnsignedShort5551Type)return _gl.UNSIGNED_SHORT_5_5_5_1;if(p===THREE.UnsignedShort565Type)return _gl.UNSIGNED_SHORT_5_6_5;if(p===THREE.ByteType)return _gl.BYTE;if(p===THREE.ShortType)return _gl.SHORT;if(p===THREE.UnsignedShortType)return _gl.UNSIGNED_SHORT;if(p===THREE.IntType)return _gl.INT;if(p===THREE.UnsignedIntType)return _gl.UNSIGNED_INT;if(p===THREE.FloatType)return _gl.FLOAT;if(p===THREE.AlphaFormat)return _gl.ALPHA;if(p===THREE.RGBFormat)return _gl.RGB;if(p===THREE.RGBAFormat)return _gl.RGBA;if(p===THREE.LuminanceFormat)return _gl.LUMINANCE;if(p===THREE.LuminanceAlphaFormat)return _gl.LUMINANCE_ALPHA;if(p===THREE.AddEquation)return _gl.FUNC_ADD;if(p===THREE.SubtractEquation)return _gl.FUNC_SUBTRACT;if(p===THREE.ReverseSubtractEquation)return _gl.FUNC_REVERSE_SUBTRACT;if(p===THREE.ZeroFactor)return _gl.ZERO;if(p===THREE.OneFactor)return _gl.ONE;if(p===THREE.SrcColorFactor)return _gl.SRC_COLOR;if(p===THREE.OneMinusSrcColorFactor)return _gl.ONE_MINUS_SRC_COLOR;if(p===THREE.SrcAlphaFactor)return _gl.SRC_ALPHA;if(p===THREE.OneMinusSrcAlphaFactor)return _gl.ONE_MINUS_SRC_ALPHA;if(p===THREE.DstAlphaFactor)return _gl.DST_ALPHA;if(p===THREE.OneMinusDstAlphaFactor)return _gl.ONE_MINUS_DST_ALPHA;if(p===THREE.DstColorFactor)return _gl.DST_COLOR;if(p===THREE.OneMinusDstColorFactor)return _gl.ONE_MINUS_DST_COLOR;if(p===THREE.SrcAlphaSaturateFactor)return _gl.SRC_ALPHA_SATURATE;if(void 0!==_glExtensionCompressedTextureS3TC){if(p===THREE.RGB_S3TC_DXT1_Format)return _glExtensionCompressedTextureS3TC.COMPRESSED_RGB_S3TC_DXT1_EXT;if(p===THREE.RGBA_S3TC_DXT1_Format)return _glExtensionCompressedTextureS3TC.COMPRESSED_RGBA_S3TC_DXT1_EXT;if(p===THREE.RGBA_S3TC_DXT3_Format)return _glExtensionCompressedTextureS3TC.COMPRESSED_RGBA_S3TC_DXT3_EXT;if(p===THREE.RGBA_S3TC_DXT5_Format)return _glExtensionCompressedTextureS3TC.COMPRESSED_RGBA_S3TC_DXT5_EXT}return 0}function allocateBones(object){if(_supportsBoneTextures&&object&&object.useVertexTexture)return 1024;var nVertexUniforms=_gl.getParameter(_gl.MAX_VERTEX_UNIFORM_VECTORS),nVertexMatrices=_Mathfloor3((nVertexUniforms-20)/4),maxBones=nVertexMatrices;return void 0!==object&&object instanceof THREE.SkinnedMesh&&(maxBones=_Mathmin4(object.bones.length,maxBones),maxBones<object.bones.length&&console.warn('WebGLRenderer: too many bones - '+object.bones.length+', this GPU supports just '+maxBones+' (try OpenGL instead of ANGLE)')),maxBones}function allocateLights(lights){for(var dirLights=0,pointLights=0,spotLights=0,hemiLights=0,l=0,ll=lights.length,light;l<ll;l++)light=lights[l],light.onlyShadow||(light instanceof THREE.DirectionalLight&&dirLights++,light instanceof THREE.PointLight&&pointLights++,light instanceof THREE.SpotLight&&spotLights++,light instanceof THREE.HemisphereLight&&hemiLights++);return{directional:dirLights,point:pointLights,spot:spotLights,hemi:hemiLights}}function allocateShadows(lights){for(var maxShadows=0,l=0,ll=lights.length,light;l<ll;l++)light=lights[l],light.castShadow&&(light instanceof THREE.SpotLight&&maxShadows++,light instanceof THREE.DirectionalLight&&!light.shadowCascade&&maxShadows++);return maxShadows}function initGL(){try{var attributes={alpha:_alpha,premultipliedAlpha:_premultipliedAlpha,antialias:_antialias,stencil:_stencil,preserveDrawingBuffer:_preserveDrawingBuffer};if(_gl=_canvas.getContext('webgl',attributes)||_canvas.getContext('experimental-webgl',attributes),null===_gl)throw'Error creating WebGL context.'}catch(error){console.error(error)}_glExtensionTextureFloat=_gl.getExtension('OES_texture_float'),_glExtensionTextureFloatLinear=_gl.getExtension('OES_texture_float_linear'),_glExtensionStandardDerivatives=_gl.getExtension('OES_standard_derivatives'),_glExtensionTextureFilterAnisotropic=_gl.getExtension('EXT_texture_filter_anisotropic')||_gl.getExtension('MOZ_EXT_texture_filter_anisotropic')||_gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic'),_glExtensionCompressedTextureS3TC=_gl.getExtension('WEBGL_compressed_texture_s3tc')||_gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc')||_gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc'),_glExtensionTextureFloat||console.log('THREE.WebGLRenderer: Float textures not supported.'),_glExtensionStandardDerivatives||console.log('THREE.WebGLRenderer: Standard derivatives not supported.'),_glExtensionTextureFilterAnisotropic||console.log('THREE.WebGLRenderer: Anisotropic texture filtering not supported.'),_glExtensionCompressedTextureS3TC||console.log('THREE.WebGLRenderer: S3TC compressed textures not supported.'),_gl.getShaderPrecisionFormat===void 0&&(_gl.getShaderPrecisionFormat=function(){return{rangeMin:1,rangeMax:1,precision:1}})}function setDefaultGLState(){_gl.clearColor(0,0,0,1),_gl.clearDepth(1),_gl.clearStencil(0),_gl.enable(_gl.DEPTH_TEST),_gl.depthFunc(_gl.LEQUAL),_gl.frontFace(_gl.CCW),_gl.cullFace(_gl.BACK),_gl.enable(_gl.CULL_FACE),_gl.enable(_gl.BLEND),_gl.blendEquation(_gl.FUNC_ADD),_gl.blendFunc(_gl.SRC_ALPHA,_gl.ONE_MINUS_SRC_ALPHA),_gl.clearColor(_clearColor.r,_clearColor.g,_clearColor.b,_clearAlpha)}var _Mathmin4=Math.min,_Mathfloor3=Math.floor,_Mathmax4=Math.max;console.log('THREE.WebGLRenderer',THREE.REVISION),parameters=parameters||{};var _canvas=parameters.canvas===void 0?document.createElement('canvas'):parameters.canvas,_precision=parameters.precision===void 0?'highp':parameters.precision,_alpha=!(parameters.alpha!==void 0)||parameters.alpha,_premultipliedAlpha=!(parameters.premultipliedAlpha!==void 0)||parameters.premultipliedAlpha,_antialias=parameters.antialias!==void 0&&parameters.antialias,_stencil=!(parameters.stencil!==void 0)||parameters.stencil,_preserveDrawingBuffer=parameters.preserveDrawingBuffer!==void 0&&parameters.preserveDrawingBuffer,_clearColor=new THREE.Color(0),_clearAlpha=0;parameters.clearColor!==void 0&&(console.warn('DEPRECATED: clearColor in WebGLRenderer constructor parameters is being removed. Use .setClearColor() instead.'),_clearColor.setHex(parameters.clearColor)),parameters.clearAlpha!==void 0&&(console.warn('DEPRECATED: clearAlpha in WebGLRenderer constructor parameters is being removed. Use .setClearColor() instead.'),_clearAlpha=parameters.clearAlpha),this.domElement=_canvas,this.context=null,this.devicePixelRatio=parameters.devicePixelRatio===void 0?window.devicePixelRatio===void 0?1:window.devicePixelRatio:parameters.devicePixelRatio,this.autoClear=!0,this.autoClearColor=!0,this.autoClearDepth=!0,this.autoClearStencil=!0,this.sortObjects=!0,this.autoUpdateObjects=!0,this.gammaInput=!1,this.gammaOutput=!1,this.physicallyBasedShading=!1,this.shadowMapEnabled=!1,this.shadowMapAutoUpdate=!0,this.shadowMapType=THREE.PCFShadowMap,this.shadowMapCullFace=THREE.CullFaceFront,this.shadowMapDebug=!1,this.shadowMapCascade=!1,this.maxMorphTargets=8,this.maxMorphNormals=4,this.autoScaleCubemaps=!0,this.renderPluginsPre=[],this.renderPluginsPost=[],this.info={memory:{programs:0,geometries:0,textures:0},render:{calls:0,vertices:0,faces:0,points:0}};var _this=this,_programs=[],_programs_counter=0,_currentProgram=null,_currentFramebuffer=null,_currentMaterialId=-1,_currentGeometryGroupHash=null,_currentCamera=null,_geometryGroupCounter=0,_usedTextureUnits=0,_oldDoubleSided=-1,_oldFlipSided=-1,_oldBlending=-1,_oldBlendEquation=-1,_oldBlendSrc=-1,_oldBlendDst=-1,_oldDepthTest=-1,_oldDepthWrite=-1,_oldPolygonOffset=null,_oldPolygonOffsetFactor=null,_oldPolygonOffsetUnits=null,_oldLineWidth=null,_viewportX=0,_viewportY=0,_viewportWidth=0,_viewportHeight=0,_currentWidth=0,_currentHeight=0,_enabledAttributes={},_frustum=new THREE.Frustum,_projScreenMatrix=new THREE.Matrix4,_projScreenMatrixPS=new THREE.Matrix4,_vector3=new THREE.Vector3,_direction=new THREE.Vector3,_lightsNeedUpdate=!0,_lights={ambient:[0,0,0],directional:{length:0,colors:[],positions:[]},point:{length:0,colors:[],positions:[],distances:[]},spot:{length:0,colors:[],positions:[],distances:[],directions:[],anglesCos:[],exponents:[]},hemi:{length:0,skyColors:[],groundColors:[],positions:[]}},_gl,_glExtensionTextureFloat,_glExtensionTextureFloatLinear,_glExtensionStandardDerivatives,_glExtensionTextureFilterAnisotropic,_glExtensionCompressedTextureS3TC;initGL(),setDefaultGLState(),this.context=_gl;var _maxTextures=_gl.getParameter(_gl.MAX_TEXTURE_IMAGE_UNITS),_maxVertexTextures=_gl.getParameter(_gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),_maxTextureSize=_gl.getParameter(_gl.MAX_TEXTURE_SIZE),_maxCubemapSize=_gl.getParameter(_gl.MAX_CUBE_MAP_TEXTURE_SIZE),_maxAnisotropy=_glExtensionTextureFilterAnisotropic?_gl.getParameter(_glExtensionTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT):0,_supportsVertexTextures=0<_maxVertexTextures,_supportsBoneTextures=_supportsVertexTextures&&_glExtensionTextureFloat,_compressedTextureFormats=_glExtensionCompressedTextureS3TC?_gl.getParameter(_gl.COMPRESSED_TEXTURE_FORMATS):[],_vertexShaderPrecisionHighpFloat=_gl.getShaderPrecisionFormat(_gl.VERTEX_SHADER,_gl.HIGH_FLOAT),_vertexShaderPrecisionMediumpFloat=_gl.getShaderPrecisionFormat(_gl.VERTEX_SHADER,_gl.MEDIUM_FLOAT),_vertexShaderPrecisionLowpFloat=_gl.getShaderPrecisionFormat(_gl.VERTEX_SHADER,_gl.LOW_FLOAT),_fragmentShaderPrecisionHighpFloat=_gl.getShaderPrecisionFormat(_gl.FRAGMENT_SHADER,_gl.HIGH_FLOAT),_fragmentShaderPrecisionMediumpFloat=_gl.getShaderPrecisionFormat(_gl.FRAGMENT_SHADER,_gl.MEDIUM_FLOAT),_fragmentShaderPrecisionLowpFloat=_gl.getShaderPrecisionFormat(_gl.FRAGMENT_SHADER,_gl.LOW_FLOAT),_vertexShaderPrecisionHighpInt=_gl.getShaderPrecisionFormat(_gl.VERTEX_SHADER,_gl.HIGH_INT),_vertexShaderPrecisionMediumpInt=_gl.getShaderPrecisionFormat(_gl.VERTEX_SHADER,_gl.MEDIUM_INT),_vertexShaderPrecisionLowpInt=_gl.getShaderPrecisionFormat(_gl.VERTEX_SHADER,_gl.LOW_INT),_fragmentShaderPrecisionHighpInt=_gl.getShaderPrecisionFormat(_gl.FRAGMENT_SHADER,_gl.HIGH_INT),_fragmentShaderPrecisionMediumpInt=_gl.getShaderPrecisionFormat(_gl.FRAGMENT_SHADER,_gl.MEDIUM_INT),_fragmentShaderPrecisionLowpInt=_gl.getShaderPrecisionFormat(_gl.FRAGMENT_SHADER,_gl.LOW_INT),highpAvailable=0<_vertexShaderPrecisionHighpFloat.precision&&0<_fragmentShaderPrecisionHighpFloat.precision,mediumpAvailable=0<_vertexShaderPrecisionMediumpFloat.precision&&0<_fragmentShaderPrecisionMediumpFloat.precision;'highp'!==_precision||highpAvailable||(mediumpAvailable?(_precision='mediump',console.warn('WebGLRenderer: highp not supported, using mediump')):(_precision='lowp',console.warn('WebGLRenderer: highp and mediump not supported, using lowp'))),'mediump'!==_precision||mediumpAvailable||(_precision='lowp',console.warn('WebGLRenderer: mediump not supported, using lowp')),this.getContext=function(){return _gl},this.supportsVertexTextures=function(){return _supportsVertexTextures},this.supportsFloatTextures=function(){return _glExtensionTextureFloat},this.supportsStandardDerivatives=function(){return _glExtensionStandardDerivatives},this.supportsCompressedTextureS3TC=function(){return _glExtensionCompressedTextureS3TC},this.getMaxAnisotropy=function(){return _maxAnisotropy},this.getPrecision=function(){return _precision},this.setSize=function(width,height,updateStyle){_canvas.width=width*this.devicePixelRatio,_canvas.height=height*this.devicePixelRatio,1!==this.devicePixelRatio&&!1!==updateStyle&&(_canvas.style.width=width+'px',_canvas.style.height=height+'px'),this.setViewport(0,0,_canvas.width,_canvas.height)},this.setViewport=function(x,y,width,height){_viewportX=x===void 0?0:x,_viewportY=y===void 0?0:y,_viewportWidth=width===void 0?_canvas.width:width,_viewportHeight=height===void 0?_canvas.height:height,_gl.viewport(_viewportX,_viewportY,_viewportWidth,_viewportHeight)},this.setScissor=function(x,y,width,height){_gl.scissor(x,y,width,height)},this.enableScissorTest=function(enable){enable?_gl.enable(_gl.SCISSOR_TEST):_gl.disable(_gl.SCISSOR_TEST)},this.setClearColor=function(color,alpha){_clearColor.set(color),_clearAlpha=alpha===void 0?1:alpha,_gl.clearColor(_clearColor.r,_clearColor.g,_clearColor.b,_clearAlpha)},this.setClearColorHex=function(hex,alpha){console.warn('DEPRECATED: .setClearColorHex() is being removed. Use .setClearColor() instead.'),this.setClearColor(hex,alpha)},this.getClearColor=function(){return _clearColor},this.getClearAlpha=function(){return _clearAlpha},this.clear=function(color,depth,stencil){var bits=0;(color===void 0||color)&&(bits|=_gl.COLOR_BUFFER_BIT),(depth===void 0||depth)&&(bits|=_gl.DEPTH_BUFFER_BIT),(stencil===void 0||stencil)&&(bits|=_gl.STENCIL_BUFFER_BIT),_gl.clear(bits)},this.clearTarget=function(renderTarget,color,depth,stencil){this.setRenderTarget(renderTarget),this.clear(color,depth,stencil)},this.addPostPlugin=function(plugin){plugin.init(this),this.renderPluginsPost.push(plugin)},this.addPrePlugin=function(plugin){plugin.init(this),this.renderPluginsPre.push(plugin)},this.updateShadowMap=function(scene,camera){_currentProgram=null,_oldBlending=-1,_oldDepthTest=-1,_oldDepthWrite=-1,_currentGeometryGroupHash=-1,_currentMaterialId=-1,_lightsNeedUpdate=!0,_oldDoubleSided=-1,_oldFlipSided=-1,this.shadowMapPlugin.update(scene,camera)};var onGeometryDispose=function(event){var geometry=event.target;geometry.removeEventListener('dispose',onGeometryDispose),deallocateGeometry(geometry)},onTextureDispose=function(event){var texture=event.target;texture.removeEventListener('dispose',onTextureDispose),deallocateTexture(texture),_this.info.memory.textures--},onRenderTargetDispose=function(event){var renderTarget=event.target;renderTarget.removeEventListener('dispose',onRenderTargetDispose),deallocateRenderTarget(renderTarget),_this.info.memory.textures--},onMaterialDispose=function(event){var material=event.target;material.removeEventListener('dispose',onMaterialDispose),deallocateMaterial(material)},deleteBuffers=function(geometry){if(void 0!==geometry.__webglVertexBuffer&&_gl.deleteBuffer(geometry.__webglVertexBuffer),void 0!==geometry.__webglNormalBuffer&&_gl.deleteBuffer(geometry.__webglNormalBuffer),void 0!==geometry.__webglTangentBuffer&&_gl.deleteBuffer(geometry.__webglTangentBuffer),void 0!==geometry.__webglColorBuffer&&_gl.deleteBuffer(geometry.__webglColorBuffer),void 0!==geometry.__webglUVBuffer&&_gl.deleteBuffer(geometry.__webglUVBuffer),void 0!==geometry.__webglUV2Buffer&&_gl.deleteBuffer(geometry.__webglUV2Buffer),void 0!==geometry.__webglSkinIndicesBuffer&&_gl.deleteBuffer(geometry.__webglSkinIndicesBuffer),void 0!==geometry.__webglSkinWeightsBuffer&&_gl.deleteBuffer(geometry.__webglSkinWeightsBuffer),void 0!==geometry.__webglFaceBuffer&&_gl.deleteBuffer(geometry.__webglFaceBuffer),void 0!==geometry.__webglLineBuffer&&_gl.deleteBuffer(geometry.__webglLineBuffer),void 0!==geometry.__webglLineDistanceBuffer&&_gl.deleteBuffer(geometry.__webglLineDistanceBuffer),void 0!==geometry.__webglCustomAttributesList)for(var id in geometry.__webglCustomAttributesList)_gl.deleteBuffer(geometry.__webglCustomAttributesList[id].buffer);_this.info.memory.geometries--},deallocateGeometry=function(geometry){if(geometry.__webglInit=void 0,geometry instanceof THREE.BufferGeometry){var attributes=geometry.attributes;for(var key in attributes)void 0!==attributes[key].buffer&&_gl.deleteBuffer(attributes[key].buffer);_this.info.memory.geometries--}else if(void 0!==geometry.geometryGroups)for(var g in geometry.geometryGroups){var geometryGroup=geometry.geometryGroups[g];if(void 0!==geometryGroup.numMorphTargets)for(var m=0,ml=geometryGroup.numMorphTargets;m<ml;m++)_gl.deleteBuffer(geometryGroup.__webglMorphTargetsBuffers[m]);if(void 0!==geometryGroup.numMorphNormals)for(var m=0,ml=geometryGroup.numMorphNormals;m<ml;m++)_gl.deleteBuffer(geometryGroup.__webglMorphNormalsBuffers[m]);deleteBuffers(geometryGroup)}else deleteBuffers(geometry)},deallocateTexture=function(texture){if(texture.image&&texture.image.__webglTextureCube)_gl.deleteTexture(texture.image.__webglTextureCube);else{if(!texture.__webglInit)return;texture.__webglInit=!1,_gl.deleteTexture(texture.__webglTexture)}},deallocateRenderTarget=function(renderTarget){if(renderTarget&&renderTarget.__webglTexture)if(_gl.deleteTexture(renderTarget.__webglTexture),renderTarget instanceof THREE.WebGLRenderTargetCube)for(var i=0;6>i;i++)_gl.deleteFramebuffer(renderTarget.__webglFramebuffer[i]),_gl.deleteRenderbuffer(renderTarget.__webglRenderbuffer[i]);else _gl.deleteFramebuffer(renderTarget.__webglFramebuffer),_gl.deleteRenderbuffer(renderTarget.__webglRenderbuffer)},deallocateMaterial=function(material){var program=material.program;if(void 0!==program){material.program=void 0;var deleteProgram=!1,i,il,programInfo;for(i=0,il=_programs.length;i<il;i++)if(programInfo=_programs[i],programInfo.program===program){programInfo.usedTimes--,0===programInfo.usedTimes&&(deleteProgram=!0);break}if(!0==deleteProgram){var newPrograms=[];for(i=0,il=_programs.length;i<il;i++)programInfo=_programs[i],programInfo.program!==program&&newPrograms.push(programInfo);_programs=newPrograms,_gl.deleteProgram(program),_this.info.memory.programs--}}};this.renderBufferImmediate=function(object,program,material){if(object.hasPositions&&!object.__webglVertexBuffer&&(object.__webglVertexBuffer=_gl.createBuffer()),object.hasNormals&&!object.__webglNormalBuffer&&(object.__webglNormalBuffer=_gl.createBuffer()),object.hasUvs&&!object.__webglUvBuffer&&(object.__webglUvBuffer=_gl.createBuffer()),object.hasColors&&!object.__webglColorBuffer&&(object.__webglColorBuffer=_gl.createBuffer()),object.hasPositions&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,object.__webglVertexBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,object.positionArray,_gl.DYNAMIC_DRAW),_gl.enableVertexAttribArray(program.attributes.position),_gl.vertexAttribPointer(program.attributes.position,3,_gl.FLOAT,!1,0,0)),object.hasNormals){if(_gl.bindBuffer(_gl.ARRAY_BUFFER,object.__webglNormalBuffer),material.shading===THREE.FlatShading){var il=3*object.count,nx,ny,nz,nax,nbx,ncx,nay,nby,ncy,naz,nbz,ncz,normalArray,i;for(i=0;i<il;i+=9)normalArray=object.normalArray,nax=normalArray[i],nay=normalArray[i+1],naz=normalArray[i+2],nbx=normalArray[i+3],nby=normalArray[i+4],nbz=normalArray[i+5],ncx=normalArray[i+6],ncy=normalArray[i+7],ncz=normalArray[i+8],nx=(nax+nbx+ncx)/3,ny=(nay+nby+ncy)/3,nz=(naz+nbz+ncz)/3,normalArray[i]=nx,normalArray[i+1]=ny,normalArray[i+2]=nz,normalArray[i+3]=nx,normalArray[i+4]=ny,normalArray[i+5]=nz,normalArray[i+6]=nx,normalArray[i+7]=ny,normalArray[i+8]=nz}_gl.bufferData(_gl.ARRAY_BUFFER,object.normalArray,_gl.DYNAMIC_DRAW),_gl.enableVertexAttribArray(program.attributes.normal),_gl.vertexAttribPointer(program.attributes.normal,3,_gl.FLOAT,!1,0,0)}object.hasUvs&&material.map&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,object.__webglUvBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,object.uvArray,_gl.DYNAMIC_DRAW),_gl.enableVertexAttribArray(program.attributes.uv),_gl.vertexAttribPointer(program.attributes.uv,2,_gl.FLOAT,!1,0,0)),object.hasColors&&material.vertexColors!==THREE.NoColors&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,object.__webglColorBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,object.colorArray,_gl.DYNAMIC_DRAW),_gl.enableVertexAttribArray(program.attributes.color),_gl.vertexAttribPointer(program.attributes.color,3,_gl.FLOAT,!1,0,0)),_gl.drawArrays(_gl.TRIANGLES,0,object.count),object.count=0},this.renderBufferDirect=function(camera,lights,fog,material,geometry,object){if(!1!==material.visible){var program=setProgram(camera,lights,fog,material,object),programAttributes=program.attributes,geometryAttributes=geometry.attributes,updateBuffers=!1,wireframeBit=material.wireframe?1:0,geometryHash=16777215*geometry.id+2*program.id+wireframeBit,attributeItem,attributeName,attributePointer,attributeSize;if(geometryHash!==_currentGeometryGroupHash&&(_currentGeometryGroupHash=geometryHash,updateBuffers=!0),updateBuffers&&disableAttributes(),object instanceof THREE.Mesh){var index=geometryAttributes.index;if(index){var offsets=geometry.offsets;1<offsets.length&&(updateBuffers=!0);for(var i=0,il=offsets.length,startIndex;i<il;i++){if(startIndex=offsets[i].index,updateBuffers){for(attributeName in programAttributes)attributePointer=programAttributes[attributeName],attributeItem=geometryAttributes[attributeName],0<=attributePointer&&(attributeItem?(attributeSize=attributeItem.itemSize,_gl.bindBuffer(_gl.ARRAY_BUFFER,attributeItem.buffer),enableAttribute(attributePointer),_gl.vertexAttribPointer(attributePointer,attributeSize,_gl.FLOAT,!1,0,4*(startIndex*attributeSize))):material.defaultAttributeValues&&(2===material.defaultAttributeValues[attributeName].length?_gl.vertexAttrib2fv(attributePointer,material.defaultAttributeValues[attributeName]):3===material.defaultAttributeValues[attributeName].length&&_gl.vertexAttrib3fv(attributePointer,material.defaultAttributeValues[attributeName])));_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,index.buffer)}_gl.drawElements(_gl.TRIANGLES,offsets[i].count,_gl.UNSIGNED_SHORT,2*offsets[i].start),_this.info.render.calls++,_this.info.render.vertices+=offsets[i].count,_this.info.render.faces+=offsets[i].count/3}}else{if(updateBuffers)for(attributeName in programAttributes)'index'!==attributeName&&(attributePointer=programAttributes[attributeName],attributeItem=geometryAttributes[attributeName],0<=attributePointer&&(attributeItem?(attributeSize=attributeItem.itemSize,_gl.bindBuffer(_gl.ARRAY_BUFFER,attributeItem.buffer),enableAttribute(attributePointer),_gl.vertexAttribPointer(attributePointer,attributeSize,_gl.FLOAT,!1,0,0)):material.defaultAttributeValues&&material.defaultAttributeValues[attributeName]&&(2===material.defaultAttributeValues[attributeName].length?_gl.vertexAttrib2fv(attributePointer,material.defaultAttributeValues[attributeName]):3===material.defaultAttributeValues[attributeName].length&&_gl.vertexAttrib3fv(attributePointer,material.defaultAttributeValues[attributeName]))));var position=geometry.attributes.position;_gl.drawArrays(_gl.TRIANGLES,0,position.numItems/3),_this.info.render.calls++,_this.info.render.vertices+=position.numItems/3,_this.info.render.faces+=position.numItems/3/3}}else if(object instanceof THREE.ParticleSystem){if(updateBuffers){for(attributeName in programAttributes)attributePointer=programAttributes[attributeName],attributeItem=geometryAttributes[attributeName],0<=attributePointer&&(attributeItem?(attributeSize=attributeItem.itemSize,_gl.bindBuffer(_gl.ARRAY_BUFFER,attributeItem.buffer),enableAttribute(attributePointer),_gl.vertexAttribPointer(attributePointer,attributeSize,_gl.FLOAT,!1,0,0)):material.defaultAttributeValues&&material.defaultAttributeValues[attributeName]&&(2===material.defaultAttributeValues[attributeName].length?_gl.vertexAttrib2fv(attributePointer,material.defaultAttributeValues[attributeName]):3===material.defaultAttributeValues[attributeName].length&&_gl.vertexAttrib3fv(attributePointer,material.defaultAttributeValues[attributeName])));var position=geometryAttributes.position;_gl.drawArrays(_gl.POINTS,0,position.numItems/3),_this.info.render.calls++,_this.info.render.points+=position.numItems/3}}else if(object instanceof THREE.Line&&updateBuffers){for(attributeName in programAttributes)attributePointer=programAttributes[attributeName],attributeItem=geometryAttributes[attributeName],0<=attributePointer&&(attributeItem?(attributeSize=attributeItem.itemSize,_gl.bindBuffer(_gl.ARRAY_BUFFER,attributeItem.buffer),enableAttribute(attributePointer),_gl.vertexAttribPointer(attributePointer,attributeSize,_gl.FLOAT,!1,0,0)):material.defaultAttributeValues&&material.defaultAttributeValues[attributeName]&&(2===material.defaultAttributeValues[attributeName].length?_gl.vertexAttrib2fv(attributePointer,material.defaultAttributeValues[attributeName]):3===material.defaultAttributeValues[attributeName].length&&_gl.vertexAttrib3fv(attributePointer,material.defaultAttributeValues[attributeName])));var primitives=object.type===THREE.LineStrip?_gl.LINE_STRIP:_gl.LINES;setLineWidth(material.linewidth);var position=geometryAttributes.position;_gl.drawArrays(primitives,0,position.numItems/3),_this.info.render.calls++,_this.info.render.points+=position.numItems}}},this.renderBuffer=function(camera,lights,fog,material,geometryGroup,object){if(!1!==material.visible){var program=setProgram(camera,lights,fog,material,object),attributes=program.attributes,updateBuffers=!1,wireframeBit=material.wireframe?1:0,geometryGroupHash=16777215*geometryGroup.id+2*program.id+wireframeBit,attribute,i,il;if(geometryGroupHash!==_currentGeometryGroupHash&&(_currentGeometryGroupHash=geometryGroupHash,updateBuffers=!0),updateBuffers&&disableAttributes(),!material.morphTargets&&0<=attributes.position?updateBuffers&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglVertexBuffer),enableAttribute(attributes.position),_gl.vertexAttribPointer(attributes.position,3,_gl.FLOAT,!1,0,0)):object.morphTargetBase&&setupMorphTargets(material,geometryGroup,object),updateBuffers){if(geometryGroup.__webglCustomAttributesList)for(i=0,il=geometryGroup.__webglCustomAttributesList.length;i<il;i++)attribute=geometryGroup.__webglCustomAttributesList[i],0<=attributes[attribute.buffer.belongsToAttribute]&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,attribute.buffer),enableAttribute(attributes[attribute.buffer.belongsToAttribute]),_gl.vertexAttribPointer(attributes[attribute.buffer.belongsToAttribute],attribute.size,_gl.FLOAT,!1,0,0));0<=attributes.color&&(0<object.geometry.colors.length||0<object.geometry.faces.length?(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglColorBuffer),enableAttribute(attributes.color),_gl.vertexAttribPointer(attributes.color,3,_gl.FLOAT,!1,0,0)):material.defaultAttributeValues&&_gl.vertexAttrib3fv(attributes.color,material.defaultAttributeValues.color)),0<=attributes.normal&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglNormalBuffer),enableAttribute(attributes.normal),_gl.vertexAttribPointer(attributes.normal,3,_gl.FLOAT,!1,0,0)),0<=attributes.tangent&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglTangentBuffer),enableAttribute(attributes.tangent),_gl.vertexAttribPointer(attributes.tangent,4,_gl.FLOAT,!1,0,0)),0<=attributes.uv&&(object.geometry.faceVertexUvs[0]?(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglUVBuffer),enableAttribute(attributes.uv),_gl.vertexAttribPointer(attributes.uv,2,_gl.FLOAT,!1,0,0)):material.defaultAttributeValues&&_gl.vertexAttrib2fv(attributes.uv,material.defaultAttributeValues.uv)),0<=attributes.uv2&&(object.geometry.faceVertexUvs[1]?(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglUV2Buffer),enableAttribute(attributes.uv2),_gl.vertexAttribPointer(attributes.uv2,2,_gl.FLOAT,!1,0,0)):material.defaultAttributeValues&&_gl.vertexAttrib2fv(attributes.uv2,material.defaultAttributeValues.uv2)),material.skinning&&0<=attributes.skinIndex&&0<=attributes.skinWeight&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglSkinIndicesBuffer),enableAttribute(attributes.skinIndex),_gl.vertexAttribPointer(attributes.skinIndex,4,_gl.FLOAT,!1,0,0),_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglSkinWeightsBuffer),enableAttribute(attributes.skinWeight),_gl.vertexAttribPointer(attributes.skinWeight,4,_gl.FLOAT,!1,0,0)),0<=attributes.lineDistance&&(_gl.bindBuffer(_gl.ARRAY_BUFFER,geometryGroup.__webglLineDistanceBuffer),enableAttribute(attributes.lineDistance),_gl.vertexAttribPointer(attributes.lineDistance,1,_gl.FLOAT,!1,0,0))}if(object instanceof THREE.Mesh)material.wireframe?(setLineWidth(material.wireframeLinewidth),updateBuffers&&_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,geometryGroup.__webglLineBuffer),_gl.drawElements(_gl.LINES,geometryGroup.__webglLineCount,_gl.UNSIGNED_SHORT,0)):(updateBuffers&&_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,geometryGroup.__webglFaceBuffer),_gl.drawElements(_gl.TRIANGLES,geometryGroup.__webglFaceCount,_gl.UNSIGNED_SHORT,0)),_this.info.render.calls++,_this.info.render.vertices+=geometryGroup.__webglFaceCount,_this.info.render.faces+=geometryGroup.__webglFaceCount/3;else if(object instanceof THREE.Line){var primitives=object.type===THREE.LineStrip?_gl.LINE_STRIP:_gl.LINES;setLineWidth(material.linewidth),_gl.drawArrays(primitives,0,geometryGroup.__webglLineCount),_this.info.render.calls++}else object instanceof THREE.ParticleSystem?(_gl.drawArrays(_gl.POINTS,0,geometryGroup.__webglParticleCount),_this.info.render.calls++,_this.info.render.points+=geometryGroup.__webglParticleCount):object instanceof THREE.Ribbon&&(_gl.drawArrays(_gl.TRIANGLE_STRIP,0,geometryGroup.__webglVertexCount),_this.info.render.calls++)}};this.render=function(scene,camera,renderTarget,forceClear){if(!1==camera instanceof THREE.Camera)return void console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');var lights=scene.__lights,fog=scene.fog,i,il,webglObject,object,renderList;for(_currentMaterialId=-1,_lightsNeedUpdate=!0,!0===scene.autoUpdate&&scene.updateMatrixWorld(),void 0===camera.parent&&camera.updateMatrixWorld(),camera.matrixWorldInverse.getInverse(camera.matrixWorld),_projScreenMatrix.multiplyMatrices(camera.projectionMatrix,camera.matrixWorldInverse),_frustum.setFromMatrix(_projScreenMatrix),this.autoUpdateObjects&&this.initWebGLObjects(scene),renderPlugins(this.renderPluginsPre,scene,camera),_this.info.render.calls=0,_this.info.render.vertices=0,_this.info.render.faces=0,_this.info.render.points=0,this.setRenderTarget(renderTarget),(this.autoClear||forceClear)&&this.clear(this.autoClearColor,this.autoClearDepth,this.autoClearStencil),renderList=scene.__webglObjects,(i=0,il=renderList.length);i<il;i++)webglObject=renderList[i],object=webglObject.object,webglObject.id=i,webglObject.render=!1,object.visible&&(!(object instanceof THREE.Mesh||object instanceof THREE.ParticleSystem)||!object.frustumCulled||_frustum.intersectsObject(object))&&(setupMatrices(object,camera),unrollBufferMaterial(webglObject),webglObject.render=!0,!0===this.sortObjects&&(null===object.renderDepth?(_vector3.getPositionFromMatrix(object.matrixWorld),_vector3.applyProjection(_projScreenMatrix),webglObject.z=_vector3.z):webglObject.z=object.renderDepth));for(this.sortObjects&&renderList.sort(painterSortStable),renderList=scene.__webglObjectsImmediate,(i=0,il=renderList.length);i<il;i++)webglObject=renderList[i],object=webglObject.object,object.visible&&(setupMatrices(object,camera),unrollImmediateBufferMaterial(webglObject));if(scene.overrideMaterial){var material=scene.overrideMaterial;this.setBlending(material.blending,material.blendEquation,material.blendSrc,material.blendDst),this.setDepthTest(material.depthTest),this.setDepthWrite(material.depthWrite),setPolygonOffset(material.polygonOffset,material.polygonOffsetFactor,material.polygonOffsetUnits),renderObjects(scene.__webglObjects,!1,'',camera,lights,fog,!0,material),renderObjectsImmediate(scene.__webglObjectsImmediate,'',camera,lights,fog,!1,material)}else{var material=null;this.setBlending(THREE.NoBlending),renderObjects(scene.__webglObjects,!0,'opaque',camera,lights,fog,!1,material),renderObjectsImmediate(scene.__webglObjectsImmediate,'opaque',camera,lights,fog,!1,material),renderObjects(scene.__webglObjects,!1,'transparent',camera,lights,fog,!0,material),renderObjectsImmediate(scene.__webglObjectsImmediate,'transparent',camera,lights,fog,!0,material)}renderPlugins(this.renderPluginsPost,scene,camera),renderTarget&&renderTarget.generateMipmaps&&renderTarget.minFilter!==THREE.NearestFilter&&renderTarget.minFilter!==THREE.LinearFilter&&updateRenderTargetMipmap(renderTarget),this.setDepthTest(!0),this.setDepthWrite(!0)};this.renderImmediateObject=function(camera,lights,fog,material,object){var program=setProgram(camera,lights,fog,material,object);_currentGeometryGroupHash=-1,_this.setMaterialFaces(material),object.immediateRenderCallback?object.immediateRenderCallback(program,_gl,_frustum):object.render(function(object){_this.renderBufferImmediate(object,program,material)})};this.initWebGLObjects=function(scene){for(scene.__webglObjects||(scene.__webglObjects=[],scene.__webglObjectsImmediate=[],scene.__webglSprites=[],scene.__webglFlares=[]);scene.__objectsAdded.length;)addObject(scene.__objectsAdded[0],scene),scene.__objectsAdded.splice(0,1);for(;scene.__objectsRemoved.length;)removeObject(scene.__objectsRemoved[0],scene),scene.__objectsRemoved.splice(0,1);for(var o=0,ol=scene.__webglObjects.length,object;o<ol;o++)object=scene.__webglObjects[o].object,void 0===object.__webglInit&&(void 0!==object.__webglActive&&removeObject(object,scene),addObject(object,scene)),updateObject(object)};this.initMaterial=function(material,lights,fog,object){material.addEventListener('dispose',onMaterialDispose);var u,i,parameters,maxLightCount,maxBones,maxShadows,shaderID;material instanceof THREE.MeshDepthMaterial?shaderID='depth':material instanceof THREE.MeshNormalMaterial?shaderID='normal':material instanceof THREE.MeshBasicMaterial?shaderID='basic':material instanceof THREE.MeshLambertMaterial?shaderID='lambert':material instanceof THREE.MeshPhongMaterial?shaderID='phong':material instanceof THREE.LineBasicMaterial?shaderID='basic':material instanceof THREE.LineDashedMaterial?shaderID='dashed':material instanceof THREE.ParticleBasicMaterial&&(shaderID='particle_basic'),shaderID&&setMaterialShaders(material,THREE.ShaderLib[shaderID]),maxLightCount=allocateLights(lights),maxShadows=allocateShadows(lights),maxBones=allocateBones(object),parameters={map:!!material.map,envMap:!!material.envMap,lightMap:!!material.lightMap,bumpMap:!!material.bumpMap,normalMap:!!material.normalMap,specularMap:!!material.specularMap,vertexColors:material.vertexColors,fog:fog,useFog:material.fog,fogExp:fog instanceof THREE.FogExp2,sizeAttenuation:material.sizeAttenuation,skinning:material.skinning,maxBones:maxBones,useVertexTexture:_supportsBoneTextures&&object&&object.useVertexTexture,boneTextureWidth:object&&object.boneTextureWidth,boneTextureHeight:object&&object.boneTextureHeight,morphTargets:material.morphTargets,morphNormals:material.morphNormals,maxMorphTargets:this.maxMorphTargets,maxMorphNormals:this.maxMorphNormals,maxDirLights:maxLightCount.directional,maxPointLights:maxLightCount.point,maxSpotLights:maxLightCount.spot,maxHemiLights:maxLightCount.hemi,maxShadows:maxShadows,shadowMapEnabled:this.shadowMapEnabled&&object.receiveShadow,shadowMapType:this.shadowMapType,shadowMapDebug:this.shadowMapDebug,shadowMapCascade:this.shadowMapCascade,alphaTest:material.alphaTest,metal:material.metal,perPixel:material.perPixel,wrapAround:material.wrapAround,doubleSided:material.side===THREE.DoubleSide,flipSided:material.side===THREE.BackSide},material.program=buildProgram(shaderID,material.fragmentShader,material.vertexShader,material.uniforms,material.attributes,material.defines,parameters,material.index0AttributeName);var attributes=material.program.attributes;if(material.morphTargets){material.numSupportedMorphTargets=0;var base='morphTarget',id;for(i=0;i<this.maxMorphTargets;i++)id=base+i,0<=attributes[id]&&material.numSupportedMorphTargets++}if(material.morphNormals){material.numSupportedMorphNormals=0;var base='morphNormal',id;for(i=0;i<this.maxMorphNormals;i++)id=base+i,0<=attributes[id]&&material.numSupportedMorphNormals++}for(u in material.uniformsList=[],material.uniforms)material.uniformsList.push([material.uniforms[u],u])};this.setFaceCulling=function(cullFace,frontFaceDirection){cullFace===THREE.CullFaceNone?_gl.disable(_gl.CULL_FACE):(frontFaceDirection===THREE.FrontFaceDirectionCW?_gl.frontFace(_gl.CW):_gl.frontFace(_gl.CCW),cullFace===THREE.CullFaceBack?_gl.cullFace(_gl.BACK):cullFace===THREE.CullFaceFront?_gl.cullFace(_gl.FRONT):_gl.cullFace(_gl.FRONT_AND_BACK),_gl.enable(_gl.CULL_FACE))},this.setMaterialFaces=function(material){var doubleSided=material.side===THREE.DoubleSide,flipSided=material.side===THREE.BackSide;_oldDoubleSided!==doubleSided&&(doubleSided?_gl.disable(_gl.CULL_FACE):_gl.enable(_gl.CULL_FACE),_oldDoubleSided=doubleSided),_oldFlipSided!==flipSided&&(flipSided?_gl.frontFace(_gl.CW):_gl.frontFace(_gl.CCW),_oldFlipSided=flipSided)},this.setDepthTest=function(depthTest){_oldDepthTest!==depthTest&&(depthTest?_gl.enable(_gl.DEPTH_TEST):_gl.disable(_gl.DEPTH_TEST),_oldDepthTest=depthTest)},this.setDepthWrite=function(depthWrite){_oldDepthWrite!==depthWrite&&(_gl.depthMask(depthWrite),_oldDepthWrite=depthWrite)};this.setBlending=function(blending,blendEquation,blendSrc,blendDst){blending!==_oldBlending&&(blending===THREE.NoBlending?_gl.disable(_gl.BLEND):blending===THREE.AdditiveBlending?(_gl.enable(_gl.BLEND),_gl.blendEquation(_gl.FUNC_ADD),_gl.blendFunc(_gl.SRC_ALPHA,_gl.ONE)):blending===THREE.SubtractiveBlending?(_gl.enable(_gl.BLEND),_gl.blendEquation(_gl.FUNC_ADD),_gl.blendFunc(_gl.ZERO,_gl.ONE_MINUS_SRC_COLOR)):blending===THREE.MultiplyBlending?(_gl.enable(_gl.BLEND),_gl.blendEquation(_gl.FUNC_ADD),_gl.blendFunc(_gl.ZERO,_gl.SRC_COLOR)):blending===THREE.CustomBlending?_gl.enable(_gl.BLEND):(_gl.enable(_gl.BLEND),_gl.blendEquationSeparate(_gl.FUNC_ADD,_gl.FUNC_ADD),_gl.blendFuncSeparate(_gl.SRC_ALPHA,_gl.ONE_MINUS_SRC_ALPHA,_gl.ONE,_gl.ONE_MINUS_SRC_ALPHA)),_oldBlending=blending),blending===THREE.CustomBlending?(blendEquation!==_oldBlendEquation&&(_gl.blendEquation(paramThreeToGL(blendEquation)),_oldBlendEquation=blendEquation),(blendSrc!==_oldBlendSrc||blendDst!==_oldBlendDst)&&(_gl.blendFunc(paramThreeToGL(blendSrc),paramThreeToGL(blendDst)),_oldBlendSrc=blendSrc,_oldBlendDst=blendDst)):(_oldBlendEquation=null,_oldBlendSrc=null,_oldBlendDst=null)};this.setTexture=function(texture,slot){if(texture.needsUpdate){texture.__webglInit||(texture.__webglInit=!0,texture.addEventListener('dispose',onTextureDispose),texture.__webglTexture=_gl.createTexture(),_this.info.memory.textures++),_gl.activeTexture(_gl.TEXTURE0+slot),_gl.bindTexture(_gl.TEXTURE_2D,texture.__webglTexture),_gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL,texture.flipY),_gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL,texture.premultiplyAlpha),_gl.pixelStorei(_gl.UNPACK_ALIGNMENT,texture.unpackAlignment);var image=texture.image,isImagePowerOfTwo=isPowerOfTwo(image.width)&&isPowerOfTwo(image.height),glFormat=paramThreeToGL(texture.format),glType=paramThreeToGL(texture.type);setTextureParameters(_gl.TEXTURE_2D,texture,isImagePowerOfTwo);var mipmaps=texture.mipmaps,mipmap;if(texture instanceof THREE.DataTexture){if(0<mipmaps.length&&isImagePowerOfTwo){for(var i=0,il=mipmaps.length;i<il;i++)mipmap=mipmaps[i],_gl.texImage2D(_gl.TEXTURE_2D,i,glFormat,mipmap.width,mipmap.height,0,glFormat,glType,mipmap.data);texture.generateMipmaps=!1}else _gl.texImage2D(_gl.TEXTURE_2D,0,glFormat,image.width,image.height,0,glFormat,glType,image.data);}else if(texture instanceof THREE.CompressedTexture)for(var i=0,il=mipmaps.length;i<il;i++)mipmap=mipmaps[i],_gl.compressedTexImage2D(_gl.TEXTURE_2D,i,glFormat,mipmap.width,mipmap.height,0,mipmap.data);else if(0<mipmaps.length&&isImagePowerOfTwo){for(var i=0,il=mipmaps.length;i<il;i++)mipmap=mipmaps[i],_gl.texImage2D(_gl.TEXTURE_2D,i,glFormat,glFormat,glType,mipmap);texture.generateMipmaps=!1}else _gl.texImage2D(_gl.TEXTURE_2D,0,glFormat,glFormat,glType,texture.image);texture.generateMipmaps&&isImagePowerOfTwo&&_gl.generateMipmap(_gl.TEXTURE_2D),texture.needsUpdate=!1,texture.onUpdate&&texture.onUpdate()}else _gl.activeTexture(_gl.TEXTURE0+slot),_gl.bindTexture(_gl.TEXTURE_2D,texture.__webglTexture)};this.setRenderTarget=function(renderTarget){var isCube=renderTarget instanceof THREE.WebGLRenderTargetCube;if(renderTarget&&!renderTarget.__webglFramebuffer){renderTarget.depthBuffer===void 0&&(renderTarget.depthBuffer=!0),renderTarget.stencilBuffer===void 0&&(renderTarget.stencilBuffer=!0),renderTarget.addEventListener('dispose',onRenderTargetDispose),renderTarget.__webglTexture=_gl.createTexture(),_this.info.memory.textures++;var isTargetPowerOfTwo=isPowerOfTwo(renderTarget.width)&&isPowerOfTwo(renderTarget.height),glFormat=paramThreeToGL(renderTarget.format),glType=paramThreeToGL(renderTarget.type);if(isCube){renderTarget.__webglFramebuffer=[],renderTarget.__webglRenderbuffer=[],_gl.bindTexture(_gl.TEXTURE_CUBE_MAP,renderTarget.__webglTexture),setTextureParameters(_gl.TEXTURE_CUBE_MAP,renderTarget,isTargetPowerOfTwo);for(var i=0;6>i;i++)renderTarget.__webglFramebuffer[i]=_gl.createFramebuffer(),renderTarget.__webglRenderbuffer[i]=_gl.createRenderbuffer(),_gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X+i,0,glFormat,renderTarget.width,renderTarget.height,0,glFormat,glType,null),setupFrameBuffer(renderTarget.__webglFramebuffer[i],renderTarget,_gl.TEXTURE_CUBE_MAP_POSITIVE_X+i),setupRenderBuffer(renderTarget.__webglRenderbuffer[i],renderTarget);isTargetPowerOfTwo&&_gl.generateMipmap(_gl.TEXTURE_CUBE_MAP)}else renderTarget.__webglFramebuffer=_gl.createFramebuffer(),renderTarget.__webglRenderbuffer=renderTarget.shareDepthFrom?renderTarget.shareDepthFrom.__webglRenderbuffer:_gl.createRenderbuffer(),_gl.bindTexture(_gl.TEXTURE_2D,renderTarget.__webglTexture),setTextureParameters(_gl.TEXTURE_2D,renderTarget,isTargetPowerOfTwo),_gl.texImage2D(_gl.TEXTURE_2D,0,glFormat,renderTarget.width,renderTarget.height,0,glFormat,glType,null),setupFrameBuffer(renderTarget.__webglFramebuffer,renderTarget,_gl.TEXTURE_2D),renderTarget.shareDepthFrom?renderTarget.depthBuffer&&!renderTarget.stencilBuffer?_gl.framebufferRenderbuffer(_gl.FRAMEBUFFER,_gl.DEPTH_ATTACHMENT,_gl.RENDERBUFFER,renderTarget.__webglRenderbuffer):renderTarget.depthBuffer&&renderTarget.stencilBuffer&&_gl.framebufferRenderbuffer(_gl.FRAMEBUFFER,_gl.DEPTH_STENCIL_ATTACHMENT,_gl.RENDERBUFFER,renderTarget.__webglRenderbuffer):setupRenderBuffer(renderTarget.__webglRenderbuffer,renderTarget),isTargetPowerOfTwo&&_gl.generateMipmap(_gl.TEXTURE_2D);isCube?_gl.bindTexture(_gl.TEXTURE_CUBE_MAP,null):_gl.bindTexture(_gl.TEXTURE_2D,null),_gl.bindRenderbuffer(_gl.RENDERBUFFER,null),_gl.bindFramebuffer(_gl.FRAMEBUFFER,null)}var framebuffer,width,height,vx,vy;renderTarget?(framebuffer=isCube?renderTarget.__webglFramebuffer[renderTarget.activeCubeFace]:renderTarget.__webglFramebuffer,width=renderTarget.width,height=renderTarget.height,vx=0,vy=0):(framebuffer=null,width=_viewportWidth,height=_viewportHeight,vx=_viewportX,vy=_viewportY),framebuffer!==_currentFramebuffer&&(_gl.bindFramebuffer(_gl.FRAMEBUFFER,framebuffer),_gl.viewport(vx,vy,width,height),_currentFramebuffer=framebuffer),_currentWidth=width,_currentHeight=height};this.shadowMapPlugin=new THREE.ShadowMapPlugin,this.addPrePlugin(this.shadowMapPlugin),this.addPostPlugin(new THREE.SpritePlugin),this.addPostPlugin(new THREE.LensFlarePlugin)},THREE.WebGLRenderTarget=function(width,height,options){this.width=width,this.height=height,options=options||{},this.wrapS=options.wrapS===void 0?THREE.ClampToEdgeWrapping:options.wrapS,this.wrapT=options.wrapT===void 0?THREE.ClampToEdgeWrapping:options.wrapT,this.magFilter=options.magFilter===void 0?THREE.LinearFilter:options.magFilter,this.minFilter=options.minFilter===void 0?THREE.LinearMipMapLinearFilter:options.minFilter,this.anisotropy=options.anisotropy===void 0?1:options.anisotropy,this.offset=new THREE.Vector2(0,0),this.repeat=new THREE.Vector2(1,1),this.format=options.format===void 0?THREE.RGBAFormat:options.format,this.type=options.type===void 0?THREE.UnsignedByteType:options.type,this.depthBuffer=!(options.depthBuffer!==void 0)||options.depthBuffer,this.stencilBuffer=!(options.stencilBuffer!==void 0)||options.stencilBuffer,this.generateMipmaps=!0,this.shareDepthFrom=null},THREE.WebGLRenderTarget.prototype={constructor:THREE.WebGLRenderTarget,clone:function clone(){var tmp=new THREE.WebGLRenderTarget(this.width,this.height);return tmp.wrapS=this.wrapS,tmp.wrapT=this.wrapT,tmp.magFilter=this.magFilter,tmp.minFilter=this.minFilter,tmp.anisotropy=this.anisotropy,tmp.offset.copy(this.offset),tmp.repeat.copy(this.repeat),tmp.format=this.format,tmp.type=this.type,tmp.depthBuffer=this.depthBuffer,tmp.stencilBuffer=this.stencilBuffer,tmp.generateMipmaps=this.generateMipmaps,tmp.shareDepthFrom=this.shareDepthFrom,tmp},dispose:function dispose(){this.dispatchEvent({type:'dispose'})}},THREE.EventDispatcher.prototype.apply(THREE.WebGLRenderTarget.prototype),THREE.WebGLRenderTargetCube=function(width,height,options){THREE.WebGLRenderTarget.call(this,width,height,options),this.activeCubeFace=0},THREE.WebGLRenderTargetCube.prototype=Object.create(THREE.WebGLRenderTarget.prototype),THREE.RenderableVertex=function(){this.positionWorld=new THREE.Vector3,this.positionScreen=new THREE.Vector4,this.visible=!0},THREE.RenderableVertex.prototype.copy=function(vertex){this.positionWorld.copy(vertex.positionWorld),this.positionScreen.copy(vertex.positionScreen)},THREE.RenderableFace3=function(){this.id=0,this.v1=new THREE.RenderableVertex,this.v2=new THREE.RenderableVertex,this.v3=new THREE.RenderableVertex,this.centroidModel=new THREE.Vector3,this.normalModel=new THREE.Vector3,this.normalModelView=new THREE.Vector3,this.vertexNormalsLength=0,this.vertexNormalsModel=[new THREE.Vector3,new THREE.Vector3,new THREE.Vector3],this.vertexNormalsModelView=[new THREE.Vector3,new THREE.Vector3,new THREE.Vector3],this.color=null,this.material=null,this.uvs=[[]],this.z=0},THREE.RenderableObject=function(){this.id=0,this.object=null,this.z=0},THREE.RenderableParticle=function(){this.id=0,this.object=null,this.x=0,this.y=0,this.z=0,this.rotation=null,this.scale=new THREE.Vector2,this.material=null},THREE.RenderableLine=function(){this.id=0,this.v1=new THREE.RenderableVertex,this.v2=new THREE.RenderableVertex,this.vertexColors=[new THREE.Color,new THREE.Color],this.material=null,this.z=0},THREE.GeometryUtils={merge:function merge(geometry1,object2,materialIndexOffset){var vertexOffset=geometry1.vertices.length,uvPosition=geometry1.faceVertexUvs[0].length,geometry2=object2 instanceof THREE.Mesh?object2.geometry:object2,vertices1=geometry1.vertices,vertices2=geometry2.vertices,faces1=geometry1.faces,faces2=geometry2.faces,uvs1=geometry1.faceVertexUvs[0],uvs2=geometry2.faceVertexUvs[0],matrix,normalMatrix;materialIndexOffset===void 0&&(materialIndexOffset=0),object2 instanceof THREE.Mesh&&(object2.matrixAutoUpdate&&object2.updateMatrix(),matrix=object2.matrix,normalMatrix=new THREE.Matrix3().getNormalMatrix(matrix));for(var i=0,il=vertices2.length;i<il;i++){var vertex=vertices2[i],vertexCopy=vertex.clone();matrix&&vertexCopy.applyMatrix4(matrix),vertices1.push(vertexCopy)}for(i=0,il=faces2.length;i<il;i++){var face=faces2[i],faceVertexNormals=face.vertexNormals,faceVertexColors=face.vertexColors,faceCopy,normal,color;faceCopy=new THREE.Face3(face.a+vertexOffset,face.b+vertexOffset,face.c+vertexOffset),faceCopy.normal.copy(face.normal),normalMatrix&&faceCopy.normal.applyMatrix3(normalMatrix).normalize();for(var j=0,jl=faceVertexNormals.length;j<jl;j++)normal=faceVertexNormals[j].clone(),normalMatrix&&normal.applyMatrix3(normalMatrix).normalize(),faceCopy.vertexNormals.push(normal);faceCopy.color.copy(face.color);for(var j=0,jl=faceVertexColors.length;j<jl;j++)color=faceVertexColors[j],faceCopy.vertexColors.push(color.clone());faceCopy.materialIndex=face.materialIndex+materialIndexOffset,faceCopy.centroid.copy(face.centroid),matrix&&faceCopy.centroid.applyMatrix4(matrix),faces1.push(faceCopy)}for(i=0,il=uvs2.length;i<il;i++){for(var uv=uvs2[i],uvCopy=[],j=0,jl=uv.length;j<jl;j++)uvCopy.push(new THREE.Vector2(uv[j].x,uv[j].y));uvs1.push(uvCopy)}},randomPointInTriangle:function(){var vector=new THREE.Vector3;return function(vectorA,vectorB,vectorC){var point=new THREE.Vector3,a=THREE.Math.random16(),b=THREE.Math.random16();1<a+b&&(a=1-a,b=1-b);var c=1-a-b;return point.copy(vectorA),point.multiplyScalar(a),vector.copy(vectorB),vector.multiplyScalar(b),point.add(vector),vector.copy(vectorC),vector.multiplyScalar(c),point.add(vector),point}}(),randomPointInFace:function randomPointInFace(face,geometry){var vA,vB,vC;return vA=geometry.vertices[face.a],vB=geometry.vertices[face.b],vC=geometry.vertices[face.c],THREE.GeometryUtils.randomPointInTriangle(vA,vB,vC)},randomPointsInGeometry:function randomPointsInGeometry(geometry,n){function binarySearchIndices(value){function binarySearch(start,end){if(end<start)return start;var mid=start+Math.floor((end-start)/2);return cumulativeAreas[mid]>value?binarySearch(start,mid-1):cumulativeAreas[mid]<value?binarySearch(mid+1,end):mid}var result=binarySearch(0,cumulativeAreas.length-1);return result}var faces=geometry.faces,vertices=geometry.vertices,il=faces.length,totalArea=0,cumulativeAreas=[],face,i,vA,vB,vC;for(i=0;i<il;i++)face=faces[i],vA=vertices[face.a],vB=vertices[face.b],vC=vertices[face.c],face._area=THREE.GeometryUtils.triangleArea(vA,vB,vC),totalArea+=face._area,cumulativeAreas[i]=totalArea;var result=[],stats={},r,index;for(i=0;i<n;i++)r=THREE.Math.random16()*totalArea,index=binarySearchIndices(r),result[i]=THREE.GeometryUtils.randomPointInFace(faces[index],geometry,!0),stats[index]?stats[index]+=1:stats[index]=1;return result},triangleArea:function(){var vector1=new THREE.Vector3,vector2=new THREE.Vector3;return function(vectorA,vectorB,vectorC){return vector1.subVectors(vectorB,vectorA),vector2.subVectors(vectorC,vectorA),vector1.cross(vector2),.5*vector1.length()}}(),center:function center(geometry){geometry.computeBoundingBox();var bb=geometry.boundingBox,offset=new THREE.Vector3;return offset.addVectors(bb.min,bb.max),offset.multiplyScalar(-.5),geometry.applyMatrix(new THREE.Matrix4().makeTranslation(offset.x,offset.y,offset.z)),geometry.computeBoundingBox(),offset},triangulateQuads:function triangulateQuads(geometry){var faces=[],faceVertexUvs=[],i,il,j,jl;for(i=0,il=geometry.faceVertexUvs.length;i<il;i++)faceVertexUvs[i]=[];for(i=0,il=geometry.faces.length;i<il;i++){var face=geometry.faces[i];for(faces.push(face),j=0,jl=geometry.faceVertexUvs.length;j<jl;j++)faceVertexUvs[j].push(geometry.faceVertexUvs[j][i])}geometry.faces=faces,geometry.faceVertexUvs=faceVertexUvs,geometry.computeCentroids(),geometry.computeFaceNormals(),geometry.computeVertexNormals(),geometry.hasTangents&&geometry.computeTangents()}},THREE.ImageUtils={crossOrigin:'anonymous',loadTexture:function loadTexture(url,mapping,onLoad){var image=new Image,texture=new THREE.Texture(image,mapping),loader=new THREE.ImageLoader;return loader.crossOrigin=this.crossOrigin,loader.load(url,function(image){texture.image=image,texture.needsUpdate=!0,onLoad&&onLoad(texture)}),texture.sourceFile=url,texture},loadCompressedTexture:function loadCompressedTexture(url,mapping,onLoad,onError){var texture=new THREE.CompressedTexture;texture.mapping=mapping;var request=new XMLHttpRequest;return request.onload=function(){var buffer=request.response,dds=THREE.ImageUtils.parseDDS(buffer,!0);texture.format=dds.format,texture.mipmaps=dds.mipmaps,texture.image.width=dds.width,texture.image.height=dds.height,texture.generateMipmaps=!1,texture.needsUpdate=!0,onLoad&&onLoad(texture)},request.onerror=onError,request.open('GET',url,!0),request.responseType='arraybuffer',request.send(null),texture},loadTextureCube:function loadTextureCube(array,mapping,onLoad,onError){var images=[];images.loadCount=0;var texture=new THREE.Texture;texture.image=images,mapping!==void 0&&(texture.mapping=mapping),texture.flipY=!1;for(var i=0,il=array.length,cubeImage;i<il;++i)cubeImage=new Image,images[i]=cubeImage,cubeImage.onload=function(){images.loadCount+=1,6===images.loadCount&&(texture.needsUpdate=!0,onLoad&&onLoad(texture))},cubeImage.onerror=onError,cubeImage.crossOrigin=this.crossOrigin,cubeImage.src=array[i];return texture},loadCompressedTextureCube:function loadCompressedTextureCube(array,mapping,onLoad,onError){var images=[];images.loadCount=0;var texture=new THREE.CompressedTexture;texture.image=images,mapping!==void 0&&(texture.mapping=mapping),texture.flipY=!1,texture.generateMipmaps=!1;var generateCubeFaceCallback=function(rq,img){return function(){var buffer=rq.response,dds=THREE.ImageUtils.parseDDS(buffer,!0);img.format=dds.format,img.mipmaps=dds.mipmaps,img.width=dds.width,img.height=dds.height,images.loadCount+=1,6===images.loadCount&&(texture.format=dds.format,texture.needsUpdate=!0,onLoad&&onLoad(texture))}};if(array instanceof Array)for(var i=0,il=array.length,cubeImage;i<il;++i){cubeImage={},images[i]=cubeImage;var request=new XMLHttpRequest;request.onload=generateCubeFaceCallback(request,cubeImage),request.onerror=onError;var url=array[i];request.open('GET',url,!0),request.responseType='arraybuffer',request.send(null)}else{var url=array,request=new XMLHttpRequest;request.onload=function(){var buffer=request.response,dds=THREE.ImageUtils.parseDDS(buffer,!0);if(dds.isCubemap){for(var faces=dds.mipmaps.length/dds.mipmapCount,f=0;f<faces;f++){images[f]={mipmaps:[]};for(var i=0;i<dds.mipmapCount;i++)images[f].mipmaps.push(dds.mipmaps[f*dds.mipmapCount+i]),images[f].format=dds.format,images[f].width=dds.width,images[f].height=dds.height}texture.format=dds.format,texture.needsUpdate=!0,onLoad&&onLoad(texture)}},request.onerror=onError,request.open('GET',url,!0),request.responseType='arraybuffer',request.send(null)}return texture},parseDDS:function parseDDS(buffer,loadMipmaps){function fourCCToInt32(value){return value.charCodeAt(0)+(value.charCodeAt(1)<<8)+(value.charCodeAt(2)<<16)+(value.charCodeAt(3)<<24)}function int32ToFourCC(value){return String.fromCharCode(255&value,255&value>>8,255&value>>16,255&value>>24)}var _Mathmax5=Math.max,dds={mipmaps:[],width:0,height:0,format:null,mipmapCount:1},FOURCC_DXT1=fourCCToInt32('DXT1'),FOURCC_DXT3=fourCCToInt32('DXT3'),FOURCC_DXT5=fourCCToInt32('DXT5'),header=new Int32Array(buffer,0,31);if(header[0]!==542327876)return console.error('ImageUtils.parseDDS(): Invalid magic number in DDS header'),dds;if(!header[20]&4)return console.error('ImageUtils.parseDDS(): Unsupported format, must contain a FourCC code'),dds;var fourCC=header[21],blockBytes;switch(fourCC){case FOURCC_DXT1:blockBytes=8,dds.format=THREE.RGB_S3TC_DXT1_Format;break;case FOURCC_DXT3:blockBytes=16,dds.format=THREE.RGBA_S3TC_DXT3_Format;break;case FOURCC_DXT5:blockBytes=16,dds.format=THREE.RGBA_S3TC_DXT5_Format;break;default:return console.error('ImageUtils.parseDDS(): Unsupported FourCC code: ',int32ToFourCC(fourCC)),dds;}dds.mipmapCount=1,header[2]&131072&&!1!==loadMipmaps&&(dds.mipmapCount=_Mathmax5(1,header[7])),dds.isCubemap=!!(header[28]&512),dds.width=header[4],dds.height=header[3];for(var dataOffset=header[1]+4,width=dds.width,height=dds.height,faces=dds.isCubemap?6:1,face=0;face<faces;face++){for(var i=0;i<dds.mipmapCount;i++){var dataLength=_Mathmax5(4,width)/4*_Mathmax5(4,height)/4*blockBytes,byteArray=new Uint8Array(buffer,dataOffset,dataLength),mipmap={data:byteArray,width:width,height:height};dds.mipmaps.push(mipmap),dataOffset+=dataLength,width=_Mathmax5(.5*width,1),height=_Mathmax5(.5*height,1)}width=dds.width,height=dds.height}return dds},getNormalMap:function getNormalMap(image,depth){var cross=function(a,b){return[a[1]*b[2]-a[2]*b[1],a[2]*b[0]-a[0]*b[2],a[0]*b[1]-a[1]*b[0]]},subtract=function(a,b){return[a[0]-b[0],a[1]-b[1],a[2]-b[2]]},normalize=function(a){var l=Math.sqrt(a[0]*a[0]+a[1]*a[1]+a[2]*a[2]);return[a[0]/l,a[1]/l,a[2]/l]};depth|=1;var width=image.width,height=image.height,canvas=document.createElement('canvas');canvas.width=width,canvas.height=height;var context=canvas.getContext('2d');context.drawImage(image,0,0);for(var data=context.getImageData(0,0,width,height).data,imageData=context.createImageData(width,height),output=imageData.data,x=0;x<width;x++)for(var y=0;y<height;y++){var ly=0>y-1?0:y-1,uy=y+1>height-1?height-1:y+1,lx=0>x-1?0:x-1,ux=x+1>width-1?width-1:x+1,points=[],origin=[0,0,data[4*(y*width+x)]/255*depth];points.push([-1,0,data[4*(y*width+lx)]/255*depth]),points.push([-1,-1,data[4*(ly*width+lx)]/255*depth]),points.push([0,-1,data[4*(ly*width+x)]/255*depth]),points.push([1,-1,data[4*(ly*width+ux)]/255*depth]),points.push([1,0,data[4*(y*width+ux)]/255*depth]),points.push([1,1,data[4*(uy*width+ux)]/255*depth]),points.push([0,1,data[4*(uy*width+x)]/255*depth]),points.push([-1,1,data[4*(uy*width+lx)]/255*depth]);for(var normals=[],num_points=points.length,i=0;i<num_points;i++){var v1=points[i],v2=points[(i+1)%num_points];v1=subtract(v1,origin),v2=subtract(v2,origin),normals.push(normalize(cross(v1,v2)))}for(var normal=[0,0,0],i=0;i<normals.length;i++)normal[0]+=normals[i][0],normal[1]+=normals[i][1],normal[2]+=normals[i][2];normal[0]/=normals.length,normal[1]/=normals.length,normal[2]/=normals.length;var idx=4*(y*width+x);output[idx]=0|255*((normal[0]+1)/2),output[idx+1]=0|255*((normal[1]+1)/2),output[idx+2]=0|255*normal[2],output[idx+3]=255}return context.putImageData(imageData,0,0),canvas},generateDataTexture:function generateDataTexture(width,height,color){for(var _Mathfloor4=Math.floor,size=width*height,data=new Uint8Array(3*size),r=_Mathfloor4(255*color.r),g=_Mathfloor4(255*color.g),b=_Mathfloor4(255*color.b),i=0;i<size;i++)data[3*i]=r,data[3*i+1]=g,data[3*i+2]=b;var texture=new THREE.DataTexture(data,width,height,THREE.RGBFormat);return texture.needsUpdate=!0,texture}},THREE.SceneUtils={createMultiMaterialObject:function createMultiMaterialObject(geometry,materials){for(var group=new THREE.Object3D,i=0,l=materials.length;i<l;i++)group.add(new THREE.Mesh(geometry,materials[i]));return group},detach:function detach(child,parent,scene){child.applyMatrix(parent.matrixWorld),parent.remove(child),scene.add(child)},attach:function attach(child,scene,parent){var matrixWorldInverse=new THREE.Matrix4;matrixWorldInverse.getInverse(parent.matrixWorld),child.applyMatrix(matrixWorldInverse),scene.remove(child),parent.add(child)}},THREE.FontUtils={faces:{},face:'helvetiker',weight:'normal',style:'normal',size:150,divisions:10,getFace:function getFace(){return this.faces[this.face][this.weight][this.style]},loadFace:function loadFace(data){var family=data.familyName.toLowerCase(),ThreeFont=this;ThreeFont.faces[family]=ThreeFont.faces[family]||{},ThreeFont.faces[family][data.cssFontWeight]=ThreeFont.faces[family][data.cssFontWeight]||{},ThreeFont.faces[family][data.cssFontWeight][data.cssFontStyle]=data;ThreeFont.faces[family][data.cssFontWeight][data.cssFontStyle]=data;return data},drawText:function drawText(text){var face=this.getFace(),scale=this.size/face.resolution,offset=0,chars=(text+'').split(''),length=chars.length,fontPaths=[],i;for(i=0;i<length;i++){var path=new THREE.Path,ret=this.extractGlyphPoints(chars[i],face,scale,offset,path);offset+=ret.offset,fontPaths.push(ret.path)}var width=offset/2;return{paths:fontPaths,offset:width}},extractGlyphPoints:function extractGlyphPoints(c,face,scale,offset,path){var pts=[],glyph=face.glyphs[c]||face.glyphs['?'],i,i2,divisions,outline,action,length,scaleX,scaleY,x,y,cpx,cpy,cpx0,cpy0,cpx1,cpy1,cpx2,cpy2,laste;if(glyph){if(glyph.o)for(outline=glyph._cachedOutline||(glyph._cachedOutline=glyph.o.split(' ')),length=outline.length,scaleX=scale,scaleY=scale,i=0;i<length;)switch(action=outline[i++],action){case'm':x=outline[i++]*scaleX+offset,y=outline[i++]*scaleY,path.moveTo(x,y);break;case'l':x=outline[i++]*scaleX+offset,y=outline[i++]*scaleY,path.lineTo(x,y);break;case'q':if(cpx=outline[i++]*scaleX+offset,cpy=outline[i++]*scaleY,cpx1=outline[i++]*scaleX+offset,cpy1=outline[i++]*scaleY,path.quadraticCurveTo(cpx1,cpy1,cpx,cpy),laste=pts[pts.length-1],laste)for(cpx0=laste.x,cpy0=laste.y,(i2=1,divisions=this.divisions);i2<=divisions;i2++)var t=i2/divisions,tx=THREE.Shape.Utils.b2(t,cpx0,cpx1,cpx),ty=THREE.Shape.Utils.b2(t,cpy0,cpy1,cpy);break;case'b':if(cpx=outline[i++]*scaleX+offset,cpy=outline[i++]*scaleY,cpx1=outline[i++]*scaleX+offset,cpy1=outline[i++]*-scaleY,cpx2=outline[i++]*scaleX+offset,cpy2=outline[i++]*-scaleY,path.bezierCurveTo(cpx,cpy,cpx1,cpy1,cpx2,cpy2),laste=pts[pts.length-1],laste)for(cpx0=laste.x,cpy0=laste.y,(i2=1,divisions=this.divisions);i2<=divisions;i2++)var t=i2/divisions,tx=THREE.Shape.Utils.b3(t,cpx0,cpx1,cpx2,cpx),ty=THREE.Shape.Utils.b3(t,cpy0,cpy1,cpy2,cpy);}return{offset:glyph.ha*scale,path:path}}}},THREE.FontUtils.generateShapes=function(text,parameters){parameters=parameters||{};var size=parameters.size===void 0?100:parameters.size,curveSegments=parameters.curveSegments===void 0?4:parameters.curveSegments,font=parameters.font===void 0?'helvetiker':parameters.font,weight=parameters.weight===void 0?'normal':parameters.weight,style=parameters.style===void 0?'normal':parameters.style;THREE.FontUtils.size=size,THREE.FontUtils.divisions=curveSegments,THREE.FontUtils.face=font,THREE.FontUtils.weight=weight,THREE.FontUtils.style=style;for(var data=THREE.FontUtils.drawText(text),paths=data.paths,shapes=[],p=0,pl=paths.length;p<pl;p++)Array.prototype.push.apply(shapes,paths[p].toShapes());return shapes},function(namespace){var EPSILON=1e-10,area=function(contour){for(var n=contour.length,a=0,p=n-1,q=0;q<n;p=q++)a+=contour[p].x*contour[q].y-contour[q].x*contour[p].y;return .5*a},snip=function(contour,u,v,w,n,verts){var p,ax,ay,bx,by,cx,cy,px,py;if(ax=contour[verts[u]].x,ay=contour[verts[u]].y,bx=contour[verts[v]].x,by=contour[verts[v]].y,cx=contour[verts[w]].x,cy=contour[verts[w]].y,EPSILON>(bx-ax)*(cy-ay)-(by-ay)*(cx-ax))return!1;var aX,aY,bX,bY,cX,cY,apx,apy,bpx,bpy,cpx,cpy,cCROSSap,bCROSScp,aCROSSbp;for(aX=cx-bx,aY=cy-by,bX=ax-cx,bY=ay-cy,cX=bx-ax,cY=by-ay,p=0;p<n;p++)if(p!==u&&p!==v&&p!==w&&(px=contour[verts[p]].x,py=contour[verts[p]].y,apx=px-ax,apy=py-ay,bpx=px-bx,bpy=py-by,cpx=px-cx,cpy=py-cy,aCROSSbp=aX*bpy-aY*bpx,cCROSSap=cX*apy-cY*apx,bCROSScp=bX*cpy-bY*cpx,aCROSSbp>=-EPSILON&&bCROSScp>=-EPSILON&&cCROSSap>=-EPSILON))return!1;return!0};return namespace.Triangulate=function process(contour,indices){var n=contour.length;if(3>n)return null;var result=[],verts=[],vertIndices=[],u,v,w;if(0<area(contour))for(v=0;v<n;v++)verts[v]=v;else for(v=0;v<n;v++)verts[v]=n-1-v;var nv=n,count=2*nv;for(v=nv-1;2<nv;){if(0>=count--)return console.log('Warning, unable to triangulate polygon!'),indices?vertIndices:result;if(u=v,nv<=u&&(u=0),v=u+1,nv<=v&&(v=0),w=v+1,nv<=w&&(w=0),snip(contour,u,v,w,nv,verts)){var a,b,c,s,t;for(a=verts[u],b=verts[v],c=verts[w],result.push([contour[a],contour[b],contour[c]]),vertIndices.push([verts[u],verts[v],verts[w]]),(s=v,t=v+1);t<nv;s++,t++)verts[s]=verts[t];nv--,count=2*nv}}return indices?vertIndices:result},namespace.Triangulate.area=area,namespace}(THREE.FontUtils),self._typeface_js={faces:THREE.FontUtils.faces,loadFace:THREE.FontUtils.loadFace},THREE.typeface_js=self._typeface_js,THREE.Curve=function(){},THREE.Curve.prototype.getPoint=function(){return console.log('Warning, getPoint() not implemented!'),null},THREE.Curve.prototype.getPointAt=function(u){var t=this.getUtoTmapping(u);return this.getPoint(t)},THREE.Curve.prototype.getPoints=function(divisions){divisions||(divisions=5);var pts=[],d;for(d=0;d<=divisions;d++)pts.push(this.getPoint(d/divisions));return pts},THREE.Curve.prototype.getSpacedPoints=function(divisions){divisions||(divisions=5);var pts=[],d;for(d=0;d<=divisions;d++)pts.push(this.getPointAt(d/divisions));return pts},THREE.Curve.prototype.getLength=function(){var lengths=this.getLengths();return lengths[lengths.length-1]},THREE.Curve.prototype.getLengths=function(divisions){if(divisions||(divisions=this.__arcLengthDivisions?this.__arcLengthDivisions:200),this.cacheArcLengths&&this.cacheArcLengths.length==divisions+1&&!this.needsUpdate)return this.cacheArcLengths;this.needsUpdate=!1;var cache=[],last=this.getPoint(0),sum=0,current,p;for(cache.push(0),p=1;p<=divisions;p++)current=this.getPoint(p/divisions),sum+=current.distanceTo(last),cache.push(sum),last=current;return this.cacheArcLengths=cache,cache},THREE.Curve.prototype.updateArcLengths=function(){this.needsUpdate=!0,this.getLengths()},THREE.Curve.prototype.getUtoTmapping=function(u,distance){var arcLengths=this.getLengths(),i=0,il=arcLengths.length,targetArcLength;targetArcLength=distance?distance:u*arcLengths[il-1];for(var low=0,high=il-1,comparison;low<=high;)if(i=Math.floor(low+(high-low)/2),comparison=arcLengths[i]-targetArcLength,0>comparison){low=i+1;continue}else if(0<comparison){high=i-1;continue}else{high=i;break}if(i=high,arcLengths[i]==targetArcLength){var t=i/(il-1);return t}var lengthBefore=arcLengths[i],lengthAfter=arcLengths[i+1],segmentFraction=(targetArcLength-lengthBefore)/(lengthAfter-lengthBefore),t=(i+segmentFraction)/(il-1);return t},THREE.Curve.prototype.getTangent=function(t){var delta=1e-4,t1=t-delta,t2=t+delta;0>t1&&(t1=0),1<t2&&(t2=1);var pt1=this.getPoint(t1),pt2=this.getPoint(t2),vec=pt2.clone().sub(pt1);return vec.normalize()},THREE.Curve.prototype.getTangentAt=function(u){var t=this.getUtoTmapping(u);return this.getTangent(t)},THREE.Curve.Utils={tangentQuadraticBezier:function tangentQuadraticBezier(t,p0,p1,p2){return 2*(1-t)*(p1-p0)+2*t*(p2-p1)},tangentCubicBezier:function tangentCubicBezier(t,p0,p1,p2,p3){return-3*p0*(1-t)*(1-t)+3*p1*(1-t)*(1-t)-6*t*p1*(1-t)+6*t*p2*(1-t)-3*t*t*p2+3*t*t*p3},tangentSpline:function tangentSpline(t){return 6*t*t-6*t+(3*t*t-4*t+1)+(-6*t*t+6*t)+(3*t*t-2*t)},interpolate:function interpolate(p0,p1,p2,p3,t){var v0=.5*(p2-p0),v1=.5*(p3-p1),t2=t*t;return(2*p1-2*p2+v0+v1)*(t*t2)+(-3*p1+3*p2-2*v0-v1)*t2+v0*t+p1}},THREE.Curve.create=function(constructor,getPointFunc){return constructor.prototype=Object.create(THREE.Curve.prototype),constructor.prototype.getPoint=getPointFunc,constructor},THREE.CurvePath=function(){this.curves=[],this.bends=[],this.autoClose=!1},THREE.CurvePath.prototype=Object.create(THREE.Curve.prototype),THREE.CurvePath.prototype.add=function(curve){this.curves.push(curve)},THREE.CurvePath.prototype.checkConnection=function(){},THREE.CurvePath.prototype.closePath=function(){var startPoint=this.curves[0].getPoint(0),endPoint=this.curves[this.curves.length-1].getPoint(1);startPoint.equals(endPoint)||this.curves.push(new THREE.LineCurve(endPoint,startPoint))},THREE.CurvePath.prototype.getPoint=function(t){for(var d=t*this.getLength(),curveLengths=this.getCurveLengths(),i=0,diff,curve;i<curveLengths.length;){if(curveLengths[i]>=d){diff=curveLengths[i]-d,curve=this.curves[i];var u=1-diff/curve.getLength();return curve.getPointAt(u)}i++}return null},THREE.CurvePath.prototype.getLength=function(){var lens=this.getCurveLengths();return lens[lens.length-1]},THREE.CurvePath.prototype.getCurveLengths=function(){if(this.cacheLengths&&this.cacheLengths.length==this.curves.length)return this.cacheLengths;var lengths=[],sums=0,il=this.curves.length,i;for(i=0;i<il;i++)sums+=this.curves[i].getLength(),lengths.push(sums);return this.cacheLengths=lengths,lengths},THREE.CurvePath.prototype.getBoundingBox=function(){var points=this.getPoints(),maxX,maxY,maxZ,minX,minY,minZ;maxX=maxY=Number.NEGATIVE_INFINITY,minX=minY=Number.POSITIVE_INFINITY;var v3=points[0]instanceof THREE.Vector3,p,i,il,sum;for(sum=v3?new THREE.Vector3:new THREE.Vector2,i=0,il=points.length;i<il;i++)p=points[i],p.x>maxX?maxX=p.x:p.x<minX&&(minX=p.x),p.y>maxY?maxY=p.y:p.y<minY&&(minY=p.y),v3&&(p.z>maxZ?maxZ=p.z:p.z<minZ&&(minZ=p.z)),sum.add(p);var ret={minX:minX,minY:minY,maxX:maxX,maxY:maxY,centroid:sum.divideScalar(il)};return v3&&(ret.maxZ=maxZ,ret.minZ=minZ),ret},THREE.CurvePath.prototype.createPointsGeometry=function(divisions){var pts=this.getPoints(divisions,!0);return this.createGeometry(pts)},THREE.CurvePath.prototype.createSpacedPointsGeometry=function(divisions){var pts=this.getSpacedPoints(divisions,!0);return this.createGeometry(pts)},THREE.CurvePath.prototype.createGeometry=function(points){for(var geometry=new THREE.Geometry,i=0;i<points.length;i++)geometry.vertices.push(new THREE.Vector3(points[i].x,points[i].y,points[i].z||0));return geometry},THREE.CurvePath.prototype.addWrapPath=function(bendpath){this.bends.push(bendpath)},THREE.CurvePath.prototype.getTransformedPoints=function(segments,bends){var oldPts=this.getPoints(segments),i,il;for(bends||(bends=this.bends),i=0,il=bends.length;i<il;i++)oldPts=this.getWrapPoints(oldPts,bends[i]);return oldPts},THREE.CurvePath.prototype.getTransformedSpacedPoints=function(segments,bends){var oldPts=this.getSpacedPoints(segments),i,il;for(bends||(bends=this.bends),i=0,il=bends.length;i<il;i++)oldPts=this.getWrapPoints(oldPts,bends[i]);return oldPts},THREE.CurvePath.prototype.getWrapPoints=function(oldPts,path){var bounds=this.getBoundingBox(),i,il,p,oldX,oldY,xNorm;for(i=0,il=oldPts.length;i<il;i++){p=oldPts[i],oldX=p.x,oldY=p.y,xNorm=oldX/bounds.maxX,xNorm=path.getUtoTmapping(xNorm,oldX);var pathPt=path.getPoint(xNorm),normal=path.getNormalVector(xNorm).multiplyScalar(oldY);p.x=pathPt.x+normal.x,p.y=pathPt.y+normal.y}return oldPts},THREE.Gyroscope=function(){THREE.Object3D.call(this)},THREE.Gyroscope.prototype=Object.create(THREE.Object3D.prototype),THREE.Gyroscope.prototype.updateMatrixWorld=function(force){this.matrixAutoUpdate&&this.updateMatrix(),(this.matrixWorldNeedsUpdate||force)&&(this.parent?(this.matrixWorld.multiplyMatrices(this.parent.matrixWorld,this.matrix),this.matrixWorld.decompose(this.translationWorld,this.quaternionWorld,this.scaleWorld),this.matrix.decompose(this.translationObject,this.quaternionObject,this.scaleObject),this.matrixWorld.compose(this.translationWorld,this.quaternionObject,this.scaleWorld)):this.matrixWorld.copy(this.matrix),this.matrixWorldNeedsUpdate=!1,force=!0);for(var i=0,l=this.children.length;i<l;i++)this.children[i].updateMatrixWorld(force)},THREE.Gyroscope.prototype.translationWorld=new THREE.Vector3,THREE.Gyroscope.prototype.translationObject=new THREE.Vector3,THREE.Gyroscope.prototype.quaternionWorld=new THREE.Quaternion,THREE.Gyroscope.prototype.quaternionObject=new THREE.Quaternion,THREE.Gyroscope.prototype.scaleWorld=new THREE.Vector3,THREE.Gyroscope.prototype.scaleObject=new THREE.Vector3,THREE.Path=function(points){THREE.CurvePath.call(this),this.actions=[],points&&this.fromPoints(points)},THREE.Path.prototype=Object.create(THREE.CurvePath.prototype),THREE.PathActions={MOVE_TO:'moveTo',LINE_TO:'lineTo',QUADRATIC_CURVE_TO:'quadraticCurveTo',BEZIER_CURVE_TO:'bezierCurveTo',CSPLINE_THRU:'splineThru',ARC:'arc',ELLIPSE:'ellipse'},THREE.Path.prototype.fromPoints=function(vectors){this.moveTo(vectors[0].x,vectors[0].y);for(var v=1,vlen=vectors.length;v<vlen;v++)this.lineTo(vectors[v].x,vectors[v].y)},THREE.Path.prototype.moveTo=function(){var args=Array.prototype.slice.call(arguments);this.actions.push({action:THREE.PathActions.MOVE_TO,args:args})},THREE.Path.prototype.lineTo=function(x,y){var args=Array.prototype.slice.call(arguments),lastargs=this.actions[this.actions.length-1].args,x0=lastargs[lastargs.length-2],y0=lastargs[lastargs.length-1],curve=new THREE.LineCurve(new THREE.Vector2(x0,y0),new THREE.Vector2(x,y));this.curves.push(curve),this.actions.push({action:THREE.PathActions.LINE_TO,args:args})},THREE.Path.prototype.quadraticCurveTo=function(aCPx,aCPy,aX,aY){var args=Array.prototype.slice.call(arguments),lastargs=this.actions[this.actions.length-1].args,x0=lastargs[lastargs.length-2],y0=lastargs[lastargs.length-1],curve=new THREE.QuadraticBezierCurve(new THREE.Vector2(x0,y0),new THREE.Vector2(aCPx,aCPy),new THREE.Vector2(aX,aY));this.curves.push(curve),this.actions.push({action:THREE.PathActions.QUADRATIC_CURVE_TO,args:args})},THREE.Path.prototype.bezierCurveTo=function(aCP1x,aCP1y,aCP2x,aCP2y,aX,aY){var args=Array.prototype.slice.call(arguments),lastargs=this.actions[this.actions.length-1].args,x0=lastargs[lastargs.length-2],y0=lastargs[lastargs.length-1],curve=new THREE.CubicBezierCurve(new THREE.Vector2(x0,y0),new THREE.Vector2(aCP1x,aCP1y),new THREE.Vector2(aCP2x,aCP2y),new THREE.Vector2(aX,aY));this.curves.push(curve),this.actions.push({action:THREE.PathActions.BEZIER_CURVE_TO,args:args})},THREE.Path.prototype.splineThru=function(pts){var args=Array.prototype.slice.call(arguments),lastargs=this.actions[this.actions.length-1].args,x0=lastargs[lastargs.length-2],y0=lastargs[lastargs.length-1],npts=[new THREE.Vector2(x0,y0)];Array.prototype.push.apply(npts,pts);var curve=new THREE.SplineCurve(npts);this.curves.push(curve),this.actions.push({action:THREE.PathActions.CSPLINE_THRU,args:args})},THREE.Path.prototype.arc=function(aX,aY,aRadius,aStartAngle,aEndAngle,aClockwise){var lastargs=this.actions[this.actions.length-1].args,x0=lastargs[lastargs.length-2],y0=lastargs[lastargs.length-1];this.absarc(aX+x0,aY+y0,aRadius,aStartAngle,aEndAngle,aClockwise)},THREE.Path.prototype.absarc=function(aX,aY,aRadius,aStartAngle,aEndAngle,aClockwise){this.absellipse(aX,aY,aRadius,aRadius,aStartAngle,aEndAngle,aClockwise)},THREE.Path.prototype.ellipse=function(aX,aY,xRadius,yRadius,aStartAngle,aEndAngle,aClockwise){var lastargs=this.actions[this.actions.length-1].args,x0=lastargs[lastargs.length-2],y0=lastargs[lastargs.length-1];this.absellipse(aX+x0,aY+y0,xRadius,yRadius,aStartAngle,aEndAngle,aClockwise)},THREE.Path.prototype.absellipse=function(aX,aY,xRadius,yRadius,aStartAngle,aEndAngle,aClockwise){var args=Array.prototype.slice.call(arguments),curve=new THREE.EllipseCurve(aX,aY,xRadius,yRadius,aStartAngle,aEndAngle,aClockwise);this.curves.push(curve);var lastPoint=curve.getPoint(aClockwise?1:0);args.push(lastPoint.x),args.push(lastPoint.y),this.actions.push({action:THREE.PathActions.ELLIPSE,args:args})},THREE.Path.prototype.getSpacedPoints=function(divisions){divisions||(divisions=40);for(var points=[],i=0;i<divisions;i++)points.push(this.getPoint(i/divisions));return points},THREE.Path.prototype.getPoints=function(divisions,closedPath){var _Mathabs7=Math.abs,_Mathsin4=Math.sin,_Mathcos3=Math.cos;if(this.useSpacedPoints)return console.log('tata'),this.getSpacedPoints(divisions,closedPath);divisions=divisions||12;var points=[],i,il,item,action,args,cpx,cpy,cpx2,cpy2,cpx1,cpy1,cpx0,cpy0,laste,j,t,tx,ty;for(i=0,il=this.actions.length;i<il;i++)switch(item=this.actions[i],action=item.action,args=item.args,action){case THREE.PathActions.MOVE_TO:points.push(new THREE.Vector2(args[0],args[1]));break;case THREE.PathActions.LINE_TO:points.push(new THREE.Vector2(args[0],args[1]));break;case THREE.PathActions.QUADRATIC_CURVE_TO:for(cpx=args[2],cpy=args[3],cpx1=args[0],cpy1=args[1],0<points.length?(laste=points[points.length-1],cpx0=laste.x,cpy0=laste.y):(laste=this.actions[i-1].args,cpx0=laste[laste.length-2],cpy0=laste[laste.length-1]),j=1;j<=divisions;j++)t=j/divisions,tx=THREE.Shape.Utils.b2(t,cpx0,cpx1,cpx),ty=THREE.Shape.Utils.b2(t,cpy0,cpy1,cpy),points.push(new THREE.Vector2(tx,ty));break;case THREE.PathActions.BEZIER_CURVE_TO:for(cpx=args[4],cpy=args[5],cpx1=args[0],cpy1=args[1],cpx2=args[2],cpy2=args[3],0<points.length?(laste=points[points.length-1],cpx0=laste.x,cpy0=laste.y):(laste=this.actions[i-1].args,cpx0=laste[laste.length-2],cpy0=laste[laste.length-1]),j=1;j<=divisions;j++)t=j/divisions,tx=THREE.Shape.Utils.b3(t,cpx0,cpx1,cpx2,cpx),ty=THREE.Shape.Utils.b3(t,cpy0,cpy1,cpy2,cpy),points.push(new THREE.Vector2(tx,ty));break;case THREE.PathActions.CSPLINE_THRU:laste=this.actions[i-1].args;var last=new THREE.Vector2(laste[laste.length-2],laste[laste.length-1]),spts=[last],n=divisions*args[0].length;spts=spts.concat(args[0]);var spline=new THREE.SplineCurve(spts);for(j=1;j<=n;j++)points.push(spline.getPointAt(j/n));break;case THREE.PathActions.ARC:var aX=args[0],aY=args[1],aRadius=args[2],aStartAngle=args[3],aEndAngle=args[4],aClockwise=!!args[5],deltaAngle=aEndAngle-aStartAngle,tdivisions=2*divisions,angle;for(j=1;j<=tdivisions;j++)t=j/tdivisions,aClockwise||(t=1-t),angle=aStartAngle+t*deltaAngle,tx=aX+aRadius*_Mathcos3(angle),ty=aY+aRadius*_Mathsin4(angle),points.push(new THREE.Vector2(tx,ty));break;case THREE.PathActions.ELLIPSE:var aX=args[0],aY=args[1],xRadius=args[2],yRadius=args[3],aStartAngle=args[4],aEndAngle=args[5],aClockwise=!!args[6],deltaAngle=aEndAngle-aStartAngle,tdivisions=2*divisions,angle;for(j=1;j<=tdivisions;j++)t=j/tdivisions,aClockwise||(t=1-t),angle=aStartAngle+t*deltaAngle,tx=aX+xRadius*_Mathcos3(angle),ty=aY+yRadius*_Mathsin4(angle),points.push(new THREE.Vector2(tx,ty));}var lastPoint=points[points.length-1],EPSILON=1e-10;return _Mathabs7(lastPoint.x-points[0].x)<EPSILON&&_Mathabs7(lastPoint.y-points[0].y)<EPSILON&&points.splice(points.length-1,1),closedPath&&points.push(points[0]),points},THREE.Path.prototype.toShapes=function(isCCW){var subPaths=[],lastPath=new THREE.Path,i,il,item,action,args;for(i=0,il=this.actions.length;i<il;i++)item=this.actions[i],args=item.args,action=item.action,action==THREE.PathActions.MOVE_TO&&0!=lastPath.actions.length&&(subPaths.push(lastPath),lastPath=new THREE.Path),lastPath[action].apply(lastPath,args);if(0!=lastPath.actions.length&&subPaths.push(lastPath),0==subPaths.length)return[];var shapes=[],solid,tmpPath,tmpShape;if(1==subPaths.length)return tmpPath=subPaths[0],tmpShape=new THREE.Shape,tmpShape.actions=tmpPath.actions,tmpShape.curves=tmpPath.curves,shapes.push(tmpShape),shapes;var holesFirst=!THREE.Shape.Utils.isClockWise(subPaths[0].getPoints());if(holesFirst=isCCW?!holesFirst:holesFirst,holesFirst)for(tmpShape=new THREE.Shape,i=0,il=subPaths.length;i<il;i++)tmpPath=subPaths[i],solid=THREE.Shape.Utils.isClockWise(tmpPath.getPoints()),solid=isCCW?!solid:solid,solid?(tmpShape.actions=tmpPath.actions,tmpShape.curves=tmpPath.curves,shapes.push(tmpShape),tmpShape=new THREE.Shape):tmpShape.holes.push(tmpPath);else{for(tmpShape=void 0,i=0,il=subPaths.length;i<il;i++)tmpPath=subPaths[i],solid=THREE.Shape.Utils.isClockWise(tmpPath.getPoints()),solid=isCCW?!solid:solid,solid?(tmpShape&&shapes.push(tmpShape),tmpShape=new THREE.Shape,tmpShape.actions=tmpPath.actions,tmpShape.curves=tmpPath.curves):tmpShape.holes.push(tmpPath);shapes.push(tmpShape)}return shapes},THREE.Shape=function(){THREE.Path.apply(this,arguments),this.holes=[]},THREE.Shape.prototype=Object.create(THREE.Path.prototype),THREE.Shape.prototype.extrude=function(options){var extruded=new THREE.ExtrudeGeometry(this,options);return extruded},THREE.Shape.prototype.makeGeometry=function(options){var geometry=new THREE.ShapeGeometry(this,options);return geometry},THREE.Shape.prototype.getPointsHoles=function(divisions){var il=this.holes.length,holesPts=[],i;for(i=0;i<il;i++)holesPts[i]=this.holes[i].getTransformedPoints(divisions,this.bends);return holesPts},THREE.Shape.prototype.getSpacedPointsHoles=function(divisions){var il=this.holes.length,holesPts=[],i;for(i=0;i<il;i++)holesPts[i]=this.holes[i].getTransformedSpacedPoints(divisions,this.bends);return holesPts},THREE.Shape.prototype.extractAllPoints=function(divisions){return{shape:this.getTransformedPoints(divisions),holes:this.getPointsHoles(divisions)}},THREE.Shape.prototype.extractPoints=function(divisions){return this.useSpacedPoints?this.extractAllSpacedPoints(divisions):this.extractAllPoints(divisions)},THREE.Shape.prototype.extractAllSpacedPoints=function(divisions){return{shape:this.getTransformedSpacedPoints(divisions),holes:this.getSpacedPointsHoles(divisions)}},THREE.Shape.Utils={removeHoles:function removeHoles(contour,holes){var shape=contour.concat(),allpoints=shape.concat(),verts=[],prevShapeVert,prevHoleVert,holeIndex,shapeIndex,h,h2,hole,shortest,d,p,pts1,pts2,tmpShape1,tmpShape2,tmpHole1,tmpHole2;for(h=0;h<holes.length;h++){for(hole=holes[h],Array.prototype.push.apply(allpoints,hole),shortest=Number.POSITIVE_INFINITY,h2=0;h2<hole.length;h2++){pts1=hole[h2];var dist=[];for(p=0;p<shape.length;p++)pts2=shape[p],d=pts1.distanceToSquared(pts2),dist.push(d),d<shortest&&(shortest=d,holeIndex=h2,shapeIndex=p)}prevShapeVert=0<=shapeIndex-1?shapeIndex-1:shape.length-1,prevHoleVert=0<=holeIndex-1?holeIndex-1:hole.length-1;var areaapts=[hole[holeIndex],shape[shapeIndex],shape[prevShapeVert]],areaa=THREE.FontUtils.Triangulate.area(areaapts),areabpts=[hole[holeIndex],hole[prevHoleVert],shape[shapeIndex]],areab=THREE.FontUtils.Triangulate.area(areabpts),oldShapeIndex=shapeIndex,oldHoleIndex=holeIndex;shapeIndex+=1,holeIndex+=-1,0>shapeIndex&&(shapeIndex+=shape.length),shapeIndex%=shape.length,0>holeIndex&&(holeIndex+=hole.length),holeIndex%=hole.length,prevShapeVert=0<=shapeIndex-1?shapeIndex-1:shape.length-1,prevHoleVert=0<=holeIndex-1?holeIndex-1:hole.length-1,areaapts=[hole[holeIndex],shape[shapeIndex],shape[prevShapeVert]];var areaa2=THREE.FontUtils.Triangulate.area(areaapts);areabpts=[hole[holeIndex],hole[prevHoleVert],shape[shapeIndex]];var areab2=THREE.FontUtils.Triangulate.area(areabpts);areaa+areab>areaa2+areab2&&(shapeIndex=oldShapeIndex,holeIndex=oldHoleIndex,0>shapeIndex&&(shapeIndex+=shape.length),shapeIndex%=shape.length,0>holeIndex&&(holeIndex+=hole.length),holeIndex%=hole.length,prevShapeVert=0<=shapeIndex-1?shapeIndex-1:shape.length-1,prevHoleVert=0<=holeIndex-1?holeIndex-1:hole.length-1),tmpShape1=shape.slice(0,shapeIndex),tmpShape2=shape.slice(shapeIndex),tmpHole1=hole.slice(holeIndex),tmpHole2=hole.slice(0,holeIndex);var trianglea=[hole[holeIndex],shape[shapeIndex],shape[prevShapeVert]],triangleb=[hole[holeIndex],hole[prevHoleVert],shape[shapeIndex]];verts.push(trianglea),verts.push(triangleb),shape=tmpShape1.concat(tmpHole1).concat(tmpHole2).concat(tmpShape2)}return{shape:shape,isolatedPts:verts,allpoints:allpoints}},triangulateShape:function triangulateShape(contour,holes){var shapeWithoutHoles=THREE.Shape.Utils.removeHoles(contour,holes),shape=shapeWithoutHoles.shape,allpoints=shapeWithoutHoles.allpoints,isolatedPts=shapeWithoutHoles.isolatedPts,triangles=THREE.FontUtils.Triangulate(shape,!1),allPointsMap={},i,il,f,face,key,index;for(i=0,il=allpoints.length;i<il;i++)key=allpoints[i].x+':'+allpoints[i].y,void 0!==allPointsMap[key]&&console.log('Duplicate point',key),allPointsMap[key]=i;for(i=0,il=triangles.length;i<il;i++)for(face=triangles[i],f=0;3>f;f++)key=face[f].x+':'+face[f].y,index=allPointsMap[key],void 0!==index&&(face[f]=index);for(i=0,il=isolatedPts.length;i<il;i++)for(face=isolatedPts[i],f=0;3>f;f++)key=face[f].x+':'+face[f].y,index=allPointsMap[key],void 0!==index&&(face[f]=index);return triangles.concat(isolatedPts)},isClockWise:function isClockWise(pts){return 0>THREE.FontUtils.Triangulate.area(pts)},b2p0:function b2p0(t,p){var k=1-t;return k*k*p},b2p1:function b2p1(t,p){return 2*(1-t)*t*p},b2p2:function b2p2(t,p){return t*t*p},b2:function b2(t,p0,p1,p2){return this.b2p0(t,p0)+this.b2p1(t,p1)+this.b2p2(t,p2)},b3p0:function b3p0(t,p){var k=1-t;return k*k*k*p},b3p1:function b3p1(t,p){var k=1-t;return 3*k*k*t*p},b3p2:function b3p2(t,p){return 3*(1-t)*t*t*p},b3p3:function b3p3(t,p){return t*t*t*p},b3:function b3(t,p0,p1,p2,p3){return this.b3p0(t,p0)+this.b3p1(t,p1)+this.b3p2(t,p2)+this.b3p3(t,p3)}},THREE.LineCurve=function(v1,v2){this.v1=v1,this.v2=v2},THREE.LineCurve.prototype=Object.create(THREE.Curve.prototype),THREE.LineCurve.prototype.getPoint=function(t){var point=this.v2.clone().sub(this.v1);return point.multiplyScalar(t).add(this.v1),point},THREE.LineCurve.prototype.getPointAt=function(u){return this.getPoint(u)},THREE.LineCurve.prototype.getTangent=function(){var tangent=this.v2.clone().sub(this.v1);return tangent.normalize()},THREE.QuadraticBezierCurve=function(v0,v1,v2){this.v0=v0,this.v1=v1,this.v2=v2},THREE.QuadraticBezierCurve.prototype=Object.create(THREE.Curve.prototype),THREE.QuadraticBezierCurve.prototype.getPoint=function(t){var tx,ty;return tx=THREE.Shape.Utils.b2(t,this.v0.x,this.v1.x,this.v2.x),ty=THREE.Shape.Utils.b2(t,this.v0.y,this.v1.y,this.v2.y),new THREE.Vector2(tx,ty)},THREE.QuadraticBezierCurve.prototype.getTangent=function(t){var tx,ty;tx=THREE.Curve.Utils.tangentQuadraticBezier(t,this.v0.x,this.v1.x,this.v2.x),ty=THREE.Curve.Utils.tangentQuadraticBezier(t,this.v0.y,this.v1.y,this.v2.y);var tangent=new THREE.Vector2(tx,ty);return tangent.normalize(),tangent},THREE.CubicBezierCurve=function(v0,v1,v2,v3){this.v0=v0,this.v1=v1,this.v2=v2,this.v3=v3},THREE.CubicBezierCurve.prototype=Object.create(THREE.Curve.prototype),THREE.CubicBezierCurve.prototype.getPoint=function(t){var tx,ty;return tx=THREE.Shape.Utils.b3(t,this.v0.x,this.v1.x,this.v2.x,this.v3.x),ty=THREE.Shape.Utils.b3(t,this.v0.y,this.v1.y,this.v2.y,this.v3.y),new THREE.Vector2(tx,ty)},THREE.CubicBezierCurve.prototype.getTangent=function(t){var tx,ty;tx=THREE.Curve.Utils.tangentCubicBezier(t,this.v0.x,this.v1.x,this.v2.x,this.v3.x),ty=THREE.Curve.Utils.tangentCubicBezier(t,this.v0.y,this.v1.y,this.v2.y,this.v3.y);var tangent=new THREE.Vector2(tx,ty);return tangent.normalize(),tangent},THREE.SplineCurve=function(points){this.points=points==void 0?[]:points},THREE.SplineCurve.prototype=Object.create(THREE.Curve.prototype),THREE.SplineCurve.prototype.getPoint=function(t){var v=new THREE.Vector2,c=[],points=this.points,point,intPoint,weight;return point=(points.length-1)*t,intPoint=Math.floor(point),weight=point-intPoint,c[0]=0==intPoint?intPoint:intPoint-1,c[1]=intPoint,c[2]=intPoint>points.length-2?points.length-1:intPoint+1,c[3]=intPoint>points.length-3?points.length-1:intPoint+2,v.x=THREE.Curve.Utils.interpolate(points[c[0]].x,points[c[1]].x,points[c[2]].x,points[c[3]].x,weight),v.y=THREE.Curve.Utils.interpolate(points[c[0]].y,points[c[1]].y,points[c[2]].y,points[c[3]].y,weight),v},THREE.EllipseCurve=function(aX,aY,xRadius,yRadius,aStartAngle,aEndAngle,aClockwise){this.aX=aX,this.aY=aY,this.xRadius=xRadius,this.yRadius=yRadius,this.aStartAngle=aStartAngle,this.aEndAngle=aEndAngle,this.aClockwise=aClockwise},THREE.EllipseCurve.prototype=Object.create(THREE.Curve.prototype),THREE.EllipseCurve.prototype.getPoint=function(t){var deltaAngle=this.aEndAngle-this.aStartAngle;this.aClockwise||(t=1-t);var angle=this.aStartAngle+t*deltaAngle,tx=this.aX+this.xRadius*Math.cos(angle),ty=this.aY+this.yRadius*Math.sin(angle);return new THREE.Vector2(tx,ty)},THREE.ArcCurve=function(aX,aY,aRadius,aStartAngle,aEndAngle,aClockwise){THREE.EllipseCurve.call(this,aX,aY,aRadius,aRadius,aStartAngle,aEndAngle,aClockwise)},THREE.ArcCurve.prototype=Object.create(THREE.EllipseCurve.prototype),THREE.LineCurve3=THREE.Curve.create(function(v1,v2){this.v1=v1,this.v2=v2},function(t){var r=new THREE.Vector3;return r.subVectors(this.v2,this.v1),r.multiplyScalar(t),r.add(this.v1),r}),THREE.QuadraticBezierCurve3=THREE.Curve.create(function(v0,v1,v2){this.v0=v0,this.v1=v1,this.v2=v2},function(t){var tx,ty,tz;return tx=THREE.Shape.Utils.b2(t,this.v0.x,this.v1.x,this.v2.x),ty=THREE.Shape.Utils.b2(t,this.v0.y,this.v1.y,this.v2.y),tz=THREE.Shape.Utils.b2(t,this.v0.z,this.v1.z,this.v2.z),new THREE.Vector3(tx,ty,tz)}),THREE.CubicBezierCurve3=THREE.Curve.create(function(v0,v1,v2,v3){this.v0=v0,this.v1=v1,this.v2=v2,this.v3=v3},function(t){var tx,ty,tz;return tx=THREE.Shape.Utils.b3(t,this.v0.x,this.v1.x,this.v2.x,this.v3.x),ty=THREE.Shape.Utils.b3(t,this.v0.y,this.v1.y,this.v2.y,this.v3.y),tz=THREE.Shape.Utils.b3(t,this.v0.z,this.v1.z,this.v2.z,this.v3.z),new THREE.Vector3(tx,ty,tz)}),THREE.SplineCurve3=THREE.Curve.create(function(points){this.points=points==void 0?[]:points},function(t){var v=new THREE.Vector3,c=[],points=this.points,point,intPoint,weight;point=(points.length-1)*t,intPoint=Math.floor(point),weight=point-intPoint,c[0]=0==intPoint?intPoint:intPoint-1,c[1]=intPoint,c[2]=intPoint>points.length-2?points.length-1:intPoint+1,c[3]=intPoint>points.length-3?points.length-1:intPoint+2;var pt0=points[c[0]],pt1=points[c[1]],pt2=points[c[2]],pt3=points[c[3]];return v.x=THREE.Curve.Utils.interpolate(pt0.x,pt1.x,pt2.x,pt3.x,weight),v.y=THREE.Curve.Utils.interpolate(pt0.y,pt1.y,pt2.y,pt3.y,weight),v.z=THREE.Curve.Utils.interpolate(pt0.z,pt1.z,pt2.z,pt3.z,weight),v}),THREE.ClosedSplineCurve3=THREE.Curve.create(function(points){this.points=points==void 0?[]:points},function(t){var _Mathfloor5=Math.floor,v=new THREE.Vector3,c=[],points=this.points,point,intPoint,weight;return point=(points.length-0)*t,intPoint=_Mathfloor5(point),weight=point-intPoint,intPoint+=0<intPoint?0:(_Mathfloor5(Math.abs(intPoint)/points.length)+1)*points.length,c[0]=(intPoint-1)%points.length,c[1]=intPoint%points.length,c[2]=(intPoint+1)%points.length,c[3]=(intPoint+2)%points.length,v.x=THREE.Curve.Utils.interpolate(points[c[0]].x,points[c[1]].x,points[c[2]].x,points[c[3]].x,weight),v.y=THREE.Curve.Utils.interpolate(points[c[0]].y,points[c[1]].y,points[c[2]].y,points[c[3]].y,weight),v.z=THREE.Curve.Utils.interpolate(points[c[0]].z,points[c[1]].z,points[c[2]].z,points[c[3]].z,weight),v}),THREE.AnimationHandler=function(){var playing=[],library={},that={};that.update=function(deltaTimeMS){for(var i=0;i<playing.length;i++)playing[i].update(deltaTimeMS)},that.addToUpdate=function(animation){-1===playing.indexOf(animation)&&playing.push(animation)},that.removeFromUpdate=function(animation){var index=playing.indexOf(animation);-1!==index&&playing.splice(index,1)},that.add=function(data){void 0!==library[data.name]&&console.log('THREE.AnimationHandler.add: Warning! '+data.name+' already exists in library. Overwriting.'),library[data.name]=data,initData(data)},that.get=function(name){if('string'==typeof name)return library[name]?library[name]:(console.log('THREE.AnimationHandler.get: Couldn\'t find animation '+name),null)},that.parse=function(root){var hierarchy=[];if(root instanceof THREE.SkinnedMesh)for(var b=0;b<root.bones.length;b++)hierarchy.push(root.bones[b]);else parseRecurseHierarchy(root,hierarchy);return hierarchy};var parseRecurseHierarchy=function(root,hierarchy){hierarchy.push(root);for(var c=0;c<root.children.length;c++)parseRecurseHierarchy(root.children[c],hierarchy)},initData=function(data){if(!0!==data.initialized){for(var h=0;h<data.hierarchy.length;h++){for(var k=0;k<data.hierarchy[h].keys.length;k++)if(0>data.hierarchy[h].keys[k].time&&(data.hierarchy[h].keys[k].time=0),void 0!==data.hierarchy[h].keys[k].rot&&!(data.hierarchy[h].keys[k].rot instanceof THREE.Quaternion)){var quat=data.hierarchy[h].keys[k].rot;data.hierarchy[h].keys[k].rot=new THREE.Quaternion(quat[0],quat[1],quat[2],quat[3])}if(data.hierarchy[h].keys.length&&void 0!==data.hierarchy[h].keys[0].morphTargets){for(var usedMorphTargets={},k=0;k<data.hierarchy[h].keys.length;k++)for(var m=0,morphTargetName;m<data.hierarchy[h].keys[k].morphTargets.length;m++)morphTargetName=data.hierarchy[h].keys[k].morphTargets[m],usedMorphTargets[morphTargetName]=-1;data.hierarchy[h].usedMorphTargets=usedMorphTargets;for(var k=0,influences;k<data.hierarchy[h].keys.length;k++){for(var morphTargetName in influences={},usedMorphTargets){for(var m=0;m<data.hierarchy[h].keys[k].morphTargets.length;m++)if(data.hierarchy[h].keys[k].morphTargets[m]===morphTargetName){influences[morphTargetName]=data.hierarchy[h].keys[k].morphTargetsInfluences[m];break}m===data.hierarchy[h].keys[k].morphTargets.length&&(influences[morphTargetName]=0)}data.hierarchy[h].keys[k].morphTargetsInfluences=influences}}for(var k=1;k<data.hierarchy[h].keys.length;k++)data.hierarchy[h].keys[k].time===data.hierarchy[h].keys[k-1].time&&(data.hierarchy[h].keys.splice(k,1),k--);for(var k=0;k<data.hierarchy[h].keys.length;k++)data.hierarchy[h].keys[k].index=k}var lengthInFrames=parseInt(data.length*data.fps,10);data.JIT={},data.JIT.hierarchy=[];for(var h=0;h<data.hierarchy.length;h++)data.JIT.hierarchy.push(Array(lengthInFrames));data.initialized=!0}};return that.LINEAR=0,that.CATMULLROM=1,that.CATMULLROM_FORWARD=2,that}(),THREE.Animation=function(root,name,interpolationType){this.root=root,this.data=THREE.AnimationHandler.get(name),this.hierarchy=THREE.AnimationHandler.parse(root),this.currentTime=0,this.timeScale=1,this.isPlaying=!1,this.isPaused=!0,this.loop=!0,this.interpolationType=interpolationType===void 0?THREE.AnimationHandler.LINEAR:interpolationType,this.points=[],this.target=new THREE.Vector3},THREE.Animation.prototype.play=function(loop,startTimeMS){if(!1===this.isPlaying){this.isPlaying=!0,this.loop=!(loop!==void 0)||loop,this.currentTime=startTimeMS===void 0?0:startTimeMS;var hl=this.hierarchy.length,h,object;for(h=0;h<hl;h++){object=this.hierarchy[h],object.matrixAutoUpdate=!0,object.animationCache===void 0&&(object.animationCache={},object.animationCache.prevKey={pos:0,rot:0,scl:0},object.animationCache.nextKey={pos:0,rot:0,scl:0},object.animationCache.originalMatrix=object instanceof THREE.Bone?object.skinMatrix:object.matrix);var prevKey=object.animationCache.prevKey,nextKey=object.animationCache.nextKey;prevKey.pos=this.data.hierarchy[h].keys[0],prevKey.rot=this.data.hierarchy[h].keys[0],prevKey.scl=this.data.hierarchy[h].keys[0],nextKey.pos=this.getNextKeyWith('pos',h,1),nextKey.rot=this.getNextKeyWith('rot',h,1),nextKey.scl=this.getNextKeyWith('scl',h,1)}this.update(0)}this.isPaused=!1,THREE.AnimationHandler.addToUpdate(this)},THREE.Animation.prototype.pause=function(){!0===this.isPaused?THREE.AnimationHandler.addToUpdate(this):THREE.AnimationHandler.removeFromUpdate(this),this.isPaused=!this.isPaused},THREE.Animation.prototype.stop=function(){this.isPlaying=!1,this.isPaused=!1,THREE.AnimationHandler.removeFromUpdate(this)},THREE.Animation.prototype.update=function(deltaTimeMS){if(!1!==this.isPlaying){var types=['pos','rot','scl'],JIThierarchy=this.data.JIT.hierarchy,type,scale,vector,prevXYZ,nextXYZ,prevKey,nextKey,object,animationCache,frame,currentTime,unloopedCurrentTime,currentPoint,forwardPoint,angle;this.currentTime+=deltaTimeMS*this.timeScale,unloopedCurrentTime=this.currentTime,currentTime=this.currentTime%=this.data.length,frame=parseInt(Math.min(currentTime*this.data.fps,this.data.length*this.data.fps),10);for(var h=0,hl=this.hierarchy.length;h<hl;h++){object=this.hierarchy[h],animationCache=object.animationCache;for(var t=0;3>t;t++){if(type=types[t],prevKey=animationCache.prevKey[type],nextKey=animationCache.nextKey[type],nextKey.time<=unloopedCurrentTime){if(!(currentTime<unloopedCurrentTime))do prevKey=nextKey,nextKey=this.getNextKeyWith(type,h,nextKey.index+1);while(nextKey.time<currentTime);else if(this.loop)for(prevKey=this.data.hierarchy[h].keys[0],nextKey=this.getNextKeyWith(type,h,1);nextKey.time<currentTime;)prevKey=nextKey,nextKey=this.getNextKeyWith(type,h,nextKey.index+1);else return void this.stop();animationCache.prevKey[type]=prevKey,animationCache.nextKey[type]=nextKey}object.matrixAutoUpdate=!0,object.matrixWorldNeedsUpdate=!0,scale=(currentTime-prevKey.time)/(nextKey.time-prevKey.time),prevXYZ=prevKey[type],nextXYZ=nextKey[type],(0>scale||1<scale)&&(console.log('THREE.Animation.update: Warning! Scale out of bounds:'+scale+' on bone '+h),scale=0>scale?0:1),'pos'===type?(vector=object.position,this.interpolationType===THREE.AnimationHandler.LINEAR?(vector.x=prevXYZ[0]+(nextXYZ[0]-prevXYZ[0])*scale,vector.y=prevXYZ[1]+(nextXYZ[1]-prevXYZ[1])*scale,vector.z=prevXYZ[2]+(nextXYZ[2]-prevXYZ[2])*scale):(this.interpolationType===THREE.AnimationHandler.CATMULLROM||this.interpolationType===THREE.AnimationHandler.CATMULLROM_FORWARD)&&(this.points[0]=this.getPrevKeyWith('pos',h,prevKey.index-1).pos,this.points[1]=prevXYZ,this.points[2]=nextXYZ,this.points[3]=this.getNextKeyWith('pos',h,nextKey.index+1).pos,scale=.33*scale+.33,currentPoint=this.interpolateCatmullRom(this.points,scale),vector.x=currentPoint[0],vector.y=currentPoint[1],vector.z=currentPoint[2],this.interpolationType===THREE.AnimationHandler.CATMULLROM_FORWARD&&(forwardPoint=this.interpolateCatmullRom(this.points,1.01*scale),this.target.set(forwardPoint[0],forwardPoint[1],forwardPoint[2]),this.target.sub(vector),this.target.y=0,this.target.normalize(),angle=Math.atan2(this.target.x,this.target.z),object.rotation.set(0,angle,0)))):'rot'===type?THREE.Quaternion.slerp(prevXYZ,nextXYZ,object.quaternion,scale):'scl'===type&&(vector=object.scale,vector.x=prevXYZ[0]+(nextXYZ[0]-prevXYZ[0])*scale,vector.y=prevXYZ[1]+(nextXYZ[1]-prevXYZ[1])*scale,vector.z=prevXYZ[2]+(nextXYZ[2]-prevXYZ[2])*scale)}}}},THREE.Animation.prototype.interpolateCatmullRom=function(points,scale){var c=[],v3=[],point,intPoint,weight,w2,w3,pa,pb,pc,pd;return point=(points.length-1)*scale,intPoint=Math.floor(point),weight=point-intPoint,c[0]=0===intPoint?intPoint:intPoint-1,c[1]=intPoint,c[2]=intPoint>points.length-2?intPoint:intPoint+1,c[3]=intPoint>points.length-3?intPoint:intPoint+2,pa=points[c[0]],pb=points[c[1]],pc=points[c[2]],pd=points[c[3]],w2=weight*weight,w3=weight*w2,v3[0]=this.interpolate(pa[0],pb[0],pc[0],pd[0],weight,w2,w3),v3[1]=this.interpolate(pa[1],pb[1],pc[1],pd[1],weight,w2,w3),v3[2]=this.interpolate(pa[2],pb[2],pc[2],pd[2],weight,w2,w3),v3},THREE.Animation.prototype.interpolate=function(p0,p1,p2,p3,t,t2,t3){var v0=.5*(p2-p0),v1=.5*(p3-p1);return(2*(p1-p2)+v0+v1)*t3+(-3*(p1-p2)-2*v0-v1)*t2+v0*t+p1},THREE.Animation.prototype.getNextKeyWith=function(type,h,key){var keys=this.data.hierarchy[h].keys;for(this.interpolationType===THREE.AnimationHandler.CATMULLROM||this.interpolationType===THREE.AnimationHandler.CATMULLROM_FORWARD?key=key<keys.length-1?key:keys.length-1:key%=keys.length;key<keys.length;key++)if(keys[key][type]!==void 0)return keys[key];return this.data.hierarchy[h].keys[0]},THREE.Animation.prototype.getPrevKeyWith=function(type,h,key){var keys=this.data.hierarchy[h].keys;for(key=this.interpolationType===THREE.AnimationHandler.CATMULLROM||this.interpolationType===THREE.AnimationHandler.CATMULLROM_FORWARD?0<key?key:0:0<=key?key:key+keys.length;0<=key;key--)if(keys[key][type]!==void 0)return keys[key];return this.data.hierarchy[h].keys[keys.length-1]},THREE.KeyFrameAnimation=function(root,data,JITCompile){this.root=root,this.data=THREE.AnimationHandler.get(data),this.hierarchy=THREE.AnimationHandler.parse(root),this.currentTime=0,this.timeScale=.001,this.isPlaying=!1,this.isPaused=!0,this.loop=!0,this.JITCompile=!(JITCompile!==void 0)||JITCompile;for(var h=0,hl=this.hierarchy.length;h<hl;h++){var keys=this.data.hierarchy[h].keys,sids=this.data.hierarchy[h].sids,obj=this.hierarchy[h];if(keys.length&&sids){for(var s=0;s<sids.length;s++){var sid=sids[s],next=this.getNextKeyWith(sid,h,0);next&&next.apply(sid)}obj.matrixAutoUpdate=!1,this.data.hierarchy[h].node.updateMatrix(),obj.matrixWorldNeedsUpdate=!0}}},THREE.KeyFrameAnimation.prototype.play=function(loop,startTimeMS){if(!this.isPlaying){this.isPlaying=!0,this.loop=!(loop!==void 0)||loop,this.currentTime=startTimeMS===void 0?0:startTimeMS,this.startTimeMs=startTimeMS,this.startTime=1e7,this.endTime=-this.startTime;var hl=this.hierarchy.length,h,object,node;for(h=0;h<hl;h++){object=this.hierarchy[h],node=this.data.hierarchy[h],node.animationCache===void 0&&(node.animationCache={},node.animationCache.prevKey=null,node.animationCache.nextKey=null,node.animationCache.originalMatrix=object instanceof THREE.Bone?object.skinMatrix:object.matrix);var keys=this.data.hierarchy[h].keys;keys.length&&(node.animationCache.prevKey=keys[0],node.animationCache.nextKey=keys[1],this.startTime=Math.min(keys[0].time,this.startTime),this.endTime=Math.max(keys[keys.length-1].time,this.endTime))}this.update(0)}this.isPaused=!1,THREE.AnimationHandler.addToUpdate(this)},THREE.KeyFrameAnimation.prototype.pause=function(){this.isPaused?THREE.AnimationHandler.addToUpdate(this):THREE.AnimationHandler.removeFromUpdate(this),this.isPaused=!this.isPaused},THREE.KeyFrameAnimation.prototype.stop=function(){this.isPlaying=!1,this.isPaused=!1,THREE.AnimationHandler.removeFromUpdate(this);for(var h=0;h<this.data.hierarchy.length;h++){var obj=this.hierarchy[h],node=this.data.hierarchy[h];if(node.animationCache!==void 0){var original=node.animationCache.originalMatrix;obj instanceof THREE.Bone?(original.copy(obj.skinMatrix),obj.skinMatrix=original):(original.copy(obj.matrix),obj.matrix=original),delete node.animationCache}}},THREE.KeyFrameAnimation.prototype.update=function(deltaTimeMS){if(this.isPlaying){var JIThierarchy=this.data.JIT.hierarchy,prevKey,nextKey,object,node,frame,currentTime,unloopedCurrentTime,looped;if(this.currentTime+=deltaTimeMS*this.timeScale,unloopedCurrentTime=this.currentTime,currentTime=this.currentTime%=this.data.length,currentTime<this.startTimeMs&&(currentTime=this.currentTime=this.startTimeMs+currentTime),frame=parseInt(Math.min(currentTime*this.data.fps,this.data.length*this.data.fps),10),looped=currentTime<unloopedCurrentTime,looped&&!this.loop){for(var h=0,hl=this.hierarchy.length;h<hl;h++){var keys=this.data.hierarchy[h].keys,sids=this.data.hierarchy[h].sids,end=keys.length-1,obj=this.hierarchy[h];if(keys.length){for(var s=0;s<sids.length;s++){var sid=sids[s],prev=this.getPrevKeyWith(sid,h,end);prev&&prev.apply(sid)}this.data.hierarchy[h].node.updateMatrix(),obj.matrixWorldNeedsUpdate=!0}}return void this.stop()}if(!(currentTime<this.startTime)){for(var h=0,hl=this.hierarchy.length;h<hl;h++){object=this.hierarchy[h],node=this.data.hierarchy[h];var keys=node.keys,animationCache=node.animationCache;if(this.JITCompile&&void 0!==JIThierarchy[h][frame])object instanceof THREE.Bone?(object.skinMatrix=JIThierarchy[h][frame],object.matrixWorldNeedsUpdate=!1):(object.matrix=JIThierarchy[h][frame],object.matrixWorldNeedsUpdate=!0);else if(keys.length){if(this.JITCompile&&animationCache&&(object instanceof THREE.Bone?object.skinMatrix=animationCache.originalMatrix:object.matrix=animationCache.originalMatrix),prevKey=animationCache.prevKey,nextKey=animationCache.nextKey,prevKey&&nextKey){if(nextKey.time<=unloopedCurrentTime){if(looped&&this.loop)for(prevKey=keys[0],nextKey=keys[1];nextKey.time<currentTime;)prevKey=nextKey,nextKey=keys[prevKey.index+1];else if(!looped)for(var lastIndex=keys.length-1;nextKey.time<currentTime&&nextKey.index!==lastIndex;)prevKey=nextKey,nextKey=keys[prevKey.index+1];animationCache.prevKey=prevKey,animationCache.nextKey=nextKey}nextKey.time>=currentTime?prevKey.interpolate(nextKey,currentTime):prevKey.interpolate(nextKey,nextKey.time)}this.data.hierarchy[h].node.updateMatrix(),object.matrixWorldNeedsUpdate=!0}}if(this.JITCompile&&void 0===JIThierarchy[0][frame]){this.hierarchy[0].updateMatrixWorld(!0);for(var h=0;h<this.hierarchy.length;h++)JIThierarchy[h][frame]=this.hierarchy[h]instanceof THREE.Bone?this.hierarchy[h].skinMatrix.clone():this.hierarchy[h].matrix.clone()}}}},THREE.KeyFrameAnimation.prototype.getNextKeyWith=function(sid,h,key){var keys=this.data.hierarchy[h].keys;for(key%=keys.length;key<keys.length;key++)if(keys[key].hasTarget(sid))return keys[key];return keys[0]},THREE.KeyFrameAnimation.prototype.getPrevKeyWith=function(sid,h,key){var keys=this.data.hierarchy[h].keys;for(key=0<=key?key:key+keys.length;0<=key;key--)if(keys[key].hasTarget(sid))return keys[key];return keys[keys.length-1]},THREE.CubeCamera=function(near,far,cubeResolution){THREE.Object3D.call(this);var fov=90,aspect=1,cameraPX=new THREE.PerspectiveCamera(fov,aspect,near,far);cameraPX.up.set(0,-1,0),cameraPX.lookAt(new THREE.Vector3(1,0,0)),this.add(cameraPX);var cameraNX=new THREE.PerspectiveCamera(fov,aspect,near,far);cameraNX.up.set(0,-1,0),cameraNX.lookAt(new THREE.Vector3(-1,0,0)),this.add(cameraNX);var cameraPY=new THREE.PerspectiveCamera(fov,aspect,near,far);cameraPY.up.set(0,0,1),cameraPY.lookAt(new THREE.Vector3(0,1,0)),this.add(cameraPY);var cameraNY=new THREE.PerspectiveCamera(fov,aspect,near,far);cameraNY.up.set(0,0,-1),cameraNY.lookAt(new THREE.Vector3(0,-1,0)),this.add(cameraNY);var cameraPZ=new THREE.PerspectiveCamera(fov,aspect,near,far);cameraPZ.up.set(0,-1,0),cameraPZ.lookAt(new THREE.Vector3(0,0,1)),this.add(cameraPZ);var cameraNZ=new THREE.PerspectiveCamera(fov,aspect,near,far);cameraNZ.up.set(0,-1,0),cameraNZ.lookAt(new THREE.Vector3(0,0,-1)),this.add(cameraNZ),this.renderTarget=new THREE.WebGLRenderTargetCube(cubeResolution,cubeResolution,{format:THREE.RGBFormat,magFilter:THREE.LinearFilter,minFilter:THREE.LinearFilter}),this.updateCubeMap=function(renderer,scene){var renderTarget=this.renderTarget,generateMipmaps=renderTarget.generateMipmaps;renderTarget.generateMipmaps=!1,renderTarget.activeCubeFace=0,renderer.render(scene,cameraPX,renderTarget),renderTarget.activeCubeFace=1,renderer.render(scene,cameraNX,renderTarget),renderTarget.activeCubeFace=2,renderer.render(scene,cameraPY,renderTarget),renderTarget.activeCubeFace=3,renderer.render(scene,cameraNY,renderTarget),renderTarget.activeCubeFace=4,renderer.render(scene,cameraPZ,renderTarget),renderTarget.generateMipmaps=generateMipmaps,renderTarget.activeCubeFace=5,renderer.render(scene,cameraNZ,renderTarget)}},THREE.CubeCamera.prototype=Object.create(THREE.Object3D.prototype),THREE.CombinedCamera=function(width,height,fov,near,far,orthoNear,orthoFar){THREE.Camera.call(this),this.fov=fov,this.left=-width/2,this.right=width/2,this.top=height/2,this.bottom=-height/2,this.cameraO=new THREE.OrthographicCamera(width/-2,width/2,height/2,height/-2,orthoNear,orthoFar),this.cameraP=new THREE.PerspectiveCamera(fov,width/height,near,far),this.zoom=1,this.toPerspective()},THREE.CombinedCamera.prototype=Object.create(THREE.Camera.prototype),THREE.CombinedCamera.prototype.toPerspective=function(){this.near=this.cameraP.near,this.far=this.cameraP.far,this.cameraP.fov=this.fov/this.zoom,this.cameraP.updateProjectionMatrix(),this.projectionMatrix=this.cameraP.projectionMatrix,this.inPerspectiveMode=!0,this.inOrthographicMode=!1},THREE.CombinedCamera.prototype.toOrthographic=function(){var fov=this.fov,aspect=this.cameraP.aspect,near=this.cameraP.near,far=this.cameraP.far,halfHeight=Math.tan(fov/2)*((near+far)/2),planeHeight=2*halfHeight,halfWidth=planeHeight*aspect/2;halfHeight/=this.zoom,halfWidth/=this.zoom,this.cameraO.left=-halfWidth,this.cameraO.right=halfWidth,this.cameraO.top=halfHeight,this.cameraO.bottom=-halfHeight,this.cameraO.updateProjectionMatrix(),this.near=this.cameraO.near,this.far=this.cameraO.far,this.projectionMatrix=this.cameraO.projectionMatrix,this.inPerspectiveMode=!1,this.inOrthographicMode=!0},THREE.CombinedCamera.prototype.setSize=function(width,height){this.cameraP.aspect=width/height,this.left=-width/2,this.right=width/2,this.top=height/2,this.bottom=-height/2},THREE.CombinedCamera.prototype.setFov=function(fov){this.fov=fov,this.inPerspectiveMode?this.toPerspective():this.toOrthographic()},THREE.CombinedCamera.prototype.updateProjectionMatrix=function(){this.inPerspectiveMode?this.toPerspective():(this.toPerspective(),this.toOrthographic())},THREE.CombinedCamera.prototype.setLens=function(focalLength,frameHeight){void 0===frameHeight&&(frameHeight=24);var fov=2*THREE.Math.radToDeg(Math.atan(frameHeight/(2*focalLength)));return this.setFov(fov),fov},THREE.CombinedCamera.prototype.setZoom=function(zoom){this.zoom=zoom,this.inPerspectiveMode?this.toPerspective():this.toOrthographic()},THREE.CombinedCamera.prototype.toFrontView=function(){this.rotation.x=0,this.rotation.y=0,this.rotation.z=0,this.rotationAutoUpdate=!1},THREE.CombinedCamera.prototype.toBackView=function(){this.rotation.x=0,this.rotation.y=Math.PI,this.rotation.z=0,this.rotationAutoUpdate=!1},THREE.CombinedCamera.prototype.toLeftView=function(){this.rotation.x=0,this.rotation.y=-Math.PI/2,this.rotation.z=0,this.rotationAutoUpdate=!1},THREE.CombinedCamera.prototype.toRightView=function(){this.rotation.x=0,this.rotation.y=Math.PI/2,this.rotation.z=0,this.rotationAutoUpdate=!1},THREE.CombinedCamera.prototype.toTopView=function(){this.rotation.x=-Math.PI/2,this.rotation.y=0,this.rotation.z=0,this.rotationAutoUpdate=!1},THREE.CombinedCamera.prototype.toBottomView=function(){this.rotation.x=Math.PI/2,this.rotation.y=0,this.rotation.z=0,this.rotationAutoUpdate=!1},THREE.CircleGeometry=function(radius,segments,thetaStart,thetaLength){THREE.Geometry.call(this),radius=radius||50,thetaStart=thetaStart===void 0?0:thetaStart,thetaLength=thetaLength===void 0?2*Math.PI:thetaLength,segments=segments===void 0?8:Math.max(3,segments);var uvs=[],center=new THREE.Vector3,centerUV=new THREE.Vector2(.5,.5),i;for(this.vertices.push(center),uvs.push(centerUV),i=0;i<=segments;i++){var vertex=new THREE.Vector3,segment=thetaStart+i/segments*thetaLength;vertex.x=radius*Math.cos(segment),vertex.y=radius*Math.sin(segment),this.vertices.push(vertex),uvs.push(new THREE.Vector2((vertex.x/radius+1)/2,(vertex.y/radius+1)/2))}var n=new THREE.Vector3(0,0,1);for(i=1;i<=segments;i++){var v1=i,v2=i+1;this.faces.push(new THREE.Face3(v1,v2,0,[n,n,n])),this.faceVertexUvs[0].push([uvs[i],uvs[i+1],centerUV])}this.computeCentroids(),this.computeFaceNormals(),this.boundingSphere=new THREE.Sphere(new THREE.Vector3(),radius)},THREE.CircleGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.CubeGeometry=function(width,height,depth,widthSegments,heightSegments,depthSegments){function buildPlane(u,v,udir,vdir,width,height,depth,materialIndex){var gridX=scope.widthSegments,gridY=scope.heightSegments,offset=scope.vertices.length,w,ix,iy;'x'===u&&'y'===v||'y'===u&&'x'===v?w='z':'x'===u&&'z'===v||'z'===u&&'x'===v?(w='y',gridY=scope.depthSegments):('z'==u&&'y'==v||'y'==u&&'z'==v)&&(w='x',gridX=scope.depthSegments);var gridX1=gridX+1,gridY1=gridY+1,segment_width=width/gridX,segment_height=height/gridY,normal=new THREE.Vector3;for(normal[w]=0<depth?1:-1,iy=0;iy<gridY1;iy++)for(ix=0;ix<gridX1;ix++){var vector=new THREE.Vector3;vector[u]=(ix*segment_width-width/2)*udir,vector[v]=(iy*segment_height-height/2)*vdir,vector[w]=depth,scope.vertices.push(vector)}for(iy=0;iy<gridY;iy++)for(ix=0;ix<gridX;ix++){var a=ix+gridX1*iy,b=ix+gridX1*(iy+1),c=ix+1+gridX1*(iy+1),d=ix+1+gridX1*iy,uva=new THREE.Vector2(ix/gridX,1-iy/gridY),uvb=new THREE.Vector2(ix/gridX,1-(iy+1)/gridY),uvc=new THREE.Vector2((ix+1)/gridX,1-(iy+1)/gridY),uvd=new THREE.Vector2((ix+1)/gridX,1-iy/gridY),face=new THREE.Face3(a+offset,b+offset,d+offset);face.normal.copy(normal),face.vertexNormals.push(normal.clone(),normal.clone(),normal.clone()),face.materialIndex=materialIndex,scope.faces.push(face),scope.faceVertexUvs[0].push([uva,uvb,uvd]),face=new THREE.Face3(b+offset,c+offset,d+offset),face.normal.copy(normal),face.vertexNormals.push(normal.clone(),normal.clone(),normal.clone()),face.materialIndex=materialIndex,scope.faces.push(face),scope.faceVertexUvs[0].push([uvb.clone(),uvc,uvd.clone()])}}THREE.Geometry.call(this);var scope=this;this.width=width,this.height=height,this.depth=depth,this.widthSegments=widthSegments||1,this.heightSegments=heightSegments||1,this.depthSegments=depthSegments||1;var width_half=this.width/2,height_half=this.height/2,depth_half=this.depth/2;buildPlane('z','y',-1,-1,this.depth,this.height,width_half,0),buildPlane('z','y',1,-1,this.depth,this.height,-width_half,1),buildPlane('x','z',1,1,this.width,this.depth,height_half,2),buildPlane('x','z',1,-1,this.width,this.depth,-height_half,3),buildPlane('x','y',1,-1,this.width,this.height,depth_half,4),buildPlane('x','y',-1,-1,this.width,this.height,-depth_half,5),this.computeCentroids(),this.mergeVertices()},THREE.CubeGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.CylinderGeometry=function(radiusTop,radiusBottom,height,radialSegments,heightSegments,openEnded){var _MathPI=Math.PI,_Mathsqrt5=Math.sqrt;THREE.Geometry.call(this),this.radiusTop=radiusTop=radiusTop===void 0?20:radiusTop,this.radiusBottom=radiusBottom=radiusBottom===void 0?20:radiusBottom,this.height=height=height===void 0?100:height,this.radialSegments=radialSegments=radialSegments||8,this.heightSegments=heightSegments=heightSegments||1,this.openEnded=openEnded=openEnded!==void 0&&openEnded;var heightHalf=height/2,vertices=[],uvs=[],x,y;for(y=0;y<=heightSegments;y++){var verticesRow=[],uvsRow=[],v=y/heightSegments,radius=v*(radiusBottom-radiusTop)+radiusTop;for(x=0;x<=radialSegments;x++){var u=x/radialSegments,vertex=new THREE.Vector3;vertex.x=radius*Math.sin(2*(u*_MathPI)),vertex.y=-v*height+heightHalf,vertex.z=radius*Math.cos(2*(u*_MathPI)),this.vertices.push(vertex),verticesRow.push(this.vertices.length-1),uvsRow.push(new THREE.Vector2(u,1-v))}vertices.push(verticesRow),uvs.push(uvsRow)}var tanTheta=(radiusBottom-radiusTop)/height,na,nb;for(x=0;x<radialSegments;x++)for(0===radiusTop?(na=this.vertices[vertices[1][x]].clone(),nb=this.vertices[vertices[1][x+1]].clone()):(na=this.vertices[vertices[0][x]].clone(),nb=this.vertices[vertices[0][x+1]].clone()),na.setY(_Mathsqrt5(na.x*na.x+na.z*na.z)*tanTheta).normalize(),nb.setY(_Mathsqrt5(nb.x*nb.x+nb.z*nb.z)*tanTheta).normalize(),y=0;y<heightSegments;y++){var v1=vertices[y][x],v2=vertices[y+1][x],v3=vertices[y+1][x+1],v4=vertices[y][x+1],n1=na.clone(),n2=na.clone(),n3=nb.clone(),n4=nb.clone(),uv1=uvs[y][x].clone(),uv2=uvs[y+1][x].clone(),uv3=uvs[y+1][x+1].clone(),uv4=uvs[y][x+1].clone();this.faces.push(new THREE.Face3(v1,v2,v4,[n1,n2,n4])),this.faceVertexUvs[0].push([uv1,uv2,uv4]),this.faces.push(new THREE.Face3(v2,v3,v4,[n2,n3,n4])),this.faceVertexUvs[0].push([uv2,uv3,uv4])}if(!1===openEnded&&0<radiusTop)for(this.vertices.push(new THREE.Vector3(0,heightHalf,0)),x=0;x<radialSegments;x++){var v1=vertices[0][x],v2=vertices[0][x+1],v3=this.vertices.length-1,n1=new THREE.Vector3(0,1,0),n2=new THREE.Vector3(0,1,0),n3=new THREE.Vector3(0,1,0),uv1=uvs[0][x].clone(),uv2=uvs[0][x+1].clone(),uv3=new THREE.Vector2(uv2.u,0);this.faces.push(new THREE.Face3(v1,v2,v3,[n1,n2,n3])),this.faceVertexUvs[0].push([uv1,uv2,uv3])}if(!1===openEnded&&0<radiusBottom)for(this.vertices.push(new THREE.Vector3(0,-heightHalf,0)),x=0;x<radialSegments;x++){var v1=vertices[y][x+1],v2=vertices[y][x],v3=this.vertices.length-1,n1=new THREE.Vector3(0,-1,0),n2=new THREE.Vector3(0,-1,0),n3=new THREE.Vector3(0,-1,0),uv1=uvs[y][x+1].clone(),uv2=uvs[y][x].clone(),uv3=new THREE.Vector2(uv2.u,1);this.faces.push(new THREE.Face3(v1,v2,v3,[n1,n2,n3])),this.faceVertexUvs[0].push([uv1,uv2,uv3])}this.computeCentroids(),this.computeFaceNormals()},THREE.CylinderGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.ExtrudeGeometry=function(shapes,options){return'undefined'==typeof shapes?void(shapes=[]):void(THREE.Geometry.call(this),shapes=shapes instanceof Array?shapes:[shapes],this.shapebb=shapes[shapes.length-1].getBoundingBox(),this.addShapeList(shapes,options),this.computeCentroids(),this.computeFaceNormals())},THREE.ExtrudeGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.ExtrudeGeometry.prototype.addShapeList=function(shapes,options){for(var sl=shapes.length,s=0,shape;s<sl;s++)shape=shapes[s],this.addShape(shape,options)},THREE.ExtrudeGeometry.prototype.addShape=function(shape,options){function scalePt2(pt,vec,size){return vec||console.log('die'),vec.clone().multiplyScalar(size).add(pt)}function getBevelVec(pt_i,pt_j,pt_k){return getBevelVec2(pt_i,pt_j,pt_k)}function getBevelVec1(pt_i,pt_j,pt_k){var anglea=_Mathatan3(pt_j.y-pt_i.y,pt_j.x-pt_i.x),angleb=_Mathatan3(pt_k.y-pt_i.y,pt_k.x-pt_i.x);anglea>angleb&&(angleb+=2*_MathPI2);var anglec=(anglea+angleb)/2,x=-Math.cos(anglec),y=-_Mathsin5(anglec),vec=new THREE.Vector2(x,y);return vec}function getBevelVec2(pt_i,pt_j,pt_k){var a=THREE.ExtrudeGeometry.__v1,b=THREE.ExtrudeGeometry.__v2,v_hat=THREE.ExtrudeGeometry.__v3,w_hat=THREE.ExtrudeGeometry.__v4,p=THREE.ExtrudeGeometry.__v5,q=THREE.ExtrudeGeometry.__v6,v,w,v_dot_w_hat,q_sub_p_dot_w_hat,s,intersection;return(a.set(pt_i.x-pt_j.x,pt_i.y-pt_j.y),b.set(pt_i.x-pt_k.x,pt_i.y-pt_k.y),v=a.normalize(),w=b.normalize(),v_hat.set(-v.y,v.x),w_hat.set(w.y,-w.x),p.copy(pt_i).add(v_hat),q.copy(pt_i).add(w_hat),p.equals(q))?w_hat.clone():(p.copy(pt_j).add(v_hat),q.copy(pt_k).add(w_hat),v_dot_w_hat=v.dot(w_hat),q_sub_p_dot_w_hat=q.sub(p).dot(w_hat),0===v_dot_w_hat&&(console.log('Either infinite or no solutions!'),0===q_sub_p_dot_w_hat?console.log('Its finite solutions.'):console.log('Too bad, no solutions.')),s=q_sub_p_dot_w_hat/v_dot_w_hat,0>s)?getBevelVec1(pt_i,pt_j,pt_k):(intersection=v.multiplyScalar(s).add(p),intersection.sub(pt_i).clone())}function buildLidFaces(){if(bevelEnabled){var layer=0,offset=vlen*layer;for(i=0;i<flen;i++)face=faces[i],f3(face[2]+offset,face[1]+offset,face[0]+offset,!0);for(layer=steps+2*bevelSegments,offset=vlen*layer,i=0;i<flen;i++)face=faces[i],f3(face[0]+offset,face[1]+offset,face[2]+offset,!1)}else{for(i=0;i<flen;i++)face=faces[i],f3(face[2],face[1],face[0],!0);for(i=0;i<flen;i++)face=faces[i],f3(face[0]+vlen*steps,face[1]+vlen*steps,face[2]+vlen*steps,!1)}}function buildSideFaces(){var layeroffset=0;for(sidewalls(contour,layeroffset),layeroffset+=contour.length,(h=0,hl=holes.length);h<hl;h++)ahole=holes[h],sidewalls(ahole,layeroffset),layeroffset+=ahole.length}function sidewalls(contour,layeroffset){var j,k;for(i=contour.length;0<=--i;){j=i,k=i-1,0>k&&(k=contour.length-1);var s=0,sl=steps+2*bevelSegments;for(s=0;s<sl;s++){var slen1=vlen*s,slen2=vlen*(s+1),a=layeroffset+j+slen1,b=layeroffset+k+slen1,c=layeroffset+k+slen2,d=layeroffset+j+slen2;f4(a,b,c,d,contour,s,sl,j,k)}}}function v(x,y,z){scope.vertices.push(new THREE.Vector3(x,y,z))}function f3(a,b,c,isBottom){a+=shapesOffset,b+=shapesOffset,c+=shapesOffset,scope.faces.push(new THREE.Face3(a,b,c,null,null,material));var uvs=isBottom?uvgen.generateBottomUV(scope,shape,options,a,b,c):uvgen.generateTopUV(scope,shape,options,a,b,c);scope.faceVertexUvs[0].push(uvs)}function f4(a,b,c,d,wallContour,stepIndex,stepsLength,contourIndex1,contourIndex2){a+=shapesOffset,b+=shapesOffset,c+=shapesOffset,d+=shapesOffset,scope.faces.push(new THREE.Face3(a,b,d,null,null,extrudeMaterial)),scope.faces.push(new THREE.Face3(b,c,d,null,null,extrudeMaterial));var uvs=uvgen.generateSideWallUV(scope,shape,wallContour,options,a,b,c,d,stepIndex,stepsLength,contourIndex1,contourIndex2);scope.faceVertexUvs[0].push([uvs[0],uvs[1],uvs[3]]),scope.faceVertexUvs[0].push([uvs[1],uvs[2],uvs[3]])}var _Mathatan3=Math.atan2,_MathPI2=Math.PI,_Mathsin5=Math.sin,amount=void 0===options.amount?100:options.amount,bevelThickness=void 0===options.bevelThickness?6:options.bevelThickness,bevelSize=void 0===options.bevelSize?bevelThickness-2:options.bevelSize,bevelSegments=void 0===options.bevelSegments?3:options.bevelSegments,bevelEnabled=void 0===options.bevelEnabled||options.bevelEnabled,curveSegments=void 0===options.curveSegments?12:options.curveSegments,steps=void 0===options.steps?1:options.steps,extrudePath=options.extrudePath,extrudeByPath=!1,material=options.material,extrudeMaterial=options.extrudeMaterial,uvgen=void 0===options.UVGenerator?THREE.ExtrudeGeometry.WorldUVGenerator:options.UVGenerator,shapebb=this.shapebb,extrudePts,splineTube,binormal,normal,position2;extrudePath&&(extrudePts=extrudePath.getSpacedPoints(steps),extrudeByPath=!0,bevelEnabled=!1,splineTube=options.frames===void 0?new THREE.TubeGeometry.FrenetFrames(extrudePath,steps,!1):options.frames,binormal=new THREE.Vector3,normal=new THREE.Vector3,position2=new THREE.Vector3),bevelEnabled||(bevelSegments=0,bevelThickness=0,bevelSize=0);var scope=this,shapesOffset=this.vertices.length,shapePoints=shape.extractPoints(curveSegments),vertices=shapePoints.shape,holes=shapePoints.holes,reverse=!THREE.Shape.Utils.isClockWise(vertices),ahole,h,hl;if(reverse){for(vertices=vertices.reverse(),h=0,hl=holes.length;h<hl;h++)ahole=holes[h],THREE.Shape.Utils.isClockWise(ahole)&&(holes[h]=ahole.reverse());reverse=!1}var faces=THREE.Shape.Utils.triangulateShape(vertices,holes),contour=vertices;for(h=0,hl=holes.length;h<hl;h++)ahole=holes[h],vertices=vertices.concat(ahole);for(var vlen=vertices.length,flen=faces.length,clen=contour.length,contourMovements=[],i=0,il=contour.length,j=il-1,k=i+1,b,bs,t,z,vert,face;i<il;i++,j++,k++){j===il&&(j=0),k===il&&(k=0);var pt_i=contour[i],pt_j=contour[j],pt_k=contour[k];contourMovements[i]=getBevelVec(contour[i],contour[j],contour[k])}var holesMovements=[],verticesMovements=contourMovements.concat(),oneHoleMovements;for(h=0,hl=holes.length;h<hl;h++){for(ahole=holes[h],oneHoleMovements=[],(i=0,il=ahole.length,j=il-1,k=i+1);i<il;i++,j++,k++)j===il&&(j=0),k===il&&(k=0),oneHoleMovements[i]=getBevelVec(ahole[i],ahole[j],ahole[k]);holesMovements.push(oneHoleMovements),verticesMovements=verticesMovements.concat(oneHoleMovements)}for(b=0;b<bevelSegments;b++){for(t=b/bevelSegments,z=bevelThickness*(1-t),bs=bevelSize*_Mathsin5(t*_MathPI2/2),(i=0,il=contour.length);i<il;i++)vert=scalePt2(contour[i],contourMovements[i],bs),v(vert.x,vert.y,-z);for(h=0,hl=holes.length;h<hl;h++)for(ahole=holes[h],oneHoleMovements=holesMovements[h],(i=0,il=ahole.length);i<il;i++)vert=scalePt2(ahole[i],oneHoleMovements[i],bs),v(vert.x,vert.y,-z)}for(bs=bevelSize,i=0;i<vlen;i++)vert=bevelEnabled?scalePt2(vertices[i],verticesMovements[i],bs):vertices[i],extrudeByPath?(normal.copy(splineTube.normals[0]).multiplyScalar(vert.x),binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y),position2.copy(extrudePts[0]).add(normal).add(binormal),v(position2.x,position2.y,position2.z)):v(vert.x,vert.y,0);var s;for(s=1;s<=steps;s++)for(i=0;i<vlen;i++)vert=bevelEnabled?scalePt2(vertices[i],verticesMovements[i],bs):vertices[i],extrudeByPath?(normal.copy(splineTube.normals[s]).multiplyScalar(vert.x),binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y),position2.copy(extrudePts[s]).add(normal).add(binormal),v(position2.x,position2.y,position2.z)):v(vert.x,vert.y,amount/steps*s);for(b=bevelSegments-1;0<=b;b--){for(t=b/bevelSegments,z=bevelThickness*(1-t),bs=bevelSize*_Mathsin5(t*_MathPI2/2),(i=0,il=contour.length);i<il;i++)vert=scalePt2(contour[i],contourMovements[i],bs),v(vert.x,vert.y,amount+z);for(h=0,hl=holes.length;h<hl;h++)for(ahole=holes[h],oneHoleMovements=holesMovements[h],(i=0,il=ahole.length);i<il;i++)vert=scalePt2(ahole[i],oneHoleMovements[i],bs),extrudeByPath?v(vert.x,vert.y+extrudePts[steps-1].y,extrudePts[steps-1].x+z):v(vert.x,vert.y,amount+z)}buildLidFaces(),buildSideFaces()},THREE.ExtrudeGeometry.WorldUVGenerator={generateTopUV:function generateTopUV(geometry,extrudedShape,extrudeOptions,indexA,indexB,indexC){var ax=geometry.vertices[indexA].x,ay=geometry.vertices[indexA].y,bx=geometry.vertices[indexB].x,by=geometry.vertices[indexB].y,cx=geometry.vertices[indexC].x,cy=geometry.vertices[indexC].y;return[new THREE.Vector2(ax,ay),new THREE.Vector2(bx,by),new THREE.Vector2(cx,cy)]},generateBottomUV:function generateBottomUV(geometry,extrudedShape,extrudeOptions,indexA,indexB,indexC){return this.generateTopUV(geometry,extrudedShape,extrudeOptions,indexA,indexB,indexC)},generateSideWallUV:function generateSideWallUV(geometry,extrudedShape,wallContour,extrudeOptions,indexA,indexB,indexC,indexD){var ax=geometry.vertices[indexA].x,ay=geometry.vertices[indexA].y,az=geometry.vertices[indexA].z,bx=geometry.vertices[indexB].x,by=geometry.vertices[indexB].y,bz=geometry.vertices[indexB].z,cx=geometry.vertices[indexC].x,cy=geometry.vertices[indexC].y,cz=geometry.vertices[indexC].z,dx=geometry.vertices[indexD].x,dy=geometry.vertices[indexD].y,dz=geometry.vertices[indexD].z;return .01>Math.abs(ay-by)?[new THREE.Vector2(ax,1-az),new THREE.Vector2(bx,1-bz),new THREE.Vector2(cx,1-cz),new THREE.Vector2(dx,1-dz)]:[new THREE.Vector2(ay,1-az),new THREE.Vector2(by,1-bz),new THREE.Vector2(cy,1-cz),new THREE.Vector2(dy,1-dz)]}},THREE.ExtrudeGeometry.__v1=new THREE.Vector2,THREE.ExtrudeGeometry.__v2=new THREE.Vector2,THREE.ExtrudeGeometry.__v3=new THREE.Vector2,THREE.ExtrudeGeometry.__v4=new THREE.Vector2,THREE.ExtrudeGeometry.__v5=new THREE.Vector2,THREE.ExtrudeGeometry.__v6=new THREE.Vector2,THREE.ShapeGeometry=function(shapes,options){THREE.Geometry.call(this),!1==shapes instanceof Array&&(shapes=[shapes]),this.shapebb=shapes[shapes.length-1].getBoundingBox(),this.addShapeList(shapes,options),this.computeCentroids(),this.computeFaceNormals()},THREE.ShapeGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.ShapeGeometry.prototype.addShapeList=function(shapes,options){for(var i=0,l=shapes.length;i<l;i++)this.addShape(shapes[i],options);return this},THREE.ShapeGeometry.prototype.addShape=function(shape,options){options===void 0&&(options={});var curveSegments=options.curveSegments===void 0?12:options.curveSegments,material=options.material,uvgen=options.UVGenerator===void 0?THREE.ExtrudeGeometry.WorldUVGenerator:options.UVGenerator,shapebb=this.shapebb,shapesOffset=this.vertices.length,shapePoints=shape.extractPoints(curveSegments),vertices=shapePoints.shape,holes=shapePoints.holes,reverse=!THREE.Shape.Utils.isClockWise(vertices),i,l,hole;if(reverse){for(vertices=vertices.reverse(),i=0,l=holes.length;i<l;i++)hole=holes[i],THREE.Shape.Utils.isClockWise(hole)&&(holes[i]=hole.reverse());reverse=!1}var faces=THREE.Shape.Utils.triangulateShape(vertices,holes),contour=vertices;for(i=0,l=holes.length;i<l;i++)hole=holes[i],vertices=vertices.concat(hole);var vlen=vertices.length,flen=faces.length,clen=contour.length,vert,face;for(i=0;i<vlen;i++)vert=vertices[i],this.vertices.push(new THREE.Vector3(vert.x,vert.y,0));for(i=0;i<flen;i++){face=faces[i];var a=face[0]+shapesOffset,b=face[1]+shapesOffset,c=face[2]+shapesOffset;this.faces.push(new THREE.Face3(a,b,c,null,null,material)),this.faceVertexUvs[0].push(uvgen.generateBottomUV(this,shape,options,a,b,c))}},THREE.LatheGeometry=function(points,segments,phiStart,phiLength){THREE.Geometry.call(this),segments=segments||12,phiStart=phiStart||0,phiLength=phiLength||2*Math.PI;for(var inversePointLength=1/(points.length-1),inverseSegments=1/segments,i=0,il=segments;i<=il;i++)for(var phi=phiStart+i*inverseSegments*phiLength,c=Math.cos(phi),s=Math.sin(phi),j=0,jl=points.length;j<jl;j++){var pt=points[j],vertex=new THREE.Vector3;vertex.x=c*pt.x-s*pt.y,vertex.y=s*pt.x+c*pt.y,vertex.z=pt.z,this.vertices.push(vertex)}for(var np=points.length,i=0,il=segments;i<il;i++)for(var j=0,jl=points.length-1;j<jl;j++){var base=j+np*i,b=base+np,c=base+1+np,d=base+1,u0=i*inverseSegments,v0=j*inversePointLength,u1=u0+inverseSegments,v1=v0+inversePointLength;this.faces.push(new THREE.Face3(base,b,d)),this.faceVertexUvs[0].push([new THREE.Vector2(u0,v0),new THREE.Vector2(u1,v0),new THREE.Vector2(u0,v1)]),this.faces.push(new THREE.Face3(b,c,d)),this.faceVertexUvs[0].push([new THREE.Vector2(u1,v0),new THREE.Vector2(u1,v1),new THREE.Vector2(u0,v1)])}this.mergeVertices(),this.computeCentroids(),this.computeFaceNormals(),this.computeVertexNormals()},THREE.LatheGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.PlaneGeometry=function(width,height,widthSegments,heightSegments){THREE.Geometry.call(this),this.width=width,this.height=height,this.widthSegments=widthSegments||1,this.heightSegments=heightSegments||1;var gridX=this.widthSegments,gridZ=this.heightSegments,gridX1=gridX+1,segment_width=this.width/gridX,segment_height=this.height/gridZ,normal=new THREE.Vector3(0,0,1),ix,iz;for(iz=0;iz<gridZ+1;iz++)for(ix=0;ix<gridX1;ix++){var x=ix*segment_width-width/2,y=iz*segment_height-height/2;this.vertices.push(new THREE.Vector3(x,-y,0))}for(iz=0;iz<gridZ;iz++)for(ix=0;ix<gridX;ix++){var a=ix+gridX1*iz,b=ix+gridX1*(iz+1),c=ix+1+gridX1*(iz+1),d=ix+1+gridX1*iz,uva=new THREE.Vector2(ix/gridX,1-iz/gridZ),uvb=new THREE.Vector2(ix/gridX,1-(iz+1)/gridZ),uvc=new THREE.Vector2((ix+1)/gridX,1-(iz+1)/gridZ),uvd=new THREE.Vector2((ix+1)/gridX,1-iz/gridZ),face=new THREE.Face3(a,b,d);face.normal.copy(normal),face.vertexNormals.push(normal.clone(),normal.clone(),normal.clone()),this.faces.push(face),this.faceVertexUvs[0].push([uva,uvb,uvd]),face=new THREE.Face3(b,c,d),face.normal.copy(normal),face.vertexNormals.push(normal.clone(),normal.clone(),normal.clone()),this.faces.push(face),this.faceVertexUvs[0].push([uvb.clone(),uvc,uvd.clone()])}this.computeCentroids()},THREE.PlaneGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.RingGeometry=function(innerRadius,outerRadius,thetaSegments,phiSegments,thetaStart,thetaLength){var _Mathmax6=Math.max;THREE.Geometry.call(this),innerRadius=innerRadius||0,outerRadius=outerRadius||50,thetaStart=thetaStart===void 0?0:thetaStart,thetaLength=thetaLength===void 0?2*Math.PI:thetaLength,thetaSegments=thetaSegments===void 0?8:_Mathmax6(3,thetaSegments),phiSegments=phiSegments===void 0?8:_Mathmax6(3,phiSegments);var uvs=[],radius=innerRadius,radiusStep=(outerRadius-innerRadius)/phiSegments,i,o;for(i=0;i<=phiSegments;i++){for(o=0;o<=thetaSegments;o++){var vertex=new THREE.Vector3,segment=thetaStart+o/thetaSegments*thetaLength;vertex.x=radius*Math.cos(segment),vertex.y=radius*Math.sin(segment),this.vertices.push(vertex),uvs.push(new THREE.Vector2((vertex.x/radius+1)/2,-(vertex.y/radius+1)/2+1))}radius+=radiusStep}var n=new THREE.Vector3(0,0,1);for(i=0;i<phiSegments;i++){var thetaSegment=i*thetaSegments;for(o=0;o<=thetaSegments;o++){var segment=o+thetaSegment,v1=segment+i,v2=segment+thetaSegments+i,v3=segment+thetaSegments+1+i;this.faces.push(new THREE.Face3(v1,v2,v3,[n,n,n])),this.faceVertexUvs[0].push([uvs[v1],uvs[v2],uvs[v3]]),v1=segment+i,v2=segment+thetaSegments+1+i,v3=segment+1+i,this.faces.push(new THREE.Face3(v1,v2,v3,[n,n,n])),this.faceVertexUvs[0].push([uvs[v1],uvs[v2],uvs[v3]])}}this.computeCentroids(),this.computeFaceNormals(),this.boundingSphere=new THREE.Sphere(new THREE.Vector3(),radius)},THREE.RingGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.SphereGeometry=function(radius,widthSegments,heightSegments,phiStart,phiLength,thetaStart,thetaLength){var _MathPI3=Math.PI,_Mathabs8=Math.abs,_Mathsin6=Math.sin,_Mathcos4=Math.cos,_Mathfloor6=Math.floor,_Mathmax7=Math.max;THREE.Geometry.call(this),this.radius=radius=radius||50,this.widthSegments=widthSegments=_Mathmax7(3,_Mathfloor6(widthSegments)||8),this.heightSegments=heightSegments=_Mathmax7(2,_Mathfloor6(heightSegments)||6),this.phiStart=phiStart=phiStart===void 0?0:phiStart,this.phiLength=phiLength=phiLength===void 0?2*_MathPI3:phiLength,this.thetaStart=thetaStart=thetaStart===void 0?0:thetaStart,this.thetaLength=thetaLength=thetaLength===void 0?_MathPI3:thetaLength;var vertices=[],uvs=[],x,y;for(y=0;y<=heightSegments;y++){var verticesRow=[],uvsRow=[];for(x=0;x<=widthSegments;x++){var u=x/widthSegments,v=y/heightSegments,vertex=new THREE.Vector3;vertex.x=-radius*_Mathcos4(phiStart+u*phiLength)*_Mathsin6(thetaStart+v*thetaLength),vertex.y=radius*_Mathcos4(thetaStart+v*thetaLength),vertex.z=radius*_Mathsin6(phiStart+u*phiLength)*_Mathsin6(thetaStart+v*thetaLength),this.vertices.push(vertex),verticesRow.push(this.vertices.length-1),uvsRow.push(new THREE.Vector2(u,1-v))}vertices.push(verticesRow),uvs.push(uvsRow)}for(y=0;y<this.heightSegments;y++)for(x=0;x<this.widthSegments;x++){var v1=vertices[y][x+1],v2=vertices[y][x],v3=vertices[y+1][x],v4=vertices[y+1][x+1],n1=this.vertices[v1].clone().normalize(),n2=this.vertices[v2].clone().normalize(),n3=this.vertices[v3].clone().normalize(),n4=this.vertices[v4].clone().normalize(),uv1=uvs[y][x+1].clone(),uv2=uvs[y][x].clone(),uv3=uvs[y+1][x].clone(),uv4=uvs[y+1][x+1].clone();_Mathabs8(this.vertices[v1].y)===this.radius?(this.faces.push(new THREE.Face3(v1,v3,v4,[n1,n3,n4])),this.faceVertexUvs[0].push([uv1,uv3,uv4])):_Mathabs8(this.vertices[v3].y)===this.radius?(this.faces.push(new THREE.Face3(v1,v2,v3,[n1,n2,n3])),this.faceVertexUvs[0].push([uv1,uv2,uv3])):(this.faces.push(new THREE.Face3(v1,v2,v4,[n1,n2,n4])),this.faceVertexUvs[0].push([uv1,uv2,uv4]),this.faces.push(new THREE.Face3(v2,v3,v4,[n2,n3,n4])),this.faceVertexUvs[0].push([uv2.clone(),uv3,uv4.clone()]))}this.computeCentroids(),this.computeFaceNormals(),this.boundingSphere=new THREE.Sphere(new THREE.Vector3(),radius)},THREE.SphereGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.TextGeometry=function(text,parameters){parameters=parameters||{};var textShapes=THREE.FontUtils.generateShapes(text,parameters);parameters.amount=parameters.height===void 0?50:parameters.height,parameters.bevelThickness===void 0&&(parameters.bevelThickness=10),parameters.bevelSize===void 0&&(parameters.bevelSize=8),parameters.bevelEnabled===void 0&&(parameters.bevelEnabled=!1),THREE.ExtrudeGeometry.call(this,textShapes,parameters)},THREE.TextGeometry.prototype=Object.create(THREE.ExtrudeGeometry.prototype),THREE.TorusGeometry=function(radius,tube,radialSegments,tubularSegments,arc){var _MathPI4=Math.PI,_Mathsin7=Math.sin,_Mathcos5=Math.cos;THREE.Geometry.call(this);this;this.radius=radius||100,this.tube=tube||40,this.radialSegments=radialSegments||8,this.tubularSegments=tubularSegments||6,this.arc=arc||2*_MathPI4;for(var center=new THREE.Vector3,uvs=[],normals=[],j=0;j<=this.radialSegments;j++)for(var i=0;i<=this.tubularSegments;i++){var u=i/this.tubularSegments*this.arc,v=2*(j/this.radialSegments*_MathPI4);center.x=this.radius*_Mathcos5(u),center.y=this.radius*_Mathsin7(u);var vertex=new THREE.Vector3;vertex.x=(this.radius+this.tube*_Mathcos5(v))*_Mathcos5(u),vertex.y=(this.radius+this.tube*_Mathcos5(v))*_Mathsin7(u),vertex.z=this.tube*_Mathsin7(v),this.vertices.push(vertex),uvs.push(new THREE.Vector2(i/this.tubularSegments,j/this.radialSegments)),normals.push(vertex.clone().sub(center).normalize())}for(var j=1;j<=this.radialSegments;j++)for(var i=1;i<=this.tubularSegments;i++){var a=(this.tubularSegments+1)*j+i-1,b=(this.tubularSegments+1)*(j-1)+i-1,c=(this.tubularSegments+1)*(j-1)+i,d=(this.tubularSegments+1)*j+i,face=new THREE.Face3(a,b,d,[normals[a],normals[b],normals[d]]);face.normal.add(normals[a]),face.normal.add(normals[b]),face.normal.add(normals[d]),face.normal.normalize(),this.faces.push(face),this.faceVertexUvs[0].push([uvs[a].clone(),uvs[b].clone(),uvs[d].clone()]),face=new THREE.Face3(b,c,d,[normals[b],normals[c],normals[d]]),face.normal.add(normals[b]),face.normal.add(normals[c]),face.normal.add(normals[d]),face.normal.normalize(),this.faces.push(face),this.faceVertexUvs[0].push([uvs[b].clone(),uvs[c].clone(),uvs[d].clone()])}this.computeCentroids()},THREE.TorusGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.TorusKnotGeometry=function(radius,tube,radialSegments,tubularSegments,p,q,heightScale){function getPos(u,in_q,in_p,radius,heightScale){var cu=_Mathcos6(u),su=_Mathsin8(u),quOverP=in_q/in_p*u,cs=_Mathcos6(quOverP),tz=.5*(heightScale*radius*_Mathsin8(quOverP));return new THREE.Vector3(.5*(radius*(2+cs))*cu,.5*(radius*(2+cs)*su),tz)}var _MathPI5=Math.PI,_Mathsin8=Math.sin,_Mathcos6=Math.cos;THREE.Geometry.call(this);var scope=this;this.radius=radius||100,this.tube=tube||40,this.radialSegments=radialSegments||64,this.tubularSegments=tubularSegments||8,this.p=p||2,this.q=q||3,this.heightScale=heightScale||1,this.grid=Array(this.radialSegments);for(var tang=new THREE.Vector3,n=new THREE.Vector3,bitan=new THREE.Vector3,i=0;i<this.radialSegments;++i){this.grid[i]=Array(this.tubularSegments);var u=2*(i/this.radialSegments)*this.p*_MathPI5,p1=getPos(u,this.q,this.p,this.radius,this.heightScale),p2=getPos(u+.01,this.q,this.p,this.radius,this.heightScale);tang.subVectors(p2,p1),n.addVectors(p2,p1),bitan.crossVectors(tang,n),n.crossVectors(bitan,tang),bitan.normalize(),n.normalize();for(var j=0;j<this.tubularSegments;++j){var v=2*(j/this.tubularSegments)*_MathPI5,cx=-this.tube*_Mathcos6(v),cy=this.tube*_Mathsin8(v),pos=new THREE.Vector3;pos.x=p1.x+cx*n.x+cy*bitan.x,pos.y=p1.y+cx*n.y+cy*bitan.y,pos.z=p1.z+cx*n.z+cy*bitan.z,this.grid[i][j]=scope.vertices.push(pos)-1}}for(var i=0;i<this.radialSegments;++i)for(var j=0;j<this.tubularSegments;++j){var ip=(i+1)%this.radialSegments,jp=(j+1)%this.tubularSegments,a=this.grid[i][j],b=this.grid[ip][j],c=this.grid[ip][jp],d=this.grid[i][jp],uva=new THREE.Vector2(i/this.radialSegments,j/this.tubularSegments),uvb=new THREE.Vector2((i+1)/this.radialSegments,j/this.tubularSegments),uvc=new THREE.Vector2((i+1)/this.radialSegments,(j+1)/this.tubularSegments),uvd=new THREE.Vector2(i/this.radialSegments,(j+1)/this.tubularSegments);this.faces.push(new THREE.Face3(a,b,d)),this.faceVertexUvs[0].push([uva,uvb,uvd]),this.faces.push(new THREE.Face3(b,c,d)),this.faceVertexUvs[0].push([uvb.clone(),uvc,uvd.clone()])}this.computeCentroids(),this.computeFaceNormals(),this.computeVertexNormals()},THREE.TorusKnotGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.TubeGeometry=function(path,segments,radius,radialSegments,closed){function vert(x,y,z){return scope.vertices.push(new THREE.Vector3(x,y,z))-1}THREE.Geometry.call(this),this.path=path,this.segments=segments||64,this.radius=radius||1,this.radialSegments=radialSegments||8,this.closed=closed||!1,this.grid=[];var scope=this,numpoints=this.segments+1,pos2=new THREE.Vector3,frames=new THREE.TubeGeometry.FrenetFrames(this.path,this.segments,this.closed),tangents=frames.tangents,normals=frames.normals,binormals=frames.binormals,tangent,normal,binormal,u,v,cx,cy,pos,i,j,ip,jp,a,b,c,d,uva,uvb,uvc,uvd;for(this.tangents=tangents,this.normals=normals,this.binormals=binormals,i=0;i<numpoints;i++)for(this.grid[i]=[],u=i/(numpoints-1),pos=path.getPointAt(u),tangent=tangents[i],normal=normals[i],binormal=binormals[i],j=0;j<this.radialSegments;j++)v=2*(j/this.radialSegments)*Math.PI,cx=-this.radius*Math.cos(v),cy=this.radius*Math.sin(v),pos2.copy(pos),pos2.x+=cx*normal.x+cy*binormal.x,pos2.y+=cx*normal.y+cy*binormal.y,pos2.z+=cx*normal.z+cy*binormal.z,this.grid[i][j]=vert(pos2.x,pos2.y,pos2.z);for(i=0;i<this.segments;i++)for(j=0;j<this.radialSegments;j++)ip=this.closed?(i+1)%this.segments:i+1,jp=(j+1)%this.radialSegments,a=this.grid[i][j],b=this.grid[ip][j],c=this.grid[ip][jp],d=this.grid[i][jp],uva=new THREE.Vector2(i/this.segments,j/this.radialSegments),uvb=new THREE.Vector2((i+1)/this.segments,j/this.radialSegments),uvc=new THREE.Vector2((i+1)/this.segments,(j+1)/this.radialSegments),uvd=new THREE.Vector2(i/this.segments,(j+1)/this.radialSegments),this.faces.push(new THREE.Face3(a,b,d)),this.faceVertexUvs[0].push([uva,uvb,uvd]),this.faces.push(new THREE.Face3(b,c,d)),this.faceVertexUvs[0].push([uvb.clone(),uvc,uvd.clone()]);this.computeCentroids(),this.computeFaceNormals(),this.computeVertexNormals()},THREE.TubeGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.TubeGeometry.FrenetFrames=function(path,segments,closed){function initialNormal3(){normals[0]=new THREE.Vector3,binormals[0]=new THREE.Vector3,smallest=Number.MAX_VALUE,tx=_Mathabs9(tangents[0].x),ty=_Mathabs9(tangents[0].y),tz=_Mathabs9(tangents[0].z),tx<=smallest&&(smallest=tx,normal.set(1,0,0)),ty<=smallest&&(smallest=ty,normal.set(0,1,0)),tz<=smallest&&normal.set(0,0,1),vec.crossVectors(tangents[0],normal).normalize(),normals[0].crossVectors(tangents[0],vec),binormals[0].crossVectors(tangents[0],normals[0])}var _Mathabs9=Math.abs,_Mathacos=Math.acos,tangent=new THREE.Vector3,normal=new THREE.Vector3,binormal=new THREE.Vector3,tangents=[],normals=[],binormals=[],vec=new THREE.Vector3,mat=new THREE.Matrix4,numpoints=segments+1,epsilon=1e-4,theta,smallest,tx,ty,tz,i,u;for(this.tangents=tangents,this.normals=normals,this.binormals=binormals,i=0;i<numpoints;i++)u=i/(numpoints-1),tangents[i]=path.getTangentAt(u),tangents[i].normalize();for(initialNormal3(),i=1;i<numpoints;i++)normals[i]=normals[i-1].clone(),binormals[i]=binormals[i-1].clone(),vec.crossVectors(tangents[i-1],tangents[i]),vec.length()>epsilon&&(vec.normalize(),theta=_Mathacos(THREE.Math.clamp(tangents[i-1].dot(tangents[i]),-1,1)),normals[i].applyMatrix4(mat.makeRotationAxis(vec,theta))),binormals[i].crossVectors(tangents[i],normals[i]);if(closed)for(theta=_Mathacos(THREE.Math.clamp(normals[0].dot(normals[numpoints-1]),-1,1)),theta/=numpoints-1,0<tangents[0].dot(vec.crossVectors(normals[0],normals[numpoints-1]))&&(theta=-theta),i=1;i<numpoints;i++)normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i],theta*i)),binormals[i].crossVectors(tangents[i],normals[i])},THREE.PolyhedronGeometry=function(vertices,faces,radius,detail){function prepare(vector){var vertex=vector.normalize().clone();vertex.index=that.vertices.push(vertex)-1;var u=azimuth(vector)/2/_MathPI6+.5,v=inclination(vector)/_MathPI6+.5;return vertex.uv=new THREE.Vector2(u,1-v),vertex}function make(v1,v2,v3){var face=new THREE.Face3(v1.index,v2.index,v3.index,[v1.clone(),v2.clone(),v3.clone()]);face.centroid.add(v1).add(v2).add(v3).divideScalar(3),that.faces.push(face);var azi=azimuth(face.centroid);that.faceVertexUvs[0].push([correctUV(v1.uv,v1,azi),correctUV(v2.uv,v2,azi),correctUV(v3.uv,v3,azi)])}function subdivide(face,detail){for(var cols=_Mathpow(2,detail),cells=_Mathpow(4,detail),a=prepare(that.vertices[face.a]),b=prepare(that.vertices[face.b]),c=prepare(that.vertices[face.c]),v=[],i=0;i<=cols;i++){v[i]=[];for(var aj=prepare(a.clone().lerp(c,i/cols)),bj=prepare(b.clone().lerp(c,i/cols)),rows=cols-i,j=0;j<=rows;j++)v[i][j]=0==j&&i==cols?aj:prepare(aj.clone().lerp(bj,j/rows))}for(var i=0;i<cols;i++)for(var j=0,k;j<2*(cols-i)-1;j++)k=Math.floor(j/2),0==j%2?make(v[i][k+1],v[i+1][k],v[i][k]):make(v[i][k+1],v[i+1][k+1],v[i+1][k])}function azimuth(vector){return _Mathatan4(vector.z,-vector.x)}function inclination(vector){return _Mathatan4(-vector.y,Math.sqrt(vector.x*vector.x+vector.z*vector.z))}function correctUV(uv,vector,azimuth){return 0>azimuth&&1===uv.x&&(uv=new THREE.Vector2(uv.x-1,uv.y)),0===vector.x&&0===vector.z&&(uv=new THREE.Vector2(azimuth/2/_MathPI6+.5,uv.y)),uv.clone()}var _Mathpow=Math.pow,_Mathatan4=Math.atan2,_MathPI6=Math.PI,_Mathmin5=Math.min,_Mathmax8=Math.max;THREE.Geometry.call(this),radius=radius||1,detail=detail||0;for(var that=this,i=0,l=vertices.length;i<l;i++)prepare(new THREE.Vector3(vertices[i][0],vertices[i][1],vertices[i][2]));for(var p=this.vertices,f=[],i=0,l=faces.length;i<l;i++){var v1=p[faces[i][0]],v2=p[faces[i][1]],v3=p[faces[i][2]];f[i]=new THREE.Face3(v1.index,v2.index,v3.index,[v1.clone(),v2.clone(),v3.clone()])}for(var i=0,l=f.length;i<l;i++)subdivide(f[i],detail);for(var i=0,l=this.faceVertexUvs[0].length;i<l;i++){var uvs=this.faceVertexUvs[0][i],x0=uvs[0].x,x1=uvs[1].x,x2=uvs[2].x,max=_Mathmax8(x0,_Mathmax8(x1,x2)),min=_Mathmin5(x0,_Mathmin5(x1,x2));.9<max&&.1>min&&(.2>x0&&(uvs[0].x+=1),.2>x1&&(uvs[1].x+=1),.2>x2&&(uvs[2].x+=1))}for(var i=0,l=this.vertices.length;i<l;i++)this.vertices[i].multiplyScalar(radius);this.mergeVertices(),this.computeCentroids(),this.computeFaceNormals(),this.boundingSphere=new THREE.Sphere(new THREE.Vector3(),radius)},THREE.PolyhedronGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.IcosahedronGeometry=function(radius,detail){this.radius=radius,this.detail=detail;var t=(1+2.23606797749979)/2;THREE.PolyhedronGeometry.call(this,[[-1,t,0],[1,t,0],[-1,-t,0],[1,-t,0],[0,-1,t],[0,1,t],[0,-1,-t],[0,1,-t],[t,0,-1],[t,0,1],[-t,0,-1],[-t,0,1]],[[0,11,5],[0,5,1],[0,1,7],[0,7,10],[0,10,11],[1,5,9],[5,11,4],[11,10,2],[10,7,6],[7,1,8],[3,9,4],[3,4,2],[3,2,6],[3,6,8],[3,8,9],[4,9,5],[2,4,11],[6,2,10],[8,6,7],[9,8,1]],radius,detail)},THREE.IcosahedronGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.OctahedronGeometry=function(radius,detail){THREE.PolyhedronGeometry.call(this,[[1,0,0],[-1,0,0],[0,1,0],[0,-1,0],[0,0,1],[0,0,-1]],[[0,2,4],[0,4,3],[0,3,5],[0,5,2],[1,2,5],[1,5,3],[1,3,4],[1,4,2]],radius,detail)},THREE.OctahedronGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.TetrahedronGeometry=function(radius,detail){THREE.PolyhedronGeometry.call(this,[[1,1,1],[-1,-1,1],[-1,1,-1],[1,-1,-1]],[[2,1,0],[0,3,2],[1,3,0],[2,3,1]],radius,detail)},THREE.TetrahedronGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.ParametricGeometry=function(func,slices,stacks){THREE.Geometry.call(this);var verts=this.vertices,faces=this.faces,uvs=this.faceVertexUvs[0],sliceCount=slices+1,i,j,p,u,v;for(i=0;i<=stacks;i++)for(v=i/stacks,j=0;j<=slices;j++)u=j/slices,p=func(u,v),verts.push(p);var a,b,c,d,uva,uvb,uvc,uvd;for(i=0;i<stacks;i++)for(j=0;j<slices;j++)a=i*sliceCount+j,b=i*sliceCount+j+1,c=(i+1)*sliceCount+j+1,d=(i+1)*sliceCount+j,uva=new THREE.Vector2(j/slices,i/stacks),uvb=new THREE.Vector2((j+1)/slices,i/stacks),uvc=new THREE.Vector2((j+1)/slices,(i+1)/stacks),uvd=new THREE.Vector2(j/slices,(i+1)/stacks),faces.push(new THREE.Face3(a,b,d)),uvs.push([uva,uvb,uvd]),faces.push(new THREE.Face3(b,c,d)),uvs.push([uvb.clone(),uvc,uvd.clone()]);this.computeCentroids(),this.computeFaceNormals(),this.computeVertexNormals()},THREE.ParametricGeometry.prototype=Object.create(THREE.Geometry.prototype),THREE.AxisHelper=function(size){size=size||1;var geometry=new THREE.Geometry;geometry.vertices.push(new THREE.Vector3,new THREE.Vector3(size,0,0),new THREE.Vector3,new THREE.Vector3(0,size,0),new THREE.Vector3,new THREE.Vector3(0,0,size)),geometry.colors.push(new THREE.Color(16711680),new THREE.Color(16755200),new THREE.Color(65280),new THREE.Color(11206400),new THREE.Color(255),new THREE.Color(43775));var material=new THREE.LineBasicMaterial({vertexColors:THREE.VertexColors});THREE.Line.call(this,geometry,material,THREE.LinePieces)},THREE.AxisHelper.prototype=Object.create(THREE.Line.prototype),THREE.ArrowHelper=function(dir,origin,length,hex){THREE.Object3D.call(this),hex===void 0&&(hex=16776960),length===void 0&&(length=1),this.position=origin;var lineGeometry=new THREE.Geometry;lineGeometry.vertices.push(new THREE.Vector3(0,0,0)),lineGeometry.vertices.push(new THREE.Vector3(0,1,0)),this.line=new THREE.Line(lineGeometry,new THREE.LineBasicMaterial({color:hex})),this.line.matrixAutoUpdate=!1,this.add(this.line);var coneGeometry=new THREE.CylinderGeometry(0,.05,.25,5,1);coneGeometry.applyMatrix(new THREE.Matrix4().makeTranslation(0,.875,0)),this.cone=new THREE.Mesh(coneGeometry,new THREE.MeshBasicMaterial({color:hex})),this.cone.matrixAutoUpdate=!1,this.add(this.cone),this.setDirection(dir),this.setLength(length)},THREE.ArrowHelper.prototype=Object.create(THREE.Object3D.prototype),THREE.ArrowHelper.prototype.setDirection=function(){var axis=new THREE.Vector3,radians;return function(dir){.99999<dir.y?this.quaternion.set(0,0,0,1):-.99999>dir.y?this.quaternion.set(1,0,0,0):(axis.set(dir.z,0,-dir.x).normalize(),radians=Math.acos(dir.y),this.quaternion.setFromAxisAngle(axis,radians))}}(),THREE.ArrowHelper.prototype.setLength=function(length){this.scale.set(length,length,length)},THREE.ArrowHelper.prototype.setColor=function(hex){this.line.material.color.setHex(hex),this.cone.material.color.setHex(hex)},THREE.BoxHelper=function(object){var vertices=[new THREE.Vector3(1,1,1),new THREE.Vector3(-1,1,1),new THREE.Vector3(-1,-1,1),new THREE.Vector3(1,-1,1),new THREE.Vector3(1,1,-1),new THREE.Vector3(-1,1,-1),new THREE.Vector3(-1,-1,-1),new THREE.Vector3(1,-1,-1)];this.vertices=vertices;var geometry=new THREE.Geometry;geometry.vertices.push(vertices[0],vertices[1],vertices[1],vertices[2],vertices[2],vertices[3],vertices[3],vertices[0],vertices[4],vertices[5],vertices[5],vertices[6],vertices[6],vertices[7],vertices[7],vertices[4],vertices[0],vertices[4],vertices[1],vertices[5],vertices[2],vertices[6],vertices[3],vertices[7]),THREE.Line.call(this,geometry,new THREE.LineBasicMaterial({color:16776960}),THREE.LinePieces),object!==void 0&&this.update(object)},THREE.BoxHelper.prototype=Object.create(THREE.Line.prototype),THREE.BoxHelper.prototype.update=function(object){var geometry=object.geometry;null===geometry.boundingBox&&geometry.computeBoundingBox();var min=geometry.boundingBox.min,max=geometry.boundingBox.max,vertices=this.vertices;vertices[0].set(max.x,max.y,max.z),vertices[1].set(min.x,max.y,max.z),vertices[2].set(min.x,min.y,max.z),vertices[3].set(max.x,min.y,max.z),vertices[4].set(max.x,max.y,min.z),vertices[5].set(min.x,max.y,min.z),vertices[6].set(min.x,min.y,min.z),vertices[7].set(max.x,min.y,min.z),this.geometry.computeBoundingSphere(),this.geometry.verticesNeedUpdate=!0,this.matrixAutoUpdate=!1,this.matrixWorld=object.matrixWorld},THREE.BoundingBoxHelper=function(object,hex){this.object=object,this.box=new THREE.Box3,THREE.Mesh.call(this,new THREE.CubeGeometry(1,1,1),new THREE.MeshBasicMaterial({color:hex||8947848,wireframe:!0}))},THREE.BoundingBoxHelper.prototype=Object.create(THREE.Mesh.prototype),THREE.BoundingBoxHelper.prototype.update=function(){this.box.setFromObject(this.object),this.box.size(this.scale),this.box.center(this.position)},THREE.CameraHelper=function(camera){function addLine(a,b,hex){addPoint(a,hex),addPoint(b,hex)}function addPoint(id,hex){geometry.vertices.push(new THREE.Vector3),geometry.colors.push(new THREE.Color(hex)),pointMap[id]===void 0&&(pointMap[id]=[]),pointMap[id].push(geometry.vertices.length-1)}var geometry=new THREE.Geometry,material=new THREE.LineBasicMaterial({color:16777215,vertexColors:THREE.FaceColors}),pointMap={},hexFrustum=16755200,hexCone=16711680,hexUp=43775,hexCross=3355443;addLine('n1','n2',hexFrustum),addLine('n2','n4',hexFrustum),addLine('n4','n3',hexFrustum),addLine('n3','n1',hexFrustum),addLine('f1','f2',hexFrustum),addLine('f2','f4',hexFrustum),addLine('f4','f3',hexFrustum),addLine('f3','f1',hexFrustum),addLine('n1','f1',hexFrustum),addLine('n2','f2',hexFrustum),addLine('n3','f3',hexFrustum),addLine('n4','f4',hexFrustum),addLine('p','n1',hexCone),addLine('p','n2',hexCone),addLine('p','n3',hexCone),addLine('p','n4',hexCone),addLine('u1','u2',hexUp),addLine('u2','u3',hexUp),addLine('u3','u1',hexUp),addLine('c','t',16777215),addLine('p','c',hexCross),addLine('cn1','cn2',hexCross),addLine('cn3','cn4',hexCross),addLine('cf1','cf2',hexCross),addLine('cf3','cf4',hexCross),THREE.Line.call(this,geometry,material,THREE.LinePieces),this.camera=camera,this.matrixWorld=camera.matrixWorld,this.matrixAutoUpdate=!1,this.pointMap=pointMap,this.update()},THREE.CameraHelper.prototype=Object.create(THREE.Line.prototype),THREE.CameraHelper.prototype.update=function(){var vector=new THREE.Vector3,camera=new THREE.Camera,projector=new THREE.Projector;return function(){function setPoint(point,x,y,z){vector.set(x,y,z),projector.unprojectVector(vector,camera);var points=scope.pointMap[point];if(points!==void 0)for(var i=0,il=points.length;i<il;i++)scope.geometry.vertices[points[i]].copy(vector)}var scope=this,w=1,h=1;camera.projectionMatrix.copy(this.camera.projectionMatrix),setPoint('c',0,0,-1),setPoint('t',0,0,1),setPoint('n1',-w,-h,-1),setPoint('n2',w,-h,-1),setPoint('n3',-w,h,-1),setPoint('n4',w,h,-1),setPoint('f1',-w,-h,1),setPoint('f2',w,-h,1),setPoint('f3',-w,h,1),setPoint('f4',w,h,1),setPoint('u1',.7*w,1.1*h,-1),setPoint('u2',.7*-w,1.1*h,-1),setPoint('u3',0,2*h,-1),setPoint('cf1',-w,0,1),setPoint('cf2',w,0,1),setPoint('cf3',0,-h,1),setPoint('cf4',0,h,1),setPoint('cn1',-w,0,-1),setPoint('cn2',w,0,-1),setPoint('cn3',0,-h,-1),setPoint('cn4',0,h,-1),this.geometry.verticesNeedUpdate=!0}}(),THREE.DirectionalLightHelper=function(light,size){THREE.Object3D.call(this),this.light=light,this.light.updateMatrixWorld(),this.matrixWorld=light.matrixWorld,this.matrixAutoUpdate=!1;var geometry=new THREE.PlaneGeometry(size,size),material=new THREE.MeshBasicMaterial({wireframe:!0,fog:!1});material.color.copy(this.light.color).multiplyScalar(this.light.intensity),this.lightPlane=new THREE.Mesh(geometry,material),this.add(this.lightPlane),geometry=new THREE.Geometry,geometry.vertices.push(new THREE.Vector3),geometry.vertices.push(new THREE.Vector3),geometry.computeLineDistances(),material=new THREE.LineBasicMaterial({fog:!1}),material.color.copy(this.light.color).multiplyScalar(this.light.intensity),this.targetLine=new THREE.Line(geometry,material),this.add(this.targetLine),this.update()},THREE.DirectionalLightHelper.prototype=Object.create(THREE.Object3D.prototype),THREE.DirectionalLightHelper.prototype.update=function(){var vector=new THREE.Vector3;return function(){vector.getPositionFromMatrix(this.light.matrixWorld).negate(),this.lightPlane.lookAt(vector),this.lightPlane.material.color.copy(this.light.color).multiplyScalar(this.light.intensity),this.targetLine.geometry.vertices[1].copy(vector),this.targetLine.geometry.verticesNeedUpdate=!0,this.targetLine.material.color.copy(this.lightPlane.material.color)}}(),THREE.FaceNormalsHelper=function(object,size,hex,linewidth){this.object=object,this.size=size||1;for(var color=hex||16776960,width=linewidth||1,geometry=new THREE.Geometry,faces=this.object.geometry.faces,i=0,l=faces.length;i<l;i++)geometry.vertices.push(new THREE.Vector3),geometry.vertices.push(new THREE.Vector3);THREE.Line.call(this,geometry,new THREE.LineBasicMaterial({color:color,linewidth:width}),THREE.LinePieces),this.matrixAutoUpdate=!1,this.normalMatrix=new THREE.Matrix3,this.update()},THREE.FaceNormalsHelper.prototype=Object.create(THREE.Line.prototype),THREE.FaceNormalsHelper.prototype.update=function(){var v1=new THREE.Vector3;return function(){this.object.updateMatrixWorld(!0),this.normalMatrix.getNormalMatrix(this.object.matrixWorld);for(var vertices=this.geometry.vertices,faces=this.object.geometry.faces,worldMatrix=this.object.matrixWorld,i=0,l=faces.length,face;i<l;i++){face=faces[i],v1.copy(face.normal).applyMatrix3(this.normalMatrix).normalize().multiplyScalar(this.size);var idx=2*i;vertices[idx].copy(face.centroid).applyMatrix4(worldMatrix),vertices[idx+1].addVectors(vertices[idx],v1)}return this.geometry.verticesNeedUpdate=!0,this}}(),THREE.GridHelper=function(size,step){var geometry=new THREE.Geometry,material=new THREE.LineBasicMaterial({vertexColors:THREE.VertexColors});this.color1=new THREE.Color(4473924),this.color2=new THREE.Color(8947848);for(var i=-size;i<=size;i+=step){geometry.vertices.push(new THREE.Vector3(-size,0,i),new THREE.Vector3(size,0,i),new THREE.Vector3(i,0,-size),new THREE.Vector3(i,0,size));var color=0===i?this.color1:this.color2;geometry.colors.push(color,color,color,color)}THREE.Line.call(this,geometry,material,THREE.LinePieces)},THREE.GridHelper.prototype=Object.create(THREE.Line.prototype),THREE.GridHelper.prototype.setColors=function(colorCenterLine,colorGrid){this.color1.set(colorCenterLine),this.color2.set(colorGrid),this.geometry.colorsNeedUpdate=!0},THREE.HemisphereLightHelper=function(light,sphereSize){THREE.Object3D.call(this),this.light=light,this.light.updateMatrixWorld(),this.matrixWorld=light.matrixWorld,this.matrixAutoUpdate=!1,this.colors=[new THREE.Color,new THREE.Color];var geometry=new THREE.SphereGeometry(sphereSize,4,2);geometry.applyMatrix(new THREE.Matrix4().makeRotationX(-Math.PI/2));for(var i=0;i<8;i++)geometry.faces[i].color=this.colors[4>i?0:1];var material=new THREE.MeshBasicMaterial({vertexColors:THREE.FaceColors,wireframe:!0});this.lightSphere=new THREE.Mesh(geometry,material),this.add(this.lightSphere),this.update()},THREE.HemisphereLightHelper.prototype=Object.create(THREE.Object3D.prototype),THREE.HemisphereLightHelper.prototype.update=function(){var vector=new THREE.Vector3;return function(){this.colors[0].copy(this.light.color).multiplyScalar(this.light.intensity),this.colors[1].copy(this.light.groundColor).multiplyScalar(this.light.intensity),this.lightSphere.lookAt(vector.getPositionFromMatrix(this.light.matrixWorld).negate()),this.lightSphere.geometry.colorsNeedUpdate=!0}}(),THREE.PointLightHelper=function(light,sphereSize){this.light=light,this.light.updateMatrixWorld();var geometry=new THREE.SphereGeometry(sphereSize,4,2),material=new THREE.MeshBasicMaterial({wireframe:!0,fog:!1});material.color.copy(this.light.color).multiplyScalar(this.light.intensity),THREE.Mesh.call(this,geometry,material),this.matrixWorld=this.light.matrixWorld,this.matrixAutoUpdate=!1},THREE.PointLightHelper.prototype=Object.create(THREE.Mesh.prototype),THREE.PointLightHelper.prototype.update=function(){this.material.color.copy(this.light.color).multiplyScalar(this.light.intensity)},THREE.SpotLightHelper=function(light){THREE.Object3D.call(this),this.light=light,this.light.updateMatrixWorld(),this.matrixWorld=light.matrixWorld,this.matrixAutoUpdate=!1;var geometry=new THREE.CylinderGeometry(0,1,1,8,1,!0);geometry.applyMatrix(new THREE.Matrix4().makeTranslation(0,-.5,0)),geometry.applyMatrix(new THREE.Matrix4().makeRotationX(-Math.PI/2));var material=new THREE.MeshBasicMaterial({wireframe:!0,fog:!1});this.cone=new THREE.Mesh(geometry,material),this.add(this.cone),this.update()},THREE.SpotLightHelper.prototype=Object.create(THREE.Object3D.prototype),THREE.SpotLightHelper.prototype.update=function(){var vector=new THREE.Vector3,vector2=new THREE.Vector3;return function(){var coneLength=this.light.distance?this.light.distance:1e4,coneWidth=coneLength*Math.tan(this.light.angle);this.cone.scale.set(coneWidth,coneWidth,coneLength),vector.getPositionFromMatrix(this.light.matrixWorld),vector2.getPositionFromMatrix(this.light.target.matrixWorld),this.cone.lookAt(vector2.sub(vector)),this.cone.material.color.copy(this.light.color).multiplyScalar(this.light.intensity)}}(),THREE.VertexNormalsHelper=function(object,size,hex,linewidth){this.object=object,this.size=size||1;for(var color=hex||16711680,width=linewidth||1,geometry=new THREE.Geometry,vertices=object.geometry.vertices,faces=object.geometry.faces,i=0,l=faces.length,face;i<l;i++){face=faces[i];for(var j=0,jl=face.vertexNormals.length;j<jl;j++)geometry.vertices.push(new THREE.Vector3),geometry.vertices.push(new THREE.Vector3)}THREE.Line.call(this,geometry,new THREE.LineBasicMaterial({color:color,linewidth:width}),THREE.LinePieces),this.matrixAutoUpdate=!1,this.normalMatrix=new THREE.Matrix3,this.update()},THREE.VertexNormalsHelper.prototype=Object.create(THREE.Line.prototype),THREE.VertexNormalsHelper.prototype.update=function(){var v1=new THREE.Vector3;return function(){var keys=['a','b','c','d'];this.object.updateMatrixWorld(!0),this.normalMatrix.getNormalMatrix(this.object.matrixWorld);for(var vertices=this.geometry.vertices,verts=this.object.geometry.vertices,faces=this.object.geometry.faces,worldMatrix=this.object.matrixWorld,idx=0,i=0,l=faces.length,face;i<l;i++){face=faces[i];for(var j=0,jl=face.vertexNormals.length;j<jl;j++){var vertexId=face[keys[j]],vertex=verts[vertexId],normal=face.vertexNormals[j];vertices[idx].copy(vertex).applyMatrix4(worldMatrix),v1.copy(normal).applyMatrix3(this.normalMatrix).normalize().multiplyScalar(this.size),v1.add(vertices[idx]),++idx,vertices[idx].copy(v1),++idx}}return this.geometry.verticesNeedUpdate=!0,this}}(),THREE.VertexTangentsHelper=function(object,size,hex,linewidth){this.object=object,this.size=size||1;for(var color=hex||255,width=linewidth||1,geometry=new THREE.Geometry,vertices=object.geometry.vertices,faces=object.geometry.faces,i=0,l=faces.length,face;i<l;i++){face=faces[i];for(var j=0,jl=face.vertexTangents.length;j<jl;j++)geometry.vertices.push(new THREE.Vector3),geometry.vertices.push(new THREE.Vector3)}THREE.Line.call(this,geometry,new THREE.LineBasicMaterial({color:color,linewidth:width}),THREE.LinePieces),this.matrixAutoUpdate=!1,this.update()},THREE.VertexTangentsHelper.prototype=Object.create(THREE.Line.prototype),THREE.VertexTangentsHelper.prototype.update=function(){var v1=new THREE.Vector3;return function(){var keys=['a','b','c','d'];this.object.updateMatrixWorld(!0);for(var vertices=this.geometry.vertices,verts=this.object.geometry.vertices,faces=this.object.geometry.faces,worldMatrix=this.object.matrixWorld,idx=0,i=0,l=faces.length,face;i<l;i++){face=faces[i];for(var j=0,jl=face.vertexTangents.length;j<jl;j++){var vertexId=face[keys[j]],vertex=verts[vertexId],tangent=face.vertexTangents[j];vertices[idx].copy(vertex).applyMatrix4(worldMatrix),v1.copy(tangent).transformDirection(worldMatrix).multiplyScalar(this.size),v1.add(vertices[idx]),++idx,vertices[idx].copy(v1),++idx}}return this.geometry.verticesNeedUpdate=!0,this}}(),THREE.WireframeHelper=function(object){for(var edge=[0,0],hash={},sortFunction=function(a,b){return a-b},keys=['a','b','c','d'],geometry=new THREE.Geometry,vertices=object.geometry.vertices,faces=object.geometry.faces,i=0,l=faces.length,face;i<l;i++){face=faces[i];for(var j=0;3>j;j++){edge[0]=face[keys[j]],edge[1]=face[keys[(j+1)%3]],edge.sort(sortFunction);var key=edge.toString();hash[key]===void 0&&(geometry.vertices.push(vertices[edge[0]]),geometry.vertices.push(vertices[edge[1]]),hash[key]=!0)}}THREE.Line.call(this,geometry,new THREE.LineBasicMaterial({color:16777215}),THREE.LinePieces),this.matrixAutoUpdate=!1,this.matrixWorld=object.matrixWorld},THREE.WireframeHelper.prototype=Object.create(THREE.Line.prototype),THREE.ImmediateRenderObject=function(){THREE.Object3D.call(this),this.render=function(){}},THREE.ImmediateRenderObject.prototype=Object.create(THREE.Object3D.prototype),THREE.LensFlare=function(texture,size,distance,blending,color){THREE.Object3D.call(this),this.lensFlares=[],this.positionScreen=new THREE.Vector3,this.customUpdateCallback=void 0,texture!==void 0&&this.add(texture,size,distance,blending,color)},THREE.LensFlare.prototype=Object.create(THREE.Object3D.prototype),THREE.LensFlare.prototype.add=function(texture,size,distance,blending,color,opacity){size===void 0&&(size=-1),distance===void 0&&(distance=0),opacity===void 0&&(opacity=1),color===void 0&&(color=new THREE.Color(16777215)),blending===void 0&&(blending=THREE.NormalBlending),distance=Math.min(distance,Math.max(0,distance)),this.lensFlares.push({texture:texture,size:size,distance:distance,x:0,y:0,z:0,scale:1,rotation:1,opacity:opacity,color:color,blending:blending})},THREE.LensFlare.prototype.updateLensFlares=function(){var fl=this.lensFlares.length,vecX=2*-this.positionScreen.x,vecY=2*-this.positionScreen.y,f,flare;for(f=0;f<fl;f++)flare=this.lensFlares[f],flare.x=this.positionScreen.x+vecX*flare.distance,flare.y=this.positionScreen.y+vecY*flare.distance,flare.wantedRotation=.25*(flare.x*Math.PI),flare.rotation+=.25*(flare.wantedRotation-flare.rotation)},THREE.MorphBlendMesh=function(geometry,material){THREE.Mesh.call(this,geometry,material),this.animationsMap={},this.animationsList=[];var numFrames=this.geometry.morphTargets.length,name='__default';this.createAnimation(name,0,numFrames-1,numFrames/1),this.setAnimationWeight(name,1)},THREE.MorphBlendMesh.prototype=Object.create(THREE.Mesh.prototype),THREE.MorphBlendMesh.prototype.createAnimation=function(name,start,end,fps){var animation={startFrame:start,endFrame:end,length:end-start+1,fps:fps,duration:(end-start)/fps,lastFrame:0,currentFrame:0,active:!1,time:0,direction:1,weight:1,directionBackwards:!1,mirroredLoop:!1};this.animationsMap[name]=animation,this.animationsList.push(animation)},THREE.MorphBlendMesh.prototype.autoCreateAnimations=function(fps){for(var pattern=/([a-z]+)(\d+)/,frameRanges={},geometry=this.geometry,i=0,il=geometry.morphTargets.length,firstAnimation;i<il;i++){var morph=geometry.morphTargets[i],chunks=morph.name.match(pattern);if(chunks&&1<chunks.length){var name=chunks[1],num=chunks[2];frameRanges[name]||(frameRanges[name]={start:Infinity,end:-Infinity});var range=frameRanges[name];i<range.start&&(range.start=i),i>range.end&&(range.end=i),firstAnimation||(firstAnimation=name)}}for(var name in frameRanges){var range=frameRanges[name];this.createAnimation(name,range.start,range.end,fps)}this.firstAnimation=firstAnimation},THREE.MorphBlendMesh.prototype.setAnimationDirectionForward=function(name){var animation=this.animationsMap[name];animation&&(animation.direction=1,animation.directionBackwards=!1)},THREE.MorphBlendMesh.prototype.setAnimationDirectionBackward=function(name){var animation=this.animationsMap[name];animation&&(animation.direction=-1,animation.directionBackwards=!0)},THREE.MorphBlendMesh.prototype.setAnimationFPS=function(name,fps){var animation=this.animationsMap[name];animation&&(animation.fps=fps,animation.duration=(animation.end-animation.start)/animation.fps)},THREE.MorphBlendMesh.prototype.setAnimationDuration=function(name,duration){var animation=this.animationsMap[name];animation&&(animation.duration=duration,animation.fps=(animation.end-animation.start)/animation.duration)},THREE.MorphBlendMesh.prototype.setAnimationWeight=function(name,weight){var animation=this.animationsMap[name];animation&&(animation.weight=weight)},THREE.MorphBlendMesh.prototype.setAnimationTime=function(name,time){var animation=this.animationsMap[name];animation&&(animation.time=time)},THREE.MorphBlendMesh.prototype.getAnimationTime=function(name){var time=0,animation=this.animationsMap[name];return animation&&(time=animation.time),time},THREE.MorphBlendMesh.prototype.getAnimationDuration=function(name){var duration=-1,animation=this.animationsMap[name];return animation&&(duration=animation.duration),duration},THREE.MorphBlendMesh.prototype.playAnimation=function(name){var animation=this.animationsMap[name];animation?(animation.time=0,animation.active=!0):console.warn('animation['+name+'] undefined')},THREE.MorphBlendMesh.prototype.stopAnimation=function(name){var animation=this.animationsMap[name];animation&&(animation.active=!1)},THREE.MorphBlendMesh.prototype.update=function(delta){for(var i=0,il=this.animationsList.length,animation;i<il;i++)if(animation=this.animationsList[i],animation.active){var frameTime=animation.duration/animation.length;animation.time+=animation.direction*delta,animation.mirroredLoop?(animation.time>animation.duration||0>animation.time)&&(animation.direction*=-1,animation.time>animation.duration&&(animation.time=animation.duration,animation.directionBackwards=!0),0>animation.time&&(animation.time=0,animation.directionBackwards=!1)):(animation.time%=animation.duration,0>animation.time&&(animation.time+=animation.duration));var keyframe=animation.startFrame+THREE.Math.clamp(Math.floor(animation.time/frameTime),0,animation.length-1),weight=animation.weight;keyframe!==animation.currentFrame&&(this.morphTargetInfluences[animation.lastFrame]=0,this.morphTargetInfluences[animation.currentFrame]=1*weight,this.morphTargetInfluences[keyframe]=0,animation.lastFrame=animation.currentFrame,animation.currentFrame=keyframe);var mix=animation.time%frameTime/frameTime;animation.directionBackwards&&(mix=1-mix),this.morphTargetInfluences[animation.currentFrame]=mix*weight,this.morphTargetInfluences[animation.lastFrame]=(1-mix)*weight}},THREE.LensFlarePlugin=function(){function createProgram(shader,precision){var program=_gl.createProgram(),fragmentShader=_gl.createShader(_gl.FRAGMENT_SHADER),vertexShader=_gl.createShader(_gl.VERTEX_SHADER),prefix='precision '+precision+' float;\n';return _gl.shaderSource(fragmentShader,prefix+shader.fragmentShader),_gl.shaderSource(vertexShader,prefix+shader.vertexShader),_gl.compileShader(fragmentShader),_gl.compileShader(vertexShader),_gl.attachShader(program,fragmentShader),_gl.attachShader(program,vertexShader),_gl.linkProgram(program),program}var _lensFlare={},_gl,_renderer,_precision;this.init=function(renderer){_gl=renderer.context,_renderer=renderer,_precision=renderer.getPrecision(),_lensFlare.vertices=new Float32Array(16),_lensFlare.faces=new Uint16Array(6);var i=0;_lensFlare.vertices[i++]=-1,_lensFlare.vertices[i++]=-1,_lensFlare.vertices[i++]=0,_lensFlare.vertices[i++]=0,_lensFlare.vertices[i++]=1,_lensFlare.vertices[i++]=-1,_lensFlare.vertices[i++]=1,_lensFlare.vertices[i++]=0,_lensFlare.vertices[i++]=1,_lensFlare.vertices[i++]=1,_lensFlare.vertices[i++]=1,_lensFlare.vertices[i++]=1,_lensFlare.vertices[i++]=-1,_lensFlare.vertices[i++]=1,_lensFlare.vertices[i++]=0,_lensFlare.vertices[i++]=1,i=0,_lensFlare.faces[i++]=0,_lensFlare.faces[i++]=1,_lensFlare.faces[i++]=2,_lensFlare.faces[i++]=0,_lensFlare.faces[i++]=2,_lensFlare.faces[i++]=3,_lensFlare.vertexBuffer=_gl.createBuffer(),_lensFlare.elementBuffer=_gl.createBuffer(),_gl.bindBuffer(_gl.ARRAY_BUFFER,_lensFlare.vertexBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,_lensFlare.vertices,_gl.STATIC_DRAW),_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,_lensFlare.elementBuffer),_gl.bufferData(_gl.ELEMENT_ARRAY_BUFFER,_lensFlare.faces,_gl.STATIC_DRAW),_lensFlare.tempTexture=_gl.createTexture(),_lensFlare.occlusionTexture=_gl.createTexture(),_gl.bindTexture(_gl.TEXTURE_2D,_lensFlare.tempTexture),_gl.texImage2D(_gl.TEXTURE_2D,0,_gl.RGB,16,16,0,_gl.RGB,_gl.UNSIGNED_BYTE,null),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_WRAP_S,_gl.CLAMP_TO_EDGE),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_WRAP_T,_gl.CLAMP_TO_EDGE),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_MAG_FILTER,_gl.NEAREST),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_MIN_FILTER,_gl.NEAREST),_gl.bindTexture(_gl.TEXTURE_2D,_lensFlare.occlusionTexture),_gl.texImage2D(_gl.TEXTURE_2D,0,_gl.RGBA,16,16,0,_gl.RGBA,_gl.UNSIGNED_BYTE,null),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_WRAP_S,_gl.CLAMP_TO_EDGE),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_WRAP_T,_gl.CLAMP_TO_EDGE),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_MAG_FILTER,_gl.NEAREST),_gl.texParameteri(_gl.TEXTURE_2D,_gl.TEXTURE_MIN_FILTER,_gl.NEAREST),0>=_gl.getParameter(_gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS)?(_lensFlare.hasVertexTexture=!1,_lensFlare.program=createProgram(THREE.ShaderFlares.lensFlare,_precision)):(_lensFlare.hasVertexTexture=!0,_lensFlare.program=createProgram(THREE.ShaderFlares.lensFlareVertexTexture,_precision)),_lensFlare.attributes={},_lensFlare.uniforms={},_lensFlare.attributes.vertex=_gl.getAttribLocation(_lensFlare.program,'position'),_lensFlare.attributes.uv=_gl.getAttribLocation(_lensFlare.program,'uv'),_lensFlare.uniforms.renderType=_gl.getUniformLocation(_lensFlare.program,'renderType'),_lensFlare.uniforms.map=_gl.getUniformLocation(_lensFlare.program,'map'),_lensFlare.uniforms.occlusionMap=_gl.getUniformLocation(_lensFlare.program,'occlusionMap'),_lensFlare.uniforms.opacity=_gl.getUniformLocation(_lensFlare.program,'opacity'),_lensFlare.uniforms.color=_gl.getUniformLocation(_lensFlare.program,'color'),_lensFlare.uniforms.scale=_gl.getUniformLocation(_lensFlare.program,'scale'),_lensFlare.uniforms.rotation=_gl.getUniformLocation(_lensFlare.program,'rotation'),_lensFlare.uniforms.screenPosition=_gl.getUniformLocation(_lensFlare.program,'screenPosition')},this.render=function(scene,camera,viewportWidth,viewportHeight){var flares=scene.__webglFlares,nFlares=flares.length;if(nFlares){var tempPosition=new THREE.Vector3,invAspect=viewportHeight/viewportWidth,halfViewportWidth=.5*viewportWidth,halfViewportHeight=.5*viewportHeight,size=16/viewportHeight,scale=new THREE.Vector2(size*invAspect,size),screenPosition=new THREE.Vector3(1,1,0),screenPositionPixels=new THREE.Vector2(1,1),uniforms=_lensFlare.uniforms,attributes=_lensFlare.attributes;_gl.useProgram(_lensFlare.program),_gl.enableVertexAttribArray(_lensFlare.attributes.vertex),_gl.enableVertexAttribArray(_lensFlare.attributes.uv),_gl.uniform1i(uniforms.occlusionMap,0),_gl.uniform1i(uniforms.map,1),_gl.bindBuffer(_gl.ARRAY_BUFFER,_lensFlare.vertexBuffer),_gl.vertexAttribPointer(attributes.vertex,2,_gl.FLOAT,!1,16,0),_gl.vertexAttribPointer(attributes.uv,2,_gl.FLOAT,!1,16,8),_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,_lensFlare.elementBuffer),_gl.disable(_gl.CULL_FACE),_gl.depthMask(!1);var i,j,jl,flare,sprite;for(i=0;i<nFlares;i++)if(size=16/viewportHeight,scale.set(size*invAspect,size),flare=flares[i],tempPosition.set(flare.matrixWorld.elements[12],flare.matrixWorld.elements[13],flare.matrixWorld.elements[14]),tempPosition.applyMatrix4(camera.matrixWorldInverse),tempPosition.applyProjection(camera.projectionMatrix),screenPosition.copy(tempPosition),screenPositionPixels.x=screenPosition.x*halfViewportWidth+halfViewportWidth,screenPositionPixels.y=screenPosition.y*halfViewportHeight+halfViewportHeight,_lensFlare.hasVertexTexture||0<screenPositionPixels.x&&screenPositionPixels.x<viewportWidth&&0<screenPositionPixels.y&&screenPositionPixels.y<viewportHeight)for(_gl.activeTexture(_gl.TEXTURE1),_gl.bindTexture(_gl.TEXTURE_2D,_lensFlare.tempTexture),_gl.copyTexImage2D(_gl.TEXTURE_2D,0,_gl.RGB,screenPositionPixels.x-8,screenPositionPixels.y-8,16,16,0),_gl.uniform1i(uniforms.renderType,0),_gl.uniform2f(uniforms.scale,scale.x,scale.y),_gl.uniform3f(uniforms.screenPosition,screenPosition.x,screenPosition.y,screenPosition.z),_gl.disable(_gl.BLEND),_gl.enable(_gl.DEPTH_TEST),_gl.drawElements(_gl.TRIANGLES,6,_gl.UNSIGNED_SHORT,0),_gl.activeTexture(_gl.TEXTURE0),_gl.bindTexture(_gl.TEXTURE_2D,_lensFlare.occlusionTexture),_gl.copyTexImage2D(_gl.TEXTURE_2D,0,_gl.RGBA,screenPositionPixels.x-8,screenPositionPixels.y-8,16,16,0),_gl.uniform1i(uniforms.renderType,1),_gl.disable(_gl.DEPTH_TEST),_gl.activeTexture(_gl.TEXTURE1),_gl.bindTexture(_gl.TEXTURE_2D,_lensFlare.tempTexture),_gl.drawElements(_gl.TRIANGLES,6,_gl.UNSIGNED_SHORT,0),flare.positionScreen.copy(screenPosition),flare.customUpdateCallback?flare.customUpdateCallback(flare):flare.updateLensFlares(),_gl.uniform1i(uniforms.renderType,2),_gl.enable(_gl.BLEND),(j=0,jl=flare.lensFlares.length);j<jl;j++)sprite=flare.lensFlares[j],.001<sprite.opacity&&.001<sprite.scale&&(screenPosition.x=sprite.x,screenPosition.y=sprite.y,screenPosition.z=sprite.z,size=sprite.size*sprite.scale/viewportHeight,scale.x=size*invAspect,scale.y=size,_gl.uniform3f(uniforms.screenPosition,screenPosition.x,screenPosition.y,screenPosition.z),_gl.uniform2f(uniforms.scale,scale.x,scale.y),_gl.uniform1f(uniforms.rotation,sprite.rotation),_gl.uniform1f(uniforms.opacity,sprite.opacity),_gl.uniform3f(uniforms.color,sprite.color.r,sprite.color.g,sprite.color.b),_renderer.setBlending(sprite.blending,sprite.blendEquation,sprite.blendSrc,sprite.blendDst),_renderer.setTexture(sprite.texture,1),_gl.drawElements(_gl.TRIANGLES,6,_gl.UNSIGNED_SHORT,0));_gl.enable(_gl.CULL_FACE),_gl.enable(_gl.DEPTH_TEST),_gl.depthMask(!0)}}},THREE.ShadowMapPlugin=function(){function createVirtualLight(light,cascade){var virtualLight=new THREE.DirectionalLight;virtualLight.isVirtual=!0,virtualLight.onlyShadow=!0,virtualLight.castShadow=!0,virtualLight.shadowCameraNear=light.shadowCameraNear,virtualLight.shadowCameraFar=light.shadowCameraFar,virtualLight.shadowCameraLeft=light.shadowCameraLeft,virtualLight.shadowCameraRight=light.shadowCameraRight,virtualLight.shadowCameraBottom=light.shadowCameraBottom,virtualLight.shadowCameraTop=light.shadowCameraTop,virtualLight.shadowCameraVisible=light.shadowCameraVisible,virtualLight.shadowDarkness=light.shadowDarkness,virtualLight.shadowBias=light.shadowCascadeBias[cascade],virtualLight.shadowMapWidth=light.shadowCascadeWidth[cascade],virtualLight.shadowMapHeight=light.shadowCascadeHeight[cascade],virtualLight.pointsWorld=[],virtualLight.pointsFrustum=[];for(var pointsWorld=virtualLight.pointsWorld,pointsFrustum=virtualLight.pointsFrustum,i=0;8>i;i++)pointsWorld[i]=new THREE.Vector3,pointsFrustum[i]=new THREE.Vector3;var nearZ=light.shadowCascadeNearZ[cascade],farZ=light.shadowCascadeFarZ[cascade];return pointsFrustum[0].set(-1,-1,nearZ),pointsFrustum[1].set(1,-1,nearZ),pointsFrustum[2].set(-1,1,nearZ),pointsFrustum[3].set(1,1,nearZ),pointsFrustum[4].set(-1,-1,farZ),pointsFrustum[5].set(1,-1,farZ),pointsFrustum[6].set(-1,1,farZ),pointsFrustum[7].set(1,1,farZ),virtualLight}function updateVirtualLight(light,cascade){var virtualLight=light.shadowCascadeArray[cascade];virtualLight.position.copy(light.position),virtualLight.target.position.copy(light.target.position),virtualLight.lookAt(virtualLight.target),virtualLight.shadowCameraVisible=light.shadowCameraVisible,virtualLight.shadowDarkness=light.shadowDarkness,virtualLight.shadowBias=light.shadowCascadeBias[cascade];var nearZ=light.shadowCascadeNearZ[cascade],farZ=light.shadowCascadeFarZ[cascade],pointsFrustum=virtualLight.pointsFrustum;pointsFrustum[0].z=nearZ,pointsFrustum[1].z=nearZ,pointsFrustum[2].z=nearZ,pointsFrustum[3].z=nearZ,pointsFrustum[4].z=farZ,pointsFrustum[5].z=farZ,pointsFrustum[6].z=farZ,pointsFrustum[7].z=farZ}function updateShadowCamera(camera,light){var shadowCamera=light.shadowCamera,pointsFrustum=light.pointsFrustum,pointsWorld=light.pointsWorld;_min.set(Infinity,Infinity,Infinity),_max.set(-Infinity,-Infinity,-Infinity);for(var i=0,p;8>i;i++)p=pointsWorld[i],p.copy(pointsFrustum[i]),THREE.ShadowMapPlugin.__projector.unprojectVector(p,camera),p.applyMatrix4(shadowCamera.matrixWorldInverse),p.x<_min.x&&(_min.x=p.x),p.x>_max.x&&(_max.x=p.x),p.y<_min.y&&(_min.y=p.y),p.y>_max.y&&(_max.y=p.y),p.z<_min.z&&(_min.z=p.z),p.z>_max.z&&(_max.z=p.z);shadowCamera.left=_min.x,shadowCamera.right=_max.x,shadowCamera.top=_max.y,shadowCamera.bottom=_min.y,shadowCamera.updateProjectionMatrix()}function getObjectMaterial(object){return object.material instanceof THREE.MeshFaceMaterial?object.material.materials[0]:object.material}var _frustum=new THREE.Frustum,_projScreenMatrix=new THREE.Matrix4,_min=new THREE.Vector3,_max=new THREE.Vector3,_matrixPosition=new THREE.Vector3,_gl,_renderer,_depthMaterial,_depthMaterialMorph,_depthMaterialSkin,_depthMaterialMorphSkin;this.init=function(renderer){_gl=renderer.context,_renderer=renderer;var depthShader=THREE.ShaderLib.depthRGBA,depthUniforms=THREE.UniformsUtils.clone(depthShader.uniforms);_depthMaterial=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms}),_depthMaterialMorph=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms,morphTargets:!0}),_depthMaterialSkin=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms,skinning:!0}),_depthMaterialMorphSkin=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms,morphTargets:!0,skinning:!0}),_depthMaterial._shadowPass=!0,_depthMaterialMorph._shadowPass=!0,_depthMaterialSkin._shadowPass=!0,_depthMaterialMorphSkin._shadowPass=!0},this.render=function(scene,camera){_renderer.shadowMapEnabled&&_renderer.shadowMapAutoUpdate&&this.update(scene,camera)},this.update=function(scene,camera){var lights=[],k=0,fog=null,i,il,j,jl,n,shadowMap,shadowMatrix,shadowCamera,buffer,material,webglObject,object,light,renderList;for(_gl.clearColor(1,1,1,1),_gl.disable(_gl.BLEND),_gl.enable(_gl.CULL_FACE),_gl.frontFace(_gl.CCW),_renderer.shadowMapCullFace===THREE.CullFaceFront?_gl.cullFace(_gl.FRONT):_gl.cullFace(_gl.BACK),_renderer.setDepthTest(!0),(i=0,il=scene.__lights.length);i<il;i++)if(light=scene.__lights[i],light.castShadow)if(light instanceof THREE.DirectionalLight&&light.shadowCascade)for(n=0;n<light.shadowCascadeCount;n++){var virtualLight;if(!light.shadowCascadeArray[n]){virtualLight=createVirtualLight(light,n),virtualLight.originalCamera=camera;var gyro=new THREE.Gyroscope;gyro.position=light.shadowCascadeOffset,gyro.add(virtualLight),gyro.add(virtualLight.target),camera.add(gyro),light.shadowCascadeArray[n]=virtualLight,console.log('Created virtualLight',virtualLight)}else virtualLight=light.shadowCascadeArray[n];updateVirtualLight(light,n),lights[k]=virtualLight,k++}else lights[k]=light,k++;for(i=0,il=lights.length;i<il;i++){if(light=lights[i],!light.shadowMap){var shadowFilter=THREE.LinearFilter;_renderer.shadowMapType===THREE.PCFSoftShadowMap&&(shadowFilter=THREE.NearestFilter);var pars={minFilter:shadowFilter,magFilter:shadowFilter,format:THREE.RGBAFormat};light.shadowMap=new THREE.WebGLRenderTarget(light.shadowMapWidth,light.shadowMapHeight,pars),light.shadowMapSize=new THREE.Vector2(light.shadowMapWidth,light.shadowMapHeight),light.shadowMatrix=new THREE.Matrix4}if(!light.shadowCamera){if(light instanceof THREE.SpotLight)light.shadowCamera=new THREE.PerspectiveCamera(light.shadowCameraFov,light.shadowMapWidth/light.shadowMapHeight,light.shadowCameraNear,light.shadowCameraFar);else if(light instanceof THREE.DirectionalLight)light.shadowCamera=new THREE.OrthographicCamera(light.shadowCameraLeft,light.shadowCameraRight,light.shadowCameraTop,light.shadowCameraBottom,light.shadowCameraNear,light.shadowCameraFar);else{console.error('Unsupported light type for shadow');continue}scene.add(light.shadowCamera),!0===scene.autoUpdate&&scene.updateMatrixWorld()}for(light.shadowCameraVisible&&!light.cameraHelper&&(light.cameraHelper=new THREE.CameraHelper(light.shadowCamera),light.shadowCamera.add(light.cameraHelper)),light.isVirtual&&virtualLight.originalCamera==camera&&updateShadowCamera(camera,light),shadowMap=light.shadowMap,shadowMatrix=light.shadowMatrix,shadowCamera=light.shadowCamera,shadowCamera.position.getPositionFromMatrix(light.matrixWorld),_matrixPosition.getPositionFromMatrix(light.target.matrixWorld),shadowCamera.lookAt(_matrixPosition),shadowCamera.updateMatrixWorld(),shadowCamera.matrixWorldInverse.getInverse(shadowCamera.matrixWorld),light.cameraHelper&&(light.cameraHelper.visible=light.shadowCameraVisible),light.shadowCameraVisible&&light.cameraHelper.update(),shadowMatrix.set(.5,0,0,.5,0,.5,0,.5,0,0,.5,.5,0,0,0,1),shadowMatrix.multiply(shadowCamera.projectionMatrix),shadowMatrix.multiply(shadowCamera.matrixWorldInverse),_projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix,shadowCamera.matrixWorldInverse),_frustum.setFromMatrix(_projScreenMatrix),_renderer.setRenderTarget(shadowMap),_renderer.clear(),renderList=scene.__webglObjects,(j=0,jl=renderList.length);j<jl;j++)webglObject=renderList[j],object=webglObject.object,webglObject.render=!1,object.visible&&object.castShadow&&(!(object instanceof THREE.Mesh||object instanceof THREE.ParticleSystem)||!object.frustumCulled||_frustum.intersectsObject(object))&&(object._modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse,object.matrixWorld),webglObject.render=!0);var objectMaterial,useMorphing,useSkinning;for(j=0,jl=renderList.length;j<jl;j++)webglObject=renderList[j],webglObject.render&&(object=webglObject.object,buffer=webglObject.buffer,objectMaterial=getObjectMaterial(object),useMorphing=0<object.geometry.morphTargets.length&&objectMaterial.morphTargets,useSkinning=object instanceof THREE.SkinnedMesh&&objectMaterial.skinning,material=object.customDepthMaterial?object.customDepthMaterial:useSkinning?useMorphing?_depthMaterialMorphSkin:_depthMaterialSkin:useMorphing?_depthMaterialMorph:_depthMaterial,buffer instanceof THREE.BufferGeometry?_renderer.renderBufferDirect(shadowCamera,scene.__lights,fog,material,buffer,object):_renderer.renderBuffer(shadowCamera,scene.__lights,fog,material,buffer,object));for(renderList=scene.__webglObjectsImmediate,j=0,jl=renderList.length;j<jl;j++)webglObject=renderList[j],object=webglObject.object,object.visible&&object.castShadow&&(object._modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse,object.matrixWorld),_renderer.renderImmediateObject(shadowCamera,scene.__lights,fog,_depthMaterial,object))}var clearColor=_renderer.getClearColor(),clearAlpha=_renderer.getClearAlpha();_gl.clearColor(clearColor.r,clearColor.g,clearColor.b,clearAlpha),_gl.enable(_gl.BLEND),_renderer.shadowMapCullFace===THREE.CullFaceFront&&_gl.cullFace(_gl.BACK)}},THREE.ShadowMapPlugin.__projector=new THREE.Projector,THREE.SpritePlugin=function(){function createProgram(shader,precision){var program=_gl.createProgram(),fragmentShader=_gl.createShader(_gl.FRAGMENT_SHADER),vertexShader=_gl.createShader(_gl.VERTEX_SHADER),prefix='precision '+precision+' float;\n';return _gl.shaderSource(fragmentShader,prefix+shader.fragmentShader),_gl.shaderSource(vertexShader,prefix+shader.vertexShader),_gl.compileShader(fragmentShader),_gl.compileShader(vertexShader),_gl.attachShader(program,fragmentShader),_gl.attachShader(program,vertexShader),_gl.linkProgram(program),program}function painterSortStable(a,b){return a.z===b.z?b.id-a.id:b.z-a.z}var _sprite={},_gl,_renderer,_precision;this.init=function(renderer){_gl=renderer.context,_renderer=renderer,_precision=renderer.getPrecision(),_sprite.vertices=new Float32Array(16),_sprite.faces=new Uint16Array(6);var i=0;_sprite.vertices[i++]=-1,_sprite.vertices[i++]=-1,_sprite.vertices[i++]=0,_sprite.vertices[i++]=0,_sprite.vertices[i++]=1,_sprite.vertices[i++]=-1,_sprite.vertices[i++]=1,_sprite.vertices[i++]=0,_sprite.vertices[i++]=1,_sprite.vertices[i++]=1,_sprite.vertices[i++]=1,_sprite.vertices[i++]=1,_sprite.vertices[i++]=-1,_sprite.vertices[i++]=1,_sprite.vertices[i++]=0,_sprite.vertices[i++]=1,i=0,_sprite.faces[i++]=0,_sprite.faces[i++]=1,_sprite.faces[i++]=2,_sprite.faces[i++]=0,_sprite.faces[i++]=2,_sprite.faces[i++]=3,_sprite.vertexBuffer=_gl.createBuffer(),_sprite.elementBuffer=_gl.createBuffer(),_gl.bindBuffer(_gl.ARRAY_BUFFER,_sprite.vertexBuffer),_gl.bufferData(_gl.ARRAY_BUFFER,_sprite.vertices,_gl.STATIC_DRAW),_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,_sprite.elementBuffer),_gl.bufferData(_gl.ELEMENT_ARRAY_BUFFER,_sprite.faces,_gl.STATIC_DRAW),_sprite.program=createProgram(THREE.ShaderSprite.sprite,_precision),_sprite.attributes={},_sprite.uniforms={},_sprite.attributes.position=_gl.getAttribLocation(_sprite.program,'position'),_sprite.attributes.uv=_gl.getAttribLocation(_sprite.program,'uv'),_sprite.uniforms.uvOffset=_gl.getUniformLocation(_sprite.program,'uvOffset'),_sprite.uniforms.uvScale=_gl.getUniformLocation(_sprite.program,'uvScale'),_sprite.uniforms.rotation=_gl.getUniformLocation(_sprite.program,'rotation'),_sprite.uniforms.scale=_gl.getUniformLocation(_sprite.program,'scale'),_sprite.uniforms.alignment=_gl.getUniformLocation(_sprite.program,'alignment'),_sprite.uniforms.color=_gl.getUniformLocation(_sprite.program,'color'),_sprite.uniforms.map=_gl.getUniformLocation(_sprite.program,'map'),_sprite.uniforms.opacity=_gl.getUniformLocation(_sprite.program,'opacity'),_sprite.uniforms.useScreenCoordinates=_gl.getUniformLocation(_sprite.program,'useScreenCoordinates'),_sprite.uniforms.sizeAttenuation=_gl.getUniformLocation(_sprite.program,'sizeAttenuation'),_sprite.uniforms.screenPosition=_gl.getUniformLocation(_sprite.program,'screenPosition'),_sprite.uniforms.modelViewMatrix=_gl.getUniformLocation(_sprite.program,'modelViewMatrix'),_sprite.uniforms.projectionMatrix=_gl.getUniformLocation(_sprite.program,'projectionMatrix'),_sprite.uniforms.fogType=_gl.getUniformLocation(_sprite.program,'fogType'),_sprite.uniforms.fogDensity=_gl.getUniformLocation(_sprite.program,'fogDensity'),_sprite.uniforms.fogNear=_gl.getUniformLocation(_sprite.program,'fogNear'),_sprite.uniforms.fogFar=_gl.getUniformLocation(_sprite.program,'fogFar'),_sprite.uniforms.fogColor=_gl.getUniformLocation(_sprite.program,'fogColor'),_sprite.uniforms.alphaTest=_gl.getUniformLocation(_sprite.program,'alphaTest')},this.render=function(scene,camera,viewportWidth,viewportHeight){var sprites=scene.__webglSprites,nSprites=sprites.length;if(nSprites){var attributes=_sprite.attributes,uniforms=_sprite.uniforms,halfViewportWidth=.5*viewportWidth,halfViewportHeight=.5*viewportHeight;_gl.useProgram(_sprite.program),_gl.enableVertexAttribArray(attributes.position),_gl.enableVertexAttribArray(attributes.uv),_gl.disable(_gl.CULL_FACE),_gl.enable(_gl.BLEND),_gl.bindBuffer(_gl.ARRAY_BUFFER,_sprite.vertexBuffer),_gl.vertexAttribPointer(attributes.position,2,_gl.FLOAT,!1,16,0),_gl.vertexAttribPointer(attributes.uv,2,_gl.FLOAT,!1,16,8),_gl.bindBuffer(_gl.ELEMENT_ARRAY_BUFFER,_sprite.elementBuffer),_gl.uniformMatrix4fv(uniforms.projectionMatrix,!1,camera.projectionMatrix.elements),_gl.activeTexture(_gl.TEXTURE0),_gl.uniform1i(uniforms.map,0);var oldFogType=0,sceneFogType=0,fog=scene.fog;fog?(_gl.uniform3f(uniforms.fogColor,fog.color.r,fog.color.g,fog.color.b),fog instanceof THREE.Fog?(_gl.uniform1f(uniforms.fogNear,fog.near),_gl.uniform1f(uniforms.fogFar,fog.far),_gl.uniform1i(uniforms.fogType,1),oldFogType=1,sceneFogType=1):fog instanceof THREE.FogExp2&&(_gl.uniform1f(uniforms.fogDensity,fog.density),_gl.uniform1i(uniforms.fogType,2),oldFogType=2,sceneFogType=2)):(_gl.uniform1i(uniforms.fogType,0),oldFogType=0,sceneFogType=0);var scale=[],i,sprite,material,size,fogType;for(i=0;i<nSprites;i++)sprite=sprites[i],material=sprite.material,!sprite.visible||0===material.opacity||(material.useScreenCoordinates?sprite.z=-sprite.position.z:(sprite._modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse,sprite.matrixWorld),sprite.z=-sprite._modelViewMatrix.elements[14]));for(sprites.sort(painterSortStable),i=0;i<nSprites;i++)sprite=sprites[i],material=sprite.material,sprite.visible&&0!==material.opacity&&material.map&&material.map.image&&material.map.image.width&&(_gl.uniform1f(uniforms.alphaTest,material.alphaTest),!0===material.useScreenCoordinates?(_gl.uniform1i(uniforms.useScreenCoordinates,1),_gl.uniform3f(uniforms.screenPosition,(sprite.position.x*_renderer.devicePixelRatio-halfViewportWidth)/halfViewportWidth,(halfViewportHeight-sprite.position.y*_renderer.devicePixelRatio)/halfViewportHeight,Math.max(0,Math.min(1,sprite.position.z))),scale[0]=_renderer.devicePixelRatio,scale[1]=_renderer.devicePixelRatio):(_gl.uniform1i(uniforms.useScreenCoordinates,0),_gl.uniform1i(uniforms.sizeAttenuation,material.sizeAttenuation?1:0),_gl.uniformMatrix4fv(uniforms.modelViewMatrix,!1,sprite._modelViewMatrix.elements),scale[0]=1,scale[1]=1),fogType=scene.fog&&material.fog?sceneFogType:0,oldFogType!==fogType&&(_gl.uniform1i(uniforms.fogType,fogType),oldFogType=fogType),size=1/(material.scaleByViewport?viewportHeight:1),scale[0]*=size*(viewportHeight/viewportWidth)*sprite.scale.x,scale[1]*=size*sprite.scale.y,_gl.uniform2f(uniforms.uvScale,material.uvScale.x,material.uvScale.y),_gl.uniform2f(uniforms.uvOffset,material.uvOffset.x,material.uvOffset.y),_gl.uniform2f(uniforms.alignment,material.alignment.x,material.alignment.y),_gl.uniform1f(uniforms.opacity,material.opacity),_gl.uniform3f(uniforms.color,material.color.r,material.color.g,material.color.b),_gl.uniform1f(uniforms.rotation,sprite.rotation),_gl.uniform2fv(uniforms.scale,scale),_renderer.setBlending(material.blending,material.blendEquation,material.blendSrc,material.blendDst),_renderer.setDepthTest(material.depthTest),_renderer.setDepthWrite(material.depthWrite),_renderer.setTexture(material.map,0),_gl.drawElements(_gl.TRIANGLES,6,_gl.UNSIGNED_SHORT,0));_gl.enable(_gl.CULL_FACE)}}},THREE.DepthPassPlugin=function(){function getObjectMaterial(object){return object.material instanceof THREE.MeshFaceMaterial?object.material.materials[0]:object.material}this.enabled=!1,this.renderTarget=null;var _frustum=new THREE.Frustum,_projScreenMatrix=new THREE.Matrix4,_gl,_renderer,_depthMaterial,_depthMaterialMorph,_depthMaterialSkin,_depthMaterialMorphSkin;this.init=function(renderer){_gl=renderer.context,_renderer=renderer;var depthShader=THREE.ShaderLib.depthRGBA,depthUniforms=THREE.UniformsUtils.clone(depthShader.uniforms);_depthMaterial=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms}),_depthMaterialMorph=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms,morphTargets:!0}),_depthMaterialSkin=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms,skinning:!0}),_depthMaterialMorphSkin=new THREE.ShaderMaterial({fragmentShader:depthShader.fragmentShader,vertexShader:depthShader.vertexShader,uniforms:depthUniforms,morphTargets:!0,skinning:!0}),_depthMaterial._shadowPass=!0,_depthMaterialMorph._shadowPass=!0,_depthMaterialSkin._shadowPass=!0,_depthMaterialMorphSkin._shadowPass=!0},this.render=function(scene,camera){this.enabled&&this.update(scene,camera)},this.update=function(scene,camera){var fog=null,j,jl,buffer,material,webglObject,object,renderList;for(_gl.clearColor(1,1,1,1),_gl.disable(_gl.BLEND),_renderer.setDepthTest(!0),!0===scene.autoUpdate&&scene.updateMatrixWorld(),camera.matrixWorldInverse.getInverse(camera.matrixWorld),_projScreenMatrix.multiplyMatrices(camera.projectionMatrix,camera.matrixWorldInverse),_frustum.setFromMatrix(_projScreenMatrix),_renderer.setRenderTarget(this.renderTarget),_renderer.clear(),renderList=scene.__webglObjects,(j=0,jl=renderList.length);j<jl;j++)webglObject=renderList[j],object=webglObject.object,webglObject.render=!1,object.visible&&(!(object instanceof THREE.Mesh||object instanceof THREE.ParticleSystem)||!object.frustumCulled||_frustum.intersectsObject(object))&&(object._modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse,object.matrixWorld),webglObject.render=!0);var objectMaterial,useMorphing,useSkinning;for(j=0,jl=renderList.length;j<jl;j++)if(webglObject=renderList[j],webglObject.render){if(object=webglObject.object,buffer=webglObject.buffer,object instanceof THREE.ParticleSystem&&!object.customDepthMaterial)continue;objectMaterial=getObjectMaterial(object),objectMaterial&&_renderer.setMaterialFaces(object.material),useMorphing=0<object.geometry.morphTargets.length&&objectMaterial.morphTargets,useSkinning=object instanceof THREE.SkinnedMesh&&objectMaterial.skinning,material=object.customDepthMaterial?object.customDepthMaterial:useSkinning?useMorphing?_depthMaterialMorphSkin:_depthMaterialSkin:useMorphing?_depthMaterialMorph:_depthMaterial,buffer instanceof THREE.BufferGeometry?_renderer.renderBufferDirect(camera,scene.__lights,fog,material,buffer,object):_renderer.renderBuffer(camera,scene.__lights,fog,material,buffer,object)}for(renderList=scene.__webglObjectsImmediate,j=0,jl=renderList.length;j<jl;j++)webglObject=renderList[j],object=webglObject.object,object.visible&&(object._modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse,object.matrixWorld),_renderer.renderImmediateObject(camera,scene.__lights,fog,_depthMaterial,object));var clearColor=_renderer.getClearColor(),clearAlpha=_renderer.getClearAlpha();_gl.clearColor(clearColor.r,clearColor.g,clearColor.b,clearAlpha),_gl.enable(_gl.BLEND)}},THREE.ShaderFlares={lensFlareVertexTexture:{vertexShader:'uniform lowp int renderType;\nuniform vec3 screenPosition;\nuniform vec2 scale;\nuniform float rotation;\nuniform sampler2D occlusionMap;\nattribute vec2 position;\nattribute vec2 uv;\nvarying vec2 vUV;\nvarying float vVisibility;\nvoid main() {\nvUV = uv;\nvec2 pos = position;\nif( renderType == 2 ) {\nvec4 visibility = texture2D( occlusionMap, vec2( 0.1, 0.1 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.1 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.1 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.9 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.1, 0.9 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) );\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.5 ) );\nvVisibility =        visibility.r / 9.0;\nvVisibility *= 1.0 - visibility.g / 9.0;\nvVisibility *=       visibility.b / 9.0;\nvVisibility *= 1.0 - visibility.a / 9.0;\npos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;\npos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;\n}\ngl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );\n}',fragmentShader:'uniform lowp int renderType;\nuniform sampler2D map;\nuniform float opacity;\nuniform vec3 color;\nvarying vec2 vUV;\nvarying float vVisibility;\nvoid main() {\nif( renderType == 0 ) {\ngl_FragColor = vec4( 1.0, 0.0, 1.0, 0.0 );\n} else if( renderType == 1 ) {\ngl_FragColor = texture2D( map, vUV );\n} else {\nvec4 texture = texture2D( map, vUV );\ntexture.a *= opacity * vVisibility;\ngl_FragColor = texture;\ngl_FragColor.rgb *= color;\n}\n}'},lensFlare:{vertexShader:'uniform lowp int renderType;\nuniform vec3 screenPosition;\nuniform vec2 scale;\nuniform float rotation;\nattribute vec2 position;\nattribute vec2 uv;\nvarying vec2 vUV;\nvoid main() {\nvUV = uv;\nvec2 pos = position;\nif( renderType == 2 ) {\npos.x = cos( rotation ) * position.x - sin( rotation ) * position.y;\npos.y = sin( rotation ) * position.x + cos( rotation ) * position.y;\n}\ngl_Position = vec4( ( pos * scale + screenPosition.xy ).xy, screenPosition.z, 1.0 );\n}',fragmentShader:'precision mediump float;\nuniform lowp int renderType;\nuniform sampler2D map;\nuniform sampler2D occlusionMap;\nuniform float opacity;\nuniform vec3 color;\nvarying vec2 vUV;\nvoid main() {\nif( renderType == 0 ) {\ngl_FragColor = vec4( texture2D( map, vUV ).rgb, 0.0 );\n} else if( renderType == 1 ) {\ngl_FragColor = texture2D( map, vUV );\n} else {\nfloat visibility = texture2D( occlusionMap, vec2( 0.5, 0.1 ) ).a;\nvisibility += texture2D( occlusionMap, vec2( 0.9, 0.5 ) ).a;\nvisibility += texture2D( occlusionMap, vec2( 0.5, 0.9 ) ).a;\nvisibility += texture2D( occlusionMap, vec2( 0.1, 0.5 ) ).a;\nvisibility = ( 1.0 - visibility / 4.0 );\nvec4 texture = texture2D( map, vUV );\ntexture.a *= opacity * visibility;\ngl_FragColor = texture;\ngl_FragColor.rgb *= color;\n}\n}'}},THREE.ShaderSprite={sprite:{vertexShader:'uniform int useScreenCoordinates;\nuniform int sizeAttenuation;\nuniform vec3 screenPosition;\nuniform mat4 modelViewMatrix;\nuniform mat4 projectionMatrix;\nuniform float rotation;\nuniform vec2 scale;\nuniform vec2 alignment;\nuniform vec2 uvOffset;\nuniform vec2 uvScale;\nattribute vec2 position;\nattribute vec2 uv;\nvarying vec2 vUV;\nvoid main() {\nvUV = uvOffset + uv * uvScale;\nvec2 alignedPosition = position + alignment;\nvec2 rotatedPosition;\nrotatedPosition.x = ( cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y ) * scale.x;\nrotatedPosition.y = ( sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y ) * scale.y;\nvec4 finalPosition;\nif( useScreenCoordinates != 0 ) {\nfinalPosition = vec4( screenPosition.xy + rotatedPosition, screenPosition.z, 1.0 );\n} else {\nfinalPosition = projectionMatrix * modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\nfinalPosition.xy += rotatedPosition * ( sizeAttenuation == 1 ? 1.0 : finalPosition.z );\n}\ngl_Position = finalPosition;\n}',fragmentShader:'uniform vec3 color;\nuniform sampler2D map;\nuniform float opacity;\nuniform int fogType;\nuniform vec3 fogColor;\nuniform float fogDensity;\nuniform float fogNear;\nuniform float fogFar;\nuniform float alphaTest;\nvarying vec2 vUV;\nvoid main() {\nvec4 texture = texture2D( map, vUV );\nif ( texture.a < alphaTest ) discard;\ngl_FragColor = vec4( color * texture.xyz, texture.a * opacity );\nif ( fogType > 0 ) {\nfloat depth = gl_FragCoord.z / gl_FragCoord.w;\nfloat fogFactor = 0.0;\nif ( fogType == 1 ) {\nfogFactor = smoothstep( fogNear, fogFar, depth );\n} else {\nconst float LOG2 = 1.442695;\nfloat fogFactor = exp2( - fogDensity * fogDensity * depth * depth * LOG2 );\nfogFactor = 1.0 - clamp( fogFactor, 0.0, 1.0 );\n}\ngl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );\n}\n}'}};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
THREE.OBJLoader=function(manager){this.manager=manager===void 0?THREE.DefaultLoadingManager:manager},THREE.OBJLoader.prototype={constructor:THREE.OBJLoader,load:function load(url,onLoad){var scope=this,loader=new THREE.XHRLoader(scope.manager);loader.setCrossOrigin(this.crossOrigin),loader.load(url,function(text){onLoad(scope.parse(text))})},parse:function parse(text){function vector(x,y,z){return new THREE.Vector3(parseFloat(x),parseFloat(y),parseFloat(z))}function uv(u,v){return new THREE.Vector2(parseFloat(u),parseFloat(v))}function face3(a,b,c,normals){return new THREE.Face3(a,b,c,normals)}function parseVertexIndex(index){return index=parseInt(index),0<=index?index-1:index+vertices.length}function parseNormalIndex(index){return index=parseInt(index),0<=index?index-1:index+normals.length}function parseUVIndex(index){return index=parseInt(index),0<=index?index-1:index+uvs.length}function add_face(a,b,c,normals_inds){normals_inds===void 0?geometry.faces.push(face3(vertices[parseVertexIndex(a)]-1,vertices[parseVertexIndex(b)]-1,vertices[parseVertexIndex(c)]-1)):geometry.faces.push(face3(vertices[parseVertexIndex(a)]-1,vertices[parseVertexIndex(b)]-1,vertices[parseVertexIndex(c)]-1,[normals[parseNormalIndex(normals_inds[0])].clone(),normals[parseNormalIndex(normals_inds[1])].clone(),normals[parseNormalIndex(normals_inds[2])].clone()]))}function add_uvs(a,b,c){geometry.faceVertexUvs[0].push([uvs[parseUVIndex(a)].clone(),uvs[parseUVIndex(b)].clone(),uvs[parseUVIndex(c)].clone()])}function handle_face_line(faces,uvs,normals_inds){faces[3]===void 0?(add_face(faces[0],faces[1],faces[2],normals_inds),uvs!==void 0&&0<uvs.length&&add_uvs(uvs[0],uvs[1],uvs[2])):(normals_inds!==void 0&&0<normals_inds.length?(add_face(faces[0],faces[1],faces[3],[normals_inds[0],normals_inds[1],normals_inds[3]]),add_face(faces[1],faces[2],faces[3],[normals_inds[1],normals_inds[2],normals_inds[3]])):(add_face(faces[0],faces[1],faces[3]),add_face(faces[1],faces[2],faces[3])),uvs!==void 0&&0<uvs.length&&(add_uvs(uvs[0],uvs[1],uvs[3]),add_uvs(uvs[1],uvs[2],uvs[3])))}var geometry,material,mesh,object=new THREE.Object3D;!1===/^o /gm.test(text)&&(geometry=new THREE.Geometry,material=new THREE.MeshLambertMaterial,mesh=new THREE.Mesh(geometry,material),object.add(mesh));var vertices=[],normals=[],uvs=[],vertex_pattern=/v( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/,normal_pattern=/vn( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/,uv_pattern=/vt( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/,face_pattern1=/f( +-?\d+)( +-?\d+)( +-?\d+)( +-?\d+)?/,face_pattern2=/f( +(-?\d+)\/(-?\d+))( +(-?\d+)\/(-?\d+))( +(-?\d+)\/(-?\d+))( +(-?\d+)\/(-?\d+))?/,face_pattern3=/f( +(-?\d+)\/(-?\d+)\/(-?\d+))( +(-?\d+)\/(-?\d+)\/(-?\d+))( +(-?\d+)\/(-?\d+)\/(-?\d+))( +(-?\d+)\/(-?\d+)\/(-?\d+))?/,face_pattern4=/f( +(-?\d+)\/\/(-?\d+))( +(-?\d+)\/\/(-?\d+))( +(-?\d+)\/\/(-?\d+))( +(-?\d+)\/\/(-?\d+))?/;text=text.replace(/\\\r\n/g,'');for(var line,lines=text.split('\n'),i=0;i<lines.length;i++){line=lines[i],line=line.trim();var result;if(0===line.length||'#'===line.charAt(0))continue;else if(null!==(result=vertex_pattern.exec(line)))vertices.push(geometry.vertices.push(vector(result[1],result[2],result[3])));else if(null!==(result=normal_pattern.exec(line)))normals.push(vector(result[1],result[2],result[3]));else if(null!==(result=uv_pattern.exec(line)))uvs.push(uv(result[1],result[2]));else if(null!==(result=face_pattern1.exec(line)))handle_face_line([result[1],result[2],result[3],result[4]]);else if(null!==(result=face_pattern2.exec(line)))handle_face_line([result[2],result[5],result[8],result[11]],[result[3],result[6],result[9],result[12]]);else if(null!==(result=face_pattern3.exec(line)))handle_face_line([result[2],result[6],result[10],result[14]],[result[3],result[7],result[11],result[15]],[result[4],result[8],result[12],result[16]]);else if(null!==(result=face_pattern4.exec(line)))handle_face_line([result[2],result[5],result[8],result[11]],[],[result[3],result[6],result[9],result[12]]);else if(/^o /.test(line))geometry=new THREE.Geometry,material=new THREE.MeshLambertMaterial,mesh=new THREE.Mesh(geometry,material),mesh.name=line.substring(2).trim(),object.add(mesh);else if(/^g /.test(line));else if(/^usemtl /.test(line))material.name=line.substring(7).trim();else if(/^mtllib /.test(line));else if(/^s /.test(line));else;}for(var geometry,children=object.children,i=0,l=children.length;i<l;i++)geometry=children[i].geometry,geometry.computeFaceNormals(),geometry.computeBoundingSphere();return object}};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
THREE.MTLLoader=function(baseUrl,options,crossOrigin){this.baseUrl=baseUrl,this.options=options,this.crossOrigin=crossOrigin},THREE.MTLLoader.prototype={constructor:THREE.MTLLoader,load:function load(url){var scope=this,xhr=new XMLHttpRequest;xhr.addEventListener('load',function(event){if(200===event.target.status||0===event.target.status){var materialCreator=scope.parse(event.target.responseText);scope.dispatchEvent({type:'load',content:materialCreator})}else scope.dispatchEvent({type:'error',message:'Couldn\'t load URL ['+url+']',response:event.target.responseText})},!1),xhr.addEventListener('progress',function(event){scope.dispatchEvent({type:'progress',loaded:event.loaded,total:event.total})},!1),xhr.addEventListener('error',function(){scope.dispatchEvent({type:'error',message:'Couldn\'t load URL ['+url+']'})},!1),xhr.open('GET',url,!0),xhr.send(null)},parse:function parse(text){for(var line,lines=text.split('\n'),info={},delimiter_pattern=/\s+/,materialsInfo={},i=0;i<lines.length;i++)if(line=lines[i],line=line.trim(),0!==line.length&&'#'!==line.charAt(0)){var pos=line.indexOf(' '),key=0<=pos?line.substring(0,pos):line;key=key.toLowerCase();var value=0<=pos?line.substring(pos+1):'';if(value=value.trim(),'newmtl'===key)info={name:value},materialsInfo[value]=info;else if(info)if('ka'===key||'kd'===key||'ks'===key){var ss=value.split(delimiter_pattern,3);info[key]=[parseFloat(ss[0]),parseFloat(ss[1]),parseFloat(ss[2])]}else info[key]=value}var materialCreator=new THREE.MTLLoader.MaterialCreator(this.baseUrl,this.options);return materialCreator.setMaterials(materialsInfo),materialCreator}},THREE.MTLLoader.MaterialCreator=function(baseUrl,options){this.baseUrl=baseUrl,this.options=options,this.materialsInfo={},this.materials={},this.materialsArray=[],this.nameLookup={},this.side=this.options&&this.options.side?this.options.side:THREE.FrontSide,this.wrap=this.options&&this.options.wrap?this.options.wrap:THREE.RepeatWrapping},THREE.MTLLoader.MaterialCreator.prototype={constructor:THREE.MTLLoader.MaterialCreator,setMaterials:function setMaterials(materialsInfo){this.materialsInfo=this.convert(materialsInfo),this.materials={},this.materialsArray=[],this.nameLookup={}},convert:function convert(materialsInfo){if(!this.options)return materialsInfo;var converted={};for(var mn in materialsInfo){var mat=materialsInfo[mn],covmat={};for(var prop in converted[mn]=covmat,mat){var save=!0,value=mat[prop],lprop=prop.toLowerCase();switch(lprop){case'kd':case'ka':case'ks':this.options&&this.options.normalizeRGB&&(value=[value[0]/255,value[1]/255,value[2]/255]),this.options&&this.options.ignoreZeroRGBs&&0===value[0]&&0===value[1]&&0===value[1]&&(save=!1);break;case'd':this.options&&this.options.invertTransparency&&(value=1-value);break;default:}save&&(covmat[lprop]=value)}}return converted},preload:function preload(){for(var mn in this.materialsInfo)this.create(mn)},getIndex:function getIndex(materialName){return this.nameLookup[materialName]},getAsArray:function getAsArray(){var index=0;for(var mn in this.materialsInfo)this.materialsArray[index]=this.create(mn),this.nameLookup[mn]=index,index++;return this.materialsArray},create:function create(materialName){return void 0===this.materials[materialName]&&this.createMaterial_(materialName),this.materials[materialName]},createMaterial_:function createMaterial_(materialName){var mat=this.materialsInfo[materialName],params={name:materialName,side:this.side};for(var prop in mat){var value=mat[prop];switch(prop.toLowerCase()){case'kd':params.diffuse=new THREE.Color().setRGB(value[0],value[1],value[2]);break;case'ka':params.ambient=new THREE.Color().setRGB(value[0],value[1],value[2]);break;case'ks':params.specular=new THREE.Color().setRGB(value[0],value[1],value[2]);break;case'map_kd':params.map=this.loadTexture(this.baseUrl+value),params.map.wrapS=this.wrap,params.map.wrapT=this.wrap;break;case'ns':params.shininess=value;break;case'd':1>value&&(params.transparent=!0,params.opacity=value);break;default:}}return params.diffuse&&(!params.ambient&&(params.ambient=params.diffuse),params.color=params.diffuse),this.materials[materialName]=new THREE.MeshPhongMaterial(params),this.materials[materialName]},loadTexture:function loadTexture(url,mapping,onLoad,onError){var isCompressed=/\.dds$/i.test(url);if(isCompressed)var texture=THREE.ImageUtils.loadCompressedTexture(url,mapping,onLoad,onError);else{var image=new Image,texture=new THREE.Texture(image,mapping),loader=new THREE.ImageLoader;loader.crossOrigin=this.crossOrigin,loader.load(url,function(image){texture.image=THREE.MTLLoader.ensurePowerOfTwo_(image),texture.needsUpdate=!0,onLoad&&onLoad(texture)})}return texture}},THREE.MTLLoader.ensurePowerOfTwo_=function(image){if(!THREE.MTLLoader.isPowerOfTwo_(image.width)||!THREE.MTLLoader.isPowerOfTwo_(image.height)){var canvas=document.createElement('canvas');canvas.width=THREE.MTLLoader.nextHighestPowerOfTwo_(image.width),canvas.height=THREE.MTLLoader.nextHighestPowerOfTwo_(image.height);var ctx=canvas.getContext('2d');return ctx.drawImage(image,0,0,image.width,image.height,0,0,canvas.width,canvas.height),canvas}return image},THREE.MTLLoader.isPowerOfTwo_=function(x){return 0==(x&x-1)},THREE.MTLLoader.nextHighestPowerOfTwo_=function(x){--x;for(var i=1;32>i;i<<=1)x|=x>>i;return x+1},THREE.EventDispatcher.prototype.apply(THREE.MTLLoader.prototype);

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
THREE.OBJMTLLoader=function(){},THREE.OBJMTLLoader.prototype={constructor:THREE.OBJMTLLoader,load:function load(url,mtlfileurl,options){function waitReady(event){if(!('load'===event.type))'error'===event.type&&(mtlDone=!0);else if(event.content instanceof THREE.MTLLoader.MaterialCreator)mtlDone=!0,materialsCreator=event.content,materialsCreator.preload();else if(200===event.target.status||0===event.target.status){var objContent=event.target.responseText;obj3d=mtlfileurl?scope.parse(objContent):scope.parse(objContent,function(mtlfile){mtlDone=!1,mtlLoader.load(mtlLoader.baseUrl+mtlfile)})}else scope.dispatchEvent({type:'error',message:'Couldn\'t load URL ['+url+']',response:event.target.responseText});mtlDone&&obj3d&&(materialsCreator&&obj3d.traverse(function(object){if(object instanceof THREE.Mesh&&object.material.name){var material=materialsCreator.create(object.material.name);material&&(object.material=material)}}),scope.dispatchEvent({type:'load',content:obj3d}))}var mtlDone,obj3d,materialsCreator,scope=this,xhr=new XMLHttpRequest,mtlLoader=new THREE.MTLLoader(url.substr(0,url.lastIndexOf('/')+1),options);mtlLoader.addEventListener('load',waitReady),mtlLoader.addEventListener('error',waitReady),mtlfileurl?(mtlLoader.load(mtlfileurl),mtlDone=!1):mtlDone=!0,xhr.addEventListener('load',waitReady,!1),xhr.addEventListener('progress',function(event){scope.dispatchEvent({type:'progress',loaded:event.loaded,total:event.total})},!1),xhr.addEventListener('error',function(){scope.dispatchEvent({type:'error',message:'Couldn\'t load URL ['+url+']'})},!1),xhr.open('GET',url,!0),xhr.send(null)},parse:function parse(data,mtllibCallback){function vector(x,y,z){return new THREE.Vector3(x,y,z)}function uv(u,v){return new THREE.Vector2(u,v)}function face3(a,b,c,normals){return new THREE.Face3(a,b,c,normals)}function meshN(meshName,materialName){0<geometry.vertices.length&&(geometry.mergeVertices(),geometry.computeCentroids(),geometry.computeFaceNormals(),geometry.computeBoundingSphere(),object.add(mesh),geometry=new THREE.Geometry,mesh=new THREE.Mesh(geometry,material),verticesCount=0),void 0!==meshName&&(mesh.name=meshName),void 0!==materialName&&(material=new THREE.MeshLambertMaterial,material.name=materialName,mesh.material=material)}data=data.replace(/\ \\\r\n/g,'');var replacement='/f$1$2$4\n/f$2$3$4';data=data.replace(/f( +\d+)( +\d+)( +\d+)( +\d+)/g,replacement),data=data.replace(/f( +\d+\/\d+)( +\d+\/\d+)( +\d+\/\d+)( +\d+\/\d+)/g,replacement),data=data.replace(/f( +\d+\/\d+\/\d+)( +\d+\/\d+\/\d+)( +\d+\/\d+\/\d+)( +\d+\/\d+\/\d+)/g,replacement),data=data.replace(/f( +\d+\/\/\d+)( +\d+\/\/\d+)( +\d+\/\/\d+)( +\d+\/\/\d+)/g,replacement);for(var line,group=new THREE.Object3D,object=group,geometry=new THREE.Geometry,material=new THREE.MeshLambertMaterial,mesh=new THREE.Mesh(geometry,material),vertices=[],verticesCount=0,normals=[],uvs=[],vertex_pattern=/v( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/,normal_pattern=/vn( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/,uv_pattern=/vt( +[\d|\.|\+|\-|e]+)( +[\d|\.|\+|\-|e]+)/,face_pattern1=/f( +\d+)( +\d+)( +\d+)/,face_pattern2=/f( +(\d+)\/(\d+))( +(\d+)\/(\d+))( +(\d+)\/(\d+))/,face_pattern3=/f( +(\d+)\/(\d+)\/(\d+))( +(\d+)\/(\d+)\/(\d+))( +(\d+)\/(\d+)\/(\d+))/,face_pattern4=/f( +(\d+)\/\/(\d+))( +(\d+)\/\/(\d+))( +(\d+)\/\/(\d+))/,lines=data.split('\n'),i=0;i<lines.length;i++){line=lines[i],line=line.trim();var result;if(0===line.length||'#'===line.charAt(0))continue;else if(null!==(result=vertex_pattern.exec(line)))vertices.push(vector(parseFloat(result[1]),parseFloat(result[2]),parseFloat(result[3])));else if(null!==(result=normal_pattern.exec(line)))normals.push(vector(parseFloat(result[1]),parseFloat(result[2]),parseFloat(result[3])));else if(null!==(result=uv_pattern.exec(line)))uvs.push(uv(parseFloat(result[1]),parseFloat(result[2])));else if(null!==(result=face_pattern1.exec(line)))geometry.vertices.push(vertices[parseInt(result[1])-1],vertices[parseInt(result[2])-1],vertices[parseInt(result[3])-1]),geometry.faces.push(face3(verticesCount++,verticesCount++,verticesCount++));else if(null!==(result=face_pattern2.exec(line)))geometry.vertices.push(vertices[parseInt(result[2])-1],vertices[parseInt(result[5])-1],vertices[parseInt(result[8])-1]),geometry.faces.push(face3(verticesCount++,verticesCount++,verticesCount++)),geometry.faceVertexUvs[0].push([uvs[parseInt(result[3])-1],uvs[parseInt(result[6])-1],uvs[parseInt(result[9])-1]]);else if(null!==(result=face_pattern3.exec(line)))geometry.vertices.push(vertices[parseInt(result[2])-1],vertices[parseInt(result[6])-1],vertices[parseInt(result[10])-1]),geometry.faces.push(face3(verticesCount++,verticesCount++,verticesCount++,[normals[parseInt(result[4])-1],normals[parseInt(result[8])-1],normals[parseInt(result[12])-1]])),geometry.faceVertexUvs[0].push([uvs[parseInt(result[3])-1],uvs[parseInt(result[7])-1],uvs[parseInt(result[11])-1]]);else if(null!==(result=face_pattern4.exec(line)))geometry.vertices.push(vertices[parseInt(result[2])-1],vertices[parseInt(result[5])-1],vertices[parseInt(result[8])-1]),geometry.faces.push(face3(verticesCount++,verticesCount++,verticesCount++,[normals[parseInt(result[3])-1],normals[parseInt(result[6])-1],normals[parseInt(result[9])-1]]));else if(/^o /.test(line))object=new THREE.Object3D,object.name=line.substring(2).trim(),group.add(object);else if(/^g /.test(line))meshN(line.substring(2).trim(),void 0);else if(/^usemtl /.test(line))meshN(void 0,line.substring(7).trim());else if(/^mtllib /.test(line)){if(mtllibCallback){var mtlfile=line.substring(7);mtlfile=mtlfile.trim(),mtllibCallback(mtlfile)}}else if(/^s /.test(line));else console.log('THREE.OBJMTLLoader: Unhandled line '+line)}return meshN(void 0,void 0),group}},THREE.EventDispatcher.prototype.apply(THREE.OBJMTLLoader.prototype);

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
THREE.OrbitControls=function(object,domElement,center,minCameraDistance){function getAutoRotationAngle(){return 2*_MathPI/60/60*scope.autoRotateSpeed}function getZoomScale(){return Math.pow(.95,scope.userZoomSpeed)}function onMouseMove(event){if(!1!==scope.enabled)if(event.preventDefault(),state===STATE.ROTATE){var x='clientX'in event?event.clientX:event.center.x;var y=event.clientY||event.center.y;rotateEnd.set(x,y),rotateDelta.subVectors(rotateEnd,rotateStart),scope.rotateLeft(2*_MathPI*rotateDelta.x/PIXELS_PER_ROUND*scope.userRotateSpeed),scope.rotateUp(2*_MathPI*rotateDelta.y/PIXELS_PER_ROUND*scope.userRotateSpeed),rotateStart.copy(rotateEnd)}else if(state===STATE.ZOOM)zoomEnd.set(event.clientX,event.clientY),zoomDelta.subVectors(zoomEnd,zoomStart),0<zoomDelta.y?scope.zoomIn():scope.zoomOut(),zoomStart.copy(zoomEnd);else if(state===STATE.PAN){var movementX=event.movementX||event.mozMovementX||event.webkitMovementX||0,movementY=event.movementY||event.mozMovementY||event.webkitMovementY||0;scope.pan(new THREE.Vector3(-movementX,movementY,0))}}function onMouseUp(){!1===scope.enabled||!1===scope.userRotate||(document.removeEventListener('mousemove',onMouseMove,!1),document.removeEventListener('mouseup',onMouseUp,!1),state=STATE.NONE)}function onMouseWheel(event){if(!1!==scope.enabled&&!1!==scope.userZoom){var delta=0;event.wheelDelta?delta=event.wheelDelta:event.detail&&(delta=-event.detail),0<delta?scope.zoomOut():scope.zoomIn(),event.stopPropagation(),event.preventDefault()}}var _MathPI=Math.PI;this.object=object,this.domElement=domElement===void 0?document:domElement,this.enabled=!0,this.center=center||new THREE.Vector3(0,200,0),this.userZoom=!0,this.userZoomSpeed=1,this.userRotate=!0,this.userRotateSpeed=1,this.userPan=!0,this.userPanSpeed=2,this.autoRotate=!1,this.autoRotateSpeed=2,this.minPolarAngle=-_MathPI,this.maxPolarAngle=_MathPI/2,this.minDistance=minCameraDistance,this.maxDistance=Detector.webgl?3500:1500,this.keys={LEFT:37,UP:38,RIGHT:39,BOTTOM:40},this.hammer=new Hammer(domElement),this.hammer.get('pan').set({direction:Hammer.DIRECTION_ALL}),this.hammer.get('press').set({time:0});var scope=this,EPS=1e-6,PIXELS_PER_ROUND=1800,rotateStart=new THREE.Vector2,rotateEnd=new THREE.Vector2,rotateDelta=new THREE.Vector2,zoomStart=new THREE.Vector2,zoomEnd=new THREE.Vector2,zoomDelta=new THREE.Vector2,phiDelta=0,thetaDelta=0,scale=1,lastPosition=new THREE.Vector3,STATE={NONE:-1,ROTATE:0,ZOOM:1,PAN:2},state=STATE.NONE,changeEvent={type:'change'};this.rotateLeft=function(angle){angle===void 0&&(angle=getAutoRotationAngle()),thetaDelta-=angle},this.rotateRight=function(angle){angle===void 0&&(angle=getAutoRotationAngle()),thetaDelta+=angle},this.rotateUp=function(angle){angle===void 0&&(angle=getAutoRotationAngle()),phiDelta-=angle},this.rotateDown=function(angle){angle===void 0&&(angle=getAutoRotationAngle()),phiDelta+=angle},this.zoomIn=function(zoomScale){zoomScale===void 0&&(zoomScale=getZoomScale()),scale/=zoomScale},this.zoomOut=function(zoomScale){zoomScale===void 0&&(zoomScale=getZoomScale()),scale*=zoomScale},this.pan=function(distance){distance.transformDirection(this.object.matrix),distance.multiplyScalar(scope.userPanSpeed),this.object.position.add(distance),this.center.add(distance)},this.update=function(){var _Mathcos=Math.cos,_Mathsin=Math.sin,_Mathmax=Math.max,_Mathmin=Math.min,_Mathatan=Math.atan2,position=this.object.position,offset=position.clone().sub(this.center),theta=_Mathatan(offset.x,offset.z),phi=_Mathatan(Math.sqrt(offset.x*offset.x+offset.z*offset.z),offset.y);this.autoRotate&&this.rotateLeft(getAutoRotationAngle()),theta+=thetaDelta,phi+=phiDelta,phi=_Mathmax(this.minPolarAngle,_Mathmin(this.maxPolarAngle,phi)),phi=_Mathmax(EPS,_Mathmin(_MathPI-EPS,phi));var radius=offset.length()*scale;radius=_Mathmax(this.minDistance,_Mathmin(this.maxDistance,radius)),offset.x=radius*_Mathsin(phi)*_Mathsin(theta),offset.y=radius*_Mathcos(phi),offset.z=radius*_Mathsin(phi)*_Mathcos(theta),position.copy(this.center).add(offset),this.object.lookAt(this.center),thetaDelta=0,phiDelta=0,scale=1,0<lastPosition.distanceTo(this.object.position)&&(this.dispatchEvent(changeEvent),lastPosition.copy(this.object.position))},this.hammer.on('pan',function(ev){state=STATE.ROTATE,onMouseMove(ev)}),this.hammer.on('press',function(event){rotateStart.set(event.center.x,event.center.y)}),this.domElement.addEventListener('contextmenu',function(event){event.preventDefault()},!1),this.domElement.addEventListener('mousedown',function(event){!1===scope.enabled||!1===scope.userRotate||(event.preventDefault(),0===event.button?(state=STATE.ROTATE,rotateStart.set(event.clientX,event.clientY)):1===event.button?(state=STATE.ZOOM,zoomStart.set(event.clientX,event.clientY)):2===event.button&&(state=STATE.PAN),document.addEventListener('mousemove',onMouseMove,!1),document.addEventListener('mouseup',onMouseUp,!1))},!1),this.domElement.addEventListener('mousewheel',onMouseWheel,!1),this.domElement.addEventListener('DOMMouseScroll',onMouseWheel,!1),this.domElement.addEventListener('keydown',function(event){if(!1!==scope.enabled&&!1!==scope.userPan)switch(event.keyCode){case scope.keys.UP:scope.pan(new THREE.Vector3(0,1,0));break;case scope.keys.BOTTOM:scope.pan(new THREE.Vector3(0,-1,0));break;case scope.keys.LEFT:scope.pan(new THREE.Vector3(-1,0,0));break;case scope.keys.RIGHT:scope.pan(new THREE.Vector3(1,0,0));}},!1)},THREE.OrbitControls.prototype=Object.create(THREE.EventDispatcher.prototype);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
module.exports={getChoices:function getChoices(){return __webpack_require__(118)},dynamicRequire:__webpack_require__(5)};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),ColorPicker=__webpack_require__(119),Dimensions=__webpack_require__(120),Options=__webpack_require__(127),Mssg=dynamicRequire('Mssg.jsx'),Choices=function(_React$Component){function Choices(){return _classCallCheck(this,Choices),_possibleConstructorReturn(this,(Choices.__proto__||Object.getPrototypeOf(Choices)).apply(this,arguments))}return _inherits(Choices,_React$Component),_createClass(Choices,[{key:'render',value:function render(){var link=this.props.location.search?this.props.location.href+'&refresh':'?refresh';return React.createElement('div',{className:'lr-sidebar-box lr-casefactory-choices choices sidebar-box'},React.createElement(Dimensions,this.props),React.createElement(ColorPicker,this.props),React.createElement(Options,this.props),React.createElement('div',{className:'lr-casefactory-choices-reset-button reset-button'},React.createElement('a',{href:link},React.createElement(Mssg,{__key:'nc_casefactory.reset.all.values'}))))}}]),Choices}(React.Component);Choices.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Choices;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),SVGIcon=dynamicRequire('SVGIcon.jsx'),ColorPicker=function(_React$Component){function ColorPicker(){return _classCallCheck(this,ColorPicker),_possibleConstructorReturn(this,(ColorPicker.__proto__||Object.getPrototypeOf(ColorPicker)).apply(this,arguments))}return _inherits(ColorPicker,_React$Component),_createClass(ColorPicker,[{key:'render',value:function render(){var selectedColor=this.getSelectedColor(),colorName=resolveLanguage('nc_casefactory.color.'+selectedColor.colorName),ral=/(RAL\d{4})/.exec(selectedColor.name),colorAndRal=colorName+(ral?' ('+ral[1]+')':'');return React.createElement('div',{className:'lr-casefactory-choices-color-picker color-picker'},React.createElement('strong',{className:'headline'},React.createElement(Mssg,{__key:'nc_casefactory.chosen.color'}),':',React.createElement('br',null),React.createElement('span',{dangerouslySetInnerHTML:{__html:colorAndRal}})),this.hasPolyBoardPanels()?this.getPanels(this.getPolyBoardPanels(),'nc_casefactory.choose.polyboard'):'',this.hasWoodPanels()?this.getPanels(this.getWoodPanels(),'nc_casefactory.choose.birkenmultiplex'):'',this.hasPvcPanels()?this.getPanels(this.getPvcPanels(),'nc_casefactory.choose.wabenkunststoff'):'')}},{key:'getPolyBoardPanels',value:function getPolyBoardPanels(){return this.getColors().filter(function(color){return-1!==color.name.indexOf('Poly-Board')}).sort(function(color1,color2){return color1.id>color2.id?1:-1})}},{key:'getWoodPanels',value:function getWoodPanels(){return this.getColors().filter(function(color){return-1!==color.name.indexOf('Birke')}).sort(function(color1,color2){return color1.id>color2.id?1:-1})}},{key:'getPvcPanels',value:function getPvcPanels(){return this.getColors().filter(function(color){return-1!==color.name.indexOf('Wabenkunststoff')}).sort(function(color1,color2){return color1.id>color2.id?1:-1})}},{key:'getSelectedColor',value:function getSelectedColor(){var _this2=this;return this.getColors().filter(function(color){return color.id==_this2.props.case.PANEL})[0]}},{key:'getColors',value:function getColors(){return this.props.possibleParts.filter(function(possiblePart){return'PANEL'==possiblePart.category})}},{key:'hasPolyBoardPanels',value:function hasPolyBoardPanels(){return this.getPolyBoardPanels().length}},{key:'hasWoodPanels',value:function hasWoodPanels(){return this.getWoodPanels().length}},{key:'hasPvcPanels',value:function hasPvcPanels(){return this.getPvcPanels().length}},{key:'getPanels',value:function getPanels(panels,explanationKey){var _this3=this;return React.createElement('div',null,React.createElement('p',{className:'lr-casefactory-choices-color-picker-explaination explanation'},React.createElement(Mssg,{__key:explanationKey})),React.createElement('div',{className:'lr-casefactory-choices-color-picker-colors-colors colors'},panels.map(function(panel){var classes='lr-casefactory-choices-color-picker-colors-color color'+(_this3.isBright(panel.color)?' bright':'')+(panel.id==_this3.props.case.PANEL?' lr-casefactory-choices-color-picker-colors-color-active active':'');return React.createElement('span',{onClick:function onClick(){_this3.context.emitter.emit('color',panel)},key:panel.id,className:classes,style:{backgroundColor:panel.color}},React.createElement(SVGIcon,{identifier:'haken'}))})))}},{key:'isBright',value:function isBright(color){return'#f5f7f7'===color}}]),ColorPicker}(React.Component);ColorPicker.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=ColorPicker;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Mssg=dynamicRequire('Mssg.jsx'),resolveLanguage=dynamicRequire('resolveLanguage'),DoubledoorRackChooser=__webpack_require__(121),KeyboardChooser=__webpack_require__(122),Alerts=__webpack_require__(123),ExteriorMeasures=__webpack_require__(124),DimensionsChooser=__webpack_require__(125),UnitSwitcher=__webpack_require__(126),Dimensions=function(_React$Component){function Dimensions(){return _classCallCheck(this,Dimensions),_possibleConstructorReturn(this,(Dimensions.__proto__||Object.getPrototypeOf(Dimensions)).apply(this,arguments))}return _inherits(Dimensions,_React$Component),_createClass(Dimensions,[{key:'render',value:function render(){return React.createElement('div',{className:'lr-casefactory-choices-sliders-dimensions dimensions'},this.isKeyboardCase()?'':React.createElement(UnitSwitcher,this.props),React.createElement('strong',{className:'headline'},this.getHeadline()),React.createElement('div',{className:'lr-casefactory-choices-sliders sliders'},this.determineChooser(),this.isKeyboardCase()?'':React.createElement(ExteriorMeasures,this.props),React.createElement(Alerts,this.props)))}},{key:'isKeyboardCase',value:function isKeyboardCase(){return this.props.case.isKeyboardcase}},{key:'getHeadline',value:function getHeadline(){return this.isKeyboardCase()?React.createElement(Mssg,{__key:'nc_casefactory.keyboard'}):React.createElement(Mssg,{__key:'nc_casefactory.size'})}},{key:'isDoubleDoorRack',value:function isDoubleDoorRack(){return this.props.case.isDoubleDoorRack}},{key:'determineChooser',value:function determineChooser(){return this.isKeyboardCase()?React.createElement(KeyboardChooser,this.props):this.isDoubleDoorRack()?React.createElement(DoubledoorRackChooser,this.props):React.createElement(DimensionsChooser,this.props)}}]),Dimensions}(React.Component);Dimensions.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Dimensions;

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Select=dynamicRequire('Select.jsx'),DimensionChooser=__webpack_require__(63),resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),DoubledoorRackChooser=function(_React$Component){function DoubledoorRackChooser(){return _classCallCheck(this,DoubledoorRackChooser),_possibleConstructorReturn(this,(DoubledoorRackChooser.__proto__||Object.getPrototypeOf(DoubledoorRackChooser)).apply(this,arguments))}return _inherits(DoubledoorRackChooser,_React$Component),_createClass(DoubledoorRackChooser,[{key:'render',value:function render(){return React.createElement('div',null,this.getHeightUnitChooser(),this.getChooser('depth'))}},{key:'getHeightUnitChooser',value:function getHeightUnitChooser(){var _this2=this;return React.createElement('div',{className:'lr-casefactory-choices-sliders-dimensions-dimension-select dimension-select'},React.createElement('label',null,React.createElement(Mssg,{__key:'nc_casefactory.height'})),React.createElement(Select,{className:'lr-style',options:this.getHeightUnitOptions(),active:this.props.case.dimensions.interior.height/45,choiceHandler:function choiceHandler(value){_this2.context.emitter.emit('dimensionChange','height_unit',value,!0)}}))}},{key:'getHeightUnitOptions',value:function getHeightUnitOptions(){return this.props.dimensions.height.map(function(height){return{value:height.unit,name:height.unit+' '+resolveLanguage('nc_casefactory.height.units')}})}},{key:'getChooser',value:function getChooser(dimension){var props={start:this.props.case.dimensions.interior[dimension],range:{min:this.props.dimensions[dimension].min,max:this.props.dimensions[dimension].max}};return React.createElement(DimensionChooser,_extends({dimension:dimension},props,{label:'nc_casefactory.'+dimension,isCmMode:this.props.isCmMode}))}}]),DoubledoorRackChooser}(React.Component);DoubledoorRackChooser.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=DoubledoorRackChooser;

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Select=dynamicRequire('Select.jsx'),AccordionTab=dynamicRequire('AccordionTab.jsx'),resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),KeyboardChooser=function(_React$Component){function KeyboardChooser(props,context){_classCallCheck(this,KeyboardChooser);var _this=_possibleConstructorReturn(this,(KeyboardChooser.__proto__||Object.getPrototypeOf(KeyboardChooser)).call(this,props));return _this.state={tabOpen:!!_this.props.case.keyboardBrandAndModel},context.emitter.on('tabOpen',function(group,name){'customKeyboard'==group&&'customKeyboard'==name&&_this.setState({tabOpen:!0})}),context.emitter.on('tabClose',function(group,name){'customKeyboard'==group&&'customKeyboard'==name&&_this.setState({tabOpen:!1})}),_this}return _inherits(KeyboardChooser,_React$Component),_createClass(KeyboardChooser,[{key:'render',value:function render(){return React.createElement('div',null,this.getKeyboardCaseChooser(),this.getCustomKeyboardInput())}},{key:'getKeyboardCaseChooser',value:function getKeyboardCaseChooser(){var _this2=this;return React.createElement('div',{className:'lr-casefactory-choices-keyboard-select keyboard-select'},React.createElement('label',null,React.createElement(Mssg,{__key:'nc_casefactory.keyboard.manufacturer'})),React.createElement(Select,{className:'lr-style',choiceHandler:function choiceHandler(value){_this2.context.emitter.emit('manufacturer',value)},active:this.props.case.keyboardManufacturer,callToAction:resolveLanguage('nc_casefactory.choose.manufacturer'),showCallToAction:!this.props.case.keyboardManufacturer,options:this.getManufacturers().map(function(manufacturer){return{value:manufacturer,name:manufacturer}})}),this.getModels().length?React.createElement('div',null,React.createElement('label',null,React.createElement(Mssg,{__key:'nc_casefactory.keyboard.model'})),React.createElement(Select,{className:'lr-style',key:this.props.case.keyboardManufacturer,choiceHandler:function choiceHandler(value){_this2.context.emitter.emit('keyboard',value)},showCallToAction:!this.props.case.keyboardId,callToAction:resolveLanguage('nc_casefactory.choose.model'),active:this.props.case.keyboardId,options:this.getModels().map(function(model){return{name:model.model,value:model.id}})})):'')}},{key:'getCustomKeyboardInput',value:function getCustomKeyboardInput(){var _this3=this;return React.createElement(AccordionTab,{className:'lr-casefactory-choices-keyboardcases keyboardcases',open:!!this.props.case.keyboardBrandAndModel||this.state.tabOpen,group:'customKeyboard',name:'customKeyboard',duration:200},React.createElement('div',{className:'lr-casefactory-choices-keyboardcases-notfound notfound'},React.createElement(Mssg,{__key:'nc_casefactory.did.not.found.keyboard.header'})),React.createElement('div',null,React.createElement('label',{htmlFor:'keyboardInput'},React.createElement(Mssg,{__key:'nc_casefactory.keyboards.modelandmanufacturer'}),' '),React.createElement('input',{type:'text',name:'keyboardInput',className:'lr-casefactory-choices-customkeyboard customkeyboard',onChange:function onChange(e){_this3.context.emitter.emit('keyboardBrandAndModelChange',e.target.value)},onKeyPress:function onKeyPress(e){'Enter'===e.key&&e.target.blur()},onBlur:function onBlur(e){_this3.context.emitter.emit('keyboardBrandAndModel',e.target.value)},value:this.props.case.keyboardBrandAndModel||''})))}},{key:'getModels',value:function getModels(){var _this4=this;return this.props.keyboards.filter(function(keyboard){return keyboard.manufacturer==_this4.props.case.keyboardManufacturer})}},{key:'getManufacturers',value:function getManufacturers(){return unique(this.props.keyboards.map(function(keyboard){return keyboard.manufacturer})).sort()}}]),KeyboardChooser}(React.Component);function unique(array){return array.filter(function(item,index){return array.indexOf(item)===index})}KeyboardChooser.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=KeyboardChooser;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Mssg=dynamicRequire('Mssg.jsx'),Alerts=function(_React$Component){function Alerts(){return _classCallCheck(this,Alerts),_possibleConstructorReturn(this,(Alerts.__proto__||Object.getPrototypeOf(Alerts)).apply(this,arguments))}return _inherits(Alerts,_React$Component),_createClass(Alerts,[{key:'render',value:function render(){return React.createElement('div',{className:'lr-casefactory-choices-alerts alerts'},React.createElement('div',{className:'lr-casefactory-choices-alert alert',style:this.showDoorWarning()?{display:'block'}:{display:'none'}},React.createElement('span',{className:'lr-casefactory-choices-attention attention'},React.createElement(Mssg,{__key:'nc_casefactory.attention'}),': '),React.createElement(Mssg,{__key:'nc_casefactory.alert.too.big.for.door'})),React.createElement('div',{className:'lr-casefactory-choices-alert alert',style:this.showHeavyWarning()?{display:'block'}:{display:'none'}},React.createElement('span',{className:'lr-casefactory-choices-attention attention'},React.createElement(Mssg,{__key:'nc_casefactory.attention'}),': '),React.createElement(Mssg,{__key:'nc_casefactory.alert.too.heavy.to.carry'})))}},{key:'showHeavyWarning',value:function showHeavyWarning(){return 2e8<this.props.case.dimensions.interior.width*this.props.case.dimensions.interior.height*this.props.case.dimensions.interior.depth}},{key:'showDoorWarning',value:function showDoorWarning(){return 800<this.props.case.dimensions.exterior.width&&800<this.props.case.dimensions.exterior.depth}}]),Alerts}(React.Component);Alerts.contextTypes={},module.exports=Alerts;

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Mssg=dynamicRequire('Mssg.jsx'),ExteriorMeasures=function(_React$Component){function ExteriorMeasures(){return _classCallCheck(this,ExteriorMeasures),_possibleConstructorReturn(this,(ExteriorMeasures.__proto__||Object.getPrototypeOf(ExteriorMeasures)).apply(this,arguments))}return _inherits(ExteriorMeasures,_React$Component),_createClass(ExteriorMeasures,[{key:'render',value:function render(){return React.createElement('p',{className:'lr-casefactory-choices-exterior exterior'},React.createElement(Mssg,{__key:'nc_casefactory.exterior.dimensions'}),':',React.createElement('br',null),React.createElement('span',null,asCm(this.props.case.dimensions.exterior.width)),' ',React.createElement(Mssg,{__key:'nc_casefactory.centimeter'}),' ','x',' ',React.createElement('span',null,asCm(this.props.case.dimensions.exterior.height)),' ',React.createElement(Mssg,{__key:'nc_casefactory.centimeter'}),' ','x',' ',React.createElement('span',null,asCm(this.props.case.dimensions.exterior.depth)),' ',React.createElement(Mssg,{__key:'nc_casefactory.centimeter'}))}}]),ExteriorMeasures}(React.Component);function asCm(mm){return(mm/10).toLocaleString()}ExteriorMeasures.contextTypes={},module.exports=ExteriorMeasures;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),DimensionChooser=__webpack_require__(63),Mssg=dynamicRequire('Mssg.jsx'),DimensionsChooser=function(_React$Component){function DimensionsChooser(){return _classCallCheck(this,DimensionsChooser),_possibleConstructorReturn(this,(DimensionsChooser.__proto__||Object.getPrototypeOf(DimensionsChooser)).apply(this,arguments))}return _inherits(DimensionsChooser,_React$Component),_createClass(DimensionsChooser,[{key:'render',value:function render(){return React.createElement('div',null,this.getChooser('width'),this.getChooser('height'),this.getChooser('depth'))}},{key:'getChooser',value:function getChooser(dimension){var props={start:this.props.case.dimensions.interior[dimension],range:{min:this.props.dimensions[dimension].min,max:this.props.dimensions[dimension].max}};return React.createElement(DimensionChooser,_extends({dimension:dimension},props,{label:'nc_casefactory.'+dimension,isCmMode:this.props.isCmMode}))}}]),DimensionsChooser}(React.Component);DimensionsChooser.contextTypes={},module.exports=DimensionsChooser;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Mssg=dynamicRequire('Mssg.jsx'),UnitSwitcher=function(_React$Component){function UnitSwitcher(){return _classCallCheck(this,UnitSwitcher),_possibleConstructorReturn(this,(UnitSwitcher.__proto__||Object.getPrototypeOf(UnitSwitcher)).apply(this,arguments))}return _inherits(UnitSwitcher,_React$Component),_createClass(UnitSwitcher,[{key:'render',value:function render(){var _this2=this,mmClasses='rs-btn lr-casefactory-choices-sliders-dimensions-unit unit'+(this.props.isCmMode?'':' lr-casefactory-choices-sliders-dimensions-unit-active active'),cmClasses='rs-btn lr-casefactory-choices-sliders-dimensions-unit unit'+(this.props.isCmMode?' lr-casefactory-choices-sliders-dimensions-unit-active active':'');return React.createElement('div',{className:'lr-casefactory-choices-sliders-dimensions-unit-selector unit-selector'},React.createElement('span',{className:cmClasses,onClick:function onClick(){_this2.context.emitter.emit('unitMode','cm')}},React.createElement(Mssg,{__key:'nc_casefactory.centimeter'})),React.createElement('span',{className:mmClasses,onClick:function onClick(){_this2.context.emitter.emit('unitMode','mm')}},'mm'))}}]),UnitSwitcher}(React.Component);UnitSwitcher.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=UnitSwitcher;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),AccordionTab=dynamicRequire('AccordionTab.jsx'),Mssg=dynamicRequire('Mssg.jsx'),SVGIcon=dynamicRequire('SVGIcon.jsx'),Parts=__webpack_require__(128),Wheels=__webpack_require__(129),Foam=__webpack_require__(130),ConfigurationOption=__webpack_require__(131),Accessories=__webpack_require__(132),Options=function(_React$Component){function Options(){return _classCallCheck(this,Options),_possibleConstructorReturn(this,(Options.__proto__||Object.getPrototypeOf(Options)).apply(this,arguments))}return _inherits(Options,_React$Component),_createClass(Options,[{key:'render',value:function render(){var _this2=this;return this.hasNoOptions()?React.createElement('span',null):React.createElement('div',{className:'lr-casefactory-choices-accordion lr-sidebar-accordion choices-accordion sidebar-accordion'},this.getBaseChoices(),React.createElement(AccordionTab,{name:'options',group:'caseconfigurator'},React.createElement('strong',{className:'headline'},React.createElement(Mssg,{__key:'nc_casefactory.options'}),React.createElement(SVGIcon,{identifier:'plus'}),React.createElement(SVGIcon,{identifier:'minus'})),React.createElement('div',{className:'lr-casefactory-choices-options options'},!this.props.case.isKeyboardcase&&this.hasWheels()?React.createElement(Wheels,{isDoubleDoorRack:this.props.case.isDoubleDoorRack,wheelId:this.props.case.WHEEL,wheels:this.getWheels(),key:'wheels'}):'',this.hasFoam()?React.createElement(Foam,{foamId:this.props.case.FOAM,foams:this.getFoams(),key:'foam'}):'',this.props.options.map(function(option){return React.createElement(ConfigurationOption,{case:_this2.props.case,key:option,option:option,conflicts:_this2.props.conflicts,infos:_this2.props.infos,label:_this2.getOptionLabel(option)})}))),this.hasAccessories()?React.createElement(Accessories,this.props):'')}},{key:'hasNoOptions',value:function hasNoOptions(){return this.props.case.isKeyboardcase&&!this.props.options.length&&!this.hasFoam()}},{key:'hasAccessories',value:function hasAccessories(){return this.props.possibleParts.reduce(function(prev,cur){return prev||0===cur.category.indexOf('ACCESSORY')},!1)}},{key:'hasFoam',value:function hasFoam(){return this.getFoams().length}},{key:'getBaseChoices',value:function getBaseChoices(){return this.props.case.isKeyboardcase?'':React.createElement('div',null,this.hasShutters()?React.createElement(Parts,{basePath:this.props.basePath,parts:this.getShutters(),key:'fastener',event:'fastener',title:'nc_casefactory.shutter',id:this.props.case.FASTENER}):'',this.hasGrips()?React.createElement(Parts,{basePath:this.props.basePath,parts:this.getGrips(),key:'handle',event:'handle',title:'nc_casefactory.grip',id:this.props.case.HANDLE}):'',this.hasCorners()?React.createElement(Parts,{basePath:this.props.basePath,parts:this.getCorners(),key:'corners',event:'corners',title:'nc_casefactory.corners',id:this.props.case.CORNER}):'')}},{key:'hasCorners',value:function hasCorners(){return this.getCorners().length}},{key:'hasGrips',value:function hasGrips(){return this.getGrips().length}},{key:'hasShutters',value:function hasShutters(){return this.getShutters().length}},{key:'hasWheels',value:function hasWheels(){return this.getWheels().length}},{key:'isDoubleDoorRack',value:function isDoubleDoorRack(){return this.props.case.isDoubleDoorRack}},{key:'getShutters',value:function getShutters(){return this.props.possibleParts.filter(function(part){return'FASTENER'==part.category})}},{key:'getGrips',value:function getGrips(){return this.props.possibleParts.filter(function(part){return'HANDLE'==part.category})}},{key:'getFoams',value:function getFoams(){return this.props.possibleParts.filter(function(part){return'FOAM'==part.category})}},{key:'getCorners',value:function getCorners(){return this.props.possibleParts.filter(function(part){return'CORNER'==part.category})}},{key:'getWheels',value:function getWheels(){return this.props.possibleParts.filter(function(part){return'WHEEL'==part.category||'ROLL_BOARD'==part.category||'STAND'==part.category})}},{key:'getOptionLabel',value:function getOptionLabel(option){return{STACKABLE:'nc_casefactory.option.stackable',PLAYABLE_IN_CASE:'nc_casefactory.option.in.case.playable',ACCESSORIES_COMPARTMENT:'nc_casefactory.option.accessory.box',TROLLEY_FUNCTION:'nc_casefactory.option.trolley.function',REMOVABLE_CAP:'nc_casefactory.option.cap.removable',LEATHER_HANDLE:'nc_casefactory.option.with.leathergrip',ADDITIONAL_BACK_RACKRAIL:'nc_casefactory.option.back.racks'}[option]}}]),Options}(React.Component);Options.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Options;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),AccordionTab=dynamicRequire('AccordionTab.jsx'),resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),SVGIcon=dynamicRequire('SVGIcon.jsx'),Parts=function(_React$Component){function Parts(){return _classCallCheck(this,Parts),_possibleConstructorReturn(this,(Parts.__proto__||Object.getPrototypeOf(Parts)).apply(this,arguments))}return _inherits(Parts,_React$Component),_createClass(Parts,[{key:'render',value:function render(){var _this2=this;return React.createElement(AccordionTab,{name:this.props.event,group:'caseconfigurator'},React.createElement('strong',{className:'lr-sidebar-accordion-block-title headline'},React.createElement(Mssg,{__key:this.props.title}),React.createElement(SVGIcon,{identifier:'plus'}),React.createElement(SVGIcon,{identifier:'minus'})),React.createElement('div',{className:'lr-casefactory-choices-part-picker part-picker'},this.props.parts.sort(function(part1,part2){return part1.id>part2.id?1:-1}).map(function(part,index){var image=_this2.props.basePath+'/images/partImages/small/'+part.articleNumber+'.jpg',label=part.partName?part.partName:resolveLanguage('nc_casefactory.part.name.'+part.articleNumber),description=part.description?part.description:resolveLanguage('nc_casefactory.part.description.'+part.articleNumber);return React.createElement('div',{className:'lr-casefactory-choices-part-picker-part part',key:part.id},React.createElement('label',{className:'lr-casefactory-choices-part-picker-part-name name'},React.createElement('input',{checked:_this2.props.id==part.id||null===_this2.props.id&&0==index,onChange:function onChange(e){return _this2.context.emitter.emit(_this2.props.event,part,e.target.value)},value:part.id,type:'radio',name:part.category,className:'lr-casefactory-choices-part-picker-part-input input'}),React.createElement('span',{className:'lr-casefactory-choices-part-picker-part-text-label text-label',dangerouslySetInnerHTML:{__html:label}})),React.createElement('label',{className:'lr-casefactory-choices-part-picker-part-image-label image-label'},React.createElement('img',{src:image,className:'lr-casefactory-choices-part-picker-part-image image'})),React.createElement('p',{className:'lr-casefactory-choices-part-picker-part-description description',dangerouslySetInnerHTML:{__html:description}}))})))}}]),Parts}(React.Component);Parts.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Parts;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Select=dynamicRequire('Select.jsx'),Mssg=dynamicRequire('Mssg.jsx'),resolveLanguage=dynamicRequire('resolveLanguage'),Wheels=function(_React$Component){function Wheels(){return _classCallCheck(this,Wheels),_possibleConstructorReturn(this,(Wheels.__proto__||Object.getPrototypeOf(Wheels)).apply(this,arguments))}return _inherits(Wheels,_React$Component),_createClass(Wheels,[{key:'render',value:function render(){var _this2=this,selectKey=this.props.wheels.reduce(function(prev,wheel){return wheel.partName+prev},'');return React.createElement('div',{className:'lr-casefactory-choices-options-option option clearfix'},React.createElement(Mssg,{__key:'nc_casefactory.rolls'}),React.createElement('br',null),React.createElement(Select,{key:selectKey,className:'lr-style',choiceHandler:function choiceHandler(value){_this2.context.emitter.emit('rollsOrWheels',_this2.getWheel(value))},active:this.props.wheelId||'',options:this.getWheelOptions(this.props.wheels)}))}},{key:'getWheelOptions',value:function getWheelOptions(wheels){var options=wheels.map(function(wheel){var label=wheel.partName?wheel.partName:resolveLanguage('nc_casefactory.part.name.'+wheel.articleNumber);return{value:wheel.id,name:label}});return this.props.isDoubleDoorRack||(options=[{name:resolveLanguage('nc_casefactory.no.wheels'),value:''}].concat(_toConsumableArray(options))),options}},{key:'getWheel',value:function getWheel(value){var wheelCandidates=this.props.wheels.filter(function(wheel){return wheel.id==value});return wheelCandidates.length?wheelCandidates[0]:null}}]),Wheels}(React.Component);Wheels.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Wheels;

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Select=dynamicRequire('Select.jsx'),resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),Foam=function(_React$Component){function Foam(){return _classCallCheck(this,Foam),_possibleConstructorReturn(this,(Foam.__proto__||Object.getPrototypeOf(Foam)).apply(this,arguments))}return _inherits(Foam,_React$Component),_createClass(Foam,[{key:'render',value:function render(){var _this2=this,props=this.props,selectKey=this.props.foams.reduce(function(prev,foam){return foam.partName+prev},'');return React.createElement('div',{className:'lr-casefactory-choices-options-option option clearfix'},React.createElement(Mssg,{__key:'nc_casefactory.foam'}),React.createElement('br',null),props.foamId?React.createElement(Mssg,{__key:'nc_casefactory.foam.notice'}):'',React.createElement(Select,{key:selectKey,className:'lr-style',choiceHandler:function choiceHandler(value){_this2.context.emitter.emit('foam',value)},active:props.foamId||'',options:this.getFoamOptions(props.foams)}))}},{key:'getFoamOptions',value:function getFoamOptions(foams){var defaultOption={value:'',name:resolveLanguage('nc_casefactory.no.foam')},foamOptions=foams.map(function(foam){var label=foam.partName?foam.partName:resolveLanguage('nc_casefactory.part.name.'+foam.articleNumber);return{value:foam.id,name:label}});return[defaultOption].concat(_toConsumableArray(foamOptions))}}]),Foam}(React.Component);Foam.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Foam;

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),SVGIcon=dynamicRequire('SVGIcon.jsx'),Option=function(_React$Component){function Option(){return _classCallCheck(this,Option),_possibleConstructorReturn(this,(Option.__proto__||Object.getPrototypeOf(Option)).apply(this,arguments))}return _inherits(Option,_React$Component),_createClass(Option,[{key:'render',value:function render(){var _this2=this;return React.createElement('div',{className:'lr-casefactory-choices-options-option option'+(this.isDisabled(this.props.option)?' disabled':'')},React.createElement('label',null,React.createElement('input',{type:'checkbox',defaultChecked:this.isChecked(this.props.option),disabled:this.isDisabled(this.props.option),onChange:function onChange(e){return!e.target.disabled&&void(e.target.checked=!_this2.isChecked(_this2.props.option),_this2.context.emitter.emit('option',_this2.props.option,_this2.isChecked(_this2.props.option)))},className:'lr-casefactory-choices-part-picker-part-input input'}),React.createElement('span',{className:'lr-casefactory-choices-part-picker-part-input-label-text text-label'},React.createElement(Mssg,{__key:this.props.label})),this.hasInfo(this.props.option)?this.getInfoPopUp():''))}},{key:'getInfoPopUp',value:function getInfoPopUp(){return React.createElement('div',{className:'popup-container'},React.createElement(SVGIcon,{identifier:'info'}),React.createElement('div',{className:'tr-tooltip tr-tooltip-bottom'},React.createElement('div',{className:'tr-tooltip-content'},React.createElement(Mssg,{__key:this.getInfoText(this.props.option)}))))}},{key:'isChecked',value:function isChecked(option){return-1!==this.props.case.options.indexOf(option)}},{key:'isDisabled',value:function isDisabled(option){var conflictedOption=this.props.conflicts[option];return!!(conflictedOption&&this.isChecked(conflictedOption))}},{key:'hasInfo',value:function hasInfo(option){return!!this.getInfoText(option)}},{key:'getInfoText',value:function getInfoText(option){return this.props.infos[option]}}]),Option}(React.Component);Option.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Option;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),PullOutHandle=__webpack_require__(133),Accessory=__webpack_require__(134),AccordionTab=dynamicRequire('AccordionTab.jsx'),Mssg=dynamicRequire('Mssg.jsx'),SVGIcon=dynamicRequire('SVGIcon.jsx'),Accessories=function(_React$Component){function Accessories(){return _classCallCheck(this,Accessories),_possibleConstructorReturn(this,(Accessories.__proto__||Object.getPrototypeOf(Accessories)).apply(this,arguments))}return _inherits(Accessories,_React$Component),_createClass(Accessories,[{key:'render',value:function render(){return React.createElement(AccordionTab,{name:'accessories',group:'caseconfigurator'},React.createElement('strong',{className:'headline'},React.createElement(Mssg,{__key:'nc_casefactory.accessory'}),React.createElement(SVGIcon,{identifier:'plus'}),React.createElement(SVGIcon,{identifier:'minus'})),React.createElement('div',{className:'lr-casefactory-choices-part-picker part-picker'},this.getLabelNotch().length?React.createElement(Accessory,{basePath:this.props.basePath,case:this.props.case,accessory:this.getLabelNotch()}):'',this.getVentilationDish().length?React.createElement(Accessory,{basePath:this.props.basePath,case:this.props.case,accessory:this.getVentilationDish()}):'',this.getPullOutHandle().length?React.createElement(PullOutHandle,{basePath:this.props.basePath,case:this.props.case,accessory:this.getPullOutHandle()}):''))}},{key:'getLabelNotch',value:function getLabelNotch(){return this.props.possibleParts.filter(function(part){return'ACCESSORY_LABEL_NOTCH'==part.category})}},{key:'getVentilationDish',value:function getVentilationDish(){return this.props.possibleParts.filter(function(part){return'ACCESSORY_VENTILATION_DISH'==part.category})}},{key:'getPullOutHandle',value:function getPullOutHandle(){return this.props.possibleParts.filter(function(part){return'ACCESSORY_PULLOUT_HANDLE'==part.category})}}]),Accessories}(React.Component);Accessories.contextTypes={},module.exports=Accessories;

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Select=dynamicRequire('Select.jsx'),resolveLanguage=dynamicRequire('resolveLanguage'),Mssg=dynamicRequire('Mssg.jsx'),PullOutHandle=function(_React$Component){function PullOutHandle(){return _classCallCheck(this,PullOutHandle),_possibleConstructorReturn(this,(PullOutHandle.__proto__||Object.getPrototypeOf(PullOutHandle)).apply(this,arguments))}return _inherits(PullOutHandle,_React$Component),_createClass(PullOutHandle,[{key:'render',value:function render(){var _this2=this,selectKey=this.props.accessory.reduce(function(prev,accessoryItem){return accessoryItem.partName+prev},'');return React.createElement('div',{className:'lr-casefactory-choices-options-option option clearfix'},React.createElement(Mssg,{__key:'nc_casefactory.pullout.handles'}),React.createElement('br',null),React.createElement(Select,{className:'lr-style',key:selectKey,choiceHandler:function choiceHandler(value){return _this2.context.emitter.emit('rollsOrWheels',_this2.getPart(_this2.props.accessory,value))},active:this.props.case.WHEEL,options:this.getOptions()}))}},{key:'getOptions',value:function getOptions(){var defaultOption={value:'',name:resolveLanguage('nc_casefactory.no.pullout.handle')};return[defaultOption].concat(_toConsumableArray(this.props.accessory.map(function(accessoryItem){var label=accessoryItem.partName?accessoryItem.partName:resolveLanguage('nc_casefactory.part.name.'+accessoryItem.articleNumber);return{value:accessoryItem.id,name:label}})))}},{key:'getPart',value:function getPart(parts,id){var candidates=parts.filter(function(part){return part.id==id});return 1==candidates.length?candidates[0]:null}}]),PullOutHandle}(React.Component);PullOutHandle.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=PullOutHandle;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var dynamicRequire=__webpack_require__(5),React=dynamicRequire('react'),Mssg=dynamicRequire('Mssg.jsx'),Accessory=function(_React$Component){function Accessory(){return _classCallCheck(this,Accessory),_possibleConstructorReturn(this,(Accessory.__proto__||Object.getPrototypeOf(Accessory)).apply(this,arguments))}return _inherits(Accessory,_React$Component),_createClass(Accessory,[{key:'render',value:function render(){var _this2=this;return React.createElement('div',null,this.props.accessory.map(function(accessoryItem){var description=accessoryItem.description?accessoryItem.description:React.createElement(Mssg,{__key:'nc_casefactory.part.description.'+accessoryItem.articleNumber}),label=accessoryItem.partName?accessoryItem.partName:React.createElement(Mssg,{__key:'nc_casefactory.part.name.'+accessoryItem.articleNumber}),image=_this2.props.basePath+'/images/partImages/small/'+accessoryItem.articleNumber+'.jpg',type=1<_this2.props.accessory.length?'radio':'checkbox';return React.createElement('div',{className:'lr-casefactory-choices-part-picker-part part',key:accessoryItem.id},React.createElement('label',{className:'lr-casefactory-choices-part-picker-part-name name'},React.createElement('input',{type:type,name:accessoryItem.id,onChange:function onChange(){return _this2.context.emitter.emit('part',accessoryItem,_this2.isAccessoryChecked(accessoryItem))},checked:_this2.isAccessoryChecked(accessoryItem),className:'lr-casefactory-choices-part-picker-part-input input'}),React.createElement('span',{className:'lr-casefactory-choices-part-picker-part-text-label label'},label)),React.createElement('label',{className:'lr-casefactory-choices-part-picker-part-image-label label'},React.createElement('img',{src:image,className:'lr-casefactory-choices-part-picker-part-image image'})),React.createElement('p',{className:'lr-casefactory-choices-part-picker-part-description description'},description))}))}},{key:'isAccessoryChecked',value:function isAccessoryChecked(accessoryItem){return-1!==values(this.props.case.accessories).indexOf(accessoryItem.id)}}]),Accessory}(React.Component);function values(object){return Object.keys(object).map(function(key){return object[key]})}Accessory.contextTypes={emitter:React.PropTypes.object.isRequired},module.exports=Accessory;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(137);
var ReactElement = __webpack_require__(18);

var emptyFunction = __webpack_require__(10);
var traverseAllChildren = __webpack_require__(138);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(22);

var invariant = __webpack_require__(0);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(22);

var ReactCurrentOwner = __webpack_require__(13);
var REACT_ELEMENT_TYPE = __webpack_require__(68);

var getIteratorFn = __webpack_require__(139);
var invariant = __webpack_require__(0);
var KeyEscapeUtils = __webpack_require__(140);
var warning = __webpack_require__(2);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(18);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(18),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(69);

module.exports = factory(isValidElement);

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(144);
var assign = __webpack_require__(3);

var ReactPropTypesSecret = __webpack_require__(146);
var has = __webpack_require__(147);
var checkPropTypes = __webpack_require__(148);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(145);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(65),
    Component = _require.Component;

var _require2 = __webpack_require__(18),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(66);
var factory = __webpack_require__(151);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(22);

var ReactElement = __webpack_require__(18);

var invariant = __webpack_require__(0);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),PropTypes=React.PropTypes,_require=__webpack_require__(71),cancelAnimationFrame=_require.cancelAnimationFrame,requestAnimationFrame=_require.requestAnimationFrame,AccordionTab=function(_React$Component){function AccordionTab(props,context){_classCallCheck(this,AccordionTab);var _this=_possibleConstructorReturn(this,(AccordionTab.__proto__||Object.getPrototypeOf(AccordionTab)).call(this,props));if(!props.children||2!=props.children.length)throw new Error('Accordion tab must have exactly 2 children!');return _this.animation={height:{start:null,end:null},paddingTop:{start:null,end:null},paddingBottom:{start:null,end:null},startTime:null,initialFrame:!1},_this.state=_this.getDefaultComponentState(props),_this.group=_this.props.group||Math.random(),_this.currentAnimation=null,_this.handleHeadlineClick=_this.handleHeadlineClick.bind(_this),_this.animateExpand=_this.animateExpand.bind(_this),_this.animateCollapse=_this.animateCollapse.bind(_this),_this.handleOtherTabOpen=_this.handleOtherTabOpen.bind(_this),context.emitter.on('tabOpen',_this.handleOtherTabOpen),_this}return _inherits(AccordionTab,_React$Component),_createClass(AccordionTab,[{key:'componentWillUnmount',value:function componentWillUnmount(){cancelAnimationFrame(this.currentAnimation),this.context.emitter.removeListener('tabOpen',this.handleOtherTabOpen)}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){this.state.open!=nextProps.open&&void 0!==nextProps.open&&(nextProps.open?this.expand():this.collapse())}},{key:'getDefaultComponentState',value:function getDefaultComponentState(props){return{open:props.open,animationInProgress:!1,animation:{height:null,paddingTop:null,paddingBottom:null}}}},{key:'render',value:function render(){var classNames=this.props.className?this.props.className:' lr-components-accordion-tab';return React.createElement('div',{className:classNames},this.showChildren())}},{key:'handleOtherTabOpen',value:function handleOtherTabOpen(group,name){group==this.group&&name!=this.props.name&&this.state.open&&this.collapse()}},{key:'collapse',value:function collapse(){this.context.emitter.emit('tabClose',this.group,this.props.name),cancelAnimationFrame(this.currentAnimation),this.setState({animationInProgress:!0,open:!1}),this.animation.initialFrame=!0,this.currentAnimation=requestAnimationFrame(this.animateCollapse)}},{key:'expand',value:function expand(){this.context.emitter.emit('tabOpen',this.group,this.props.name),cancelAnimationFrame(this.currentAnimation),this.setState({animationInProgress:!0,open:!0}),this.animation.initialFrame=!0,this.currentAnimation=requestAnimationFrame(this.animateExpand)}},{key:'handleHeadlineClick',value:function handleHeadlineClick(){this.state.open?this.collapse():this.expand()}},{key:'showChildren',value:function showChildren(){var _this2=this,Headline=this.props.children[0].type,Body=this.props.children[1].type,animationStyle=this.state.animationInProgress?{height:this.state.animation.height,overflow:'hidden',display:'block',paddingTop:this.state.animation.paddingTop,paddingBottom:this.state.animation.paddingBottom}:{display:this.state.open?'block':'none'};return[React.createElement(Headline,_extends({},this.props.children[0].props,{className:(this.state.open?'open ':'')+(this.props.children[0].props.className||''),key:'headline',onClick:this.handleHeadlineClick}),this.props.children[0].props.children),React.createElement(Body,_extends({},this.props.children[1].props,{style:animationStyle,key:'body',ref:function ref(_ref){return _this2.body=_ref}}),this.props.children[1].props.children)]}},{key:'animateExpand',value:function animateExpand(time){var finalStyles=this.getFinalExpandStyles(),finalHeight=finalStyles.finalHeight,finalPaddingTop=finalStyles.finalPaddingTop,finalPaddingBottom=finalStyles.finalPaddingBottom,startTime=this.getStartTime(time),progress=this.getProgress(time),_getProgressExpandSty=this.getProgressExpandStyles(progress,finalStyles),newHeight=_getProgressExpandSty.newHeight,newPaddingBottom=_getProgressExpandSty.newPaddingBottom,newPaddingTop=_getProgressExpandSty.newPaddingTop;1>progress?(this.setState({open:!0,animationInProgress:!0,animation:{height:newHeight,paddingTop:newPaddingTop,paddingBottom:newPaddingBottom}}),this.animation={height:{start:0,end:finalHeight},paddingTop:{start:0,end:finalPaddingTop},paddingBottom:{start:0,end:finalPaddingBottom},startTime:startTime,initialFrame:!1},this.currentAnimation=requestAnimationFrame(this.animateExpand)):(this.setState(this.getDefaultComponentState({open:!0})),this.context.emitter.emit('tabOpenAnimationEnd',this.group,this.props.name))}},{key:'getProgressExpandStyles',value:function getProgressExpandStyles(progress,finalStyles){var finalHeight=finalStyles.finalHeight,finalPaddingTop=finalStyles.finalPaddingTop,finalPaddingBottom=finalStyles.finalPaddingBottom,newHeight=this.getValueByProgress(progress,0,finalHeight),newPaddingBottom=this.getValueByProgress(progress,0,finalPaddingBottom),newPaddingTop=this.getValueByProgress(progress,0,finalPaddingTop);return{newHeight:newHeight,newPaddingBottom:newPaddingBottom,newPaddingTop:newPaddingTop}}},{key:'getFinalExpandStyles',value:function getFinalExpandStyles(){var finalHeight=this.animation.height.end,finalPaddingTop=this.animation.paddingTop.end,finalPaddingBottom=this.animation.paddingBottom.end,initialFrame=this.animation.initialFrame;return initialFrame&&(this.body.style.display='block',finalHeight=this.body.getBoundingClientRect().height,finalPaddingTop=parseFloat(getComputedStyle(this.body,null).getPropertyValue('padding-top')),finalPaddingBottom=parseFloat(getComputedStyle(this.body,null).getPropertyValue('padding-bottom'))),{finalHeight:finalHeight,finalPaddingTop:finalPaddingTop,finalPaddingBottom:finalPaddingBottom}}},{key:'animateCollapse',value:function animateCollapse(time){var startTime=this.getStartTime(time),progress=this.getProgress(time),initialStyles=this.getInitialCollapseStyle(),initialHeight=initialStyles.initialHeight,initialPaddingTop=initialStyles.initialPaddingTop,initialPaddingBottom=initialStyles.initialPaddingBottom,_getProgressCollapseS=this.getProgressCollapseStyles(progress,initialStyles),newHeight=_getProgressCollapseS.newHeight,newPaddingTop=_getProgressCollapseS.newPaddingTop,newPaddingBottom=_getProgressCollapseS.newPaddingBottom;1>progress?(this.setState({open:!1,animationInProgress:!0,animation:{height:newHeight,paddingTop:newPaddingTop,paddingBottom:newPaddingBottom}}),this.animation={height:{end:0,start:initialHeight},paddingTop:{end:0,start:initialPaddingTop},paddingBottom:{end:0,start:initialPaddingBottom},startTime:startTime,initialFrame:!1},this.currentAnimation=requestAnimationFrame(this.animateCollapse)):(this.setState(this.getDefaultComponentState({open:!1})),this.context.emitter.emit('tabCloseAnimationEnd',this.group,this.props.name))}},{key:'getProgressCollapseStyles',value:function getProgressCollapseStyles(progress,initialStyles){var initialHeight=initialStyles.initialHeight,initialPaddingTop=initialStyles.initialPaddingTop,initialPaddingBottom=initialStyles.initialPaddingBottom,newHeight=this.getValueByProgress(progress,initialHeight,0),newPaddingTop=this.getValueByProgress(progress,initialPaddingTop,0),newPaddingBottom=this.getValueByProgress(progress,initialPaddingBottom,0);return{newHeight:newHeight,newPaddingTop:newPaddingTop,newPaddingBottom:newPaddingBottom}}},{key:'getInitialCollapseStyle',value:function getInitialCollapseStyle(){var height=this.body.getBoundingClientRect().height,initialFrame=this.animation.initialFrame,initialHeight=initialFrame?height:this.animation.height.start,initialPaddingTop=initialFrame?parseFloat(getComputedStyle(this.body,null).getPropertyValue('padding-top')):this.animation.paddingTop.start,initialPaddingBottom=initialFrame?parseFloat(getComputedStyle(this.body,null).getPropertyValue('padding-bottom')):this.animation.paddingBottom.start;return{initialHeight:initialHeight,initialPaddingTop:initialPaddingTop,initialPaddingBottom:initialPaddingBottom}}},{key:'getValueByProgress',value:function getValueByProgress(progress,initialHeight,finalHeight){return initialHeight<finalHeight?finalHeight*progress:initialHeight*(1-progress)}},{key:'getProgress',value:function getProgress(time){var startTime=this.getStartTime(time);return Math.min(1,(time-startTime)/this.props.duration)}},{key:'getStartTime',value:function getStartTime(time){var initialFrame=this.animation.initialFrame;return initialFrame?time:this.animation.startTime}}]),AccordionTab}(React.Component);AccordionTab.contextTypes={emitter:PropTypes.object.isRequired},AccordionTab.defaultProps={duration:400},module.exports=AccordionTab;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _POSITION,_DIMENSION,_slicedToArray=function(){function sliceIterator(arr,i){var _arr=[],_n=!0,_d=!1,_e=void 0;try{for(var _s,_i=arr[Symbol.iterator]();!(_n=(_s=_i.next()).done)&&(_arr.push(_s.value),!(i&&_arr.length===i));_n=!0);}catch(err){_d=!0,_e=err}finally{try{!_n&&_i['return']&&_i['return']()}finally{if(_d)throw _e}}return _arr}return function(arr,i){if(Array.isArray(arr))return arr;if(Symbol.iterator in Object(arr))return sliceIterator(arr,i);throw new TypeError('Invalid attempt to destructure non-iterable instance')}}(),_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_Transition=__webpack_require__(155),_Transition2=_interopRequireDefault(_Transition);Object.defineProperty(exports,'__esModule',{value:!0}),exports.Slider=void 0;function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _defineProperty(obj,key,value){return key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++)arr2[i]=arr[i];return arr2}return Array.from(arr)}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),PropTypes=React.PropTypes,compose=__webpack_require__(72),RangeSlider=function(_React$Component){function RangeSlider(){_classCallCheck(this,RangeSlider);var _this=_possibleConstructorReturn(this,(RangeSlider.__proto__||Object.getPrototypeOf(RangeSlider)).call(this));return _this.state={dragging:!1},_this.handles=[],_this.boundary=null,_this.offset=0,_this.rect={},_this.locked=[],_this}var _NumberNEGATIVE_INFINITY=Number.NEGATIVE_INFINITY,_Mathlog=Math.log,_Mathround=Math.round,_Mathmax=Math.max,_Mathmin=Math.min;return _inherits(RangeSlider,_React$Component),_createClass(RangeSlider,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(){this.state.dragging||this._reinitialize()}},{key:'componentDidMount',value:function componentDidMount(){var _this2=this,onMount=this.props.onMount,handles=this.handles;this._boundary(),onMount&&onMount(handles.map(function(handle,id){return _this2._calculate(id,handle)}))}},{key:'_onDrag',value:function _onDrag(id,event,click,touching){var _props=this.props,onDrag=_props.onDrag,snap=_props.snap,handles=this.handles,position=this._move(id,event,click,touching);snap&&(position=this._snap(id)),this.setState({dragging:!0});var ratios=this._calculate(id,position);return onDrag&&onDrag(ratios),handles[id].left=position.left,handles[id].top=position.top,this.handles=handles,{position:position,ratio:ratios[id]}}},{key:'_onStop',value:function _onStop(id){var onRelease=this.props.onRelease,handles=this.handles;return this.setState({dragging:!1}),onRelease&&onRelease(this._calculate(id,handles[id])),this.handles=handles,handles[id]}},{key:'_onUpdate',value:function _onUpdate(id,rect){var handles=this.handles;handles[id]=rect,this.handles=handles,this.forceUpdate()}},{key:'_onResize',value:function _onResize(){this._reinitialize(),this._boundary(),this.forceUpdate()}},{key:'_boundary',value:function _boundary(){var parent=this.refs.parent,axis=this.props.axis,handles=this.handles,_window$getComputedSt=window.getComputedStyle(parent),width=_window$getComputedSt.width,height=_window$getComputedSt.height;this.rect={width:parseInt(width),height:parseInt(height)},this.offset=handles.reduce(function(prev,handle){return prev+=handle[Constants.DIMENSION[axis]]},0),this.boundary=handles.reduce(function(prev,handle){return prev-handle[Constants.DIMENSION[axis]]},this.rect[Constants.DIMENSION[axis]])}},{key:'_calculate',value:function _calculate(id,position){var handles=this.handles,boundary=this.boundary,_props2=this.props,axis=_props2.axis,relative=_props2.relative,precision=_props2.precision,range=_props2.range,func=_props2.func;return handles.map(function(item,i){var max,ratio,min=0;if(null!=handles[i-1]&&relative&&(min=handles[i-1][Constants.POSITION[axis]]),max=i==id?position[Constants.POSITION[axis]]:handles[i][Constants.POSITION[axis]],ratio=100/boundary*(max-min),range){var _min=_Mathmin.apply(Math,_toConsumableArray(range)),_max=_Mathmax.apply(Math,_toConsumableArray(range));ratio=func(ratio,_min,_max)}if(null!=precision&&0<=precision)ratio=parseFloat(ratio).toFixed(precision);else if(0>precision){var factor=Math.pow(10,-precision);ratio=_Mathround(parseFloat(ratio)/factor)*factor}return ratio})}},{key:'_move',value:function _move(id,event,click,touching){var axis=this.props.axis,handles=this.handles,left=handles[id].left,top=handles[id].top;touching&&(event=event.touches[0]),axis==RangeSlider.Axis.X&&event&&(left=event.clientX-click[Constants.POSITION[axis]]),axis==RangeSlider.Axis.Y&&event&&(top=event.clientY-click[Constants.POSITION[axis]]);var _clamp2=this._clamp(id,left,top),_clamp3=_slicedToArray(_clamp2,2);return left=_clamp3[0],top=_clamp3[1],handles[id].left=left,handles[id].top=top,this.handles=handles,{left:left,top:top}}},{key:'_reinitialize',value:function _reinitialize(){this.locked=[]}},{key:'_snap',value:function _snap(id){var _this3=this,handles=this.handles,rect=this.rect,offset=this.offset,_props3=this.props,points=_props3.points,axis=_props3.axis,total=rect[Constants.DIMENSION[axis]];offset/=handles.length,total-=offset;var min=_Mathmin.apply(Math,_toConsumableArray(points)),max=_Mathmax.apply(Math,_toConsumableArray(points));return handles.forEach(function(handle,i){var pointer=handle[Constants.POSITION[axis]],dest=[].concat(points).sort(function(a,b){var _Mathabs=Math.abs;return a=total*(a-min)/(max-min),b=total*(b-min)/(max-min),_Mathabs(a-pointer)-_Mathabs(b-pointer)}).shift();handles[i][Constants.POSITION[axis]]=total*(dest-min)/(max-min),_this3.handles=handles}),this.handles[id]}},{key:'_clamp',value:function _clamp(id,left,top){var _max2,_min2,handles=this.handles,rect=this.rect,_props4=this.props,axis=_props4.axis,grid=_props4.grid;if(grid){var _grid2=this._grid(grid,left,top),_grid3=_slicedToArray(_grid2,2);left=_grid3[0],top=_grid3[1]}var max=(_max2={},_defineProperty(_max2,RangeSlider.Axis.X,rect.width),_defineProperty(_max2,RangeSlider.Axis.Y,rect.height),_max2),min=(_min2={},_defineProperty(_min2,RangeSlider.Axis.X,0),_defineProperty(_min2,RangeSlider.Axis.Y,0),_min2);return max[axis]=null==handles[id+1]?handles.reduce(function(p,handle){return p-handle[Constants.DIMENSION[axis]]},max[axis]):handles[id+1][Constants.POSITION[axis]],null!=handles[id-1]&&(min[axis]=handles[id-1][Constants.POSITION[axis]]),[_Mathmax(_Mathmin(left,max[RangeSlider.Axis.X]),min[RangeSlider.Axis.X]),_Mathmax(_Mathmin(top,max[RangeSlider.Axis.Y]),min[RangeSlider.Axis.Y])]}},{key:'_grid',value:function _grid(grid,left,top){var _grid4=_slicedToArray(grid,2),a=_grid4[0],b=_grid4[1];return[_Mathround(left/a)*a,_Mathround(top/b)*b]}},{key:'_waypoints',value:function _waypoints(){var _props5=this.props,points=_props5.points,axis=_props5.axis,func=_props5.func,handles=this.handles,rect=this.rect,offset=this.offset;if(!points||2>points.length||0==handles.length)return[];var total=rect[Constants.DIMENSION[axis]]-1;offset/=handles.length,total-=offset;var min=_Mathmin.apply(Math,_toConsumableArray(points)),max=_Mathmax.apply(Math,_toConsumableArray(points)),waypoints=[],pool=[];return points.filter(function(point,i,s){return i==s.indexOf(parseInt(point))}).forEach(function(point){var position=0;if(func==RangeSlider.Function.LINEAR)position=total/100*(100/(max-min)*(point-min));else if(func==RangeSlider.Function.LOGARITHMIC){var minv=_Mathlog(min);minv=_NumberNEGATIVE_INFINITY==minv?0:minv;var maxv=_Mathlog(max);position=total*(_Mathlog(point)-minv)/(maxv-minv),position=_NumberNEGATIVE_INFINITY==position?0:position}else position=func(point,min,max);var lookup=_Mathround(position);0>pool.indexOf(lookup)&&waypoints.push(React.createElement('div',{className:'rangeslider-waypoint',key:'waypoint'+point,style:_defineProperty({},Constants.POSITION[axis],position+'px')})),pool.push(lookup)}),waypoints}},{key:'_position',value:function _position(id,val){var boundary=this.boundary,_props6=this.props,points=_props6.points,range=_props6.range,func=_props6.func,max=boundary,min=0;if(points&&(max=_Mathmax.apply(Math,_toConsumableArray(points)),min=_Mathmin.apply(Math,_toConsumableArray(points))),range&&(max=_Mathmax.apply(Math,_toConsumableArray(range)),min=_Mathmin.apply(Math,_toConsumableArray(range))),val=_Mathmin(_Mathmax(val,min),max),this.locked[id]=!0,func==RangeSlider.Function.LOGARITHMIC){var minv=_Mathlog(min);minv=_NumberNEGATIVE_INFINITY==minv?0:minv;var maxv=_Mathlog(max),scale=(maxv-minv)/100;return boundary/100*(_Mathlog(val)-minv)/scale}return boundary*(100/(max-min)*((val-min)/100))}},{key:'_bars',value:function _bars(){var axis=this.props.axis,handles=this.handles,bars=[];if(1==handles.length){var _ref2,handle=handles[0],dim=handle[Constants.POSITION[axis]];bars.push(React.createElement('div',{className:'rangeslider-bar',key:0,style:(_ref2={},_defineProperty(_ref2,Constants.POSITION[axis],'0px'),_defineProperty(_ref2,Constants.DIMENSION[axis],dim+'px'),_ref2)}))}else for(var prev=0,i=0;i<=handles.length-2;i++){var _ref3,left=handles[i],right=handles[i+1],self=left[Constants.DIMENSION[axis]];prev+=.5*self;var pos=left[Constants.POSITION[axis]]+prev-.5*self;prev+=.5*self;var _dim=right[Constants.POSITION[axis]]-pos+prev;bars.push(React.createElement('div',{className:'rangeslider-bar',key:i,style:(_ref3={},_defineProperty(_ref3,Constants.POSITION[axis],pos+'px'),_defineProperty(_ref3,Constants.DIMENSION[axis],_dim+'px'),_ref3)}))}return bars}},{key:'_sliders',value:function _sliders(){var _this4=this,_props7=this.props,axis=_props7.axis,children=_props7.children,boundary=this.boundary,locked=this.locked,position='',i=0;return React.Children.map(children,function(child){position=0==i&&0!=children.length-1?'first':i==children.length-1&&0!=children.length-1?'last':'';var value=child.props.value||child.props.initial;return value=value&&boundary&&null==locked[i]?_this4._position(i,value):null,React.cloneElement(child,{id:i++,axis:axis,value:value,position:position,onUpdate:function onUpdate(id,dimension){return _this4._onUpdate(id,dimension)},onDrag:function onDrag(id,event,click,touching){return _this4._onDrag(id,event,click,touching)},onStop:function onStop(id){return _this4._onStop(id)},onResize:function onResize(id){return _this4._onResize(id)}})})}},{key:'render',value:function render(){var handles=this.handles,offset=this.offset,_props8=this.props,axis=_props8.axis,className=_props8.className,show=_props8.show,bars=-1<show.indexOf(RangeSlider.Show.BARS)&&this._bars(),waypoints=-1<show.indexOf(RangeSlider.Show.WAYPOINTS)&&this._waypoints(),sliders=this._sliders();return className=compose(className,'rangeslider',{horizontal:axis==RangeSlider.Axis.X,vertical:axis==RangeSlider.Axis.Y}),React.createElement('div',{className:className,ref:'parent'},React.createElement('div',{className:'rangeslider-rail',style:{width:'calc(100% - '+offset/handles.length+'px)',left:offset/handles.length/2+'px'}},waypoints&&React.createElement(_Transition2.default,{children:waypoints,monitor:waypoints.length}),bars),sliders)}}]),RangeSlider}(React.Component),Slider=function(_React$Component2){function Slider(){_classCallCheck(this,Slider);var _this5=_possibleConstructorReturn(this,(Slider.__proto__||Object.getPrototypeOf(Slider)).call(this));return _this5._onDragEndListener=_this5._onDragEnd.bind(_this5),_this5._onDragListener=_this5._onDrag.bind(_this5),_this5._onDragStartListener=_this5._onDragStart.bind(_this5),_this5._onResizeListener=_this5._onResize.bind(_this5),_this5.handleEvents={},_this5.state={dragging:!1,touching:!1,left:'0px',top:'0px',rect:{},click:{}},_this5}return _inherits(Slider,_React$Component2),_createClass(Slider,[{key:'componentDidMount',value:function componentDidMount(){this._addEvent(this.refs.element,Event.MOUSEDOWN,this._onDragStartListener,!1,!0),this._addEvent(this.refs.element,Event.TOUCHSTART,this._onDragStartListener,!1,!0),this._addEvent(window,Event.RESIZE,this._onResizeListener,!1,!0);var _props9=this.props,id=_props9.id,onUpdate=_props9.onUpdate,rect=this._getRect();onUpdate(id,rect)}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){null!=props.value&&this._setPosition(props.value)}},{key:'_setPosition',value:function _setPosition(pos){var _props10=this.props,axis=_props10.axis,onUpdate=_props10.onUpdate,id=_props10.id;this.setState(_defineProperty({},Constants.POSITION[axis],pos+'px'));var rect=this._getRect();rect[Constants.POSITION[axis]]=pos,onUpdate(id,rect)}},{key:'componentWillUnmount',value:function componentWillUnmount(){this._clearEvents(!0)}},{key:'_addEvent',value:function _addEvent(node,event,handler,options){var permanent=!!(4<arguments.length&&void 0!==arguments[4])&&arguments[4];this.handleEvents[event]={permanent:permanent,remove:function remove(){node.removeEventListener(event,handler)}},node.addEventListener(event,handler,options||!1)}},{key:'_clearEvents',value:function _clearEvents(){var _this6=this,all=!!(0<arguments.length&&void 0!==arguments[0])&&arguments[0];Object.keys(this.handleEvents).forEach(function(key){var event=_this6.handleEvents[key];(!event.permanent||all)&&(event.remove(),delete _this6.handleEvents[key])})}},{key:'_onDragStart',value:function _onDragStart(e){var touching=e.touches;if(e.button==MouseLeft||touching){e.preventDefault(),this._addEvent(document,Event.MOUSEUP,this._onDragEndListener),this._addEvent(document,Event.TOUCHEND,this._onDragEndListener),this._addEvent(document,Event.MOUSEMOVE,this._onDragListener),this._addEvent(document,Event.TOUCHMOVE,this._onDragListener);var rect=this._getRect();touching&&(e=e.touches[0]),this.setState({dragging:!0,touching:touching,click:{left:e.clientX-rect.left,top:e.clientY-rect.top},rect:rect})}}},{key:'_onDrag',value:function _onDrag(e){var _props11=this.props,onDrag=_props11.onDrag,onChange=_props11.onChange,id=_props11.id,_state=this.state,dragging=_state.dragging,click=_state.click,touching=_state.touching;if(dragging){var _onDrag2=onDrag(id,e,click,touching),_onDrag2$position=_onDrag2.position,left=_onDrag2$position.left,top=_onDrag2$position.top,ratio=_onDrag2.ratio;onChange&&onChange(ratio),this.setState({left:left+'px',top:top+'px'})}}},{key:'_onDragEnd',value:function _onDragEnd(){var _props12=this.props,onStop=_props12.onStop,id=_props12.id,_onStop2=onStop(id),left=_onStop2.left,top=_onStop2.top;this.setState({left:left+'px',top:top+'px'}),this._clearEvents(),this.setState({dragging:!1})}},{key:'_onResize',value:function _onResize(){var _props13=this.props,onResize=_props13.onResize,onChange=_props13.onChange,initial=_props13.initial,id=_props13.id;onChange&&initial&&onChange(initial),onResize(id)}},{key:'_getRect',value:function _getRect(){var element=this.refs.element,_window$getComputedSt2=window.getComputedStyle(element),width=_window$getComputedSt2.width,height=_window$getComputedSt2.height,top=_window$getComputedSt2.top,left=_window$getComputedSt2.left;return{top:parseInt(top),left:parseInt(left),width:parseInt(width),height:parseInt(height)}}},{key:'render',value:function render(){var _props14=this.props,children=_props14.children,className=_props14.className,position=_props14.position,_state2=this.state,left=_state2.left,top=_state2.top;return className=compose('rangeslider-handle',className,_defineProperty({},position,position)),React.createElement('div',{className:className,ref:'element',style:{left:left,top:top},children:children})}}]),Slider}(React.Component);RangeSlider.Axis={X:'x',Y:'y'},RangeSlider.Show={BARS:'bars',WAYPOINTS:'waypoints'},RangeSlider.Function={LINEAR:function LINEAR(v,x,y){return(y-x)*v/100+x},LOGARITHMIC:function LOGARITHMIC(v,x,y){var _Mathlog2=Math.log,m=3<arguments.length&&void 0!==arguments[3]?arguments[3]:0,n=4<arguments.length&&void 0!==arguments[4]?arguments[4]:100;return x=_Mathlog2(x),x=Number.NEGATIVE_INFINITY==x?0:x,Math.exp(x+(_Mathlog2(y)-x)/(n-m)*(v-m))}},RangeSlider.defaultProps={axis:RangeSlider.Axis.X,func:RangeSlider.Function.LINEAR,show:[]},RangeSlider.propTypes={axis:React.PropTypes.any,grid:React.PropTypes.any,snap:React.PropTypes.bool,show:React.PropTypes.oneOfType([React.PropTypes.array,React.PropTypes.string]),onDrag:React.PropTypes.func,onRelease:React.PropTypes.func,onUpdate:React.PropTypes.func,range:React.PropTypes.array,points:React.PropTypes.array,relative:React.PropTypes.bool,precision:React.PropTypes.number,func:React.PropTypes.func},Slider.propTypes={onChange:React.PropTypes.func,value:React.PropTypes.oneOfType([React.PropTypes.string,React.PropTypes.number]),initial:React.PropTypes.oneOfType([React.PropTypes.string,React.PropTypes.number])};var Constants={POSITION:(_POSITION={},_defineProperty(_POSITION,RangeSlider.Axis.X,'left'),_defineProperty(_POSITION,RangeSlider.Axis.Y,'top'),_POSITION),DIMENSION:(_DIMENSION={},_defineProperty(_DIMENSION,RangeSlider.Axis.X,'width'),_defineProperty(_DIMENSION,RangeSlider.Axis.Y,'height'),_DIMENSION)},MouseLeft=0,Event={MOUSEDOWN:'mousedown',MOUSEUP:'mouseup',MOUSEMOVE:'mousemove',TOUCHSTART:'touchstart',TOUCHEND:'touchend',TOUCHMOVE:'touchmove',RESIZE:'resize'};exports.default=RangeSlider,exports.Slider=Slider;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _Transition$Presets,_typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();Object.defineProperty(exports,'__esModule',{value:!0});function _defineProperty(obj,key,value){return key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),_require=__webpack_require__(71),requestAnimationFrame=_require.requestAnimationFrame,cancelAnimationFrame=_require.cancelAnimationFrame,Transition=function(_React$Component){function Transition(props){_classCallCheck(this,Transition);var _this=_possibleConstructorReturn(this,(Transition.__proto__||Object.getPrototypeOf(Transition)).call(this,props));return _this.frame=null,_this.state={active:props.active},_this}return _inherits(Transition,_React$Component),_createClass(Transition,[{key:'componentDidMount',value:function componentDidMount(){var initial=this.props.initial;initial&&this._execute()}},{key:'componentDidUpdate',value:function componentDidUpdate(nextProps){var monitor=this.props.monitor;null==monitor||this._deepEqual(monitor,nextProps.monitor)||this._execute()}},{key:'componentWillUnmount',value:function componentWillUnmount(){this.setState({active:!1})}},{key:'_deepEqual',value:function _deepEqual(x,y){var _this2=this;return x&&y&&'object'===('undefined'==typeof x?'undefined':_typeof(x))&&'object'===('undefined'==typeof y?'undefined':_typeof(y))?Object.keys(x).length===Object.keys(y).length&&Object.keys(x).reduce(function(isEqual,key){return isEqual&&_this2._deepEqual(x[key],y[key])},!0):x===y}},{key:'_execute',value:function _execute(){null!=this.refs.transition&&this.props.active&&this._animate(Transition.Type.FADEIN)}},{key:'_animate',value:function _animate(animation){var _this3=this,_props$callback=this.props.callback,callback=void 0===_props$callback?function(){}:_props$callback,active=this.props.active;if(active){var preset=Transition.Presets[animation];Object.keys(this.props).map(function(key){preset[key]=_this3.props[key]||preset[key]});var linear=function(a,b,value,factor){return null==factor&&(factor=1),a<b?value+=speed*factor:value-=speed*factor,value},_props=this.props,speed=_props.speed,display=_props.display,transition=this.refs.transition;transition.style[preset.property]=preset.from+preset.unit,transition.style.display=display||'block';var tick=function(){var next=parseFloat(transition.style[preset.property]);next=linear(preset.from,preset.to,next),active&&next>=preset.to&&next<=preset.from||next<=preset.to&&next>=preset.from?(transition.style[preset.property]=next+preset.unit,_this3.frame=requestAnimationFrame(tick)):(cancelAnimationFrame(_this3.frame),transition.style[preset.property]=preset.to+preset.unit,callback&&callback(animation))};tick()}}},{key:'render',value:function render(){var _props2=this.props,children=_props2.children,style=_props2.style;return style=style||{},React.createElement('div',{style:style,className:'transition',ref:'transition',children:children})}}]),Transition}(React.Component);exports.default=Transition,Transition.Easing={},Transition.Type={FADEIN:'fade-in',FADEOUT:'fade-out'},Transition.Presets=(_Transition$Presets={},_defineProperty(_Transition$Presets,Transition.Type.FADEIN,{property:'opacity',from:0,to:1,unit:''}),_defineProperty(_Transition$Presets,Transition.Type.FADEOUT,{property:'opacity',from:1,to:0,unit:''}),_Transition$Presets),Transition.Speed={SLOW:.001,NORMAL:.075,FAST:.2},Transition.propTypes={speed:React.PropTypes.oneOf(Object.keys(Transition.Speed).map(function(key){return Transition.Speed[key]})),type:React.PropTypes.oneOf(Object.keys(Transition.Type).map(function(key){return Transition.Type[key]})),monitor:React.PropTypes.any,callback:React.PropTypes.func,continuous:React.PropTypes.bool,initial:React.PropTypes.bool,active:React.PropTypes.bool,display:React.PropTypes.string,style:React.PropTypes.object,sequential:React.PropTypes.bool},Transition.defaultProps={speed:Transition.Speed.NORMAL,type:Transition.Type.FADEIN,callback:function callback(){},continuous:!0,active:!0,initial:!0,monitor:null};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _typeof='function'==typeof Symbol&&'symbol'==typeof Symbol.iterator?function(obj){return typeof obj}:function(obj){return obj&&'function'==typeof Symbol&&obj.constructor===Symbol&&obj!==Symbol.prototype?'symbol':typeof obj},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();Object.defineProperty(exports,'__esModule',{value:!0});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),RangeSlider=function(_React$Component){function RangeSlider(props){_classCallCheck(this,RangeSlider);var _this=_possibleConstructorReturn(this,(RangeSlider.__proto__||Object.getPrototypeOf(RangeSlider)).call(this,props));return _this.onRailClick=_this.onRailClick.bind(_this),_this.onDragStart=_this.onDragStart.bind(_this),_this.onDrag=_this.onDrag.bind(_this),_this.onDragEnd=_this.onDragEnd.bind(_this),_this.state={percent:_this.getPercentFromValue(_this.props.value)},_this.dragging=!1,_this.lastClientX=0,_this}return _inherits(RangeSlider,_React$Component),_createClass(RangeSlider,[{key:'componentWillUnmount',value:function componentWillUnmount(){this.removeMoveListeners()}},{key:'onRailClick',value:function onRailClick(e){this.handleRelease(e)}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(props){this.setState({percent:this.getPercentFromValue(props.value)})}},{key:'handleRelease',value:function handleRelease(e){var percent=this.getPercentFromEvent(e);this.setState({percent:percent}),this.props.onRelease&&this.props.onRelease([this.getValueFromPercent(percent)])}},{key:'attachMoveListeners',value:function attachMoveListeners(){document.addEventListener('mouseup',this.onDragEnd,!1),document.addEventListener('touchend',this.onDragEnd,!1),document.addEventListener('touchmove',this.onDrag,!1),document.addEventListener('mousemove',this.onDrag,!1)}},{key:'removeMoveListeners',value:function removeMoveListeners(){document.removeEventListener('mouseup',this.onDragEnd),document.removeEventListener('touchend',this.onDragEnd),document.removeEventListener('touchmove',this.onDrag),document.removeEventListener('mousemove',this.onDrag)}},{key:'onDragStart',value:function onDragStart(e){this.dragging=!0,this.attachMoveListeners(),this.handleChange(e)}},{key:'handleChange',value:function handleChange(e){var percent=this.getPercentFromEvent(e);this.setState({percent:percent}),this.props.onChange&&this.props.onChange(this.getValueFromPercent(percent))}},{key:'onDrag',value:function onDrag(e){this.dragging&&this.handleChange(e)}},{key:'onDragEnd',value:function onDragEnd(e){this.dragging&&(this.dragging=!1,this.removeMoveListeners(),this.handleRelease(e))}},{key:'getPercentFromValue',value:function getPercentFromValue(value){var rawPercent=this.getRawPercentFromValue(value);return this.snapPercent(this.clampPercent(rawPercent))}},{key:'getRawPercentFromValue',value:function getRawPercentFromValue(value){return 100*((value-this.props.range[0])/this.getRange())}},{key:'getValueFromPercent',value:function getValueFromPercent(percent){return percent/100*this.getRange()+this.props.range[0]}},{key:'getRange',value:function getRange(){return this.props.range[1]-this.props.range[0]}},{key:'getPercentFromEvent',value:function getPercentFromEvent(e){var rawPercent=100*(this.getLeftOffsetFromEvent(e)/this.getParentWidth());return this.snapPercent(this.clampPercent(rawPercent))}},{key:'clampPercent',value:function clampPercent(percent){return Math.min(Math.max(percent,0),100)}},{key:'snapPercent',value:function snapPercent(percent){if(!this.props.points)return percent;var value=this.getValueFromPercent(percent),snappedValue=[].concat(this.props.points).sort(function(a,b){var _Mathabs=Math.abs;return _Mathabs(a-value)-_Mathabs(b-value)}).shift();return this.getRawPercentFromValue(snappedValue)}},{key:'render',value:function render(){return React.createElement('div',{className:'rangeslider v3 horizontal',ref:'parent',onClick:this.onRailClick},React.createElement('div',{className:'rangeslider-rail'},React.createElement('div',{className:'rangeslider-bar',style:{width:this.state.percent+'%'}})),React.createElement('div',{className:'rangeslider-handle',onMouseDown:this.onDragStart,onTouchStart:this.onDragStart,style:{left:this.state.percent+'%'}}))}},{key:'getParentWidth',value:function getParentWidth(){var rect=this.refs.parent.getBoundingClientRect();return rect.right-rect.left}},{key:'getLeftOffsetFromEvent',value:function getLeftOffsetFromEvent(e){var rect=this.refs.parent.getBoundingClientRect(),clientX=e.clientX;return'object'==_typeof(e.touches)&&(clientX=this.lastClientX,'touchend'!==e.type&&(clientX=e.touches[0].clientX,this.lastClientX=clientX)),clientX-rect.left}}]),RangeSlider}(React.Component);exports.default=RangeSlider;

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_ClickOutside=__webpack_require__(158);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),PropTypes=React.PropTypes,Select=function(_React$Component){function Select(props){_classCallCheck(this,Select);var _this=_possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this,props));return _this.state={dropdownOpen:!1},_this}return _inherits(Select,_React$Component),_createClass(Select,[{key:'render',value:function render(){var _this2=this,activeValue=this.props.active,options=this.props.options,isWrapper='undefined'!=typeof this.props.children,callToAction=isWrapper?this.props.children.map(function(child,i){if(0===i)return React.createElement('div',{className:'option callToAction',onClick:function onClick(){return _this2.toggleDropdown()},key:'callToAction'},child)}):React.createElement('div',{className:'option callToAction',onClick:function onClick(){return _this2.toggleDropdown()},key:this.props.callToAction},this.props.callToAction),dropdownOptions=void 0;dropdownOptions=isWrapper?this.props.children.map(function(option,i){if('undefined'==typeof _this2.props.showCallToAction||0!==i){var className=activeValue===i?'option selected':'option';return React.createElement('div',{className:className,onClick:function onClick(){return _this2.handleOptionClick(i)},key:i},option)}}):options.map(function(option){var className=activeValue===option.value?'option selected':'option';return React.createElement('div',{className:className,onClick:function onClick(){return _this2.handleOptionClick(option.value)},key:option.name},option.name)});var activeOption,activeOptionElement;isWrapper?(activeOption=this.props.children.filter(function(option,i){return activeValue===i}),0===activeOption.length&&this.props.children.length&&(activeOption=[this.props.children[0]]),activeOptionElement=activeOption.map(function(option,i){return React.createElement('div',{className:'option active',key:i,onClick:function onClick(){return _this2.toggleDropdown()}},option)})):(activeOption=options.filter(function(option){return activeValue===option.value}),0===activeOption.length&&options.length&&(activeOption=[options[0]]),activeOptionElement=activeOption.map(function(option){return React.createElement('div',{className:'option active',key:option.name,onClick:function onClick(){return _this2.toggleDropdown()}},option.name)}));var selectToggleClassName=this.state.dropdownOpen?'select-toggle open':'select-toggle',dropDownStyle={display:this.state.dropdownOpen?'block':'none'},dropdown=React.createElement('div',{className:'dropdown',style:dropDownStyle},dropdownOptions),mySelect=React.createElement('div',{className:'lr-components-select select '+this.props.className},React.createElement('div',{className:selectToggleClassName,onClick:function onClick(){return _this2.toggleDropdown()}}),this.props.showCallToAction?callToAction:activeOptionElement,dropdown);return(0,_ClickOutside.clickoutsideWrapper)(mySelect,function(){return _this2.closeDropdown()})}},{key:'handleOptionClick',value:function handleOptionClick(value){this.state.dropdownOpen&&this.props.choiceHandler(value),this.toggleDropdown()}},{key:'toggleDropdown',value:function toggleDropdown(){this.state.dropdownOpen?this.setState({dropdownOpen:!1}):this.setState({dropdownOpen:!0})}},{key:'closeDropdown',value:function closeDropdown(){this.state.dropdownOpen&&this.setState({dropdownOpen:!1})}}]),Select}(React.Component);Select.propTypes={active:PropTypes.oneOfType([PropTypes.string,PropTypes.number]),options:PropTypes.arrayOf(PropTypes.shape({name:PropTypes.oneOfType([PropTypes.string,PropTypes.number]).isRequired,value:PropTypes.isRequired})),choiceHandler:PropTypes.func.isRequired,callToAction:PropTypes.string,showCallToAction:PropTypes.bool},module.exports=Select;

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();Object.defineProperty(exports,'__esModule',{value:!0});exports.clickoutsideWrapper=clickoutsideWrapper;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),PropTypes=React.PropTypes,ClickOutside=exports.ClickOutside=function(_React$Component){function ClickOutside(){_classCallCheck(this,ClickOutside);var _this=_possibleConstructorReturn(this,(ClickOutside.__proto__||Object.getPrototypeOf(ClickOutside)).call(this));return _this._handle=_this.handle.bind(_this),_this}return _inherits(ClickOutside,_React$Component),_createClass(ClickOutside,[{key:'render',value:function render(){var _this2=this,_props=this.props,children=_props.children,onClickOutside=_props.onClickOutside,props=_objectWithoutProperties(_props,['children','onClickOutside']);return React.createElement('div',_extends({},props,{ref:function ref(_ref){return _this2.container=_ref}}),children)}},{key:'componentDidMount',value:function componentDidMount(){$(document).on('click',this._handle)}},{key:'componentWillUnmount',value:function componentWillUnmount(){$(document).off('click',this._handle)}},{key:'handle',value:function handle(e){var onClickOutside=this.props.onClickOutside,el=this.container;el.contains(e.target)||onClickOutside(e)}}]),ClickOutside}(React.Component);ClickOutside.propTypes={onClickOutside:PropTypes.func.isRequired};function clickoutsideWrapper(Component,handler){return React.createElement(ClickOutside,{onClickOutside:handler},Component)}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_react=__webpack_require__(8),_react2=_interopRequireDefault(_react);Object.defineProperty(exports,'__esModule',{value:!0});function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _defineProperty(obj,key,value){return key in obj?Object.defineProperty(obj,key,{value:value,enumerable:!0,configurable:!0,writable:!0}):obj[key]=value,obj}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj)0<=keys.indexOf(i)||Object.prototype.hasOwnProperty.call(obj,i)&&(target[i]=obj[i]);return target}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var cc=__webpack_require__(72),SVGIcon=function(_React$Component){function SVGIcon(){return _classCallCheck(this,SVGIcon),_possibleConstructorReturn(this,(SVGIcon.__proto__||Object.getPrototypeOf(SVGIcon)).apply(this,arguments))}return _inherits(SVGIcon,_React$Component),_createClass(SVGIcon,[{key:'render',value:function render(){var _props=this.props,identifier=_props.identifier,addClass=_props.addClass,_rest=_objectWithoutProperties(_props,['identifier','addClass']),className=cc('rs-icon',_defineProperty({},'rs-icon-'+identifier,identifier),addClass);return _react2.default.createElement('svg',_extends({className:className},_rest),_react2.default.createElement('use',{xlinkHref:'/static/icons/icons.svg'+'?v=66'+'#'+identifier}))}}]),SVGIcon}(_react2.default.Component);exports.default=SVGIcon,SVGIcon.propTypes={identifier:_react2.default.PropTypes.string.isRequired,addClass:_react2.default.PropTypes.string};

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _extends=Object.assign||function(target){for(var source,i=1;i<arguments.length;i++)for(var key in source=arguments[i],source)Object.prototype.hasOwnProperty.call(source,key)&&(target[key]=source[key]);return target},_Provider=__webpack_require__(161),_Provider2=_interopRequireDefault(_Provider),_CaseInfoBox=__webpack_require__(162),_CaseInfoBox2=_interopRequireDefault(_CaseInfoBox);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}var Emitter=__webpack_require__(27).EventEmitter,casefactory=__webpack_require__(36),React=__webpack_require__(8),ReactDom=__webpack_require__(164),Choices=window.ThomannCasefactory_ui.getChoices(),debounce=__webpack_require__(241),_casefactory$action=casefactory.action,changeElementInCaseWorld=_casefactory$action.changeElementInCaseWorld,scaleCaseDimensionTo=_casefactory$action.scaleCaseDimensionTo,updateKeyboard=_casefactory$action.updateKeyboard,addRollsOrFeeds=_casefactory$action.addRollsOrFeeds,removeRollsOrFeeds=_casefactory$action.removeRollsOrFeeds,deactivateOption=_casefactory$action.deactivateOption,activateOption=_casefactory$action.activateOption,scaleCaseDimensionToAndRequestUpdates=_casefactory$action.scaleCaseDimensionToAndRequestUpdates,isCmMode=!0;module.exports={bootstrap:function bootstrap(){function renderCasefactoryUi(data){currentData=data,updateNonReactComponents(data),updateCaseInfoBox(data),ReactDom.render(React.createElement(_Provider2.default,{emitter:emitter},React.createElement(Choices,_extends({basePath:basePath},data,{location:window.location}))),$('.lr-casefactory-choices-react').get(0))}function updateNonReactComponents(data){var summary=$('#content .product .product-summary'),price=summary.find('.price'),cart=summary.find('form.cart'),caseIdElement=cart.find('.megacase_case_id');if(data.case.hasOwnProperty('casePrice'))price.html(data.case.casePrice);else{var grossPrice=Math.floor(1.19*data.case.netPrice),currentPrice=parseFloat(grossPrice).toFixed(2),formattedPrice=currentPrice.replace('.',',');price.find('.amount').contents().filter(function(){return 3===this.nodeType}).first().replaceWith(formattedPrice+' ')}data.case.isVirtualCase?cart.addClass('virtualCase'):cart.removeClass('virtualCase'),caseIdElement.val(data.case.id)}function updateCaseInfoBox(data){ReactDom.render(React.createElement(_CaseInfoBox2.default,{data:data}),document.getElementById('case-info'))}var currentData=casefactory.getData(),caseWorldController=casefactory.getCaseWorldController(),userIsDragging=!1,emitter=new Emitter,basePath=casefactory.getBasePath();currentData.isCmMode=isCmMode,renderCasefactoryUi(currentData),caseWorldController.on('init',function(){emitter.on('dimensionChange',function(dimension,value){userIsDragging=!1,currentData.case.dimensions.interior[dimension]=value,'height_unit'==dimension&&(currentData.case.dimensions.interior.height=45*value),renderCasefactoryUi(currentData),scaleCaseDimensionToAndRequestUpdates(dimension,value,null)}),emitter.on('dimensionDrag',function(dimension,value){userIsDragging=!0,currentData.case.dimensions.interior[dimension]=value,renderUiAndUpdateCaseWorldDebounced(dimension,value)}),emitter.on('keyboard',function(keyboardId){currentData.case.keyboardId=keyboardId,currentData.case.keyboardBrandAndModel=null,renderCasefactoryUi(currentData),keyboardId&&updateKeyboard(keyboardId,'')}),emitter.on('manufacturer',function(manufacturer){currentData.case.keyboardBrandAndModel=null,currentData.case.keyboardId=null,currentData.case.keyboardManufacturer=manufacturer,renderCasefactoryUi(currentData),manufacturer||updateKeyboard(-1,'')}),emitter.on('keyboardBrandAndModel',function(keyboardBrandAndModel){currentData.case.keyboardId=null,currentData.case.keyboardManufacturer=null,currentData.case.keyboardBrandAndModel=keyboardBrandAndModel,updateKeyboard(-1,keyboardBrandAndModel),renderCasefactoryUi(currentData)}),emitter.on('keyboardBrandAndModelChange',function(keyboardBrandAndModel){currentData.case.keyboardId=null,currentData.case.keyboardManufacturer=null,currentData.case.keyboardBrandAndModel=keyboardBrandAndModel,renderCasefactoryUi(currentData)}),emitter.on('option',function(option,value){if(!value)currentData.case.options.push(option),renderCasefactoryUi(currentData),activateOption(option);else{var index=currentData.case.options.indexOf(option);currentData.case.options.splice(index,1),renderCasefactoryUi(currentData),deactivateOption(option)}}),emitter.on('foam',function(foamId){currentData.case.FOAM=foamId,renderCasefactoryUi(currentData),changeElementInCaseWorld(foamId,'FOAM',null,null,null,null,!0,!0)}),emitter.on('handle',function(part){currentData.case.HANDLE=part.id,renderCasefactoryUi(currentData),changeElementInCaseWorld(part.id,part.category,null,null,null,null,!0,!0)}),emitter.on('fastener',function(part){currentData.case.FASTENER=part.id,renderCasefactoryUi(currentData),changeElementInCaseWorld(part.id,part.category,null,null,null,null,!0,!0)}),emitter.on('corners',function(part){currentData.case.CORNER=part.id,renderCasefactoryUi(currentData),changeElementInCaseWorld(part.id,part.category,null,null,null,null,!0,!0)}),emitter.on('unitMode',function(unit){isCmMode='cm'==unit,currentData.isCmMode=isCmMode,renderCasefactoryUi(currentData)}),emitter.on('rollsOrWheels',function(wheel){wheel?(currentData.case.WHEEL=wheel.id,renderCasefactoryUi(currentData),addRollsOrFeeds(wheel)):(currentData.case.WHEEL=null,renderCasefactoryUi(currentData),removeRollsOrFeeds({category:'WHEEL'}))}),emitter.on('color',function(color){currentData.case.PANEL=color.id,renderCasefactoryUi(currentData),changeElementInCaseWorld(color.id,color.category,color.file,color.textureFile,color.normalMaps,null,!0,!1)}),emitter.on('part',function(part,value){value?(currentData.case.accessories[part.category]=null,renderCasefactoryUi(currentData),changeElementInCaseWorld(null,part.category,null,null,null,!value,!0,!1)):(currentData.case.accessories[part.category]=part.id,renderCasefactoryUi(currentData),changeElementInCaseWorld(part.id,part.category,part.file,part.textureFile,part.normalMaps,!value,!0,!1))}),caseWorldController.on('caseUpdated',function(newData){newData.isCmMode=isCmMode,currentData=newData,userIsDragging||renderCasefactoryUi(currentData)})});var renderUiAndUpdateCaseWorldDebounced=debounce(function(dimension,value){renderCasefactoryUi(currentData),caseWorldController.startAction(),scaleCaseDimensionTo(dimension,value),caseWorldController.endAction()},6)}};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}();Object.defineProperty(exports,'__esModule',{value:!0});function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),PropTypes=React.PropTypes,Provider=function(_React$Component){function Provider(){return _classCallCheck(this,Provider),_possibleConstructorReturn(this,(Provider.__proto__||Object.getPrototypeOf(Provider)).call(this))}return _inherits(Provider,_React$Component),_createClass(Provider,[{key:'render',value:function render(){return this.props.children}},{key:'getChildContext',value:function getChildContext(){var contextData={};return this.props.emitter&&(contextData.emitter=this.props.emitter),contextData}}]),Provider}(React.Component);Provider.childContextTypes={emitter:PropTypes.object},exports.default=Provider;

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var descriptor,i=0;i<props.length;i++)descriptor=props[i],descriptor.enumerable=descriptor.enumerable||!1,descriptor.configurable=!0,'value'in descriptor&&(descriptor.writable=!0),Object.defineProperty(target,descriptor.key,descriptor)}return function(Constructor,protoProps,staticProps){return protoProps&&defineProperties(Constructor.prototype,protoProps),staticProps&&defineProperties(Constructor,staticProps),Constructor}}(),_Mssg=__webpack_require__(70),_Mssg2=_interopRequireDefault(_Mssg);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor))throw new TypeError('Cannot call a class as a function')}function _possibleConstructorReturn(self,call){if(!self)throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');return call&&('object'==typeof call||'function'==typeof call)?call:self}function _inherits(subClass,superClass){if('function'!=typeof superClass&&null!==superClass)throw new TypeError('Super expression must either be null or a function, not '+typeof superClass);subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}}),superClass&&(Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass)}var React=__webpack_require__(8),CaseInfoBox=function(_React$Component){function CaseInfoBox(props){_classCallCheck(this,CaseInfoBox);var _this=_possibleConstructorReturn(this,(CaseInfoBox.__proto__||Object.getPrototypeOf(CaseInfoBox)).call(this,props));return _this.state={currentCase:props.data},_this}return _inherits(CaseInfoBox,_React$Component),_createClass(CaseInfoBox,[{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){var newState={currentCase:nextProps.data};this.setState(newState)}},{key:'render',value:function render(){var caseData=this.state.currentCase,weight=parseFloat(caseData.case.weight).toFixed(2).replace('.',',');return React.createElement('table',{className:'lr-casefactory-stage-case-values'},React.createElement('tbody',null,React.createElement('tr',null,React.createElement('td',{className:'lr-casefactory-stage-case-value-description'},React.createElement(_Mssg2.default,{__key:'current.interiors'}),' ',React.createElement(_Mssg2.default,{__key:'width.height.depth'})),React.createElement('td',{className:'lr-casefactory-stage-case-value'},React.createElement('span',null,caseData.case.dimensions.interior.width,' x ',caseData.case.dimensions.interior.height,' x ',caseData.case.dimensions.interior.depth,'mm'))),React.createElement('tr',null,React.createElement('td',{className:'lr-casefactory-stage-case-value-description'},React.createElement(_Mssg2.default,{__key:'current.exteriors'}),' ',React.createElement(_Mssg2.default,{__key:'width.height.depth'}),' (',React.createElement(_Mssg2.default,{__key:'from.edge.to.edge'}),')'),React.createElement('td',{className:'lr-casefactory-stage-case-value'},React.createElement('span',null,caseData.case.dimensions.exterior.width,' x ',caseData.case.dimensions.exterior.height,' x ',caseData.case.dimensions.exterior.depth,'mm'))),React.createElement('tr',null,React.createElement('td',{className:'lr-casefactory-stage-case-value-description'},React.createElement(_Mssg2.default,{__key:'own.weight'})),React.createElement('td',{className:'lr-casefactory-stage-case-value'},React.createElement('span',null,weight,' Kg')))))}}]),CaseInfoBox}(React.Component);CaseInfoBox.contextTypes={},CaseInfoBox.defaultProps={},module.exports=CaseInfoBox;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var lastRequest=null;function requestUpdates(changeData,callback){lastRequest=$.ajax({url:'/wp-admin/admin-ajax.php',type:'POST',data:{action:'megacase_ajax_update_case',changeData:JSON.stringify(changeData)}}),lastRequest.fail(function(){megacase_remove_error_notes(),megacase_show_error_note('Fehler beim abrufen der Flightcase Daten.')}),lastRequest.done(function(data,state,promise){promise===lastRequest&&(megacase_remove_error_notes(),lastRequest=null,callback(data))})}function megacase_show_error_note(error_text){(function($){$('.casefactory .summary form.cart').addClass('virtualCase');var wc_info_div=$('.site-content > .col-full > .woocommerce');wc_info_div.append('<div class="woocommerce-error mc-error">'+error_text+' <a href="">Seite neu laden</a></div>')})(jQuery)}function megacase_remove_error_notes(){(function($){$('.casefactory .summary form.cart').removeClass('virtualCase');var wc_info_div=$('.site-content > .col-full > .woocommerce > .woocommerce-error.mc-error');wc_info_div.remove()})(jQuery)}module.exports=requestUpdates;

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(165);


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/



var ReactDOMComponentTree = __webpack_require__(4);
var ReactDefaultInjection = __webpack_require__(166);
var ReactMount = __webpack_require__(96);
var ReactReconciler = __webpack_require__(20);
var ReactUpdates = __webpack_require__(11);
var ReactVersion = __webpack_require__(238);

var findDOMNode = __webpack_require__(239);
var getHostComponentFromComposite = __webpack_require__(97);
var renderSubtreeIntoContainer = __webpack_require__(240);
var warning = __webpack_require__(2);

ReactDefaultInjection.inject();

var ReactDOM = {
  findDOMNode: findDOMNode,
  render: ReactMount.render,
  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
  version: ReactVersion,

  /* eslint-disable camelcase */
  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
  /* eslint-enable camelcase */
};

// Inject the runtime into a devtools global hook regardless of browser.
// Allows for debugging when the hook is injected on the page.
if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
    ComponentTree: {
      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
      getNodeFromInstance: function (inst) {
        // inst is an internal instance (but could be a composite)
        if (inst._renderedComponent) {
          inst = getHostComponentFromComposite(inst);
        }
        if (inst) {
          return ReactDOMComponentTree.getNodeFromInstance(inst);
        } else {
          return null;
        }
      }
    },
    Mount: ReactMount,
    Reconciler: ReactReconciler
  });
}

if (false) {
  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
    // First check if devtools is not installed
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
      // If we're in Chrome or Firefox, provide a download link if not installed.
      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
        // Firefox does not have the issue with devtools loaded over file://
        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
      }
    }

    var testFunc = function testFn() {};
    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;

    // If we're in IE8, check to see if we are in compatibility mode and provide
    // information on preventing compatibility mode
    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;

    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;

    var expectedFeatures = [
    // shims
    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];

    for (var i = 0; i < expectedFeatures.length; i++) {
      if (!expectedFeatures[i]) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
        break;
      }
    }
  }
}

if (false) {
  var ReactInstrumentation = require('./ReactInstrumentation');
  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');

  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
}

module.exports = ReactDOM;

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = __webpack_require__(167);
var BeforeInputEventPlugin = __webpack_require__(168);
var ChangeEventPlugin = __webpack_require__(172);
var DefaultEventPluginOrder = __webpack_require__(175);
var EnterLeaveEventPlugin = __webpack_require__(176);
var HTMLDOMPropertyConfig = __webpack_require__(177);
var ReactComponentBrowserEnvironment = __webpack_require__(178);
var ReactDOMComponent = __webpack_require__(184);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMEmptyComponent = __webpack_require__(209);
var ReactDOMTreeTraversal = __webpack_require__(210);
var ReactDOMTextComponent = __webpack_require__(211);
var ReactDefaultBatchingStrategy = __webpack_require__(212);
var ReactEventListener = __webpack_require__(213);
var ReactInjection = __webpack_require__(215);
var ReactReconcileTransaction = __webpack_require__(216);
var SVGDOMPropertyConfig = __webpack_require__(222);
var SelectEventPlugin = __webpack_require__(223);
var SimpleEventPlugin = __webpack_require__(224);

var alreadyInjected = false;

function inject() {
  if (alreadyInjected) {
    // TODO: This is currently true because these injections are shared between
    // the client and the server package. They should be built independently
    // and not share any injection state. Then this problem will be solved.
    return;
  }
  alreadyInjected = true;

  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);

  /**
   * Inject modules for resolving DOM hierarchy and plugin ordering.
   */
  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);

  /**
   * Some important event plugins included by default (without having to require
   * them).
   */
  ReactInjection.EventPluginHub.injectEventPluginsByName({
    SimpleEventPlugin: SimpleEventPlugin,
    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
    ChangeEventPlugin: ChangeEventPlugin,
    SelectEventPlugin: SelectEventPlugin,
    BeforeInputEventPlugin: BeforeInputEventPlugin
  });

  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);

  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);

  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);

  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
    return new ReactDOMEmptyComponent(instantiate);
  });

  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);

  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
}

module.exports = {
  inject: inject
};

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ARIADOMPropertyConfig = {
  Properties: {
    // Global States and Properties
    'aria-current': 0, // state
    'aria-details': 0,
    'aria-disabled': 0, // state
    'aria-hidden': 0, // state
    'aria-invalid': 0, // state
    'aria-keyshortcuts': 0,
    'aria-label': 0,
    'aria-roledescription': 0,
    // Widget Attributes
    'aria-autocomplete': 0,
    'aria-checked': 0,
    'aria-expanded': 0,
    'aria-haspopup': 0,
    'aria-level': 0,
    'aria-modal': 0,
    'aria-multiline': 0,
    'aria-multiselectable': 0,
    'aria-orientation': 0,
    'aria-placeholder': 0,
    'aria-pressed': 0,
    'aria-readonly': 0,
    'aria-required': 0,
    'aria-selected': 0,
    'aria-sort': 0,
    'aria-valuemax': 0,
    'aria-valuemin': 0,
    'aria-valuenow': 0,
    'aria-valuetext': 0,
    // Live Region Attributes
    'aria-atomic': 0,
    'aria-busy': 0,
    'aria-live': 0,
    'aria-relevant': 0,
    // Drag-and-Drop Attributes
    'aria-dropeffect': 0,
    'aria-grabbed': 0,
    // Relationship Attributes
    'aria-activedescendant': 0,
    'aria-colcount': 0,
    'aria-colindex': 0,
    'aria-colspan': 0,
    'aria-controls': 0,
    'aria-describedby': 0,
    'aria-errormessage': 0,
    'aria-flowto': 0,
    'aria-labelledby': 0,
    'aria-owns': 0,
    'aria-posinset': 0,
    'aria-rowcount': 0,
    'aria-rowindex': 0,
    'aria-rowspan': 0,
    'aria-setsize': 0
  },
  DOMAttributeNames: {},
  DOMPropertyNames: {}
};

module.exports = ARIADOMPropertyConfig;

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(23);
var ExecutionEnvironment = __webpack_require__(6);
var FallbackCompositionState = __webpack_require__(169);
var SyntheticCompositionEvent = __webpack_require__(170);
var SyntheticInputEvent = __webpack_require__(171);

var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
var START_KEYCODE = 229;

var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;

var documentMode = null;
if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
  documentMode = document.documentMode;
}

// Webkit offers a very useful `textInput` event that can be used to
// directly represent `beforeInput`. The IE `textinput` event is not as
// useful, so we don't use it.
var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();

// In IE9+, we have access to composition events, but the data supplied
// by the native compositionend event may be incorrect. Japanese ideographic
// spaces, for instance (\u3000) are not recorded correctly.
var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);

/**
 * Opera <= 12 includes TextEvent in window, but does not fire
 * text input events. Rely on keypress instead.
 */
function isPresto() {
  var opera = window.opera;
  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
}

var SPACEBAR_CODE = 32;
var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);

// Events and their corresponding property names.
var eventTypes = {
  beforeInput: {
    phasedRegistrationNames: {
      bubbled: 'onBeforeInput',
      captured: 'onBeforeInputCapture'
    },
    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
  },
  compositionEnd: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionEnd',
      captured: 'onCompositionEndCapture'
    },
    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionStart: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionStart',
      captured: 'onCompositionStartCapture'
    },
    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  },
  compositionUpdate: {
    phasedRegistrationNames: {
      bubbled: 'onCompositionUpdate',
      captured: 'onCompositionUpdateCapture'
    },
    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
  }
};

// Track whether we've ever handled a keypress on the space key.
var hasSpaceKeypress = false;

/**
 * Return whether a native keypress event is assumed to be a command.
 * This is required because Firefox fires `keypress` events for key commands
 * (cut, copy, select-all, etc.) even though no character is inserted.
 */
function isKeypressCommand(nativeEvent) {
  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
  !(nativeEvent.ctrlKey && nativeEvent.altKey);
}

/**
 * Translate native top level events into event types.
 *
 * @param {string} topLevelType
 * @return {object}
 */
function getCompositionEventType(topLevelType) {
  switch (topLevelType) {
    case 'topCompositionStart':
      return eventTypes.compositionStart;
    case 'topCompositionEnd':
      return eventTypes.compositionEnd;
    case 'topCompositionUpdate':
      return eventTypes.compositionUpdate;
  }
}

/**
 * Does our fallback best-guess model think this event signifies that
 * composition has begun?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionStart(topLevelType, nativeEvent) {
  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
}

/**
 * Does our fallback mode think that this event is the end of composition?
 *
 * @param {string} topLevelType
 * @param {object} nativeEvent
 * @return {boolean}
 */
function isFallbackCompositionEnd(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topKeyUp':
      // Command keys insert or clear IME input.
      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
    case 'topKeyDown':
      // Expect IME keyCode on each keydown. If we get any other
      // code we must have exited earlier.
      return nativeEvent.keyCode !== START_KEYCODE;
    case 'topKeyPress':
    case 'topMouseDown':
    case 'topBlur':
      // Events are not possible without cancelling IME.
      return true;
    default:
      return false;
  }
}

/**
 * Google Input Tools provides composition data via a CustomEvent,
 * with the `data` property populated in the `detail` object. If this
 * is available on the event object, use it. If not, this is a plain
 * composition event and we have nothing special to extract.
 *
 * @param {object} nativeEvent
 * @return {?string}
 */
function getDataFromCustomEvent(nativeEvent) {
  var detail = nativeEvent.detail;
  if (typeof detail === 'object' && 'data' in detail) {
    return detail.data;
  }
  return null;
}

// Track the current IME composition fallback object, if any.
var currentComposition = null;

/**
 * @return {?object} A SyntheticCompositionEvent.
 */
function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var eventType;
  var fallbackData;

  if (canUseCompositionEvent) {
    eventType = getCompositionEventType(topLevelType);
  } else if (!currentComposition) {
    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
      eventType = eventTypes.compositionStart;
    }
  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
    eventType = eventTypes.compositionEnd;
  }

  if (!eventType) {
    return null;
  }

  if (useFallbackCompositionData) {
    // The current composition is stored statically and must not be
    // overwritten while composition continues.
    if (!currentComposition && eventType === eventTypes.compositionStart) {
      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
    } else if (eventType === eventTypes.compositionEnd) {
      if (currentComposition) {
        fallbackData = currentComposition.getData();
      }
    }
  }

  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);

  if (fallbackData) {
    // Inject data generated from fallback path into the synthetic event.
    // This matches the property of native CompositionEventInterface.
    event.data = fallbackData;
  } else {
    var customData = getDataFromCustomEvent(nativeEvent);
    if (customData !== null) {
      event.data = customData;
    }
  }

  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The string corresponding to this `beforeInput` event.
 */
function getNativeBeforeInputChars(topLevelType, nativeEvent) {
  switch (topLevelType) {
    case 'topCompositionEnd':
      return getDataFromCustomEvent(nativeEvent);
    case 'topKeyPress':
      /**
       * If native `textInput` events are available, our goal is to make
       * use of them. However, there is a special case: the spacebar key.
       * In Webkit, preventing default on a spacebar `textInput` event
       * cancels character insertion, but it *also* causes the browser
       * to fall back to its default spacebar behavior of scrolling the
       * page.
       *
       * Tracking at:
       * https://code.google.com/p/chromium/issues/detail?id=355103
       *
       * To avoid this issue, use the keypress event as if no `textInput`
       * event is available.
       */
      var which = nativeEvent.which;
      if (which !== SPACEBAR_CODE) {
        return null;
      }

      hasSpaceKeypress = true;
      return SPACEBAR_CHAR;

    case 'topTextInput':
      // Record the characters to be added to the DOM.
      var chars = nativeEvent.data;

      // If it's a spacebar character, assume that we have already handled
      // it at the keypress level and bail immediately. Android Chrome
      // doesn't give us keycodes, so we need to blacklist it.
      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
        return null;
      }

      return chars;

    default:
      // For other native event types, do nothing.
      return null;
  }
}

/**
 * For browsers that do not provide the `textInput` event, extract the
 * appropriate string to use for SyntheticInputEvent.
 *
 * @param {string} topLevelType Record from `EventConstants`.
 * @param {object} nativeEvent Native browser event.
 * @return {?string} The fallback string for this `beforeInput` event.
 */
function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
  // If we are currently composing (IME) and using a fallback to do so,
  // try to extract the composed characters from the fallback object.
  // If composition event is available, we extract a string only at
  // compositionevent, otherwise extract it at fallback events.
  if (currentComposition) {
    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
      var chars = currentComposition.getData();
      FallbackCompositionState.release(currentComposition);
      currentComposition = null;
      return chars;
    }
    return null;
  }

  switch (topLevelType) {
    case 'topPaste':
      // If a paste event occurs after a keypress, throw out the input
      // chars. Paste events should not lead to BeforeInput events.
      return null;
    case 'topKeyPress':
      /**
       * As of v27, Firefox may fire keypress events even when no character
       * will be inserted. A few possibilities:
       *
       * - `which` is `0`. Arrow keys, Esc key, etc.
       *
       * - `which` is the pressed key code, but no char is available.
       *   Ex: 'AltGr + d` in Polish. There is no modified character for
       *   this key combination and no character is inserted into the
       *   document, but FF fires the keypress for char code `100` anyway.
       *   No `input` event will occur.
       *
       * - `which` is the pressed key code, but a command combination is
       *   being used. Ex: `Cmd+C`. No character is inserted, and no
       *   `input` event will occur.
       */
      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
        return String.fromCharCode(nativeEvent.which);
      }
      return null;
    case 'topCompositionEnd':
      return useFallbackCompositionData ? null : nativeEvent.data;
    default:
      return null;
  }
}

/**
 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
 * `textInput` or fallback behavior.
 *
 * @return {?object} A SyntheticInputEvent.
 */
function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var chars;

  if (canUseTextInputEvent) {
    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
  } else {
    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
  }

  // If no characters are being inserted, no BeforeInput event should
  // be fired.
  if (!chars) {
    return null;
  }

  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);

  event.data = chars;
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}

/**
 * Create an `onBeforeInput` event to match
 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
 *
 * This event plugin is based on the native `textInput` event
 * available in Chrome, Safari, Opera, and IE. This event fires after
 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
 *
 * `beforeInput` is spec'd but not implemented in any browsers, and
 * the `input` event does not provide any useful information about what has
 * actually been added, contrary to the spec. Thus, `textInput` is the best
 * available event to identify the characters that have actually been inserted
 * into the target node.
 *
 * This plugin is also responsible for emitting `composition` events, thus
 * allowing us to share composition fallback code for both `beforeInput` and
 * `composition` event types.
 */
var BeforeInputEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
  }
};

module.exports = BeforeInputEventPlugin;

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(16);

var getTextContentAccessor = __webpack_require__(76);

/**
 * This helper class stores information about text content of a target node,
 * allowing comparison of content before and after a given event.
 *
 * Identify the node where selection currently begins, then observe
 * both its text content and its current position in the DOM. Since the
 * browser may natively replace the target node during composition, we can
 * use its position to find its replacement.
 *
 * @param {DOMEventTarget} root
 */
function FallbackCompositionState(root) {
  this._root = root;
  this._startText = this.getText();
  this._fallbackText = null;
}

_assign(FallbackCompositionState.prototype, {
  destructor: function () {
    this._root = null;
    this._startText = null;
    this._fallbackText = null;
  },

  /**
   * Get current text of input.
   *
   * @return {string}
   */
  getText: function () {
    if ('value' in this._root) {
      return this._root.value;
    }
    return this._root[getTextContentAccessor()];
  },

  /**
   * Determine the differing substring between the initially stored
   * text content and the current content.
   *
   * @return {string}
   */
  getData: function () {
    if (this._fallbackText) {
      return this._fallbackText;
    }

    var start;
    var startValue = this._startText;
    var startLength = startValue.length;
    var end;
    var endValue = this.getText();
    var endLength = endValue.length;

    for (start = 0; start < startLength; start++) {
      if (startValue[start] !== endValue[start]) {
        break;
      }
    }

    var minEnd = startLength - start;
    for (end = 1; end <= minEnd; end++) {
      if (startValue[startLength - end] !== endValue[endLength - end]) {
        break;
      }
    }

    var sliceTail = end > 1 ? 1 - end : undefined;
    this._fallbackText = endValue.slice(start, sliceTail);
    return this._fallbackText;
  }
});

PooledClass.addPoolingTo(FallbackCompositionState);

module.exports = FallbackCompositionState;

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
 */
var CompositionEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);

module.exports = SyntheticCompositionEvent;

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
 *      /#events-inputevents
 */
var InputEventInterface = {
  data: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);

module.exports = SyntheticInputEvent;

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(24);
var EventPropagators = __webpack_require__(23);
var ExecutionEnvironment = __webpack_require__(6);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(11);
var SyntheticEvent = __webpack_require__(14);

var inputValueTracking = __webpack_require__(79);
var getEventTarget = __webpack_require__(40);
var isEventSupported = __webpack_require__(41);
var isTextInputElement = __webpack_require__(80);

var eventTypes = {
  change: {
    phasedRegistrationNames: {
      bubbled: 'onChange',
      captured: 'onChangeCapture'
    },
    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
  }
};

function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
  event.type = 'change';
  EventPropagators.accumulateTwoPhaseDispatches(event);
  return event;
}
/**
 * For IE shims
 */
var activeElement = null;
var activeElementInst = null;

/**
 * SECTION: handle `change` event
 */
function shouldUseChangeEvent(elem) {
  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
}

var doesChangeEventBubble = false;
if (ExecutionEnvironment.canUseDOM) {
  // See `handleChange` comment below
  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
}

function manualDispatchChangeEvent(nativeEvent) {
  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));

  // If change and propertychange bubbled, we'd just bind to it like all the
  // other events and have it go through ReactBrowserEventEmitter. Since it
  // doesn't, we manually listen for the events and so we have to enqueue and
  // process the abstract event manually.
  //
  // Batching is necessary here in order to ensure that all event handlers run
  // before the next rerender (including event handlers attached to ancestor
  // elements instead of directly on the input). Without this, controlled
  // components don't work properly in conjunction with event bubbling because
  // the component is rerendered and the value reverted before all the event
  // handlers can run. See https://github.com/facebook/react/issues/708.
  ReactUpdates.batchedUpdates(runEventInBatch, event);
}

function runEventInBatch(event) {
  EventPluginHub.enqueueEvents(event);
  EventPluginHub.processEventQueue(false);
}

function startWatchingForChangeEventIE8(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
}

function stopWatchingForChangeEventIE8() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
  activeElement = null;
  activeElementInst = null;
}

function getInstIfValueChanged(targetInst, nativeEvent) {
  var updated = inputValueTracking.updateValueIfChanged(targetInst);
  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;

  if (updated || simulated) {
    return targetInst;
  }
}

function getTargetInstForChangeEvent(topLevelType, targetInst) {
  if (topLevelType === 'topChange') {
    return targetInst;
  }
}

function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForChangeEventIE8();
    startWatchingForChangeEventIE8(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForChangeEventIE8();
  }
}

/**
 * SECTION: handle `input` event
 */
var isInputEventSupported = false;
if (ExecutionEnvironment.canUseDOM) {
  // IE9 claims to support the input event but fails to trigger it when
  // deleting text, so we ignore its input events.

  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
}

/**
 * (For IE <=9) Starts tracking propertychange events on the passed-in element
 * and override the value property so that we can distinguish user events from
 * value changes in JS.
 */
function startWatchingForValueChange(target, targetInst) {
  activeElement = target;
  activeElementInst = targetInst;
  activeElement.attachEvent('onpropertychange', handlePropertyChange);
}

/**
 * (For IE <=9) Removes the event listeners from the currently-tracked element,
 * if any exists.
 */
function stopWatchingForValueChange() {
  if (!activeElement) {
    return;
  }
  activeElement.detachEvent('onpropertychange', handlePropertyChange);

  activeElement = null;
  activeElementInst = null;
}

/**
 * (For IE <=9) Handles a propertychange event, sending a `change` event if
 * the value of the active element has changed.
 */
function handlePropertyChange(nativeEvent) {
  if (nativeEvent.propertyName !== 'value') {
    return;
  }
  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
    manualDispatchChangeEvent(nativeEvent);
  }
}

function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
  if (topLevelType === 'topFocus') {
    // In IE8, we can capture almost all .value changes by adding a
    // propertychange handler and looking for events with propertyName
    // equal to 'value'
    // In IE9, propertychange fires for most input events but is buggy and
    // doesn't fire when text is deleted, but conveniently, selectionchange
    // appears to fire in all of the remaining cases so we catch those and
    // forward the event if the value has changed
    // In either case, we don't want to call the event handler if the value
    // is changed from JS so we redefine a setter for `.value` that updates
    // our activeElementValue variable, allowing us to ignore those changes
    //
    // stopWatching() should be a noop here but we call it just in case we
    // missed a blur event somehow.
    stopWatchingForValueChange();
    startWatchingForValueChange(target, targetInst);
  } else if (topLevelType === 'topBlur') {
    stopWatchingForValueChange();
  }
}

// For IE8 and IE9.
function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
    // On the selectionchange event, the target is just document which isn't
    // helpful for us so just check activeElement instead.
    //
    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
    // propertychange on the first input event after setting `value` from a
    // script and fires only keydown, keypress, keyup. Catching keyup usually
    // gets it and catching keydown lets us fire an event for the first
    // keystroke if user does a key repeat (it'll be a little delayed: right
    // before the second keystroke). Other input methods (e.g., paste) seem to
    // fire selectionchange normally.
    return getInstIfValueChanged(activeElementInst, nativeEvent);
  }
}

/**
 * SECTION: handle `click` event
 */
function shouldUseClickEvent(elem) {
  // Use the `click` event to detect changes to checkbox and radio inputs.
  // This approach works across all browsers, whereas `change` does not fire
  // until `blur` in IE8.
  var nodeName = elem.nodeName;
  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
}

function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topClick') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
    return getInstIfValueChanged(targetInst, nativeEvent);
  }
}

function handleControlledInputBlur(inst, node) {
  // TODO: In IE, inst is occasionally null. Why?
  if (inst == null) {
    return;
  }

  // Fiber and ReactDOM keep wrapper state in separate places
  var state = inst._wrapperState || node._wrapperState;

  if (!state || !state.controlled || node.type !== 'number') {
    return;
  }

  // If controlled, assign the value attribute to the current value on blur
  var value = '' + node.value;
  if (node.getAttribute('value') !== value) {
    node.setAttribute('value', value);
  }
}

/**
 * This plugin creates an `onChange` event that normalizes change events
 * across form elements. This event fires at a time when it's possible to
 * change the element's value without seeing a flicker.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - select
 */
var ChangeEventPlugin = {
  eventTypes: eventTypes,

  _allowSimulatedPassThrough: true,
  _isInputEventSupported: isInputEventSupported,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    var getTargetInstFunc, handleEventFunc;
    if (shouldUseChangeEvent(targetNode)) {
      if (doesChangeEventBubble) {
        getTargetInstFunc = getTargetInstForChangeEvent;
      } else {
        handleEventFunc = handleEventsForChangeEventIE8;
      }
    } else if (isTextInputElement(targetNode)) {
      if (isInputEventSupported) {
        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
      } else {
        getTargetInstFunc = getTargetInstForInputEventPolyfill;
        handleEventFunc = handleEventsForInputEventPolyfill;
      }
    } else if (shouldUseClickEvent(targetNode)) {
      getTargetInstFunc = getTargetInstForClickEvent;
    }

    if (getTargetInstFunc) {
      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
      if (inst) {
        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
        return event;
      }
    }

    if (handleEventFunc) {
      handleEventFunc(topLevelType, targetNode, targetInst);
    }

    // When blurring, set the value attribute for number inputs
    if (topLevelType === 'topBlur') {
      handleControlledInputBlur(targetInst, targetNode);
    }
  }
};

module.exports = ChangeEventPlugin;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactOwner = __webpack_require__(174);

var ReactRef = {};

function attachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(component.getPublicInstance());
  } else {
    // Legacy ref
    ReactOwner.addComponentAsRefTo(component, ref, owner);
  }
}

function detachRef(ref, component, owner) {
  if (typeof ref === 'function') {
    ref(null);
  } else {
    // Legacy ref
    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
  }
}

ReactRef.attachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    attachRef(ref, instance, element._owner);
  }
};

ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
  // If either the owner or a `ref` has changed, make sure the newest owner
  // has stored a reference to `this`, and the previous owner (if different)
  // has forgotten the reference to `this`. We use the element instead
  // of the public this.props because the post processing cannot determine
  // a ref. The ref conceptually lives on the element.

  // TODO: Should this even be possible? The owner cannot change because
  // it's forbidden by shouldUpdateReactComponent. The ref can change
  // if you swap the keys of but not the refs. Reconsider where this check
  // is made. It probably belongs where the key checking and
  // instantiateReactComponent is done.

  var prevRef = null;
  var prevOwner = null;
  if (prevElement !== null && typeof prevElement === 'object') {
    prevRef = prevElement.ref;
    prevOwner = prevElement._owner;
  }

  var nextRef = null;
  var nextOwner = null;
  if (nextElement !== null && typeof nextElement === 'object') {
    nextRef = nextElement.ref;
    nextOwner = nextElement._owner;
  }

  return prevRef !== nextRef ||
  // If owner changes but we have an unchanged function ref, don't update refs
  typeof nextRef === 'string' && nextOwner !== prevOwner;
};

ReactRef.detachRefs = function (instance, element) {
  if (element === null || typeof element !== 'object') {
    return;
  }
  var ref = element.ref;
  if (ref != null) {
    detachRef(ref, instance, element._owner);
  }
};

module.exports = ReactRef;

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

/**
 * @param {?object} object
 * @return {boolean} True if `object` is a valid owner.
 * @final
 */
function isValidOwner(object) {
  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
}

/**
 * ReactOwners are capable of storing references to owned components.
 *
 * All components are capable of //being// referenced by owner components, but
 * only ReactOwner components are capable of //referencing// owned components.
 * The named reference is known as a "ref".
 *
 * Refs are available when mounted and updated during reconciliation.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return (
 *         <div onClick={this.handleClick}>
 *           <CustomComponent ref="custom" />
 *         </div>
 *       );
 *     },
 *     handleClick: function() {
 *       this.refs.custom.handleClick();
 *     },
 *     componentDidMount: function() {
 *       this.refs.custom.initialize();
 *     }
 *   });
 *
 * Refs should rarely be used. When refs are used, they should only be done to
 * control data that is not handled by React's data flow.
 *
 * @class ReactOwner
 */
var ReactOwner = {
  /**
   * Adds a component by ref to an owner component.
   *
   * @param {ReactComponent} component Component to reference.
   * @param {string} ref Name by which to refer to the component.
   * @param {ReactOwner} owner Component on which to record the ref.
   * @final
   * @internal
   */
  addComponentAsRefTo: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
    owner.attachRef(ref, component);
  },

  /**
   * Removes a component by ref from an owner component.
   *
   * @param {ReactComponent} component Component to dereference.
   * @param {string} ref Name of the ref to remove.
   * @param {ReactOwner} owner Component on which the ref is recorded.
   * @final
   * @internal
   */
  removeComponentAsRefFrom: function (component, ref, owner) {
    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
    var ownerPublicInstance = owner.getPublicInstance();
    // Check that `component`'s owner is still alive and that `component` is still the current ref
    // because we do not want to detach the ref if another component stole it.
    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
      owner.detachRef(ref);
    }
  }
};

module.exports = ReactOwner;

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Module that is injectable into `EventPluginHub`, that specifies a
 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
 * plugins, without having to package every one of them. This is better than
 * having plugins be ordered in the same order that they are injected because
 * that ordering would be influenced by the packaging order.
 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
 */

var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];

module.exports = DefaultEventPluginOrder;

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(23);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticMouseEvent = __webpack_require__(29);

var eventTypes = {
  mouseEnter: {
    registrationName: 'onMouseEnter',
    dependencies: ['topMouseOut', 'topMouseOver']
  },
  mouseLeave: {
    registrationName: 'onMouseLeave',
    dependencies: ['topMouseOut', 'topMouseOver']
  }
};

var EnterLeaveEventPlugin = {
  eventTypes: eventTypes,

  /**
   * For almost every interaction we care about, there will be both a top-level
   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
   * we do not extract duplicate events. However, moving the mouse into the
   * browser from outside will not fire a `mouseout` event. In this case, we use
   * the `mouseover` top-level event.
   */
  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
      return null;
    }
    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
      // Must not be a mouse in or mouse out - ignoring.
      return null;
    }

    var win;
    if (nativeEventTarget.window === nativeEventTarget) {
      // `nativeEventTarget` is probably a window object.
      win = nativeEventTarget;
    } else {
      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
      var doc = nativeEventTarget.ownerDocument;
      if (doc) {
        win = doc.defaultView || doc.parentWindow;
      } else {
        win = window;
      }
    }

    var from;
    var to;
    if (topLevelType === 'topMouseOut') {
      from = targetInst;
      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
    } else {
      // Moving to a node from outside the window.
      from = null;
      to = targetInst;
    }

    if (from === to) {
      // Nothing pertains to our managed components.
      return null;
    }

    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);

    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
    leave.type = 'mouseleave';
    leave.target = fromNode;
    leave.relatedTarget = toNode;

    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
    enter.type = 'mouseenter';
    enter.target = toNode;
    enter.relatedTarget = fromNode;

    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);

    return [leave, enter];
  }
};

module.exports = EnterLeaveEventPlugin;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(19);

var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;

var HTMLDOMPropertyConfig = {
  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
  Properties: {
    /**
     * Standard Properties
     */
    accept: 0,
    acceptCharset: 0,
    accessKey: 0,
    action: 0,
    allowFullScreen: HAS_BOOLEAN_VALUE,
    allowTransparency: 0,
    alt: 0,
    // specifies target context for links with `preload` type
    as: 0,
    async: HAS_BOOLEAN_VALUE,
    autoComplete: 0,
    // autoFocus is polyfilled/normalized by AutoFocusUtils
    // autoFocus: HAS_BOOLEAN_VALUE,
    autoPlay: HAS_BOOLEAN_VALUE,
    capture: HAS_BOOLEAN_VALUE,
    cellPadding: 0,
    cellSpacing: 0,
    charSet: 0,
    challenge: 0,
    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    cite: 0,
    classID: 0,
    className: 0,
    cols: HAS_POSITIVE_NUMERIC_VALUE,
    colSpan: 0,
    content: 0,
    contentEditable: 0,
    contextMenu: 0,
    controls: HAS_BOOLEAN_VALUE,
    controlsList: 0,
    coords: 0,
    crossOrigin: 0,
    data: 0, // For `<object />` acts as `src`.
    dateTime: 0,
    'default': HAS_BOOLEAN_VALUE,
    defer: HAS_BOOLEAN_VALUE,
    dir: 0,
    disabled: HAS_BOOLEAN_VALUE,
    download: HAS_OVERLOADED_BOOLEAN_VALUE,
    draggable: 0,
    encType: 0,
    form: 0,
    formAction: 0,
    formEncType: 0,
    formMethod: 0,
    formNoValidate: HAS_BOOLEAN_VALUE,
    formTarget: 0,
    frameBorder: 0,
    headers: 0,
    height: 0,
    hidden: HAS_BOOLEAN_VALUE,
    high: 0,
    href: 0,
    hrefLang: 0,
    htmlFor: 0,
    httpEquiv: 0,
    icon: 0,
    id: 0,
    inputMode: 0,
    integrity: 0,
    is: 0,
    keyParams: 0,
    keyType: 0,
    kind: 0,
    label: 0,
    lang: 0,
    list: 0,
    loop: HAS_BOOLEAN_VALUE,
    low: 0,
    manifest: 0,
    marginHeight: 0,
    marginWidth: 0,
    max: 0,
    maxLength: 0,
    media: 0,
    mediaGroup: 0,
    method: 0,
    min: 0,
    minLength: 0,
    // Caution; `option.selected` is not updated if `select.multiple` is
    // disabled with `removeAttribute`.
    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    name: 0,
    nonce: 0,
    noValidate: HAS_BOOLEAN_VALUE,
    open: HAS_BOOLEAN_VALUE,
    optimum: 0,
    pattern: 0,
    placeholder: 0,
    playsInline: HAS_BOOLEAN_VALUE,
    poster: 0,
    preload: 0,
    profile: 0,
    radioGroup: 0,
    readOnly: HAS_BOOLEAN_VALUE,
    referrerPolicy: 0,
    rel: 0,
    required: HAS_BOOLEAN_VALUE,
    reversed: HAS_BOOLEAN_VALUE,
    role: 0,
    rows: HAS_POSITIVE_NUMERIC_VALUE,
    rowSpan: HAS_NUMERIC_VALUE,
    sandbox: 0,
    scope: 0,
    scoped: HAS_BOOLEAN_VALUE,
    scrolling: 0,
    seamless: HAS_BOOLEAN_VALUE,
    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
    shape: 0,
    size: HAS_POSITIVE_NUMERIC_VALUE,
    sizes: 0,
    span: HAS_POSITIVE_NUMERIC_VALUE,
    spellCheck: 0,
    src: 0,
    srcDoc: 0,
    srcLang: 0,
    srcSet: 0,
    start: HAS_NUMERIC_VALUE,
    step: 0,
    style: 0,
    summary: 0,
    tabIndex: 0,
    target: 0,
    title: 0,
    // Setting .type throws on non-<input> tags
    type: 0,
    useMap: 0,
    value: 0,
    width: 0,
    wmode: 0,
    wrap: 0,

    /**
     * RDFa Properties
     */
    about: 0,
    datatype: 0,
    inlist: 0,
    prefix: 0,
    // property is also supported for OpenGraph in meta tags.
    property: 0,
    resource: 0,
    'typeof': 0,
    vocab: 0,

    /**
     * Non-standard Properties
     */
    // autoCapitalize and autoCorrect are supported in Mobile Safari for
    // keyboard hints.
    autoCapitalize: 0,
    autoCorrect: 0,
    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
    autoSave: 0,
    // color is for Safari mask-icon link
    color: 0,
    // itemProp, itemScope, itemType are for
    // Microdata support. See http://schema.org/docs/gs.html
    itemProp: 0,
    itemScope: HAS_BOOLEAN_VALUE,
    itemType: 0,
    // itemID and itemRef are for Microdata support as well but
    // only specified in the WHATWG spec document. See
    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
    itemID: 0,
    itemRef: 0,
    // results show looking glass icon and recent searches on input
    // search fields in WebKit/Blink
    results: 0,
    // IE-only attribute that specifies security restrictions on an iframe
    // as an alternative to the sandbox attribute on IE<10
    security: 0,
    // IE-only attribute that controls focus behavior
    unselectable: 0
  },
  DOMAttributeNames: {
    acceptCharset: 'accept-charset',
    className: 'class',
    htmlFor: 'for',
    httpEquiv: 'http-equiv'
  },
  DOMPropertyNames: {},
  DOMMutationMethods: {
    value: function (node, value) {
      if (value == null) {
        return node.removeAttribute('value');
      }

      // Number inputs get special treatment due to some edge cases in
      // Chrome. Let everything else assign the value attribute as normal.
      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
      if (node.type !== 'number' || node.hasAttribute('value') === false) {
        node.setAttribute('value', '' + value);
      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
        // Don't assign an attribute if validation reports bad
        // input. Chrome will clear the value. Additionally, don't
        // operate on inputs that have focus, otherwise Chrome might
        // strip off trailing decimal places and cause the user's
        // cursor position to jump to the beginning of the input.
        //
        // In ReactDOMInput, we have an onBlur event that will trigger
        // this function again when focus is lost.
        node.setAttribute('value', '' + value);
      }
    }
  }
};

module.exports = HTMLDOMPropertyConfig;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(43);
var ReactDOMIDOperations = __webpack_require__(183);

/**
 * Abstracts away all functionality of the reconciler that requires knowledge of
 * the browser context. TODO: These callers should be refactored to avoid the
 * need for this injection.
 */
var ReactComponentBrowserEnvironment = {
  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,

  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
};

module.exports = ReactComponentBrowserEnvironment;

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var DOMLazyTree = __webpack_require__(21);
var ExecutionEnvironment = __webpack_require__(6);

var createNodesFromMarkup = __webpack_require__(180);
var emptyFunction = __webpack_require__(10);
var invariant = __webpack_require__(0);

var Danger = {
  /**
   * Replaces a node with a string of markup at its current position within its
   * parent. The markup must render into a single root node.
   *
   * @param {DOMElement} oldChild Child node to replace.
   * @param {string} markup Markup to render in place of the child node.
   * @internal
   */
  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;

    if (typeof markup === 'string') {
      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
      oldChild.parentNode.replaceChild(newChild, oldChild);
    } else {
      DOMLazyTree.replaceChildWithTree(oldChild, markup);
    }
  }
};

module.exports = Danger;

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/*eslint-disable fb-www/unsafe-html*/

var ExecutionEnvironment = __webpack_require__(6);

var createArrayFromMixed = __webpack_require__(181);
var getMarkupWrap = __webpack_require__(182);
var invariant = __webpack_require__(0);

/**
 * Dummy container used to render all markup.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Pattern used by `getNodeName`.
 */
var nodeNamePattern = /^\s*<(\w+)/;

/**
 * Extracts the `nodeName` of the first element in a string of markup.
 *
 * @param {string} markup String of markup.
 * @return {?string} Node name of the supplied markup.
 */
function getNodeName(markup) {
  var nodeNameMatch = markup.match(nodeNamePattern);
  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
}

/**
 * Creates an array containing the nodes rendered from the supplied markup. The
 * optionally supplied `handleScript` function will be invoked once for each
 * <script> element that is rendered. If no `handleScript` function is supplied,
 * an exception is thrown if any <script> elements are rendered.
 *
 * @param {string} markup A string of valid HTML markup.
 * @param {?function} handleScript Invoked once for each rendered <script>.
 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
 */
function createNodesFromMarkup(markup, handleScript) {
  var node = dummyNode;
  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
  var nodeName = getNodeName(markup);

  var wrap = nodeName && getMarkupWrap(nodeName);
  if (wrap) {
    node.innerHTML = wrap[1] + markup + wrap[2];

    var wrapDepth = wrap[0];
    while (wrapDepth--) {
      node = node.lastChild;
    }
  } else {
    node.innerHTML = markup;
  }

  var scripts = node.getElementsByTagName('script');
  if (scripts.length) {
    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
    createArrayFromMixed(scripts).forEach(handleScript);
  }

  var nodes = Array.from(node.childNodes);
  while (node.lastChild) {
    node.removeChild(node.lastChild);
  }
  return nodes;
}

module.exports = createNodesFromMarkup;

/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var invariant = __webpack_require__(0);

/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */
function toArray(obj) {
  var length = obj.length;

  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).
  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;

  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;

  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;

  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;

  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.
  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {
      // IE < 9 does not support Array#slice on collections objects
    }
  }

  // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.
  var ret = Array(length);
  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }
  return ret;
}

/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */
function hasArrayNature(obj) {
  return (
    // not null/false
    !!obj && (
    // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') &&
    // quacks like an array
    'length' in obj &&
    // not window
    !('setInterval' in obj) &&
    // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && (
    // a real array
    Array.isArray(obj) ||
    // arguments
    'callee' in obj ||
    // HTMLCollection/NodeList
    'item' in obj)
  );
}

/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */
function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/*eslint-disable fb-www/unsafe-html */

var ExecutionEnvironment = __webpack_require__(6);

var invariant = __webpack_require__(0);

/**
 * Dummy container used to detect which wraps are necessary.
 */
var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;

/**
 * Some browsers cannot use `innerHTML` to render certain elements standalone,
 * so we wrap them, render the wrapped nodes, then extract the desired node.
 *
 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
 */

var shouldWrap = {};

var selectWrap = [1, '<select multiple="true">', '</select>'];
var tableWrap = [1, '<table>', '</table>'];
var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];

var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];

var markupWrap = {
  '*': [1, '?<div>', '</div>'],

  'area': [1, '<map>', '</map>'],
  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
  'legend': [1, '<fieldset>', '</fieldset>'],
  'param': [1, '<object>', '</object>'],
  'tr': [2, '<table><tbody>', '</tbody></table>'],

  'optgroup': selectWrap,
  'option': selectWrap,

  'caption': tableWrap,
  'colgroup': tableWrap,
  'tbody': tableWrap,
  'tfoot': tableWrap,
  'thead': tableWrap,

  'td': trWrap,
  'th': trWrap
};

// Initialize the SVG elements since we know they'll always need to be wrapped
// consistently. If they are created inside a <div> they will be initialized in
// the wrong namespace (and will not display).
var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
svgElements.forEach(function (nodeName) {
  markupWrap[nodeName] = svgWrap;
  shouldWrap[nodeName] = true;
});

/**
 * Gets the markup wrap configuration for the supplied `nodeName`.
 *
 * NOTE: This lazily detects which wraps are necessary for the current browser.
 *
 * @param {string} nodeName Lowercase `nodeName`.
 * @return {?array} Markup wrap configuration, if applicable.
 */
function getMarkupWrap(nodeName) {
  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
  if (!markupWrap.hasOwnProperty(nodeName)) {
    nodeName = '*';
  }
  if (!shouldWrap.hasOwnProperty(nodeName)) {
    if (nodeName === '*') {
      dummyNode.innerHTML = '<link />';
    } else {
      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
    }
    shouldWrap[nodeName] = !dummyNode.firstChild;
  }
  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
}

module.exports = getMarkupWrap;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMChildrenOperations = __webpack_require__(43);
var ReactDOMComponentTree = __webpack_require__(4);

/**
 * Operations used to process updates to DOM nodes.
 */
var ReactDOMIDOperations = {
  /**
   * Updates a component's children by processing a series of updates.
   *
   * @param {array<object>} updates List of update configurations.
   * @internal
   */
  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
    DOMChildrenOperations.processUpdates(node, updates);
  }
};

module.exports = ReactDOMIDOperations;

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/* global hasOwnProperty:true */



var _prodInvariant = __webpack_require__(1),
    _assign = __webpack_require__(3);

var AutoFocusUtils = __webpack_require__(185);
var CSSPropertyOperations = __webpack_require__(186);
var DOMLazyTree = __webpack_require__(21);
var DOMNamespaces = __webpack_require__(44);
var DOMProperty = __webpack_require__(19);
var DOMPropertyOperations = __webpack_require__(85);
var EventPluginHub = __webpack_require__(24);
var EventPluginRegistry = __webpack_require__(37);
var ReactBrowserEventEmitter = __webpack_require__(32);
var ReactDOMComponentFlags = __webpack_require__(73);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMInput = __webpack_require__(196);
var ReactDOMOption = __webpack_require__(198);
var ReactDOMSelect = __webpack_require__(86);
var ReactDOMTextarea = __webpack_require__(199);
var ReactInstrumentation = __webpack_require__(9);
var ReactMultiChild = __webpack_require__(200);
var ReactServerRenderingTransaction = __webpack_require__(207);

var emptyFunction = __webpack_require__(10);
var escapeTextContentForBrowser = __webpack_require__(31);
var invariant = __webpack_require__(0);
var isEventSupported = __webpack_require__(41);
var shallowEqual = __webpack_require__(48);
var inputValueTracking = __webpack_require__(79);
var validateDOMNesting = __webpack_require__(52);
var warning = __webpack_require__(2);

var Flags = ReactDOMComponentFlags;
var deleteListener = EventPluginHub.deleteListener;
var getNode = ReactDOMComponentTree.getNodeFromInstance;
var listenTo = ReactBrowserEventEmitter.listenTo;
var registrationNameModules = EventPluginRegistry.registrationNameModules;

// For quickly matching children type, to test if can be treated as content.
var CONTENT_TYPES = { string: true, number: true };

var STYLE = 'style';
var HTML = '__html';
var RESERVED_PROPS = {
  children: null,
  dangerouslySetInnerHTML: null,
  suppressContentEditableWarning: null
};

// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
var DOC_FRAGMENT_TYPE = 11;

function getDeclarationErrorAddendum(internalInstance) {
  if (internalInstance) {
    var owner = internalInstance._currentElement._owner || null;
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' This DOM node was rendered by `' + name + '`.';
      }
    }
  }
  return '';
}

function friendlyStringify(obj) {
  if (typeof obj === 'object') {
    if (Array.isArray(obj)) {
      return '[' + obj.map(friendlyStringify).join(', ') + ']';
    } else {
      var pairs = [];
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
        }
      }
      return '{' + pairs.join(', ') + '}';
    }
  } else if (typeof obj === 'string') {
    return JSON.stringify(obj);
  } else if (typeof obj === 'function') {
    return '[function object]';
  }
  // Differs from JSON.stringify in that undefined because undefined and that
  // inf and nan don't become null
  return String(obj);
}

var styleMutationWarning = {};

function checkAndWarnForMutatedStyle(style1, style2, component) {
  if (style1 == null || style2 == null) {
    return;
  }
  if (shallowEqual(style1, style2)) {
    return;
  }

  var componentName = component._tag;
  var owner = component._currentElement._owner;
  var ownerName;
  if (owner) {
    ownerName = owner.getName();
  }

  var hash = ownerName + '|' + componentName;

  if (styleMutationWarning.hasOwnProperty(hash)) {
    return;
  }

  styleMutationWarning[hash] = true;

   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
}

/**
 * @param {object} component
 * @param {?object} props
 */
function assertValidProps(component, props) {
  if (!props) {
    return;
  }
  // Note the use of `==` which checks for null or undefined.
  if (voidElementTags[component._tag]) {
    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
  }
  if (props.dangerouslySetInnerHTML != null) {
    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
  }
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
  }
  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
}

function enqueuePutListener(inst, registrationName, listener, transaction) {
  if (transaction instanceof ReactServerRenderingTransaction) {
    return;
  }
  if (false) {
    // IE8 has no API for event capturing and the `onScroll` event doesn't
    // bubble.
    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
  }
  var containerInfo = inst._hostContainerInfo;
  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
  listenTo(registrationName, doc);
  transaction.getReactMountReady().enqueue(putListener, {
    inst: inst,
    registrationName: registrationName,
    listener: listener
  });
}

function putListener() {
  var listenerToPut = this;
  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
}

function inputPostMount() {
  var inst = this;
  ReactDOMInput.postMountWrapper(inst);
}

function textareaPostMount() {
  var inst = this;
  ReactDOMTextarea.postMountWrapper(inst);
}

function optionPostMount() {
  var inst = this;
  ReactDOMOption.postMountWrapper(inst);
}

var setAndValidateContentChildDev = emptyFunction;
if (false) {
  setAndValidateContentChildDev = function (content) {
    var hasExistingContent = this._contentDebugID != null;
    var debugID = this._debugID;
    // This ID represents the inlined child that has no backing instance:
    var contentDebugID = -debugID;

    if (content == null) {
      if (hasExistingContent) {
        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
      }
      this._contentDebugID = null;
      return;
    }

    validateDOMNesting(null, String(content), this, this._ancestorInfo);
    this._contentDebugID = contentDebugID;
    if (hasExistingContent) {
      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
    } else {
      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
    }
  };
}

// There are so many media events, it makes sense to just
// maintain a list rather than create a `trapBubbledEvent` for each
var mediaEvents = {
  topAbort: 'abort',
  topCanPlay: 'canplay',
  topCanPlayThrough: 'canplaythrough',
  topDurationChange: 'durationchange',
  topEmptied: 'emptied',
  topEncrypted: 'encrypted',
  topEnded: 'ended',
  topError: 'error',
  topLoadedData: 'loadeddata',
  topLoadedMetadata: 'loadedmetadata',
  topLoadStart: 'loadstart',
  topPause: 'pause',
  topPlay: 'play',
  topPlaying: 'playing',
  topProgress: 'progress',
  topRateChange: 'ratechange',
  topSeeked: 'seeked',
  topSeeking: 'seeking',
  topStalled: 'stalled',
  topSuspend: 'suspend',
  topTimeUpdate: 'timeupdate',
  topVolumeChange: 'volumechange',
  topWaiting: 'waiting'
};

function trackInputValue() {
  inputValueTracking.track(this);
}

function trapBubbledEventsLocal() {
  var inst = this;
  // If a component renders to null or if another component fatals and causes
  // the state of the tree to be corrupted, `node` here can be null.
  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
  var node = getNode(inst);
  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;

  switch (inst._tag) {
    case 'iframe':
    case 'object':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'video':
    case 'audio':
      inst._wrapperState.listeners = [];
      // Create listener for each media event
      for (var event in mediaEvents) {
        if (mediaEvents.hasOwnProperty(event)) {
          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
        }
      }
      break;
    case 'source':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
      break;
    case 'img':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
      break;
    case 'form':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
      break;
    case 'input':
    case 'select':
    case 'textarea':
      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
      break;
  }
}

function postUpdateSelectWrapper() {
  ReactDOMSelect.postUpdateWrapper(this);
}

// For HTML, certain tags should omit their close tag. We keep a whitelist for
// those special-case tags.

var omittedCloseTags = {
  area: true,
  base: true,
  br: true,
  col: true,
  embed: true,
  hr: true,
  img: true,
  input: true,
  keygen: true,
  link: true,
  meta: true,
  param: true,
  source: true,
  track: true,
  wbr: true
  // NOTE: menuitem's close tag should be omitted, but that causes problems.
};

var newlineEatingTags = {
  listing: true,
  pre: true,
  textarea: true
};

// For HTML, certain tags cannot have children. This has the same purpose as
// `omittedCloseTags` except that `menuitem` should still have its closing tag.

var voidElementTags = _assign({
  menuitem: true
}, omittedCloseTags);

// We accept any tag to be rendered but since this gets injected into arbitrary
// HTML, we want to make sure that it's a safe tag.
// http://www.w3.org/TR/REC-xml/#NT-Name

var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
var validatedTagCache = {};
var hasOwnProperty = {}.hasOwnProperty;

function validateDangerousTag(tag) {
  if (!hasOwnProperty.call(validatedTagCache, tag)) {
    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
    validatedTagCache[tag] = true;
  }
}

function isCustomComponent(tagName, props) {
  return tagName.indexOf('-') >= 0 || props.is != null;
}

var globalIdCounter = 1;

/**
 * Creates a new React class that is idempotent and capable of containing other
 * React components. It accepts event listeners and DOM properties that are
 * valid according to `DOMProperty`.
 *
 *  - Event listeners: `onClick`, `onMouseDown`, etc.
 *  - DOM properties: `className`, `name`, `title`, etc.
 *
 * The `style` property functions differently from the DOM API. It accepts an
 * object mapping of style properties to values.
 *
 * @constructor ReactDOMComponent
 * @extends ReactMultiChild
 */
function ReactDOMComponent(element) {
  var tag = element.type;
  validateDangerousTag(tag);
  this._currentElement = element;
  this._tag = tag.toLowerCase();
  this._namespaceURI = null;
  this._renderedChildren = null;
  this._previousStyle = null;
  this._previousStyleCopy = null;
  this._hostNode = null;
  this._hostParent = null;
  this._rootNodeID = 0;
  this._domID = 0;
  this._hostContainerInfo = null;
  this._wrapperState = null;
  this._topLevelWrapper = null;
  this._flags = 0;
  if (false) {
    this._ancestorInfo = null;
    setAndValidateContentChildDev.call(this, null);
  }
}

ReactDOMComponent.displayName = 'ReactDOMComponent';

ReactDOMComponent.Mixin = {
  /**
   * Generates root tag markup then recurses. This method has side effects and
   * is not idempotent.
   *
   * @internal
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?ReactDOMComponent} the parent component instance
   * @param {?object} info about the host container
   * @param {object} context
   * @return {string} The computed markup.
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    this._rootNodeID = globalIdCounter++;
    this._domID = hostContainerInfo._idCounter++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var props = this._currentElement.props;

    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        this._wrapperState = {
          listeners: null
        };
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'input':
        ReactDOMInput.mountWrapper(this, props, hostParent);
        props = ReactDOMInput.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'option':
        ReactDOMOption.mountWrapper(this, props, hostParent);
        props = ReactDOMOption.getHostProps(this, props);
        break;
      case 'select':
        ReactDOMSelect.mountWrapper(this, props, hostParent);
        props = ReactDOMSelect.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
      case 'textarea':
        ReactDOMTextarea.mountWrapper(this, props, hostParent);
        props = ReactDOMTextarea.getHostProps(this, props);
        transaction.getReactMountReady().enqueue(trackInputValue, this);
        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
        break;
    }

    assertValidProps(this, props);

    // We create tags in the namespace of their parent container, except HTML
    // tags get no namespace.
    var namespaceURI;
    var parentTag;
    if (hostParent != null) {
      namespaceURI = hostParent._namespaceURI;
      parentTag = hostParent._tag;
    } else if (hostContainerInfo._tag) {
      namespaceURI = hostContainerInfo._namespaceURI;
      parentTag = hostContainerInfo._tag;
    }
    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
      namespaceURI = DOMNamespaces.html;
    }
    if (namespaceURI === DOMNamespaces.html) {
      if (this._tag === 'svg') {
        namespaceURI = DOMNamespaces.svg;
      } else if (this._tag === 'math') {
        namespaceURI = DOMNamespaces.mathml;
      }
    }
    this._namespaceURI = namespaceURI;

    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo._tag) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(this._tag, null, this, parentInfo);
      }
      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
    }

    var mountImage;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var el;
      if (namespaceURI === DOMNamespaces.html) {
        if (this._tag === 'script') {
          // Create the script via .innerHTML so its "parser-inserted" flag is
          // set to true and it does not execute
          var div = ownerDocument.createElement('div');
          var type = this._currentElement.type;
          div.innerHTML = '<' + type + '></' + type + '>';
          el = div.removeChild(div.firstChild);
        } else if (props.is) {
          el = ownerDocument.createElement(this._currentElement.type, props.is);
        } else {
          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
          // See discussion in https://github.com/facebook/react/pull/6896
          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
          el = ownerDocument.createElement(this._currentElement.type);
        }
      } else {
        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
      }
      ReactDOMComponentTree.precacheNode(this, el);
      this._flags |= Flags.hasCachedChildNodes;
      if (!this._hostParent) {
        DOMPropertyOperations.setAttributeForRoot(el);
      }
      this._updateDOMProperties(null, props, transaction);
      var lazyTree = DOMLazyTree(el);
      this._createInitialChildren(transaction, props, context, lazyTree);
      mountImage = lazyTree;
    } else {
      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
      var tagContent = this._createContentMarkup(transaction, props, context);
      if (!tagContent && omittedCloseTags[this._tag]) {
        mountImage = tagOpen + '/>';
      } else {
        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
      }
    }

    switch (this._tag) {
      case 'input':
        transaction.getReactMountReady().enqueue(inputPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'textarea':
        transaction.getReactMountReady().enqueue(textareaPostMount, this);
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'select':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'button':
        if (props.autoFocus) {
          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
        }
        break;
      case 'option':
        transaction.getReactMountReady().enqueue(optionPostMount, this);
        break;
    }

    return mountImage;
  },

  /**
   * Creates markup for the open tag and all attributes.
   *
   * This method has side effects because events get registered.
   *
   * Iterating over object properties is faster than iterating over arrays.
   * @see http://jsperf.com/obj-vs-arr-iteration
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @return {string} Markup of opening tag.
   */
  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
    var ret = '<' + this._currentElement.type;

    for (var propKey in props) {
      if (!props.hasOwnProperty(propKey)) {
        continue;
      }
      var propValue = props[propKey];
      if (propValue == null) {
        continue;
      }
      if (registrationNameModules.hasOwnProperty(propKey)) {
        if (propValue) {
          enqueuePutListener(this, propKey, propValue, transaction);
        }
      } else {
        if (propKey === STYLE) {
          if (propValue) {
            if (false) {
              // See `_updateDOMProperties`. style block
              this._previousStyle = propValue;
            }
            propValue = this._previousStyleCopy = _assign({}, props.style);
          }
          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
        }
        var markup = null;
        if (this._tag != null && isCustomComponent(this._tag, props)) {
          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
          }
        } else {
          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
        }
        if (markup) {
          ret += ' ' + markup;
        }
      }
    }

    // For static pages, no need to put React ID and checksum. Saves lots of
    // bytes.
    if (transaction.renderToStaticMarkup) {
      return ret;
    }

    if (!this._hostParent) {
      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
    }
    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
    return ret;
  },

  /**
   * Creates markup for the content between the tags.
   *
   * @private
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} props
   * @param {object} context
   * @return {string} Content markup.
   */
  _createContentMarkup: function (transaction, props, context) {
    var ret = '';

    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        ret = innerHTML.__html;
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      if (contentToUse != null) {
        // TODO: Validate that text is allowed as a child of this node
        ret = escapeTextContentForBrowser(contentToUse);
        if (false) {
          setAndValidateContentChildDev.call(this, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        ret = mountImages.join('');
      }
    }
    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
      // text/html ignores the first character in these tags if it's a newline
      // Prefer to break application/xml over text/html (for now) by adding
      // a newline specifically to get eaten by the parser. (Alternately for
      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
      // \r is normalized out by HTMLTextAreaElement#value.)
      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
      // See: Parsing of "textarea" "listing" and "pre" elements
      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
      return '\n' + ret;
    } else {
      return ret;
    }
  },

  _createInitialChildren: function (transaction, props, context, lazyTree) {
    // Intentional use of != to avoid catching zero/false.
    var innerHTML = props.dangerouslySetInnerHTML;
    if (innerHTML != null) {
      if (innerHTML.__html != null) {
        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
      }
    } else {
      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
      var childrenToUse = contentToUse != null ? null : props.children;
      // TODO: Validate that text is allowed as a child of this node
      if (contentToUse != null) {
        // Avoid setting textContent when the text is empty. In IE11 setting
        // textContent on a text area will cause the placeholder to not
        // show within the textarea until it has been focused and blurred again.
        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
        if (contentToUse !== '') {
          if (false) {
            setAndValidateContentChildDev.call(this, contentToUse);
          }
          DOMLazyTree.queueText(lazyTree, contentToUse);
        }
      } else if (childrenToUse != null) {
        var mountImages = this.mountChildren(childrenToUse, transaction, context);
        for (var i = 0; i < mountImages.length; i++) {
          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
        }
      }
    }
  },

  /**
   * Receives a next element and updates the component.
   *
   * @internal
   * @param {ReactElement} nextElement
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {object} context
   */
  receiveComponent: function (nextElement, transaction, context) {
    var prevElement = this._currentElement;
    this._currentElement = nextElement;
    this.updateComponent(transaction, prevElement, nextElement, context);
  },

  /**
   * Updates a DOM component after it has already been allocated and
   * attached to the DOM. Reconciles the root DOM node, then recurses.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevElement
   * @param {ReactElement} nextElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevElement, nextElement, context) {
    var lastProps = prevElement.props;
    var nextProps = this._currentElement.props;

    switch (this._tag) {
      case 'input':
        lastProps = ReactDOMInput.getHostProps(this, lastProps);
        nextProps = ReactDOMInput.getHostProps(this, nextProps);
        break;
      case 'option':
        lastProps = ReactDOMOption.getHostProps(this, lastProps);
        nextProps = ReactDOMOption.getHostProps(this, nextProps);
        break;
      case 'select':
        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
        break;
      case 'textarea':
        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
        break;
    }

    assertValidProps(this, nextProps);
    this._updateDOMProperties(lastProps, nextProps, transaction);
    this._updateDOMChildren(lastProps, nextProps, transaction, context);

    switch (this._tag) {
      case 'input':
        // Update the wrapper around inputs *after* updating props. This has to
        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
        // raise warnings and prevent the new value from being assigned.
        ReactDOMInput.updateWrapper(this);

        // We also check that we haven't missed a value update, such as a
        // Radio group shifting the checked value to another named radio input.
        inputValueTracking.updateValueIfChanged(this);
        break;
      case 'textarea':
        ReactDOMTextarea.updateWrapper(this);
        break;
      case 'select':
        // <select> value update needs to occur after <option> children
        // reconciliation
        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
        break;
    }
  },

  /**
   * Reconciles the properties by detecting differences in property values and
   * updating the DOM as necessary. This function is probably the single most
   * critical path for performance optimization.
   *
   * TODO: Benchmark whether checking for changed values in memory actually
   *       improves performance (especially statically positioned elements).
   * TODO: Benchmark the effects of putting this at the top since 99% of props
   *       do not change for a given reconciliation.
   * TODO: Benchmark areas that can be improved with caching.
   *
   * @private
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {?DOMElement} node
   */
  _updateDOMProperties: function (lastProps, nextProps, transaction) {
    var propKey;
    var styleName;
    var styleUpdates;
    for (propKey in lastProps) {
      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
        continue;
      }
      if (propKey === STYLE) {
        var lastStyle = this._previousStyleCopy;
        for (styleName in lastStyle) {
          if (lastStyle.hasOwnProperty(styleName)) {
            styleUpdates = styleUpdates || {};
            styleUpdates[styleName] = '';
          }
        }
        this._previousStyleCopy = null;
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (lastProps[propKey]) {
          // Only call deleteListener if there was a listener previously or
          // else willDeleteListener gets called when there wasn't actually a
          // listener (e.g., onClick={null})
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, lastProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
      }
    }
    for (propKey in nextProps) {
      var nextProp = nextProps[propKey];
      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
        continue;
      }
      if (propKey === STYLE) {
        if (nextProp) {
          if (false) {
            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
            this._previousStyle = nextProp;
          }
          nextProp = this._previousStyleCopy = _assign({}, nextProp);
        } else {
          this._previousStyleCopy = null;
        }
        if (lastProp) {
          // Unset styles on `lastProp` but not on `nextProp`.
          for (styleName in lastProp) {
            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = '';
            }
          }
          // Update styles that changed since `lastProp`.
          for (styleName in nextProp) {
            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
              styleUpdates = styleUpdates || {};
              styleUpdates[styleName] = nextProp[styleName];
            }
          }
        } else {
          // Relies on `updateStylesByID` not mutating `styleUpdates`.
          styleUpdates = nextProp;
        }
      } else if (registrationNameModules.hasOwnProperty(propKey)) {
        if (nextProp) {
          enqueuePutListener(this, propKey, nextProp, transaction);
        } else if (lastProp) {
          deleteListener(this, propKey);
        }
      } else if (isCustomComponent(this._tag, nextProps)) {
        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
        }
      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
        var node = getNode(this);
        // If we're updating to null or undefined, we should remove the property
        // from the DOM node instead of inadvertently setting to a string. This
        // brings us in line with the same behavior we have on initial render.
        if (nextProp != null) {
          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
        } else {
          DOMPropertyOperations.deleteValueForProperty(node, propKey);
        }
      }
    }
    if (styleUpdates) {
      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
    }
  },

  /**
   * Reconciles the children with the various properties that affect the
   * children content.
   *
   * @param {object} lastProps
   * @param {object} nextProps
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   */
  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;

    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;

    // Note the use of `!=` which checks for null or undefined.
    var lastChildren = lastContent != null ? null : lastProps.children;
    var nextChildren = nextContent != null ? null : nextProps.children;

    // If we're switching from children to content/html or vice versa, remove
    // the old content
    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
    if (lastChildren != null && nextChildren == null) {
      this.updateChildren(null, transaction, context);
    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
      this.updateTextContent('');
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    }

    if (nextContent != null) {
      if (lastContent !== nextContent) {
        this.updateTextContent('' + nextContent);
        if (false) {
          setAndValidateContentChildDev.call(this, nextContent);
        }
      }
    } else if (nextHtml != null) {
      if (lastHtml !== nextHtml) {
        this.updateMarkup('' + nextHtml);
      }
      if (false) {
        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
      }
    } else if (nextChildren != null) {
      if (false) {
        setAndValidateContentChildDev.call(this, null);
      }

      this.updateChildren(nextChildren, transaction, context);
    }
  },

  getHostNode: function () {
    return getNode(this);
  },

  /**
   * Destroys all event registrations for this instance. Does not remove from
   * the DOM. That must be done by the parent.
   *
   * @internal
   */
  unmountComponent: function (safely) {
    switch (this._tag) {
      case 'audio':
      case 'form':
      case 'iframe':
      case 'img':
      case 'link':
      case 'object':
      case 'source':
      case 'video':
        var listeners = this._wrapperState.listeners;
        if (listeners) {
          for (var i = 0; i < listeners.length; i++) {
            listeners[i].remove();
          }
        }
        break;
      case 'input':
      case 'textarea':
        inputValueTracking.stopTracking(this);
        break;
      case 'html':
      case 'head':
      case 'body':
        /**
         * Components like <html> <head> and <body> can't be removed or added
         * easily in a cross-browser way, however it's valuable to be able to
         * take advantage of React's reconciliation for styling and <title>
         * management. So we just document it and throw in dangerous cases.
         */
         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
        break;
    }

    this.unmountChildren(safely);
    ReactDOMComponentTree.uncacheNode(this);
    EventPluginHub.deleteAllListeners(this);
    this._rootNodeID = 0;
    this._domID = 0;
    this._wrapperState = null;

    if (false) {
      setAndValidateContentChildDev.call(this, null);
    }
  },

  getPublicInstance: function () {
    return getNode(this);
  }
};

_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);

module.exports = ReactDOMComponent;

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMComponentTree = __webpack_require__(4);

var focusNode = __webpack_require__(83);

var AutoFocusUtils = {
  focusDOMComponent: function () {
    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
  }
};

module.exports = AutoFocusUtils;

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(84);
var ExecutionEnvironment = __webpack_require__(6);
var ReactInstrumentation = __webpack_require__(9);

var camelizeStyleName = __webpack_require__(187);
var dangerousStyleValue = __webpack_require__(189);
var hyphenateStyleName = __webpack_require__(190);
var memoizeStringOnly = __webpack_require__(192);
var warning = __webpack_require__(2);

var processStyleName = memoizeStringOnly(function (styleName) {
  return hyphenateStyleName(styleName);
});

var hasShorthandPropertyBug = false;
var styleFloatAccessor = 'cssFloat';
if (ExecutionEnvironment.canUseDOM) {
  var tempStyle = document.createElement('div').style;
  try {
    // IE8 throws "Invalid argument." if resetting shorthand style properties.
    tempStyle.font = '';
  } catch (e) {
    hasShorthandPropertyBug = true;
  }
  // IE8 only supports accessing cssFloat (standard) as styleFloat
  if (document.documentElement.style.cssFloat === undefined) {
    styleFloatAccessor = 'styleFloat';
  }
}

if (false) {
  // 'msTransform' is correct, but the other prefixes should be capitalized
  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;

  // style values shouldn't contain a semicolon
  var badStyleValueWithSemicolonPattern = /;\s*$/;

  var warnedStyleNames = {};
  var warnedStyleValues = {};
  var warnedForNaNValue = false;

  var warnHyphenatedStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
  };

  var warnBadVendoredStyleName = function (name, owner) {
    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
      return;
    }

    warnedStyleNames[name] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
  };

  var warnStyleValueWithSemicolon = function (name, value, owner) {
    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
      return;
    }

    warnedStyleValues[value] = true;
    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
  };

  var warnStyleValueIsNaN = function (name, value, owner) {
    if (warnedForNaNValue) {
      return;
    }

    warnedForNaNValue = true;
    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
  };

  var checkRenderMessage = function (owner) {
    if (owner) {
      var name = owner.getName();
      if (name) {
        return ' Check the render method of `' + name + '`.';
      }
    }
    return '';
  };

  /**
   * @param {string} name
   * @param {*} value
   * @param {ReactDOMComponent} component
   */
  var warnValidStyle = function (name, value, component) {
    var owner;
    if (component) {
      owner = component._currentElement._owner;
    }
    if (name.indexOf('-') > -1) {
      warnHyphenatedStyleName(name, owner);
    } else if (badVendoredStyleNamePattern.test(name)) {
      warnBadVendoredStyleName(name, owner);
    } else if (badStyleValueWithSemicolonPattern.test(value)) {
      warnStyleValueWithSemicolon(name, value, owner);
    }

    if (typeof value === 'number' && isNaN(value)) {
      warnStyleValueIsNaN(name, value, owner);
    }
  };
}

/**
 * Operations for dealing with CSS properties.
 */
var CSSPropertyOperations = {
  /**
   * Serializes a mapping of style properties for use as inline styles:
   *
   *   > createMarkupForStyles({width: '200px', height: 0})
   *   "width:200px;height:0;"
   *
   * Undefined values are ignored so that declarative programming is easier.
   * The result should be HTML-escaped before insertion into the DOM.
   *
   * @param {object} styles
   * @param {ReactDOMComponent} component
   * @return {?string}
   */
  createMarkupForStyles: function (styles, component) {
    var serialized = '';
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      var styleValue = styles[styleName];
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styleValue, component);
        }
      }
      if (styleValue != null) {
        serialized += processStyleName(styleName) + ':';
        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
      }
    }
    return serialized || null;
  },

  /**
   * Sets the value for multiple styles on a node.  If a value is specified as
   * '' (empty string), the corresponding style property will be unset.
   *
   * @param {DOMElement} node
   * @param {object} styles
   * @param {ReactDOMComponent} component
   */
  setValueForStyles: function (node, styles, component) {
    if (false) {
      ReactInstrumentation.debugTool.onHostOperation({
        instanceID: component._debugID,
        type: 'update styles',
        payload: styles
      });
    }

    var style = node.style;
    for (var styleName in styles) {
      if (!styles.hasOwnProperty(styleName)) {
        continue;
      }
      var isCustomProperty = styleName.indexOf('--') === 0;
      if (false) {
        if (!isCustomProperty) {
          warnValidStyle(styleName, styles[styleName], component);
        }
      }
      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
      if (styleName === 'float' || styleName === 'cssFloat') {
        styleName = styleFloatAccessor;
      }
      if (isCustomProperty) {
        style.setProperty(styleName, styleValue);
      } else if (styleValue) {
        style[styleName] = styleValue;
      } else {
        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
        if (expansion) {
          // Shorthand property that IE8 won't like unsetting, so unset each
          // component to placate it
          for (var individualStyleName in expansion) {
            style[individualStyleName] = '';
          }
        } else {
          style[styleName] = '';
        }
      }
    }
  }
};

module.exports = CSSPropertyOperations;

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var camelize = __webpack_require__(188);

var msPattern = /^-ms-/;

/**
 * Camelcases a hyphenated CSS property name, for example:
 *
 *   > camelizeStyleName('background-color')
 *   < "backgroundColor"
 *   > camelizeStyleName('-moz-transition')
 *   < "MozTransition"
 *   > camelizeStyleName('-ms-transition')
 *   < "msTransition"
 *
 * As Andi Smith suggests
 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
 * is converted to lowercase `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function camelizeStyleName(string) {
  return camelize(string.replace(msPattern, 'ms-'));
}

module.exports = camelizeStyleName;

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _hyphenPattern = /-(.)/g;

/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */
function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var CSSProperty = __webpack_require__(84);
var warning = __webpack_require__(2);

var isUnitlessNumber = CSSProperty.isUnitlessNumber;
var styleWarnings = {};

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @param {ReactDOMComponent} component
 * @return {string} Normalized style value with dimensions applied.
 */
function dangerousStyleValue(name, value, component, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901

  var isEmpty = value == null || typeof value === 'boolean' || value === '';
  if (isEmpty) {
    return '';
  }

  var isNonNumeric = isNaN(value);
  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
    return '' + value; // cast to string
  }

  if (typeof value === 'string') {
    if (false) {
      // Allow '0' to pass through without warning. 0 is already special and
      // doesn't require units, so we don't need to warn about it.
      if (component && value !== '0') {
        var owner = component._currentElement._owner;
        var ownerName = owner ? owner.getName() : null;
        if (ownerName && !styleWarnings[ownerName]) {
          styleWarnings[ownerName] = {};
        }
        var warned = false;
        if (ownerName) {
          var warnings = styleWarnings[ownerName];
          warned = warnings[name];
          if (!warned) {
            warnings[name] = true;
          }
        }
        if (!warned) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
        }
      }
    }
    value = value.trim();
  }
  return value + 'px';
}

module.exports = dangerousStyleValue;

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(191);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */



/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }
    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var escapeTextContentForBrowser = __webpack_require__(31);

/**
 * Escapes attribute value to prevent scripting attacks.
 *
 * @param {*} value Value to escape.
 * @return {string} An escaped string.
 */
function quoteAttributeValueForBrowser(value) {
  return '"' + escapeTextContentForBrowser(value) + '"';
}

module.exports = quoteAttributeValueForBrowser;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPluginHub = __webpack_require__(24);

function runEventQueueInBatch(events) {
  EventPluginHub.enqueueEvents(events);
  EventPluginHub.processEventQueue(false);
}

var ReactEventEmitterMixin = {
  /**
   * Streams a fired top-level event to `EventPluginHub` where plugins have the
   * opportunity to create `ReactEvent`s to be dispatched.
   */
  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
    runEventQueueInBatch(events);
  }
};

module.exports = ReactEventEmitterMixin;

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

/**
 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
 *
 * @param {string} styleProp
 * @param {string} eventName
 * @returns {object}
 */
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};

  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
  prefixes['Moz' + styleProp] = 'moz' + eventName;
  prefixes['ms' + styleProp] = 'MS' + eventName;
  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();

  return prefixes;
}

/**
 * A list of event names to a configurable list of vendor prefixes.
 */
var vendorPrefixes = {
  animationend: makePrefixMap('Animation', 'AnimationEnd'),
  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
  animationstart: makePrefixMap('Animation', 'AnimationStart'),
  transitionend: makePrefixMap('Transition', 'TransitionEnd')
};

/**
 * Event names that have already been detected and prefixed (if applicable).
 */
var prefixedEventNames = {};

/**
 * Element to check for prefixes on.
 */
var style = {};

/**
 * Bootstrap if a DOM exists.
 */
if (ExecutionEnvironment.canUseDOM) {
  style = document.createElement('div').style;

  // On some platforms, in particular some releases of Android 4.x,
  // the un-prefixed "animation" and "transition" properties are defined on the
  // style object but the events that fire will still be prefixed, so we need
  // to check if the un-prefixed events are usable, and if not remove them from the map.
  if (!('AnimationEvent' in window)) {
    delete vendorPrefixes.animationend.animation;
    delete vendorPrefixes.animationiteration.animation;
    delete vendorPrefixes.animationstart.animation;
  }

  // Same as above
  if (!('TransitionEvent' in window)) {
    delete vendorPrefixes.transitionend.transition;
  }
}

/**
 * Attempts to determine the correct vendor prefixed event name.
 *
 * @param {string} eventName
 * @returns {string}
 */
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  } else if (!vendorPrefixes[eventName]) {
    return eventName;
  }

  var prefixMap = vendorPrefixes[eventName];

  for (var styleProp in prefixMap) {
    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
      return prefixedEventNames[eventName] = prefixMap[styleProp];
    }
  }

  return '';
}

module.exports = getVendorPrefixedEventName;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1),
    _assign = __webpack_require__(3);

var DOMPropertyOperations = __webpack_require__(85);
var LinkedValueUtils = __webpack_require__(46);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

var didWarnValueLink = false;
var didWarnCheckedLink = false;
var didWarnValueDefaultValue = false;
var didWarnCheckedDefaultChecked = false;
var didWarnControlledToUncontrolled = false;
var didWarnUncontrolledToControlled = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMInput.updateWrapper(this);
  }
}

function isControlled(props) {
  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
  return usesChecked ? props.checked != null : props.value != null;
}

/**
 * Implements an <input> host component that allows setting these optional
 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
 *
 * If `checked` or `value` are not supplied (or null/undefined), user actions
 * that affect the checked state or value will trigger updates to the element.
 *
 * If they are supplied (and not null/undefined), the rendered element will not
 * trigger updates to the element. Instead, the props must change in order for
 * the rendered element to be updated.
 *
 * The rendered element will be initialized as unchecked (or `defaultChecked`)
 * with an empty value (or `defaultValue`).
 *
 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
 */
var ReactDOMInput = {
  getHostProps: function (inst, props) {
    var value = LinkedValueUtils.getValue(props);
    var checked = LinkedValueUtils.getChecked(props);

    var hostProps = _assign({
      // Make sure we set .type before any other properties (setting .value
      // before .type means .value is lost in IE11 and below)
      type: undefined,
      // Make sure we set .step before .value (setting .value before .step
      // means .value is rounded on mount, based upon step precision)
      step: undefined,
      // Make sure we set .min & .max before .value (to ensure proper order
      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
      min: undefined,
      max: undefined
    }, props, {
      defaultChecked: undefined,
      defaultValue: undefined,
      value: value != null ? value : inst._wrapperState.initialValue,
      checked: checked != null ? checked : inst._wrapperState.initialChecked,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);

      var owner = inst._currentElement._owner;

      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnCheckedLink = true;
      }
      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnCheckedDefaultChecked = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnValueDefaultValue = true;
      }
    }

    var defaultValue = props.defaultValue;
    inst._wrapperState = {
      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
      initialValue: props.value != null ? props.value : defaultValue,
      listeners: null,
      onChange: _handleChange.bind(inst),
      controlled: isControlled(props)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    if (false) {
      var controlled = isControlled(props);
      var owner = inst._currentElement._owner;

      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnUncontrolledToControlled = true;
      }
      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
        didWarnControlledToUncontrolled = true;
      }
    }

    // TODO: Shouldn't this be getChecked(props)?
    var checked = props.checked;
    if (checked != null) {
      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
    }

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      if (value === 0 && node.value === '') {
        node.value = '0';
        // Note: IE9 reports a number inputs as 'text', so check props instead.
      } else if (props.type === 'number') {
        // Simulate `input.valueAsNumber`. IE9 does not support it
        var valueAsNumber = parseFloat(node.value, 10) || 0;

        if (
        // eslint-disable-next-line
        value != valueAsNumber ||
        // eslint-disable-next-line
        value == valueAsNumber && node.value != value) {
          // Cast `value` to a string to ensure the value is set correctly. While
          // browsers typically do this as necessary, jsdom doesn't.
          node.value = '' + value;
        }
      } else if (node.value !== '' + value) {
        // Cast `value` to a string to ensure the value is set correctly. While
        // browsers typically do this as necessary, jsdom doesn't.
        node.value = '' + value;
      }
    } else {
      if (props.value == null && props.defaultValue != null) {
        // In Chrome, assigning defaultValue to certain input types triggers input validation.
        // For number inputs, the display value loses trailing decimal points. For email inputs,
        // Chrome raises "The specified value <x> is not a valid email address".
        //
        // Here we check to see if the defaultValue has actually changed, avoiding these problems
        // when the user is inputting text
        //
        // https://github.com/facebook/react/issues/7253
        if (node.defaultValue !== '' + props.defaultValue) {
          node.defaultValue = '' + props.defaultValue;
        }
      }
      if (props.checked == null && props.defaultChecked != null) {
        node.defaultChecked = !!props.defaultChecked;
      }
    }
  },

  postMountWrapper: function (inst) {
    var props = inst._currentElement.props;

    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);

    // Detach value from defaultValue. We won't do anything if we're working on
    // submit or reset inputs as those values & defaultValues are linked. They
    // are not resetable nodes so this operation doesn't matter and actually
    // removes browser-default values (eg "Submit Query") when no value is
    // provided.

    switch (props.type) {
      case 'submit':
      case 'reset':
        break;
      case 'color':
      case 'date':
      case 'datetime':
      case 'datetime-local':
      case 'month':
      case 'time':
      case 'week':
        // This fixes the no-show issue on iOS Safari and Android Chrome:
        // https://github.com/facebook/react/issues/7233
        node.value = '';
        node.value = node.defaultValue;
        break;
      default:
        node.value = node.value;
        break;
    }

    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
    // this is needed to work around a chrome bug where setting defaultChecked
    // will sometimes influence the value of checked (even after detachment).
    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
    // We need to temporarily unset name to avoid disrupting radio button groups.
    var name = node.name;
    if (name !== '') {
      node.name = '';
    }
    node.defaultChecked = !node.defaultChecked;
    node.defaultChecked = !node.defaultChecked;
    if (name !== '') {
      node.name = name;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;

  var returnValue = LinkedValueUtils.executeOnChange(props, event);

  // Here we use asap to wait until all updates have propagated, which
  // is important when using controlled components within layers:
  // https://github.com/facebook/react/issues/1698
  ReactUpdates.asap(forceUpdateIfMounted, this);

  var name = props.name;
  if (props.type === 'radio' && name != null) {
    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
    var queryRoot = rootNode;

    while (queryRoot.parentNode) {
      queryRoot = queryRoot.parentNode;
    }

    // If `rootNode.form` was non-null, then we could try `form.elements`,
    // but that sometimes behaves strangely in IE8. We could also try using
    // `form.getElementsByName`, but that will only return direct children
    // and won't include inputs that use the HTML5 `form=` attribute. Since
    // the input might not even be in a form, let's just use the global
    // `querySelectorAll` to ensure we don't miss anything.
    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');

    for (var i = 0; i < group.length; i++) {
      var otherNode = group[i];
      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
        continue;
      }
      // This will throw if radio buttons rendered by different copies of React
      // and the same name are rendered into the same form (same as #1939).
      // That's probably okay; we don't support it just as we don't support
      // mixing React radio buttons with non-React ones.
      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
      // If this is a controlled radio button group, forcing the input that
      // was previously checked to update will cause it to be come re-checked
      // as appropriate.
      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
    }
  }

  return returnValue;
}

module.exports = ReactDOMInput;

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var React = __webpack_require__(17);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactDOMSelect = __webpack_require__(86);

var warning = __webpack_require__(2);
var didWarnInvalidOptionChildren = false;

function flattenChildren(children) {
  var content = '';

  // Flatten children and warn if they aren't strings or numbers;
  // invalid types are ignored.
  React.Children.forEach(children, function (child) {
    if (child == null) {
      return;
    }
    if (typeof child === 'string' || typeof child === 'number') {
      content += child;
    } else if (!didWarnInvalidOptionChildren) {
      didWarnInvalidOptionChildren = true;
       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
    }
  });

  return content;
}

/**
 * Implements an <option> host component that warns when `selected` is set.
 */
var ReactDOMOption = {
  mountWrapper: function (inst, props, hostParent) {
    // TODO (yungsters): Remove support for `selected` in <option>.
    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
    }

    // Look up whether this option is 'selected'
    var selectValue = null;
    if (hostParent != null) {
      var selectParent = hostParent;

      if (selectParent._tag === 'optgroup') {
        selectParent = selectParent._hostParent;
      }

      if (selectParent != null && selectParent._tag === 'select') {
        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
      }
    }

    // If the value is null (e.g., no specified value or after initial mount)
    // or missing (e.g., for <datalist>), we don't change props.selected
    var selected = null;
    if (selectValue != null) {
      var value;
      if (props.value != null) {
        value = props.value + '';
      } else {
        value = flattenChildren(props.children);
      }
      selected = false;
      if (Array.isArray(selectValue)) {
        // multiple
        for (var i = 0; i < selectValue.length; i++) {
          if ('' + selectValue[i] === value) {
            selected = true;
            break;
          }
        }
      } else {
        selected = '' + selectValue === value;
      }
    }

    inst._wrapperState = { selected: selected };
  },

  postMountWrapper: function (inst) {
    // value="" should make a value attribute (#6219)
    var props = inst._currentElement.props;
    if (props.value != null) {
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      node.setAttribute('value', props.value);
    }
  },

  getHostProps: function (inst, props) {
    var hostProps = _assign({ selected: undefined, children: undefined }, props);

    // Read state only from initial mount because <select> updates value
    // manually; we need the initial state only for server rendering
    if (inst._wrapperState.selected != null) {
      hostProps.selected = inst._wrapperState.selected;
    }

    var content = flattenChildren(props.children);

    if (content) {
      hostProps.children = content;
    }

    return hostProps;
  }
};

module.exports = ReactDOMOption;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1),
    _assign = __webpack_require__(3);

var LinkedValueUtils = __webpack_require__(46);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(11);

var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

var didWarnValueLink = false;
var didWarnValDefaultVal = false;

function forceUpdateIfMounted() {
  if (this._rootNodeID) {
    // DOM component is still mounted; update
    ReactDOMTextarea.updateWrapper(this);
  }
}

/**
 * Implements a <textarea> host component that allows setting `value`, and
 * `defaultValue`. This differs from the traditional DOM API because value is
 * usually set as PCDATA children.
 *
 * If `value` is not supplied (or null/undefined), user actions that affect the
 * value will trigger updates to the element.
 *
 * If `value` is supplied (and not null/undefined), the rendered element will
 * not trigger updates to the element. Instead, the `value` prop must change in
 * order for the rendered element to be updated.
 *
 * The rendered element will be initialized with an empty value, the prop
 * `defaultValue` if specified, or the children content (deprecated).
 */
var ReactDOMTextarea = {
  getHostProps: function (inst, props) {
    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;

    // Always set children to the same thing. In IE9, the selection range will
    // get reset if `textContent` is mutated.  We could add a check in setTextContent
    // to only set the value if/when the value differs from the node value (which would
    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
    // The value can be a boolean or object so that's why it's forced to be a string.
    var hostProps = _assign({}, props, {
      value: undefined,
      defaultValue: undefined,
      children: '' + inst._wrapperState.initialValue,
      onChange: inst._wrapperState.onChange
    });

    return hostProps;
  },

  mountWrapper: function (inst, props) {
    if (false) {
      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
      if (props.valueLink !== undefined && !didWarnValueLink) {
        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
        didWarnValueLink = true;
      }
      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
        didWarnValDefaultVal = true;
      }
    }

    var value = LinkedValueUtils.getValue(props);
    var initialValue = value;

    // Only bother fetching default value if we're going to use it
    if (value == null) {
      var defaultValue = props.defaultValue;
      // TODO (yungsters): Remove support for children content in <textarea>.
      var children = props.children;
      if (children != null) {
        if (false) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
        }
        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
        if (Array.isArray(children)) {
          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
          children = children[0];
        }

        defaultValue = '' + children;
      }
      if (defaultValue == null) {
        defaultValue = '';
      }
      initialValue = defaultValue;
    }

    inst._wrapperState = {
      initialValue: '' + initialValue,
      listeners: null,
      onChange: _handleChange.bind(inst)
    };
  },

  updateWrapper: function (inst) {
    var props = inst._currentElement.props;

    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var value = LinkedValueUtils.getValue(props);
    if (value != null) {
      // Cast `value` to a string to ensure the value is set correctly. While
      // browsers typically do this as necessary, jsdom doesn't.
      var newValue = '' + value;

      // To avoid side effects (such as losing text selection), only set value if changed
      if (newValue !== node.value) {
        node.value = newValue;
      }
      if (props.defaultValue == null) {
        node.defaultValue = newValue;
      }
    }
    if (props.defaultValue != null) {
      node.defaultValue = props.defaultValue;
    }
  },

  postMountWrapper: function (inst) {
    // This is in postMount because we need access to the DOM node, which is not
    // available until after the component has mounted.
    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
    var textContent = node.textContent;

    // Only set node.value if textContent is equal to the expected
    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
    // will populate textContent as well.
    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
    if (textContent === inst._wrapperState.initialValue) {
      node.value = textContent;
    }
  }
};

function _handleChange(event) {
  var props = this._currentElement.props;
  var returnValue = LinkedValueUtils.executeOnChange(props, event);
  ReactUpdates.asap(forceUpdateIfMounted, this);
  return returnValue;
}

module.exports = ReactDOMTextarea;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var ReactComponentEnvironment = __webpack_require__(47);
var ReactInstanceMap = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(9);

var ReactCurrentOwner = __webpack_require__(13);
var ReactReconciler = __webpack_require__(20);
var ReactChildReconciler = __webpack_require__(201);

var emptyFunction = __webpack_require__(10);
var flattenChildren = __webpack_require__(206);
var invariant = __webpack_require__(0);

/**
 * Make an update for markup to be rendered and inserted at a supplied index.
 *
 * @param {string} markup Markup that renders into an element.
 * @param {number} toIndex Destination index.
 * @private
 */
function makeInsertMarkup(markup, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'INSERT_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for moving an existing element to another index.
 *
 * @param {number} fromIndex Source index of the existing element.
 * @param {number} toIndex Destination index of the element.
 * @private
 */
function makeMove(child, afterNode, toIndex) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'MOVE_EXISTING',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: ReactReconciler.getHostNode(child),
    toIndex: toIndex,
    afterNode: afterNode
  };
}

/**
 * Make an update for removing an element at an index.
 *
 * @param {number} fromIndex Index of the element to remove.
 * @private
 */
function makeRemove(child, node) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'REMOVE_NODE',
    content: null,
    fromIndex: child._mountIndex,
    fromNode: node,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the markup of a node.
 *
 * @param {string} markup Markup that renders into an element.
 * @private
 */
function makeSetMarkup(markup) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'SET_MARKUP',
    content: markup,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Make an update for setting the text content.
 *
 * @param {string} textContent Text content to set.
 * @private
 */
function makeTextContent(textContent) {
  // NOTE: Null values reduce hidden classes.
  return {
    type: 'TEXT_CONTENT',
    content: textContent,
    fromIndex: null,
    fromNode: null,
    toIndex: null,
    afterNode: null
  };
}

/**
 * Push an update, if any, onto the queue. Creates a new queue if none is
 * passed and always returns the queue. Mutative.
 */
function enqueue(queue, update) {
  if (update) {
    queue = queue || [];
    queue.push(update);
  }
  return queue;
}

/**
 * Processes any enqueued updates.
 *
 * @private
 */
function processQueue(inst, updateQueue) {
  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
}

var setChildrenForInstrumentation = emptyFunction;
if (false) {
  var getDebugID = function (inst) {
    if (!inst._debugID) {
      // Check for ART-like instances. TODO: This is silly/gross.
      var internal;
      if (internal = ReactInstanceMap.get(inst)) {
        inst = internal;
      }
    }
    return inst._debugID;
  };
  setChildrenForInstrumentation = function (children) {
    var debugID = getDebugID(this);
    // TODO: React Native empty components are also multichild.
    // This means they still get into this method but don't have _debugID.
    if (debugID !== 0) {
      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
        return children[key]._debugID;
      }) : []);
    }
  };
}

/**
 * ReactMultiChild are capable of reconciling multiple children.
 *
 * @class ReactMultiChild
 * @internal
 */
var ReactMultiChild = {
  /**
   * Provides common functionality for components that must reconcile multiple
   * children. This is used by `ReactDOMComponent` to mount, update, and
   * unmount child components.
   *
   * @lends {ReactMultiChild.prototype}
   */
  Mixin: {
    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
      if (false) {
        var selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
        }
      }
      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
    },

    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
      var nextChildren;
      var selfDebugID = 0;
      if (false) {
        selfDebugID = getDebugID(this);
        if (this._currentElement) {
          try {
            ReactCurrentOwner.current = this._currentElement._owner;
            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
          } finally {
            ReactCurrentOwner.current = null;
          }
          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
          return nextChildren;
        }
      }
      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
      return nextChildren;
    },

    /**
     * Generates a "mount image" for each of the supplied children. In the case
     * of `ReactDOMComponent`, a mount image is a string of markup.
     *
     * @param {?object} nestedChildren Nested child maps.
     * @return {array} An array of mounted representations.
     * @internal
     */
    mountChildren: function (nestedChildren, transaction, context) {
      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
      this._renderedChildren = children;

      var mountImages = [];
      var index = 0;
      for (var name in children) {
        if (children.hasOwnProperty(name)) {
          var child = children[name];
          var selfDebugID = 0;
          if (false) {
            selfDebugID = getDebugID(this);
          }
          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
          child._mountIndex = index++;
          mountImages.push(mountImage);
        }
      }

      if (false) {
        setChildrenForInstrumentation.call(this, children);
      }

      return mountImages;
    },

    /**
     * Replaces any rendered children with a text content string.
     *
     * @param {string} nextContent String of content.
     * @internal
     */
    updateTextContent: function (nextContent) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      // Set new text content.
      var updates = [makeTextContent(nextContent)];
      processQueue(this, updates);
    },

    /**
     * Replaces any rendered children with a markup string.
     *
     * @param {string} nextMarkup String of markup.
     * @internal
     */
    updateMarkup: function (nextMarkup) {
      var prevChildren = this._renderedChildren;
      // Remove any rendered children.
      ReactChildReconciler.unmountChildren(prevChildren, false);
      for (var name in prevChildren) {
        if (prevChildren.hasOwnProperty(name)) {
           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
        }
      }
      var updates = [makeSetMarkup(nextMarkup)];
      processQueue(this, updates);
    },

    /**
     * Updates the rendered children with new children.
     *
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @internal
     */
    updateChildren: function (nextNestedChildrenElements, transaction, context) {
      // Hook used by React ART
      this._updateChildren(nextNestedChildrenElements, transaction, context);
    },

    /**
     * @param {?object} nextNestedChildrenElements Nested child element maps.
     * @param {ReactReconcileTransaction} transaction
     * @final
     * @protected
     */
    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
      var prevChildren = this._renderedChildren;
      var removedNodes = {};
      var mountImages = [];
      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
      if (!nextChildren && !prevChildren) {
        return;
      }
      var updates = null;
      var name;
      // `nextIndex` will increment for each child in `nextChildren`, but
      // `lastIndex` will be the last index visited in `prevChildren`.
      var nextIndex = 0;
      var lastIndex = 0;
      // `nextMountIndex` will increment for each newly mounted child.
      var nextMountIndex = 0;
      var lastPlacedNode = null;
      for (name in nextChildren) {
        if (!nextChildren.hasOwnProperty(name)) {
          continue;
        }
        var prevChild = prevChildren && prevChildren[name];
        var nextChild = nextChildren[name];
        if (prevChild === nextChild) {
          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
          prevChild._mountIndex = nextIndex;
        } else {
          if (prevChild) {
            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
            // The `removedNodes` loop below will actually remove the child.
          }
          // The child must be instantiated before it's mounted.
          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
          nextMountIndex++;
        }
        nextIndex++;
        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
      }
      // Remove children that are no longer present.
      for (name in removedNodes) {
        if (removedNodes.hasOwnProperty(name)) {
          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
        }
      }
      if (updates) {
        processQueue(this, updates);
      }
      this._renderedChildren = nextChildren;

      if (false) {
        setChildrenForInstrumentation.call(this, nextChildren);
      }
    },

    /**
     * Unmounts all rendered children. This should be used to clean up children
     * when this component is unmounted. It does not actually perform any
     * backend operations.
     *
     * @internal
     */
    unmountChildren: function (safely) {
      var renderedChildren = this._renderedChildren;
      ReactChildReconciler.unmountChildren(renderedChildren, safely);
      this._renderedChildren = null;
    },

    /**
     * Moves a child component to the supplied index.
     *
     * @param {ReactComponent} child Component to move.
     * @param {number} toIndex Destination index of the element.
     * @param {number} lastIndex Last index visited of the siblings of `child`.
     * @protected
     */
    moveChild: function (child, afterNode, toIndex, lastIndex) {
      // If the index of `child` is less than `lastIndex`, then it needs to
      // be moved. Otherwise, we do not need to move it because a child will be
      // inserted or moved before `child`.
      if (child._mountIndex < lastIndex) {
        return makeMove(child, afterNode, toIndex);
      }
    },

    /**
     * Creates a child component.
     *
     * @param {ReactComponent} child Component to create.
     * @param {string} mountImage Markup to insert.
     * @protected
     */
    createChild: function (child, afterNode, mountImage) {
      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
    },

    /**
     * Removes a child component.
     *
     * @param {ReactComponent} child Child to remove.
     * @protected
     */
    removeChild: function (child, node) {
      return makeRemove(child, node);
    },

    /**
     * Mounts a child with the supplied name.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to mount.
     * @param {string} name Name of the child.
     * @param {number} index Index at which to insert the child.
     * @param {ReactReconcileTransaction} transaction
     * @private
     */
    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
      child._mountIndex = index;
      return this.createChild(child, afterNode, mountImage);
    },

    /**
     * Unmounts a rendered child.
     *
     * NOTE: This is part of `updateChildren` and is here for readability.
     *
     * @param {ReactComponent} child Component to unmount.
     * @private
     */
    _unmountChild: function (child, node) {
      var update = this.removeChild(child, node);
      child._mountIndex = null;
      return update;
    }
  }
};

module.exports = ReactMultiChild;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactReconciler = __webpack_require__(20);

var instantiateReactComponent = __webpack_require__(87);
var KeyEscapeUtils = __webpack_require__(50);
var shouldUpdateReactComponent = __webpack_require__(49);
var traverseAllChildren = __webpack_require__(91);
var warning = __webpack_require__(2);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(92);
}

function instantiateChild(childInstances, child, name, selfDebugID) {
  // We found a component instance.
  var keyUnique = childInstances[name] === undefined;
  if (false) {
    if (!ReactComponentTreeHook) {
      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
    }
    if (!keyUnique) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
    }
  }
  if (child != null && keyUnique) {
    childInstances[name] = instantiateReactComponent(child, true);
  }
}

/**
 * ReactChildReconciler provides helpers for initializing or updating a set of
 * children. Its output is suitable for passing it onto ReactMultiChild which
 * does diffed reordering and insertion.
 */
var ReactChildReconciler = {
  /**
   * Generates a "mount image" for each of the supplied children. In the case
   * of `ReactDOMComponent`, a mount image is a string of markup.
   *
   * @param {?object} nestedChildNodes Nested child maps.
   * @return {?object} A set of child instances.
   * @internal
   */
  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
  {
    if (nestedChildNodes == null) {
      return null;
    }
    var childInstances = {};

    if (false) {
      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
        return instantiateChild(childInsts, child, name, selfDebugID);
      }, childInstances);
    } else {
      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
    }
    return childInstances;
  },

  /**
   * Updates the rendered children and returns a new set of children.
   *
   * @param {?object} prevChildren Previously initialized set of children.
   * @param {?object} nextChildren Flat child element maps.
   * @param {ReactReconcileTransaction} transaction
   * @param {object} context
   * @return {?object} A new set of child instances.
   * @internal
   */
  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
  {
    // We currently don't have a way to track moves here but if we use iterators
    // instead of for..in we can zip the iterators and check if an item has
    // moved.
    // TODO: If nothing has changed, return the prevChildren object so that we
    // can quickly bailout if nothing has changed.
    if (!nextChildren && !prevChildren) {
      return;
    }
    var name;
    var prevChild;
    for (name in nextChildren) {
      if (!nextChildren.hasOwnProperty(name)) {
        continue;
      }
      prevChild = prevChildren && prevChildren[name];
      var prevElement = prevChild && prevChild._currentElement;
      var nextElement = nextChildren[name];
      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
        nextChildren[name] = prevChild;
      } else {
        if (prevChild) {
          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
          ReactReconciler.unmountComponent(prevChild, false);
        }
        // The child must be instantiated before it's mounted.
        var nextChildInstance = instantiateReactComponent(nextElement, true);
        nextChildren[name] = nextChildInstance;
        // Creating mount image now ensures refs are resolved in right order
        // (see https://github.com/facebook/react/pull/7101 for explanation).
        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
        mountImages.push(nextChildMountImage);
      }
    }
    // Unmount children that are no longer present.
    for (name in prevChildren) {
      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
        prevChild = prevChildren[name];
        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
        ReactReconciler.unmountComponent(prevChild, false);
      }
    }
  },

  /**
   * Unmounts all rendered children. This should be used to clean up children
   * when this component is unmounted.
   *
   * @param {?object} renderedChildren Previously initialized set of children.
   * @internal
   */
  unmountChildren: function (renderedChildren, safely) {
    for (var name in renderedChildren) {
      if (renderedChildren.hasOwnProperty(name)) {
        var renderedChild = renderedChildren[name];
        ReactReconciler.unmountComponent(renderedChild, safely);
      }
    }
  }
};

module.exports = ReactChildReconciler;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1),
    _assign = __webpack_require__(3);

var React = __webpack_require__(17);
var ReactComponentEnvironment = __webpack_require__(47);
var ReactCurrentOwner = __webpack_require__(13);
var ReactErrorUtils = __webpack_require__(39);
var ReactInstanceMap = __webpack_require__(26);
var ReactInstrumentation = __webpack_require__(9);
var ReactNodeTypes = __webpack_require__(88);
var ReactReconciler = __webpack_require__(20);

if (false) {
  var checkReactTypeSpec = require('./checkReactTypeSpec');
}

var emptyObject = __webpack_require__(35);
var invariant = __webpack_require__(0);
var shallowEqual = __webpack_require__(48);
var shouldUpdateReactComponent = __webpack_require__(49);
var warning = __webpack_require__(2);

var CompositeTypes = {
  ImpureClass: 0,
  PureClass: 1,
  StatelessFunctional: 2
};

function StatelessComponent(Component) {}
StatelessComponent.prototype.render = function () {
  var Component = ReactInstanceMap.get(this)._currentElement.type;
  var element = Component(this.props, this.context, this.updater);
  warnIfInvalidElement(Component, element);
  return element;
};

function warnIfInvalidElement(Component, element) {
  if (false) {
    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
  }
}

function shouldConstruct(Component) {
  return !!(Component.prototype && Component.prototype.isReactComponent);
}

function isPureComponent(Component) {
  return !!(Component.prototype && Component.prototype.isPureReactComponent);
}

// Separated into a function to contain deoptimizations caused by try/finally.
function measureLifeCyclePerf(fn, debugID, timerType) {
  if (debugID === 0) {
    // Top-level wrappers (see ReactMount) and empty components (see
    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
    // Both are implementation details that should go away in the future.
    return fn();
  }

  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
  try {
    return fn();
  } finally {
    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
  }
}

/**
 * ------------------ The Life-Cycle of a Composite Component ------------------
 *
 * - constructor: Initialization of state. The instance is now retained.
 *   - componentWillMount
 *   - render
 *   - [children's constructors]
 *     - [children's componentWillMount and render]
 *     - [children's componentDidMount]
 *     - componentDidMount
 *
 *       Update Phases:
 *       - componentWillReceiveProps (only called if parent updated)
 *       - shouldComponentUpdate
 *         - componentWillUpdate
 *           - render
 *           - [children's constructors or receive props phases]
 *         - componentDidUpdate
 *
 *     - componentWillUnmount
 *     - [children's componentWillUnmount]
 *   - [children destroyed]
 * - (destroyed): The instance is now blank, released by React and ready for GC.
 *
 * -----------------------------------------------------------------------------
 */

/**
 * An incrementing ID assigned to each component when it is mounted. This is
 * used to enforce the order in which `ReactUpdates` updates dirty components.
 *
 * @private
 */
var nextMountID = 1;

/**
 * @lends {ReactCompositeComponent.prototype}
 */
var ReactCompositeComponent = {
  /**
   * Base constructor for all composite component.
   *
   * @param {ReactElement} element
   * @final
   * @internal
   */
  construct: function (element) {
    this._currentElement = element;
    this._rootNodeID = 0;
    this._compositeType = null;
    this._instance = null;
    this._hostParent = null;
    this._hostContainerInfo = null;

    // See ReactUpdateQueue
    this._updateBatchNumber = null;
    this._pendingElement = null;
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    this._renderedNodeType = null;
    this._renderedComponent = null;
    this._context = null;
    this._mountOrder = 0;
    this._topLevelWrapper = null;

    // See ReactUpdates and ReactUpdateQueue.
    this._pendingCallbacks = null;

    // ComponentWillUnmount shall only be called once
    this._calledComponentWillUnmount = false;

    if (false) {
      this._warnedAboutRefsInRender = false;
    }
  },

  /**
   * Initializes the component, renders markup, and registers event listeners.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @param {?object} hostParent
   * @param {?object} hostContainerInfo
   * @param {?object} context
   * @return {?string} Rendered markup to be inserted into the DOM.
   * @final
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var _this = this;

    this._context = context;
    this._mountOrder = nextMountID++;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var publicProps = this._currentElement.props;
    var publicContext = this._processContext(context);

    var Component = this._currentElement.type;

    var updateQueue = transaction.getUpdateQueue();

    // Initialize the public class
    var doConstruct = shouldConstruct(Component);
    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
    var renderedElement;

    // Support functional components
    if (!doConstruct && (inst == null || inst.render == null)) {
      renderedElement = inst;
      warnIfInvalidElement(Component, renderedElement);
      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
      inst = new StatelessComponent(Component);
      this._compositeType = CompositeTypes.StatelessFunctional;
    } else {
      if (isPureComponent(Component)) {
        this._compositeType = CompositeTypes.PureClass;
      } else {
        this._compositeType = CompositeTypes.ImpureClass;
      }
    }

    if (false) {
      // This will throw later in _renderValidatedComponent, but add an early
      // warning now to help debugging
      if (inst.render == null) {
        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
      }

      var propsMutated = inst.props !== publicProps;
      var componentName = Component.displayName || Component.name || 'Component';

      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
    }

    // These should be set up in the constructor, but as a convenience for
    // simpler class abstractions, we set them up after the fact.
    inst.props = publicProps;
    inst.context = publicContext;
    inst.refs = emptyObject;
    inst.updater = updateQueue;

    this._instance = inst;

    // Store a reference from the instance back to the internal representation
    ReactInstanceMap.set(inst, this);

    if (false) {
      // Since plain JS classes are defined without any special initialization
      // logic, we can not catch common errors early. Therefore, we have to
      // catch them here, at initialization time, instead.
      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
    }

    var initialState = inst.state;
    if (initialState === undefined) {
      inst.state = initialState = null;
    }
    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;

    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;

    var markup;
    if (inst.unstable_handleError) {
      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } else {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }

    if (inst.componentDidMount) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(function () {
            return inst.componentDidMount();
          }, _this._debugID, 'componentDidMount');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
      }
    }

    return markup;
  },

  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
    if (false) {
      ReactCurrentOwner.current = this;
      try {
        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
    }
  },

  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
    var Component = this._currentElement.type;

    if (doConstruct) {
      if (false) {
        return measureLifeCyclePerf(function () {
          return new Component(publicProps, publicContext, updateQueue);
        }, this._debugID, 'ctor');
      } else {
        return new Component(publicProps, publicContext, updateQueue);
      }
    }

    // This can still be an instance in case of factory components
    // but we'll count this as time spent rendering as the more common case.
    if (false) {
      return measureLifeCyclePerf(function () {
        return Component(publicProps, publicContext, updateQueue);
      }, this._debugID, 'render');
    } else {
      return Component(publicProps, publicContext, updateQueue);
    }
  },

  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var markup;
    var checkpoint = transaction.checkpoint();
    try {
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    } catch (e) {
      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
      transaction.rollback(checkpoint);
      this._instance.unstable_handleError(e);
      if (this._pendingStateQueue) {
        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
      }
      checkpoint = transaction.checkpoint();

      this._renderedComponent.unmountComponent(true);
      transaction.rollback(checkpoint);

      // Try again - we've informed the component about the error, so they can render an error message this time.
      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
    }
    return markup;
  },

  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
    var inst = this._instance;

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (inst.componentWillMount) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillMount();
        }, debugID, 'componentWillMount');
      } else {
        inst.componentWillMount();
      }
      // When mounting, calls to `setState` by `componentWillMount` will set
      // `this._pendingStateQueue` without triggering a re-render.
      if (this._pendingStateQueue) {
        inst.state = this._processPendingState(inst.props, inst.context);
      }
    }

    // If not a stateless component, we now render
    if (renderedElement === undefined) {
      renderedElement = this._renderValidatedComponent();
    }

    var nodeType = ReactNodeTypes.getType(renderedElement);
    this._renderedNodeType = nodeType;
    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
    );
    this._renderedComponent = child;

    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);

    if (false) {
      if (debugID !== 0) {
        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
      }
    }

    return markup;
  },

  getHostNode: function () {
    return ReactReconciler.getHostNode(this._renderedComponent);
  },

  /**
   * Releases any resources allocated by `mountComponent`.
   *
   * @final
   * @internal
   */
  unmountComponent: function (safely) {
    if (!this._renderedComponent) {
      return;
    }

    var inst = this._instance;

    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
      inst._calledComponentWillUnmount = true;

      if (safely) {
        var name = this.getName() + '.componentWillUnmount()';
        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
      } else {
        if (false) {
          measureLifeCyclePerf(function () {
            return inst.componentWillUnmount();
          }, this._debugID, 'componentWillUnmount');
        } else {
          inst.componentWillUnmount();
        }
      }
    }

    if (this._renderedComponent) {
      ReactReconciler.unmountComponent(this._renderedComponent, safely);
      this._renderedNodeType = null;
      this._renderedComponent = null;
      this._instance = null;
    }

    // Reset pending fields
    // Even if this component is scheduled for another update in ReactUpdates,
    // it would still be ignored because these fields are reset.
    this._pendingStateQueue = null;
    this._pendingReplaceState = false;
    this._pendingForceUpdate = false;
    this._pendingCallbacks = null;
    this._pendingElement = null;

    // These fields do not really need to be reset since this object is no
    // longer accessible.
    this._context = null;
    this._rootNodeID = 0;
    this._topLevelWrapper = null;

    // Delete the reference from the instance to this internal representation
    // which allow the internals to be properly cleaned up even if the user
    // leaks a reference to the public instance.
    ReactInstanceMap.remove(inst);

    // Some existing components rely on inst.props even after they've been
    // destroyed (in event handlers).
    // TODO: inst.props = null;
    // TODO: inst.state = null;
    // TODO: inst.context = null;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _maskContext: function (context) {
    var Component = this._currentElement.type;
    var contextTypes = Component.contextTypes;
    if (!contextTypes) {
      return emptyObject;
    }
    var maskedContext = {};
    for (var contextName in contextTypes) {
      maskedContext[contextName] = context[contextName];
    }
    return maskedContext;
  },

  /**
   * Filters the context object to only contain keys specified in
   * `contextTypes`, and asserts that they are valid.
   *
   * @param {object} context
   * @return {?object}
   * @private
   */
  _processContext: function (context) {
    var maskedContext = this._maskContext(context);
    if (false) {
      var Component = this._currentElement.type;
      if (Component.contextTypes) {
        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
      }
    }
    return maskedContext;
  },

  /**
   * @param {object} currentContext
   * @return {object}
   * @private
   */
  _processChildContext: function (currentContext) {
    var Component = this._currentElement.type;
    var inst = this._instance;
    var childContext;

    if (inst.getChildContext) {
      if (false) {
        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
        try {
          childContext = inst.getChildContext();
        } finally {
          ReactInstrumentation.debugTool.onEndProcessingChildContext();
        }
      } else {
        childContext = inst.getChildContext();
      }
    }

    if (childContext) {
      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
      if (false) {
        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
      }
      for (var name in childContext) {
        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
      }
      return _assign({}, currentContext, childContext);
    }
    return currentContext;
  },

  /**
   * Assert that the context types are valid
   *
   * @param {object} typeSpecs Map of context field to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @private
   */
  _checkContextTypes: function (typeSpecs, values, location) {
    if (false) {
      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
    }
  },

  receiveComponent: function (nextElement, transaction, nextContext) {
    var prevElement = this._currentElement;
    var prevContext = this._context;

    this._pendingElement = null;

    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
  },

  /**
   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
   * is set, update the component.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  performUpdateIfNecessary: function (transaction) {
    if (this._pendingElement != null) {
      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
    } else {
      this._updateBatchNumber = null;
    }
  },

  /**
   * Perform an update to a mounted component. The componentWillReceiveProps and
   * shouldComponentUpdate methods are called, then (assuming the update isn't
   * skipped) the remaining update lifecycle methods are called and the DOM
   * representation is updated.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @param {ReactElement} prevParentElement
   * @param {ReactElement} nextParentElement
   * @internal
   * @overridable
   */
  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
    var inst = this._instance;
    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;

    var willReceive = false;
    var nextContext;

    // Determine if the context has changed or not
    if (this._context === nextUnmaskedContext) {
      nextContext = inst.context;
    } else {
      nextContext = this._processContext(nextUnmaskedContext);
      willReceive = true;
    }

    var prevProps = prevParentElement.props;
    var nextProps = nextParentElement.props;

    // Not a simple state update but a props update
    if (prevParentElement !== nextParentElement) {
      willReceive = true;
    }

    // An update here will schedule an update but immediately set
    // _pendingStateQueue which will ensure that any state updates gets
    // immediately reconciled instead of waiting for the next batch.
    if (willReceive && inst.componentWillReceiveProps) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillReceiveProps(nextProps, nextContext);
        }, this._debugID, 'componentWillReceiveProps');
      } else {
        inst.componentWillReceiveProps(nextProps, nextContext);
      }
    }

    var nextState = this._processPendingState(nextProps, nextContext);
    var shouldUpdate = true;

    if (!this._pendingForceUpdate) {
      if (inst.shouldComponentUpdate) {
        if (false) {
          shouldUpdate = measureLifeCyclePerf(function () {
            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
          }, this._debugID, 'shouldComponentUpdate');
        } else {
          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
        }
      } else {
        if (this._compositeType === CompositeTypes.PureClass) {
          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
        }
      }
    }

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
    }

    this._updateBatchNumber = null;
    if (shouldUpdate) {
      this._pendingForceUpdate = false;
      // Will set `this.props`, `this.state` and `this.context`.
      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
    } else {
      // If it's determined that a component should not update, we still want
      // to set props and state but we shortcut the rest of the update.
      this._currentElement = nextParentElement;
      this._context = nextUnmaskedContext;
      inst.props = nextProps;
      inst.state = nextState;
      inst.context = nextContext;
    }
  },

  _processPendingState: function (props, context) {
    var inst = this._instance;
    var queue = this._pendingStateQueue;
    var replace = this._pendingReplaceState;
    this._pendingReplaceState = false;
    this._pendingStateQueue = null;

    if (!queue) {
      return inst.state;
    }

    if (replace && queue.length === 1) {
      return queue[0];
    }

    var nextState = _assign({}, replace ? queue[0] : inst.state);
    for (var i = replace ? 1 : 0; i < queue.length; i++) {
      var partial = queue[i];
      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
    }

    return nextState;
  },

  /**
   * Merges new props and state, notifies delegate methods of update and
   * performs update.
   *
   * @param {ReactElement} nextElement Next element
   * @param {object} nextProps Next public object to set as properties.
   * @param {?object} nextState Next object to set as state.
   * @param {?object} nextContext Next public object to set as context.
   * @param {ReactReconcileTransaction} transaction
   * @param {?object} unmaskedContext
   * @private
   */
  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
    var _this2 = this;

    var inst = this._instance;

    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
    var prevProps;
    var prevState;
    var prevContext;
    if (hasComponentDidUpdate) {
      prevProps = inst.props;
      prevState = inst.state;
      prevContext = inst.context;
    }

    if (inst.componentWillUpdate) {
      if (false) {
        measureLifeCyclePerf(function () {
          return inst.componentWillUpdate(nextProps, nextState, nextContext);
        }, this._debugID, 'componentWillUpdate');
      } else {
        inst.componentWillUpdate(nextProps, nextState, nextContext);
      }
    }

    this._currentElement = nextElement;
    this._context = unmaskedContext;
    inst.props = nextProps;
    inst.state = nextState;
    inst.context = nextContext;

    this._updateRenderedComponent(transaction, unmaskedContext);

    if (hasComponentDidUpdate) {
      if (false) {
        transaction.getReactMountReady().enqueue(function () {
          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
        });
      } else {
        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
      }
    }
  },

  /**
   * Call the component's `render` method and update the DOM accordingly.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  _updateRenderedComponent: function (transaction, context) {
    var prevComponentInstance = this._renderedComponent;
    var prevRenderedElement = prevComponentInstance._currentElement;
    var nextRenderedElement = this._renderValidatedComponent();

    var debugID = 0;
    if (false) {
      debugID = this._debugID;
    }

    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
    } else {
      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
      ReactReconciler.unmountComponent(prevComponentInstance, false);

      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
      this._renderedNodeType = nodeType;
      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
      );
      this._renderedComponent = child;

      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);

      if (false) {
        if (debugID !== 0) {
          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
        }
      }

      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
    }
  },

  /**
   * Overridden in shallow rendering.
   *
   * @protected
   */
  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
  },

  /**
   * @protected
   */
  _renderValidatedComponentWithoutOwnerOrContext: function () {
    var inst = this._instance;
    var renderedElement;

    if (false) {
      renderedElement = measureLifeCyclePerf(function () {
        return inst.render();
      }, this._debugID, 'render');
    } else {
      renderedElement = inst.render();
    }

    if (false) {
      // We allow auto-mocks to proceed as if they're returning null.
      if (renderedElement === undefined && inst.render._isMockFunction) {
        // This is probably bad practice. Consider warning here and
        // deprecating this convenience.
        renderedElement = null;
      }
    }

    return renderedElement;
  },

  /**
   * @private
   */
  _renderValidatedComponent: function () {
    var renderedElement;
    if ("production" !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
      ReactCurrentOwner.current = this;
      try {
        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
      } finally {
        ReactCurrentOwner.current = null;
      }
    } else {
      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
    }
    !(
    // TODO: An `isValidNode` function would probably be more appropriate
    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;

    return renderedElement;
  },

  /**
   * Lazily allocates the refs object and stores `component` as `ref`.
   *
   * @param {string} ref Reference name.
   * @param {component} component Component to store as `ref`.
   * @final
   * @private
   */
  attachRef: function (ref, component) {
    var inst = this.getPublicInstance();
    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
    var publicComponentInstance = component.getPublicInstance();
    if (false) {
      var componentName = component && component.getName ? component.getName() : 'a component';
      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
    }
    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
    refs[ref] = publicComponentInstance;
  },

  /**
   * Detaches a reference name.
   *
   * @param {string} ref Name to dereference.
   * @final
   * @private
   */
  detachRef: function (ref) {
    var refs = this.getPublicInstance().refs;
    delete refs[ref];
  },

  /**
   * Get a text description of the component that can be used to identify it
   * in error messages.
   * @return {string} The name or null.
   * @internal
   */
  getName: function () {
    var type = this._currentElement.type;
    var constructor = this._instance && this._instance.constructor;
    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
  },

  /**
   * Get the publicly accessible representation of this component - i.e. what
   * is exposed by refs and returned by render. Can be null for stateless
   * components.
   *
   * @return {ReactComponent} the public component instance.
   * @internal
   */
  getPublicInstance: function () {
    var inst = this._instance;
    if (this._compositeType === CompositeTypes.StatelessFunctional) {
      return null;
    }
    return inst;
  },

  // Stub
  _instantiateReactComponent: null
};

module.exports = ReactCompositeComponent;

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var nextDebugID = 1;

function getNextDebugID() {
  return nextDebugID++;
}

module.exports = getNextDebugID;

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var KeyEscapeUtils = __webpack_require__(50);
var traverseAllChildren = __webpack_require__(91);
var warning = __webpack_require__(2);

var ReactComponentTreeHook;

if (typeof process !== 'undefined' && process.env && "production" === 'test') {
  // Temporary hack.
  // Inline requires don't work well with Jest:
  // https://github.com/facebook/react/issues/7240
  // Remove the inline requires when we don't need them anymore:
  // https://github.com/facebook/react/pull/7178
  ReactComponentTreeHook = __webpack_require__(92);
}

/**
 * @param {function} traverseContext Context passed through traversal.
 * @param {?ReactComponent} child React child component.
 * @param {!string} name String name of key path to child.
 * @param {number=} selfDebugID Optional debugID of the current internal instance.
 */
function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
  // We found a component instance.
  if (traverseContext && typeof traverseContext === 'object') {
    var result = traverseContext;
    var keyUnique = result[name] === undefined;
    if (false) {
      if (!ReactComponentTreeHook) {
        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
      }
      if (!keyUnique) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
      }
    }
    if (keyUnique && child != null) {
      result[name] = child;
    }
  }
}

/**
 * Flattens children that are typically specified as `props.children`. Any null
 * children will not be included in the resulting object.
 * @return {!object} flattened children keyed by name.
 */
function flattenChildren(children, selfDebugID) {
  if (children == null) {
    return children;
  }
  var result = {};

  if (false) {
    traverseAllChildren(children, function (traverseContext, child, name) {
      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
    }, result);
  } else {
    traverseAllChildren(children, flattenSingleChildIntoContext, result);
  }
  return result;
}

module.exports = flattenChildren;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(34)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var PooledClass = __webpack_require__(16);
var Transaction = __webpack_require__(28);
var ReactInstrumentation = __webpack_require__(9);
var ReactServerUpdateQueue = __webpack_require__(208);

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

var noopCallbackQueue = {
  enqueue: function () {}
};

/**
 * @class ReactServerRenderingTransaction
 * @param {boolean} renderToStaticMarkup
 */
function ReactServerRenderingTransaction(renderToStaticMarkup) {
  this.reinitializeTransaction();
  this.renderToStaticMarkup = renderToStaticMarkup;
  this.useCreateElement = false;
  this.updateQueue = new ReactServerUpdateQueue(this);
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array} Empty list of operation wrap procedures.
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return noopCallbackQueue;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return this.updateQueue;
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {},

  checkpoint: function () {},

  rollback: function () {}
};

_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactServerRenderingTransaction);

module.exports = ReactServerRenderingTransaction;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ReactUpdateQueue = __webpack_require__(51);

var warning = __webpack_require__(2);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the update queue used for server rendering.
 * It delegates to ReactUpdateQueue while server rendering is in progress and
 * switches to ReactNoopUpdateQueue after the transaction has completed.
 * @class ReactServerUpdateQueue
 * @param {Transaction} transaction
 */

var ReactServerUpdateQueue = function () {
  function ReactServerUpdateQueue(transaction) {
    _classCallCheck(this, ReactServerUpdateQueue);

    this.transaction = transaction;
  }

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */


  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
    return false;
  };

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
    }
  };

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
    } else {
      warnNoop(publicInstance, 'forceUpdate');
    }
  };

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} completeState Next state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
    } else {
      warnNoop(publicInstance, 'replaceState');
    }
  };

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object|function} partialState Next partial state to be merged with state.
   * @internal
   */


  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
    if (this.transaction.isInTransaction()) {
      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
    } else {
      warnNoop(publicInstance, 'setState');
    }
  };

  return ReactServerUpdateQueue;
}();

module.exports = ReactServerUpdateQueue;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var DOMLazyTree = __webpack_require__(21);
var ReactDOMComponentTree = __webpack_require__(4);

var ReactDOMEmptyComponent = function (instantiate) {
  // ReactCompositeComponent uses this:
  this._currentElement = null;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;
  this._hostContainerInfo = null;
  this._domID = 0;
};
_assign(ReactDOMEmptyComponent.prototype, {
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    var domID = hostContainerInfo._idCounter++;
    this._domID = domID;
    this._hostParent = hostParent;
    this._hostContainerInfo = hostContainerInfo;

    var nodeValue = ' react-empty: ' + this._domID + ' ';
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var node = ownerDocument.createComment(nodeValue);
      ReactDOMComponentTree.precacheNode(this, node);
      return DOMLazyTree(node);
    } else {
      if (transaction.renderToStaticMarkup) {
        // Normally we'd insert a comment node, but since this is a situation
        // where React won't take over (static pages), we can simply return
        // nothing.
        return '';
      }
      return '<!--' + nodeValue + '-->';
    }
  },
  receiveComponent: function () {},
  getHostNode: function () {
    return ReactDOMComponentTree.getNodeFromInstance(this);
  },
  unmountComponent: function () {
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMEmptyComponent;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var invariant = __webpack_require__(0);

/**
 * Return the lowest common ancestor of A and B, or null if they are in
 * different trees.
 */
function getLowestCommonAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;

  var depthA = 0;
  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
    depthA++;
  }
  var depthB = 0;
  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
    depthB++;
  }

  // If A is deeper, crawl up.
  while (depthA - depthB > 0) {
    instA = instA._hostParent;
    depthA--;
  }

  // If B is deeper, crawl up.
  while (depthB - depthA > 0) {
    instB = instB._hostParent;
    depthB--;
  }

  // Walk in lockstep until we find a match.
  var depth = depthA;
  while (depth--) {
    if (instA === instB) {
      return instA;
    }
    instA = instA._hostParent;
    instB = instB._hostParent;
  }
  return null;
}

/**
 * Return if A is an ancestor of B.
 */
function isAncestor(instA, instB) {
  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;

  while (instB) {
    if (instB === instA) {
      return true;
    }
    instB = instB._hostParent;
  }
  return false;
}

/**
 * Return the parent instance of the passed-in instance.
 */
function getParentInstance(inst) {
  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;

  return inst._hostParent;
}

/**
 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
 */
function traverseTwoPhase(inst, fn, arg) {
  var path = [];
  while (inst) {
    path.push(inst);
    inst = inst._hostParent;
  }
  var i;
  for (i = path.length; i-- > 0;) {
    fn(path[i], 'captured', arg);
  }
  for (i = 0; i < path.length; i++) {
    fn(path[i], 'bubbled', arg);
  }
}

/**
 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
 * should would receive a `mouseEnter` or `mouseLeave` event.
 *
 * Does not invoke the callback on the nearest common ancestor because nothing
 * "entered" or "left" that element.
 */
function traverseEnterLeave(from, to, fn, argFrom, argTo) {
  var common = from && to ? getLowestCommonAncestor(from, to) : null;
  var pathFrom = [];
  while (from && from !== common) {
    pathFrom.push(from);
    from = from._hostParent;
  }
  var pathTo = [];
  while (to && to !== common) {
    pathTo.push(to);
    to = to._hostParent;
  }
  var i;
  for (i = 0; i < pathFrom.length; i++) {
    fn(pathFrom[i], 'bubbled', argFrom);
  }
  for (i = pathTo.length; i-- > 0;) {
    fn(pathTo[i], 'captured', argTo);
  }
}

module.exports = {
  isAncestor: isAncestor,
  getLowestCommonAncestor: getLowestCommonAncestor,
  getParentInstance: getParentInstance,
  traverseTwoPhase: traverseTwoPhase,
  traverseEnterLeave: traverseEnterLeave
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1),
    _assign = __webpack_require__(3);

var DOMChildrenOperations = __webpack_require__(43);
var DOMLazyTree = __webpack_require__(21);
var ReactDOMComponentTree = __webpack_require__(4);

var escapeTextContentForBrowser = __webpack_require__(31);
var invariant = __webpack_require__(0);
var validateDOMNesting = __webpack_require__(52);

/**
 * Text nodes violate a couple assumptions that React makes about components:
 *
 *  - When mounting text into the DOM, adjacent text nodes are merged.
 *  - Text nodes cannot be assigned a React root ID.
 *
 * This component is used to wrap strings between comment nodes so that they
 * can undergo the same reconciliation that is applied to elements.
 *
 * TODO: Investigate representing React components in the DOM with text nodes.
 *
 * @class ReactDOMTextComponent
 * @extends ReactComponent
 * @internal
 */
var ReactDOMTextComponent = function (text) {
  // TODO: This is really a ReactText (ReactNode), not a ReactElement
  this._currentElement = text;
  this._stringText = '' + text;
  // ReactDOMComponentTree uses these:
  this._hostNode = null;
  this._hostParent = null;

  // Properties
  this._domID = 0;
  this._mountIndex = 0;
  this._closingComment = null;
  this._commentNodes = null;
};

_assign(ReactDOMTextComponent.prototype, {
  /**
   * Creates the markup for this text node. This node is not intended to have
   * any features besides containing text content.
   *
   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
   * @return {string} Markup for this text node.
   * @internal
   */
  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
    if (false) {
      var parentInfo;
      if (hostParent != null) {
        parentInfo = hostParent._ancestorInfo;
      } else if (hostContainerInfo != null) {
        parentInfo = hostContainerInfo._ancestorInfo;
      }
      if (parentInfo) {
        // parentInfo should always be present except for the top-level
        // component when server rendering
        validateDOMNesting(null, this._stringText, this, parentInfo);
      }
    }

    var domID = hostContainerInfo._idCounter++;
    var openingValue = ' react-text: ' + domID + ' ';
    var closingValue = ' /react-text ';
    this._domID = domID;
    this._hostParent = hostParent;
    if (transaction.useCreateElement) {
      var ownerDocument = hostContainerInfo._ownerDocument;
      var openingComment = ownerDocument.createComment(openingValue);
      var closingComment = ownerDocument.createComment(closingValue);
      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
      if (this._stringText) {
        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
      }
      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
      ReactDOMComponentTree.precacheNode(this, openingComment);
      this._closingComment = closingComment;
      return lazyTree;
    } else {
      var escapedText = escapeTextContentForBrowser(this._stringText);

      if (transaction.renderToStaticMarkup) {
        // Normally we'd wrap this between comment nodes for the reasons stated
        // above, but since this is a situation where React won't take over
        // (static pages), we can simply return the text as it is.
        return escapedText;
      }

      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
    }
  },

  /**
   * Updates this component by updating the text content.
   *
   * @param {ReactText} nextText The next text content
   * @param {ReactReconcileTransaction} transaction
   * @internal
   */
  receiveComponent: function (nextText, transaction) {
    if (nextText !== this._currentElement) {
      this._currentElement = nextText;
      var nextStringText = '' + nextText;
      if (nextStringText !== this._stringText) {
        // TODO: Save this as pending props and use performUpdateIfNecessary
        // and/or updateComponent to do the actual update for consistency with
        // other component types?
        this._stringText = nextStringText;
        var commentNodes = this.getHostNode();
        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
      }
    }
  },

  getHostNode: function () {
    var hostNode = this._commentNodes;
    if (hostNode) {
      return hostNode;
    }
    if (!this._closingComment) {
      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
      var node = openingComment.nextSibling;
      while (true) {
        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
          this._closingComment = node;
          break;
        }
        node = node.nextSibling;
      }
    }
    hostNode = [this._hostNode, this._closingComment];
    this._commentNodes = hostNode;
    return hostNode;
  },

  unmountComponent: function () {
    this._closingComment = null;
    this._commentNodes = null;
    ReactDOMComponentTree.uncacheNode(this);
  }
});

module.exports = ReactDOMTextComponent;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var ReactUpdates = __webpack_require__(11);
var Transaction = __webpack_require__(28);

var emptyFunction = __webpack_require__(10);

var RESET_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: function () {
    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
  }
};

var FLUSH_BATCHED_UPDATES = {
  initialize: emptyFunction,
  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
};

var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];

function ReactDefaultBatchingStrategyTransaction() {
  this.reinitializeTransaction();
}

_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  }
});

var transaction = new ReactDefaultBatchingStrategyTransaction();

var ReactDefaultBatchingStrategy = {
  isBatchingUpdates: false,

  /**
   * Call the provided function in a context within which calls to `setState`
   * and friends are batched such that components aren't updated unnecessarily.
   */
  batchedUpdates: function (callback, a, b, c, d, e) {
    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;

    ReactDefaultBatchingStrategy.isBatchingUpdates = true;

    // The code is written this way to avoid extra allocations
    if (alreadyBatchingUpdates) {
      return callback(a, b, c, d, e);
    } else {
      return transaction.perform(callback, null, a, b, c, d, e);
    }
  }
};

module.exports = ReactDefaultBatchingStrategy;

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var EventListener = __webpack_require__(93);
var ExecutionEnvironment = __webpack_require__(6);
var PooledClass = __webpack_require__(16);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactUpdates = __webpack_require__(11);

var getEventTarget = __webpack_require__(40);
var getUnboundedScrollPosition = __webpack_require__(214);

/**
 * Find the deepest React component completely containing the root of the
 * passed-in instance (for use when entire React trees are nested within each
 * other). If React trees are not nested, returns null.
 */
function findParent(inst) {
  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
  // traversal, but caching is difficult to do correctly without using a
  // mutation observer to listen for all DOM changes.
  while (inst._hostParent) {
    inst = inst._hostParent;
  }
  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
  var container = rootNode.parentNode;
  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
}

// Used to store ancestor hierarchy in top level callback
function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
  this.topLevelType = topLevelType;
  this.nativeEvent = nativeEvent;
  this.ancestors = [];
}
_assign(TopLevelCallbackBookKeeping.prototype, {
  destructor: function () {
    this.topLevelType = null;
    this.nativeEvent = null;
    this.ancestors.length = 0;
  }
});
PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);

function handleTopLevelImpl(bookKeeping) {
  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);

  // Loop through the hierarchy, in case there's any nested components.
  // It's important that we build the array of ancestors before calling any
  // event handlers, because event handlers can modify the DOM, leading to
  // inconsistencies with ReactMount's node cache. See #1105.
  var ancestor = targetInst;
  do {
    bookKeeping.ancestors.push(ancestor);
    ancestor = ancestor && findParent(ancestor);
  } while (ancestor);

  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
    targetInst = bookKeeping.ancestors[i];
    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
  }
}

function scrollValueMonitor(cb) {
  var scrollPosition = getUnboundedScrollPosition(window);
  cb(scrollPosition);
}

var ReactEventListener = {
  _enabled: true,
  _handleTopLevel: null,

  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,

  setHandleTopLevel: function (handleTopLevel) {
    ReactEventListener._handleTopLevel = handleTopLevel;
  },

  setEnabled: function (enabled) {
    ReactEventListener._enabled = !!enabled;
  },

  isEnabled: function () {
    return ReactEventListener._enabled;
  },

  /**
   * Traps top-level events by using event bubbling.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  /**
   * Traps a top-level event by using event capturing.
   *
   * @param {string} topLevelType Record from `EventConstants`.
   * @param {string} handlerBaseName Event name (e.g. "click").
   * @param {object} element Element on which to attach listener.
   * @return {?object} An object with a remove function which will forcefully
   *                  remove the listener.
   * @internal
   */
  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
    if (!element) {
      return null;
    }
    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
  },

  monitorScrollValue: function (refresh) {
    var callback = scrollValueMonitor.bind(null, refresh);
    EventListener.listen(window, 'scroll', callback);
  },

  dispatchEvent: function (topLevelType, nativeEvent) {
    if (!ReactEventListener._enabled) {
      return;
    }

    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
    try {
      // Event queue being processed in the same cycle allows
      // `preventDefault`.
      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
    } finally {
      TopLevelCallbackBookKeeping.release(bookKeeping);
    }
  }
};

module.exports = ReactEventListener;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }
  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var DOMProperty = __webpack_require__(19);
var EventPluginHub = __webpack_require__(24);
var EventPluginUtils = __webpack_require__(38);
var ReactComponentEnvironment = __webpack_require__(47);
var ReactEmptyComponent = __webpack_require__(89);
var ReactBrowserEventEmitter = __webpack_require__(32);
var ReactHostComponent = __webpack_require__(90);
var ReactUpdates = __webpack_require__(11);

var ReactInjection = {
  Component: ReactComponentEnvironment.injection,
  DOMProperty: DOMProperty.injection,
  EmptyComponent: ReactEmptyComponent.injection,
  EventPluginHub: EventPluginHub.injection,
  EventPluginUtils: EventPluginUtils.injection,
  EventEmitter: ReactBrowserEventEmitter.injection,
  HostComponent: ReactHostComponent.injection,
  Updates: ReactUpdates.injection
};

module.exports = ReactInjection;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(3);

var CallbackQueue = __webpack_require__(77);
var PooledClass = __webpack_require__(16);
var ReactBrowserEventEmitter = __webpack_require__(32);
var ReactInputSelection = __webpack_require__(94);
var ReactInstrumentation = __webpack_require__(9);
var Transaction = __webpack_require__(28);
var ReactUpdateQueue = __webpack_require__(51);

/**
 * Ensures that, when possible, the selection range (currently selected text
 * input) is not disturbed by performing the transaction.
 */
var SELECTION_RESTORATION = {
  /**
   * @return {Selection} Selection information.
   */
  initialize: ReactInputSelection.getSelectionInformation,
  /**
   * @param {Selection} sel Selection information returned from `initialize`.
   */
  close: ReactInputSelection.restoreSelection
};

/**
 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
 * high level DOM manipulations (like temporarily removing a text input from the
 * DOM).
 */
var EVENT_SUPPRESSION = {
  /**
   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
   * the reconciliation.
   */
  initialize: function () {
    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
    ReactBrowserEventEmitter.setEnabled(false);
    return currentlyEnabled;
  },

  /**
   * @param {boolean} previouslyEnabled Enabled status of
   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
   *   restores the previous value.
   */
  close: function (previouslyEnabled) {
    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
  }
};

/**
 * Provides a queue for collecting `componentDidMount` and
 * `componentDidUpdate` callbacks during the transaction.
 */
var ON_DOM_READY_QUEUEING = {
  /**
   * Initializes the internal `onDOMReady` queue.
   */
  initialize: function () {
    this.reactMountReady.reset();
  },

  /**
   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
   */
  close: function () {
    this.reactMountReady.notifyAll();
  }
};

/**
 * Executed within the scope of the `Transaction` instance. Consider these as
 * being member methods, but with an implied ordering while being isolated from
 * each other.
 */
var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];

if (false) {
  TRANSACTION_WRAPPERS.push({
    initialize: ReactInstrumentation.debugTool.onBeginFlush,
    close: ReactInstrumentation.debugTool.onEndFlush
  });
}

/**
 * Currently:
 * - The order that these are listed in the transaction is critical:
 * - Suppresses events.
 * - Restores selection range.
 *
 * Future:
 * - Restore document/overflow scroll positions that were unintentionally
 *   modified via DOM insertions above the top viewport boundary.
 * - Implement/integrate with customized constraint based layout system and keep
 *   track of which dimensions must be remeasured.
 *
 * @class ReactReconcileTransaction
 */
function ReactReconcileTransaction(useCreateElement) {
  this.reinitializeTransaction();
  // Only server-side rendering really needs this option (see
  // `ReactServerRendering`), but server-side uses
  // `ReactServerRenderingTransaction` instead. This option is here so that it's
  // accessible and defaults to false when `ReactDOMComponent` and
  // `ReactDOMTextComponent` checks it in `mountComponent`.`
  this.renderToStaticMarkup = false;
  this.reactMountReady = CallbackQueue.getPooled(null);
  this.useCreateElement = useCreateElement;
}

var Mixin = {
  /**
   * @see Transaction
   * @abstract
   * @final
   * @return {array<object>} List of operation wrap procedures.
   *   TODO: convert to array<TransactionWrapper>
   */
  getTransactionWrappers: function () {
    return TRANSACTION_WRAPPERS;
  },

  /**
   * @return {object} The queue to collect `onDOMReady` callbacks with.
   */
  getReactMountReady: function () {
    return this.reactMountReady;
  },

  /**
   * @return {object} The queue to collect React async events.
   */
  getUpdateQueue: function () {
    return ReactUpdateQueue;
  },

  /**
   * Save current transaction state -- if the return value from this method is
   * passed to `rollback`, the transaction will be reset to that state.
   */
  checkpoint: function () {
    // reactMountReady is the our only stateful wrapper
    return this.reactMountReady.checkpoint();
  },

  rollback: function (checkpoint) {
    this.reactMountReady.rollback(checkpoint);
  },

  /**
   * `PooledClass` looks for this, and will invoke this before allowing this
   * instance to be reused.
   */
  destructor: function () {
    CallbackQueue.release(this.reactMountReady);
    this.reactMountReady = null;
  }
};

_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);

PooledClass.addPoolingTo(ReactReconcileTransaction);

module.exports = ReactReconcileTransaction;

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ExecutionEnvironment = __webpack_require__(6);

var getNodeForCharacterOffset = __webpack_require__(218);
var getTextContentAccessor = __webpack_require__(76);

/**
 * While `isCollapsed` is available on the Selection object and `collapsed`
 * is available on the Range object, IE11 sometimes gets them wrong.
 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
 */
function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
  return anchorNode === focusNode && anchorOffset === focusOffset;
}

/**
 * Get the appropriate anchor and focus node/offset pairs for IE.
 *
 * The catch here is that IE's selection API doesn't provide information
 * about whether the selection is forward or backward, so we have to
 * behave as though it's always forward.
 *
 * IE text differs from modern selection in that it behaves as though
 * block elements end with a new line. This means character offsets will
 * differ between the two APIs.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getIEOffsets(node) {
  var selection = document.selection;
  var selectedRange = selection.createRange();
  var selectedLength = selectedRange.text.length;

  // Duplicate selection so we can move range without breaking user selection.
  var fromStart = selectedRange.duplicate();
  fromStart.moveToElementText(node);
  fromStart.setEndPoint('EndToStart', selectedRange);

  var startOffset = fromStart.text.length;
  var endOffset = startOffset + selectedLength;

  return {
    start: startOffset,
    end: endOffset
  };
}

/**
 * @param {DOMElement} node
 * @return {?object}
 */
function getModernOffsets(node) {
  var selection = window.getSelection && window.getSelection();

  if (!selection || selection.rangeCount === 0) {
    return null;
  }

  var anchorNode = selection.anchorNode;
  var anchorOffset = selection.anchorOffset;
  var focusNode = selection.focusNode;
  var focusOffset = selection.focusOffset;

  var currentRange = selection.getRangeAt(0);

  // In Firefox, range.startContainer and range.endContainer can be "anonymous
  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
  // divs do not seem to expose properties, triggering a "Permission denied
  // error" if any of its properties are accessed. The only seemingly possible
  // way to avoid erroring is to access a property that typically works for
  // non-anonymous divs and catch any error that may otherwise arise. See
  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
  try {
    /* eslint-disable no-unused-expressions */
    currentRange.startContainer.nodeType;
    currentRange.endContainer.nodeType;
    /* eslint-enable no-unused-expressions */
  } catch (e) {
    return null;
  }

  // If the node and offset values are the same, the selection is collapsed.
  // `Selection.isCollapsed` is available natively, but IE sometimes gets
  // this value wrong.
  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);

  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;

  var tempRange = currentRange.cloneRange();
  tempRange.selectNodeContents(node);
  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);

  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);

  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
  var end = start + rangeLength;

  // Detect whether the selection is backward.
  var detectionRange = document.createRange();
  detectionRange.setStart(anchorNode, anchorOffset);
  detectionRange.setEnd(focusNode, focusOffset);
  var isBackward = detectionRange.collapsed;

  return {
    start: isBackward ? end : start,
    end: isBackward ? start : end
  };
}

/**
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setIEOffsets(node, offsets) {
  var range = document.selection.createRange().duplicate();
  var start, end;

  if (offsets.end === undefined) {
    start = offsets.start;
    end = start;
  } else if (offsets.start > offsets.end) {
    start = offsets.end;
    end = offsets.start;
  } else {
    start = offsets.start;
    end = offsets.end;
  }

  range.moveToElementText(node);
  range.moveStart('character', start);
  range.setEndPoint('EndToStart', range);
  range.moveEnd('character', end - start);
  range.select();
}

/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programmatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 *
 * @param {DOMElement|DOMTextNode} node
 * @param {object} offsets
 */
function setModernOffsets(node, offsets) {
  if (!window.getSelection) {
    return;
  }

  var selection = window.getSelection();
  var length = node[getTextContentAccessor()].length;
  var start = Math.min(offsets.start, length);
  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);

  // IE 11 uses modern selection, but doesn't support the extend method.
  // Flip backward selections, so we can set with a single range.
  if (!selection.extend && start > end) {
    var temp = end;
    end = start;
    start = temp;
  }

  var startMarker = getNodeForCharacterOffset(node, start);
  var endMarker = getNodeForCharacterOffset(node, end);

  if (startMarker && endMarker) {
    var range = document.createRange();
    range.setStart(startMarker.node, startMarker.offset);
    selection.removeAllRanges();

    if (start > end) {
      selection.addRange(range);
      selection.extend(endMarker.node, endMarker.offset);
    } else {
      range.setEnd(endMarker.node, endMarker.offset);
      selection.addRange(range);
    }
  }
}

var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);

var ReactDOMSelection = {
  /**
   * @param {DOMElement} node
   */
  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,

  /**
   * @param {DOMElement|DOMTextNode} node
   * @param {object} offsets
   */
  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
};

module.exports = ReactDOMSelection;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Given any node return the first leaf node without children.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {DOMElement|DOMTextNode}
 */

function getLeafNode(node) {
  while (node && node.firstChild) {
    node = node.firstChild;
  }
  return node;
}

/**
 * Get the next sibling within a container. This will walk up the
 * DOM if a node's siblings have been exhausted.
 *
 * @param {DOMElement|DOMTextNode} node
 * @return {?DOMElement|DOMTextNode}
 */
function getSiblingNode(node) {
  while (node) {
    if (node.nextSibling) {
      return node.nextSibling;
    }
    node = node.parentNode;
  }
}

/**
 * Get object describing the nodes which contain characters at offset.
 *
 * @param {DOMElement|DOMTextNode} root
 * @param {number} offset
 * @return {?object}
 */
function getNodeForCharacterOffset(root, offset) {
  var node = getLeafNode(root);
  var nodeStart = 0;
  var nodeEnd = 0;

  while (node) {
    if (node.nodeType === 3) {
      nodeEnd = nodeStart + node.textContent.length;

      if (nodeStart <= offset && nodeEnd >= offset) {
        return {
          node: node,
          offset: offset - nodeStart
        };
      }

      nodeStart = nodeEnd;
    }

    node = getLeafNode(getSiblingNode(node));
  }
}

module.exports = getNodeForCharacterOffset;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(220);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(221);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var NS = {
  xlink: 'http://www.w3.org/1999/xlink',
  xml: 'http://www.w3.org/XML/1998/namespace'
};

// We use attributes for everything SVG so let's avoid some duplication and run
// code instead.
// The following are all specified in the HTML config already so we exclude here.
// - class (as className)
// - color
// - height
// - id
// - lang
// - max
// - media
// - method
// - min
// - name
// - style
// - target
// - type
// - width
var ATTRS = {
  accentHeight: 'accent-height',
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 'alignment-baseline',
  allowReorder: 'allowReorder',
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 'arabic-form',
  ascent: 0,
  attributeName: 'attributeName',
  attributeType: 'attributeType',
  autoReverse: 'autoReverse',
  azimuth: 0,
  baseFrequency: 'baseFrequency',
  baseProfile: 'baseProfile',
  baselineShift: 'baseline-shift',
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 'calcMode',
  capHeight: 'cap-height',
  clip: 0,
  clipPath: 'clip-path',
  clipRule: 'clip-rule',
  clipPathUnits: 'clipPathUnits',
  colorInterpolation: 'color-interpolation',
  colorInterpolationFilters: 'color-interpolation-filters',
  colorProfile: 'color-profile',
  colorRendering: 'color-rendering',
  contentScriptType: 'contentScriptType',
  contentStyleType: 'contentStyleType',
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 'diffuseConstant',
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 'dominant-baseline',
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 'edgeMode',
  elevation: 0,
  enableBackground: 'enable-background',
  end: 0,
  exponent: 0,
  externalResourcesRequired: 'externalResourcesRequired',
  fill: 0,
  fillOpacity: 'fill-opacity',
  fillRule: 'fill-rule',
  filter: 0,
  filterRes: 'filterRes',
  filterUnits: 'filterUnits',
  floodColor: 'flood-color',
  floodOpacity: 'flood-opacity',
  focusable: 0,
  fontFamily: 'font-family',
  fontSize: 'font-size',
  fontSizeAdjust: 'font-size-adjust',
  fontStretch: 'font-stretch',
  fontStyle: 'font-style',
  fontVariant: 'font-variant',
  fontWeight: 'font-weight',
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 'glyph-name',
  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
  glyphOrientationVertical: 'glyph-orientation-vertical',
  glyphRef: 'glyphRef',
  gradientTransform: 'gradientTransform',
  gradientUnits: 'gradientUnits',
  hanging: 0,
  horizAdvX: 'horiz-adv-x',
  horizOriginX: 'horiz-origin-x',
  ideographic: 0,
  imageRendering: 'image-rendering',
  'in': 0,
  in2: 0,
  intercept: 0,
  k: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  kernelMatrix: 'kernelMatrix',
  kernelUnitLength: 'kernelUnitLength',
  kerning: 0,
  keyPoints: 'keyPoints',
  keySplines: 'keySplines',
  keyTimes: 'keyTimes',
  lengthAdjust: 'lengthAdjust',
  letterSpacing: 'letter-spacing',
  lightingColor: 'lighting-color',
  limitingConeAngle: 'limitingConeAngle',
  local: 0,
  markerEnd: 'marker-end',
  markerMid: 'marker-mid',
  markerStart: 'marker-start',
  markerHeight: 'markerHeight',
  markerUnits: 'markerUnits',
  markerWidth: 'markerWidth',
  mask: 0,
  maskContentUnits: 'maskContentUnits',
  maskUnits: 'maskUnits',
  mathematical: 0,
  mode: 0,
  numOctaves: 'numOctaves',
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 'overline-position',
  overlineThickness: 'overline-thickness',
  paintOrder: 'paint-order',
  panose1: 'panose-1',
  pathLength: 'pathLength',
  patternContentUnits: 'patternContentUnits',
  patternTransform: 'patternTransform',
  patternUnits: 'patternUnits',
  pointerEvents: 'pointer-events',
  points: 0,
  pointsAtX: 'pointsAtX',
  pointsAtY: 'pointsAtY',
  pointsAtZ: 'pointsAtZ',
  preserveAlpha: 'preserveAlpha',
  preserveAspectRatio: 'preserveAspectRatio',
  primitiveUnits: 'primitiveUnits',
  r: 0,
  radius: 0,
  refX: 'refX',
  refY: 'refY',
  renderingIntent: 'rendering-intent',
  repeatCount: 'repeatCount',
  repeatDur: 'repeatDur',
  requiredExtensions: 'requiredExtensions',
  requiredFeatures: 'requiredFeatures',
  restart: 0,
  result: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  seed: 0,
  shapeRendering: 'shape-rendering',
  slope: 0,
  spacing: 0,
  specularConstant: 'specularConstant',
  specularExponent: 'specularExponent',
  speed: 0,
  spreadMethod: 'spreadMethod',
  startOffset: 'startOffset',
  stdDeviation: 'stdDeviation',
  stemh: 0,
  stemv: 0,
  stitchTiles: 'stitchTiles',
  stopColor: 'stop-color',
  stopOpacity: 'stop-opacity',
  strikethroughPosition: 'strikethrough-position',
  strikethroughThickness: 'strikethrough-thickness',
  string: 0,
  stroke: 0,
  strokeDasharray: 'stroke-dasharray',
  strokeDashoffset: 'stroke-dashoffset',
  strokeLinecap: 'stroke-linecap',
  strokeLinejoin: 'stroke-linejoin',
  strokeMiterlimit: 'stroke-miterlimit',
  strokeOpacity: 'stroke-opacity',
  strokeWidth: 'stroke-width',
  surfaceScale: 'surfaceScale',
  systemLanguage: 'systemLanguage',
  tableValues: 'tableValues',
  targetX: 'targetX',
  targetY: 'targetY',
  textAnchor: 'text-anchor',
  textDecoration: 'text-decoration',
  textRendering: 'text-rendering',
  textLength: 'textLength',
  to: 0,
  transform: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 'underline-position',
  underlineThickness: 'underline-thickness',
  unicode: 0,
  unicodeBidi: 'unicode-bidi',
  unicodeRange: 'unicode-range',
  unitsPerEm: 'units-per-em',
  vAlphabetic: 'v-alphabetic',
  vHanging: 'v-hanging',
  vIdeographic: 'v-ideographic',
  vMathematical: 'v-mathematical',
  values: 0,
  vectorEffect: 'vector-effect',
  version: 0,
  vertAdvY: 'vert-adv-y',
  vertOriginX: 'vert-origin-x',
  vertOriginY: 'vert-origin-y',
  viewBox: 'viewBox',
  viewTarget: 'viewTarget',
  visibility: 0,
  widths: 0,
  wordSpacing: 'word-spacing',
  writingMode: 'writing-mode',
  x: 0,
  xHeight: 'x-height',
  x1: 0,
  x2: 0,
  xChannelSelector: 'xChannelSelector',
  xlinkActuate: 'xlink:actuate',
  xlinkArcrole: 'xlink:arcrole',
  xlinkHref: 'xlink:href',
  xlinkRole: 'xlink:role',
  xlinkShow: 'xlink:show',
  xlinkTitle: 'xlink:title',
  xlinkType: 'xlink:type',
  xmlBase: 'xml:base',
  xmlns: 0,
  xmlnsXlink: 'xmlns:xlink',
  xmlLang: 'xml:lang',
  xmlSpace: 'xml:space',
  y: 0,
  y1: 0,
  y2: 0,
  yChannelSelector: 'yChannelSelector',
  z: 0,
  zoomAndPan: 'zoomAndPan'
};

var SVGDOMPropertyConfig = {
  Properties: {},
  DOMAttributeNamespaces: {
    xlinkActuate: NS.xlink,
    xlinkArcrole: NS.xlink,
    xlinkHref: NS.xlink,
    xlinkRole: NS.xlink,
    xlinkShow: NS.xlink,
    xlinkTitle: NS.xlink,
    xlinkType: NS.xlink,
    xmlBase: NS.xml,
    xmlLang: NS.xml,
    xmlSpace: NS.xml
  },
  DOMAttributeNames: {}
};

Object.keys(ATTRS).forEach(function (key) {
  SVGDOMPropertyConfig.Properties[key] = 0;
  if (ATTRS[key]) {
    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
  }
});

module.exports = SVGDOMPropertyConfig;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var EventPropagators = __webpack_require__(23);
var ExecutionEnvironment = __webpack_require__(6);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInputSelection = __webpack_require__(94);
var SyntheticEvent = __webpack_require__(14);

var getActiveElement = __webpack_require__(95);
var isTextInputElement = __webpack_require__(80);
var shallowEqual = __webpack_require__(48);

var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;

var eventTypes = {
  select: {
    phasedRegistrationNames: {
      bubbled: 'onSelect',
      captured: 'onSelectCapture'
    },
    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
  }
};

var activeElement = null;
var activeElementInst = null;
var lastSelection = null;
var mouseDown = false;

// Track whether a listener exists for this plugin. If none exist, we do
// not extract events. See #3639.
var hasListener = false;

/**
 * Get an object which is a unique representation of the current selection.
 *
 * The return value will not be consistent across nodes or browsers, but
 * two identical selections on the same node will return identical objects.
 *
 * @param {DOMElement} node
 * @return {object}
 */
function getSelection(node) {
  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
    return {
      start: node.selectionStart,
      end: node.selectionEnd
    };
  } else if (window.getSelection) {
    var selection = window.getSelection();
    return {
      anchorNode: selection.anchorNode,
      anchorOffset: selection.anchorOffset,
      focusNode: selection.focusNode,
      focusOffset: selection.focusOffset
    };
  } else if (document.selection) {
    var range = document.selection.createRange();
    return {
      parentElement: range.parentElement(),
      text: range.text,
      top: range.boundingTop,
      left: range.boundingLeft
    };
  }
}

/**
 * Poll selection to see whether it's changed.
 *
 * @param {object} nativeEvent
 * @return {?SyntheticEvent}
 */
function constructSelectEvent(nativeEvent, nativeEventTarget) {
  // Ensure we have the right element, and that the user is not dragging a
  // selection (this matches native `select` event behavior). In HTML5, select
  // fires only on input and textarea thus if there's no focused element we
  // won't dispatch.
  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
    return null;
  }

  // Only fire when selection has actually changed.
  var currentSelection = getSelection(activeElement);
  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
    lastSelection = currentSelection;

    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);

    syntheticEvent.type = 'select';
    syntheticEvent.target = activeElement;

    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);

    return syntheticEvent;
  }

  return null;
}

/**
 * This plugin creates an `onSelect` event that normalizes select events
 * across form elements.
 *
 * Supported elements are:
 * - input (see `isTextInputElement`)
 * - textarea
 * - contentEditable
 *
 * This differs from native browser implementations in the following ways:
 * - Fires on contentEditable fields as well as inputs.
 * - Fires for collapsed selection.
 * - Fires after user input.
 */
var SelectEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    if (!hasListener) {
      return null;
    }

    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;

    switch (topLevelType) {
      // Track the input node that has focus.
      case 'topFocus':
        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
          activeElement = targetNode;
          activeElementInst = targetInst;
          lastSelection = null;
        }
        break;
      case 'topBlur':
        activeElement = null;
        activeElementInst = null;
        lastSelection = null;
        break;
      // Don't fire the event while the user is dragging. This matches the
      // semantics of the native select event.
      case 'topMouseDown':
        mouseDown = true;
        break;
      case 'topContextMenu':
      case 'topMouseUp':
        mouseDown = false;
        return constructSelectEvent(nativeEvent, nativeEventTarget);
      // Chrome and IE fire non-standard event when selection is changed (and
      // sometimes when it hasn't). IE's event fires out of order with respect
      // to key and input events on deletion, so we discard it.
      //
      // Firefox doesn't support selectionchange, so check selection status
      // after each key entry. The selection changes after keydown and before
      // keyup, but we check on keydown as well in the case of holding down a
      // key, when multiple keydown events are fired but only one keyup is.
      // This is also our approach for IE handling, for the reason above.
      case 'topSelectionChange':
        if (skipSelectionChangeEvent) {
          break;
        }
      // falls through
      case 'topKeyDown':
      case 'topKeyUp':
        return constructSelectEvent(nativeEvent, nativeEventTarget);
    }

    return null;
  },

  didPutListener: function (inst, registrationName, listener) {
    if (registrationName === 'onSelect') {
      hasListener = true;
    }
  }
};

module.exports = SelectEventPlugin;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(1);

var EventListener = __webpack_require__(93);
var EventPropagators = __webpack_require__(23);
var ReactDOMComponentTree = __webpack_require__(4);
var SyntheticAnimationEvent = __webpack_require__(225);
var SyntheticClipboardEvent = __webpack_require__(226);
var SyntheticEvent = __webpack_require__(14);
var SyntheticFocusEvent = __webpack_require__(227);
var SyntheticKeyboardEvent = __webpack_require__(228);
var SyntheticMouseEvent = __webpack_require__(29);
var SyntheticDragEvent = __webpack_require__(230);
var SyntheticTouchEvent = __webpack_require__(231);
var SyntheticTransitionEvent = __webpack_require__(232);
var SyntheticUIEvent = __webpack_require__(25);
var SyntheticWheelEvent = __webpack_require__(233);

var emptyFunction = __webpack_require__(10);
var getEventCharCode = __webpack_require__(53);
var invariant = __webpack_require__(0);

/**
 * Turns
 * ['abort', ...]
 * into
 * eventTypes = {
 *   'abort': {
 *     phasedRegistrationNames: {
 *       bubbled: 'onAbort',
 *       captured: 'onAbortCapture',
 *     },
 *     dependencies: ['topAbort'],
 *   },
 *   ...
 * };
 * topLevelEventsToDispatchConfig = {
 *   'topAbort': { sameConfig }
 * };
 */
var eventTypes = {};
var topLevelEventsToDispatchConfig = {};
['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
  var onEvent = 'on' + capitalizedEvent;
  var topEvent = 'top' + capitalizedEvent;

  var type = {
    phasedRegistrationNames: {
      bubbled: onEvent,
      captured: onEvent + 'Capture'
    },
    dependencies: [topEvent]
  };
  eventTypes[event] = type;
  topLevelEventsToDispatchConfig[topEvent] = type;
});

var onClickListeners = {};

function getDictionaryKey(inst) {
  // Prevents V8 performance issue:
  // https://github.com/facebook/react/pull/7232
  return '.' + inst._rootNodeID;
}

function isInteractive(tag) {
  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
}

var SimpleEventPlugin = {
  eventTypes: eventTypes,

  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
    if (!dispatchConfig) {
      return null;
    }
    var EventConstructor;
    switch (topLevelType) {
      case 'topAbort':
      case 'topCanPlay':
      case 'topCanPlayThrough':
      case 'topDurationChange':
      case 'topEmptied':
      case 'topEncrypted':
      case 'topEnded':
      case 'topError':
      case 'topInput':
      case 'topInvalid':
      case 'topLoad':
      case 'topLoadedData':
      case 'topLoadedMetadata':
      case 'topLoadStart':
      case 'topPause':
      case 'topPlay':
      case 'topPlaying':
      case 'topProgress':
      case 'topRateChange':
      case 'topReset':
      case 'topSeeked':
      case 'topSeeking':
      case 'topStalled':
      case 'topSubmit':
      case 'topSuspend':
      case 'topTimeUpdate':
      case 'topVolumeChange':
      case 'topWaiting':
        // HTML Events
        // @see http://www.w3.org/TR/html5/index.html#events-0
        EventConstructor = SyntheticEvent;
        break;
      case 'topKeyPress':
        // Firefox creates a keypress event for function keys too. This removes
        // the unwanted keypress events. Enter is however both printable and
        // non-printable. One would expect Tab to be as well (but it isn't).
        if (getEventCharCode(nativeEvent) === 0) {
          return null;
        }
      /* falls through */
      case 'topKeyDown':
      case 'topKeyUp':
        EventConstructor = SyntheticKeyboardEvent;
        break;
      case 'topBlur':
      case 'topFocus':
        EventConstructor = SyntheticFocusEvent;
        break;
      case 'topClick':
        // Firefox creates a click event on right mouse clicks. This removes the
        // unwanted click events.
        if (nativeEvent.button === 2) {
          return null;
        }
      /* falls through */
      case 'topDoubleClick':
      case 'topMouseDown':
      case 'topMouseMove':
      case 'topMouseUp':
      // TODO: Disabled elements should not respond to mouse events
      /* falls through */
      case 'topMouseOut':
      case 'topMouseOver':
      case 'topContextMenu':
        EventConstructor = SyntheticMouseEvent;
        break;
      case 'topDrag':
      case 'topDragEnd':
      case 'topDragEnter':
      case 'topDragExit':
      case 'topDragLeave':
      case 'topDragOver':
      case 'topDragStart':
      case 'topDrop':
        EventConstructor = SyntheticDragEvent;
        break;
      case 'topTouchCancel':
      case 'topTouchEnd':
      case 'topTouchMove':
      case 'topTouchStart':
        EventConstructor = SyntheticTouchEvent;
        break;
      case 'topAnimationEnd':
      case 'topAnimationIteration':
      case 'topAnimationStart':
        EventConstructor = SyntheticAnimationEvent;
        break;
      case 'topTransitionEnd':
        EventConstructor = SyntheticTransitionEvent;
        break;
      case 'topScroll':
        EventConstructor = SyntheticUIEvent;
        break;
      case 'topWheel':
        EventConstructor = SyntheticWheelEvent;
        break;
      case 'topCopy':
      case 'topCut':
      case 'topPaste':
        EventConstructor = SyntheticClipboardEvent;
        break;
    }
    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
    EventPropagators.accumulateTwoPhaseDispatches(event);
    return event;
  },

  didPutListener: function (inst, registrationName, listener) {
    // Mobile Safari does not fire properly bubble click events on
    // non-interactive elements, which means delegated click listeners do not
    // fire. The workaround for this bug involves attaching an empty click
    // listener on the target node.
    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
      if (!onClickListeners[key]) {
        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
      }
    }
  },

  willDeleteListener: function (inst, registrationName) {
    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
      var key = getDictionaryKey(inst);
      onClickListeners[key].remove();
      delete onClickListeners[key];
    }
  }
};

module.exports = SimpleEventPlugin;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
 */
var AnimationEventInterface = {
  animationName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);

module.exports = SyntheticAnimationEvent;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/clipboard-apis/
 */
var ClipboardEventInterface = {
  clipboardData: function (event) {
    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);

module.exports = SyntheticClipboardEvent;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(25);

/**
 * @interface FocusEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var FocusEventInterface = {
  relatedTarget: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);

module.exports = SyntheticFocusEvent;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(25);

var getEventCharCode = __webpack_require__(53);
var getEventKey = __webpack_require__(229);
var getEventModifierState = __webpack_require__(42);

/**
 * @interface KeyboardEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var KeyboardEventInterface = {
  key: getEventKey,
  location: null,
  ctrlKey: null,
  shiftKey: null,
  altKey: null,
  metaKey: null,
  repeat: null,
  locale: null,
  getModifierState: getEventModifierState,
  // Legacy Interface
  charCode: function (event) {
    // `charCode` is the result of a KeyPress event and represents the value of
    // the actual printable character.

    // KeyPress is deprecated, but its replacement is not yet final and not
    // implemented in any major browser. Only KeyPress has charCode.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    return 0;
  },
  keyCode: function (event) {
    // `keyCode` is the result of a KeyDown/Up event and represents the value of
    // physical keyboard key.

    // The actual meaning of the value depends on the users' keyboard layout
    // which cannot be detected. Assuming that it is a US keyboard layout
    // provides a surprisingly accurate mapping for US and European users.
    // Due to this, it is left to the user to implement at this time.
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  },
  which: function (event) {
    // `which` is an alias for either `keyCode` or `charCode` depending on the
    // type of the event.
    if (event.type === 'keypress') {
      return getEventCharCode(event);
    }
    if (event.type === 'keydown' || event.type === 'keyup') {
      return event.keyCode;
    }
    return 0;
  }
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);

module.exports = SyntheticKeyboardEvent;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var getEventCharCode = __webpack_require__(53);

/**
 * Normalization of deprecated HTML5 `key` values
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var normalizeKey = {
  Esc: 'Escape',
  Spacebar: ' ',
  Left: 'ArrowLeft',
  Up: 'ArrowUp',
  Right: 'ArrowRight',
  Down: 'ArrowDown',
  Del: 'Delete',
  Win: 'OS',
  Menu: 'ContextMenu',
  Apps: 'ContextMenu',
  Scroll: 'ScrollLock',
  MozPrintableKey: 'Unidentified'
};

/**
 * Translation from legacy `keyCode` to HTML5 `key`
 * Only special keys supported, all others depend on keyboard layout or browser
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
 */
var translateToKey = {
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  45: 'Insert',
  46: 'Delete',
  112: 'F1',
  113: 'F2',
  114: 'F3',
  115: 'F4',
  116: 'F5',
  117: 'F6',
  118: 'F7',
  119: 'F8',
  120: 'F9',
  121: 'F10',
  122: 'F11',
  123: 'F12',
  144: 'NumLock',
  145: 'ScrollLock',
  224: 'Meta'
};

/**
 * @param {object} nativeEvent Native browser event.
 * @return {string} Normalized `key` property.
 */
function getEventKey(nativeEvent) {
  if (nativeEvent.key) {
    // Normalize inconsistent values reported by browsers due to
    // implementations of a working draft specification.

    // FireFox implements `key` but returns `MozPrintableKey` for all
    // printable characters (normalized to `Unidentified`), ignore it.
    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
    if (key !== 'Unidentified') {
      return key;
    }
  }

  // Browser does not implement `key`, polyfill as much of it as we can.
  if (nativeEvent.type === 'keypress') {
    var charCode = getEventCharCode(nativeEvent);

    // The enter-key is technically both printable and non-printable and can
    // thus be captured by `keypress`, no other non-printable key should.
    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
  }
  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
    // While user keyboard layout determines the actual meaning of each
    // `keyCode` value, almost all function keys have a universal value.
    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
  }
  return '';
}

module.exports = getEventKey;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(29);

/**
 * @interface DragEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var DragEventInterface = {
  dataTransfer: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);

module.exports = SyntheticDragEvent;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticUIEvent = __webpack_require__(25);

var getEventModifierState = __webpack_require__(42);

/**
 * @interface TouchEvent
 * @see http://www.w3.org/TR/touch-events/
 */
var TouchEventInterface = {
  touches: null,
  targetTouches: null,
  changedTouches: null,
  altKey: null,
  metaKey: null,
  ctrlKey: null,
  shiftKey: null,
  getModifierState: getEventModifierState
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticUIEvent}
 */
function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);

module.exports = SyntheticTouchEvent;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticEvent = __webpack_require__(14);

/**
 * @interface Event
 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
 */
var TransitionEventInterface = {
  propertyName: null,
  elapsedTime: null,
  pseudoElement: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticEvent}
 */
function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);

module.exports = SyntheticTransitionEvent;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var SyntheticMouseEvent = __webpack_require__(29);

/**
 * @interface WheelEvent
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var WheelEventInterface = {
  deltaX: function (event) {
    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
  },
  deltaY: function (event) {
    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
    'wheelDelta' in event ? -event.wheelDelta : 0;
  },
  deltaZ: null,

  // Browsers without "deltaMode" is reporting in raw wheel delta where one
  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
  deltaMode: null
};

/**
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {string} dispatchMarker Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @extends {SyntheticMouseEvent}
 */
function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
}

SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);

module.exports = SyntheticWheelEvent;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var validateDOMNesting = __webpack_require__(52);

var DOC_NODE_TYPE = 9;

function ReactDOMContainerInfo(topLevelWrapper, node) {
  var info = {
    _topLevelWrapper: topLevelWrapper,
    _idCounter: 1,
    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
    _node: node,
    _tag: node ? node.nodeName.toLowerCase() : null,
    _namespaceURI: node ? node.namespaceURI : null
  };
  if (false) {
    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
  }
  return info;
}

module.exports = ReactDOMContainerInfo;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactDOMFeatureFlags = {
  useCreateElement: true,
  useFiber: false
};

module.exports = ReactDOMFeatureFlags;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var adler32 = __webpack_require__(237);

var TAG_END = /\/?>/;
var COMMENT_START = /^<\!\-\-/;

var ReactMarkupChecksum = {
  CHECKSUM_ATTR_NAME: 'data-react-checksum',

  /**
   * @param {string} markup Markup string
   * @return {string} Markup string with checksum attribute attached
   */
  addChecksumToMarkup: function (markup) {
    var checksum = adler32(markup);

    // Add checksum (handle both parent tags, comments and self-closing tags)
    if (COMMENT_START.test(markup)) {
      return markup;
    } else {
      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
    }
  },

  /**
   * @param {string} markup to use
   * @param {DOMElement} element root React element
   * @returns {boolean} whether or not the markup is the same
   */
  canReuseMarkup: function (markup, element) {
    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
    var markupChecksum = adler32(markup);
    return markupChecksum === existingChecksum;
  }
};

module.exports = ReactMarkupChecksum;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var MOD = 65521;

// adler32 is not cryptographically strong, and is only used to sanity check that
// markup generated on the server matches the markup generated on the client.
// This implementation (a modified version of the SheetJS version) has been optimized
// for our use case, at the expense of conforming to the adler32 specification
// for non-ascii inputs.
function adler32(data) {
  var a = 1;
  var b = 0;
  var i = 0;
  var l = data.length;
  var m = l & ~0x3;
  while (i < m) {
    var n = Math.min(i + 4096, m);
    for (; i < n; i += 4) {
      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
    }
    a %= MOD;
    b %= MOD;
  }
  for (; i < l; i++) {
    b += a += data.charCodeAt(i);
  }
  a %= MOD;
  b %= MOD;
  return a | b << 16;
}

module.exports = adler32;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.6.2';

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(1);

var ReactCurrentOwner = __webpack_require__(13);
var ReactDOMComponentTree = __webpack_require__(4);
var ReactInstanceMap = __webpack_require__(26);

var getHostComponentFromComposite = __webpack_require__(97);
var invariant = __webpack_require__(0);
var warning = __webpack_require__(2);

/**
 * Returns the DOM node rendered by this element.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
 *
 * @param {ReactComponent|DOMElement} componentOrElement
 * @return {?DOMElement} The root node of this element.
 */
function findDOMNode(componentOrElement) {
  if (false) {
    var owner = ReactCurrentOwner.current;
    if (owner !== null) {
      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
      owner._warnedAboutRefsInRender = true;
    }
  }
  if (componentOrElement == null) {
    return null;
  }
  if (componentOrElement.nodeType === 1) {
    return componentOrElement;
  }

  var inst = ReactInstanceMap.get(componentOrElement);
  if (inst) {
    inst = getHostComponentFromComposite(inst);
    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
  }

  if (typeof componentOrElement.render === 'function') {
     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
  } else {
     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
  }
}

module.exports = findDOMNode;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactMount = __webpack_require__(96);

module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ }),
/* 241 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

module.exports = function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var caseWorldController,caseWorld=__webpack_require__(36);function bootstrap(){caseWorldController=caseWorld.getCaseWorldController(),caseWorldController.on('init',setupCanvasControls)}function setupCanvasControls(){var $canvas=$('canvas'),cameraPositioningIsActive=!0;$('[data-camera-position]').click(function(){if(cameraPositioningIsActive&&!caseWorldController.isStartAnimationActive()){var $this=$(this);cameraPositioningIsActive=!1,$('[data-camera-position]').removeClass('tr-prod-media-active'),$this.addClass('tr-prod-media-active'),caseWorldController.moveCameraTo($this.attr('data-camera-position')),Detector.webgl?caseWorldController.once('cameraAnimationDone',function(){setTimeout(function(){cameraPositioningIsActive=!0},100)}):cameraPositioningIsActive=!0}}),$canvas.click(function(){Detector.webgl&&$('[data-camera-position]').removeClass('tr-prod-media-active')});var $zoomIn=$('[data-zoom-in]');$zoomIn.mousedown(function(){caseWorldController.zoom('zoom_in')});var $zoomOut=$('[data-zoom-out]');$zoomOut.mousedown(function(){caseWorldController.zoom('zoom_out')}),$canvas.mousedown(function(){caseWorldController.startAction()}).mouseup(function(){caseWorldController.endAction()}).mousewheel(function(e){e.preventDefault();caseWorldController.getCaseWorldView();1===e.deltaY?$zoomIn.trigger('mousedown'):$zoomOut.trigger('mousedown')})}module.exports={bootstrap:bootstrap};

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// bundle.js